// Generated by scripts/generate-i18n-runtime.mjs. Edit the JSON catalogs instead.
export const en = {
  navProducts: "Products",
  navCustomization: "Customization",
  navAbout: "About",
  navBlog: "Blog",
  navFaq: "FAQ",
  navContact: "Contact",
  navSearch: "Search",
  announcementLabel: "News",
  contactSales: "Contact Sales",
  toggleMenu: "Toggle menu",
  language: "Language",
  breadcrumbLabel: "Breadcrumb",
  heroEyebrow: "STB hardware for operators · Since 2011",
  heroTitle: "Android TV Set-Top Boxes",
  heroTitleAccent: "for IPTV & OTT operators",
  heroDescription:
    "Four production-ready Android TV models, customized for your brand and software, with Alcatraz DMS for fleet operations.",
  heroModelsCta: "Compare STB models",
  heroQuoteCta: "Request a quote",
  exploreProducts: "Explore Products",
  bookDemo: "Book a Demo",
  trustedBy: "250+ operators and TV providers across 15 countries trust inext",
  operationsStatPill: "Powering 120+ operator networks worldwide",
  stackEyebrow: "The inext stack",
  stackTitle: "Hardware, customization and",
  stackTitleAccent: "operations",
  stackTitleEnd: "— in one place",
  stackDescription:
    "Three pillars that cover everything an operator needs to launch and run a modern IPTV / OTT service.",
  hardwareEyebrow: "Hardware · Our flagship STB",
  hardwareTitle: "Meet the",
  hardwareDescription:
    "A compact yet powerful Android 12 (AOSP) TV box built for ISPs and TV operators. Powered by the Allwinner H618 with 4GB DDR3 and 32GB eMMC, it delivers smooth 4K UHD playback at 60fps over HDMI 2.0a, connects via dual-band Wi-Fi AC, Bluetooth 5.0 or 100Mb Ethernet, and ships with a remote, HDMI cable and power adapter included.",
  viewTechSpecs: "View tech specs",
  clientsEyebrow: "White-label & Co-branding",
  clientsTitle: "Operators already shipping",
  clientsTitleAccent: "inext STBs",
  clientsDescription:
    "Real hardware, packaging and UX delivered to leading ISPs and OTT platforms — fully branded, end-to-end.",
  clientsOutro: "From a single box to a nationwide rollout — your brand, our engineering.",
  customizationEyebrow: "Customization",
  customizationTitle: "Your brand, end to end",
  customizationDescription:
    "From the box on the shelf to the launcher on the TV, every layer of the inext experience can be tailored to your operator brand and content.",
  learnMore: "Learn more",
  lineupEyebrow: "Choose your hardware",
  lineupTitle: "Four STBs. One operator platform.",
  lineupDescription:
    "Start with the deployment: essential 4K hardware, more memory and storage, or the full 4 GB flagship. Every model is built for operator control and Alcatraz DMS.",
  lineupCompareAll: "Compare all models",
  lineupFlagshipBadge: "Flagship",
  lineupTv5Tagline: "Essential 4K Android for cost-sensitive rollouts.",
  lineupTv5UltraTagline: "More memory and storage on the proven platform.",
  lineupTv6Tagline: "Smarter 4K with Bluetooth and Wi-Fi ac.",
  lineupTv6UltraTagline: "Maximum power and storage — the flagship.",
  homeCompanionEyebrow: "Companion app",
  homeCompanionCta: "Explore inext Remote",
  operationsEyebrow: "Operations · Alcatraz DMS + protocols",
  operationsTitle: "One platform to manage",
  operationsTitleAccent: "every device",
  operationsDescription:
    "Alcatraz DMS is the device management system behind every inext deployment. From one console, teams can detect fleet issues, review device activity, deploy firmware and run remote diagnostics.",
  ctaEyebrow: "Talk to us",
  ctaTitle: "Ready to choose the",
  ctaTitleAccent: "right STB?",
  ctaDescription:
    "Tell us about the service, fleet size and technical requirements. We'll recommend the hardware configuration and rollout path.",
  footerDescription:
    "Set-Top Boxes and device management software for ISPs and TV providers since 2011.",
  footerProducts: "Products",
  footerSolutions: "Solutions",
  footerCompany: "Company",
  footerRights: "All rights reserved.",
  homeTitle: "Android TV Set-Top Boxes for IPTV & OTT Operators | inext",
  homeDescription:
    "inext supplies Android TV Set-Top Boxes for ISPs and TV operators, with white-label customization, IPTV applications, Alcatraz DMS and global B2B delivery.",
  portalEyebrow: "Beyond the box",
  portalTitle: "Everything an operator needs around the STB.",
  portalDescription:
    "Turn selected hardware into a complete subscriber product with branding, applications, fleet operations and coordinated B2B delivery.",
  portalResourcesEyebrow: "Knowledge center",
  portalResourcesTitle: "Plan the deployment with field-tested guides and tools.",
  portalResourcesDescription:
    "Research hardware decisions, compare fleet costs and find practical answers across the inext portal.",
  heroQuickHardware: "Hardware",
  heroQuickCustomization: "Customization",
  heroQuickOperations: "Operations",
  heroQuickLogistics: "Worldwide Delivery",
  heroDashboardTitle: "Alcatraz DMS · Fleet Overview",
  heroMetricActiveDevices: "Active devices",
  heroMetricOnline: "Online",
  heroMetricStreams: "Streams / min",
  heroFirmware: "Firmware",
  heroDeviceOnline: "Online",
  heroDeviceImageAlt: "inext TV6 Ultra set-top box with remote",
  heroSpecChipset: "Chipset",
  heroSpecMemory: "Memory",
  heroSpecVideo: "Video",
  heroSpecOs: "OS",
  heroStackBadge: "Hardware + software, in one stack",
  productMenuFlagship: "Flagship",
  productMenuTv6UltraDesc: "Premium · 4 GB / 32 GB · voice remote",
  productMenuTv6Desc: "Performance · 2 GB / 16 GB · IR remote",
  productMenuTv5UltraDesc: "Standard · 2 GB / 16 GB · IR remote",
  productMenuTv5Desc: "Essential · 1 GB / 8 GB · IR remote",
  navMenuProductsEyebrow: "Set-top boxes",
  navMenuSolutionsEyebrow: "Solutions & software",
  navMenuSolutionsGroupPlatform: "Platform & operations",
  navMenuSolutionsGroupApps: "Apps",
  navMenuSolutionsGroupServices: "Services",
  productMenuFeaturedTitle: "The flagship 4K box",
  productMenuFeaturedDesc: "Android 12 · BT voice remote · Alcatraz DMS",
  productMenuFeaturedCta: "Explore flagship",
  pillarHardwareEyebrow: "Hardware",
  pillarHardwareTitle: "Android TV Set-Top Boxes",
  pillarHardwareDescription:
    "Compact, powerful 4K STBs engineered for ISPs and TV operators. Our flagship — the inext TV6 Ultra — leads the lineup.",
  pillarHardwareCta: "Explore the lineup",
  pillarCustomizationEyebrow: "Customization",
  pillarCustomizationTitle: "Your brand, on every screen",
  pillarCustomizationDescription:
    "White-label hardware, co-branding, custom IPTV apps, operator launcher and a companion remote app — built around your identity.",
  pillarCustomizationCta: "Explore customization",
  pillarOperationsEyebrow: "Operations",
  pillarOperationsTitle: "Run your fleet at scale",
  pillarOperationsDescription:
    "Fleet Health, device activity, staged OTA updates, remote diagnostics and TR-069 in one Alcatraz DMS console for the entire network.",
  pillarOperationsCta: "Inside Alcatraz DMS",
  hardwareSpecChipset: "Allwinner H618 · Quad-Core A53",
  hardwareSpecMemory: "4GB DDR3 · 32GB eMMC · Mali-G31 MP2",
  hardwareSpecVideo: "4K UHD H.265 60fps · VP9 · H.264",
  hardwareSpecWireless: "Wi-Fi AC dual-band · BT 5.0 · LAN 100Mb",
  hardwareSpecPorts: "HDMI 2.0a · A/V out · 2×USB 2.0 · microSD/TF",
  hardwareSpecSoftware: "Android 12 (AOSP) · Alcatraz™ DMS · TR-069",
  hardwareImageAlt: "inext TV6 Ultra Set-Top Box with remote and packaging",
  hardwareStatUltraHd: "Ultra HD",
  hardwareStat60Fps: "60fps",
  hardwareStatAndroid: "Android",
  clientTagFullPackage: "Full package",
  clientTagCoBranding: "Co-branding",
  clientTagRetailKit: "Retail kit",
  clientTagCustomApp: "Custom app",
  clientTagWhiteLabel: "White-label",
  clientImageAltSuffix: "STB by inext",
  clientNoteBeeline: "Branded STB, remote and retail box",
  clientNoteOkTv: "Operator-branded device and retail packaging",
  clientNoteKyivstar: "Branded device, remote and retail box",
  clientNoteAlmaTv: "IPTV box — packaging + remote set",
  clientNoteSarkor: "Operator UI, packaging and accessories",
  clientNoteSweetTv: "Box 2 UltraHD — full retail bundle",
  clientNoteMegogo: "Black edition with branded remote",
  clientNoteMetroTv: "Operator-branded STB with retail box",
  customServiceWhiteLabelingTitle: "White-labeling",
  customServiceWhiteLabelingDescription:
    "Ship hardware and apps under your own brand — packaging, firmware and UI fully customized to your identity.",
  customServiceCoBrandingTitle: "Co-branding",
  customServiceCoBrandingDescription:
    "Pair your brand with the inext platform through flexible co-branded experiences and retail kits.",
  customServiceIptvAppTitle: "Custom IPTV Client App",
  customServiceIptvAppDescription:
    "Bespoke IPTV/OTT player with EPG, catch-up, time-shift and VOD — tailored to your content catalogue.",
  customServiceLauncherTitle: "Operator Tier Launcher",
  customServiceLauncherDescription:
    "A curated Android TV launcher with branded rows, custom home screens and locked-down experiences.",
  customServiceRemoteAppTitle: "Remote Control Mobile App",
  customServiceRemoteAppDescription:
    "Turn any smartphone into a powerful remote — Bluetooth pairing, voice search, keyboard input and gestures.",
  customServiceAppDesignTitle: "Custom App Design",
  customServiceAppDesignDescription:
    "End-to-end UI/UX work for launcher, EPG and player — designed around your subscribers and your content.",
  operationsImageAlt:
    "Alcatraz DMS dashboard — real-time fleet overview with online devices, models and firmware distribution",
  operationsFeatureTelemetry: "Fleet Health alerts & issue queue",
  operationsFeatureOta: "Staged OTA firmware rollouts",
  operationsFeatureTr069: "TR-069 / CWMP support",
  operationsFeaturePush: "Targeted push notifications",
  operationsFeatureIperf: "MTR & iPerf3 diagnostics",
  operationsFeatureAccess: "Scoped API keys & role-based access",
  operationsFeatureDiagnostics: "Device activity & issue history",
  operationsLiveBadge: "Live",
  operationsCalloutOnline: "6,236 devices online",
  operationsCalloutActive: "62% active this month",
  operationsCalloutFirmware: "2 new firmwares to test",
  operationsMetric1Value: "120+",
  operationsMetric1Label: "operator networks",
  operationsMetric3Value: "24/7",
  operationsMetric3Label: "fleet monitoring",
  footerLinkTv6Ultra: "inext TV6 Ultra",
  footerLinkTv6: "inext TV6",
  footerLinkTv5Ultra: "inext TV5 Ultra",
  footerLinkTv5: "inext TV5",
  footerLinkAbout: "About",
  footerLinkBlog: "Blog",
  footerLinkNewsletter: "Newsletter",
  footerLinkFaq: "FAQ",
  footerLinkContact: "Contact",
  footerLinkDistributors: "Distributors",
  footerLinkPrivacy: "Privacy Policy",
  footerLinkRepublishing: "Republishing",
  footerLinkServiceStatus: "Service status",
  aboutTitle: "About inext",
  aboutDescription:
    "Meet inext, an international engineering team founded in Kyiv and building operator-ready set-top boxes, TV software and device management tools.",
  aboutEyebrow: "International TV technology company",
  aboutHeading: "We build TV solutions that work in real networks.",
  aboutIntro:
    "inext is an international team designing set-top boxes, TV software and fleet management tools for ISPs and OTT providers. We support the product from initial specification through deployment and long-term operation.",
  aboutStat1Value: "15",
  aboutStat1Label: "countries with operator deployments",
  aboutStat3Value: "250+",
  aboutStat3Label: "B2B clients and partners",
  aboutStat4Value: "17",
  aboutStat4Label: "STB models developed since 2011",
  aboutStat5Value: "700K+",
  aboutStat5Label: "devices delivered worldwide",
  aboutWorldwideDeliveryTitle: "Worldwide delivery in practice",
  aboutWorldwideDeliveryBody:
    "inext has practical international project experience, from single-market launches to multi-country operator rollouts. We can deliver set-top boxes, branded packaging, firmware and deployment support directly or through coordinated distributor work.",
  aboutBrandResourcesPrompt: "Looking for our logo or approved brand files?",
  aboutBrandResourcesCta: "Open brand resources",
  aboutCapabilitiesEyebrow: "What we build",
  aboutCapabilitiesTitle: "One team for the complete subscriber experience.",
  aboutCapabilitiesLede:
    "Hardware, software and fleet operations are developed together, giving operators a practical route from product specification to a supported deployment.",
  aboutCapabilityHardwareTitle: "Operator-ready TV hardware",
  aboutCapabilityHardwareBody:
    "Proven Android AOSP set-top boxes configured for IPTV and OTT services, from accessible rollout models to our flagship platform.",
  aboutCapabilityHardwareCta: "Explore the lineup",
  aboutCapabilitySoftwareTitle: "Firmware and TV software",
  aboutCapabilitySoftwareBody:
    "Branded firmware, launchers, application integration and custom TV development shaped around the operator's service and identity.",
  aboutCapabilitySoftwareCta: "Explore customization",
  aboutCapabilityOperationsTitle: "Fleet operations",
  aboutCapabilityOperationsBody:
    "Provisioning, staged firmware updates, diagnostics and remote control through Alcatraz DMS and established operator protocols.",
  aboutCapabilityOperationsCta: "Explore Alcatraz DMS",
  aboutHeritageEyebrow: "Our story",
  aboutHeritageTitle: "Kyiv roots. International perspective.",
  aboutStoryPara1:
    "Founded in Kyiv in 2011, inext began by engineering home media hardware during the shift from physical formats to streaming. Video performance, device stability and long-term reliability were essential from the start.",
  aboutStoryPara2:
    "Today, we are an international team working from several countries. As IPTV and OTT became central to operator networks, our experience evolved into a broader platform: set-top boxes, adaptable TV software and fleet management. The market has changed, but our role remains the same — turn complex technical requirements into dependable products for everyday use.",
  aboutPrinciplesEyebrow: "How we work",
  aboutPrinciplesTitle: "Practical engineering for real deployments.",
  aboutPrinciplesLede:
    "We make decisions around the realities of operator networks, subscriber support and products that need to stay useful long after launch.",
  aboutPrinciple1Title: "Deployment-ready",
  aboutPrinciple1Body:
    "Start with proven hardware and software foundations instead of rebuilding the basics for every rollout.",
  aboutPrinciple2Title: "Adaptable where it matters",
  aboutPrinciple2Body:
    "Customize branding, firmware, integrations and hardware when the project has requirements a standard device cannot meet.",
  aboutPrinciple3Title: "Supported through the lifecycle",
  aboutPrinciple3Body:
    "Manage firmware, diagnostics and device operations after launch, not only during product delivery.",
  aboutCtaEyebrow: "Work with inext",
  aboutCtaTitle: "Planning a branded TV deployment?",
  aboutCtaBody:
    "Tell us about your network, content model and markets. We will help shape the right device and software package.",
  aboutHeroEst: "Founded in Kyiv · 2011",
  aboutHeroImageAlt: "inext 3D kid, HD1, TV, TV2e and 4K2 devices",
  aboutClientsEyebrow: "Trusted by operators",
  aboutClientsLede:
    "ISPs and OTT platforms across 15 countries already ship inext STBs to their subscribers.",
  aboutClientsCta: "See all clients & case studies",
  aboutClientImageAltSuffix: "inext STB deployment",
  contactsTitle: "Contact inext",
  contactsDescription: "Talk to the right inext sales contact for your market.",
  contactsEyebrow: "Contact",
  contactsHeading: "Let's build your next TV experience",
  contactsIntro: "Tell us about your project and our team will get back to you.",
  contactFormTitle: "Send an inquiry",
  contactFormIntro: "Share a few details so we can connect you with the right person.",
  contactNameLabel: "Name",
  contactCompanyLabel: "Company",
  contactCompanyOptionalLabel: "Company (optional)",
  contactCompanyRequired: "Enter a company name for this inquiry type.",
  contactCountryLabel: "Country",
  contactPhoneOptionalLabel: "Phone (optional)",
  contactInquiryTypeLabel: "How can we help?",
  contactInquiryTypePlaceholder: "Select an inquiry type",
  contactInquiryType_sales: "Sales inquiry",
  contactInquiryType_demo: "Book a demo",
  contactInquiryType_integration: "Integration",
  contactInquiryType_brand: "Brand & media request",
  contactInquiryType_partnership: "Partnership",
  contactInquiryType_support: "Device support",
  contactInquiryType_other: "Other",
  contactBrandResourcesNote:
    "Official logo files and usage guidelines are available for immediate download. Use this form only for special-use questions.",
  contactBrandResourcesCta: "Open brand resources",
  contactMessageLabel: "Message",
  contactWebsiteHoneypotLabel: "Website",
  contactConsentPrefix: "I agree to the processing of my information as described in the",
  contactPrivacyLink: "Privacy Policy",
  contactConsentRequired: "Please accept the privacy policy to continue.",
  contactSubmit: "Send inquiry",
  contactSubmitting: "Sending...",
  contactSuccessTitle: "Thank you for contacting us",
  contactSuccessBody: "Your inquiry has been sent. Our team will get back to you shortly.",
  contactFailureTitle: "We couldn't send your inquiry",
  contactFailureBody: "Please try again or email us directly at",
  contactRoutingLabel: "Global sales & distributor routing",
  findDistributorTitle: "Looking for a local distributor?",
  findDistributorBody: "Find the right inext partner for your market.",
  viewDistributors: "View distributors",
  exclusiveDistributorTitle: "Exclusive distributor in Ukraine",
  globalDistributorListTitle: "Distributors",
  distributorListTitle: "Distributors in Poland",
  otherRegionsDistributorTitle: "Other regions",
  directSalesOperationsTitle: "Direct sales & EU operations",
  contactAddressLabel: "Address",
  contactPhoneLabel: "Phone",
  contactEmailLabel: "E-mail",
  contactWebsiteLabel: "Website",
  distributorsTitle: "inext distributors",
  distributorsDescription: "Find an official inext distributor for your market.",
  distributorsEyebrow: "Partners",
  distributorsHeading: "Find your local distributor",
  distributorsIntro: "Connect with an official inext distributor in your region.",
  distributorRegionUkraine: "Ukraine",
  distributorRegionPoland: "Poland",
  distributorRegionSlovakia: "Slovakia",
  distributorRegionMoldova: "Moldova",
  distributorRegionEuOperations: "EU operations",
  distributorRegionGlobal: "Global",
  distributorContactCtaTitle: "Not sure who to contact?",
  distributorContactCtaBody:
    "Tell us about your market and project. We'll route your inquiry to the right distributor or direct inext sales contact.",
  distributorContactCtaButton: "Contact inext",
  privacyTitle: "Privacy Policy",
  privacyDescription: "How inext processes information submitted through this website.",
  privacyEyebrow: "Legal",
  privacyHeading: "Privacy Policy",
  republishingTitle: "Republishing & Licensing",
  republishingDescription:
    "Most inext articles are CC BY 4.0 — free to republish, translate, and adapt with attribution. Here's how.",
  republishingEyebrow: "Licensing",
  republishingHeading: "Republishing our content",
  blogLicenseLabel: "License",
  blogLicenseAllRightsReserved: "All rights reserved",
  blogLicenseReusableNote: "You're welcome to republish this article with attribution to inext.",
  blogLicenseReservedNote: "Please contact us before republishing.",
  blogLicenseGuidelines: "Republishing guidelines",
  republishKitToggle: "Republish this article",
  republishKitIntro: "Licensed CC BY 4.0 — credit inext and link back.",
  republishCopyLink: "Copy link",
  republishCopyMarkdown: "Copy as Markdown",
  republishCopyHtml: "Copy as HTML",
  republishDownloadMarkdown: "Download .md",
  republishDownloadHtml: "Download .html",
  republishDownloadImages: "Download images (.zip)",
  republishDownloadingImages: "Preparing images…",
  republishDownloadAudio: "Download audio",
  republishDownloadingAudio: "Preparing audio…",
  republishCopied: "Copied",
  republishContact: "Questions or need a higher-res asset?",
  republishReservedNotice:
    "This article is republished from a third party and isn't available under CC BY 4.0.",
  republishCreditPrefix: "Originally published by inext at ",
  republishCreditSuffix: " — republished under CC BY 4.0.",
  faqTitle: "inext FAQ",
  faqDescription:
    "Answers about inext STBs, IPTV solutions, customization, Alcatraz™ DMS, firmware and troubleshooting.",
  faqEyebrow: "Support",
  faqHeading: "Frequently asked questions",
  faqIntro:
    "Quick answers about inext hardware, operator solutions (IPTV app, branding, fleet management), firmware and common device issues.",
  faqCategoryAll: "All",
  faqCategoryDevices: "Devices & Setup",
  faqCategoryFirmware: "Firmware",
  faqCategorySolutions: "Solutions & Apps",
  faqCategoryManagement: "Alcatraz™ DMS",
  faqCategoryTroubleshooting: "Troubleshooting",
  faqQuestionCompare: "Which inext set-top box should I choose?",
  faqAnswerCompare:
    "TV6 Ultra is the flagship for premium 4K deployments. TV6 balances performance and cost. TV5 Ultra suits mainstream IPTV/OTT rollouts; TV5 is the entry tier. Use our side-by-side compare tool to match memory, remotes and connectivity to your network.",
  faqQuestionIptvMiddleware: "Which IPTV middleware does the inext IPTV app support?",
  faqAnswerIptvMiddleware:
    "The prebuilt inext IPTV client works with Stalker/Ministra, TVIP, Hibox, Aura and plain M3U playlists with XMLTV EPG — white-labelled and preconfigured for your service before boxes ship.",
  faqQuestionWhiteLabel: "What's the difference between co-branding and white-labeling?",
  faqAnswerWhiteLabel:
    "Co-branding pairs your brand with inext on shared hardware and UI. White-labeling removes inext from the box, firmware and apps entirely — subscribers only see your identity.",
  faqQuestionRemoteApp: "What is the inext Remote app?",
  faqAnswerRemoteApp:
    "inext Remote is a free companion app for Android and iOS that controls inext STBs from a phone — keyboard and voice search, room switching, gamepad mode and light/dark themes.",
  faqQuestionBuy: "How can I buy inext products or become a partner?",
  faqAnswerBuy:
    "inext sells to operators and distributors worldwide. Find an authorised partner near you, or contact our sales team for fleet quotes, customization and Alcatraz™ DMS onboarding.",
  faqQuestionAlcatrazDeploy: "Can Alcatraz™ DMS run in our own network?",
  faqAnswerAlcatrazDeploy:
    "Yes. Alcatraz runs as managed cloud SaaS or as an on-premises install inside a closed ISP network — same console and feature set, with deployment chosen to match your data-residency requirements.",
  faqQuestionAlcatrazIntegrate: "Can we integrate Alcatraz with our BSS/OSS or support tools?",
  faqAnswerAlcatrazIntegrate:
    "Yes. Alcatraz provides a documented REST API and MQTT messaging. Administrators can create and revoke API keys, restrict permissions and source IP addresses, set expiration dates, and connect device records to CRM or billing references through external IDs.",
  faqQuestionHdmi: "Which HDMI standard do inext devices support?",
  faqAnswerHdmi:
    "All current inext STBs include HDMI 2.0a output with CEC support. An HDMI cable is included in the box.",
  faqQuestionResolution: "Do all inext devices support 4K?",
  faqAnswerResolution:
    "Yes — TV5, TV5 Ultra, TV6 and TV6 Ultra all support 4K UHD playback at up to 60 FPS via hardware H.265, VP9 and H.264 decoding.",
  faqQuestionAndroid: "Which Android version do inext devices run?",
  faqAnswerAndroid:
    "TV6 Ultra and TV6 run Android 12 (AOSP). TV5 Ultra and TV5 run Android 10 (AOSP). All models use open AOSP without pre-installed Google Play Services.",
  faqQuestionRemote: "What type of remote control is included?",
  faqAnswerRemote:
    "TV6 Ultra ships with a Bluetooth 5.0 voice remote. TV6 typically includes an IR remote with a full numeric keypad, though some regions ship it with a Bluetooth remote instead. TV5 Ultra and TV5 include an IR remote with a full numeric keypad.",
  faqQuestionFirmwares: "Where can I find official Firmwares?",
  faqAnswerFirmwares:
    "All the latest firmware for inext devices are available only for online OTA update. You can check for online updates on your device via Settings → About → System update. If you experience any problems updating your device, please contact our service center.",
  faqQuestionFirmwareCheck: "How do I check my current firmware version?",
  faqAnswerFirmwareCheck:
    "Go to Settings → About → Build number on your device. The firmware version and build date are displayed there.",
  faqQuestionOtaFleet: "How do OTA firmware updates work for operators?",
  faqAnswerOtaFleet:
    "OTA Firmware Updates is an operator solution built into the Alcatraz platform. Upload a release, define target device groups and set a staged rollout percentage — the platform routes downloads through the nearest storage node and tracks per-device installation status. You can pause, expand, or roll back at any stage, and mark critical updates as mandatory so devices cannot skip them.",
  faqQuestionAlcatraz: "What is Alcatraz™ DMS?",
  faqAnswerAlcatraz:
    "Alcatraz™ DMS is the inext platform for remote fleet management. Operators use Fleet Health to prioritize issues, review device activity, deploy OTA firmware, run diagnostics and manage settings from one console. Alcatraz Pro is included at no extra cost for fleets with fewer than 500 active devices. For fleets with 500 active devices or more, access and commercial terms are agreed directly with inext.",
  faqQuestionAlcatrazModels: "Which models include Alcatraz™ DMS support?",
  faqAnswerAlcatrazModels:
    "All four current inext models — TV5, TV5 Ultra, TV6 and TV6 Ultra — ship with Alcatraz™ DMS support included.",
  faqQuestionTr069: "Is TR-069 supported?",
  faqAnswerTr069:
    "Yes. All current models support TR-069/CWMP alongside Alcatraz, so operators with an existing ACS can keep using it. Alcatraz adds richer telemetry, push notifications, in-app remote control and a modern REST API on top.",
  faqQuestionBlackScreen: "My device has a black screen, what should I do?",
  faqAnswerBlackScreen:
    "First of all, try a simple reboot: unplug your inext from the power socket, wait for 30 seconds, then plug it back in. If this doesn't help, please contact our service center.",
  faqQuestionWifi: "My device won't connect to Wi-Fi. What should I do?",
  faqAnswerWifi:
    "Make sure you're in range of your router and entering the correct password. If that doesn't help: (1) restart the device and router, (2) forget the network and reconnect, (3) check that your router broadcasts on a band the device supports (2.4 GHz or 5 GHz). If none of these work, contact our service center.",
  faqQuestionBlocked: "My device says that it has been blocked. What should I do?",
  faqAnswerBlocked:
    "First of all, try to contact your Internet Service Provider (ISP). If your ISP can't help you, please drop us a message using the contact form above.",
  faqContactTitle: "Still have a question?",
  faqContactBody:
    "Our support team and service partners can help with device issues, firmware, IPTV app setup, customization, provisioning and Alcatraz™ DMS integration.",
  faqContactCta: "Contact support",
  faqSearchPlaceholder: "Search questions...",
  faqSearchClear: "Clear search",
  faqNoResultsTitle: "No results found",
  faqNoResultsWithQuery: 'Nothing matched "{query}". Try different keywords or clear the search.',
  faqNoResultsCategory: "No questions in this category yet.",
  searchTitle: "Search inext",
  searchDescription: "Search the inext website, product pages, support pages and blog articles.",
  searchEyebrow: "Search",
  searchHeading: "Search the inext website",
  searchIntro:
    "Find product details, support answers, distributor contacts, legal information and blog articles across the site.",
  searchPlaceholder: "Search products, support, blog...",
  searchClear: "Clear search",
  searchLoading: "Loading search index...",
  searchErrorTitle: "Search is temporarily unavailable",
  searchErrorBody:
    "The search index could not be loaded. Please refresh the page or try again later.",
  searchNoQueryTitle: "Start with a keyword",
  searchNoQueryBody:
    "Search by model name, feature, distributor, support topic or article keyword.",
  searchNoResultsTitle: "No results found",
  searchNoResultsBody: 'Nothing matched "{query}". Try a shorter phrase or a different keyword.',
  searchResultsCount: '{count} results for "{query}"',
  searchTypePage: "Page",
  searchTypeProduct: "Product",
  searchTypeBlog: "Blog",
  searchTypeSupport: "Support",
  searchTypeLegal: "Legal",
  searchTypeApp: "App",
  blogTitle: "inext insights",
  blogDescription:
    "Event highlights, product news, and technical insights for IPTV and OTT operators.",
  blogReadMore: "Read article",
  blogEmpty: "No articles have been published for this market yet.",
  blogFeatured: "Latest",
  blogFilterAll: "All",
  blogTagEvents: "Events",
  blogTagPartnerships: "Partnerships",
  blogTagProducts: "Products",
  blogTagSoftware: "Software",
  blogTagCompany: "Company",
  blogLoadMore: "Load more",
  blogBackToTop: "Back to top",
  blogNewerPost: "Newer article",
  blogOlderPost: "Older article",
  blogMediaAudio: "Includes audio",
  blogMediaVideo: "Includes video",
  newsletterEyebrow: "inext updates",
  newsletterTitle: "Product launches, firmware releases, and practical insights for operators.",
  newsletterDescription:
    "Get product announcements, firmware releases, Alcatraz DMS updates, and practical articles for TV operators.",
  newsletterSeoTitle: "inext newsletter — product news and firmware updates",
  newsletterSeoDescription:
    "Subscribe for inext product announcements, firmware releases, Alcatraz DMS updates, and practical articles for TV operators.",
  newsletterPageBenefitProducts: "New set-top boxes and accessories",
  newsletterPageBenefitFirmware: "Firmware releases and Alcatraz DMS updates",
  newsletterPageBenefitInsights: "Practical guides for TV operators",
  newsletterPageFormTitle: "Subscribe to inext updates",
  newsletterPageReassurance: "Occasional emails. Unsubscribe anytime.",
  newsletterEmailLabel: "Email address",
  newsletterEmailPlaceholder: "name@company.com",
  newsletterSubmit: "Subscribe",
  newsletterSubmitting: "Subscribing…",
  newsletterSuccessTitle: "You’re subscribed",
  newsletterSuccessBody: "You’ll now receive product news and updates from inext.",
  newsletterError: "We couldn’t complete your subscription. Please try again.",
  newsletterPrivacyPrefix:
    "By subscribing, you agree to receive product news and updates from inext. Read our",
  newsletterPrivacyLink: "privacy policy",
  newsletterWebsiteLabel: "Leave this field blank",
  newsEyebrow: "Newsroom",
  newsTitle: "What's new at",
  newsTitleAccent: "inext",
  newsDescription: "Product launches, partnerships, and field notes from operator deployments.",
  newsViewAll: "View all articles",
  notFoundTitle: "Page not found",
  notFoundBody: "The page you're looking for doesn't exist or has been moved.",
  goHome: "Go home",
  errorTitle: "This page didn't load",
  errorBody: "Something went wrong on our end. You can try refreshing or head back home.",
  tryAgain: "Try again",
  compareAllModels: "Compare all 4 models",
  compareTierFlagship: "Flagship",
  compareTierPerformance: "Performance",
  compareTierStandard: "Standard",
  compareTierEssential: "Essential",
  compareGroupPerformance: "Performance",
  compareGroupConnectivity: "Connectivity",
  compareGroupManagement: "Management",
  compareGroupPhysical: "Physical",
  compareGroupInBox: "In the box",
  compareRowOs: "Operating system",
  compareRowChipset: "Chipset",
  compareRowCpu: "CPU",
  compareRowGpu: "GPU",
  compareRowRam: "RAM",
  compareRowStorage: "Storage",
  compareRowMaxRes: "Max resolution",
  compareRowCodecs: "Video codecs",
  compareRowHdmi: "HDMI",
  compareRowEthernet: "Ethernet",
  compareRowWifi: "Wi-Fi",
  compareRowBluetooth: "Bluetooth",
  compareRowUsb: "USB",
  compareRowCardReader: "Card reader",
  compareRowAvOutput: "AV / audio output",
  compareRowRemote: "Remote",
  compareRowAlcatraz: "Alcatraz DMS",
  compareRowTr069: "TR-069",
  compareRowDimensions: "Dimensions",
  compareRowPower: "Power supply",
  compareRowRemoteInBox: "Remote control",
  compareRowHdmiCable: "HDMI cable",
  compareRowPowerAdapter: "Power adapter",
  compareRowBatteries: "Batteries",
  compareRowGuide: "Quick start guide",
  compareViewSpecs: "View specs",
  compareCtaTitle: "Need help choosing the right model?",
  compareCtaBody:
    "Tell us about your network, subscriber profile and target price point. We will map the right inext device to your rollout.",
  compareIncluded: "Included",
  compareNotIncluded: "Not included",
  compareModelTv6UltraTagline: "Flagship Android 12 box for advanced 4K deployments.",
  compareModelTv6UltraSpecRemote: "BT Voice Remote",
  compareModelTv6UltraHighlight1: "Highest RAM & storage in the lineup",
  compareModelTv6UltraHighlight2: "Bluetooth 5.0 voice remote",
  compareModelTv6UltraHighlight3: "Alcatraz™ DMS + TR-069",
  compareModelTv6Tagline: "Balanced Android 12 model for everyday IPTV and OTT.",
  compareModelTv6SpecRemote: "IR Remote",
  compareModelTv6Highlight1: "Same H618 platform as TV6 Ultra",
  compareModelTv6Highlight2: "Android 12 AOSP",
  compareModelTv6Highlight3: "Alcatraz™ DMS + TR-069",
  compareModelTv5UltraTagline: "Stable Android 10 option with 2 GB RAM.",
  compareModelTv5UltraSpecRemote: "IR Remote",
  compareModelTv5UltraHighlight1: "Proven H313 platform",
  compareModelTv5UltraHighlight2: "Alcatraz™ DMS + TR-069",
  compareModelTv5UltraHighlight3: "RCA AV output for legacy TVs",
  compareModelTv5Tagline: "Essential Android 10 box for cost-sensitive rollouts.",
  compareModelTv5SpecRemote: "IR Remote",
  compareModelTv5Highlight1: "Most cost-effective in the lineup",
  compareModelTv5Highlight2: "Alcatraz™ DMS + TR-069",
  compareModelTv5Highlight3: "4K@60 hardware decoding",
  compareRemoteBtVoice: "BT Voice",
  compareRemoteIr: "IR",
  productPhotoComingSoon: "Product photo coming soon",
  productHardwarePhotoComingSoon: "Hardware photo coming soon",
  productSoftwarePhotoComingSoon: "Software lifestyle photo coming soon",
  productSoftwareLifestyleImageAlt:
    "TV showing a region-neutral operator launcher with Live TV, VOD, catch-up, radio, apps and settings",
  tv6HeroImageAlt:
    "inext TV6 on a living-room table with the TV showing inext TV, MEGOGO, sweet.tv, IPTV, Plex, VLC and Spotify",
  tv6PortsImageAlt:
    "inext TV6 rear ports: microSD, 2× USB, market-dependent IR extender or AV port, S/PDIF, Ethernet, HDMI, DC 5V",
  tv6RemoteImageAlt:
    "inext TV6 IR remote control with full numeric keypad, navigation pad and direct playback buttons",
  tv6HardwareRevealLabel: "Reveal TV6 internal hardware",
  tv6HardwareRevealImageAlt: "inext TV6 top view with a draggable reveal of the internal hardware",
  tv6UltraHeroImageAlt:
    "inext TV6 Ultra on a living-room console with the TV showing inext TV, MEGOGO, sweet.tv, IPTV, Plex, VLC and Spotify",
  tv6UltraPortsImageAlt:
    "inext TV6 Ultra rear ports: microSD, 2× USB, AV, S/PDIF, Ethernet, HDMI, DC 5V",
  tv5PortsImageAlt:
    "inext TV5 rear ports: AV, S/PDIF optical, Ethernet, HDMI, DC power, 2× USB, microSD",
  tv5RemoteImageAlt: "inext TV5 remote control with OK pad, number keys and shortcut buttons",
  tv5HardwareRevealLabel: "Reveal TV5 internal hardware",
  tv5HardwareRevealImageAlt: "inext TV5 top view with a draggable reveal of the internal hardware",
  tv5SoftwareImageAlt: "TV showing a customizable IPTV launcher above an inext TV5 set-top box",
  tv6UltraRemoteImageAlt:
    "inext Bluetooth voice remote with microphone, programmable TV power and FAV buttons",
  tv6UltraHardwareRevealLabel: "Reveal TV6 Ultra internal hardware",
  tv6UltraHardwareRevealImageAlt:
    "inext TV6 Ultra top view with a draggable reveal of the internal hardware",
  tv5UltraSeoTitle: "inext TV5 Ultra — Android 10 Set-Top Box for Operators",
  tv5UltraSeoDescription:
    "inext TV5 Ultra: Allwinner H313, 2GB RAM, 16GB eMMC, 4K@60 playback, dual-band Wi-Fi, Android 10 AOSP and Alcatraz™ DMS for operator deployments.",
  tv5SeoTitle: "inext TV5 — Essential Android 10 Set-Top Box for Operators",
  tv5SeoDescription:
    "inext TV5: Allwinner H313, 1GB RAM, 8GB eMMC, 4K@60 playback, dual-band Wi-Fi, Android 10 AOSP and Alcatraz™ DMS for cost-effective IPTV and OTT rollouts.",
  tv5UltraHeroEyebrow: "Standard · Android 10 STB",
  tv5UltraHeroHeadline: "A proven Android TV box for stable operator rollouts.",
  tv5UltraHeroSub:
    "TV5 Ultra pairs the reliable Allwinner H313 platform with 2 GB RAM, 16 GB storage, practical connectivity and inext Alcatraz™ DMS support.",
  tv5UltraHeroImageAlt: "inext TV5 Ultra on a media console below a TV running the inext launcher",
  tv5UltraHardwareRevealLabel: "Reveal TV5 Ultra internal hardware",
  tv5UltraHardwareRevealImageAlt:
    "inext TV5 Ultra top view with a draggable reveal of the internal hardware",
  tv5UltraSoftwareImageAlt:
    "TV showing a customizable operator launcher above an inext TV5 Ultra set-top box",
  tv5UltraCompareLabel: "Compare all models",
  tv5UltraGlanceValue1: "4K @ 60 Hz",
  tv5UltraGlanceLabel1: "H.265 playback",
  tv5UltraGlanceValue2: "Android 10",
  tv5UltraGlanceLabel2: "AOSP, app-ready",
  tv5UltraGlanceValue3: "2 GB / 16 GB",
  tv5UltraGlanceLabel3: "DDR3 + eMMC",
  tv5UltraGlanceValue4: "IR Remote",
  tv5UltraGlanceLabel4: "Simple control",
  tv5UltraIntroPara1:
    "TV5 Ultra is built for operators who need a stable Android 10 set-top box with enough memory for everyday IPTV, OTT and launcher workflows.",
  tv5UltraIntroPara2:
    "It keeps the deployment practical: proven hardware, familiar IR control, broad media support and remote management through Alcatraz™ DMS.",
  tv5UltraPerformanceTitle: "Proven 4K, with room to spare.",
  tv5UltraPerformanceBody:
    "Allwinner H313 with Mali-G31 MP2 gives TV5 Ultra reliable 4K@60 H.265 playback for IPTV, OTT and launcher workflows, with 2 GB RAM and 16 GB eMMC for everyday operator deployments.",
  tv5UltraPerformanceAccent: "Allwinner H313 · 2 GB DDR3 · 16 GB eMMC · 4K@60 H.265",
  tv5UltraConnectivityCaption:
    "HDMI 2.0a · 100 Mb Ethernet · 2× USB 2.0 · microSD · S/PDIF optical · RCA AV output · dual-band Wi-Fi 2.4/5 GHz.",
  tv5UltraPortsImageAlt: "inext TV5 Ultra rear ports — optical S/PDIF, LAN, HDMI, USB and microSD",
  tv5UltraSoftwareTitle: "Android 10, tuned for operator apps.",
  tv5UltraSoftwareBody:
    "Android 10 AOSP gives operators a familiar app platform, custom launcher options and remote fleet workflows through Alcatraz™ DMS and TR-069.",
  tv5UltraRemoteFeature1: "Full numeric keypad for channel-based IPTV services",
  tv5UltraRemoteFeature2: "Dedicated navigation and playback controls",
  tv5UltraRemoteFeature3: "IR control for simple subscriber setup",
  tv5UltraAlcatrazBody:
    "TV5 Ultra can be provisioned, monitored and updated through the same Alcatraz device management workflows used across the inext lineup.",
  tv5UltraCtaTitle: "Order TV5 Ultra for your network",
  tv5UltraCtaBody:
    "A practical Android 10 STB option with 2 GB RAM, 16 GB storage, branded packaging and Alcatraz™ provisioning.",
  tv5HeroEyebrow: "Essential · Android 10 STB",
  tv5HeroHeadline: "Cost-effective Android TV for essential IPTV deployments.",
  tv5HeroSub:
    "TV5 keeps the inext operator stack accessible with Android 10, H313 4K playback, 1 GB RAM, 8 GB storage and Alcatraz™ DMS support.",
  tv5CompareLabel: "Compare all models",
  tv5GlanceValue1: "4K @ 60 Hz",
  tv5GlanceLabel1: "H.265 playback",
  tv5GlanceValue2: "Android 10",
  tv5GlanceLabel2: "AOSP, app-ready",
  tv5GlanceValue3: "1 GB / 8 GB",
  tv5GlanceLabel3: "DDR3 + eMMC",
  tv5GlanceValue4: "IR Remote",
  tv5GlanceLabel4: "Simple control",
  tv5IntroPara1:
    "TV5 is the entry point into the inext operator lineup: compact hardware, Android 10 AOSP and the essential connectivity needed for managed IPTV and OTT services.",
  tv5IntroPara2:
    "It is designed for rollouts where low device cost, predictable playback and fleet control matter most.",
  tv5PerformanceTitle: "Dependable 4K on a lean budget.",
  tv5PerformanceBody:
    "Allwinner H313 with Mali-G31 MP2 gives TV5 reliable 4K@60 H.265 playback for essential IPTV and OTT services, with 1 GB RAM and 8 GB eMMC for cost-sensitive operator rollouts.",
  tv5PerformanceAccent: "Allwinner H313 · 1 GB DDR3 · 8 GB eMMC · 4K@60 H.265",
  tv5ConnectivityCaption:
    "HDMI 2.0a · 100 Mb Ethernet · 2× USB 2.0 · microSD · S/PDIF optical · RCA AV output · dual-band Wi-Fi 2.4/5 GHz.",
  tv5SoftwareTitle: "Android 10 for essential service delivery.",
  tv5SoftwareBody:
    "TV5 supports operator launchers, IPTV and OTT apps, localization and remote fleet control through Alcatraz™ DMS and TR-069.",
  tv5RemoteFeature1: "Numeric keypad for channel-based navigation",
  tv5RemoteFeature2: "Dedicated playback and menu controls",
  tv5RemoteFeature3: "Simple IR setup for subscriber homes",
  tv5AlcatrazBody:
    "TV5 can be provisioned, monitored and updated through Alcatraz™ DMS, keeping low-cost deployments manageable at scale.",
  tv5CtaTitle: "Order TV5 for your network",
  tv5CtaBody:
    "A cost-effective Android STB package with branded packaging and Alcatraz™ provisioning for essential IPTV and OTT rollouts.",
  tv6SeoTitle: "inext TV6 — 4K Android 12 Set-Top Box for Operators",
  tv6SeoDescription:
    "inext TV6: Allwinner H618, 2GB RAM, 16GB eMMC, 4K@60 HDR, dual-band Wi-Fi, Android 12 AOSP and Alcatraz™ DMS. A compact STB for ISPs, hotels and OTT operators.",
  tv6UltraSeoTitle: "inext TV6 Ultra — 4K Android 12 Set-Top Box for Operators",
  tv6UltraSeoDescription:
    "inext TV6 Ultra: Allwinner H618, 4GB RAM, 32GB eMMC, 4K@60 HDR, dual-band Wi-Fi, BT 5.0, Android 12 AOSP and Alcatraz™ DMS. Built for ISPs, hotels and OTT operators.",
  tv6UltraBreadcrumbHome: "Home",
  tv6UltraBreadcrumbProducts: "Products",
  tv6UltraContactSales: "Contact sales",
  tv6UltraFindDistributor: "Find a distributor",
  tv6UltraAlcatrazTitle: "Managed by Alcatraz™ DMS",
  tv6UltraAlcatrazBody:
    "Every TV6 Ultra ships ready for the inext Alcatraz device management system — used today by 120+ operator networks worldwide.",
  tv6UltraAlcatrazCta: "See operations",
  tv6UltraCtaTitle: "Order TV6 Ultra for your network",
  tv6UltraCtaBody:
    "Volume pricing, white-label packaging and Alcatraz™ provisioning — all from one team.",
  tv6UltraSpecChipset: "Chipset",
  tv6UltraSpecCpu: "CPU",
  tv6UltraSpecGpu: "GPU",
  tv6UltraSpecRam: "RAM",
  tv6UltraSpecStorage: "Storage",
  tv6UltraSpecDimensions: "Dimensions",
  tv6UltraSpecPower: "Power supply",
  tv6UltraSpecHdmi: "HDMI",
  tv6UltraSpecEthernet: "Ethernet",
  tv6UltraSpecWifi: "Wi-Fi",
  tv6UltraSpecBluetooth: "Bluetooth",
  tv6UltraSpecUsb: "USB",
  tv6UltraSpecCardReader: "Card reader",
  tv6UltraSpecAudioOut: "Audio output",
  tv6UltraSpecAudioFormats: "Audio formats",
  tv6UltraSpecVideoFormats: "Video formats",
  tv6UltraSpecVideoCodecs: "Video codecs",
  tv6UltraSpecMaxRes: "Max resolution",
  tv6UltraSpec3d: "3D support",
  tv6UltraSpecImageFormats: "Image formats",
  tv6UltraSpecOs: "Operating system",
  tv6UltraSpecDms: "Device management",
  tv6UltraSpecTr069: "TR-069",
  tv6UltraSpecFilesystems: "File systems",
  tv6UltraSpecLanguages: "Languages",
  tv6UltraSpecInternet: "Internet features",
  tv6UltraSpecTr069Yes: "Supported",
  tv6UltraSpecLanguagesValue: "Multi-language",
  productSpecCpuArmv8Quad: "ARM v8 Cortex-A53 Quad-Core",
  productSpecCpuQuadCoreArm: "Quad-Core ARM Cortex-A53",
  productSpecHdmiCableIncluded: "HDMI 2.0a (cable included)",
  productSpecEthernet100: "RJ45 Fast Ethernet (100 Mbps)",
  productSpecWifiDualBandN: "Dual-band 2.4 / 5 GHz · 802.11 b/g/n",
  productSpecWifiDualBandAc: "Dual-band 2.4 / 5 GHz · 802.11 b/g/n/ac",
  productSpecUsbHost: "2 × USB 2.0 Host",
  productSpecAudioSpdifRcaTrs: "S/PDIF optical · RCA via 3.5 mm TRS",
  productSpecAudioSpdif: "S/PDIF optical",
  productSpecAudioSpdifRca: "S/PDIF optical · RCA (3.5 mm TRS)",
  productSpecInternetFeatures:
    "IPTV · OTT · VOD · HLS · Internet Radio · HTML5 · WebKit · Android Apps",
  tv6UltraSpec3dValue: "Side-by-side · Frame-packed",
  tv6UltraSpecMaxResValue: "4K UHD (2160p) @ 60 FPS",
  tv6PackageRemote: "IR remote control",
  tv6UltraPackageRemote: "Bluetooth remote control",
  tv6UltraPackagePower: "Power adapter (5V / 2A)",
  tv6UltraPackageHdmi: "HDMI cable",
  tv6UltraPackageGuide: "Quick start guide",
  tv6UltraPackageBatteries: "Batteries",
  packageNote: "Package contents may vary by market, shipment and operator configuration.",
  tv6HeroEyebrow: "Essential · 4K Android 12 STB",
  tv6HeroHeadline: "Compact power for everyday IPTV and OTT.",
  tv6HeroSub:
    "A practical Android 12 set-top box for operator deployments that need reliable 4K playback, proven connectivity and Alcatraz™ DMS control without flagship memory overhead.",
  tv6CompareLabel: "Compare with TV6 Ultra",
  tv6GlanceValue1: "4K @ 60 Hz",
  tv6GlanceLabel1: "HDR · H.265",
  tv6GlanceValue2: "Android 12",
  tv6GlanceLabel2: "AOSP, app-ready",
  tv6GlanceValue3: "2 GB / 16 GB",
  tv6GlanceLabel3: "DDR3 + eMMC",
  tv6GlanceValue4: "IR Remote",
  tv6GlanceLabel4: "Simple control",
  tv6IntroPara1:
    "TV6 brings the same operator-first inext approach into a compact, cost-effective device: 4K video support, Android 12 AOSP, practical home connectivity and remote fleet management.",
  tv6IntroPara2:
    "It is designed for deployments where predictable subscriber experience, easy provisioning and long-term support matter more than oversized specifications.",
  tv6PerformanceAccent: "Allwinner H618 · 2 GB DDR3 · 16 GB eMMC · 4K@60 H.265",
  tv6ConnectivityCaption:
    "HDMI 2.0a · 100 Mb Ethernet · 2× USB 2.0 · microSD · S/PDIF optical · dedicated IR extender or AV port, depending on the TV6 variant · dual-band Wi-Fi 2.4/5 GHz · Bluetooth 5.0.",
  tv6RemoteEyebrow: "Remote",
  tv6RemoteTitle: "Simple IR control for everyday viewing.",
  tv6RemoteBody:
    "The included IR remote keeps the living-room experience familiar: numeric keypad, navigation controls, playback buttons and direct access patterns that fit IPTV subscribers.",
  tv5RemoteTitle: "A familiar remote, included.",
  tv5RemoteBody:
    "TV5 comes with a classic IR remote — numeric keypad, D-pad navigation and playback keys — so first-time setup feels instantly familiar.",
  tv5UltraRemoteTitle: "Classic IR remote in every box.",
  tv5UltraRemoteBody:
    "TV5 Ultra ships with the same dependable IR remote: full numeric keypad, navigation pad and direct playback buttons, ready to pair out of the box.",
  tv6PerformanceTitle: "Smooth 4K without the flagship price.",
  tv6PerformanceBody:
    "The quad-core Allwinner H618 with Mali-G31 MP2 decodes H.265, VP9 Profile 2 and H.264 in hardware — dependable 4K playback for mainstream IPTV and OTT line-ups.",
  tv6SoftwareTitle: "Android 12 with room to grow.",
  tv6SoftwareBody:
    "Open Android 12 (AOSP) with Bluetooth, dual-band Wi-Fi and an operator-ready launcher — a flexible base for branded apps, OTT services and casual gaming.",
  tv6RemoteFeature1: "Full numeric keypad for channel-based services",
  tv6RemoteFeature2: "Dedicated navigation and playback controls",
  tv6RemoteFeature3:
    "Dedicated IR extender port on supported TV6 variants; variants with an AV port do not support the extender",
  tv6RemoteBtNoteTitle: "Any remote you spec",
  tv6RemoteBtNoteBody:
    "A built-in Bluetooth module lets you order TV6 with any remote in our lineup — IR or Bluetooth. In some regions it ships with a Bluetooth remote by default.",
  tv6RemoteBtNoteLink: "Browse remote options",
  tv5RemoteIrNoteTitle: "Your choice of IR remote",
  tv5RemoteIrNoteBody:
    "Ships with a classic IR remote, but it can be spec'd with any IR remote in our lineup — including programmable models that control the set-top box and the TV together.",
  tv6IrAvPortLabel: "3.5 mm port",
  tv6IrAvPortSpec:
    "Varies by market: dedicated IR extender or AV; AV variants are not compatible with the IR extender",
  tv6AlcatrazBody:
    "Every TV6 can be provisioned, monitored and updated through the inext Alcatraz device management system used by operator networks worldwide.",
  tv6CtaTitle: "Order TV6 for your network",
  tv6CtaBody:
    "Volume pricing, branded packaging and Alcatraz™ provisioning for practical IPTV and OTT rollouts.",
  tv6UltraV2HeroEyebrow: "Flagship · 4K Android 12 STB",
  tv6UltraV2HeroHeadline: "Maximum power for maximum content.",
  tv6UltraV2HeroSub:
    "An operator-grade media hub for the living room — and the operations team behind it.",
  tv6UltraCompareLabel: "Compare all models",
  tv6UltraV2IntroPara1:
    "TV6 Ultra is the flagship of the inext family: twice the RAM and storage of TV6, hardware-accelerated 4K at 60 FPS, and the same Alcatraz™ DMS that already powers 120+ operator networks worldwide.",
  tv6UltraV2IntroPara2:
    "Built to disappear into the living room and stay invisible to your support team — fast to provision, easy to update, quiet on the shelf.",
  tv6UltraV2PerformanceEyebrow: "Performance",
  tv6UltraV2PerformanceTitle: "Effortless 4K. Every codec.",
  tv6UltraV2PerformanceBody:
    "The Allwinner H618 quad-core with Mali-G31 MP2 decodes H.265, VP9 Profile 2 and H.264 in hardware, so 4K streams, VOD and apps stay smooth even under load.",
  tv6UltraV2PerformanceAccent: "Allwinner H618 · 4 GB DDR3 · 32 GB eMMC · 4K@60 H.265",
  tv6UltraV2ConnectivityEyebrow: "Connectivity",
  tv6UltraV2ConnectivityTitle: "Every port your subscribers need.",
  tv5ConnectivityTitle: "Every essential port, built in.",
  tv5UltraConnectivityTitle: "All the I/O your install needs.",
  tv6ConnectivityTitle: "Wired, Wi-Fi and Bluetooth ready.",
  tv6UltraV2ConnectivityCaption:
    "HDMI 2.0a · 100 Mb Ethernet · 2× USB 2.0 · microSD · S/PDIF optical · AV · dual-band Wi-Fi 2.4/5 GHz · Bluetooth 5.0.",
  tv6UltraV2SoftwareEyebrow: "Software",
  tv6UltraV2SoftwareTitle: "Android 12, ready out of the box.",
  tv6UltraV2SoftwareBody:
    "Open Android 12 (AOSP) with an operator-ready launcher, flexible branding and TR-069 + Alcatraz™ DMS for the operations team behind every deployed device.",
  tv6UltraV2SoftwareCustomTitle1: "Operator launcher",
  tv6UltraV2SoftwareCustomBody1:
    "Shape the home screen around Live TV, VOD, catch-up, radio, apps, settings and your preferred subscriber flows.",
  tv6UltraV2SoftwareCustomTitle2: "Brand and market fit",
  tv6UltraV2SoftwareCustomBody2:
    "Adapt logos, colors, language, default sections and preloaded services for each operator or regional deployment.",
  tv6UltraV2SoftwareCustomTitle3: "Remote fleet control",
  tv6UltraV2SoftwareCustomBody3:
    "Use Alcatraz™ DMS and TR-069 to provision devices, push updates, manage settings and keep support work off the subscriber’s screen.",
  tv6UltraV2SpecsTitle: "Complete specifications",
  tv6UltraV2SpecsGroupHardware: "Hardware",
  tv6UltraV2SpecsGroupConnectivity: "Connectivity",
  tv6UltraV2SpecsGroupMedia: "Media",
  tv6UltraV2SpecsGroupSoftware: "Software",
  tv6UltraV2SpecsGroupPackage: "In the box",
  tv6UltraV2RemoteEyebrow: "Remote",
  tv6UltraV2RemoteTitle: "Bluetooth voice remote, built for living rooms.",
  tv6UltraV2RemoteBody:
    "Pair once over Bluetooth and forget line-of-sight. A built-in microphone enables voice search across the launcher and apps, while the programmable TV power button and customizable favorites key let each subscriber make it their own.",
  tv6UltraV2RemoteFeatureBt: "Bluetooth 5.0 — no IR aiming required",
  tv6UltraV2RemoteFeatureMic: "Built-in microphone for voice search",
  tv6UltraV2RemoteFeatureTvPower: "Programmable TV power button",
  tv6UltraV2RemoteFeatureFav: "Customizable favorites (FAV) button",
  tv6UltraV2RemoteNoteBody:
    "TV6 Ultra ships with the Bluetooth voice remote by default — but you can spec it with any remote in our lineup, Bluetooth or IR, to suit your market.",
  tv6UltraV2GlanceValue1: "4K @ 60 Hz",
  tv6UltraV2GlanceLabel1: "HDR · H.265",
  tv6UltraV2GlanceValue2: "Android 12",
  tv6UltraV2GlanceLabel2: "AOSP, app-ready",
  tv6UltraV2GlanceValue3: "4 GB / 32 GB",
  tv6UltraV2GlanceLabel3: "DDR3 + eMMC",
  tv6UltraV2GlanceValue4: "BT 5.0 Remote",
  tv6UltraV2GlanceLabel4: "Voice + FAV",
  remoteAppMenuLabel: "inext Remote app",
  remoteAppProductCallout: "Prefer your phone? Get the free inext Remote app",
  footerLinkRemoteApp: "Remote Control App",
  remoteAppSeoTitle: "inext Remote — Mobile Remote Control App for inext STBs",
  remoteAppSeoDescription:
    "Download the free inext Remote app for Android and iOS. Control inext STBs, switch rooms, search by voice or keyboard, enter text, use gamepad mode, and choose light or dark themes.",
  remoteAppBreadcrumbApps: "Apps",
  remoteAppHeroEyebrow: "Free app for your inext TV box",
  remoteAppHeroTitle: "Your TV remote, now on your phone.",
  remoteAppHeroBody:
    "inext Remote turns your phone into a full remote for your inext TV box — type fast, search by voice, hop between rooms, play games, swipe to navigate, and pick a light or dark look.",
  remoteAppAppleBadgeAlt: "Download inext Remote on the App Store",
  remoteAppGoogleBadgeAlt: "Get inext Remote on Google Play",
  remoteAppHeroImageAlt: "inext Remote mobile app control screen",
  remoteAppStatDownloadsValue: "500K+",
  remoteAppStatDownloadsLabel: "downloads",
  remoteAppStatModesValue: "D-pad + swipe",
  remoteAppStatModesLabel: "control modes",
  remoteAppStatThemesValue: "Light + dark",
  remoteAppStatThemesLabel: "themes",
  remoteAppFeaturesEyebrow: "Why you'll love it",
  remoteAppFeaturesTitle: "Everything you want from a modern remote.",
  remoteAppFeaturesBody:
    "Your everyday TV controls stay close, plus the things a plastic remote can't do: easy typing, quick search, multiple rooms and casual games.",
  remoteAppFeatureControlTitle: "A remote that just works",
  remoteAppFeatureControlBody:
    "Navigate, play, pause and adjust volume with all the TV controls you already know — right from your phone.",
  remoteAppFeatureRoomsTitle: "Switch devices and rooms",
  remoteAppFeatureRoomsBody:
    "Jump between your inext devices in seconds when you have more than one screen at home.",
  remoteAppFeatureVoiceTitle: "Voice and quick search",
  remoteAppFeatureVoiceBody:
    "Use voice search or the mobile keyboard to find content faster than with a physical remote.",
  remoteAppFeatureKeyboardTitle: "Easy text entry",
  remoteAppFeatureKeyboardBody:
    "Enter logins, search queries and app text on the phone keyboard instead of clicking letter by letter.",
  remoteAppFeatureGamepadTitle: "Gamepad mode",
  remoteAppFeatureGamepadBody:
    "Turn the phone into a simple game controller for games and interactive TV experiences.",
  remoteAppFeatureModesTitle: "D-pad or gestures",
  remoteAppFeatureModesBody:
    "Use classic directional buttons or switch to swipe and gesture control when that feels faster.",
  remoteAppModesEyebrow: "Control modes",
  remoteAppModesTitle: "A remote, keyboard and gamepad in one app.",
  remoteAppModesBody:
    "Stay in the familiar D-pad layout for TV, switch to gestures for faster browsing, open the keyboard to search, or rotate your phone into gamepad mode.",
  remoteAppModeDpad: "Classic D-pad",
  remoteAppModeSwipe: "Swipe and gesture mode",
  remoteAppGamepadImageAlt: "inext Remote gamepad mode screenshot",
  remoteAppVideoEyebrow: "See it in action",
  remoteAppVideoTitle: "Watch inext Remote in action.",
  remoteAppVideoBody:
    "A quick tour of everything the app can do — remote, keyboard, voice, rooms, gamepad and themes.",
  remoteAppVideoIframeTitle: "inext Remote app demo video",
  remoteAppScreensEyebrow: "Screenshots",
  remoteAppScreensTitle: "Made for the way you watch.",
  remoteAppScreensBody:
    "Browse the main remote, devices, dialpad, keyboard, gamepad and theme screens from the mobile app.",
  remoteAppScreenshotAlt: "inext Remote app screenshot",
  remoteAppThemesEyebrow: "Appearance",
  remoteAppThemesTitle: "Comfortable in light or dark rooms.",
  remoteAppThemesBody:
    "Light and dark themes both look great — perfect for daytime, late-night viewing, or matching your phone.",
  remoteAppLightTheme: "Light theme",
  remoteAppLightThemeBody: "Clean controls for daytime use and bright rooms.",
  remoteAppDarkTheme: "Dark theme",
  remoteAppDarkThemeBody: "Reduced glare for late-night viewing.",
  remoteAppCtaEyebrow: "Download free",
  remoteAppCtaTitle: "Get inext Remote for your phone.",
  remoteAppCtaBody:
    "Download the free app from Google Play or the App Store and pair it with your inext TV box in seconds.",
  navSolutions: "Solutions",
  navSolutionsAlcatraz: "Alcatraz DMS",
  navSolutionsAlcatrazDesc: "Proactive fleet health and remote operations",
  footerLinkAlcatrazDms: "Alcatraz DMS",
  operationsLearnMore: "Learn more about Alcatraz DMS",
  alcatrazBreadcrumbHome: "Home",
  alcatrazBreadcrumbSolutions: "Solutions",
  alcatrazBreadcrumbPage: "Alcatraz DMS",
  alcatrazSeoTitle: "inext Alcatraz DMS — Device Management for IPTV operators",
  alcatrazSeoDescription:
    "Cloud or on-prem device management for inext STBs, with Fleet Health, device activity history, remote diagnostics and controlled OTA updates.",
  alcatrazTrialSeoTitle: "Start a free 3-month Alcatraz Pro trial | inext",
  alcatrazTrialSeoDescription:
    "Request three months of Alcatraz Pro free — with the inext STBs already in your network or a demo device sample we ship to you.",
  alcatrazTrialBreadcrumb: "Free trial",
  alcatrazTrialEyebrow: "For ISPs and TV operators",
  alcatrazTrialTitle: "Try Alcatraz Pro free for three months",
  alcatrazTrialIntro:
    "See what Alcatraz Pro can do with inext set-top boxes — the ones already in your network, or a demo sample we ship to you. Our team will help you get started — no payment card or long-term commitment.",
  alcatrazTrialBenefitFree: "Full Alcatraz Pro access for three months",
  alcatrazTrialBenefitExisting: "Use your existing inext STBs — or get a demo sample from us",
  alcatrazTrialBenefitGuided: "Setup support from the inext team",
  alcatrazTrialStepsTitle: "How it works",
  alcatrazTrialStep1: "Send the request",
  alcatrazTrialStep2: "We confirm your company details",
  alcatrazTrialStep3: "We set up access and help you start",
  alcatrazTrialFeaturesLink: "Explore features and deployment options",
  alcatrazTrialDashboardAlt: "Alcatraz Pro fleet management dashboard",
  alcatrazTrialFormTitle: "Start your free 3-month trial",
  alcatrazTrialFormIntro:
    "Tell us where to reach you. We'll confirm your eligibility and help you get started.",
  alcatrazTrialDemoOption: "I'd like a demo before my trial",
  alcatrazTrialSampleOption: "I don't have inext STBs yet — I'd like a demo sample",
  alcatrazRequestNamePlaceholder: "Alex Morgan",
  alcatrazRequestCompanyPlaceholder: "Acme Telecom",
  alcatrazRequestEmailPlaceholder: "alex@acme.com",
  alcatrazRequestPhonePlaceholder: "+372 555 1234",
  alcatrazRequestNameError: "Enter your name.",
  alcatrazRequestCompanyError: "Enter your company name.",
  alcatrazRequestEmailError: "Enter a valid business email.",
  alcatrazRequestPhoneError: "Enter a phone number.",
  alcatrazTrialEligibility:
    "For business customers — ISPs and TV operators. No inext STBs yet? We'll prepare a demo sample for you. Trial access is subject to a quick account check.",
  alcatrazTrialNoCardNote: "No payment card. No long-term commitment.",
  alcatrazTrialSubmitting: "Sending...",
  alcatrazTrialSubmitTrial: "Request 3 months free",
  alcatrazTrialSubmitDemo: "Request a demo + 3 months free",
  alcatrazTrialSuccessTitle: "We received your trial request",
  alcatrazTrialSuccessBody:
    "Thanks. We'll confirm your company details and contact you to set up your free three-month Alcatraz Pro trial.",
  alcatrazTrialDemoSuccessBody:
    "Thanks. We'll confirm your company details and contact you to arrange a demo before setting up your free three-month trial.",
  alcatrazTrialSampleSuccessNote: "We'll also prepare and ship a demo STB sample to you.",
  alcatrazTrialSuccessTimeline: "We typically reply within one business day.",
  alcatrazStartSeoTitle: "Get Alcatraz Pro for fleets with fewer than 500 active devices | inext",
  alcatrazStartSeoDescription:
    "Alcatraz Pro is included at no extra cost for inext fleets with fewer than 500 active devices. Request access—and an evaluation unit if the fleet does not yet use inext STBs.",
  alcatrazStartBreadcrumb: "Get Alcatraz Pro",
  alcatrazStartEyebrow: "For ISPs and TV operators",
  alcatrazStartTitle: "Alcatraz Pro is included with your inext set-top boxes",
  alcatrazStartIntro:
    "Run the entire fleet from one console—monitoring, firmware, diagnostics and remote support. Alcatraz Pro is included at no extra cost while the fleet has fewer than 500 active inext devices.",
  alcatrazStartBenefit1: "Included at no extra cost for fleets with fewer than 500 active devices",
  alcatrazStartBenefit2: "The complete Alcatraz Pro console, not a cut-down version",
  alcatrazStartBenefit3: "Setup support from the inext team",
  alcatrazStartActiveTitle: "What counts as an active device",
  alcatrazStartActiveBody:
    "Access is based on the latest 30-day active-device snapshot. Devices still in production, in transit, in a warehouse or already retired do not count toward the 500-device threshold.",
  alcatrazStartStepsTitle: "How it works",
  alcatrazStartStep1: "Send the request",
  alcatrazStartStep2: "We confirm your company details",
  alcatrazStartStep3: "We set up your account and help you start",
  alcatrazStartFeaturesLink: "Explore features and deployment options",
  alcatrazStartDashboardAlt: "Alcatraz Pro fleet management dashboard",
  alcatrazStartFormTitle: "Get your Alcatraz Pro account",
  alcatrazStartFormIntro:
    "Tell us where to reach you. We'll confirm your company details and help you get started.",
  alcatrazStartDemoOption: "I'd like a demo before we start",
  alcatrazStartSampleOption: "I don't have inext STBs yet — I'd like a demo sample",
  alcatrazStartEligibility:
    "Alcatraz Pro is available to business customers—ISPs and TV operators—and included at no extra cost for fleets with fewer than 500 active devices. For fleets with 500 active devices or more, contact sales to discuss access and commercial terms.",
  alcatrazStartSubmitting: "Sending...",
  alcatrazStartSubmit: "Get Alcatraz Pro",
  alcatrazStartSubmitDemo: "Request a demo + Alcatraz Pro",
  alcatrazStartNoCardNote: "No payment card. No long-term commitment.",
  alcatrazStartSuccessTitle: "We received your request",
  alcatrazStartSuccessBody:
    "Thanks. We'll confirm your company details and contact you to set up your Alcatraz Pro account.",
  alcatrazStartDemoSuccessBody:
    "Thanks. We'll confirm your company details and contact you to arrange a demo before setting up your Alcatraz Pro account.",
  alcatrazStartSampleSuccessNote: "We'll also prepare and ship a demo STB sample to you.",
  alcatrazStartSuccessTimeline: "We typically reply within one business day.",
  alcatrazHeroEyebrow: "Device Management System",
  alcatrazHeroTitle: "inext Alcatraz DMS —",
  alcatrazHeroTitleAccent: "your fleet, always under control",
  alcatrazHeroSub:
    "Cloud SaaS or fully on-premises. Monitor fleet health, review device history, deliver updates and support every inext STB from one platform.",
  alcatrazCtaStart: "Get Alcatraz Pro",
  alcatrazHeroCtaDemo: "Request a demo",
  alcatrazHeroCtaSales: "Talk to sales",
  alcatrazHeroImageCaption: "Alcatraz DMS — fleet overview dashboard",
  alcatrazHeroStatNetworks: "120+ operator networks",
  alcatrazHeroStatDeploy: "Cloud or on-prem",
  alcatrazHeroStatScale: "Scales with your fleet",
  alcatrazDeploymentEyebrow: "Deployment",
  alcatrazDeploymentTitle: "Two ways to deploy",
  alcatrazDeploymentDescription:
    "Pick the model that fits your network policy. Same features, same console, same subscription.",
  alcatrazDeploymentCloudTag: "Recommended",
  alcatrazDeploymentCloudTitle: "Cloud (SaaS)",
  alcatrazDeploymentCloudBody:
    "Hosted and operated by inext. Fastest start, automatic updates, geo-distributed access for your support team.",
  alcatrazDeploymentCloudBullet1: "No infrastructure to maintain",
  alcatrazDeploymentCloudBullet2: "Automatic platform upgrades",
  alcatrazDeploymentCloudBullet3: "SLA-backed availability",
  alcatrazDeploymentOnpremTitle: "On-premises",
  alcatrazDeploymentOnpremBody:
    "Runs inside your closed ISP network. Full data sovereignty for operators with strict regulatory or security requirements.",
  alcatrazDeploymentOnpremBullet1: "Deployed in your data center",
  alcatrazDeploymentOnpremBullet2: "Your data never leaves your network",
  alcatrazDeploymentOnpremBullet3: "Works behind NAT / closed networks",
  alcatrazPillarsEyebrow: "What's inside",
  alcatrazPillarsTitle: "Everything you need to run a fleet of STBs",
  alcatrazPillar1Title: "Fleet Health",
  alcatrazPillar1Body:
    "Prioritize detected Wi-Fi and temperature issues, review device history and receive weekly fleet summaries.",
  alcatrazPillar2Title: "Staged firmware rollouts",
  alcatrazPillar2Body:
    "Stage firmware rollouts, track results, exclude individual devices and keep comments with each build or release.",
  alcatrazPillar3Title: "Remote support & diagnostics",
  alcatrazPillar3Body:
    "Reboot and remotely control devices, run MTR or iPerf3 diagnostics and resolve issues without a site visit.",
  alcatrazPillar4Title: "Device activity & audit",
  alcatrazPillar4Body:
    "Review commands, changes, private notes and OTA events, with user and API-key attribution for audit.",
  alcatrazPillar5Title: "Device protection",
  alcatrazPillar5Body:
    "Apply block profiles, app lock and net-lock to protect rented, lost or retired devices.",
  alcatrazPillar6Title: "Subscriber communication",
  alcatrazPillar6Body:
    "Send targeted launcher banners, notifications and campaigns with calls to action on the TV.",
  alcatrazPillar7Title: "API & industry standards",
  alcatrazPillar7Body:
    "Manage restricted API keys and connect through REST, MQTT or existing TR-069/CWMP workflows.",
  alcatrazPillar8Title: "Fleet organization",
  alcatrazPillar8Body:
    "Use external IDs and groups to search, filter, export and manage devices in bulk.",
  alcatrazFleetHealthEyebrow: "Fleet Health",
  alcatrazFleetHealthTitle: "Prioritize the devices that need attention",
  alcatrazFleetHealthBody:
    "Fleet Health analyzes device telemetry and organizes detected issues into a clear, actionable view for operations and support teams. The dashboard summarizes overall fleet health, while a filterable queue provides direct access to each affected device and its issue history.",
  alcatrazFleetHealthBullet1: "Detect weak Wi-Fi and high-temperature conditions",
  alcatrazFleetHealthBullet2: "Filter and prioritize the device issue queue",
  alcatrazFleetHealthBullet3: "Review issue details and history for each STB",
  alcatrazFleetHealthBullet4: "Receive weekly fleet summaries",
  alcatrazFleetHealthPlaceholder: "Fleet Health dashboard and prioritized issue queue",
  alcatrazFleetPreviewUpdated: "Updated just now",
  alcatrazFleetPreviewLive: "Live overview",
  alcatrazFleetPreviewNeedsAttention: "Needs attention",
  alcatrazFleetPreviewCallFirst: "Call first",
  alcatrazFleetPreviewKeepWatch: "Keep an eye on",
  alcatrazFleetPreviewHealthy: "Healthy",
  alcatrazFleetPreviewMonitored: "Monitored",
  alcatrazFleetPreviewIssueTypes: "Issue types",
  alcatrazFleetPreviewWeakWifi: "Weak Wi-Fi",
  alcatrazFleetPreviewTemperature: "Temperature",
  alcatrazFleetPreviewQueue: "Priority device queue",
  alcatrazFleetPreviewCriticalFirst: "Critical conditions first",
  alcatrazFleetPreviewShown: "Showing {count}",
  alcatrazFleetPreviewHighTemperature: "High temperature",
  alcatrazFleetPreviewWatch: "Monitor",
  alcatrazFleetPreviewAwaiting: "{count} issues awaiting confirmation",
  alcatrazPreviewMinutesAgo: "{minutes} min ago",
  alcatrazPreviewIllustrativeData: "Illustrative data",
  alcatrazFirmwareEyebrow: "Firmware management",
  alcatrazFirmwareTitle: "Phased rollouts with safety rails",
  alcatrazFirmwareBody:
    "Schedule firmware releases for a slice of the fleet, gate updates with client-side confirmation and watch release statistics in real time. Exclude any device from automatic updates with a single toggle, or push a manual update when you need to.",
  alcatrazFirmwareBullet1: "Staged / phased rollout",
  alcatrazFirmwareBullet2: "Exclude from auto-updates per device",
  alcatrazFirmwareBullet3: "Manual firmware release",
  alcatrazFirmwareBullet4: "Client confirmation + release stats",
  alcatrazFirmwarePlaceholder: "Firmware release dashboard",
  alcatrazFirmwareOtaLink: "Explore OTA Update Management",
  alcatrazInspectorEyebrow: "Device inspector",
  alcatrazInspectorTitle: "See current state and complete history side by side",
  alcatrazInspectorBody:
    "Open any STB to see its current condition, then follow the events that led there. The activity timeline covers commands, activation events, device changes, private notes, campaigns, notifications and OTA events.",
  alcatrazActivityBullet1: "Preset views, filters and a focused audit mode",
  alcatrazActivityBullet2: "The user or API key identified for every recorded action",
  alcatrazActivityBullet3: "Detailed OTA metrics and command history",
  alcatrazInspectorPreviewOnline: "Online",
  alcatrazInspectorPreviewCurrentState: "Current state",
  alcatrazInspectorPreviewActivity: "Activity",
  alcatrazInspectorPreviewCondition: "Device condition",
  alcatrazInspectorPreviewLastChecked: "Checked {minutes} min ago",
  alcatrazInspectorPreviewAllEvents: "All events",
  alcatrazInspectorPreviewCommands: "Commands",
  alcatrazInspectorPreviewNewest: "Newest first",
  alcatrazInspectorPreviewToday: "Today",
  alcatrazInspectorPreviewYesterday: "Yesterday",
  alcatrazInspectorPreviewThisWeek: "This week",
  alcatrazInspectorPreviewLastWeek: "Last week",
  alcatrazInspectorPreviewEarlier: "Earlier",
  alcatrazInspectorPreviewSupportNote: "Support note: intermittent buffering",
  alcatrazInspectorPreviewFirmwareChange: "Firmware 1.8.51 → 1.9.1",
  alcatrazInspectorPreviewOtaCompleted: "OTA download completed",
  alcatrazInspectorPreviewCommandBy: "Command · John Doe",
  alcatrazInspectorPreviewPrivateNoteBy: "Private note · John Doe",
  alcatrazInspectorPreviewDeviceChangeApi: "Device change · API key · rollout-bot",
  alcatrazInspectorPreviewOtaMetrics: "Version 1.9.0 · 45.78 MB/s · 1 min 18 sec",
  alcatrazInspectorPreviewWaiting: "Waiting for response",
  alcatrazInspectorPreviewCompleted: "Completed",
  alcatrazInspectorPreviewFooter: "Commands, changes, notes and OTA events",
  alcatrazInspectorPreviewIllustrative: "Sample history",
  alcatrazInspectorPreviewAlt:
    "Illustrative Alcatraz device inspector showing current state and activity history.",
  alcatrazInspectorCardTitle: "Device view",
  alcatrazInspectorLabelState: "State",
  alcatrazInspectorValueState: "Online · 4d 1h 19m",
  alcatrazInspectorLabelLastSeen: "Last seen",
  alcatrazInspectorValueLastSeen: "12 min ago",
  alcatrazInspectorLabelFirmware: "Firmware",
  alcatrazInspectorValueFirmware: "v1.8.14",
  alcatrazInspectorLabelTemps: "Temperatures",
  alcatrazInspectorValueTemps: "CPU 51.2° · GPU 52.5° · RAM 50.8° · VEE 53.4°",
  alcatrazInspectorLabelRam: "RAM",
  alcatrazInspectorValueRam: "383 MB free of 4 GB",
  alcatrazInspectorLabelFlash: "Flash",
  alcatrazInspectorValueFlash: "18.8 GB free of 32 GB",
  alcatrazInspectorLabelTv: "TV connection",
  alcatrazInspectorValueTv: "HDMI · 1920×1080 · 60 fps",
  alcatrazInspectorLabelNetwork: "Network",
  alcatrazInspectorValueNetwork: "Wi-Fi 5 GHz · RSSI −29 dBm (Excellent)",
  alcatrazInspectorLabelAndroid: "Android",
  alcatrazInspectorValueAndroid: "12",
  alcatrazInspectorLabelLocale: "Locale",
  alcatrazInspectorValueLocale: "English · Europe/Kyiv",
  alcatrazInspectorLabelApps: "Installed apps",
  alcatrazInspectorValueApps: "App list with versions",
  alcatrazRemoteEyebrow: "Remote control",
  alcatrazRemoteTitle: "A console of operator commands",
  alcatrazRemoteBody:
    "Run any of the actions you'd normally need a field engineer for — from a reboot to a full factory reset — without ever touching the box.",
  alcatrazRemoteGroupControl: "Control",
  alcatrazRemoteGroupDiagnostics: "Diagnostics",
  alcatrazRemoteGroupComms: "Communication",
  alcatrazRemoteGroupLifecycle: "Lifecycle",
  alcatrazRemoteGroupLockdown: "Lockdown",
  alcatrazRemoteCmdReboot: "Reboot",
  alcatrazRemoteCmdRemote: "Virtual remote control",
  alcatrazRemoteCmdScreenshot: "Screenshot",
  alcatrazRemoteCmdSpeed: "Speed test (iPerf3)",
  mtrAlcatrazRemoteCmd: "MTR route trace",
  alcatrazRemoteCmdPush: "Push notification",
  alcatrazRemoteCmdFirmware: "Firmware release",
  alcatrazRemoteCmdExclude: "Exclude from auto updates",
  alcatrazRemoteCmdBlock: "Block device",
  alcatrazRemoteCmdFactory: "Factory reset",
  alcatrazRemoteWarning: "Destructive",
  alcatrazRemoteHighlight1: "Resolve common issues from the NOC — no field engineer dispatch.",
  alcatrazRemoteHighlight2: "Trigger on a single device or push to a whole group in one click.",
  alcatrazRemoteHighlight3:
    "Every action is logged with the device, timestamp, and operator or API key that initiated it.",
  mtrAlcatrazEyebrow: "MTR diagnostics",
  mtrAlcatrazTitle: "Trace the route from the subscriber's STB",
  mtrAlcatrazBody:
    "Operators can run MTR (My Traceroute) from an online set-top box to any destination. Completed MTR and iPerf3 results remain available in the device activity timeline, and the tests can be run again with their original parameters.",
  alcatrazAccessEyebrow: "Device protection",
  alcatrazAccessTitle: "Protect STBs with block and net-lock policies",
  alcatrazAccessBody:
    "Alcatraz DMS helps operators protect rental STBs, lost hardware, unpaid accounts and retired devices. Block any STB or group manually, or use net-lock to restrict rented boxes outside approved ISP networks.",
  alcatrazAccessFlowTitle: "How locking starts",
  alcatrazAccessManualTitle: "Manual block",
  alcatrazAccessManualBody:
    "Block one STB or an entire group on demand. Use it for lost or stolen hardware, retired devices or accounts with overdue payments.",
  alcatrazAccessNetLockTitle: "Automatic net-lock",
  alcatrazAccessNetLockBody:
    "Automatically block rented STBs outside approved ISP networks. This prevents devices from being used through unauthorized connections.",
  alcatrazAccessFlowOutcome: "Choose a lock profile",
  alcatrazAccessMockFooter: "Managed by Alcatraz DMS",
  alcatrazAccessMockNotice: "Notice period",
  alcatrazAccessProfileHardTitle: "Hard",
  alcatrazAccessProfileHardBody: "Powers off the STB and repeats the block after restart.",
  alcatrazAccessModeHardBadge: "Hard lock",
  alcatrazAccessModeHardTitle: "This device is locked",
  alcatrazAccessModeHardBody:
    "The STB shows the operator's message, then powers off. The block repeats after restart.",
  alcatrazAccessModeHardStatus: "Powers off after notice",
  alcatrazAccessProfileSoftTitle: "Soft",
  alcatrazAccessProfileSoftBody: "Keeps the STB usable and shows reminders every 30 minutes.",
  alcatrazAccessModeSoftBadge: "Soft lock",
  alcatrazAccessModeSoftTitle: "Service notice active",
  alcatrazAccessModeSoftBody:
    "The STB stays usable while the operator's reminder appears on schedule.",
  alcatrazAccessModeSoftStatus: "Reminder every 30 minutes",
  alcatrazAccessProfileAppLockTitle: "App Lock",
  alcatrazAccessProfileAppLockBody: "Limits the STB to one selected application.",
  alcatrazAccessModeAppLockBadge: "App lock",
  alcatrazAccessModeAppLockTitle: "Only the approved app is available",
  alcatrazAccessModeAppLockBody:
    "The STB can open only the selected application until the operator changes the profile.",
  alcatrazAccessModeAppLockStatus: "Single app only",
  alcatrazAccessModeAppAllowedApp: "IPTV",
  alcatrazAccessModeAppLockedLabel: "Locked",
  alcatrazPushEyebrow: "Push notifications",
  alcatrazPushTitle: "Talk to subscribers, on their TV",
  alcatrazPushBody:
    "Send launcher banners and toast messages to any segment of your fleet — for service messages, content highlights or upgrade campaigns. Each message can carry a CTA that opens an app or page.",
  alcatrazPushBullet1: "Launcher and toast styles",
  alcatrazPushBullet2: "Target by device group, model or region",
  alcatrazPushBullet3: "CTAs that deep-link into an app",
  alcatrazPushBullet4: "Views, clicks and CTR for every message",
  alcatrazPushPlaceholder: "Push notification composer",
  alcatrazApiEyebrow: "Secure integrations · REST API",
  alcatrazApiTitle: "Connect Alcatraz to your existing systems",
  alcatrazApiBody:
    "Create and revoke API keys from the console, optionally restrict permissions and source IP addresses, set expiration dates, and securely copy each secret when it is first generated. External IDs connect Alcatraz device records to subscriber, CRM, billing or household references without changing established workflows.",
  alcatrazApiBullet1: "Self-service API keys with configurable access restrictions",
  alcatrazApiBullet2: "External device IDs for search, filters and exports",
  alcatrazApiBullet3: "TR-069 / CWMP and MQTT alongside the REST API",
  alcatrazApiPlaceholder: "API documentation",
  alcatrazPricingEyebrow: "Pricing",
  alcatrazPricingTitle: "Included at no extra cost for fleets with fewer than 500 active devices",
  alcatrazPricingBody:
    "Partners receive access to the complete Alcatraz Pro console at no extra cost while the fleet has fewer than 500 active inext devices. For fleets with 500 active devices or more, access and commercial terms are agreed directly with inext.",
  alcatrazPricingIncludedTitle: "No extra cost · Fewer than 500 active devices",
  alcatrazPricingIncludedBody:
    "Fleet Health, firmware management, diagnostics, remote support and secure integrations are included when the latest 30-day snapshot shows fewer than 500 active devices.",
  alcatrazPricingModelTitle: "500 active devices or more",
  alcatrazPricingModelBody:
    "Contact inext sales to discuss access and commercial terms for the deployment.",
  alcatrazPricingActiveTitle: "What counts as an active device",
  alcatrazPricingActiveBody:
    "Access is based on the latest 30-day active-device snapshot. Devices in these states do not count toward the threshold:",
  alcatrazPricingStateProduction: "In production",
  alcatrazPricingStateTransit: "In transit",
  alcatrazPricingStateWarehouse: "In warehouse",
  alcatrazPricingStateRetired: "Retired",
  alcatrazPricingCta: "Request a quote",
  alcatrazFaqEyebrow: "FAQ",
  alcatrazFaqTitle: "Common questions",
  alcatrazFaqQ1: "Can I deploy Alcatraz inside my own network?",
  alcatrazFaqA1:
    "Yes. Alcatraz DMS runs as a managed SaaS or as an on-premises install inside your closed ISP network. Same features, same console — your choice on where the data lives.",
  alcatrazFaqQ2: "Which devices does it support?",
  alcatrazFaqA2:
    "Every current inext STB ships with Alcatraz DMS support — TV5, TV5 Ultra, TV6 and TV6 Ultra. New models are added as they launch.",
  alcatrazFaqQ3: "How does Alcatraz relate to TR-069?",
  alcatrazFaqA3:
    "TR-069 / CWMP is supported alongside Alcatraz, so operators who already run an ACS can keep using it. Alcatraz adds richer telemetry, push notifications, in-app remote control and a modern REST API on top.",
  alcatrazFaqQ4: "Can we integrate it with our BSS / OSS?",
  alcatrazFaqA4:
    "Yes. Alcatraz exposes a documented REST API and supports MQTT messaging. Administrators can create and revoke API keys, scope permissions, limit source IP addresses and set expiration dates. External IDs connect devices to existing CRM or billing references.",
  alcatrazFaqQ5: "How is it priced?",
  alcatrazFaqA5:
    "Alcatraz Pro is included at no extra cost while the fleet has fewer than 500 active inext devices. For fleets with 500 active devices or more, access and commercial terms are agreed directly with the inext sales team.",
  alcatrazFaqQ6: "What counts as an active device?",
  alcatrazFaqA6:
    "Company Settings shows the latest 30-day active-device snapshot used to determine access. Devices still in production, in transit, in a warehouse or already retired do not count toward the threshold.",
  alcatrazFaqQ7: "How long does onboarding take?",
  alcatrazFaqA7:
    "Cloud deployments can be live in days. On-prem installs take longer and depend on your infrastructure team — typically a few weeks from kick-off to go-live.",
  alcatrazFinalEyebrow: "Take control",
  alcatrazFinalTitle: "Ready to put your STB fleet on one platform?",
  alcatrazFinalBody:
    "Tell us about your network and we'll set up a tailored Alcatraz DMS walkthrough.",
  alcatrazFinalCtaSecondary: "Talk to sales",
  navSolutionsCustomization: "Customization & Branding",
  navSolutionsCustomizationDesc: "White-label hardware and software",
  navSolutionsRemoteAppDesc: "Mobile remote control for inext STBs",
  customPageSeoTitle: "Customization, White-Labeling & Co-Branding — inext",
  customPageSeoDescription:
    "Make inext set-top boxes unmistakably yours — from a simple app preinstall to fully custom hardware design and bespoke firmware. White-labeling and co-branding for IPTV and OTT operators.",
  customPageBreadcrumbHome: "Home",
  customPageBreadcrumbSolutions: "Solutions",
  customPageBreadcrumbPage: "Customization & Branding",
  customPageHeroEyebrow: "Customization · White-label · Co-brand",
  customPageHeroTitle: "Your brand,",
  customPageHeroTitleAccent: "down to the silicon",
  customPageHeroSub:
    "From a simple app preinstall to a fully custom box running bespoke firmware — we white-label and co-brand every layer of the inext platform, so your subscribers only ever see you.",
  customPageHeroCtaPrimary: "Talk to sales",
  customPageHeroCtaSecondary: "See examples",
  customPageHeroStat1: "Software + hardware",
  customPageHeroStat2: "Branding of any level",
  customPageHeroStat3: "Your brand, not ours",
  customPageHeroImageAlt: "inext engineers customizing a set-top box, with PCB design on screen",
  customPageSurfacesEyebrow: "Two surfaces, one identity",
  customPageSurfacesTitle: "Software and hardware, both yours",
  customPageSurfacesDescription:
    "Brand the things subscribers tap every day and the box that sits under their TV. Take one, take both.",
  customPageSoftwareTag: "Software",
  customPageSoftwareTitle: "Software customization",
  customPageSoftwareBody:
    "Launcher, IPTV/OTT app, remote app and system UI — re-themed, re-branded and preloaded with your services.",
  customPageSoftwareBullet1: "Branded launcher, boot animation & wallpapers",
  customPageSoftwareBullet2: "Custom IPTV/OTT client and EPG",
  customPageSoftwareBullet3: "Preinstalled apps & a locked-down catalogue",
  customPageHardwareTag: "Hardware",
  customPageHardwareTitle: "Hardware customization",
  customPageHardwareBody:
    "From a branded sticker and retail box to a fully custom enclosure, remote and PCB built around your spec.",
  customPageHardwareBullet1: "Branded packaging, manuals & accessories",
  customPageHardwareBullet2: "Custom enclosure colour, logo & remote layout",
  customPageHardwareBullet3: "Bespoke PCB, ports & chipset for volume orders",
  customPageTiersEyebrow: "Branding of any level",
  customPageTiersTitle: "Start light. Go all the way.",
  customPageTiersDescription:
    "Pick the depth that fits your brand and budget — every step builds on the one before it.",
  customPageTiersLevelLabel: "Level",
  customPageTier1Name: "Preinstall & boot animation",
  customPageTier1Body:
    "Your apps preinstalled on stock inext boxes, plus a branded boot animation. The fastest route to market — no separate manufacturing run.",
  customPageTier1Tag: "Days",
  customPageTier2Name: "Branded experience",
  customPageTier2Body:
    "Your launcher, boot animation, wallpapers, preinstalled apps and predefined settings. Subscribers see your brand the moment they power on.",
  customPageTier2Tag: "Weeks",
  customPageTier3Name: "Full white-label",
  customPageTier3Body:
    "Your name on the hardware, firmware and every app. No inext branding anywhere — the platform disappears behind yours.",
  customPageTier3Tag: "Months",
  customPageTier4Name: "Custom hardware & firmware",
  customPageTier4Body:
    "A box designed around your spec — custom enclosure, remote, ports and a firmware build maintained for your fleet.",
  customPageTier4Tag: "Project",
  customPageTiersFootnote: "Not sure where to start? We'll help you scope the right level.",
  customPagePillarsEyebrow: "What you can customize",
  customPagePillarsTitle: "Every layer is on the table",
  customPagePillar1Title: "Packaging & box",
  customPagePillar1Body: "Retail boxes, sleeves, manuals and accessory kits in your brand.",
  customPagePillar2Title: "Boot & splash",
  customPagePillar2Body: "Branded boot animation, splash screens and shutdown sequence.",
  customPagePillar3Title: "Launcher & home UI",
  customPagePillar3Body: "Custom home screen, content rows, wallpapers and app icons.",
  customPagePillar4Title: "IPTV / OTT app",
  customPagePillar4Body: "Branded player with your EPG, catch-up, time-shift and VOD.",
  customPagePillar5Title: "Preinstalled apps",
  customPagePillar5Body: "Your apps preinstalled on the box, with a locked-down app selection.",
  customPagePillar6Title: "Remote app",
  customPagePillar6Body: "A branded mobile remote with voice, keyboard and gestures.",
  customPagePillar7Title: "Firmware & AOSP",
  customPagePillar7Body: "Custom AOSP build, system settings, OTA channel and security policy.",
  customPagePillar8Title: "Hardware design",
  customPagePillar8Body: "Enclosure, remote layout, ports, chipset and PCB for your volume.",
  customPageSoftwareDeepEyebrow: "Software in your colours",
  customPageSoftwareDeepTitle: "A home screen subscribers recognise as yours",
  customPageSoftwareDeepBody:
    "We re-theme the launcher, player and system UI around your palette, logo and typography — then preload the apps and services your subscribers expect. The result feels purpose-built, not generic Android TV.",
  customPageSoftwareDeepBullet1: "Palette, logo, icons and typography",
  customPageSoftwareDeepBullet2: "Custom launcher rows and featured content",
  customPageSoftwareDeepBullet3: "Branded IPTV/OTT player and EPG",
  customPageSoftwareDeepBullet4: "Preloaded apps and predefined settings",
  customPageSoftwareDeepPlaceholder: "Branded launcher & app mockups",
  customPageHardwareDeepEyebrow: "Hardware with your name on it",
  customPageHardwareDeepTitle: "From a branded sticker to a brand-new board",
  customPageHardwareDeepBody:
    "Choose how far to take it. Add your logo and packaging to a proven inext box, restyle the enclosure and remote, or co-design a completely new device — chipset, ports and PCB included — for high-volume deployments.",
  customPageHardwareDeepBullet1: "Custom enclosure colour, finish & logo",
  customPageHardwareDeepBullet2: "Bespoke remote layout & branding",
  customPageHardwareDeepBullet3: "Retail packaging & accessory kits",
  customPageHardwareDeepBullet4: "Custom PCB, ports & chipset (volume)",
  customPageHardwareDeepPlaceholder: "Custom hardware & packaging renders",
  customPageExamplesEyebrow: "Examples",
  customPageExamplesTitle: "Brands that made it their own",
  customPageExamplesDescription:
    "A selection of operators shipping inext hardware under their own brand — from global OTT platforms to regional ISPs across Europe and Central Asia.",
  customPageExample1Name: "MEGOGO",
  customPageExample1Tag: "Ukraine",
  customPageExample1Meta: "Since 2012",
  customPageExample1Body:
    "International OTT service for TV, films and sport, with 55M+ monthly users.",
  customPageExample2Name: "Kyivstar TV",
  customPageExample2Tag: "Ukraine",
  customPageExample2Meta: "Since 2018",
  customPageExample2Body:
    "One of Ukraine's largest telecom operators, serving around 24 million customers.",
  customPageExample3Name: "SWEET.TV",
  customPageExample3Tag: "Europe",
  customPageExample3Meta: "Since 2012",
  customPageExample3Body:
    "Streaming TV and VOD platform operating across Central and Eastern Europe.",
  customPageExample4Name: "ALMA TV",
  customPageExample4Tag: "Kazakhstan",
  customPageExample4Meta: "Since 2019",
  customPageExample4Body: "Kazakhstan's full-service subscription TV and internet provider.",
  customPageExample5Name: "Beeline",
  customPageExample5Tag: "Kazakhstan",
  customPageExample5Meta: "Since 2022",
  customPageExample5Body:
    "Digital operator with 11M mobile and 2M home-internet subscribers, part of VEON.",
  customPageExample6Name: "K@TV1",
  customPageExample6Tag: "Azerbaijan",
  customPageExample6Meta: "Since 2023",
  customPageExample6Body: "One of Azerbaijan's largest providers of digital television services.",
  customPageExample7Name: "Sarkor",
  customPageExample7Tag: "Uzbekistan",
  customPageExample7Meta: "Since 2023",
  customPageExample7Body: "A flagship Uzbek IT and telecom provider with 25+ years of service.",
  customPageExample8Name: "Metroport",
  customPageExample8Tag: "Poland",
  customPageExample8Meta: "Since 2024",
  customPageExample8Body: "A consortium of 30+ Polish ISPs serving around 150,000 subscribers.",
  customPageProcessEyebrow: "How it works",
  customPageProcessTitle: "From brief to boxes on shelves",
  customPageProcessStep1Title: "Discovery",
  customPageProcessStep1Body:
    "We scope your brand, volumes, target devices and the customization level that fits.",
  customPageProcessStep2Title: "Design",
  customPageProcessStep2Body:
    "Brand assets, UI design and hardware spec — mocked up and signed off.",
  customPageProcessStep3Title: "Build",
  customPageProcessStep3Body: "We implement firmware, apps and hardware, then hand you test units.",
  customPageProcessStep4Title: "Certify",
  customPageProcessStep4Body:
    "Compliance, store and security certifications as your market requires.",
  customPageProcessStep5Title: "Deliver",
  customPageProcessStep5Body:
    "Mass production, provisioning and ongoing OTA support through Alcatraz DMS.",
  customPageFaqEyebrow: "FAQ",
  customPageFaqTitle: "Common questions",
  customPageFaqQ1: "What's the difference between co-branding and white-labeling?",
  customPageFaqA1:
    "Co-branding pairs your brand with inext on shared hardware and UI. White-labeling removes inext entirely — your name on the box, the firmware and every app.",
  customPageFaqQ2: "What's the minimum order for custom hardware?",
  customPageFaqA2:
    "App preinstall and co-branding have low or no minimums. Custom enclosures, remotes and PCBs are volume-based — we'll confirm MOQs during discovery.",
  customPageFaqQ3: "Can you build completely custom firmware?",
  customPageFaqA3:
    "Yes. We maintain custom AOSP builds with your system settings, security policy and a dedicated OTA channel, supported long-term.",
  customPageFaqQ4: "Do you design new hardware from scratch?",
  customPageFaqA4:
    "For the right volumes, yes — custom enclosure, remote, ports, chipset and PCB, co-designed with our hardware team.",
  customPageFaqQ5: "How are updates handled after launch?",
  customPageFaqA5:
    "Branded devices are managed through Alcatraz DMS — telemetry, staged OTA firmware, remote control and push notifications.",
  customPageFaqQ6: "How long does it take?",
  customPageFaqA6:
    "Preinstall and co-branding can ship in days; a branded UI in weeks; custom hardware is a project timeline we scope together.",
  customPageFinalEyebrow: "Make it yours",
  customPageFinalTitle: "Ready to put your brand on it?",
  customPageFinalBody:
    "Tell us your brand, your volumes and how far you want to take it — we'll map out the right customization path.",
  customPageFinalCta: "Talk to sales",
  customPageFinalCtaSecondary: "Request a demo",
  navAccessories: "Accessories",
  accessoriesSeoTitle: "inext Accessories — Remotes, Cables & Power Adapters",
  accessoriesSeoDescription:
    "Explore optional accessories for inext Android TV boxes. Official programmable remote controls, analog AV cables, power supplies, and external IR receivers.",
  accessoriesTitle: "Remotes, cables & power",
  accessoriesSubtitle: "Official accessories and replacement parts for inext set-top boxes.",
  accessoriesHeroEyebrow: "Optional Accessories",
  accessoriesFilterAll: "All Accessories",
  accessoriesFilterRemotes: "Remotes",
  accessoriesFilterCables: "Cables & Adapters",
  accessoriesFilterPower: "Power Supplies",
  accessoriesFilterSensors: "IR Sensors",
  accessoriesSpecsTab: "Specifications",
  accessoriesFeaturesTab: "Features",
  accessoriesProgrammingTab: "Programming Instructions",
  accessoriesBackToList: "Back to Accessories",
  accessoriesVideoGuide: "Video Guide",
  accessoriesAppBullet1: "Available for Android and iOS — free",
  accessoriesAppBullet2: "Works over Wi-Fi — no line of sight needed",
  accessoriesAppBullet3: "Voice search and on-screen keyboard",
  accessoriesAppCta: "Learn more about the app",
  footerLinkAccessories: "Accessories",
  productMenuAccessoriesDesc: "Remotes, cables and power supplies",
  footerLinkArchive: "Legacy models",
  archiveSeoTitle: "inext Legacy Set-Top Boxes — Discontinued Models Archive",
  archiveSeoDescription:
    "An archive of discontinued inext Android and Linux set-top boxes, from the 2011 HD1 to the 4K Allwinner and Amlogic boxes. Photos and full specifications for every legacy model.",
  archiveTitle: "Legacy models",
  archiveHeroEyebrow: "Product archive",
  archiveSubtitle:
    "Every inext set-top box we've shipped since 2011. These models are discontinued — kept here with photos and full specifications for reference.",
  archiveViewSpecs: "View specs",
  archiveBadge: "Discontinued",
  archiveSpecsHeading: "Specifications",
  iptvAppSeoTitle: "IPTV App for Operators — Branded TV Client for inext STBs",
  iptvAppSeoDescription:
    "Prebuilt IPTV app for inext STBs: M3U + XMLTV, Stalker/Ministra, TVIP and other portals. White-label branding and preconfigured settings — launch faster.",
  iptvAppBreadcrumbHome: "Home",
  iptvAppBreadcrumbSolutions: "Solutions",
  iptvAppBreadcrumbPage: "IPTV Application",
  iptvAppHeroEyebrow: "Client software · inext STBs",
  iptvAppHeroTitle: "Skip building a TV app —",
  iptvAppHeroTitleAccent: "ship ours, branded as yours",
  iptvAppHeroSub:
    "A prebuilt IPTV client for inext set-top boxes. We apply your branding, preconfigure it for your middleware or playlists and ship it preinstalled — so subscribers watch TV straight out of the box.",
  iptvAppHeroStat1: "3+ portal families",
  iptvAppHeroStat2: "100% white-label",
  iptvAppHeroStat3: "Zero-touch subscriber setup",
  iptvAppHeroCtaDemo: "Request a demo",
  iptvAppHeroCtaSales: "Talk to sales",
  iptvAppModesEyebrow: "Backend modes",
  iptvAppModesTitle: "Works with the backend you already run",
  iptvAppModesDescription:
    "No migration, no new middleware. One app adapts to your existing headend — pick the mode that matches your stack.",
  iptvAppMode1Title: "M3U playlists + XMLTV EPG",
  iptvAppMode1Body:
    "The simplest way to put your channels on screen. Point the app at a playlist and an EPG feed — subscribers get a fast native interface with full programme data.",
  iptvAppMode1Bullet1: "M3U playlists with categories and channel logos",
  iptvAppMode1Bullet2: "Day-by-day XMLTV EPG with now/next on every channel",
  iptvAppMode1Bullet3: "Multi-audio track selection during playback",
  iptvAppMode1Bullet4: "Built-in UDP-to-HTTP proxy for multicast networks",
  iptvAppMode2Title: "Stalker / Ministra middleware",
  iptvAppMode2Body:
    "The app renders your actual Stalker or Ministra portal — TV, VideoClub, recordings and favourites — with a configurable STB profile and a native player overlay on top.",
  iptvAppMode2Bullet1: "Full portal rendering with a configurable STB type (e.g. MAG)",
  iptvAppMode2Bullet2: "Live TV, VideoClub / VOD, favourites and recordings",
  iptvAppMode2Bullet3: "Native player overlay: audio tracks, subtitles, zoom, virtual keyboard",
  iptvAppMode2Bullet4: "Portal URL and playback settings preconfigured for your service",
  iptvAppMode3Title: "TVIP, Hibox, Aura & other web portals",
  iptvAppMode3Body:
    "Your operator-branded portal becomes the whole TV experience — launcher, programme guide, catch-up and recordings included. Other web middlewares can be added on request.",
  iptvAppMode3Bullet1: "Operator-branded launchers rendered as designed",
  iptvAppMode3Bullet2: "Full programme-guide grid with detailed EPG",
  iptvAppMode3Bullet3: "Catch-up TV and recordings",
  iptvAppMode3Bullet4: "The same simulator approach extends to other web portals",
  iptvAppWhiteLabelEyebrow: "White-label & prepackaging",
  iptvAppWhiteLabelTitle: "Your brand on screen, your settings baked in",
  iptvAppWhiteLabelBody:
    "We restyle the app with your logo, colours and app name, then preload your portal URL, playlist and EPG source. Boxes arrive subscriber-ready — plug in and watch.",
  iptvAppWhiteLabelBullet1: "Your logo, colours and app name",
  iptvAppWhiteLabelBullet2: "Preloaded portal URL, playlist and EPG source",
  iptvAppWhiteLabelBullet3: "Locked-down or open settings — you decide what subscribers can change",
  iptvAppWhiteLabelBullet4: "Ships preinstalled on inext STBs",
  iptvAppPillarsEyebrow: "Features",
  iptvAppPillarsTitle: "Everything subscribers expect from day one",
  iptvAppPillar1Title: "Full EPG",
  iptvAppPillar1Body:
    "Day-by-day programme guide from XMLTV or your middleware, with now/next on every channel.",
  iptvAppPillar2Title: "Categories & logos",
  iptvAppPillar2Body:
    "Tidy channel lists with genre categories and channel logos for fast zapping.",
  iptvAppPillar3Title: "Multi-audio & subtitles",
  iptvAppPillar3Body: "Audio track and subtitle selection right in the player overlay.",
  iptvAppPillar4Title: "Multicast friendly",
  iptvAppPillar4Body: "Built-in UDP-to-HTTP proxy plays multicast streams without extra hardware.",
  iptvAppPillar5Title: "Remote-first UX",
  iptvAppPillar5Body:
    "Numeric zapping, colour keys and a virtual keyboard — designed for the remote in hand.",
  iptvAppPillar6Title: "Multilingual UI",
  iptvAppPillar6Body: "Interface localised for your market, switchable per device.",
  iptvAppProcessEyebrow: "How it works",
  iptvAppProcessTitle: "Three steps to subscriber-ready boxes",
  iptvAppProcessStep1Title: "Tell us your backend & branding",
  iptvAppProcessStep1Body: "Middleware or playlist details, logo, colours — one short brief.",
  iptvAppProcessStep2Title: "We brand, preconfigure & test",
  iptvAppProcessStep2Body:
    "Your build is styled, loaded with your settings and verified on inext STBs.",
  iptvAppProcessStep3Title: "Boxes arrive subscriber-ready",
  iptvAppProcessStep3Body: "Subscribers plug in and watch — updates are managed centrally.",
  iptvAppEcosystemEyebrow: "Ecosystem",
  iptvAppEcosystemTitle: "Part of the inext operator stack",
  iptvAppEcosystemBody:
    "Pair the app with inext set-top boxes and Alcatraz DMS — hardware, client software and fleet management from one vendor.",
  iptvAppEcosystemLinkStb: "Explore inext STBs",
  iptvAppEcosystemLinkAlcatraz: "Discover Alcatraz DMS",
  iptvAppFaqEyebrow: "FAQ",
  iptvAppFaqTitle: "Common questions",
  iptvAppFaqQ1: "Which middlewares are supported?",
  iptvAppFaqA1:
    "Stalker / Ministra, TVIP, Hibox and Aura out of the box, plus plain M3U playlists with XMLTV EPG. Other web-based portals can usually be added — ask us about yours.",
  iptvAppFaqQ2: "Can you apply our branding and lock the settings?",
  iptvAppFaqA2:
    "Yes. We ship the app with your logo, colours and name, preconfigure portal and playback settings, and can lock them so subscribers can't break the setup — or leave them open.",
  iptvAppFaqQ3: "Does it work without middleware (plain M3U)?",
  iptvAppFaqA3:
    "Yes. In M3U mode the app only needs a playlist URL and an optional XMLTV feed — you still get categories, logos, a full EPG and multi-audio.",
  iptvAppFaqQ4: "How fast can we launch?",
  iptvAppFaqA4:
    "Weeks, not months. Branding and preconfiguration take days; most of the timeline is testing on your network and shipping the boxes.",
  iptvAppFinalEyebrow: "Launch faster",
  iptvAppFinalTitle: "Your TV app is already built —",
  iptvAppFinalTitleAccent: "let's make it yours",
  iptvAppFinalBody:
    "Tell us about your backend and branding and we'll prepare a preconfigured demo build for your service.",
  iptvAppFinalCta: "Request a demo",
  iptvAppFinalCtaSecondary: "Talk to sales",
  iptvAppAltNativePlayer: "inext IPTV app playing live sports with player overlay and now/next EPG",
  iptvAppAltNativeEpg: "Channel list with full-day EPG timeline in the native IPTV interface",
  iptvAppAltNativeCategories: "Category sidebar with channel logos and now/next programme info",
  iptvAppAltNativeSetup: "Setup screen offering an M3U channel list or a Stalker portal",
  iptvAppAltNativeAudio: "Audio track selection menu over live video",
  iptvAppAltStalkerHome: "Stalker / Ministra portal home screen with TV and VideoClub sections",
  iptvAppAltStalkerChannels: "Stalker portal channel list with live preview and EPG",
  iptvAppAltStalkerSettings: "Settings screen with portal URL and MAG STB type selection",
  iptvAppAltStalkerPlayerMenu:
    "Player toolbar with portal, audio, subtitles, zoom and keyboard controls",
  iptvAppAltTvipHome: "Operator-branded TVIP-style launcher home screen",
  iptvAppAltTvipChannels: "Multi-column channel list with programme details in a TVIP-style portal",
  iptvAppAltTvipEpg: "Full programme guide grid with programme details",
  navSolutionsIptvApp: "IPTV Application",
  navSolutionsIptvAppDesc: "Branded TV client for inext STBs",
  footerLinkIptvApp: "IPTV Application",
  navSolutionsOta: "OTA Update Management",
  navSolutionsOtaDesc: "Staged firmware and app rollouts",
  footerLinkOta: "OTA Update Management",
  otaBreadcrumbHome: "Home",
  otaBreadcrumbSolutions: "Solutions",
  otaBreadcrumbPage: "OTA Update Management",
  otaSeoTitle: "inext OTA Update Management — staged updates for inext STB fleets",
  otaSeoDescription:
    "Test, approve, stage, deliver and monitor firmware across inext STB fleets, with support for application updates. More than 1 million OTA updates delivered through the inext platform.",
  otaHeroEyebrow: "OTA Update Management",
  otaHeroTitle: "The right firmware for the right device —",
  otaHeroTitleAccent: "safely and at scale",
  otaHeroSub:
    "Test, approve, stage, deliver and monitor inext STB firmware from one platform — from the first QA device to a nationwide fleet.",
  otaHeroCtaDemo: "Request a demo",
  otaHeroCtaSales: "Discuss your deployment",
  otaHeroPlatformNote: "OTA Update Management is part of inext",
  otaHeroStat1: "1% → 100% staged rollouts",
  otaHeroStat2: "Geo & operator-aware delivery",
  otaHeroStat3: "Cloud or on-premises",
  otaHeroDiagramTitle: "Update request",
  otaHeroDiagramSubRunning: "Evaluating per device…",
  otaHeroDiagramSubDone: "Update complete",
  otaHeroDiagramStep1: "Model · board · installed version",
  otaHeroDiagramStep2: "Targeting · schedule · rollout %",
  otaHeroDiagramStep3: "Nearest available storage node",
  otaHeroDiagramOutcome: "Secure, verified download link",
  otaHeroDiagramDownloading: "Downloading firmware to STB…",
  otaHeroDiagramInstalling: "Installing firmware on STB…",
  otaHeroDiagramInstalled: "Firmware installed successfully",
  otaReleaseEyebrow: "Controlled workflow",
  otaReleaseTitle: "From tested build to controlled rollout",
  otaReleaseDescription:
    "Each release moves through clear testing, approval, rollout and monitoring stages. Role-controlled comments keep discussions attached to the relevant build or release.",
  otaReleaseCard1Title: "Offer each device only compatible firmware",
  otaReleaseCard1Body:
    "Each request is checked against model, board, installed version, operator, release policy and artifact availability before an update is offered.",
  otaReleaseCard2Title: "Set the rollout target",
  otaReleaseCard2Body:
    "Begin with a small pilot group, review adoption, then expand toward the full fleet. Pause or reduce the target without losing progress.",
  otaReleaseCard4Title: "Test on selected devices",
  otaReleaseCard4Body:
    "Validate the build on internal or field devices before it becomes eligible for public distribution.",
  otaReleaseCard6Title: "Approve for public release",
  otaReleaseCard6Body:
    "Separate test and public-release permissions so only authorized users can move firmware into production.",
  otaRolloutEyebrow: "Release controls",
  otaRolloutTitle: "Target precisely. Limit the blast radius.",
  otaRolloutBody:
    "Compatibility checks and percentage-based rollout controls substantially reduce release risk while keeping operators in control of every expansion.",
  otaRolloutMeterLabel: "Rollout target",
  otaRolloutMeterStage1: "Internal test",
  otaRolloutMeterStage2: "Pilot ring",
  otaRolloutMeterStage3: "Expanding",
  otaRolloutMeterStage4: "Full fleet",
  otaGovernEyebrow: "Governance",
  otaGovernTitle: "Approval rules stay explicit",
  otaGovernBody:
    "Role-based permissions separate testing, approval, rollout control and access to firmware comments, keeping production decisions explicit and controlled.",
  otaGovernPerm3: "Create test releases",
  otaGovernPerm4: "Approve for public distribution",
  otaGovernPerm5: "Create & modify rollout policies",
  otaGovernPerm6: "Start, pause or resume releases",
  otaGovernPerm7: "Advanced private release options",
  otaDeliveryEyebrow: "Global delivery",
  otaDeliveryTitle: "Resilient, geography-aware firmware delivery",
  otaDeliveryDescription:
    "Firmware is distributed through approved storage nodes chosen by configurable routing rules — keeping traffic close to your fleet while you stay in control of regional delivery policy.",
  otaDeliveryCard1Title: "Route by location, operator and capacity",
  otaDeliveryCard1Body:
    "Choose the nearest approved node that has the firmware and enough capacity for another download.",
  otaDeliveryCard2Title: "Fail over only when policy allows",
  otaDeliveryCard2Body:
    "If a regional node is unavailable or full, a verified global fallback can take over without bypassing delivery rules.",
  otaDeliveryCard3Title: "Verify every download",
  otaDeliveryCard3Body:
    "Time-limited links protect routing and storage details, while file size and checksum metadata validate the artifact before installation.",
  otaDiagramEyebrow: "How a release reaches a device",
  otaDiagramTitle: "The OTA delivery path",
  otaDiagramNode1: "Management UI & APIs",
  otaDiagramNode2: "Role-based control plane",
  otaDiagramNode3: "Firmware selection engine",
  otaDiagramNode4: "OTA delivery orchestrator",
  otaDiagramNode5: "Regional / on-premises storage nodes",
  otaDiagramNode6: "Global fallback storage",
  otaDiagramNode7: "inext STB fleet",
  otaDiagramNode8: "Download & adoption telemetry",
  otaDiagramReturnLabel: "Telemetry returns to the platform",
  otaDeployEyebrow: "Your infrastructure",
  otaDeployTitle: "Deploy in the cloud, on-premises, or both",
  otaDeployDescription:
    "Use inext cloud delivery, place storage nodes inside your network, or run the complete platform on-premises.",
  otaDeployCloudTag: "Recommended",
  otaDeployCloudTitle: "Cloud (SaaS)",
  otaDeployCloudBody:
    "Hosted and operated by inext. Fastest start, automatic platform upgrades, geo-distributed delivery out of the box.",
  otaDeployCloudBullet1: "No infrastructure to maintain",
  otaDeployCloudBullet2: "Global storage nodes included",
  otaDeployCloudBullet3: "Automatic platform upgrades",
  otaDeployOnpremTitle: "On-premises",
  otaDeployOnpremBody:
    "Backend, web interface and storage nodes inside your own network — for operators with strict data-residency or security requirements.",
  otaDeployOnpremBullet1: "Firmware artifacts stay in your network",
  otaDeployOnpremBullet2: "S3-compatible object storage",
  otaDeployOnpremBullet3: "Control of capacity and topology",
  otaDeployNodeTitle: "Need faster updates? Add a dedicated storage node",
  otaDeployNodeBody:
    "A storage server can run inside your network regardless of where the platform is hosted. inext configures it remotely, replicates the firmware and joins it to the delivery network in days.",
  otaDeployNodeChip1: "Works with cloud or on-premises",
  otaDeployNodeChip2: "Remotely provisioned by inext",
  otaDeployNodeChip3: "Live in days, not weeks",
  otaMonitorEyebrow: "Operational visibility",
  otaMonitorTitle: "See rollout progress in the real console",
  otaMonitorDescription:
    "Track rollout adoption and delivery status, then open device-specific OTA events from the activity timeline when an investigation is needed.",
  otaMonitorCard1Title: "Monitor and expand",
  otaMonitorCard1Body:
    "Compare adoption against active devices and the current rollout target before expanding.",
  otaMonitorCard2Title: "Download telemetry",
  otaMonitorCard2Body:
    "Review detailed download and installation metrics by build, device type, node, region or individual device event.",
  otaMonitorCard4Title: "Automated notifications",
  otaMonitorCard4Body:
    "Notify release owners when a rollout reaches its current target and is ready for review.",
  otaMonitorMetricsNote:
    "Infrastructure metrics export in a format compatible with standard monitoring platforms such as Prometheus and Grafana.",
  otaMigrateEyebrow: "Fleet migration",
  otaMigrateTitle: "Move a generic fleet onto your own firmware branch",
  otaMigrateBody:
    "Operators that launched on generic firmware can move deployed devices to a dedicated branded branch over the air — including the bootloader — without truck rolls or hardware swaps.",
  otaMigrateBullet1: "Transition deployed devices to a custom firmware branch",
  otaMigrateBullet2: "Full image conversion, including the bootloader",
  otaMigrateBullet3: "No field visits, returns or hardware swaps",
  otaApiEyebrow: "Integration-ready",
  otaApiTitle: "Connect OTA to your operational stack",
  otaApiBody:
    "Use self-service API keys with scoped permissions to integrate firmware builds, approvals, device state and rollout adoption with existing support and reporting tools.",
  otaApiPanelTitle: "Alcatraz API",
  otaApiPanelSub: "REST · documented · token-scoped",
  otaAppsEyebrow: "Application delivery",
  otaAppsTitle: "Deliver app updates, not just firmware",
  otaAppsBody:
    "Beyond firmware, the platform can distribute application updates to supported STBs — reusing the same delivery network and staged rollout controls. Available options depend on how the app is integrated.",
  otaAppsBullet1: "Same delivery network and staged rollout",
  otaAppsBullet2: "For supported STBs and integrated apps",
  otaStatRolloutValue: "1M+",
  otaStatRolloutLabel: "OTA updates delivered through the inext platform",
  otaStatScaleValue: "1% → 100%",
  otaStatScaleLabel: "Staged rollout control, from pilot group to full fleet",
  otaStatDeliveryValue: "Geo-aware",
  otaStatDeliveryLabel: "Routing by country, operator and live node capacity",
  otaStatDeployValue: "Cloud · On-premises",
  otaStatDeployLabel: "Run in our cloud or fully inside your own network",
  otaTargetChipsLabel: "Target by",
  otaTargetChip1: "STB model & board",
  otaTargetChip2: "Installed firmware version",
  otaTargetChip3: "ISP / operator",
  otaTargetChip4: "MAC allow-list",
  otaTargetChip5: "Test group",
  otaTargetChip6: "Auto-update eligibility",
  otaFaqEyebrow: "FAQ",
  otaFaqTitle: "Common questions",
  otaFaqQ1: "Is OTA part of Alcatraz DMS?",
  otaFaqA1:
    "OTA firmware updates are delivered through the inext Alcatraz platform — the same backend, console and permissions. If you already run Alcatraz DMS, OTA is the firmware-delivery side of the same system.",
  otaFaqQ2: "Can OTA run inside an operator's network?",
  otaFaqA2:
    "Yes. Storage nodes can run inside your infrastructure, and the complete platform — backend and web interface — can be deployed on-premises. Nodes support S3-compatible object storage.",
  otaFaqQ3: "How do staged rollouts reduce risk?",
  otaFaqA3:
    "You release to a defined percentage of the fleet, monitor adoption against active devices, and expand only when you're satisfied. You can pause, resume or roll the target back at any point, and you're notified when a stage completes.",
  otaFaqQ4: "What happens if a regional storage node is down or full?",
  otaFaqA4:
    "Routing is capacity-aware. If an approved regional node is unavailable or at capacity, traffic can fall back to a global node when the routing policy allows — and an update is only ever offered when a verified delivery path exists.",
  otaFaqQ5: "Can we force a critical security update?",
  otaFaqA5:
    "Yes. Releases can be marked mandatory so users can't skip them, and update-path rules ensure a device installs any required intermediate firmware before advancing to a newer build.",
  otaFaqQ6: "How do you verify a device received the correct firmware?",
  otaFaqA6:
    "Firmware metadata includes file size and checksum information, so the STB validates the downloaded artifact before installation. Devices also report download telemetry back to the platform.",
  otaFaqQ7: "Can the system deliver application updates?",
  otaFaqA7:
    "Yes. The system is designed primarily for firmware lifecycle management, but it can also distribute application updates to supported STBs. Available controls depend on the application integration and deployment requirements.",
  otaFinalEyebrow: "Ready to plan a safer rollout?",
  otaFinalTitle: "See OTA Update Management in action",
  otaFinalBody:
    "Walk through testing, approval, staged deployment and monitoring with the inext team using a rollout scenario from your own fleet.",
  otaFinalCta: "Book an OTA demo",
  otaFinalCtaSecondary: "Discuss your deployment",
  otaLiveLabel: "Live",
  otaUiTestTitle: "Test",
  otaUiTestBody: "Send this firmware to one or more devices for testing.",
  otaUiTestAction: "Create test release",
  otaUiConfirmTitle: "Confirm",
  otaUiConfirmBody:
    "Mark the firmware as ready for public release. A confirmed build can then be used in a public release.",
  otaUiConfirmAction: "Confirm firmware",
  otaUiReleaseTitle: "Release",
  otaUiReleaseBody:
    "Configure the release date, time and rollout percentage for the approved build.",
  otaUiReleaseAction: "Create public release",
  otaUiLiveBody: "Turn the release on or off at any time.",
  otaUiMandatoryTitle: "Mandatory",
  otaUiMandatoryBody: "Users cannot decline this update.",
  otaUiResetTitle: "Reset after update",
  otaUiResetBody: "Return devices to factory settings after installation.",
  otaUiStagedTitle: "Staged rollout",
  otaUiStagedBody: "Release this firmware to a controlled percentage of eligible devices.",
  otaUiInteractiveLabel: "Interactive preview",
  otaUiCompletedAction: "Completed",
  otaUiWorkingAction: "Working…",
  otaUiWorkflowComplete: "Approved and ready for staged deployment",
  otaUiReplayAction: "Run again",
  otaUiApproximately: "approximately",
  otaUiEligibleDevices: "eligible devices",
  otaAdvancedEyebrow: "Advanced capabilities",
  otaAdvancedTitle: "Extend OTA beyond the standard rollout",
  otaAdvancedBody:
    "Migrate existing fleets to a branded firmware branch and connect release operations to the rest of the operator's tooling.",
  worldwideEyebrow: "Worldwide delivery",
  worldwideHeadline: "Built in Asia. Deployed everywhere.",
  worldwideSub:
    "From manufacturing partners in Shenzhen and Taiwan, to operators across Europe, Central Asia, the Americas and beyond. Packaging, customs, and delivery coordination — all handled.",
  worldwideOriginLabel: "China & Taiwan",
  worldwideStat1Value: "700K+",
  worldwideStat1Label: "devices shipped",
  worldwideStat3Label: "shipping modes",
  worldwideCta: "How we ship",
  navSolutionsLogistics: "Global Logistics",
  navSolutionsLogisticsDesc: "B2B hardware delivery worldwide",
  footerLinkLogistics: "Global Logistics",
  logisticsSeoTitle: "Global Logistics — B2B Hardware Delivery Worldwide",
  logisticsSeoDescription:
    "B2B delivery of inext hardware from manufacturing partners in Shenzhen, Guangzhou and Taiwan to operators and distributors worldwide — by air, sea and road, with express courier for samples.",
  logisticsBreadcrumb: "Global Logistics",
  logisticsHeroEyebrow: "Worldwide B2B logistics",
  logisticsHeroTitle: "From production to",
  logisticsHeroTitleAccent: "your warehouse",
  logisticsHeroSub:
    "We build set-top boxes with established manufacturing partners in China and Taiwan, then coordinate delivery to operators, distributors and business warehouses worldwide. One point of contact keeps every B2B shipment moving.",
  logisticsHeroCtaPrimary: "Plan a shipment",
  logisticsHeroCtaSecondary: "Find a distributor",
  logisticsHeroChip1: "B2B delivery worldwide",
  logisticsHeroChip2: "Built in China & Taiwan",
  logisticsHeroChip3: "Branded, ready-to-sell packaging",
  logisticsHeroStage1: "Production",
  logisticsHeroStage2: "Branding & packaging",
  logisticsHeroStage3: "Freight",
  logisticsHeroStage4: "Customs & delivery",
  logisticsGlobeHubLabel: "Manufacturing hub",
  logisticsGlobeRouteLabel: "Delivery route",
  logisticsGlobeCaption:
    "B2B routes from China and Taiwan to Kyiv, Bratislava, São Paulo and Almaty, with onward distribution from Bratislava to Warsaw and Hungary.",
  logisticsHubShenzhen: "Shenzhen",
  logisticsHubGuangzhou: "Guangzhou",
  logisticsHubTaiwan: "Taiwan",
  logisticsStat1Value: "700K+",
  logisticsStat1Label: "devices delivered worldwide",
  logisticsStat2Value: "15+",
  logisticsStat2Label: "countries served",
  logisticsStat3Value: "3",
  logisticsStat3Label: "manufacturing hubs in China & Taiwan",
  logisticsStat4Value: "4",
  logisticsStat4Label: "freight options — air, sea, road & sample courier",
  logisticsMakeEyebrow: "Where it's made",
  logisticsMakeTitle: "Built in proven manufacturing hubs",
  logisticsMakeBody:
    "Our set-top boxes are produced with manufacturing and supply partners in two of the world's leading electronics regions. Keeping production close to the component supply chain keeps quality high, lead times short and costs predictable.",
  logisticsMakeCard1Title: "Shenzhen, China",
  logisticsMakeCard1Tag: "Assembly & packaging",
  logisticsMakeCard1Body:
    "Final assembly, firmware flashing, quality control and packaging — including operator-branded, retail-ready boxes.",
  logisticsMakeCard2Title: "Guangzhou, China",
  logisticsMakeCard2Tag: "Boards & components",
  logisticsMakeCard2Body:
    "Board production and component sourcing, backed by the dense Pearl River Delta supply chain for fast turnaround.",
  logisticsMakeCard3Title: "Taiwan",
  logisticsMakeCard3Tag: "Silicon & modules",
  logisticsMakeCard3Body:
    "Key chipsets and modules from established Taiwanese suppliers — the silicon behind the platforms our hardware runs on.",
  logisticsFlowEyebrow: "From production to deployment",
  logisticsFlowTitle: "A coordinated path to your operation",
  logisticsFlowBody:
    "Manufacturing, packaging, freight and customs move as one plan, with a named contact coordinating every stage.",
  logisticsFlowStep1Title: "Build & quality control",
  logisticsFlowStep1Body:
    "Devices are assembled and individually tested, then flashed with your firmware build before they leave the line.",
  logisticsFlowStep2Title: "Brand & pack",
  logisticsFlowStep2Body:
    "Boxes are packed in neutral or fully branded, retail-ready packaging to match your market.",
  logisticsFlowStep3Title: "Ship & clear customs",
  logisticsFlowStep3Body:
    "We book the right carrier for your timeline and budget, and prepare the export and customs paperwork.",
  logisticsFlowStep4Title: "Delivered to your network",
  logisticsFlowStep4Body:
    "Production shipments arrive at your warehouse, distributor or nominated logistics partner, with tracking throughout the journey.",
  logisticsModesEyebrow: "How we ship",
  logisticsModesTitle: "The right mode for every shipment",
  logisticsModesBody:
    "From a single urgent pallet to a full container, we match the shipping method to your volume, budget and deadline.",
  logisticsModeAirTitle: "Air freight",
  logisticsModeAirBody:
    "The fastest freight route for launches and time-critical production orders.",
  logisticsModeSeaTitle: "Sea freight",
  logisticsModeSeaBody:
    "The most cost-effective option for large, planned orders shipped by container.",
  logisticsModeRoadTitle: "Road & rail",
  logisticsModeRoadBody:
    "Regional distribution and onward delivery once goods land in your market.",
  logisticsModeCourierTitle: "Express courier",
  logisticsModeCourierBody:
    "Fast door-to-door delivery for evaluation samples before a project or volume order.",
  logisticsB2bNoteTitle: "Business shipments only",
  logisticsB2bNoteBody:
    "Production orders go to operators, distributors, warehouses or logistics partners. We do not drop-ship to subscribers. Express courier is reserved for evaluation samples.",
  logisticsHandleEyebrow: "Handled for you",
  logisticsHandleTitle: "More than moving boxes",
  logisticsHandleBody:
    "We take care of the details that slow operators down, so hardware arrives ready to deploy.",
  logisticsHandleItem1: "Operator-branded, retail-ready packaging",
  logisticsHandleItem2: "Bulk, palletized and container shipments",
  logisticsHandleItem3: "Export, customs and compliance documentation",
  logisticsHandleItem4: "Staged, region-by-region rollouts",
  logisticsHandleItem5: "Coordination with your distributors and 3PLs",
  logisticsHandleItem6: "Express sample delivery for technical and commercial evaluation",
  logisticsHandleItem7: "Per-device serial and MAC manifests, ready for provisioning",
  logisticsHandleItem8: "Pre-flashed firmware and per-batch configuration",
  logisticsHandleItem9: "Flexible Incoterms — EXW, FOB or DAP to suit your team",
  logisticsHandleFootnote: "One coordinator owns every shipment, from the line to your dock.",
  logisticsLinksEyebrow: "Keep exploring",
  logisticsLinksTitle: "Plan the rest of your rollout",
  logisticsLinkCta: "Learn more",
  logisticsLinkDistributorsTitle: "Find a distributor",
  logisticsLinkDistributorsBody:
    "Work with an authorised inext partner already serving your region.",
  logisticsLinkCustomizationTitle: "Branding & packaging",
  logisticsLinkCustomizationBody:
    "Ship hardware under your own brand, from the firmware to the retail box.",
  logisticsLinkProductsTitle: "Browse the hardware",
  logisticsLinkProductsBody: "Compare the inext set-top box lineup and pick the right model.",
  logisticsLinkAboutTitle: "About inext",
  logisticsLinkAboutBody: "The team behind the hardware, shipping to operators since 2011.",
  logisticsFaqEyebrow: "FAQ",
  logisticsFaqTitle: "Delivery & logistics, answered",
  logisticsFaqQ1: "Which countries do you deliver to?",
  logisticsFaqA1:
    "We ship worldwide. inext hardware is already deployed by operators in more than 15 countries, and our logistics partners can reach virtually any market — directly or through a local distributor.",
  logisticsFaqQ2: "Where are inext products manufactured?",
  logisticsFaqA2:
    "Our set-top boxes are built with manufacturing and supply partners in Shenzhen and Guangzhou (China) and Taiwan — established electronics regions with mature, reliable supply chains.",
  logisticsFaqQ3: "Who handles shipping and customs?",
  logisticsFaqA3:
    "We coordinate the whole journey through our network of logistics partners and prepare the export and customs paperwork, so you get one point of contact instead of juggling freight forwarders.",
  logisticsFaqQ4: "Can you ship under our own brand?",
  logisticsFaqA4:
    "Yes. Devices can arrive at your warehouse or distribution partner in fully branded, retail-ready packaging. See our customization options for firmware, enclosure and packaging choices.",
  logisticsFaqQ5: "What shipping methods and lead times are available?",
  logisticsFaqA5:
    "Production orders can travel by air, sea, road or rail. Express courier is used for evaluation samples, not consumer drop-shipping. Lead times depend on volume, customization and destination — we confirm a realistic schedule with every quote.",
  logisticsFaqQ6: "Is there a minimum order quantity?",
  logisticsFaqA6:
    "Order sizes are agreed per project. We work with operators of different scales, from first pilot batches to repeat volume orders — talk to us about what you need.",
  logisticsFinalEyebrow: "Let's get your hardware moving",
  logisticsFinalTitle: "Plan your worldwide delivery",
  logisticsFinalBody:
    "Tell us where your devices need to go and how fast. We'll put together a delivery plan — manufacturing, packaging, freight and customs — and a single team to run it.",
  logisticsFinalCta: "Talk to our team",
  logisticsFinalCtaSecondary: "Find a distributor",
  productsIndexEyebrow: "Hardware",
  productsIndexTitle: "The inext product range",
  productsIndexSubtitle:
    "4K Android TV set-top boxes built for operators — plus the official accessories and tools that complete every deployment.",
  productsIndexMoreHeading: "Explore more",
  productsIndexArchiveDesc: "Specifications and photos of discontinued inext models.",
  productsIndexCardCta: "Learn more",
  productsIndexSeoTitle: "Products — Android TV set-top boxes & accessories | inext",
  productsIndexSeoDescription:
    "Explore the full inext product range: 4K Android TV set-top boxes, official accessories, a side-by-side comparison, and the legacy model archive.",
  solutionsIndexEyebrow: "Platform & services",
  solutionsIndexTitle: "Solutions for every stage of your TV service",
  solutionsIndexSubtitle:
    "From device management and firmware to the apps subscribers use every day — the software and services that run an inext fleet.",
  solutionsIndexCardCta: "Learn more",
  solutionsIndexFlagship: "Flagship",
  solutionsIndexSeoTitle: "Solutions — device management, OTA, IPTV app & more | inext",
  solutionsIndexSeoDescription:
    "Explore inext solutions: Alcatraz device management, OTA update management, the IPTV application, the inext Remote app, customization, and global logistics.",
  verimatrixNote:
    "Certified Verimatrix partner — our set-top boxes and IPTV app integrate natively with Verimatrix VCAS conditional access and multi-DRM.",
  solutionsRow1Title: "Run your whole fleet from one place",
  solutionsRow1Body:
    "Alcatraz analyzes telemetry, organizes detected issues in a prioritized Fleet Health queue, records device activity and supports controlled firmware delivery and remote diagnostics.",
  solutionsRow2Title: "The screen your subscribers live on",
  solutionsRow2Body:
    "A branded IPTV app and a free mobile remote turn an inext box into a TV experience subscribers actually enjoy.",
  solutionsRow3Title: "Your brand, built and delivered",
  solutionsRow3Body:
    "White-label hardware and firmware made to your spec, then shipped worldwide — you launch, we handle the rest.",
  solutionsAllTitle: "Every solution, one platform",
  navGuides: "Guides",
  footerGuides: "Guides",
  footerLinkGuidesAndroidLinux: "Android vs Linux",
  guidesBreadcrumbHome: "Home",
  guidesIndexEyebrow: "Guides",
  guidesIndexTitle: "Guides to the decisions behind your TV platform",
  guidesIndexSubtitle:
    "Honest, practical guides to the choices operators actually face — hardware, OS, device ownership, financing, and delivery. We ship the whole stack, so these aren't sales pitches.",
  guidesIndexAllTitle: "All guides",
  guidesIndexCardCta: "Read guide",
  guidesIndexSeoTitle: "Guides — choosing and running your TV platform | inext",
  guidesIndexSeoDescription:
    "Practical, vendor-neutral guides for IPTV and OTT operators — platform choices, deployment, and the decisions behind running a set-top box fleet.",
  tcoCardTitle: "STB TCO Calculator",
  tcoCardDesc:
    "Compare the total cost of two set-top box deployment scenarios, including hardware, replacements, support, field service and fleet management.",
  tcoCardCta: "Open calculator",
  tcoSeoTitle: "STB TCO Calculator — Compare Set-Top Box Fleet Costs | inext",
  tcoSeoDescription:
    "Estimate and compare the total cost of ownership of two IPTV or OTT set-top box deployment scenarios, including hardware, replacements, support, field service and device management.",
  tcoBreadcrumbPage: "STB TCO Calculator",
  tcoHeroEyebrow: "Interactive planning tool",
  tcoHeroTitle: "Set-Top Box Total Cost of Ownership Calculator",
  tcoHeroBody:
    "Compare two set-top box deployment scenarios across their full service life. See how purchase price, hardware failures, subscriber support, field service and device management affect the actual cost per device.",
  tcoExampleNotice:
    "The prefilled values are examples only, not a quote or guarantee of savings. Replace them with actual operating data and supplier quotes.",
  tcoInputsEyebrow: "Planning inputs",
  tcoInputsTitle: "Build two comparable scenarios",
  tcoInputsBody:
    "Set the fleet size, service life and currency shared by both scenarios, then enter the cost and operating assumptions for each one.",
  tcoReset: "Restore example",
  tcoFleetSize: "Devices in fleet",
  tcoOwnershipPeriod: "Service life, years",
  tcoCurrency: "Calculation currency",
  tcoScenarioLabel: "Deployment scenario",
  tcoScenarioA: "Scenario A",
  tcoScenarioB: "Scenario B",
  tcoFieldUnitPrice: "Purchase price per device",
  tcoFieldLogistics: "Logistics cost per device",
  tcoFieldSetup: "One-time setup and customization",
  tcoFieldFailureRate: "Annual hardware failure rate, %",
  tcoFieldReplacement: "Cost per replacement",
  tcoFieldSupportContacts: "Support requests per 1,000 devices per year",
  tcoFieldSupportCost: "Cost per support request",
  tcoFieldTruckRolls: "Field visits per 1,000 devices per year",
  tcoFieldTruckRollCost: "Cost per field visit",
  tcoFieldDmsCost: "Device management per device per month",
  tcoDmsIncludedNote:
    "Device management: Alcatraz Pro is included at no extra cost while the fleet has fewer than 500 active inext devices. For fleets with 500 active devices or more, contact inext to discuss commercial terms.",
  tcoResultsEyebrow: "Comparison",
  tcoResultsTitle: "Estimated total cost over the full period",
  tcoLowerResult: "{scenario}: {amount} lower ({percent}%)",
  tcoEqualResult: "Both scenarios have the same estimated TCO",
  tcoComparisonNote:
    "This estimate is based on the inputs above. At fleet scale, operating costs can outweigh a small difference in purchase price.",
  tcoTotalLabel: "Total cost over the selected period",
  tcoPerDevice: "Cost per device",
  tcoPerDeviceMonth: "Monthly cost per device",
  tcoCostProcurement: "Hardware procurement",
  tcoCostLogistics: "Logistics",
  tcoCostSetup: "Setup and customization",
  tcoCostReplacements: "Hardware replacements",
  tcoCostSupport: "Subscriber support",
  tcoCostFieldService: "Field service",
  tcoCostManagement: "Device management",
  tcoMethodEyebrow: "Calculation model",
  tcoMethodTitle: "What the TCO calculation includes",
  tcoMethodBody:
    "Total cost of ownership includes not only the initial purchase, but also the operating costs that follow. The model is deliberately transparent so each assumption can be replaced with actual operating data.",
  tcoMethod1Title: "Initial deployment",
  tcoMethod1Body:
    "Device and logistics costs are calculated across the full fleet. Setup and customization are counted once.",
  tcoMethod2Title: "Costs over the service life",
  tcoMethod2Body:
    "Hardware failures, support requests, field visits and monthly device-management costs are projected across the selected service life.",
  tcoMethod3Title: "Comparable per-device costs",
  tcoMethod3Body:
    "The total is expressed as cost per device and monthly cost per device, making scenarios with different purchase prices easier to compare.",
  tcoCtaTitle: "Validate the calculation with real hardware",
  tcoCtaBody:
    "The calculator helps narrow the shortlist. A trial deployment verifies device stability, support workflows, remote diagnostics and the actual operating costs behind the model.",
  tcoCtaButton: "Discuss your deployment",
  footerLinkGuidesTco: "STB TCO calculator",
  guidesCardAvlTitle: "Android vs Linux STB",
  guidesCardAvlDesc:
    "Which platform fits your network? An honest comparison — app ecosystem, cost, control, and when each one wins.",
  avlSeoTitle: "Android vs Linux STB: How to Choose | inext",
  avlSeoDescription:
    "Android TV or Linux for your set-top box fleet? An honest, vendor-neutral comparison from inext — we ship both. App ecosystem, cost, control, and when each one wins.",
  avlBreadcrumbPage: "Android vs Linux STB",
  avlHeroEyebrow: "Platform guide",
  avlHeroTitle: "Android vs Linux STB:",
  avlHeroTitleAccent: "which platform fits your network?",
  avlHeroSub:
    "Most ‘Android vs Linux’ guides are written by a vendor that only sells one of them — so they're really a sales pitch in disguise. We're not in that position: every inext set-top box can ship with either Android or a lean Linux build, so we genuinely don't mind which you choose. This is the honest version.",
  avlHeroNote: "We ship both — so this comparison has no thumb on the scale.",
  avlHeroCtaPrimary: "Talk to our team",
  avlHeroCtaSecondary: "See the comparison",
  avlDefineEyebrow: "Start here",
  avlDefineTitle: "First, what we actually mean",
  avlDefineBody:
    "Both run on the same silicon, so it's easy to blur them. For this comparison, keep them apart as two products:",
  avlDefineAndroidLabel: "Android",
  avlDefineAndroidBody:
    "the Android TV platform — it runs the Android app ecosystem behind a launcher you can brand, so subscribers get the apps and patterns they already know.",
  avlDefineLinuxLabel: "Linux",
  avlDefineLinuxBody:
    "a lean, purpose-built build that contains only your IPTV app, your middleware, and the tools you put there — no app store, no Android layer.",
  avlDefineCandid:
    "The candid part up front: around 95% of the operators we work with choose Android — though in some regions Linux is meaningfully more common. We'll explain exactly why, and when Linux is the smarter call.",
  avlVerdictEyebrow: "The quick verdict",
  avlVerdictTitle: "Two columns — find yourself in one",
  avlVerdictAndroidTitle: "Choose Android if…",
  avlVerdictAndroid1:
    "You want the Android app ecosystem — the mainstream streaming and OTT apps your subscribers already know",
  avlVerdictAndroid2:
    "You want a familiar, consumer-grade TV experience with minimal custom UI work",
  avlVerdictAndroid3: "You need to launch fast and keep future app options open",
  avlVerdictAndroid4:
    "A large, familiar app catalog and a consumer-grade experience matter to your offering",
  avlVerdictLinuxTitle: "Choose Linux if…",
  avlVerdictLinux1:
    "You're running a pure managed IPTV service — your own app, your walled garden, nothing else",
  avlVerdictLinux2:
    "You want the leanest footprint and the lowest running cost on the same hardware",
  avlVerdictLinux3: "You need maximum control and lock-down, with no app store on the device",
  avlVerdictLinux4: "Third-party OTT apps aren't part of what you sell",
  avlVerdictFootnote:
    "Clearly in the Android column? You're with the 95% — that's the safe default. If the Linux column describes you, read on.",
  avlCoreEyebrow: "The core difference",
  avlCoreTitle: "App ecosystem vs. leanness and control",
  avlCoreBody1:
    "Strip away the detail and the choice is one trade-off: app ecosystem and familiarity versus leanness and control.",
  avlCoreBody2:
    "Android gives you the consumer world your subscribers already know: it runs the Android app ecosystem — your own app plus the mainstream streaming and OTT apps — behind a launcher you can brand, with the whole Android app catalog open to you. That reach is why nearly every operator picks it.",
  avlCoreBody3:
    "Linux gives you the opposite virtues: a stripped-down device that does exactly what you tell it and nothing more. No app store, no Google layer, no consumer ecosystem — just your IPTV app and the tools you approved. That makes it leaner, cheaper to run, easier to lock down, and fully yours.",
  avlCoreBody4:
    "The catch that decides most cases: the big OTT apps are built as Android apps. A Linux box can't run them at all — putting a third-party app there is a bespoke, per-app effort that's usually impractical. So if your subscribers expect those apps, Linux effectively rules itself out. If they don't, its advantages are real.",
  avlTableEyebrow: "Side by side",
  avlTableTitle: "Android vs Linux, row by row",
  avlTableColDimension: "",
  avlTableColAndroid: "Android",
  avlTableColLinux: "Linux",
  avlRow1Dim: "OTT app ecosystem (Netflix, YouTube, Disney+)",
  avlRow1Android: "Runs the Android app ecosystem — your app plus OTT apps",
  avlRow1Linux: "No Android apps — only the client you build",
  avlRow2Dim: "Consumer UX familiarity",
  avlRow2Android: "Familiar Android TV experience",
  avlRow2Linux: "Fully custom — whatever you design",
  avlRow3Dim: "Branding & customization",
  avlRow3Android: "Branded launcher, deep customization",
  avlRow3Linux: "Total control over every pixel and behavior",
  avlRow4Dim: "Walled-garden lock-down",
  avlRow4Android: "Possible, takes configuration",
  avlRow4Linux: "Native — there's no app store to lock down",
  avlRow5Dim: "Footprint on the same box",
  avlRow5Android: "Wants more RAM/storage headroom",
  avlRow5Linux: "Runs leaner; lets you spec a lower-tier box",
  avlRow6Dim: "Boot time & resource use",
  avlRow6Android: "Heavier",
  avlRow6Linux: "Lighter, faster boot",
  avlRow7Dim: "Platform & security updates",
  avlRow7Android: "Android platform base plus your OTA",
  avlRow7Linux: "Fully operator/inext-managed via OTA",
  avlRow9Dim: "DRM / content protection",
  avlRow9Android: "Widevine & Verimatrix",
  avlRow9Linux: "Widevine & Verimatrix",
  avlRow10Dim: "Development speed & talent",
  avlRow10Android: "Large ecosystem, fast",
  avlRow10Linux: "Specialist work, more custom",
  avlRow12Dim: "Lifecycle & independence",
  avlRow12Android: "Moves on Google's platform cadence",
  avlRow12Linux: "No external dependency — you control longevity",
  avlRowAppDim: "inext client app",
  avlRowAppAndroid: "Ready-made IPTV app and launcher — both branded as yours",
  avlRowAppLinux: "SDK & API to build and integrate fast",
  avlRowInextDim: "Managed by the inext stack",
  avlStackLabel: "Same on both:",
  avlStackAlcatraz: "Alcatraz DMS",
  avlStackOta: "OTA",
  avlStackTr069: "TR-069",
  avlStackCustomization: "customization",
  avlTableNote:
    "DRM and exact platform specifics depend on the box and build — tell us what your deployment needs and we'll confirm.",
  avlDecideEyebrow: "What actually decides it",
  avlDecideTitle: "The questions that settle most decisions",
  avlDecide1Title: "The app ecosystem",
  avlDecide1Body:
    "This is the single biggest reason Android wins. The mainstream OTT apps — Netflix, YouTube, Disney+, Prime — are built as Android apps and run on the Android app ecosystem. A Linux box can't run them at all; adding a third-party app there is a bespoke integration that, for most operators, isn't worth it. If a subscriber's first question is ‘does it have Netflix?’, Android is your answer. If you deliver a closed IPTV bouquet and OTT apps aren't part of the deal, this disadvantage simply doesn't apply to you.",
  avlDecide2Title: "Cost and footprint",
  avlDecide2Body:
    "Because the boxes are identical, Linux doesn't make the hardware cheaper by itself — it lets you do more with less. A lean Linux build has lower RAM and storage demands, so for a pure-IPTV deployment you can spec a lower-tier box like the inext TV5 and still get a snappy experience, where the same role on Android wants more headroom. At fleet scale, that headroom is real money.",
  avlDecide3Title: "Control, security, and lock-down",
  avlDecide3Body:
    "Linux is the natural choice when ‘the device must do exactly this and nothing else’ is a hard requirement. No app store, no sideloading surface, a smaller attack surface, and a build containing only what you approved. Android can be locked down too, but that's configuration you maintain against a larger, evolving platform. For kiosk-style, regulated, or tightly-managed deployments, Linux's simplicity is the feature.",
  avlDecide4Title: "Time to market",
  avlDecide4Body:
    "Android gets a consumer-style product live faster — the launcher, the apps, and the UX patterns already exist and just need branding. Linux means building or porting more of the experience yourself, which is the point when you want full control, but it's more up-front work. We shorten both paths: on Android with our ready-made IPTV app and customization service, on Linux with an SDK and API that speed up your build and integration.",
  avlDecide5Title: "Lifecycle and independence",
  avlDecide5Body:
    "Android moves on Google's platform cadence — new versions and app compatibility. That's mostly a benefit, but it's an external dependency. A Linux build has no such gravity: it's yours, frozen or evolved on your schedule, on no one's roadmap but your own. For very long-life deployments, or markets where you want zero outside dependency, that matters.",
  avlProfilesEyebrow: "Which is right for you?",
  avlProfilesTitle: "Match your service to a platform",
  avlProfile1Title: "IPTV + OTT operator",
  avlProfile1Pick: "Android",
  avlProfile1Body:
    "Subscribers want your channels and the big streaming apps. This is the common case — the ~95%.",
  avlProfile2Title: "Pure managed IPTV / walled garden",
  avlProfile2Pick: "Linux",
  avlProfile2Body: "Your app only, no third-party OTT. Worth a serious look.",
  avlProfile3Title: "Cost-driven, high-volume rollout",
  avlProfile3Pick: "Linux",
  avlProfile3Body:
    "When the offering is your own bouquet, Linux on a lower-tier box stretches the budget.",
  avlProfile4Title: "Tightly controlled / kiosk / regulated",
  avlProfile4Pick: "Linux",
  avlProfile4Body: "When lock-down is a hard requirement, the leaner platform is easier to secure.",
  avlProfile5Title: "Not sure / keeping options open",
  avlProfile5Pick: "Android",
  avlProfile5Body: "The safe default that keeps the most doors open.",
  avlSameEyebrow: "Whichever you pick",
  avlSameTitle: "The rest of the stack is the same",
  avlSameBody:
    "Every inext box — Android or Linux — runs on the same operational stack: Alcatraz DMS for fleet control, staged OTA updates, TR-069, and our white-label customization. The client software is the one part that differs — on Android you can ship our ready-made IPTV app and branded launcher, both yours; on Linux we give you an SDK and API to build and integrate fast. Either way, you keep the tooling that runs the fleet.",
  avlLockTitle: "Same hardware — so decide deliberately, not nervously",
  avlLockBody:
    "Android or Linux is a firmware choice on the very same box, not a different product. You can evaluate both before you commit, or run a mixed fleet. Switching a box between platforms later is possible, but it's a re-flash rather than a routine OTA update — so it's best to pick the platform you intend to stay on and commit to it. The hardware decision is low-stakes; the platform decision is worth making with care.",
  avlFaqEyebrow: "FAQ",
  avlFaqTitle: "Common questions",
  avlFaqQ1: "Can I run Netflix on a Linux STB?",
  avlFaqA1:
    "Generally not. Netflix, YouTube and Disney+ are built as Android apps; a Linux box can't run them, and adding a third-party app is a bespoke, often impractical integration. If those apps matter to your offering, choose Android.",
  avlFaqQ2: "Is Android more expensive than Linux?",
  avlFaqA2:
    "The hardware is the same inext box, so the platform isn't a line-item cost. Android wants a little more RAM and storage headroom, so for a pure-IPTV role Linux can let you spec a lower-tier box.",
  avlFaqQ3: "Can I switch from Linux to Android later, or back?",
  avlFaqA3:
    "It's possible, but it isn't a routine OTA update — moving a box between Android and Linux means re-flashing the firmware, which is more involved. It's the same hardware either way, so you're not buying different devices, but we'd recommend committing to the platform you intend to stay on.",
  avlFaqQ4: "Which do most operators choose?",
  avlFaqA4:
    "Around 95% choose Android, because their subscribers expect mainstream OTT apps — though in some regions Linux is meaningfully more common. Linux wins for pure managed-IPTV, lock-down, and lowest-footprint deployments.",
  avlFaqQ5: "Does inext device management work on both?",
  avlFaqA5: "Yes — Alcatraz DMS, OTA updates and TR-069 work the same on Android and Linux builds.",
  avlCtaEyebrow: "Talk to us",
  avlCtaTitle: "Not sure which fits your rollout?",
  avlCtaBody:
    "Tell us about your service and we'll recommend a platform honestly — including when that's Linux.",
  avlCtaPrimary: "Talk to our team",
  avlCtaSecondary: "Request a Linux firmware build",
  footerLinkGuidesAospCert: "AOSP vs Certified",
  guidesCardAcTitle: "AOSP vs Certified Android TV",
  guidesCardAcDesc:
    "Which one does your launch actually need? The certified app ecosystem vs. speed, cost and control — and how we deliver both.",
  acSeoTitle: "AOSP vs Certified Android TV: Which Does Your Launch Need? | inext",
  acSeoDescription:
    "AOSP or Google-certified Android TV for your operator deployment? An honest comparison from inext — we deliver both. App ecosystem, cost, time-to-market, and when certification is worth it.",
  acBreadcrumbPage: "AOSP vs Certified Android TV",
  acHeroEyebrow: "Platform guide",
  acHeroTitle: "AOSP vs Certified Android TV:",
  acHeroTitleAccent: "which one does your launch actually need?",
  acHeroSub:
    "Both are Android — what separates them is Google's certification, and the time, cost and control you trade for it. We build AOSP ourselves, so we won't pretend to be neutral: for most operators it's the faster, cheaper, more flexible call, and that's our honest recommendation — and when a project genuinely needs certification, we deliver that too, with our certified 3PL partners. This page lays out the trade-off so you can tell which one your launch needs.",
  acHeroNote:
    "Most operators ship AOSP. When a project genuinely needs certification, we deliver that too.",
  acHeroCtaPrimary: "Talk to our team",
  acHeroCtaSecondary: "See the comparison",
  acDefineEyebrow: "Start here",
  acDefineTitle: "First, what ‘certified’ actually changes",
  acDefineBody:
    "Both run Android. The line between them is Google's certification program — and everything that rides on it:",
  acDefineAospLabel: "AOSP",
  acDefineAospBody:
    "open-source Android, fully yours — your launcher, your apps, your rules. No Google Play store and no certification gate, but with Widevine L1 and L3 on board, so with your operator deals it still runs premium apps like Netflix. Far faster and cheaper to launch.",
  acDefineCertLabel: "Certified Android TV",
  acDefineCertBody:
    "Google-certified, with Google Play, Widevine L1, Google Assistant and Chromecast built in — the foundation for the certified app ecosystem — at the cost of Google's licensing, approval and timeline.",
  acStat1: "1–2 weeks to a working sample",
  acStat2: "No per-device Google fees on AOSP",
  acStat3: "Both platforms, one partner",
  acPivotEyebrow: "Start here",
  acPivotTitle: "It usually comes down to one question",
  acPivotQuestion:
    "Do your subscribers need the open Google Play Store — a self-serve catalog of thousands of apps — plus Google Assistant and Chromecast?",
  acPivotNoLabel: "No — a curated, operator-controlled experience",
  acPivotNoPick: "AOSP",
  acPivotNoText:
    "You lead with your own service and a chosen line-up — including Netflix and other premium apps where you hold the operator agreement. Faster, cheaper, fully yours.",
  acPivotYesLabel: "Yes — the open consumer app store",
  acPivotYesPick: "Certified",
  acPivotYesText:
    "You want the full self-serve Play Store and Google's services as part of the product. Worth the licensing and the longer timeline.",
  acPivotFootnote:
    "Most operators answer ‘no’ and ship AOSP. Whichever way you lean, we deliver it.",
  acTimelineEyebrow: "Time to market",
  acTimelineTitle: "Two paths to launch",
  acTimelineIntro:
    "The biggest practical difference isn't the technology — it's how long it takes to go live, and what it costs to get there.",
  acTimelineAospLabel: "AOSP with inext",
  acTimelineAospResult: "~2 months to shipping",
  acTimelineAospStep1: "Customize the launcher, app and services to your brand",
  acTimelineAospStep2: "Confirm a working sample — about 1–2 weeks in",
  acTimelineAospStep3: "Roll out",
  acTimelineCertLabel: "Certified Android TV",
  acTimelineCertResult: "5–8 months to shipping",
  acTimelineCertStep1: "License GMS, spec Google-approved hardware",
  acTimelineCertStep2: "Build and integrate",
  acTimelineCertStep3: "Certification testing",
  acTimelineCertStep4: "Google approval",
  acTimelineCertStep5: "Roll out",
  acTimelineNote:
    "We've already built the AOSP platform, so its usual ‘slow to build’ downside is gone. Need certification? We run that track too, with our certified 3PL partners.",
  acIncludesEyebrow: "What you get",
  acIncludesTitle: "Our AOSP isn't a blank box — it's a launch-ready platform",
  acIncludesBody:
    "Everything below is already built, proven and customized to your brand. The exact app line-up is tailored to your country and licensing, so it isn't listed here.",
  acIncludes1: "A customizable operator-tier launcher — your brand and content first on boot",
  acIncludes2: "Our IPTV app, branded as yours",
  acIncludes3:
    "Your market's local TV and streaming services preloaded — plus premium apps like Netflix where you hold the agreement",
  acIncludes4: "Managed by Alcatraz DMS, OTA and TR-069 from day one",
  acIncludes5: "Customized and confirmed with a working sample in 1–2 weeks",
  acTableEyebrow: "The full comparison",
  acTableTitle: "Where AOSP and Certified actually differ",
  acTableColDimension: "",
  acTableColAosp: "AOSP",
  acTableColCert: "Certified Android TV",
  acRow1Dim: "Google Play Store",
  acRow1Aosp: "No Play Store — your own app delivery",
  acRow1Cert: "Built in — thousands of apps",
  acRow2Dim: "Premium apps (Netflix, Disney+ in HD/4K)",
  acRow2Aosp: "Works where your network holds the operator agreement — our AOSP is Widevine L1",
  acRow2Cert: "Same, plus distribution via Google Play; the operator agreement still applies",
  acRow3Dim: "Google Assistant & Chromecast",
  acRow3Aosp: "Not included (or custom)",
  acRow3Cert: "Built in",
  acRow4Dim: "Widevine DRM",
  acRow4Aosp: "Widevine L1 and L3 on inext boxes",
  acRow4Cert: "Widevine L1 and L3",
  acRow5Dim: "Operator launcher / home screen",
  acRow5Aosp: "Fully custom, leads on boot — total control",
  acRow5Cert: "Operator-tier launcher, within Google's rules",
  acRow6Dim: "Preinstalled apps & local services",
  acRow6Aosp: "Exactly what your market needs — your call",
  acRow6Cert: "Google Play model, plus your additions",
  acRow7Dim: "Customization freedom",
  acRow7Aosp: "Total",
  acRow7Cert: "Within Google's program",
  acRow8Dim: "Hardware",
  acRow8Aosp: "Runs on lean, cost-optimized boxes",
  acRow8Cert: "Higher-spec, Google-approved",
  acRow9Dim: "Time to market",
  acRow9Aosp: "~2 months to shipping (a working sample in 1–2 weeks)",
  acRow9Cert: "Typically 5–8 months to shipping",
  acRow10Dim: "Cost",
  acRow10Aosp: "No GMS license or per-device Google fees",
  acRow10Cert: "GMS license, per-device fees, test-lab costs",
  acRow11Dim: "Google dependency",
  acRow11Aosp: "None",
  acRow11Cert: "Ongoing compliance with Google",
  acRow12Dim: "Billing & payments (selling to subscribers)",
  acRow12Aosp: "Any payment gateway or partner — your own billing, no platform cut",
  acRow12Cert: "Digital sales must use Google Play billing — Google takes a fee",
  acRow13Dim: "Pushing a system/firmware update",
  acRow13Aosp: "Build it today, on the whole fleet tomorrow — entirely your call",
  acRow13Cert: "Every system change must pass Google or a 3PL lab before you can ship it",
  acTableNote:
    "Premium apps like Netflix need their own device certification and, for an ISP bundling them, a direct operator agreement — on either platform. The upside: our AOSP is Widevine L1, so with that agreement Netflix runs on it, no Google certification required. We'll map what each app in your line-up needs.",
  acSameEyebrow: "Whichever you need",
  acSameTitle: "Both platforms, one partner — and a straight answer on which you need",
  acSameBody:
    "Let's be straight: AOSP is our own product, so it's what we build and what we'll usually recommend — because for most operators it genuinely is the better fit. What we won't do is push it when your project needs certification, or sell you certification you don't. When you do need it, we deliver fully certified Android TV too, working with our certified 3PL partners on the certification. One relationship, one operations stack, and a straight answer instead of a sales pitch for whichever earns us more.",
  acInhouseTitle: "AOSP — built in-house",
  acInhouseBody:
    "A proven, fully customizable operator-tier launcher and our IPTV app, preloaded with your market's local TV and streaming services. Customized to your brand and confirmed with a working sample in 1–2 weeks.",
  acPartnerTitle: "Certified Android TV — we deliver it, with 3PL partners",
  acPartnerBody:
    "When your offer needs Google Play, certified premium apps and Widevine L1, we deliver fully certified Android TV — working with our certified 3PL partners on the certification, with inext as your single point of contact and one team accountable.",
  acSameNoteTitle: "One stack runs both",
  acSameNoteBody:
    "Whichever platform you land on, the same inext operations run the fleet — Alcatraz DMS, staged OTA, TR-069 and white-label customization. Choosing AOSP or certified doesn't change how you operate day to day.",
  acFaqEyebrow: "FAQ",
  acFaqTitle: "Common questions",
  acFaqQ1: "Can I run Netflix on inext's AOSP?",
  acFaqA1:
    "Yes — where your network holds an agreement with Netflix. Our AOSP supports Widevine L1, so given that operator agreement it runs a working Netflix app, no Google certification required. The same goes for other premium services you have deals for: you bring the agreement, we provide the L1-ready platform and the integration.",
  acFaqQ2: "inext isn't a certified Android TV vendor — can you still deliver it?",
  acFaqA2:
    "Yes. We build AOSP in-house, and we also deliver fully certified Android TV — working with certified 3PL partners on the certification itself, with inext as the prime. You get both options and a single point of contact, and we run the certified path so you don't have to assemble it yourself.",
  acFaqQ3: "How fast can you deliver an AOSP solution?",
  acFaqA3:
    "Our AOSP platform is already built and proven, so customizing it to your brand and getting a working sample to you typically takes 1–2 weeks. From project start to goods shipping is usually around 2 months — against the 5–8 months a certified Android TV STB normally needs — though it depends on your integrations, licensing and order.",
  acFaqQ4: "What does inext's AOSP come with?",
  acFaqA4:
    "A customizable operator-tier launcher, our IPTV app, and your market's local TV and streaming services preloaded. The exact app line-up depends on your country and the licensing in your region, so we tailor it per deployment.",
  acFaqQ5: "Which do most operators choose?",
  acFaqA5:
    "Most choose AOSP — it covers what their service needs, launches faster and costs less, and still runs premium apps like Netflix where they hold the operator deal. Certification is the right call when you specifically want the open, self-serve Google Play Store and Google's services — and we deliver that too.",
  acFaqQ6: "Does the inext operations stack work on both?",
  acFaqA6:
    "Yes — Alcatraz DMS, OTA updates and TR-069 manage your fleet the same way whether it's AOSP or certified.",
  acFaqQ7: "Does Google certification mean my subscribers get Netflix?",
  acFaqA7:
    "Not on its own — and you don't need it for Netflix anyway. Netflix certifies devices itself and wants a direct agreement with operators who bundle it; given that agreement, our AOSP runs Netflix without Google certification, because it's Widevine L1. Google certification's real value is the open, self-serve Play Store and Google's own services (Assistant, Chromecast) — not the marquee apps.",
  acFaqQ8: "If I sell subscriptions or content, who handles the billing?",
  acFaqA8:
    "On AOSP, you do — through any payment gateway or partner you choose, with no platform commission and no Google in the loop. On certified Android TV, digital goods sold through a Play-distributed app have to use Google Play billing, and Google takes a cut of every transaction. For operators who monetize subscribers directly, that adds up fast — it's one of the bigger reasons they stay on AOSP.",
  acFaqQ9: "Who controls firmware (OTA) updates on each platform?",
  acFaqA9:
    "On AOSP, you do — we can build new firmware and push it across your whole fleet the next day, with no outside approval. On certified Android TV it's gated: the certification framework requires every system-level change to be re-verified by Google or a designated 3PL test lab before it can ship — even under Operator Tier. For operators who patch, tune or iterate often, that's a major practical difference.",
  acCtaEyebrow: "Talk to us",
  acCtaTitle: "Not sure if your launch needs certification?",
  acCtaBody:
    "Tell us what your subscribers expect and how fast you need to go live. We'll recommend the platform that fits — AOSP or certified — and deliver it.",
  acCtaPrimary: "Talk to our team",
  acCtaSecondary: "Request an AOSP sample",
  footerLinkGuidesOwnStb: "STB vs Smart TV",
  footerLinkGuidesBoxModels: "Subsidize, lease or sell",
  footerLinkGuidesMulticastOtt: "Multicast vs OTT",
  footerLinkGuidesBuildBuy: "Build vs buy",
  footerLinkGuidesStbChecklist: "STB buyer checklist",
  guidesCardSbcTitle: "STB Buyer's Checklist",
  guidesCardSbcDesc:
    "Before you buy set-top boxes, check the whole stack: hardware, codecs, networking, DRM, apps, fleet management, branding, warranty, and logistics.",
  guidesCardOsTitle: "Own STBs vs Smart TVs",
  guidesCardOsDesc:
    "Ship your own branded box or rely on subscribers' Smart TVs? The honest answer is both — but the box is the part you 100% own. The operator's case for shipping it.",
  guidesCardBmTitle: "Subsidize, lease or sell the box",
  guidesCardBmDesc:
    "Give the box away, rent it, or sell it outright? A financing decision, not a hardware one — the CapEx/OpEx and TCO trade-offs, plus the DMS locking that keeps subsidize and lease safe.",
  guidesCardMoTitle: "Multicast IPTV vs OTT streaming",
  guidesCardMoDesc:
    "One efficient stream to many on your managed network, or one adaptive stream per viewer over the internet? The honest trade-offs on bandwidth, quality, latency and reach — and why many operators run both.",
  guidesCardBbTitle: "Build vs buy your STB",
  guidesCardBbDesc:
    "Build your own set-top-box platform or buy a turnkey stack? “Building” means owning eight layers — silicon to support. An honest make-or-buy for operators, and when each side wins.",
  sbcSeoTitle: "IPTV STB Buyer's Checklist: How to Choose Set-Top Boxes | inext",
  sbcSeoDescription:
    "A practical STB buyer's checklist for ISPs, IPTV and OTT operators, telcos, hospitality providers, MDUs and distributors choosing set-top boxes for managed TV services.",
  sbcBreadcrumbPage: "STB Buyer's Checklist",
  sbcHeroEyebrow: "Buyer checklist",
  sbcHeroTitle: "STB Buyer's Checklist:",
  sbcHeroTitleAccent: "what to verify before choosing boxes",
  sbcHeroSub:
    "A good set-top box is not just a chipset and a price. It is the hardware, firmware, apps, content protection, remote control, fleet management, support and logistics that keep a TV service working after the first shipment lands.",
  sbcHeroNote:
    "Use this checklist before sample validation, vendor shortlisting or a bulk order. It is written for ISPs, IPTV and OTT operators, telcos, hospitality and MDU projects, and distributors evaluating boxes for operator clients.",
  sbcHeroCtaPrimary: "Talk to our team",
  sbcHeroCtaSecondary: "Open the checklist",
  sbcStat1: "Hardware + software stack",
  sbcStat2: "Sample before bulk order",
  sbcStat3: "Fleet management matters",
  sbcThesisEyebrow: "Start here",
  sbcThesisTitle: "Buy the service platform, not just the box",
  sbcThesisBody1:
    "A low-cost retail Android box can look attractive on a spreadsheet, but managed TV buyers need a device that can be branded, provisioned, locked, updated and supported across thousands of homes, hotel rooms or partner deployments.",
  sbcThesisBody2:
    "The right STB depends on the service model: managed IPTV on a private network, OTT-first streaming, hybrid IPTV and OTT, hospitality or MDU television, or distributor resale. The checklist is the same, but the weight of each item changes.",
  sbcThesisNoteTitle: "The practical rule",
  sbcThesisNoteBody:
    "If a requirement affects subscriber experience, content access, support cost or fleet control, verify it on a real sample before signing off the order.",
  sbcBuyerEyebrow: "Use cases",
  sbcBuyerTitle: "Match the box to the service you run",
  sbcBuyerIntro:
    "The same model can serve several projects, but the buying criteria are different. Start with the service, then choose the hardware tier.",
  sbcBuyer1Title: "Managed IPTV",
  sbcBuyer1Body:
    "Prioritize Ethernet, multicast support, stable firmware, a simple launcher, remote diagnostics and predictable decoding for live TV.",
  sbcBuyer2Title: "OTT-first TV",
  sbcBuyer2Body:
    "Prioritize app performance, DRM readiness, storage headroom, Wi-Fi behavior, adaptive streaming and a subscriber-friendly remote.",
  sbcBuyer3Title: "Hybrid IPTV and OTT",
  sbcBuyer3Body:
    "Check that one device can move between multicast live TV, unicast VOD, catch-up, portals and operator apps without confusing the viewer.",
  sbcBuyer4Title: "Hospitality and MDU",
  sbcBuyer4Body:
    "Look for locked-down UX, no personal-account dependency, centralized settings, bulk provisioning and easy replacement in the field.",
  sbcBuyer5Title: "Distributor evaluation",
  sbcBuyer5Body:
    "Validate packaging, accessory options, warranty process, localization, logistics and whether the vendor can support operator-specific builds.",
  sbcTableEyebrow: "The checklist",
  sbcTableTitle: "What to verify before buying STBs",
  sbcTableIntro:
    "Treat every row as a sample-test item, not a brochure claim. A good vendor should be able to prove the answer on real hardware.",
  sbcTableColCheck: "Check",
  sbcTableColWhy: "Why it matters",
  sbcTableColNote: "Buyer note",
  sbcRow1Check: "Chipset and platform maturity",
  sbcRow1Why:
    "The SoC defines decoding, DRM tier, driver stability, thermals and how long firmware can be maintained.",
  sbcRow1Note:
    "Ask what platform the vendor already ships at scale, not only what can be built as a one-off.",
  sbcRow2Check: "RAM and storage",
  sbcRow2Why:
    "Too little memory makes launchers and OTT apps feel slow; too little storage limits apps, logs and updates.",
  sbcRow2Note: "Lean IPTV can run lighter. App-heavy Android deployments need more headroom.",
  sbcRow3Check: "Video, audio and 4K requirements",
  sbcRow3Why:
    "Codec, HDR, resolution and audio support decide whether the service plays smoothly on the TVs subscribers actually use.",
  sbcRow3Note: "Test real live channels and VOD assets, not only demo clips.",
  sbcRow4Check: "Ethernet and multicast behavior",
  sbcRow4Why:
    "Managed IPTV and hospitality networks often depend on wired Ethernet, IGMP and stable multicast playback.",
  sbcRow4Note: "If multicast matters, test it on the target switch and network design.",
  sbcRow5Check: "Wi-Fi and off-net OTT",
  sbcRow5Why:
    "OTT, secondary rooms and many residential installs rely on Wi-Fi quality, roaming behavior and adaptive streaming.",
  sbcRow5Note: "Test weak-signal rooms and congested apartments, not only a clean lab.",
  sbcRow6Check: "DRM and CAS readiness",
  sbcRow6Why:
    "Premium content needs the right DRM level, key provisioning, partner integration and sometimes CAS support.",
  sbcRow6Note:
    "Confirm the actual content path: Widevine, Verimatrix, portal app, operator agreement and factory provisioning.",
  sbcRow7Check: "Operating system and app strategy",
  sbcRow7Why:
    "AOSP, certified Android TV and Linux each change app availability, certification cost, update control and launch speed.",
  sbcRow7Note:
    "Choose the OS around the apps and control model, not around a generic platform preference.",
  sbcRow8Check: "Device management and OTA",
  sbcRow8Why:
    "Without remote provisioning, diagnostics, staged updates and locking, every field issue becomes expensive.",
  sbcRow8Note: "Ask to see the DMS workflow before approving the device.",
  sbcRow9Check: "Remote control and daily UX",
  sbcRow9Why:
    "The remote, launcher, boot flow and settings screens shape the subscriber's daily experience more than a spec sheet does.",
  sbcRow9Note:
    "Test with non-technical users and check button layout, IR/Bluetooth behavior and localization.",
  sbcRow10Check: "Branding, packaging and accessories",
  sbcRow10Why:
    "The box, remote, power supply, HDMI cable, labels and quick-start guide all affect support and perceived quality.",
  sbcRow10Note:
    "Confirm plugs, languages, labels, carton layout and spare accessory availability early.",
  sbcRow11Check: "Warranty, spares and logistics",
  sbcRow11Why:
    "Bulk hardware is an operations program: lead times, RMA, spare units and shipment routing matter after launch.",
  sbcRow11Note: "Separate evaluation-sample shipping from production-order logistics.",
  sbcRow12Check: "Vendor support and lifecycle",
  sbcRow12Why:
    "A box that works today still needs firmware, app updates, security fixes and replacement planning later.",
  sbcRow12Note: "Prefer vendors that can explain the support path for the whole device life.",
  sbcTableNote:
    "The best choice is usually the device that removes the most launch and support risk, not the one with the longest spec list.",
  sbcModelEyebrow: "Model fit",
  sbcModelTitle: "A practical way to size the inext lineup",
  sbcModelIntro:
    "These are not hard rules. They are a starting point for matching service complexity to hardware headroom before sample testing.",
  sbcModelTv5Body:
    "A lean choice for controlled IPTV deployments, simple launchers and cost-sensitive rollouts where the app stack is light.",
  sbcModelTv5Meta: "Lean IPTV",
  sbcModelTv5UltraBody:
    "More room for branded Android experiences, extra apps and mainstream operator deployments that need a balanced price point.",
  sbcModelTv5UltraMeta: "Balanced Android",
  sbcModelTv6Body:
    "A strong fit for modern hybrid IPTV and OTT services with more UI, app and update headroom.",
  sbcModelTv6Meta: "Mainstream hybrid",
  sbcModelTv6UltraBody:
    "The premium option for heavier app stacks, longer lifecycle headroom and flagship managed-TV deployments.",
  sbcModelTv6UltraMeta: "Premium stack",
  sbcModelCta: "Compare all STB models",
  sbcRedFlagsEyebrow: "Red flags",
  sbcRedFlagsTitle: "Warning signs before a bulk order",
  sbcRedFlagsIntro:
    "Most STB problems are visible during evaluation if the buyer tests the right things.",
  sbcRedFlag1:
    "The vendor offers a retail Android box with no operator firmware, launcher control or fleet management.",
  sbcRedFlag2:
    "DRM, CAS or premium-app support is described vaguely, without a clear provisioning and agreement path.",
  sbcRedFlag3:
    "OTA updates are manual, all-at-once or depend on subscribers doing the right thing.",
  sbcRedFlag4: "There is no way to lock, suspend, reconfigure or diagnose devices remotely.",
  sbcRedFlag5:
    "Ethernet, multicast or Wi-Fi behavior is promised but not demonstrated on the target network.",
  sbcRedFlag6: "Packaging, accessories, plugs, labels or manuals are treated as afterthoughts.",
  sbcRedFlag7:
    "The supplier cannot explain warranty handling, spare units, firmware lifecycle or production logistics.",
  sbcSampleEyebrow: "Sample validation",
  sbcSampleTitle: "What to test on the sample box",
  sbcSampleIntro:
    "A sample is not a souvenir. It is the proof that the device can become a managed fleet.",
  sbcSample1: "Cold boot into the branded launcher and confirm the first-screen experience.",
  sbcSample2: "Play live IPTV, OTT streams, VOD and catch-up from the real service sources.",
  sbcSample3: "Test multicast or portal behavior on the target network, not only in a lab.",
  sbcSample4: "Verify DRM-protected content and any premium apps that the service requires.",
  sbcSample5: "Push an app or firmware update through the management system.",
  sbcSample6: "Confirm the device appears in DMS with diagnostics, groups and remote actions.",
  sbcSample7: "Try suspend, net-lock or kiosk/app-lock behavior if the commercial model needs it.",
  sbcSample8:
    "Check remote-control feel, button mapping, pairing and support calls a subscriber might make.",
  sbcSample9: "Run the box long enough to catch heat, reboot, Wi-Fi or memory issues.",
  sbcSample10: "Review packaging, plugs, labels, accessories and localized quick-start materials.",
  sbcFitEyebrow: "Where inext fits",
  sbcFitTitle: "We help validate the whole stack",
  sbcFitBody:
    "inext supplies the hardware, firmware, launcher, IPTV app, Alcatraz DMS, OTA, branding and worldwide B2B logistics as one managed STB stack. That means the same vendor can answer the hardware question, the software question and the rollout question before a bulk order.",
  sbcFitCtaDms: "See Alcatraz DMS",
  sbcFitCtaLogistics: "See logistics",
  sbcFaqEyebrow: "FAQ",
  sbcFaqTitle: "Common questions",
  sbcFaqQ1: "Is this only for IPTV operators?",
  sbcFaqA1:
    "No. The checklist is for any organization evaluating managed TV devices: ISPs, IPTV and OTT operators, telcos, hospitality and MDU projects, and distributors buying for operator customers.",
  sbcFaqQ2: "Should I choose Android, AOSP, certified Android TV or Linux?",
  sbcFaqA2:
    "Choose around the service. Android or AOSP fits app-rich and OTT-heavy deployments, certified Android TV fits projects that specifically need Google's certified ecosystem, and Linux can be right for controlled IPTV-only deployments. The important part is matching OS, apps, certification and update control.",
  sbcFaqQ3: "How much RAM and storage do I need?",
  sbcFaqA3:
    "Lean IPTV can use a lighter box. A modern Android experience with several apps, richer UI and longer lifecycle needs more headroom. The safest answer is to test the actual launcher, apps and update package on the candidate model.",
  sbcFaqQ4: "Is Ethernet still important if OTT works over Wi-Fi?",
  sbcFaqA4:
    "Yes. OTT can run over Wi-Fi, but managed IPTV, multicast and many hospitality or MDU networks still depend on wired Ethernet for predictable service quality.",
  sbcFaqQ5: "Can one STB handle both IPTV and OTT?",
  sbcFaqA5:
    "Yes, if the hardware, firmware and app are built for both. The buyer should test live multicast or portal TV, OTT streams, VOD and catch-up on the same sample before committing.",
  sbcFaqQ6: "When should I request an evaluation sample?",
  sbcFaqA6:
    "Before commercial approval. A sample should be tested with the real portal, content, network, DRM path, launcher, remote, DMS workflow and packaging expectations.",
  sbcFaqQ7: "What should distributors check differently?",
  sbcFaqA7:
    "Distributors should verify not only the device, but also repeatable packaging, accessory options, regional plugs, warranty handling, localization, lead times and whether the vendor can support operator-specific builds.",
  sbcCtaEyebrow: "Talk to us",
  sbcCtaTitle: "Validate the box before the rollout",
  sbcCtaBody:
    "Tell us your service model, network, app requirements and target price tier. We'll help choose the right inext STB, customize a sample and prove the stack before a production order.",
  sbcCtaPrimary: "Talk to our team",
  sbcCtaSecondary: "Request a sample",
  osSeoTitle: "Own STBs vs Smart TVs: Why Operators Ship Their Own Box | inext",
  osSeoDescription:
    "Should an operator ship branded set-top boxes or rely on subscribers' Smart TVs? The honest answer is both — but your own STB is the part you fully own and control. The operator's case for the box.",
  osBreadcrumbPage: "Own STBs vs Smart TVs",
  osHeroEyebrow: "Strategy guide",
  osHeroTitle: "Your own STBs vs. subscribers' Smart TVs:",
  osHeroTitleAccent: "why you want both",
  osHeroSub:
    "Most subscribers already own a Smart TV, so it's tempting to skip the hardware and just ship an app. For a serious operator the honest answer is to do both — Smart TV and mobile apps for reach, and your own branded STB as the controlled core. The difference is ownership: the box is the one platform you fully control, at your pace, with no third party able to change the rules on you.",
  osHeroNote:
    "The branded box — and the app that runs on it — is what we build, and the part you own outright. This page makes the case for it.",
  osHeroCtaPrimary: "Talk to our team",
  osHeroCtaSecondary: "See what you control",
  osStat1: "Your brand on the box and remote",
  osStat2: "100% control — at your pace",
  osStat3: "Any TV, any room",
  osThesisEyebrow: "Start here",
  osThesisTitle: "Own the core, reach everywhere",
  osThesisBody1:
    "This isn't hardware versus apps — it's about what you own. Smart TV, mobile and web apps put your service on screens subscribers already have. They matter for reach, and you should ship them. But on those platforms you're a tenant: the device, the home screen, the rules and the data belong to Samsung, LG, Google or Apple.",
  osThesisBody2:
    "Your own STB is the exception. It's the one device that's entirely yours — your launcher on boot, your update schedule, your DRM, your data, your billing. It's where you guarantee the experience and anchor the subscriber relationship. The winning setup pairs a controlled, branded box at the core with apps everywhere else for reach.",
  osThesisCoreLabel: "Owned core",
  osThesisCoreValue: "Your branded STB",
  osThesisReachLabel: "Reach (you're a guest)",
  osThesisReachValue: "Smart TV · mobile · web apps",
  osOwnRentEyebrow: "Own vs. rent",
  osOwnRentTitle: "On your box you set the rules. On a Smart TV, someone else does.",
  osOwnColTitle: "On your own STB, you control",
  osOwnItem1: "The home screen — your launcher leads on boot",
  osOwnItem2: "Updates and new features — on your schedule",
  osOwnItem3: "DRM, security and premium-app integration",
  osOwnItem4: "Billing, ads and upsell space — no platform cut",
  osOwnItem5: "Device telemetry and viewing data — it's yours",
  osOwnItem6: "How long the device stays supported",
  osRentColTitle: "On a subscriber's Smart TV, the vendor controls",
  osRentItem1: "The home screen — your app is one icon among many",
  osRentItem2: "App-store review and OS updates — on their timeline",
  osRentItem3: "Which DRM levels and codecs the TV supports",
  osRentItem4: "Store fees and terms — they can raise them anytime",
  osRentItem5: "The platform data — you get app-level scraps",
  osRentItem6: "When old models lose support and your app stops working",
  osBenefitsEyebrow: "The case for the box",
  osBenefitsTitle: "What shipping your own STB gets you",
  osBenefit1Title: "Your brand, every day",
  osBenefit1Body:
    "Your launcher is the first screen on the TV, and your logo is on the box and the remote your subscriber holds every evening. That daily, physical brand presence builds attachment, keeps you top of mind, and makes switching feel like a bigger deal.",
  osBenefit2Title: "Platform sovereignty",
  osBenefit2Body:
    "No third party can change the rules on you. Samsung, LG or Google can redesign their home screen, promote a rival, raise fees or drop support for old TVs — and on their platforms you can't stop any of it. On your box, every one of those is your call.",
  osBenefit3Title: "Remote management, lower support",
  osBenefit3Body:
    "With Alcatraz DMS and TR-069 you monitor, diagnose, configure, update and reboot boxes remotely — fewer truck rolls, faster fixes. A subscriber's Smart TV is a black box: every issue becomes ‘is it your TV, your network, or our app?’",
  osBenefit4Title: "QoE you can guarantee",
  osBenefit4Body:
    "You fix the chipset, codecs, 4K and Wi-Fi, so the service performs the same for everyone. On an old or cheap Smart TV your stream stutters or won't decode — and you get blamed for hardware you don't control.",
  osBenefit5Title: "Ship features first",
  osBenefit5Body:
    "A new codec, catch-up, cloud DVR or a UI refresh reaches your whole fleet immediately. On Smart TVs you wait on each platform's support and re-certification, and old sets never get it at all.",
  osBenefit6Title: "Reach every TV and every room",
  osBenefit6Body:
    "A box turns any HDMI TV — old sets, bedrooms, the kitchen, a holiday home — into your platform. Smart-TV-only quietly excludes those screens, and the subscribers who don't have a Smart TV at all.",
  osBenefit7Title: "Keep what you sell",
  osBenefit7Body:
    "On your STB you run your own billing and your own ads and upsell space, with no store taking a cut — and you keep the viewing and device data to act on, instead of handing it to the TV vendor.",
  osBenefit8Title: "Open B2B and hospitality",
  osBenefit8Body:
    "Hotels, apartment blocks, hospitals and bars need centrally managed, locked-down devices with no personal logins — something app-only can't deliver. Your STB opens those markets.",
  osBenefit9Title: "Value on your network",
  osBenefit9Body:
    "A managed STB is an asset on your network, not just in the living room: efficient multicast/managed delivery keeps video on-net — lighter on bandwidth and transit than OTT pulled over the public internet — and as a managed endpoint it gives you QoE visibility right at the edge. For an ISP, it also ties TV to broadband and lifts ARPU.",
  osScenarioTitle: "A Tuesday on someone else's platform",
  osScenarioBody:
    "Picture it: on Tuesday, a TV vendor redesigns its home screen, buries your app behind a banner and starts promoting a competing service across your region. On Smart TVs there's nothing you can do about it — it's their home screen, their call, and no support ticket from an operator changes a vendor's marketing. On your own STBs, nothing changes: the home screen is still yours, because the device is. That's the difference between renting a slot and owning the platform.",
  osHiddenEyebrow: "The honest trade-off",
  osHiddenTitle: "Smart-TV-only looks cheaper than it is",
  osHiddenBody:
    "Skipping the box saves hardware and logistics up front — that's real, and for a pure OTT or D2C play it can be the right call. But ‘free’ Smart TVs carry costs you pay later:",
  osHidden1: "A support black box — you can't see or fix the device, so every issue is guesswork",
  osHidden2:
    "QoE you get blamed for — old, cheap TVs make your service look bad on hardware you don't own",
  osHidden3:
    "A fragmentation tax — building and certifying apps for Tizen, webOS, Android TV, Fire TV, Apple TV and more, each with its own quirks and DRM",
  osHidden4:
    "Platform risk — fees, policies, ads and OS support all change on the vendor's terms, not yours",
  osSameEyebrow: "Where we fit",
  osSameTitle: "We build the box you own",
  osSameBody:
    "We won't talk you out of Smart TV and mobile apps — ship them, you need the reach. What we build is the part you own outright: your branded STB. Your operator-tier launcher on boot, your IPTV app, your services preloaded, and the whole fleet managed end to end with Alcatraz DMS, OTA and TR-069. The apps extend you onto screens you don't control; the box is home base — fully yours, run at your pace.",
  osSameNoteTitle: "It's the cheapest control you'll buy",
  osSameNoteBody:
    "A box is a small line item next to the churn, support load and platform risk it removes. We help you spec the right one, brand it down to the remote, and get a working sample in your hands in 1–2 weeks.",
  osFaqEyebrow: "FAQ",
  osFaqTitle: "Common questions",
  osFaqQ1: "Most of my subscribers already have a Smart TV — why ship a box at all?",
  osFaqA1:
    "Because the Smart TV is theirs and the vendor's, not yours. The box is where you control the experience, brand it, manage and support it remotely, guarantee performance, and keep your billing and data. Ship apps to Smart TVs for reach — but the box is your anchor, and it also covers the second TVs and the subscribers that aren't smart.",
  osFaqQ2: "Isn't shipping hardware too expensive?",
  osFaqA2:
    "A box is roughly $30–50, spread over the subscriber's lifetime — small next to what it saves. Remote management cuts support costs and truck rolls, the branded device reduces churn, and you keep billing revenue no store can take a cut of. For most operators it pays for itself; we'll help you model it.",
  osFaqQ3: "Can I start app-only and add STBs later?",
  osFaqA3:
    "Yes — many do. But the operators who own the relationship lead with the box for their core subscribers and use apps for reach. If you start app-only, plan the STB in early: it's what turns a content app into a controlled, branded service.",
  osFaqQ4: "What about hotels, apartment blocks and other B2B?",
  osFaqA4:
    "That's STB territory. Hospitality and MDU deployments need centrally managed, locked-down devices with no personal logins — exactly what a managed STB delivers and an app on a guest's own TV can't.",
  osFaqQ5: "Do I lose anything by shipping a box?",
  osFaqA5:
    "You take on hardware cost and logistics — real, but we handle the manufacturing, branding and worldwide delivery, and customize a working sample in 1–2 weeks. In return you get control, brand presence, lower support and a stickier subscriber. For a managed-service operator, that trade is usually worth it.",
  osFaqQ6: "Does the box lock me into one app or service?",
  osFaqA6:
    "No — it's your platform. You choose the launcher, the apps, the services and the update cadence. That's the whole point: on your STB, the roadmap is yours, not a TV vendor's.",
  osCtaEyebrow: "Talk to us",
  osCtaTitle: "Own the screen your subscribers watch most",
  osCtaBody:
    "Tell us about your service and your fleet. We'll spec a branded STB, customize it to your brand, and get a working sample into your hands — fast.",
  osCtaPrimary: "Talk to our team",
  osCtaSecondary: "Request a sample",
  bmSeoTitle: "Subsidize, Lease or Sell the STB? CapEx vs OpEx for Operators | inext",
  bmSeoDescription:
    "Give the box away, rent it, or sell it outright? It's a financing decision, not a hardware one. The CapEx/OpEx and TCO trade-offs of subsidizing, leasing and selling set-top boxes — and the DMS locking that keeps subsidize and lease safe.",
  bmBreadcrumbPage: "Subsidize, lease or sell",
  bmHeroEyebrow: "Commercial guide",
  bmHeroTitle: "Subsidize, lease or sell your STBs:",
  bmHeroTitleAccent: "it's a financing decision",
  bmHeroSub:
    "The same managed box can reach a subscriber three ways — given to them, rented to them, or sold to them. What changes isn't the hardware; it's who funds it, who owns it, and how you earn it back. Pick the wrong model for a segment and you either leave money on the table or carry risk you can't see. Most operators don't pick one at all — they run two or three at once.",
  bmHeroNote:
    "The same inext STB serves all three, and Alcatraz DMS locking is what makes giving or renting a box safe. This is the operator's playbook for choosing — and mixing — them.",
  bmHeroCtaPrimary: "Talk to our team",
  bmHeroCtaSecondary: "See how locking helps",
  bmStat1: "One box, three models",
  bmStat2: "CapEx or OpEx — your call",
  bmStat3: "Locking keeps it safe",
  bmThesisEyebrow: "Start here",
  bmThesisTitle: "It's a financing decision, not a hardware one",
  bmThesisBody1:
    "A set-top box is often the single largest hardware line in an operator's budget, and it grows with every subscriber you add. So how the box reaches the home isn't a logistics detail: it sets your cash flow, what sits on your balance sheet, and how hard it is for a subscriber to leave. The box itself is identical in all three models. The decision is purely financial.",
  bmThesisBody2:
    "And it's rarely one decision. The same operator can subsidize boxes to win premium and triple-play subscribers, lease to the mainstream base, and sell outright to prepaid, B2B or second-TV customers — then move subscribers between models over time. The real question isn't “which model,” it's “which model for which subscriber, and how do I keep it safe?”",
  bmThesisCoreLabel: "One asset",
  bmThesisCoreValue: "Your managed STB",
  bmThesisReachLabel: "Three commercial models",
  bmThesisReachValue: "Subsidize · Lease · Sell",
  bmModelsEyebrow: "The three models",
  bmModelsTitle: "Three ways to put a box in the home",
  bmModelLabelUpfront: "Up front",
  bmModelLabelOwns: "Who owns it",
  bmModelLabelRevenue: "How you earn",
  bmModelLabelBest: "Best for",
  bmModel1Name: "Subsidize",
  bmModel1Tagline: "Give the box, win the subscriber.",
  bmModel1Upfront: "You fund it up front — CapEx on day one.",
  bmModel1Owns: "Usually the subscriber, after a minimum term.",
  bmModel1Revenue: "Earned back through the subscription over the contract.",
  bmModel1Best: "Competitive acquisition, premium and triple-play bundles.",
  bmModel2Name: "Lease / rent",
  bmModel2Tagline: "Keep the asset, bill it monthly.",
  bmModel2Upfront: "You fund it, but it stays your asset.",
  bmModel2Owns: "You do — for the life of the device.",
  bmModel2Revenue: "A recurring rental line; reclaim and redeploy on return.",
  bmModel2Best: "Recurring revenue, low friction, hardware you reuse.",
  bmModel3Name: "Sell",
  bmModel3Tagline: "Cash now, nothing to carry.",
  bmModel3Upfront: "The subscriber pays — outright or in instalments.",
  bmModel3Owns: "The subscriber, from day one.",
  bmModel3Revenue: "One-time hardware revenue; no asset to depreciate.",
  bmModel3Best: "Prepaid, second TVs, B2B, a lighter balance sheet.",
  bmTableEyebrow: "Side by side",
  bmTableTitle: "How the three compare",
  bmTableColDimension: "",
  bmTableColSubsidize: "Subsidize",
  bmTableColLease: "Lease",
  bmTableColSell: "Sell",
  bmRow1Label: "Up-front cost",
  bmRow1Sub: "Operator (CapEx)",
  bmRow1Lease: "Operator (CapEx, retained)",
  bmRow1Sell: "Subscriber",
  bmRow2Label: "On your books",
  bmRow2Sub: "Asset, then written down",
  bmRow2Lease: "Asset, depreciated over its life",
  bmRow2Sell: "Nothing — it's sold",
  bmRow3Label: "Cash flow",
  bmRow3Sub: "Out now, back over the term",
  bmRow3Lease: "Out now, recurring back",
  bmRow3Sell: "In now",
  bmRow4Label: "Recurring revenue",
  bmRow4Sub: "Inside the subscription",
  bmRow4Lease: "A separate rental line",
  bmRow4Sell: "None on the hardware",
  bmRow5Label: "Subscriber friction",
  bmRow5Sub: "Lowest — it's free",
  bmRow5Lease: "Low — a small monthly",
  bmRow5Sell: "Highest — pays up front",
  bmRow6Label: "Lock-in",
  bmRow6Sub: "The contract term",
  bmRow6Lease: "Return it to leave",
  bmRow6Sell: "Lowest — they own it",
  bmRow7Label: "If they leave early",
  bmRow7Sub: "Unrecovered subsidy",
  bmRow7Lease: "Reclaim & redeploy",
  bmRow7Sell: "Already paid — no exposure",
  bmTableSafeLabel: "What keeps it safe",
  bmTableSafeValue: "Alcatraz DMS — net-lock · app-lock · remote suspend · OTA reclaim",
  bmTableNote: "The box is the same in every column — only the money and the ownership move.",
  bmTcoEyebrow: "The numbers, roughly",
  bmTcoTitle: "Same box, three cash-flow shapes",
  bmTcoBody:
    "The model doesn't change what a box costs — it changes when the money moves. Take one managed box and follow the cash:",
  bmTco1Title: "Subsidize",
  bmTco1Body:
    "You spend the box cost on day one and earn it back through the subscription. Payback is roughly box cost ÷ monthly margin; keep the subscriber past that point and the rest is profit. Lose them before it and the unrecovered part is your loss — which is exactly what a minimum term and remote locking are there to protect.",
  bmTco2Title: "Lease",
  bmTco2Body:
    "You still fund the box, but a monthly rental turns it into an annuity that can out-earn its cost over the device's life. Because you keep ownership, a returned unit is wiped, re-provisioned and reissued — so one box can serve several subscribers before it retires.",
  bmTco3Title: "Sell",
  bmTco3Body:
    "The subscriber funds the hardware, so nothing sits on your balance sheet and no working capital is tied up. You trade some lock-in for cash today and a lighter operation — often the right call for prepaid or B2B.",
  bmTcoNote:
    "Illustrative, not a quote — your real answer turns on box cost, margin, retention and reuse. We'll help you put your own numbers through it.",
  bmLockEyebrow: "What makes it safe",
  bmLockTitle: "Control in software, not on trust",
  bmLockBody:
    "The risk in subsidizing or leasing is simple: a subscriber stops paying, or the box never comes back. Alcatraz DMS turns that risk into a setting. Net-lock and app-lock bind every device to your service — so off your network it has no resale value, and it can't be turned into a generic Android box. That's what makes handing out or lending hardware a deliberate, safe decision instead of a gamble.",
  bmLock1Title: "Net-lock the device",
  bmLock1Body:
    "A subsidized or leased box is bound to your service. Off your network it simply won't activate — so there's no resale value and no reason to walk off with it.",
  bmLock2Title: "App-lock and kiosk mode",
  bmLock2Body:
    "The box runs your launcher and your apps — not an open Android desktop. A subsidized device can't be repurposed, and your brand stays on the screen.",
  bmLock3Title: "Suspend and restore remotely",
  bmLock3Body:
    "Missed payment? Soft-lock the box from the dashboard and bring it back the moment they pay — dunning without a single truck roll.",
  bmLock4Title: "Reclaim and redeploy",
  bmLock4Body:
    "A returned lease unit is wiped and re-provisioned over the air, then reissued to the next subscriber — the reuse that makes lease economics actually work.",
  bmLockNote:
    "This is why the model is a software choice. One fleet can be subsidized, leased and sold at the same time — each device held to its own terms, and moved between them without ever touching the hardware.",
  bmMixEyebrow: "In practice",
  bmMixTitle: "Most operators run more than one",
  bmMixBody:
    "Match the model to the subscriber, not to the company. A pattern we see again and again across our clients:",
  bmMix1:
    "Acquisition and premium → subsidize. Drop the upfront barrier to win competitive and triple-play subscribers; the contract and locking protect the giveaway.",
  bmMix2:
    "Mainstream base → lease. A small monthly line keeps friction low and the asset yours, with reclaim-and-reuse when subscribers churn.",
  bmMix3:
    "Prepaid, second TVs and B2B → sell. Take the cash up front where lock-in matters less and a light balance sheet matters more.",
  bmMix4:
    "Over time → convert. The same box lets you subsidize to acquire, then move a subscriber to owned — no new hardware, just a change of terms.",
  bmFitEyebrow: "Where we fit",
  bmFitTitle: "One fleet. Any model. Switch anytime.",
  bmFitBody:
    "We ship the managed STB and Alcatraz DMS; you choose the commercial model — or several — and we make each one safe to run. Net-lock, app-lock, remote suspend and OTA reclaim are built in, so subsidizing and leasing aren't a leap of faith, and you can change the mix as your market shifts without re-flashing or re-buying. We won't push one model on you — we make all three work on the same box.",
  bmFitNoteTitle: "Model it with us",
  bmFitNoteBody:
    "Tell us your margins and retention — we'll bring the box cost and compare subsidize, lease and sell on real numbers, then set the locking that protects whichever you choose.",
  bmFaqEyebrow: "FAQ",
  bmFaqTitle: "Common questions",
  bmFaqQ1: "Which model is best?",
  bmFaqA1:
    "There's no universal winner — it depends on your market, your cash position and how much lock-in you need. Most operators mix: subsidize to acquire, lease the base, and sell where lock-in matters less. The advantage of a managed box is that you don't have to pick just one.",
  bmFaqQ2: "Can I really run all three at once?",
  bmFaqA2:
    "Yes — many of our clients do. Because the model is enforced in software through Alcatraz DMS, one fleet can hold subsidized, leased and sold devices side by side, each on its own terms.",
  bmFaqQ3: "What stops a subsidized or leased box from being resold or repurposed?",
  bmFaqA3:
    "Net-lock and app-lock. Off your network the box won't activate, so it has no resale value; and it only runs your service, so it can't become a generic Android box. That's what makes giving or lending hardware safe.",
  bmFaqQ4: "What happens when a subscriber stops paying?",
  bmFaqA4:
    "You soft-lock the device remotely and restore it the instant they pay — no truck roll. For a lease, a box that's never returned stays locked and worthless off-network; one that comes back is wiped and reissued.",
  bmFaqQ5: "How does leasing sit on my balance sheet?",
  bmFaqA5:
    "Under a typical operating lease you keep the box as an asset and depreciate it over its useful life while booking the rental as recurring revenue — the classic shift from CapEx to a recurring line. Confirm the exact treatment with your finance team; we'll supply the device-life and reuse inputs.",
  bmFaqQ6: "Can I move a subscriber from one model to another later?",
  bmFaqA6:
    "Yes. Since every model runs on the same box, you can subsidize to acquire and later convert the subscriber to owned, or turn a rental into a sale — all in software, no new hardware.",
  bmCtaEyebrow: "Talk to us",
  bmCtaTitle: "Pick the model that fits — we'll make it safe",
  bmCtaBody:
    "Tell us your margins, your churn and what you'd charge a subscriber — we'll bring the box cost and help you weigh subsidize, lease and sell on real numbers, then set the Alcatraz DMS locking that protects whichever you choose.",
  bmCtaPrimary: "Talk to our team",
  bmCtaSecondary: "Request a sample",
  moSeoTitle: "Multicast IPTV vs OTT Streaming: Delivery Architecture for Operators | inext",
  moSeoDescription:
    "Multicast IPTV or OTT unicast — how should an operator deliver live TV? One efficient stream to many on a managed network, or one adaptive stream per viewer over the internet. The honest trade-offs on bandwidth, quality, latency and reach — and why many operators run both.",
  moBreadcrumbPage: "Multicast IPTV vs OTT",
  moHeroEyebrow: "Delivery-architecture guide",
  moHeroTitle: "Multicast IPTV vs OTT streaming:",
  moHeroTitleAccent: "why you'll run both",
  moHeroSub:
    "There are two ways to put live TV on a screen: send one stream to many viewers across your own managed network (multicast IPTV), or send a separate adaptive stream to each viewer over the public internet (OTT unicast). New deployments increasingly build on OTT — it reaches any network and any device. But the many managed networks already running multicast keep it for good reason: for live at scale, nothing matches its efficiency, near-zero latency and guaranteed quality. The two aren't rivals — many operators pair them: multicast for live, unicast for the rest.",
  moHeroNote:
    "inext STBs and our IPTV app speak both — multicast on your managed network, OTT over the internet, on the same box. We support both because our clients use both.",
  moHeroCtaPrimary: "Talk to our team",
  moHeroCtaSecondary: "See how the box does both",
  moStat1: "One stream → many (multicast)",
  moStat2: "Any network, any device (OTT)",
  moStat3: "Hybrid: one box, both",
  moThesisEyebrow: "Start here",
  moThesisTitle: "It's about the network, not just the stream",
  moThesisBody1:
    "The real difference isn't picture quality in the abstract — it's where the video travels. Multicast sends a single copy of each live channel through your managed network, and everyone tuned in shares it: 50,000 subscribers on one channel cost the same bandwidth as one. OTT instead opens a separate unicast stream for every viewer over the public internet, adapting the bitrate to each connection. One is built for efficiency and control on a network you own; the other for reach and flexibility on networks you don't.",
  moThesisBody2:
    "Honestly, for a greenfield build OTT is now the default — most new deployments are unicast, and pure multicast IPTV is widely treated as legacy. But “legacy” doesn't mean bad: where a managed network already carries multicast, it delivers picture quality, near-zero latency and network efficiency that unicast still can't match for live at scale — so there's rarely a good reason to tear it down. That's why multicast stays widely deployed, usually in a hybrid: multicast for live linear, unicast for VOD, catch-up and time-shift. Each job on the transport that does it best.",
  moThesisCoreLabel: "Managed network, one-to-many",
  moThesisCoreValue: "Multicast IPTV",
  moThesisReachLabel: "Public internet, one-to-one",
  moThesisReachValue: "OTT unicast",
  moDefineEyebrow: "How each works",
  moDefineTitle: "Two transports for live video",
  moMcastColTitle: "Multicast IPTV",
  moMcastColSub: "One stream, shared by every viewer, on your managed network",
  moMcast1: "One copy of each channel travels the network; viewers join it via IGMP",
  moMcast2: "Bandwidth stays flat no matter how many tune in",
  moMcast3: "Fixed bitrate and prioritized traffic — guaranteed, buffer-free quality",
  moMcast4: "Sub-second latency — ideal for live sports and national events",
  moMcast5:
    "Runs on a managed, multicast-enabled network over wired Ethernet — Wi-Fi can't carry it reliably",
  moMcast6: "Built for live linear; VOD and personalization still ride unicast",
  moOttColTitle: "OTT unicast",
  moOttColSub: "A separate adaptive stream per viewer, over the public internet",
  moOtt1: "Each viewer gets their own stream from a CDN",
  moOtt2: "Adaptive bitrate (HLS/DASH) flexes to each connection's speed",
  moOtt3: "Reaches any network and any device — phones, laptops, Smart TVs, off-net",
  moOtt4: "Best-effort quality; latency is higher (low-latency HLS/DASH now ~2–5s)",
  moOtt5: "Bandwidth and CDN cost scale with every concurrent viewer",
  moOtt6: "Carries VOD, catch-up, nPVR and personalization natively",
  moTableEyebrow: "Side by side",
  moTableTitle: "How the two compare",
  moTableColDimension: "",
  moTableColMcast: "Multicast IPTV",
  moTableColOtt: "OTT unicast",
  moRow1Label: "Bandwidth at scale",
  moRow1Mcast: "Flat — one stream serves all",
  moRow1Ott: "Linear — one stream per viewer",
  moRow2Label: "Network needed",
  moRow2Mcast: "Your managed network only",
  moRow2Ott: "Any network, public internet",
  moRow3Label: "Reach",
  moRow3Mcast: "On-net set-top boxes",
  moRow3Ott: "Any device, anywhere",
  moRow4Label: "Quality",
  moRow4Mcast: "Guaranteed, fixed bitrate",
  moRow4Ott: "Best-effort, adaptive",
  moRow5Label: "Live latency",
  moRow5Mcast: "Sub-second",
  moRow5Ott: "~2–5s low-latency, up to 10–30s",
  moRow6Label: "Best for",
  moRow6Mcast: "Live linear, sports, big channels",
  moRow6Ott: "VOD, catch-up, mobile, off-net",
  moRow7Label: "VOD & personalization",
  moRow7Mcast: "Needs unicast",
  moRow7Ott: "Native",
  moRow8Label: "Cost shape",
  moRow8Mcast: "Network setup; flat at scale",
  moRow8Ott: "CDN / egress; grows with viewers",
  moRow9Label: "QoS control",
  moRow9Mcast: "Full — you own the network",
  moRow9Ott: "Limited — best-effort",
  moRow10Label: "Connection",
  moRow10Mcast: "Wired Ethernet — not Wi-Fi",
  moRow10Ott: "Any link, Wi-Fi included",
  moTableInextLabel: "On inext boxes",
  moTableInextValue: "One IPTV app plays both — multicast on-net, OTT off-net",
  moTableNote:
    "Most platforms put live linear on multicast where the managed network allows, and everything else on unicast.",
  moScaleEyebrow: "The efficiency gap",
  moScaleTitle: "Why multicast still wins the big live moment",
  moScaleBody:
    "Picture a national final on one channel, 50 000 subscribers watching at once. Over multicast that's a single stream on your network — the load is the same as one viewer. Over unicast it's 50 000 separate streams, and your CDN and egress scale with every one. This is the core reason so many multicast networks are kept in service: for high-concurrency live, the bigger the audience, the bigger the saving — in bandwidth, in cost, and in the near-zero latency a managed network delivers.",
  moFitListEyebrow: "When to use which",
  moFitListTitle: "Put each job on the transport that does it best",
  moFit1:
    "Live linear at scale on your managed network → multicast. Sports and big channels get sub-second latency, guaranteed quality and flat bandwidth.",
  moFit2:
    "VOD, catch-up, time-shift, nPVR and personalized channels → unicast. They're per-viewer by nature, so OTT is the natural fit.",
  moFit3:
    "Mobile, travel, secondary screens and off-net subscribers → OTT. It reaches any network and any device with no multicast infrastructure.",
  moFit4:
    "Markets that demand guaranteed quality → multicast still leads, and that's a valid, well-respected choice — not a legacy one.",
  moBothEyebrow: "Where we fit",
  moBothTitle: "One box, both transports",
  moBothBody:
    "You don't have to choose at the device. inext set-top boxes and our IPTV app handle multicast (UDP/RTP with IGMP) on your managed network and OTT (HLS/DASH, M3U, and Stalker/Ministra/Xtream portals) over unicast — on the same box, in the same home. A subscriber can watch a live channel over multicast and, a moment later, open a VOD title that streams over unicast — one seamless service, each stream on the transport that suits it. And because multicast needs a wired link, every inext box ships with an Ethernet port. Pure unicast, a classic multicast network, or a hybrid of the two — the same box fits all three. We build for both because our clients use both, and we won't tell you the one you've chosen is wrong.",
  moBothNoteTitle: "Already on one? Add the other.",
  moBothNoteBody:
    "Running pure multicast and need OTT reach for mobile and off-net? Or pure OTT and want multicast efficiency for big live events? The box and app support both, so you can extend without re-platforming. We'll help you scope it.",
  moFaqEyebrow: "FAQ",
  moFaqTitle: "Common questions",
  moFaqQ1: "Is OTT making multicast obsolete?",
  moFaqA1:
    "For new builds, largely — most greenfield deployments now go unicast/OTT, and pure multicast IPTV is widely considered legacy. But that's not the whole story: where a managed network already carries multicast, its efficiency, near-zero latency and guaranteed quality for live are hard to give up, so those networks stay in service and remain widely used. It's less “replaced” than “no longer the default for greenfield” — and usually run in a hybrid, with unicast for VOD and catch-up.",
  moFaqQ2: "Which one has better picture quality?",
  moFaqA2:
    "On a managed network, multicast delivers a fixed bitrate with prioritized traffic, so quality is consistent and buffer-free. OTT quality is adaptive and best-effort — excellent on a good connection, variable on a poor one. For quality you control end to end, multicast leads; for reach across unpredictable networks, OTT's adaptivity is the whole point.",
  moFaqQ3: "Do I need a special network for multicast?",
  moFaqA3:
    "Yes. Multicast needs a managed network where every switch in the path is multicast-enabled (IGMP), plus a wired Ethernet link at the box — Wi-Fi can't carry multicast reliably. That's why it's an on-net telco/ISP technology, and why every inext box has an Ethernet port. OTT needs none of that — it runs over the public internet and any connection, Wi-Fi included, which is exactly why it reaches anywhere.",
  moFaqQ4: "Can one set-top box do both?",
  moFaqA4:
    "Yes — that's the point of ours. inext boxes and the IPTV app play live multicast on your network and OTT streams over the internet, switching transparently. The subscriber sees one service; you decide which transport carries what.",
  moFaqQ5: "What about latency for live sports?",
  moFaqA5:
    "Multicast typically delivers sub-second latency — which matters when the neighbours cheer before your stream catches up. Standard OTT lags 10–30 seconds; low-latency HLS/DASH has closed that to roughly 2–5 seconds, fine for most content but still behind multicast for the big live moment.",
  moFaqQ6: "What is multicast ABR?",
  moFaqA6:
    "Multicast ABR (mABR) carries adaptive-bitrate, OTT-format streams over multicast — combining OTT's device-friendly format with multicast's one-to-many efficiency. It can cut live traffic peaks by up to 90% and lets operators scale high-concurrency live without a unicast stream per viewer. Our platform supports it.",
  moCtaEyebrow: "Talk to us",
  moCtaTitle: "Deliver live TV the way your network is built for",
  moCtaBody:
    "Tell us about your network, your channels and your audience. We'll help you place multicast and OTT where each performs best — and ship boxes that run both out of the box.",
  moCtaPrimary: "Talk to our team",
  moCtaSecondary: "Request a sample",
  bbSeoTitle: "Build vs Buy: Should an ISP Build Its Own Set-Top Box? | inext",
  bbSeoDescription:
    "Build your own STB platform or buy a turnkey stack? “Building” a set-top box means assembling eight layers — silicon, hardware, firmware, apps, DRM, device management, manufacturing and support. An honest make-or-buy guide for operators.",
  bbBreadcrumbPage: "Build vs buy",
  bbHeroEyebrow: "Make-or-buy guide",
  bbHeroTitle: "Build your own STB, or buy the stack?",
  bbHeroTitleAccent: "the honest make-or-buy",
  bbHeroSub:
    "“Building your own box” sounds like engineering — but no operator makes its own chips, and almost none designs the board. In practice, building means assembling a stack of eight layers, from the silicon to the support desk, and owning every one. Some operators genuinely should. Most who say they built a box actually assembled one. This guide lays out what “build” really takes, so you can tell which side you're on.",
  bbHeroNote:
    "We're the buy-and-partner side — so we won't pretend building never makes sense. It does, for some. This is the honest version of the trade-off.",
  bbHeroCtaPrimary: "Talk to our team",
  bbHeroCtaSecondary: "See the 8 layers",
  bbStat1: "8 layers to own",
  bbStat2: "Build: a multi-year program",
  bbStat3: "Buy: a branded sample in 1–2 weeks",
  bbThesisEyebrow: "Start here",
  bbThesisTitle: "“Build” rarely means what it sounds like",
  bbThesisBody1:
    "No one makes their own chips, and realistically no operator designs its own board — that's what silicon vendors and manufacturers are for. So “building your own STB” isn't a hardware project; it's an integration project. You're assembling hardware you source, software you write or license, and an operation to manufacture, update and support it — then owning the result end to end.",
  bbThesisBody2:
    "That's a real and valid path — but a bigger one than it looks. A working box a subscriber can actually use touches eight distinct competencies, and a gap in any one shows up later as a stalled launch or a field failure. Before you decide to build, it helps to see the whole stack you'd be taking on.",
  bbThesisCoreLabel: "What “build” really is",
  bbThesisCoreValue: "Assembling & owning a stack",
  bbThesisReachLabel: "What you buy either way",
  bbThesisReachValue: "Silicon · ODM hardware · DRM licences",
  bbLayersEyebrow: "The stack",
  bbLayersTitle: "Eight layers behind a working box",
  bbLayersIntro:
    "A set-top box looks like one product; it's really eight competencies stacked together. Here's each layer, and what owning it involves.",
  bbLayer1Name: "Silicon (SoC)",
  bbLayer1Body:
    "The chip — Amlogic, Allwinner, Realtek. You choose it, you never make it, and it caps your 4K, codecs, DRM tier and secure boot.",
  bbLayer2Name: "Hardware & industrial design",
  bbLayer2Body:
    "Board, ports, enclosure, power supply, remote. Designed and built by an ODM — from a reference design or your spec — not something done in-house.",
  bbLayer3Name: "Firmware & BSP",
  bbLayer3Body:
    "Android AOSP or Linux, kernel, drivers, secure boot. The vendor gives you a base; hardening it for production takes embedded engineers.",
  bbLayer4Name: "Launcher & middleware",
  bbLayer4Body:
    "The branded home screen, EPG, settings and app launcher — the part subscribers see as “yours”.",
  bbLayer5Name: "Apps",
  bbLayer5Body:
    "Your IPTV/VOD app, plus OTT. Note: Netflix, Disney+ and the rest aren't “built” — each needs its own certification and a direct operator deal.",
  bbLayer6Name: "DRM & content protection",
  bbLayer6Body:
    "Widevine and Verimatrix, licensed and provisioned. Widevine L1 keys must be burned in at the factory, on a chip with a secure enclave — you can't add L1 later.",
  bbLayer7Name: "Device management & OTA",
  bbLayer7Body:
    "Provisioning, staged firmware updates with rollback, remote diagnostics, TR-069. A backend in its own right.",
  bbLayer8Name: "Manufacturing, logistics & support",
  bbLayer8Body:
    "Production, worldwide shipping, certification, QA, RMA and a support desk — the unglamorous majority of the work.",
  bbSpectrumEyebrow: "How operators actually build",
  bbSpectrumTitle: "Four ways to “build”, from most to least",
  bbApproach1Name: "Full in-house",
  bbApproach1Body:
    "Own embedded, app and backend teams; an ODM building to your spec; your own DRM deals and device-management backend; you handle certification. Realistic at Tier-1 scale — a multi-year, multi-team program.",
  bbApproach2Name: "Reference design + your software",
  bbApproach2Body:
    "Start from a SoC reference board or an ODM box; your team builds the firmware, launcher, app and DMS integration. Needs an embedded team, but skips custom hardware.",
  bbApproach3Name: "Retail devices + your app",
  bbApproach3Body:
    "Skip hardware entirely — publish your app on Chromecast/Google TV, Fire TV or retail Android boxes. You “build” only the app, but give up the owned box: no branding, no fleet management, and the vendor controls the home screen and updates.",
  bbApproach4Name: "ODM hardware + a vendor stack",
  bbApproach4Body:
    "Source hardware from an ODM and license the firmware, launcher, app and DMS from a specialist. You brand and configure; the hard layers are already done. This is the buy-and-partner path.",
  bbCostEyebrow: "The honest cost",
  bbCostTitle: "A build is a program, not a purchase",
  bbCostBody:
    "A true from-scratch build means standing up several disciplines you may not have — embedded firmware, app development, DRM provisioning, a device-management and OTA backend, manufacturing and logistics, and certification and support — then keeping them staffed for the life of the product. The upfront cost is real, but the ongoing one is bigger: every OS bump, security patch and new app is now yours to carry. Plan for a program measured in quarters and a team measured in headcount, not a one-off purchase.",
  bbWhenEyebrow: "When to build",
  bbWhenTitle: "Building genuinely wins when…",
  bbWhen1:
    "You have the scale. A subscriber base large enough to spread an engineering org across changes the math entirely.",
  bbWhen2:
    "You have a unique requirement. A feature or integration no vendor offers, and that's core to how you differentiate.",
  bbWhen3:
    "You already have the org. An in-house embedded and app team you're committed to funding for the long run.",
  bbWhen4:
    "Control is strategic. When owning every layer — not just branding it — is a board-level decision, not a cost line.",
  bbWhenNote:
    "If two or more of these describe you, building deserves a serious look. If none do, the math usually favours sourcing the hard layers.",
  bbTableEyebrow: "Side by side",
  bbTableTitle: "Build vs buy, dimension by dimension",
  bbTableColDimension: "",
  bbTableColBuild: "Build in-house",
  bbTableColBuy: "Buy & partner",
  bbRow1Label: "Time to market",
  bbRow1Build: "Quarters to years",
  bbRow1Buy: "Weeks to a first sample",
  bbRow2Label: "Up-front cost",
  bbRow2Build: "High — teams and tooling",
  bbRow2Buy: "Per-device plus setup",
  bbRow3Label: "Team you need",
  bbRow3Build: "Embedded, app, backend, QA",
  bbRow3Buy: "Product and operations",
  bbRow4Label: "Firmware & OS upkeep",
  bbRow4Build: "Yours, forever",
  bbRow4Buy: "Maintained for you",
  bbRow5Label: "DRM (Widevine L1)",
  bbRow5Build: "You negotiate and provision",
  bbRow5Buy: "Provisioned at the factory",
  bbRow6Label: "Device management & OTA",
  bbRow6Build: "Build the backend",
  bbRow6Buy: "Included (DMS + OTA)",
  bbRow7Label: "Certification",
  bbRow7Build: "You own GMS / Netflix",
  bbRow7Buy: "Handled or partnered",
  bbRow8Label: "Manufacturing & logistics",
  bbRow8Build: "Your ODM and freight",
  bbRow8Buy: "Included, worldwide",
  bbRow9Label: "Control",
  bbRow9Build: "Total — every layer",
  bbRow9Buy: "Yours to brand and configure",
  bbRow10Label: "Where the risk sits",
  bbRow10Build: "On you, end to end",
  bbRow10Buy: "Shared with the vendor",
  bbTableInextLabel: "Where inext fits",
  bbTableInextValue:
    "The buy-and-partner column — brand and configure, a working sample in 1–2 weeks",
  bbTableNote:
    "Neither column is “right” — it depends on your scale, your team, and how much of the stack you want to own.",
  bbFitEyebrow: "Where we fit",
  bbFitTitle: "We collapse the build into “brand and configure”",
  bbFitBody:
    "We sit in the buy-and-partner column, and we don't hide it — but our job is to take the eight layers off your plate, not to talk you out of building if you genuinely should. You get ODM hardware, an Android AOSP or Linux build, your Operator-Tier launcher, the IPTV app, Widevine L1 and Verimatrix provisioned at the factory, Alcatraz DMS with staged OTA, and worldwide manufacturing and delivery. It ships white-label — your brand on the firmware, and, if you want it, your logo on the hardware and the remote. What would be a multi-quarter program becomes: choose the model, brand it, and get a working sample in one to two weeks.",
  bbFitNoteTitle: "Not sure which side you're on?",
  bbFitNoteBody:
    "Tell us your scale, whether you have an in-house embedded team, and how fast you need to launch. We'll give you a straight read on build vs buy for your situation — not a sales pitch.",
  bbFaqEyebrow: "FAQ",
  bbFaqTitle: "Common questions",
  bbFaqQ1: "Do I have to design my own hardware to “build”?",
  bbFaqA1:
    "No — and you shouldn't. Silicon comes from chip vendors and boards from ODMs; even a full in-house build starts from a reference design. “Building” is about owning the software, the integration and the operation — not etching a PCB.",
  bbFaqQ2: "Can't I just put my app on retail Android boxes?",
  bbFaqA2:
    "You can, and for a pure app play it's a valid start. But a retail box isn't yours: even with Widevine L1 on board, you get no branding, no fleet management, no net-lock, and the vendor controls the home screen and updates. It's the app-only end of the spectrum — good for reach, weak for a controlled, branded service. (It's the Own-STB-vs-Smart-TV trade-off in another form.)",
  bbFaqQ3: "What's the hardest layer to build?",
  bbFaqA3:
    "Firmware, without question. Standing a board up is the easy part; making it stable, fast and secure is the hard one — and it never really ends. Every SoC and board needs its own firmware fine-tuned: drivers, the video pipeline, DRM integration, power management, secure boot. It's not a one-time port — for us it took years of iteration to get each firmware right for its board. It's the layer teams most underestimate, and exactly the work a specialist has already put those years into.",
  bbFaqQ4: "How long does a real build take?",
  bbFaqA4:
    "For a genuine from-scratch program, plan in quarters, not weeks: firmware hardening, DRM provisioning, device management, certification and manufacturing each take time and partly run one after another. Sourcing the hard layers compresses that to the time it takes to brand and configure a proven platform.",
  bbFaqQ5: "When does building actually make sense?",
  bbFaqA5:
    "When you have the scale to amortise an engineering org, a unique requirement no vendor covers, an in-house team you're committed to, or a strategic reason to own every layer. If two or more fit you, building deserves a serious look; if none do, sourcing usually wins.",
  bbFaqQ6: "Where does inext sit — build or buy?",
  bbFaqA6:
    "We're the buy-and-partner side, and we say so. We supply ODM hardware, AOSP or Linux firmware, your branded launcher and IPTV app, factory-provisioned DRM, Alcatraz DMS and OTA, and worldwide manufacturing — white-label, so it ships as your product. We'll also tell you honestly if your situation actually favours building.",
  bbCtaEyebrow: "Talk to us",
  bbCtaTitle: "Get a straight read on build vs buy",
  bbCtaBody:
    "Tell us your scale, whether you have an in-house embedded team, and your timeline. We'll give you an honest read for your situation — and if buying fits, a branded, working sample in a week or two.",
  bbCtaPrimary: "Talk to our team",
  bbCtaSecondary: "Request a sample",
  guidesCardRsgTitle: "How much RAM and storage does an STB need?",
  guidesCardRsgDesc:
    "A workload-based guide to 1 GB, 2 GB and 4 GB RAM — plus the storage, firmware and testing decisions that matter more than a bigger number.",
  footerLinkGuidesRamStorage: "STB RAM & storage guide",
  rsgSeoTitle: "How Much RAM and Storage Does a Set-Top Box Need? | inext",
  rsgSeoDescription:
    "Compare 1 GB, 2 GB and 4 GB RAM plus 8 GB, 16 GB and 32 GB storage for set-top boxes. Choose by workload, firmware, apps and gaming.",
  rsgBreadcrumbPage: "STB RAM & storage",
  rsgHeroEyebrow: "Set-top box sizing guide",
  rsgPublishedLabel: "Published",
  rsgUpdatedLabel: "Updated",
  rsgHeroTitle: "How much RAM and storage",
  rsgHeroTitleAccent: "does a set-top box really need?",
  rsgHeroSub:
    "There is no universal minimum for a modern STB. A tightly optimized 1 GB device can be the right fit for a controlled service, while broader app ecosystems, native games and longer lifecycle headroom justify more memory.",
  rsgHeroNote:
    "Size the complete workload — firmware, launcher, apps, updates and games — rather than buying the largest number on a specification sheet.",
  rsgHeroCtaPrimary: "Compare configurations",
  rsgHeroCtaSecondary: "Compare inext models",
  rsgStat1: "Focused and efficient",
  rsgStat2: "Flexible mainstream",
  rsgStat3: "Maximum headroom",
  rsgThesisEyebrow: "The short answer",
  rsgThesisTitle: "Memory is capacity, not performance",
  rsgThesisBody1:
    "RAM gives the operating system and applications room to work. Storage holds firmware, applications, updates and local data. Neither number measures firmware quality, storage speed, GPU capability, thermal design or how much unnecessary software runs in the background.",
  rsgThesisBody2:
    "That is why a well-engineered 1 GB STB can feel responsive in a defined, single-service deployment while a poorly tuned box with more RAM still boots slowly, drops applications or becomes unstable. More memory buys flexibility and margin; it does not repair weak software.",
  rsgThesisNoteTitle: "The responsible 1 GB claim",
  rsgThesisNoteBody:
    "One gigabyte is enough only when the workload is known, the firmware is built for that hardware and the complete service has been tested under realistic conditions. It is not a blanket recommendation for every Android box.",
  rsgGoogleNote:
    "Public Android compatibility rules are more nuanced than a universal “2 GB minimum”: requirements vary by Android version, architecture, display configuration and memory reserved for hardware.",
  rsgGoogleLink: "View Android compatibility requirements",
  rsgWorkloadsEyebrow: "Start with the job",
  rsgWorkloadsTitle: "Different STBs carry different workloads",
  rsgWorkloadsIntro:
    "An operator-controlled service, a hotel room, an open streaming device and a gaming box should not receive the same memory recommendation. Define what must run now — and what may be added later.",
  rsgWorkload1Title: "Dedicated TV service",
  rsgWorkload1Body:
    "One managed launcher and one primary TV application, with a controlled firmware image and few background services.",
  rsgWorkload1Signal: "Optimization matters more than app count",
  rsgWorkload2Title: "Multi-app streaming",
  rsgWorkload2Body:
    "Several IPTV, OTT, media and utility applications, with users moving between them during a session.",
  rsgWorkload2Signal: "Allow room for app switching and caches",
  rsgWorkload3Title: "Hospitality and MDU",
  rsgWorkload3Body:
    "Branded guest experiences, property information, casting or service integrations, often repeated across many rooms.",
  rsgWorkload3Signal: "Consistency and remote recovery lead",
  rsgWorkload4Title: "Casual games",
  rsgWorkload4Body:
    "Lightweight Android games and simple interactive experiences alongside normal media applications.",
  rsgWorkload4Signal: "RAM helps; GPU and controls still decide",
  rsgWorkload5Title: "Cloud gaming",
  rsgWorkload5Body:
    "The game renders remotely while the STB decodes a low-latency video stream and sends controller input.",
  rsgWorkload5Signal: "Network latency can outweigh extra RAM",
  rsgWorkload6Title: "Rich custom platforms",
  rsgWorkload6Body:
    "Multiple branded applications, background services, analytics, integrations and features expected to grow over time.",
  rsgWorkload6Signal: "Plan margin for the product roadmap",
  rsgRamEyebrow: "What uses RAM",
  rsgRamTitle: "Four layers compete for working memory",
  rsgRamIntro:
    "The useful question is not “How many gigabytes?” but “What remains available when the real service is running?” Measure the complete image, not a clean development build.",
  rsgRamFactor1Title: "Operating system and services",
  rsgRamFactor1Body:
    "Android or Linux, the launcher, networking, DRM, device management and vendor services all reserve memory before the main app starts.",
  rsgRamFactor2Title: "Applications and background work",
  rsgRamFactor2Body:
    "EPG data, thumbnails, analytics, caches and background processes determine whether apps stay ready or must restart.",
  rsgRamFactor3Title: "Video playback",
  rsgRamFactor3Body:
    "Modern STBs decode video in dedicated hardware. Smooth 4K depends heavily on the SoC, codec pipeline and drivers — not RAM capacity alone.",
  rsgRamFactor4Title: "Games and multitasking",
  rsgRamFactor4Body:
    "Native games, richer graphics and frequent app switching create larger working sets and benefit most visibly from additional headroom.",
  rsgConfigEyebrow: "Practical comparison",
  rsgConfigTitle: "1/8, 2/16 or 4/32 GB?",
  rsgConfigIntro:
    "These are workload profiles, not universal performance tiers. The final choice should follow sample testing with the intended firmware, applications, streams and peripherals.",
  rsgConfigCommon: "Broadest fit",
  rsgConfigFitsLabel: "Good fit for",
  rsgConfigWatchLabel: "Watch for",
  rsgConfigModelsLabel: "Current inext fit",
  rsgConfig1Label: "Focused deployment",
  rsgConfig1Summary:
    "A cost-efficient configuration when inext or the operator controls the software image and keeps the workload deliberately narrow.",
  rsgConfig1Fit1: "One primary TV or media application",
  rsgConfig1Fit2: "A lightweight launcher with limited background services",
  rsgConfig1Fit3: "Large fleets where unit economics matter",
  rsgConfig1Watch:
    "Not the right default for a growing app catalogue, heavy native games or software that has not been profiled on the target firmware.",
  rsgConfig2Label: "Flexible mainstream",
  rsgConfig2Summary:
    "A balanced starting point for deployments that need several applications, a richer interface and more room for future software changes.",
  rsgConfig2Fit1: "Multi-app IPTV and OTT services",
  rsgConfig2Fit2: "Hospitality, branded portals and casual games",
  rsgConfig2Fit3: "Projects with moderate roadmap uncertainty",
  rsgConfig2Watch:
    "Still validate storage growth, app switching and long-running stability; 2 GB does not remove the need for disciplined firmware.",
  rsgConfig3Label: "Maximum headroom",
  rsgConfig3Summary:
    "The strongest option for broad application sets, heavier native workloads and projects that value flexibility above the lowest hardware cost.",
  rsgConfig3Fit1: "Larger app libraries and richer interfaces",
  rsgConfig3Fit2: "More demanding native games and interactive apps",
  rsgConfig3Fit3: "Longer roadmaps with less predictable requirements",
  rsgConfig3Watch:
    "Do not pay for unused capacity. Confirm that the processor, GPU, storage speed and software can turn the extra memory into a real benefit.",
  rsgConfigNote:
    "The configuration names describe nominal RAM and flash capacity. Available memory and usable storage are lower after hardware reservations, firmware partitions and preinstalled software.",
  rsgStorageEyebrow: "Storage needs a budget",
  rsgStorageTitle: "The number on the box is not usable space",
  rsgStorageIntro:
    "An 8 GB, 16 GB or 32 GB device must first accommodate its partition layout and production image. Buyers should ask for usable space on the final sample, then model how it changes over the service life.",
  rsgStorage1Title: "Firmware and partitions",
  rsgStorage1Body:
    "The operating system, recovery image, vendor data and reserved partitions consume capacity before applications are installed.",
  rsgStorage2Title: "Update strategy",
  rsgStorage2Body:
    "Recovery packages, staged downloads and A/B update designs can require temporary or permanently reserved storage.",
  rsgStorage3Title: "Apps, data and caches",
  rsgStorage3Body:
    "Application binaries are only the start. EPG data, artwork, logs, web data and caches grow during normal use.",
  rsgStorage4Title: "Write performance and endurance",
  rsgStorage4Body:
    "Fast, reliable eMMC and a healthy filesystem can matter more than unused capacity on a slower or poorly managed device.",
  rsgStorageNote:
    "Specify a minimum free-space threshold after provisioning and after a representative update cycle. Nominal capacity alone cannot confirm that the next firmware or application release will install safely.",
  rsgOptimizeEyebrow: "Why firmware changes the answer",
  rsgOptimizeTitle: "Optimization creates usable headroom",
  rsgOptimizeIntro:
    "STB firmware is not a generic Android image copied onto a board. The BSP, drivers, services, launcher and application lifecycle must be tuned together for the exact SoC and product role.",
  rsgOptimize1Title: "Remove work the product does not need",
  rsgOptimize1Body:
    "Every unnecessary service consumes memory, storage, CPU time and boot time. A controlled image can stay deliberately lean.",
  rsgOptimize2Title: "Tune the complete board support package",
  rsgOptimize2Body:
    "Kernel settings, drivers, memory allocation and hardware video integration determine how efficiently the platform uses its resources.",
  rsgOptimize3Title: "Control application lifecycle",
  rsgOptimize3Body:
    "Launcher behavior, background limits, cache policy and recovery paths keep the main experience responsive over long sessions.",
  rsgOptimize4Title: "Validate every production release",
  rsgOptimize4Body:
    "Optimization is maintained through regression testing, staged OTA delivery and monitoring — not completed once at launch.",
  rsgOptimizeProofTitle: "A concrete example: inext TV5",
  rsgOptimizeProofBody:
    "TV5 pairs 1 GB RAM and 8 GB eMMC with Android 10 AOSP, hardware-accelerated 4K playback and Alcatraz DMS. Its focused role is made possible by years of firmware work on the H313 platform — not by pretending memory limits do not exist.",
  rsgOptimizeProofCta: "See TV5 specifications",
  rsgGamingEyebrow: "Gaming changes the workload",
  rsgGamingTitle: "Ask what kind of game will run",
  rsgGamingIntro:
    "“Supports games” can describe very different products. A simple puzzle, a streamed console title and a native 3D game place different demands on the STB.",
  rsgGamingImageAlt:
    "Person using the inext Remote app in gamepad mode while a racing game runs on a television",
  rsgGame1Title: "Casual and lightweight games",
  rsgGame1Body:
    "Simple Android games can run within a modest memory budget when the rest of the software image is controlled and the game is tested on the target device.",
  rsgGame1Emphasis: "Often viable on 1–2 GB; test each title",
  rsgGame2Title: "Cloud gaming",
  rsgGame2Body:
    "Rendering happens in the cloud. Local success depends on low-latency networking, hardware video decoding, Bluetooth or USB input and stable frame delivery.",
  rsgGame2Emphasis: "Network, decoder and controller latency lead",
  rsgGame3Title: "Demanding native games",
  rsgGame3Body:
    "Larger textures, game engines and background assets benefit from 4 GB and more storage, but GPU capability and sustained thermal performance remain decisive.",
  rsgGame3Emphasis: "Prefer 4/32 — after GPU and thermal validation",
  rsgGamingNote:
    "Four gigabytes of RAM does not turn a weak chipset into a game console. Specify RAM, GPU, processor, storage performance, cooling and controller support as one gaming requirement.",
  rsgTestEyebrow: "Evidence before purchase",
  rsgTestTitle: "Test the workload, not a benchmark score",
  rsgTestIntro:
    "A supplier sample should run the intended production image and content. Repeat the same acceptance sequence on every candidate so the comparison reflects the service subscribers will receive.",
  rsgTest1: "Measure cold boot and resume-to-picture time",
  rsgTest2: "Launch the primary app and switch between key screens",
  rsgTest3: "Play representative 4K, HDR and protected content",
  rsgTest4: "Switch repeatedly between every required application",
  rsgTest5: "Run live TV, OTT playback or the target media workflow for 24–72 hours",
  rsgTest6: "Exercise casual, cloud or native games with the intended controller",
  rsgTest7: "Install an OTA update with realistic free space and verify recovery",
  rsgTest8: "Record available RAM and storage after provisioning, use and updates",
  rsgTestNoteTitle: "Keep the test repeatable",
  rsgTestNoteBody:
    "Document pass/fail criteria before samples arrive. A polished demonstration is not a substitute for an acceptance plan.",
  rsgTestNoteCta: "Open the STB buyer's checklist",
  rsgDecisionEyebrow: "Procurement rule",
  rsgDecisionTitle: "Buy the smallest configuration that clears the real requirement with margin",
  rsgDecision1Title: "Define the production image",
  rsgDecision1Body:
    "List the OS, launcher, applications, services, DRM, DMS and update design that will ship — not an abstract platform name.",
  rsgDecision2Title: "Separate media from compute",
  rsgDecision2Body:
    "Confirm codecs and resolutions in the hardware decoder, then evaluate CPU, GPU and RAM for the applications around playback.",
  rsgDecision3Title: "Budget storage over time",
  rsgDecision3Body:
    "Account for usable space, caches, logs, application growth, recovery and at least one realistic update cycle.",
  rsgDecision4Title: "Price lifecycle headroom",
  rsgDecision4Body:
    "Compare extra memory cost against the probability of new applications, longer support or a broader role during the fleet's life.",
  rsgDecisionConclusion:
    "The right STB is not the one with the most memory. It is the one that meets a documented workload reliably, at the right fleet cost, with enough margin for its planned life.",
  rsgFaqEyebrow: "FAQ",
  rsgFaqTitle: "RAM and storage questions, answered",
  rsgFaqQ1: "Is 1 GB RAM enough for a modern set-top box?",
  rsgFaqA1:
    "It can be. One gigabyte is a valid configuration for a controlled workload with optimized firmware, a focused launcher and a limited application set. It is a poor default for an unknown workload, a broad app ecosystem or demanding native games. Test the final software image before deciding.",
  rsgFaqQ2: "Is 2 GB RAM the minimum for Android TV?",
  rsgFaqA2:
    "There is no universal 2 GB rule that fits every television device. Public Android compatibility requirements vary by Android version, architecture, display configuration and hardware-reserved memory. Compatibility minimums also do not predict whether a specific app stack will perform well; production testing still decides.",
  rsgFaqQ3: "Does more RAM improve 4K video quality?",
  rsgFaqA3:
    "Not by itself. Dedicated hardware normally decodes H.264, H.265 or VP9 video. Smooth 4K playback depends on the SoC, decoder, drivers, output path and stream compatibility. RAM becomes more relevant to the launcher, applications, buffering strategy and multitasking around playback.",
  rsgFaqQ4: "How much of the advertised storage is usable?",
  rsgFaqA4:
    "It varies by firmware and partition layout. The operating system, recovery, reserved data and preinstalled applications all reduce usable space. Request the free-space figure from a production-equivalent sample after provisioning, not from the raw flash specification.",
  rsgFaqQ5: "How much RAM does an STB need for games?",
  rsgFaqA5:
    "Lightweight games may run well on 1–2 GB, while demanding native titles benefit from 4 GB and more storage. Cloud gaming depends more heavily on network latency, hardware decoding and controller response. In every case, GPU capability and thermal behavior matter alongside RAM.",
  rsgFaqQ6: "Should an operator buy extra memory for future-proofing?",
  rsgFaqA6:
    "Only against a plausible roadmap. Extra headroom is sensible when more apps, richer interfaces or a longer lifecycle are likely. Paying every unit in a large fleet for capacity that has no planned use can cost more than selecting a proven lower configuration and managing the product scope deliberately.",
  rsgCtaEyebrow: "Choose with evidence",
  rsgCtaTitle: "Bring the workload. We will help size the box.",
  rsgCtaBody:
    "Share the applications, streams, integrations, gaming requirements and expected lifecycle. The inext team can recommend a configuration and prepare a sample with the intended software for validation.",
  rsgCtaPrimary: "Discuss the workload",
  rsgCtaSecondary: "Compare all models",
  footerLinkBrand: "Brand assets",
  brandSeoTitle: "inext Brand Assets & Logo Guidelines",
  brandSeoDescription:
    "Download official inext logos and icons, and review the approved colors, typography, usage rules, and permissions for press and partner marketing.",
  brandEyebrow: "inext brand",
  brandHeading: "Brand assets, ready to use",
  brandIntro:
    "Download approved inext logo artwork and follow the essentials for color, typography, written references, and accurate third-party use.",
  brandDownloadPack: "Download asset pack",
  brandDownloadGuide: "Download PDF guide",
  brandDownloadNote: "Free to download for press, editorial, and accurate partner-marketing use.",
  brandLogoAlt: "inext logo",
  brandLogoEyebrow: "Logo system",
  brandLogoTitle: "Choose the version for the background",
  brandLogoDescription:
    "Use the full logo whenever space allows. The compact icon is intended for square or space-constrained placements. Download the artwork as scalable SVG or transparent PNG.",
  brandPrimary: "Primary · white background",
  brandOnDark: "For black backgrounds",
  brandOnBlue: "For inext blue backgrounds",
  brandFullLogo: "Full-size logo",
  brandIcon: "Icon",
  brandColorsEyebrow: "Color",
  brandColorsTitle: "A focused three-color palette",
  brandColorsDescription:
    "These are the approved inext logo colors. Use the exact values below and choose the supplied artwork instead of recoloring it manually.",
  brandColorBlue: "inext blue",
  brandColorWhite: "White",
  brandColorBlack: "Black",
  brandTypographyEyebrow: "Typography & name",
  brandTypographyTitle: "Keep supporting type clear and consistent",
  brandTypographyDescription:
    "Use Roboto for inext branded communication when possible. Select weights that maintain a clear hierarchy and comfortable readability.",
  brandTypographyLink: "Get Roboto from Google Fonts",
  brandNameTitle: "Written brand name",
  brandNameDescription:
    "In running text, write the brand name as lowercase “inext”. Use the approved logo artwork when the chevron should appear; do not substitute the text character “›” for the logo mark.",
  brandUsageEyebrow: "Correct use",
  brandUsageTitle: "Protect the shape, contrast, and meaning",
  brandUsageDescription:
    "Consistent treatment makes the brand recognizable across editorial coverage, product materials, and partner campaigns.",
  brandDoTitle: "Do",
  brandDoOfficialAssets: "Use the official artwork supplied on this page.",
  brandDoContrast: "Choose the approved variant with strong background contrast.",
  brandDoProportions: "Preserve the logo’s proportions and leave comfortable space around it.",
  brandDoAccurateRelationship:
    "Describe the relationship with inext accurately in partner materials.",
  brandDontTitle: "Don’t",
  brandDontRecolor: "Do not invent colors or combine parts from different variants.",
  brandDontDistort: "Do not stretch, compress, rotate, crop, or skew the artwork.",
  brandDontEffects: "Do not add outlines, shadows, gradients, or other effects.",
  brandDontRearrange: "Do not rearrange the icon and wordmark or typeset a replacement.",
  brandPermissionsEyebrow: "Permissions",
  brandPermissionsTitle: "Open assets, accurate representation",
  brandPermissionsDescription:
    "The logo files are freely available for legitimate coverage and collaboration. No request form or email gate is required.",
  brandPermissionPress: "Press and editorial teams may use the assets when referring to inext.",
  brandPermissionPartners:
    "Partners may use them in marketing that reflects a genuine relationship.",
  brandPermissionAccuracy:
    "Use must not imply an endorsement, certification, or partnership that does not exist.",
  brandContactCta: "Ask about a special use",
} as const;

export const overrides: Record<string, Partial<Record<keyof typeof en, string>>> = {
  uk: {
    navProducts: "Продукти",
    navCustomization: "Кастомізація",
    navAbout: "Про нас",
    navBlog: "Блог",
    navFaq: "FAQ",
    navContact: "Контакти",
    navSearch: "Пошук",
    announcementLabel: "Новина",
    contactSales: "Зв’язатися з продажами",
    toggleMenu: "Меню",
    language: "Мова",
    breadcrumbLabel: "Навігаційний шлях",
    heroEyebrow: "STB-обладнання для операторів · З 2011 року",
    heroTitle: "Android TV-приставки",
    heroTitleAccent: "для IPTV- та OTT-операторів",
    heroDescription:
      "Чотири готові до розгортання моделі Android TV, адаптовані під ваш бренд і програмне забезпечення, з Alcatraz DMS для керування парком пристроїв.",
    heroModelsCta: "Порівняти STB-моделі",
    heroQuoteCta: "Отримати пропозицію",
    exploreProducts: "Переглянути продукти",
    bookDemo: "Замовити демо",
    stackEyebrow: "Стек inext",
    stackTitle: "Обладнання, кастомізація та",
    stackTitleAccent: "керування",
    stackTitleEnd: "— в одному місці",
    stackDescription:
      "Три напрями, які закривають усе потрібне оператору для запуску й розвитку сучасного IPTV / OTT-сервісу.",
    hardwareEyebrow: "Обладнання · Наш флагманський STB",
    hardwareTitle: "Знайомтеся:",
    hardwareDescription:
      "Компактна й потужна Android 12 (AOSP) ТВ-приставка для ISP і ТВ-операторів. Allwinner H618, 4 ГБ DDR3 і 32 ГБ eMMC забезпечують плавне 4K UHD-відтворення при 60 к/с через HDMI 2.0a. Підключення — двосмуговий Wi-Fi AC, Bluetooth 5.0 або Ethernet 100 Мб; у комплекті вже є пульт, HDMI-кабель і блок живлення.",
    viewTechSpecs: "Переглянути характеристики",
    clientsEyebrow: "White-label і co-branding",
    clientsTitle: "Оператори вже постачають",
    clientsTitleAccent: "inext STB",
    clientsDescription:
      "Реальне обладнання, пакування та UX для провідних ISP і OTT-платформ — повністю брендовані рішення від задуму до впровадження.",
    clientsOutro: "Від однієї приставки до запуску в масштабах країни — ваш бренд, наша інженерія.",
    customizationEyebrow: "Кастомізація",
    customizationTitle: "Ваш бренд — на кожному етапі",
    customizationDescription:
      "Від коробки на полиці до лаунчера на телевізорі — кожен рівень досвіду inext можна адаптувати під бренд оператора та його контент.",
    learnMore: "Дізнатися більше",
    lineupEyebrow: "Оберіть обладнання",
    lineupTitle: "Чотири STB. Одна операторська платформа.",
    lineupDescription:
      "Почніть із потреб проєкту: базове 4K-обладнання, більше пам'яті й накопичувача або флагман із 4 ГБ. Кожна модель створена для операторського контролю та Alcatraz DMS.",
    lineupCompareAll: "Порівняти всі моделі",
    lineupFlagshipBadge: "Флагман",
    lineupTv5Tagline: "Базовий 4K Android для бюджетних проєктів.",
    lineupTv5UltraTagline: "Більше памʼяті та сховища на перевіреній платформі.",
    lineupTv6Tagline: "Розумніший 4K із Bluetooth і Wi-Fi ac.",
    lineupTv6UltraTagline: "Максимум потужності та памʼяті — флагман.",
    homeCompanionEyebrow: "Застосунок-компаньйон",
    homeCompanionCta: "Дізнатися про inext Remote",
    operationsEyebrow: "Керування · Alcatraz DMS + протоколи",
    operationsTitle: "Одна платформа для керування",
    operationsTitleAccent: "кожним пристроєм",
    operationsDescription:
      "Alcatraz DMS — система керування пристроями для кожного розгортання inext. З однієї консолі команди можуть виявляти проблеми парку, переглядати активність пристроїв, розгортати прошивки та запускати віддалену діагностику.",
    ctaEyebrow: "Поговорімо",
    ctaTitle: "Готові обрати",
    ctaTitleAccent: "потрібну STB?",
    ctaDescription:
      "Розкажіть про сервіс, розмір парку й технічні вимоги. Ми запропонуємо конфігурацію обладнання та план запуску.",
    footerDescription:
      "Set-Top Box-приставки та ПЗ для керування пристроями для ISP і ТВ-провайдерів з 2011 року.",
    footerProducts: "Продукти",
    footerSolutions: "Рішення",
    footerCompany: "Компанія",
    footerRights: "Усі права захищено.",
    homeTitle: "Android TV-приставки для IPTV- та OTT-операторів | inext",
    homeDescription:
      "inext постачає Android TV-приставки для ISP і ТВ-операторів із white-label кастомізацією, IPTV-застосунками, Alcatraz DMS та глобальною B2B-доставкою.",
    portalEyebrow: "Більше, ніж приставка",
    portalTitle: "Усе, що потрібно оператору навколо STB.",
    portalDescription:
      "Перетворіть обране обладнання на готовий абонентський продукт завдяки брендуванню, застосункам, керуванню парком і скоординованій B2B-доставці.",
    portalResourcesEyebrow: "Центр знань",
    portalResourcesTitle: "Плануйте запуск із практичними гайдами та інструментами.",
    portalResourcesDescription:
      "Досліджуйте вибір обладнання, порівнюйте вартість парку та знаходьте практичні відповіді на порталі inext.",
    heroQuickHardware: "Обладнання",
    heroQuickCustomization: "Кастомізація",
    heroQuickOperations: "Керування",
    heroQuickLogistics: "Доставка по світу",
    heroDashboardTitle: "Alcatraz DMS · Огляд парку",
    heroMetricActiveDevices: "Активні пристрої",
    heroMetricOnline: "Онлайн",
    heroMetricStreams: "Стрімів / хв",
    heroFirmware: "Прошивка",
    heroDeviceOnline: "Онлайн",
    heroDeviceImageAlt: "Set-top box inext TV6 Ultra з пультом",
    heroSpecChipset: "Чипсет",
    heroSpecMemory: "Пам’ять",
    heroSpecVideo: "Відео",
    heroSpecOs: "ОС",
    heroStackBadge: "Обладнання + ПЗ в одному стеку",
    productMenuFlagship: "Флагман",
    productMenuTv6UltraDesc: "Преміум · 4 ГБ / 32 ГБ · голосовий пульт",
    productMenuTv6Desc: "Продуктивна · 2 ГБ / 16 ГБ · IR-пульт",
    productMenuTv5UltraDesc: "Стандартна · 2 ГБ / 16 ГБ · IR-пульт",
    productMenuTv5Desc: "Базова · 1 ГБ / 8 ГБ · IR-пульт",
    navMenuProductsEyebrow: "Приставки",
    navMenuSolutionsEyebrow: "Рішення та ПЗ",
    navMenuSolutionsGroupPlatform: "Платформа та операції",
    navMenuSolutionsGroupApps: "Застосунки",
    navMenuSolutionsGroupServices: "Послуги",
    productMenuFeaturedTitle: "Флагманський 4K-бокс",
    productMenuFeaturedDesc: "Android 12 · Bluetooth-пульт з голосом · Alcatraz DMS",
    productMenuFeaturedCta: "Огляд флагмана",
    pillarHardwareEyebrow: "Обладнання",
    pillarHardwareTitle: "Android TV Set-Top Box-приставки",
    pillarHardwareDescription:
      "Компактні й потужні 4K STB, спроєктовані для ISP і ТВ-операторів. Флагман лінійки — inext TV6 Ultra.",
    pillarHardwareCta: "Переглянути лінійку",
    pillarCustomizationEyebrow: "Кастомізація",
    pillarCustomizationTitle: "Ваш бренд на кожному екрані",
    pillarCustomizationDescription:
      "White-label обладнання, co-branding, кастомні IPTV-застосунки, операторський лаунчер і мобільний застосунок-пульт — усе навколо вашої айдентики.",
    pillarCustomizationCta: "Дослідити кастомізацію",
    pillarOperationsEyebrow: "Керування",
    pillarOperationsTitle: "Керуйте парком у масштабі",
    pillarOperationsDescription:
      "Здоров’я пристроїв, історія активності, поетапні OTA-оновлення, віддалена діагностика та TR-069 в одній консолі Alcatraz DMS для всієї мережі.",
    pillarOperationsCta: "Всередині Alcatraz DMS",
    hardwareSpecChipset: "Allwinner H618 · чотириядерний A53",
    hardwareSpecMemory: "4 ГБ DDR3 · 32 ГБ eMMC · Mali-G31 MP2",
    hardwareSpecVideo: "4K UHD H.265 60 к/с · VP9 · H.264",
    hardwareSpecWireless: "Двосмуговий Wi-Fi AC · BT 5.0 · LAN 100 Мб",
    hardwareSpecPorts: "HDMI 2.0a · A/V-вихід · 2×USB 2.0 · microSD/TF",
    hardwareSpecSoftware: "Android 12 (AOSP) · Alcatraz™ DMS · TR-069",
    hardwareImageAlt: "Set-Top Box inext TV6 Ultra з пультом і пакуванням",
    hardwareStatUltraHd: "Ultra HD",
    hardwareStat60Fps: "60 к/с",
    hardwareStatAndroid: "Android",
    clientTagFullPackage: "Повний пакет",
    clientTagCoBranding: "Co-branding",
    clientTagRetailKit: "Роздрібний комплект",
    clientTagCustomApp: "Кастомний застосунок",
    clientTagWhiteLabel: "White-label",
    clientImageAltSuffix: "STB від inext",
    clientNoteBeeline: "Брендований STB, пульт і роздрібна коробка",
    clientNoteOkTv: "Пристрій і роздрібне пакування з брендом оператора",
    clientNoteKyivstar: "Брендований пристрій, пульт і роздрібна коробка",
    clientNoteAlmaTv: "IPTV-приставка — пакування та комплект з пультом",
    clientNoteSarkor: "Операторський UI, пакування й аксесуари",
    clientNoteSweetTv: "Box 2 UltraHD — повний роздрібний комплект",
    clientNoteMegogo: "Black edition з брендованим пультом",
    clientNoteMetroTv: "STB з брендом оператора та роздрібною коробкою",
    customServiceWhiteLabelingTitle: "White-labeling",
    customServiceWhiteLabelingDescription:
      "Постачайте обладнання та застосунки під власним брендом — пакування, прошивка й UI повністю адаптовані під вашу айдентику.",
    customServiceCoBrandingTitle: "Co-branding",
    customServiceCoBrandingDescription:
      "Поєднуйте ваш бренд із платформою inext через гнучкі co-branded сценарії та роздрібні комплекти.",
    customServiceIptvAppTitle: "Кастомний IPTV-застосунок",
    customServiceIptvAppDescription:
      "Індивідуальний IPTV/OTT-плеєр з EPG, catch-up, time-shift і VOD — адаптований під ваш каталог контенту.",
    customServiceLauncherTitle: "Операторський лаунчер",
    customServiceLauncherDescription:
      "Продуманий Android TV-лаунчер з брендованими рядами, кастомними головними екранами та контрольованим сценарієм користування.",
    customServiceRemoteAppTitle: "Мобільний застосунок-пульт",
    customServiceRemoteAppDescription:
      "Перетворіть смартфон на потужний пульт — Bluetooth-сполучення, голосовий пошук, введення з клавіатури та жести.",
    customServiceAppDesignTitle: "Кастомний дизайн застосунків",
    customServiceAppDesignDescription:
      "Повний UI/UX-дизайн для лаунчера, EPG і плеєра — навколо ваших абонентів і вашого контенту.",
    operationsImageAlt:
      "Дашборд Alcatraz DMS — огляд парку в реальному часі з онлайн-пристроями, моделями та розподілом прошивок",
    operationsFeatureTelemetry: "Сповіщення про здоров’я пристроїв і черга проблем",
    operationsFeatureOta: "Поетапні OTA-оновлення прошивки",
    operationsFeatureTr069: "Підтримка TR-069 / CWMP",
    operationsFeaturePush: "Таргетовані push-повідомлення",
    operationsFeatureIperf: "Діагностика MTR та iPerf3",
    operationsFeatureAccess: "API-ключі з обмеженими правами та рольовий доступ",
    operationsFeatureDiagnostics: "Активність пристроїв та історія проблем",
    operationsLiveBadge: "Наживо",
    operationsCalloutOnline: "6 236 пристроїв онлайн",
    operationsCalloutActive: "62% активні цього місяця",
    operationsCalloutFirmware: "2 нові прошивки на тестування",
    operationsMetric1Value: "120+",
    operationsMetric1Label: "операторських мереж",
    operationsMetric3Value: "24/7",
    operationsMetric3Label: "моніторинг парку",
    footerLinkTv6Ultra: "inext TV6 Ultra",
    footerLinkTv6: "inext TV6",
    footerLinkTv5Ultra: "inext TV5 Ultra",
    footerLinkTv5: "inext TV5",
    footerLinkAbout: "Про нас",
    footerLinkBlog: "Блог",
    footerLinkNewsletter: "Розсилка",
    footerLinkFaq: "FAQ",
    footerLinkContact: "Контакти",
    footerLinkDistributors: "Дистриб’ютори",
    footerLinkPrivacy: "Політика конфіденційності",
    footerLinkRepublishing: "Використання матеріалів",
    footerLinkServiceStatus: "Статус сервісів",
    compareAllModels: "Порівняти всі 4 моделі",
    aboutTitle: "Про inext",
    aboutDescription:
      "inext — міжнародна інженерна команда, заснована в Києві. Ми створюємо ТВ-приставки, програмне забезпечення та інструменти керування пристроями для операторів.",
    aboutEyebrow: "Міжнародна компанія у сфері ТВ-технологій",
    aboutHeading: "Створюємо ТВ-рішення, які працюють у реальних мережах.",
    aboutIntro:
      "inext проєктує ТВ-приставки, програмне забезпечення та інструменти керування пристроями для інтернет-провайдерів і OTT-платформ. Ми супроводжуємо продукт від формування специфікації до запуску та подальшої експлуатації.",
    aboutStat1Value: "15",
    aboutStat1Label: "країн, де працюють рішення inext",
    aboutStat3Value: "250+",
    aboutStat3Label: "B2B-клієнтів та партнерів",
    aboutStat4Value: "17",
    aboutStat4Label: "моделей STB розроблено з 2011 року",
    aboutStat5Value: "700K+",
    aboutStat5Label: "пристроїв поставлено у світі",
    aboutWorldwideDeliveryTitle: "Міжнародні поставки на практиці",
    aboutWorldwideDeliveryBody:
      "inext має практичний досвід міжнародних проєктів: від запуску на окремому ринку до розгортання для операторів у кількох країнах. Ми постачаємо ТВ-приставки, брендоване пакування, прошивку та супровід впровадження напряму або через координовану роботу з дистриб’юторами.",
    aboutBrandResourcesPrompt: "Шукаєте логотип або затверджені матеріали бренду?",
    aboutBrandResourcesCta: "Перейти до брендових матеріалів",
    aboutCapabilitiesEyebrow: "Наші рішення",
    aboutCapabilitiesTitle: "Одна команда — весь абонентський досвід.",
    aboutCapabilitiesLede:
      "Ми розробляємо обладнання, програмне забезпечення та інструменти керування пристроями як єдину систему — від специфікації продукту до запуску й подальшої підтримки.",
    aboutCapabilityHardwareTitle: "ТВ-обладнання для операторів",
    aboutCapabilityHardwareBody:
      "Перевірені приставки на Android AOSP для IPTV- й OTT-сервісів — від доступних моделей для масштабних проєктів до флагманської платформи.",
    aboutCapabilityHardwareCta: "Переглянути моделі",
    aboutCapabilitySoftwareTitle: "Прошивки та програмне забезпечення",
    aboutCapabilitySoftwareBody:
      "Прошивки під брендом оператора, лаунчери, інтеграція застосунків і розробка індивідуальних ТВ-рішень відповідно до особливостей сервісу та фірмового стилю.",
    aboutCapabilitySoftwareCta: "Дізнатися про кастомізацію",
    aboutCapabilityOperationsTitle: "Керування пристроями",
    aboutCapabilityOperationsBody:
      "Провізіонінг, поетапні оновлення прошивки, діагностика та віддалене керування через Alcatraz DMS і стандартні операторські протоколи.",
    aboutCapabilityOperationsCta: "Дізнатися про Alcatraz DMS",
    aboutHeritageEyebrow: "Наша історія",
    aboutHeritageTitle: "Київське коріння. Міжнародна команда.",
    aboutStoryPara1:
      "inext засновано в Києві у 2011 році. Спочатку ми розробляли обладнання для домашніх медіасистем у період переходу від фізичних носіїв до стримінгових сервісів. Якість відтворення відео, стабільність пристроїв і довгострокова надійність були важливими для нас від самого початку.",
    aboutStoryPara2:
      "Сьогодні члени нашої команди працюють у різних країнах. Разом із розвитком IPTV та OTT розширилися й наші рішення: до приставок додалися гнучке програмне забезпечення для ТВ та платформа керування пристроями. Ринок змінився, але наше завдання залишилося тим самим — перетворювати складні технічні вимоги на надійні продукти для щоденного використання.",
    aboutPrinciplesEyebrow: "Як ми працюємо",
    aboutPrinciplesTitle: "Практичні інженерні рішення для операторських проєктів.",
    aboutPrinciplesLede:
      "Ми враховуємо реалії операторських мереж, потреби служб підтримки та те, що продукт має залишатися актуальним і після запуску.",
    aboutPrinciple1Title: "Готова основа для запуску",
    aboutPrinciple1Body:
      "Ми спираємося на перевірену апаратну й програмну основу, щоб не створювати базові компоненти заново для кожного проєкту.",
    aboutPrinciple2Title: "Гнучкість там, де вона потрібна",
    aboutPrinciple2Body:
      "Адаптуємо брендинг, прошивки, інтеграції та обладнання, якщо стандартна конфігурація не відповідає вимогам проєкту.",
    aboutPrinciple3Title: "Підтримка протягом усього життєвого циклу",
    aboutPrinciple3Body:
      "Після запуску допомагаємо оновлювати прошивки, діагностувати проблеми та керувати пристроями.",
    aboutCtaEyebrow: "Співпраця з inext",
    aboutCtaTitle: "Плануєте запуск ТВ-сервісу під власним брендом?",
    aboutCtaBody:
      "Розкажіть про вашу мережу, контент і цільові ринки. Ми допоможемо підібрати відповідне поєднання пристроїв і програмного забезпечення.",
    aboutHeroEst: "Засновано в Києві · 2011",
    aboutHeroImageAlt: "Пристрої inext 3D kid, HD1, TV, TV2e та 4K2",
    aboutClientsEyebrow: "Нам довіряють оператори",
    aboutClientsLede:
      "Інтернет-провайдери та OTT-платформи у 15 країнах постачають приставки inext своїм абонентам.",
    aboutClientsCta: "Переглянути клієнтів і кейси",
    aboutClientImageAltSuffix: "операторське впровадження STB inext",
    contactsTitle: "Контакти inext",
    contactsDescription: "Зв’яжіться з потрібним контактом inext для вашого ринку.",
    contactsEyebrow: "Контакти",
    contactsHeading: "Створімо ваш наступний ТВ-проєкт",
    contactsIntro: "Розкажіть про ваш проєкт — наша команда зв’яжеться з вами.",
    contactFormTitle: "Надіслати запит",
    contactFormIntro: "Залиште кілька деталей, щоб ми скерували вас до потрібного спеціаліста.",
    contactNameLabel: "Ім’я",
    contactCompanyLabel: "Компанія",
    contactCompanyOptionalLabel: "Компанія (необов’язково)",
    contactCompanyRequired: "Вкажіть назву компанії для цього типу запиту.",
    contactCountryLabel: "Країна",
    contactPhoneOptionalLabel: "Телефон (необов’язково)",
    contactInquiryTypeLabel: "Чим можемо допомогти?",
    contactInquiryTypePlaceholder: "Оберіть тип запиту",
    contactInquiryType_sales: "Запит до продажів",
    contactInquiryType_demo: "Замовити демо",
    contactInquiryType_integration: "Інтеграція",
    contactInquiryType_brand: "Брендові матеріали та медіа",
    contactInquiryType_partnership: "Партнерство",
    contactInquiryType_support: "Підтримка пристроїв",
    contactInquiryType_other: "Інше",
    contactBrandResourcesNote:
      "Офіційні файли логотипа та правила використання можна завантажити одразу. Використовуйте цю форму лише для запитань щодо нестандартного використання.",
    contactBrandResourcesCta: "Перейти до брендових матеріалів",
    contactMessageLabel: "Повідомлення",
    contactWebsiteHoneypotLabel: "Вебсайт",
    contactConsentPrefix: "Я погоджуюся на обробку моїх даних, як описано в",
    contactPrivacyLink: "Політиці конфіденційності",
    contactConsentRequired: "Підтвердьте згоду з політикою конфіденційності, щоб продовжити.",
    contactSubmit: "Надіслати запит",
    contactSubmitting: "Надсилаємо...",
    contactSuccessTitle: "Дякуємо за звернення",
    contactSuccessBody: "Ваш запит надіслано. Наша команда зв’яжеться з вами найближчим часом.",
    contactFailureTitle: "Не вдалося надіслати запит",
    contactFailureBody: "Спробуйте ще раз або напишіть нам напряму на",
    findDistributorTitle: "Шукаєте локального дистриб’ютора?",
    findDistributorBody: "Знайдіть партнера inext для вашого ринку.",
    viewDistributors: "Переглянути дистриб’юторів",
    globalDistributorListTitle: "Дистриб’ютори",
    distributorListTitle: "Дистриб’ютори в Польщі",
    exclusiveDistributorTitle: "Ексклюзивний дистриб’ютор в Україні",
    otherRegionsDistributorTitle: "Інші регіони",
    directSalesOperationsTitle: "Прямі продажі та операції в ЄС",
    contactAddressLabel: "Адреса",
    contactPhoneLabel: "Телефон",
    contactEmailLabel: "E-mail",
    contactWebsiteLabel: "Вебсайт",
    distributorsTitle: "Дистриб’ютори inext",
    distributorsDescription: "Знайдіть офіційного дистриб’ютора inext для вашого ринку.",
    distributorsEyebrow: "Партнери",
    distributorsHeading: "Знайдіть локального дистриб’ютора",
    distributorsIntro: "Зв’яжіться з офіційним дистриб’ютором inext у вашому регіоні.",
    distributorRegionUkraine: "Україна",
    distributorRegionPoland: "Польща",
    distributorRegionSlovakia: "Словаччина",
    distributorRegionMoldova: "Молдова",
    distributorRegionEuOperations: "Операції в ЄС",
    distributorRegionGlobal: "Глобально",
    privacyTitle: "Політика конфіденційності",
    privacyDescription: "Як inext обробляє інформацію, надіслану через цей сайт.",
    privacyEyebrow: "Юридична інформація",
    privacyHeading: "Політика конфіденційності",
    republishingTitle: "Використання матеріалів і ліцензування",
    republishingDescription:
      "Більшість статей inext доступні за ліцензією CC BY 4.0 — їх можна вільно повторно публікувати, перекладати й адаптувати з посиланням на джерело. Ось як.",
    republishingEyebrow: "Ліцензування",
    republishingHeading: "Як використовувати наші матеріали",
    blogLicenseLabel: "Ліцензія",
    blogLicenseAllRightsReserved: "Усі права захищено",
    blogLicenseReusableNote: "Цю статтю можна вільно опублікувати повторно з посиланням на inext.",
    blogLicenseReservedNote: "Будь ласка, зв'яжіться з нами перед повторною публікацією.",
    blogLicenseGuidelines: "Умови використання",
    republishKitToggle: "Опублікувати цю статтю у себе",
    republishKitIntro: "Ліцензія CC BY 4.0 — зазначайте inext і додавайте посилання.",
    republishCopyLink: "Копіювати посилання",
    republishCopyMarkdown: "Копіювати як Markdown",
    republishCopyHtml: "Копіювати як HTML",
    republishDownloadMarkdown: "Завантажити .md",
    republishDownloadHtml: "Завантажити .html",
    republishDownloadImages: "Завантажити зображення (.zip)",
    republishDownloadingImages: "Готуємо зображення…",
    republishDownloadAudio: "Завантажити аудіо",
    republishDownloadingAudio: "Готуємо аудіо…",
    republishCopied: "Скопійовано",
    republishContact: "Маєте запитання або потрібне зображення вищої роздільної здатності?",
    republishReservedNotice:
      "Цю статтю повторно опубліковано зі стороннього джерела, і вона недоступна за ліцензією CC BY 4.0.",
    republishCreditPrefix: "Першоджерело — inext, ",
    republishCreditSuffix: " — повторно опубліковано за ліцензією CC BY 4.0.",
    faqTitle: "FAQ inext",
    faqDescription:
      "Відповіді про STB inext, IPTV-рішення, кастомізацію, Alcatraz™ DMS, прошивки та усунення несправностей.",
    faqEyebrow: "Підтримка",
    faqHeading: "Поширені запитання",
    faqIntro:
      "Короткі відповіді про обладнання inext, рішення для операторів (IPTV-застосунок, брендинг, керування парком), прошивки та типові проблеми з пристроями.",
    faqCategoryAll: "Усі",
    faqCategoryDevices: "Пристрої та налаштування",
    faqCategoryFirmware: "Прошивка",
    faqCategorySolutions: "Рішення та застосунки",
    faqCategoryManagement: "Alcatraz™ DMS",
    faqCategoryTroubleshooting: "Усунення несправностей",
    faqQuestionCompare: "Яку STB inext обрати?",
    faqAnswerCompare:
      "TV6 Ultra — флагман для преміальних 4K-розгортань. TV6 поєднує продуктивність і вартість. TV5 Ultra підходить для масових IPTV/OTT-запусків; TV5 — базовий рівень. Використайте порівняння моделей, щоб підібрати памʼять, пульт і підключення під вашу мережу.",
    faqQuestionIptvMiddleware: "Яке IPTV-middleware підтримує застосунок inext IPTV?",
    faqAnswerIptvMiddleware:
      "Готовий IPTV-клієнт inext працює зі Stalker/Ministra, TVIP, Hibox, Aura та звичайними M3U-плейлистами з XMLTV EPG — у вашому брендингу та з попередньою конфігурацією ще до відправки приставок.",
    faqQuestionWhiteLabel: "У чому різниця між co-branding і white-labeling?",
    faqAnswerWhiteLabel:
      "Co-branding поєднує ваш бренд із inext на спільному обладнанні та в інтерфейсі. White-labeling повністю прибирає inext з коробки, прошивки та застосунків — абоненти бачать лише вашу айдентику.",
    faqQuestionRemoteApp: "Що таке застосунок inext Remote?",
    faqAnswerRemoteApp:
      "inext Remote — безкоштовний супутній застосунок для Android і iOS, який керує STB inext з телефона: клавіатура та голосовий пошук, перемикання кімнат, режим геймпада та світла/темна тема.",
    faqQuestionBuy: "Як купити продукти inext або стати партнером?",
    faqAnswerBuy:
      "inext продає операторам і дистрибʼюторам по всьому світу. Знайдіть авторизованого партнера поруч із вами або зверніться до відділу продажів щодо поставок, кастомізації та підключення Alcatraz™ DMS.",
    faqQuestionAlcatrazDeploy: "Чи може Alcatraz™ DMS працювати в нашій власній мережі?",
    faqAnswerAlcatrazDeploy:
      "Так. Alcatraz доступний як керований хмарний SaaS або як on-premises-інсталяція в закритій мережі провайдера — той самий інтерфейс і функціонал, модель розгортання обираєте ви з урахуванням вимог до даних.",
    faqQuestionAlcatrazIntegrate:
      "Чи можна інтегрувати Alcatraz із нашим BSS/OSS або інструментами підтримки?",
    faqAnswerAlcatrazIntegrate:
      "Так. Alcatraz надає документований REST API та підтримує MQTT. Адміністратори можуть створювати й відкликати API-ключі, обмежувати права та IP-адреси джерела, встановлювати строк дії, а також пов’язувати пристрої із записами в CRM або білінгу за допомогою зовнішніх ID.",
    faqQuestionHdmi: "Який стандарт HDMI підтримують пристрої inext?",
    faqAnswerHdmi:
      "Усі актуальні STB inext мають вихід HDMI 2.0a з підтримкою CEC. HDMI-кабель входить до комплекту.",
    faqQuestionResolution: "Чи всі пристрої inext підтримують 4K?",
    faqAnswerResolution:
      "Так — TV5, TV5 Ultra, TV6 і TV6 Ultra підтримують відтворення 4K UHD до 60 к/с завдяки апаратному декодуванню H.265, VP9 і H.264.",
    faqQuestionAndroid: "На якій версії Android працюють пристрої inext?",
    faqAnswerAndroid:
      "TV6 Ultra і TV6 працюють на Android 12 (AOSP). TV5 Ultra і TV5 працюють на Android 10 (AOSP). Усі моделі використовують відкритий AOSP без попередньо встановлених Google Play Services.",
    faqQuestionRemote: "Який пульт входить до комплекту?",
    faqAnswerRemote:
      "TV6 Ultra постачається з голосовим Bluetooth 5.0-пультом. TV6 зазвичай комплектується IR-пультом з повною цифровою клавіатурою, але в окремих регіонах може постачатися з Bluetooth-пультом. TV5 Ultra і TV5 комплектуються IR-пультом з повною цифровою клавіатурою.",
    faqQuestionFirmwares: "Де знайти офіційні прошивки?",
    faqAnswerFirmwares:
      "Актуальні прошивки для пристроїв inext доступні через OTA-оновлення. Перевірити оновлення можна на пристрої в розділі Налаштування → Про пристрій → Оновлення системи. Якщо виникли проблеми з оновленням, зверніться до нашого сервісного центру.",
    faqQuestionFirmwareCheck: "Як перевірити поточну версію прошивки?",
    faqAnswerFirmwareCheck:
      "Перейдіть у Налаштування → Про пристрій → Номер збірки. Там відображається версія прошивки та дата збірки.",
    faqQuestionOtaFleet: "Як працюють OTA-оновлення прошивки для операторів?",
    faqAnswerOtaFleet:
      "OTA-оновлення прошивки — це операторське рішення, інтегроване в платформу Alcatraz. Завантажте релізну версію, визначте цільові групи пристроїв і встановіть відсоток поетапного охоплення — платформа маршрутизує завантаження через найближчий вузол зберігання та відстежує статус встановлення на кожному пристрої. У будь‑який момент можна призупинити, розширити або відкотити оновлення, а критичні оновлення позначити як обов'язкові — пристрої не зможуть їх пропустити.",
    faqQuestionAlcatraz: "Що таке Alcatraz™ DMS?",
    faqAnswerAlcatraz:
      "Alcatraz™ DMS — платформа inext для віддаленого керування парком пристроїв. Оператори використовують розділ «Здоров’я пристроїв» для визначення пріоритетних проблем, переглядають активність пристроїв, розгортають OTA-прошивки, запускають діагностику та керують налаштуваннями з однієї консолі. Alcatraz Pro надається без додаткової плати для парків із менш ніж 500 активними пристроями. Для парків із 500 активними пристроями або більше доступ і комерційні умови узгоджуються безпосередньо з inext.",
    faqQuestionAlcatrazModels: "Які моделі підтримують Alcatraz™ DMS?",
    faqAnswerAlcatrazModels:
      "Усі чотири актуальні моделі inext — TV5, TV5 Ultra, TV6 і TV6 Ultra — постачаються з підтримкою Alcatraz™ DMS.",
    faqQuestionTr069: "Чи підтримується TR-069?",
    faqAnswerTr069:
      "Так. Усі актуальні моделі підтримують TR-069/CWMP поряд із Alcatraz, тож оператори з наявним ACS можуть продовжувати його використовувати. Alcatraz додає розширену телеметрію, push-сповіщення, віддалене керування в застосунку та сучасний REST API.",
    faqQuestionBlackScreen: "На пристрої чорний екран. Що робити?",
    faqAnswerBlackScreen:
      "Спочатку перезавантажте пристрій: від’єднайте inext від живлення, зачекайте 30 секунд і під’єднайте знову. Якщо це не допомогло, зверніться до нашого сервісного центру.",
    faqQuestionWifi: "Пристрій не підключається до Wi-Fi. Що робити?",
    faqAnswerWifi:
      "Переконайтеся, що пристрій у зоні дії роутера, а пароль введено правильно. Якщо це не допомогло: (1) перезавантажте пристрій і роутер, (2) забудьте мережу та підключіться повторно, (3) перевірте, що роутер транслює діапазон, який підтримує пристрій (2,4 ГГц або 5 ГГц). Якщо проблема лишається, зверніться до сервісного центру.",
    faqQuestionBlocked: "Пристрій повідомляє, що його заблоковано. Що робити?",
    faqAnswerBlocked:
      "Спершу зверніться до вашого інтернет-провайдера (ISP). Якщо провайдер не може допомогти, надішліть нам повідомлення через контактну форму.",
    faqContactTitle: "Залишилися запитання?",
    faqContactBody:
      "Наша команда підтримки та сервісні партнери допоможуть з питаннями щодо пристроїв, прошивок, IPTV-застосунку, кастомізації, провізіонінгу та інтеграції Alcatraz™ DMS.",
    faqContactCta: "Звернутися до підтримки",
    faqSearchPlaceholder: "Шукати запитання...",
    faqSearchClear: "Очистити пошук",
    faqNoResultsTitle: "Нічого не знайдено",
    faqNoResultsWithQuery:
      "За запитом «{query}» нічого не знайдено. Спробуйте інші ключові слова або очистіть пошук.",
    faqNoResultsCategory: "У цій категорії поки що немає запитань.",
    searchTitle: "Пошук inext",
    searchDescription: "Пошук по сайту inext, сторінках продуктів, підтримці та статтях блогу.",
    searchEyebrow: "Пошук",
    searchHeading: "Пошук по сайту inext",
    searchIntro:
      "Шукайте характеристики продуктів, відповіді підтримки, контакти дистриб’юторів, юридичну інформацію та статті блогу.",
    searchPlaceholder: "Шукайте продукти, підтримку, блог...",
    searchClear: "Очистити пошук",
    searchLoading: "Завантажуємо пошуковий індекс...",
    searchErrorTitle: "Пошук тимчасово недоступний",
    searchErrorBody:
      "Не вдалося завантажити пошуковий індекс. Оновіть сторінку або спробуйте пізніше.",
    searchNoQueryTitle: "Почніть із ключового слова",
    searchNoQueryBody:
      "Шукайте за назвою моделі, функцією, дистриб’ютором, темою підтримки або ключовим словом зі статті.",
    searchNoResultsTitle: "Нічого не знайдено",
    searchNoResultsBody:
      "За запитом «{query}» нічого не знайдено. Спробуйте коротшу фразу або інше ключове слово.",
    searchResultsCount: "{count} результатів за запитом «{query}»",
    searchTypePage: "Сторінка",
    searchTypeProduct: "Продукт",
    searchTypeBlog: "Блог",
    searchTypeSupport: "Підтримка",
    searchTypeLegal: "Юридичне",
    searchTypeApp: "Застосунок",
    blogTitle: "inext insights",
    blogDescription:
      "Огляди подій, новини продуктів та технічні інсайти для операторів IPTV та OTT.",
    blogReadMore: "Читати статтю",
    blogEmpty: "Для цього ринку поки що немає опублікованих статей.",
    blogFeatured: "Найновіше",
    blogFilterAll: "Усі",
    blogTagEvents: "Події",
    blogTagPartnerships: "Партнерства",
    blogTagProducts: "Продукти",
    blogTagSoftware: "Програмне забезпечення",
    blogTagCompany: "Компанія",
    blogLoadMore: "Показати більше",
    blogBackToTop: "Нагору",
    blogNewerPost: "Новіша стаття",
    blogOlderPost: "Старіша стаття",
    blogMediaAudio: "Містить аудіо",
    blogMediaVideo: "Містить відео",
    newsletterEyebrow: "Новини inext",
    newsletterTitle: "Нові продукти, оновлення прошивок і практичні матеріали для операторів.",
    newsletterDescription:
      "Отримуйте анонси продуктів, нові версії прошивок, оновлення Alcatraz DMS і практичні матеріали для ТВ-операторів.",
    newsletterSeoTitle: "Розсилка inext — новини про продукти й оновлення прошивок",
    newsletterSeoDescription:
      "Підпишіться на анонси продуктів inext, нові версії прошивок, оновлення Alcatraz DMS і практичні матеріали для ТВ-операторів.",
    newsletterPageBenefitProducts: "Нові ТВ-приставки й аксесуари",
    newsletterPageBenefitFirmware: "Нові версії прошивок і оновлення Alcatraz DMS",
    newsletterPageBenefitInsights: "Практичні матеріали для ТВ-операторів",
    newsletterPageFormTitle: "Підпишіться на новини inext",
    newsletterPageReassurance: "Лише важливі новини. Відписатися можна будь-коли.",
    newsletterEmailLabel: "Електронна пошта",
    newsletterEmailPlaceholder: "email@example.com",
    newsletterSubmit: "Підписатися",
    newsletterSubmitting: "Оформлюємо підписку…",
    newsletterSuccessTitle: "Підписку оформлено",
    newsletterSuccessBody: "Відтепер ви отримуватимете новини про продукти та оновлення від inext.",
    newsletterError: "Не вдалося оформити підписку. Спробуйте ще раз.",
    newsletterPrivacyPrefix:
      "Підписуючись, ви погоджуєтеся отримувати новини про продукти та оновлення від inext. Прочитайте нашу",
    newsletterPrivacyLink: "політику конфіденційності",
    newsletterWebsiteLabel: "Залиште це поле порожнім",
    newsEyebrow: "Новини",
    newsTitle: "Що нового в",
    newsTitleAccent: "inext",
    newsDescription: "Запуски продуктів, партнерства та нотатки з впроваджень в операторів.",
    newsViewAll: "Усі статті",
    notFoundTitle: "Сторінку не знайдено",
    notFoundBody: "Сторінка, яку ви шукаєте, не існує або була переміщена.",
    goHome: "На головну",
    errorTitle: "Сторінка не завантажилася",
    errorBody:
      "На нашому боці сталася помилка. Спробуйте оновити сторінку або поверніться на головну.",
    tryAgain: "Спробувати ще раз",
    compareTierFlagship: "Флагманська",
    compareTierPerformance: "Продуктивна",
    compareTierStandard: "Стандартна",
    compareTierEssential: "Базова",
    compareGroupPerformance: "Продуктивність",
    compareGroupConnectivity: "Підключення",
    compareGroupManagement: "Керування",
    compareGroupPhysical: "Фізичні параметри",
    compareGroupInBox: "У комплекті",
    compareRowOs: "Операційна система",
    compareRowChipset: "Чипсет",
    compareRowCpu: "Процесор",
    compareRowGpu: "Графіка",
    compareRowRam: "ОЗП",
    compareRowStorage: "Накопичувач",
    compareRowMaxRes: "Максимальна роздільна здатність",
    compareRowCodecs: "Відеокодеки",
    compareRowHdmi: "HDMI",
    compareRowEthernet: "Ethernet",
    compareRowWifi: "Wi-Fi",
    compareRowBluetooth: "Bluetooth",
    compareRowUsb: "USB",
    compareRowCardReader: "Кардрідер",
    compareRowAvOutput: "AV / аудіовихід",
    compareRowRemote: "Пульт",
    compareRowAlcatraz: "Alcatraz DMS",
    compareRowTr069: "TR-069",
    compareRowDimensions: "Розміри",
    compareRowPower: "Живлення",
    compareRowRemoteInBox: "Пульт керування",
    compareRowHdmiCable: "HDMI-кабель",
    compareRowPowerAdapter: "Блок живлення",
    compareRowBatteries: "Батарейки",
    compareRowGuide: "Короткий посібник",
    compareViewSpecs: "Переглянути характеристики",
    compareCtaTitle: "Потрібна допомога з вибором моделі?",
    compareCtaBody:
      "Розкажіть про вашу мережу, профіль абонентів і цільову ціну. Ми підберемо пристрій inext під ваш проєкт.",
    compareIncluded: "Входить",
    compareNotIncluded: "Не входить",
    compareModelTv6UltraTagline: "Флагманська Android 12-приставка для просунутих 4K-проєктів.",
    compareModelTv6UltraSpecRemote: "Bluetooth-пульт з голосом",
    compareModelTv6UltraHighlight1: "Найбільший обсяг ОЗП і пам’яті в лінійці",
    compareModelTv6UltraHighlight2: "Голосовий Bluetooth 5.0-пульт",
    compareModelTv6UltraHighlight3: "Alcatraz™ DMS + TR-069",
    compareModelTv6Tagline: "Збалансована Android 12-модель для щоденного IPTV та OTT.",
    compareModelTv6SpecRemote: "IR-пульт",
    compareModelTv6Highlight1: "Та сама платформа H618, що й у TV6 Ultra",
    compareModelTv6Highlight2: "Android 12 AOSP",
    compareModelTv6Highlight3: "Alcatraz™ DMS + TR-069",
    compareModelTv5UltraTagline: "Стабільна Android 10-модель з 2 ГБ ОЗП.",
    compareModelTv5UltraSpecRemote: "IR-пульт",
    compareModelTv5UltraHighlight1: "Перевірена платформа H313",
    compareModelTv5UltraHighlight2: "Alcatraz™ DMS + TR-069",
    compareModelTv5UltraHighlight3: "RCA AV-вихід для старіших телевізорів",
    compareModelTv5Tagline: "Базова Android 10-приставка для проєктів з обмеженим бюджетом.",
    compareModelTv5SpecRemote: "IR-пульт",
    compareModelTv5Highlight1: "Найекономніша модель у лінійці",
    compareModelTv5Highlight2: "Alcatraz™ DMS + TR-069",
    compareModelTv5Highlight3: "Апаратне декодування 4K@60",
    compareRemoteBtVoice: "BT Voice",
    compareRemoteIr: "IR",
    productPhotoComingSoon: "Фото продукту готується",
    productHardwarePhotoComingSoon: "Фото обладнання готується",
    productSoftwarePhotoComingSoon: "Фото програмного середовища готується",
    productSoftwareLifestyleImageAlt:
      "Телевізор з нейтральним операторським лаунчером: Live TV, VOD, catch-up, радіо, застосунки та налаштування",
    tv6HeroImageAlt:
      "inext TV6 на столі у вітальні; на екрані телевізора inext TV, MEGOGO, sweet.tv, IPTV, Plex, VLC і Spotify",
    tv6PortsImageAlt:
      "Задні порти inext TV6: microSD, 2× USB, порт ІЧ-подовжувача або AV (залежно від версії), S/PDIF, Ethernet, HDMI, DC 5V",
    tv6RemoteImageAlt:
      "IR-пульт inext TV6 з повною цифровою клавіатурою, навігаційним блоком і кнопками відтворення",
    tv6HardwareRevealLabel: "Показати внутрішнє обладнання TV6",
    tv6HardwareRevealImageAlt:
      "Вигляд inext TV6 зверху з інтерактивним відкриттям внутрішнього обладнання",
    tv6UltraHeroImageAlt:
      "inext TV6 Ultra на консолі у вітальні; на екрані телевізора inext TV, MEGOGO, sweet.tv, IPTV, Plex, VLC і Spotify",
    tv6UltraPortsImageAlt:
      "Задні порти inext TV6 Ultra: microSD, 2× USB, AV, S/PDIF, Ethernet, HDMI, DC 5V",
    tv5PortsImageAlt:
      "Задні порти inext TV5: AV, оптичний S/PDIF, Ethernet, HDMI, живлення DC, 2× USB, microSD",
    tv5RemoteImageAlt:
      "Пульт дистанційного керування inext TV5 з кнопкою OK, цифровими та швидкими клавішами",
    tv5HardwareRevealLabel: "Показати внутрішнє обладнання TV5",
    tv5HardwareRevealImageAlt:
      "Вигляд inext TV5 зверху з інтерактивним відкриттям внутрішнього обладнання",
    tv5SoftwareImageAlt: "Телевізор із кастомним IPTV-лаунчером над приставкою inext TV5",
    tv6UltraRemoteImageAlt:
      "Голосовий Bluetooth-пульт inext з мікрофоном, програмованою кнопкою живлення TV і кнопками FAV",
    tv6UltraHardwareRevealLabel: "Показати внутрішнє обладнання TV6 Ultra",
    tv6UltraHardwareRevealImageAlt:
      "Вигляд inext TV6 Ultra зверху з інтерактивним відкриттям внутрішнього обладнання",
    tv5UltraSeoTitle: "inext TV5 Ultra — Android 10 Set-Top Box для операторів",
    tv5UltraSeoDescription:
      "inext TV5 Ultra: Allwinner H313, 2 ГБ ОЗП, 16 ГБ eMMC, відтворення 4K@60, двосмуговий Wi-Fi, Android 10 AOSP та Alcatraz™ DMS для операторських проєктів.",
    tv5SeoTitle: "inext TV5 — базовий Android 10 Set-Top Box для операторів",
    tv5SeoDescription:
      "inext TV5: Allwinner H313, 1 ГБ ОЗП, 8 ГБ eMMC, відтворення 4K@60, двосмуговий Wi-Fi, Android 10 AOSP та Alcatraz™ DMS для економних IPTV та OTT-проєктів.",
    tv5UltraHeroEyebrow: "Стандарт · Android 10 STB",
    tv5UltraHeroHeadline: "Перевірена Android-приставка для стабільних операторських впроваджень.",
    tv5UltraHeroSub:
      "TV5 Ultra поєднує надійну платформу Allwinner H313, 2 ГБ ОЗП, 16 ГБ пам’яті, практичні варіанти підключення та підтримку inext Alcatraz™ DMS.",
    tv5UltraHeroImageAlt: "inext TV5 Ultra на тумбі під телевізором із запущеним лаунчером inext",
    tv5UltraHardwareRevealLabel: "Показати внутрішнє обладнання TV5 Ultra",
    tv5UltraHardwareRevealImageAlt:
      "Вигляд inext TV5 Ultra зверху з інтерактивним відкриттям внутрішнього обладнання",
    tv5UltraSoftwareImageAlt:
      "Телевізор із кастомним операторським лаунчером над приставкою inext TV5 Ultra",
    tv5UltraCompareLabel: "Порівняти всі моделі",
    tv5UltraGlanceValue1: "4K @ 60 Гц",
    tv5UltraGlanceLabel1: "Відтворення H.265",
    tv5UltraGlanceValue2: "Android 10",
    tv5UltraGlanceLabel2: "AOSP, готовий до застосунків",
    tv5UltraGlanceValue3: "2 ГБ / 16 ГБ",
    tv5UltraGlanceLabel3: "DDR3 + eMMC",
    tv5UltraGlanceValue4: "IR-пульт",
    tv5UltraGlanceLabel4: "Просте керування",
    tv5UltraIntroPara1:
      "TV5 Ultra створена для операторів, яким потрібна стабільна Android 10-приставка з достатньою пам’яттю для щоденних IPTV, OTT і сценаріїв лаунчера.",
    tv5UltraIntroPara2:
      "Вона робить розгортання практичним: перевірене обладнання, звичне IR-керування, широка підтримка медіа та віддалене керування через Alcatraz™ DMS.",
    tv5UltraPerformanceTitle: "Перевірене 4K із запасом потужності.",
    tv5UltraPerformanceBody:
      "Allwinner H313 з Mali-G31 MP2 забезпечує TV5 Ultra надійне 4K@60 H.265-відтворення для IPTV, OTT і сценаріїв лаунчера, а 2 ГБ ОЗП і 16 ГБ eMMC достатньо для щоденних операторських проєктів.",
    tv5UltraPerformanceAccent: "Allwinner H313 · 2 ГБ DDR3 · 16 ГБ eMMC · 4K@60 H.265",
    tv5UltraConnectivityCaption:
      "HDMI 2.0a · Ethernet 100 Мб · 2× USB 2.0 · microSD · оптичний S/PDIF · RCA AV-вихід · двосмуговий Wi-Fi 2,4/5 ГГц.",
    tv5UltraPortsImageAlt:
      "Задні порти inext TV5 Ultra — оптичний S/PDIF, LAN, HDMI, USB і microSD",
    tv5UltraSoftwareTitle: "Android 10, налаштований під операторські застосунки.",
    tv5UltraSoftwareBody:
      "Android 10 AOSP дає операторам знайому платформу застосунків, можливості кастомного лаунчера та віддалені сценарії керування парком через Alcatraz™ DMS і TR-069.",
    tv5UltraRemoteFeature1: "Повна цифрова клавіатура для IPTV-сервісів з каналами",
    tv5UltraRemoteFeature2: "Окремі кнопки навігації та відтворення",
    tv5UltraRemoteFeature3: "IR-керування для простого налаштування в абонента",
    tv5UltraAlcatrazBody:
      "TV5 Ultra можна провізіонувати, моніторити й оновлювати через ті самі сценарії Alcatraz, що використовуються в усій лінійці inext.",
    tv5UltraCtaTitle: "Замовте TV5 Ultra для вашої мережі",
    tv5UltraCtaBody:
      "Практична Android 10 STB з 2 ГБ ОЗП, 16 ГБ пам’яті, брендованим пакуванням і провізіонінгом Alcatraz™.",
    tv5HeroEyebrow: "Базова · Android 10 STB",
    tv5HeroHeadline: "Економна Android TV-приставка для базових IPTV-проєктів.",
    tv5HeroSub:
      "TV5 робить операторський стек inext доступним: Android 10, 4K-відтворення на H313, 1 ГБ ОЗП, 8 ГБ пам’яті та підтримка Alcatraz™ DMS.",
    tv5CompareLabel: "Порівняти всі моделі",
    tv5GlanceValue1: "4K @ 60 Гц",
    tv5GlanceLabel1: "Відтворення H.265",
    tv5GlanceValue2: "Android 10",
    tv5GlanceLabel2: "AOSP, готовий до застосунків",
    tv5GlanceValue3: "1 ГБ / 8 ГБ",
    tv5GlanceLabel3: "DDR3 + eMMC",
    tv5GlanceValue4: "IR-пульт",
    tv5GlanceLabel4: "Просте керування",
    tv5IntroPara1:
      "TV5 — вхідна модель операторської лінійки inext: компактне обладнання, Android 10 AOSP і базові можливості підключення для керованих IPTV та OTT-сервісів.",
    tv5IntroPara2:
      "Вона створена для проєктів, де найважливішими є низька вартість пристрою, передбачуване відтворення та контроль парку.",
    tv5PerformanceTitle: "Надійне 4K за помірний бюджет.",
    tv5PerformanceBody:
      "Allwinner H313 з Mali-G31 MP2 забезпечує TV5 надійне 4K@60 H.265-відтворення для базових IPTV та OTT-сервісів, а 1 ГБ ОЗП і 8 ГБ eMMC підходять для операторських проєктів з обмеженим бюджетом.",
    tv5PerformanceAccent: "Allwinner H313 · 1 ГБ DDR3 · 8 ГБ eMMC · 4K@60 H.265",
    tv5ConnectivityCaption:
      "HDMI 2.0a · Ethernet 100 Мб · 2× USB 2.0 · microSD · оптичний S/PDIF · RCA AV-вихід · двосмуговий Wi-Fi 2,4/5 ГГц.",
    tv5SoftwareTitle: "Android 10 для базових сервісів.",
    tv5SoftwareBody:
      "TV5 підтримує операторські лаунчери, IPTV та OTT-застосунки, локалізацію й віддалене керування парком через Alcatraz™ DMS і TR-069.",
    tv5RemoteFeature1: "Цифрова клавіатура для навігації по каналах",
    tv5RemoteFeature2: "Окремі кнопки відтворення та меню",
    tv5RemoteFeature3: "Просте IR-налаштування для домівок абонентів",
    tv5AlcatrazBody:
      "TV5 можна провізіонувати, моніторити й оновлювати через Alcatraz™ DMS, щоб економні проєкти залишалися керованими в масштабі.",
    tv5CtaTitle: "Замовте TV5 для вашої мережі",
    tv5CtaBody:
      "Економний пакет Android STB з брендованим пакуванням і провізіонінгом Alcatraz™ для базових IPTV та OTT-проєктів.",
    tv6SeoTitle: "inext TV6 — 4K Android 12 Set-Top Box для операторів",
    tv6SeoDescription:
      "inext TV6: Allwinner H618, 2 ГБ ОЗП, 16 ГБ eMMC, 4K@60 HDR, двосмуговий Wi-Fi, Android 12 AOSP та Alcatraz™ DMS. Компактний STB для ISP, готелів та OTT-операторів.",
    tv6UltraSpec3dValue: "Side-by-side · Frame-packed",
    tv6UltraSpecMaxResValue: "4K UHD (2160p) @ 60 к/с",
    tv6PackageRemote: "IR-пульт керування",
    packageNote:
      "Комплектація може відрізнятися залежно від ринку, партії постачання та конфігурації оператора.",
    tv6HeroEyebrow: "Базова · 4K Android 12 STB",
    tv6HeroHeadline: "Компактна потужність для щоденного IPTV та OTT.",
    tv6HeroSub:
      "Практична Android 12-приставка для операторських проєктів, де потрібні надійне 4K-відтворення, перевірене підключення та керування Alcatraz™ DMS без флагманського запасу пам’яті.",
    tv6CompareLabel: "Порівняти з TV6 Ultra",
    tv6GlanceValue1: "4K @ 60 Гц",
    tv6GlanceLabel1: "HDR · H.265",
    tv6GlanceValue2: "Android 12",
    tv6GlanceLabel2: "AOSP, готовий до застосунків",
    tv6GlanceValue3: "2 ГБ / 16 ГБ",
    tv6GlanceLabel3: "DDR3 + eMMC",
    tv6GlanceValue4: "IR-пульт",
    tv6GlanceLabel4: "Просте керування",
    tv6IntroPara1:
      "TV6 переносить операторський підхід inext у компактний і економний пристрій: підтримка 4K-відео, Android 12 AOSP, практичне домашнє підключення та віддалене керування парком.",
    tv6IntroPara2:
      "Вона створена для проєктів, де передбачуваний абонентський досвід, простий провізіонінг і довгострокова підтримка важливіші за надлишкові характеристики.",
    tv6PerformanceAccent: "Allwinner H618 · 2 ГБ DDR3 · 16 ГБ eMMC · 4K@60 H.265",
    tv6ConnectivityCaption:
      "HDMI 2.0a · Ethernet 100 Мб · 2× USB 2.0 · microSD · оптичний S/PDIF · окремий порт ІЧ-подовжувача або AV-порт залежно від версії TV6 · двосмуговий Wi-Fi 2,4/5 ГГц · Bluetooth 5.0.",
    tv6RemoteEyebrow: "Пульт",
    tv6RemoteTitle: "Просте IR-керування для щоденного перегляду.",
    tv6RemoteBody:
      "IR-пульт у комплекті зберігає звичний досвід у вітальні: цифрова клавіатура, навігаційні кнопки, керування відтворенням і швидкі сценарії, зручні для IPTV-абонентів.",
    tv5RemoteTitle: "Звичний пульт у комплекті.",
    tv5RemoteBody:
      "TV5 постачається з класичним IR-пультом — цифрова клавіатура, навігація D-pad і кнопки відтворення, тож перше налаштування одразу відчувається звичним.",
    tv5UltraRemoteTitle: "Класичний IR-пульт у кожній коробці.",
    tv5UltraRemoteBody:
      "TV5 Ultra комплектується тим самим надійним IR-пультом: повна цифрова клавіатура, навігаційний блок і прямі кнопки відтворення — готовий до підключення з коробки.",
    tv6PerformanceTitle: "Плавне 4K без флагманської ціни.",
    tv6PerformanceBody:
      "Чотириядерний Allwinner H618 з Mali-G31 MP2 апаратно декодує H.265, VP9 Profile 2 і H.264 — надійне відтворення 4K для масових IPTV- та OTT-добірок.",
    tv6SoftwareTitle: "Android 12 із простором для розвитку.",
    tv6SoftwareBody:
      "Відкритий Android 12 (AOSP) з Bluetooth, дводіапазонним Wi-Fi і операторським лаунчером — гнучка основа для брендованих застосунків, OTT-сервісів і казуальних ігор.",
    tv6RemoteFeature1: "Повна цифрова клавіатура для сервісів з каналами",
    tv6RemoteFeature2: "Окремі кнопки навігації та відтворення",
    tv6RemoteFeature3:
      "Окремий порт ІЧ-подовжувача у сумісних версіях TV6; версії з AV-портом не підтримують подовжувач",
    tv6RemoteBtNoteTitle: "Пульт на ваш вибір",
    tv6RemoteBtNoteBody:
      "Вбудований модуль Bluetooth дозволяє замовити TV6 з будь-яким пультом із нашого асортименту — IR чи Bluetooth. У деяких регіонах він за замовчуванням постачається з Bluetooth-пультом.",
    tv6RemoteBtNoteLink: "Переглянути пульти",
    tv5RemoteIrNoteTitle: "IR-пульт на ваш вибір",
    tv5RemoteIrNoteBody:
      "Постачається з класичним IR-пультом, але його можна замовити з будь-яким IR-пультом із нашого асортименту — зокрема з програмованими моделями, які керують приставкою й телевізором одночасно.",
    tv6IrAvPortLabel: "Порт 3.5 мм",
    tv6IrAvPortSpec:
      "Залежно від ринку: окремий порт ІЧ-подовжувача або AV; версії з AV-портом несумісні з ІЧ-подовжувачем",
    tv6AlcatrazBody:
      "Кожну TV6 можна провізіонувати, моніторити й оновлювати через систему керування пристроями inext Alcatraz, яку використовують операторські мережі по всьому світу.",
    tv6CtaTitle: "Замовте TV6 для вашої мережі",
    tv6CtaBody:
      "Оптові ціни, брендоване пакування та провізіонінг Alcatraz™ для практичних IPTV та OTT-проєктів.",
    trustedBy: "inext обирають понад 250 операторів і ТВ-провайдерів у 15 країнах",
    operationsStatPill: "Працює у 120+ операторських мережах по всьому світу",
    distributorContactCtaTitle: "Не знаєте, до кого звернутися?",
    distributorContactCtaBody:
      "Розкажіть нам про ваш ринок і проєкт. Ми скеруємо запит до відповідного дистриб’ютора або напряму до команди продажів inext.",
    distributorContactCtaButton: "Зв’язатися з inext",
    contactRoutingLabel: "Глобальні продажі та маршрутизація до дистриб’юторів",
    tv6UltraSeoTitle: "inext TV6 Ultra — 4K Android 12 Set-Top Box для операторів",
    tv6UltraSeoDescription:
      "inext TV6 Ultra: Allwinner H618, 4 ГБ ОЗП, 32 ГБ eMMC, 4K@60 HDR, Wi-Fi 2,4/5 ГГц, BT 5.0, Android 12 AOSP та Alcatraz™ DMS. Для провайдерів, готелів та OTT-операторів.",
    tv6UltraBreadcrumbHome: "Головна",
    tv6UltraBreadcrumbProducts: "Продукти",
    tv6UltraContactSales: "Зв’язатися з продажами",
    tv6UltraFindDistributor: "Знайти дистриб’ютора",
    tv6UltraAlcatrazTitle: "Під керуванням Alcatraz™ DMS",
    tv6UltraAlcatrazBody:
      "Кожна TV6 Ultra готова до системи керування пристроями inext Alcatraz — нею вже користуються 120+ операторських мереж у світі.",
    tv6UltraAlcatrazCta: "Дізнатися більше",
    tv6UltraCtaTitle: "Замовте TV6 Ultra для вашої мережі",
    tv6UltraCtaBody:
      "Оптові ціни, white-label упаковка та провізіонінг через Alcatraz™ — від однієї команди.",
    tv6UltraSpecChipset: "Чипсет",
    tv6UltraSpecCpu: "Процесор",
    tv6UltraSpecGpu: "Графіка",
    tv6UltraSpecRam: "Оперативна пам’ять",
    tv6UltraSpecStorage: "Накопичувач",
    tv6UltraSpecDimensions: "Розміри",
    tv6UltraSpecPower: "Живлення",
    tv6UltraSpecHdmi: "HDMI",
    tv6UltraSpecEthernet: "Ethernet",
    tv6UltraSpecWifi: "Wi-Fi",
    tv6UltraSpecBluetooth: "Bluetooth",
    tv6UltraSpecUsb: "USB",
    tv6UltraSpecCardReader: "Кардрідер",
    tv6UltraSpecAudioOut: "Аудіовихід",
    tv6UltraSpecAudioFormats: "Аудіоформати",
    tv6UltraSpecVideoFormats: "Відеоформати",
    tv6UltraSpecVideoCodecs: "Відеокодеки",
    tv6UltraSpecMaxRes: "Максимальна роздільна здатність",
    tv6UltraSpec3d: "Підтримка 3D",
    tv6UltraSpecImageFormats: "Формати зображень",
    tv6UltraSpecOs: "Операційна система",
    tv6UltraSpecDms: "Керування пристроями",
    tv6UltraSpecTr069: "TR-069",
    tv6UltraSpecFilesystems: "Файлові системи",
    tv6UltraSpecLanguages: "Мови",
    tv6UltraSpecInternet: "Інтернет-функції",
    tv6UltraSpecTr069Yes: "Підтримується",
    tv6UltraSpecLanguagesValue: "Багатомовний",
    productSpecCpuArmv8Quad: "Чотириядерний ARM v8 Cortex-A53",
    productSpecCpuQuadCoreArm: "Чотириядерний ARM Cortex-A53",
    productSpecHdmiCableIncluded: "HDMI 2.0a (кабель у комплекті)",
    productSpecEthernet100: "RJ45 Fast Ethernet (100 Мбіт/с)",
    productSpecWifiDualBandN: "Дводіапазонний 2,4 / 5 ГГц · 802.11 b/g/n",
    productSpecWifiDualBandAc: "Дводіапазонний 2,4 / 5 ГГц · 802.11 b/g/n/ac",
    productSpecUsbHost: "2 × USB 2.0 у режимі хоста",
    productSpecAudioSpdifRcaTrs: "Оптичний S/PDIF · RCA через 3,5 мм TRS",
    productSpecAudioSpdif: "Оптичний S/PDIF",
    productSpecAudioSpdifRca: "Оптичний S/PDIF · RCA (3,5 мм TRS)",
    productSpecInternetFeatures:
      "IPTV · OTT · VOD · HLS · інтернет-радіо · HTML5 · WebKit · Android-застосунки",
    tv6UltraPackageRemote: "Bluetooth-пульт",
    tv6UltraPackagePower: "Блок живлення (5 В / 2 А)",
    tv6UltraPackageHdmi: "HDMI-кабель",
    tv6UltraPackageGuide: "Короткий посібник",
    tv6UltraPackageBatteries: "Батарейки",
    tv6UltraV2HeroEyebrow: "Флагман · 4K Android 12 ТВ-приставка",
    tv6UltraV2HeroHeadline: "Максимум потужності для максимуму контенту.",
    tv6UltraV2HeroSub:
      "Медіахаб операторського рівня — і для вітальні абонента, і для вашої команди підтримки.",
    tv6UltraCompareLabel: "Порівняти всі моделі",
    tv6UltraV2IntroPara1:
      "TV6 Ultra — флагман лінійки inext: удвічі більше ОЗП і пам’яті, ніж у TV6, апаратне 4K@60 і той самий Alcatraz™ DMS, який уже працює у 120+ операторських мережах світу.",
    tv6UltraV2IntroPara2:
      "Створена так, щоб непомітно вписатися у вітальню і не турбувати службу підтримки — швидке провізіонування, легкі оновлення, тиха робота.",
    tv6UltraV2PerformanceEyebrow: "Продуктивність",
    tv6UltraV2PerformanceTitle: "Невимушене 4K. Будь-який кодек.",
    tv6UltraV2PerformanceBody:
      "Чотириядерний Allwinner H618 з Mali-G31 MP2 апаратно декодує H.265, VP9 Profile 2 і H.264 — 4K-стріми, VOD і застосунки залишаються плавними навіть під навантаженням.",
    tv6UltraV2PerformanceAccent: "Allwinner H618 · 4 ГБ DDR3 · 32 ГБ eMMC · 4K@60 H.265",
    tv6UltraV2ConnectivityEyebrow: "Підключення",
    tv6UltraV2ConnectivityTitle: "Усі порти, які потрібні абонентам.",
    tv5ConnectivityTitle: "Усі необхідні порти — вже в комплекті.",
    tv5UltraConnectivityTitle: "Уся потрібна периферія для встановлення.",
    tv6ConnectivityTitle: "Дріт, Wi-Fi і Bluetooth — усе є.",
    tv6UltraV2ConnectivityCaption:
      "HDMI 2.0a · Ethernet 100 Мб · 2× USB 2.0 · microSD · S/PDIF · AV · Wi-Fi 2,4/5 ГГц · Bluetooth 5.0.",
    tv6UltraV2SoftwareEyebrow: "Програмне забезпечення",
    tv6UltraV2SoftwareTitle: "Android 12 — готовий з коробки.",
    tv6UltraV2SoftwareBody:
      "Відкритий Android 12 (AOSP) з операторським лаунчером, гнучким брендингом і TR-069 + Alcatraz™ DMS для команди, що керує кожним встановленим пристроєм.",
    tv6UltraV2SoftwareCustomTitle1: "Операторський лаунчер",
    tv6UltraV2SoftwareCustomBody1:
      "Адаптуйте головний екран під структуру вашого сервісу: Live TV, VOD, catch-up, радіо, застосунки, налаштування та звичні маршрути перегляду.",
    tv6UltraV2SoftwareCustomTitle2: "Бренд і локальний ринок",
    tv6UltraV2SoftwareCustomBody2:
      "Адаптуйте логотипи, кольори, мову, стартові розділи та попередньо встановлені сервіси для кожного оператора або регіону.",
    tv6UltraV2SoftwareCustomTitle3: "Віддалене керування парком",
    tv6UltraV2SoftwareCustomBody3:
      "Alcatraz™ DMS і TR-069 допомагають провізіонувати пристрої, встановлювати оновлення, керувати налаштуваннями та зменшувати навантаження на підтримку.",
    tv6UltraV2SpecsTitle: "Повні технічні характеристики",
    tv6UltraV2SpecsGroupHardware: "Апаратне забезпечення",
    tv6UltraV2SpecsGroupConnectivity: "Підключення",
    tv6UltraV2SpecsGroupMedia: "Медіа",
    tv6UltraV2SpecsGroupSoftware: "Програмне забезпечення",
    tv6UltraV2SpecsGroupPackage: "У комплекті",
    tv6UltraV2RemoteEyebrow: "Пульт",
    tv6UltraV2RemoteTitle: "Bluetooth-пульт з мікрофоном — створений для вітальні.",
    tv6UltraV2RemoteBody:
      "Сполучається по Bluetooth — без необхідності цілитися в приставку. Вбудований мікрофон забезпечує голосовий пошук у лаунчері та застосунках, а програмована кнопка живлення телевізора й кастомізована кнопка обраного дають абоненту персоналізувати пульт під себе.",
    tv6UltraV2RemoteFeatureBt: "Bluetooth 5.0 — без прямої видимості",
    tv6UltraV2RemoteFeatureMic: "Вбудований мікрофон для голосового пошуку",
    tv6UltraV2RemoteFeatureTvPower: "Програмована кнопка живлення TV",
    tv6UltraV2RemoteFeatureFav: "Кастомізована кнопка «Обране» (FAV)",
    tv6UltraV2RemoteNoteBody:
      "TV6 Ultra за замовчуванням постачається з голосовим пультом Bluetooth, але ви можете замовити його з будь-яким пультом із нашого асортименту — Bluetooth чи IR — під свій ринок.",
    tv6UltraV2GlanceValue1: "4K @ 60 Гц",
    tv6UltraV2GlanceLabel1: "HDR · H.265",
    tv6UltraV2GlanceValue2: "Android 12",
    tv6UltraV2GlanceLabel2: "AOSP, готовий до застосунків",
    tv6UltraV2GlanceValue3: "4 ГБ / 32 ГБ",
    tv6UltraV2GlanceLabel3: "DDR3 + eMMC",
    tv6UltraV2GlanceValue4: "BT 5.0 пульт",
    tv6UltraV2GlanceLabel4: "Голос + FAV",
    remoteAppMenuLabel: "Застосунок inext Remote",
    remoteAppProductCallout:
      "Бажаєте керувати з телефона? Завантажте безкоштовний застосунок inext Remote",
    footerLinkRemoteApp: "Застосунок-пульт",
    remoteAppSeoTitle: "inext Remote — мобільний застосунок-пульт для inext STB",
    remoteAppSeoDescription:
      "Завантажте безкоштовний inext Remote для Android та iOS. Керуйте inext STB, перемикайте кімнати, шукайте голосом або з клавіатури, вводьте текст, використовуйте геймпад і світлу чи темну тему.",
    remoteAppBreadcrumbApps: "Застосунки",
    remoteAppHeroEyebrow: "Безкоштовний застосунок для вашої inext ТВ-приставки",
    remoteAppHeroTitle: "Ваш пульт від телевізора — тепер у телефоні.",
    remoteAppHeroBody:
      "inext Remote перетворює ваш телефон на повноцінний пульт для inext ТВ-приставки: швидко набирайте текст, шукайте голосом, перемикайтеся між кімнатами, грайте в ігри, гортайте для навігації та обирайте світлу чи темну тему.",
    remoteAppAppleBadgeAlt: "Завантажити inext Remote в App Store",
    remoteAppGoogleBadgeAlt: "Завантажити inext Remote в Google Play",
    remoteAppHeroImageAlt: "Екран керування мобільного застосунку inext Remote",
    remoteAppStatDownloadsValue: "500K+",
    remoteAppStatDownloadsLabel: "завантажень",
    remoteAppStatModesValue: "D-pad + свайпи",
    remoteAppStatModesLabel: "режими керування",
    remoteAppStatThemesValue: "Світла + темна",
    remoteAppStatThemesLabel: "теми",
    remoteAppFeaturesEyebrow: "Чому вам сподобається",
    remoteAppFeaturesTitle: "Усе, що ви хочете від сучасного пульта.",
    remoteAppFeaturesBody:
      "Щоденне керування TV завжди під рукою, а ще — те, чого не вміє звичайний пульт: зручне введення тексту, швидкий пошук, кілька кімнат і прості ігри.",
    remoteAppFeatureControlTitle: "Пульт, який просто працює",
    remoteAppFeatureControlBody:
      "Навігація, пауза, відтворення, гучність та всі звичні TV-кнопки — прямо з вашого телефона.",
    remoteAppFeatureRoomsTitle: "Перемикання пристроїв і кімнат",
    remoteAppFeatureRoomsBody:
      "Перемикайтеся між своїми inext-пристроями за секунди, коли вдома кілька екранів.",
    remoteAppFeatureVoiceTitle: "Голос і швидкий пошук",
    remoteAppFeatureVoiceBody:
      "Шукайте контент голосом або з мобільної клавіатури швидше, ніж фізичним пультом.",
    remoteAppFeatureKeyboardTitle: "Просте введення тексту",
    remoteAppFeatureKeyboardBody:
      "Вводьте логіни, пошукові запити та текст у застосунках з клавіатури телефона, без посимвольного кліку.",
    remoteAppFeatureGamepadTitle: "Режим геймпада",
    remoteAppFeatureGamepadBody:
      "Перетворіть телефон на простий ігровий контролер для ігор та інтерактивних TV-сценаріїв.",
    remoteAppFeatureModesTitle: "D-pad або жести",
    remoteAppFeatureModesBody:
      "Користуйтеся класичними кнопками напрямків або перемикайтеся на свайпи й жести, коли так швидше.",
    remoteAppModesEyebrow: "Режими керування",
    remoteAppModesTitle: "Пульт, клавіатура і геймпад в одному застосунку.",
    remoteAppModesBody:
      "Залишайтеся у звичному D-pad для TV, перейдіть на жести для швидшої навігації, відкрийте клавіатуру для пошуку або поверніть телефон у режим геймпада.",
    remoteAppModeDpad: "Класичний D-pad",
    remoteAppModeSwipe: "Свайпи та жести",
    remoteAppGamepadImageAlt: "Скриншот режиму геймпада в inext Remote",
    remoteAppVideoEyebrow: "Подивіться в дії",
    remoteAppVideoTitle: "inext Remote у дії.",
    remoteAppVideoBody:
      "Короткий огляд усього, що вміє застосунок — пульт, клавіатура, голос, кімнати, геймпад і теми.",
    remoteAppVideoIframeTitle: "Відео-демонстрація застосунку inext Remote",
    remoteAppScreensEyebrow: "Скриншоти",
    remoteAppScreensTitle: "Створено під те, як ви дивитеся.",
    remoteAppScreensBody:
      "Перегляньте головний пульт, пристрої, цифрову клавіатуру, введення тексту, геймпад і теми мобільного застосунку.",
    remoteAppScreenshotAlt: "Скриншот застосунку inext Remote",
    remoteAppThemesEyebrow: "Вигляд",
    remoteAppThemesTitle: "Комфортно у світлій і темній кімнаті.",
    remoteAppThemesBody:
      "І світла, і темна теми мають чудовий вигляд — ідеально для дня, вечірнього перегляду чи під налаштування вашого телефона.",
    remoteAppLightTheme: "Світла тема",
    remoteAppLightThemeBody: "Чисте керування для денного використання та світлих кімнат.",
    remoteAppDarkTheme: "Темна тема",
    remoteAppDarkThemeBody: "Менше світла для вечірнього перегляду.",
    remoteAppCtaEyebrow: "Завантажте безкоштовно",
    remoteAppCtaTitle: "Встановіть inext Remote на телефон.",
    remoteAppCtaBody:
      "Завантажте безкоштовний застосунок з Google Play або App Store і за лічені секунди прив’яжіть його до вашої inext ТВ-приставки.",
    navSolutions: "Рішення",
    navSolutionsAlcatraz: "Alcatraz DMS",
    navSolutionsAlcatrazDesc: "Проактивний моніторинг парку та віддалене керування",
    footerLinkAlcatrazDms: "Alcatraz DMS",
    operationsLearnMore: "Дізнатися більше про Alcatraz DMS",
    alcatrazBreadcrumbHome: "Головна",
    alcatrazBreadcrumbSolutions: "Рішення",
    alcatrazBreadcrumbPage: "Alcatraz DMS",
    alcatrazSeoTitle: "inext Alcatraz DMS — керування пристроями для IPTV-операторів",
    alcatrazSeoDescription:
      "Хмарне або локальне керування приставками inext зі здоров’ям пристроїв, історією активності, віддаленою діагностикою та контрольованими OTA-оновленнями.",
    alcatrazTrialSeoTitle: "Безкоштовний пробний доступ до Alcatraz Pro на 3 місяці | inext",
    alcatrazTrialSeoDescription:
      "Отримайте безкоштовний тримісячний доступ до Alcatraz Pro — з приставками inext у вашій мережі або з демо-зразком, який ми надішлемо.",
    alcatrazTrialBreadcrumb: "3 місяці безкоштовно",
    alcatrazTrialEyebrow: "Для ISP і ТВ-провайдерів",
    alcatrazTrialTitle: "Спробуйте Alcatraz Pro безкоштовно протягом 3 місяців",
    alcatrazTrialIntro:
      "Дізнайтеся, як Alcatraz Pro працює з приставками inext — тими, що вже є у вашій мережі, або з демо-зразком, який ми надішлемо. Наша команда допоможе розпочати роботу — без платіжної картки та довгострокових зобов’язань.",
    alcatrazTrialBenefitFree: "Повний доступ до Alcatraz Pro на три місяці",
    alcatrazTrialBenefitExisting:
      "Використовуйте наявні приставки inext — або отримайте від нас демо-зразок",
    alcatrazTrialBenefitGuided: "Допомога команди inext із налаштуванням",
    alcatrazTrialStepsTitle: "Як це працює",
    alcatrazTrialStep1: "Надішліть запит",
    alcatrazTrialStep2: "Ми перевіримо дані компанії",
    alcatrazTrialStep3: "Налаштуємо доступ і допоможемо розпочати",
    alcatrazTrialFeaturesLink: "Переглянути функції та варіанти розгортання",
    alcatrazTrialDashboardAlt: "Панель керування парком пристроїв Alcatraz Pro",
    alcatrazTrialFormTitle: "Почніть безкоштовний доступ на 3 місяці",
    alcatrazTrialFormIntro:
      "Вкажіть, як з вами зв’язатися. Ми перевіримо дані компанії та допоможемо розпочати роботу.",
    alcatrazTrialDemoOption: "Хочу демо перед початком пробного доступу",
    alcatrazTrialSampleOption: "Ще не маю приставок inext — хочу отримати демо-зразок",
    alcatrazRequestNamePlaceholder: "Олена Коваль",
    alcatrazRequestCompanyPlaceholder: "Acme Telecom",
    alcatrazRequestEmailPlaceholder: "olena@acme.com",
    alcatrazRequestPhonePlaceholder: "+380 44 123 4567",
    alcatrazRequestNameError: "Вкажіть ім’я.",
    alcatrazRequestCompanyError: "Вкажіть назву компанії.",
    alcatrazRequestEmailError: "Вкажіть коректну робочу електронну адресу.",
    alcatrazRequestPhoneError: "Вкажіть номер телефону.",
    alcatrazTrialEligibility:
      "Для бізнес-клієнтів — ISP і ТВ-провайдерів. Ще немає приставок inext? Ми підготуємо для вас демо-зразок. Пробний доступ надається після короткої перевірки даних компанії.",
    alcatrazTrialNoCardNote: "Без платіжної картки та довгострокових зобов’язань.",
    alcatrazTrialSubmitting: "Надсилання...",
    alcatrazTrialSubmitTrial: "Отримати 3 місяці безкоштовно",
    alcatrazTrialSubmitDemo: "Замовити демо та 3 місяці безкоштовно",
    alcatrazTrialSuccessTitle: "Ми отримали ваш запит",
    alcatrazTrialSuccessBody:
      "Дякуємо. Ми перевіримо дані компанії та зв’яжемося з вами, щоб налаштувати безкоштовний тримісячний доступ до Alcatraz Pro.",
    alcatrazTrialDemoSuccessBody:
      "Дякуємо. Ми перевіримо дані компанії та зв’яжемося з вами, щоб узгодити демо перед налаштуванням безкоштовного тримісячного доступу.",
    alcatrazTrialSampleSuccessNote: "Ми також підготуємо та надішлемо вам демо-зразок приставки.",
    alcatrazTrialSuccessTimeline: "Зазвичай ми відповідаємо протягом одного робочого дня.",
    alcatrazStartSeoTitle: "Alcatraz Pro для парків із менш ніж 500 активними пристроями | inext",
    alcatrazStartSeoDescription:
      "Alcatraz Pro надається без додаткової плати паркам inext із менш ніж 500 активними пристроями. Запросіть доступ і тестовий зразок приставки, якщо парк ще не використовує STB inext.",
    alcatrazStartBreadcrumb: "Отримати Alcatraz Pro",
    alcatrazStartEyebrow: "Для ISP і ТВ-провайдерів",
    alcatrazStartTitle: "Alcatraz Pro входить у комплект із вашими приставками inext",
    alcatrazStartIntro:
      "Керуйте всім парком з однієї консолі: моніторинг, прошивки, діагностика та віддалена підтримка. Alcatraz Pro надається без додаткової плати, доки парк налічує менш ніж 500 активних пристроїв inext.",
    alcatrazStartBenefit1: "Без додаткової плати для парків із менш ніж 500 активними пристроями",
    alcatrazStartBenefit2: "Повноцінна консоль Alcatraz Pro, а не урізана версія",
    alcatrazStartBenefit3: "Допомога команди inext із налаштуванням",
    alcatrazStartActiveTitle: "Що вважається активним пристроєм",
    alcatrazStartActiveBody:
      "Доступ визначається за актуальним підрахунком активних пристроїв за останні 30 днів. Пристрої, що ще перебувають на виробництві, у дорозі, на складі або вже списані, не враховуються під час перевірки межі у 500 пристроїв.",
    alcatrazStartStepsTitle: "Як це працює",
    alcatrazStartStep1: "Надішліть запит",
    alcatrazStartStep2: "Ми перевіримо дані компанії",
    alcatrazStartStep3: "Створимо обліковий запис і допоможемо розпочати",
    alcatrazStartFeaturesLink: "Переглянути функції та варіанти розгортання",
    alcatrazStartDashboardAlt: "Панель керування парком пристроїв Alcatraz Pro",
    alcatrazStartFormTitle: "Отримайте обліковий запис Alcatraz Pro",
    alcatrazStartFormIntro:
      "Вкажіть, як з вами зв’язатися. Ми перевіримо дані компанії та допоможемо розпочати роботу.",
    alcatrazStartDemoOption: "Хочу демо перед початком роботи",
    alcatrazStartSampleOption: "Ще не маю приставок inext — хочу отримати демо-зразок",
    alcatrazStartEligibility:
      "Alcatraz Pro доступний бізнес-клієнтам — ISP і ТВ-операторам — та надається без додаткової плати для парків із менш ніж 500 активними пристроями. Для парків із 500 активними пристроями або більше зверніться до відділу продажу, щоб обговорити доступ і комерційні умови.",
    alcatrazStartSubmitting: "Надсилання...",
    alcatrazStartSubmit: "Отримати Alcatraz Pro",
    alcatrazStartSubmitDemo: "Замовити демо + Alcatraz Pro",
    alcatrazStartNoCardNote: "Без платіжної картки та довгострокових зобов’язань.",
    alcatrazStartSuccessTitle: "Ми отримали ваш запит",
    alcatrazStartSuccessBody:
      "Дякуємо. Ми перевіримо дані компанії та зв’яжемося з вами, щоб налаштувати ваш обліковий запис Alcatraz Pro.",
    alcatrazStartDemoSuccessBody:
      "Дякуємо. Ми перевіримо дані компанії та зв’яжемося з вами, щоб узгодити демо перед налаштуванням облікового запису Alcatraz Pro.",
    alcatrazStartSampleSuccessNote: "Ми також підготуємо та надішлемо вам демо-зразок приставки.",
    alcatrazStartSuccessTimeline: "Зазвичай ми відповідаємо протягом одного робочого дня.",
    alcatrazHeroEyebrow: "Система керування пристроями",
    alcatrazHeroTitle: "inext Alcatraz DMS —",
    alcatrazHeroTitleAccent: "увесь парк під цілодобовим контролем",
    alcatrazHeroSub:
      "У хмарі або повністю у власній інфраструктурі. Контролюйте стан парку, переглядайте історію пристроїв, розгортайте оновлення та підтримуйте кожну приставку inext з однієї платформи.",
    alcatrazCtaStart: "Отримати Alcatraz Pro",
    alcatrazHeroCtaDemo: "Замовити демонстрацію",
    alcatrazHeroCtaSales: "Поговорити з відділом продажу",
    alcatrazHeroImageCaption: "Alcatraz DMS — панель огляду парку",
    alcatrazHeroStatNetworks: "Понад 120 операторських мереж",
    alcatrazHeroStatDeploy: "У хмарі або локально",
    alcatrazHeroStatScale: "Масштабується разом із парком",
    alcatrazDeploymentEyebrow: "Розгортання",
    alcatrazDeploymentTitle: "Два способи розгортання",
    alcatrazDeploymentDescription:
      "Виберіть модель, яка відповідає політикам вашої мережі. Однакові можливості, консоль і умови підписки.",
    alcatrazDeploymentCloudTag: "Рекомендовано",
    alcatrazDeploymentCloudTitle: "Хмара (SaaS)",
    alcatrazDeploymentCloudBody:
      "inext розміщує й обслуговує платформу. Швидкий запуск, автоматичні оновлення та доступ для розподілених команд підтримки з будь-якого регіону.",
    alcatrazDeploymentCloudBullet1: "Не потрібно обслуговувати власну інфраструктуру",
    alcatrazDeploymentCloudBullet2: "Автоматичні оновлення платформи",
    alcatrazDeploymentCloudBullet3: "Доступність за SLA",
    alcatrazDeploymentOnpremTitle: "У власній інфраструктурі",
    alcatrazDeploymentOnpremBody:
      "Платформа працює у внутрішній мережі оператора й забезпечує повний контроль над розміщенням даних — для організацій із жорсткими регуляторними вимогами або вимогами безпеки.",
    alcatrazDeploymentOnpremBullet1: "Розгортання у власному ЦОД",
    alcatrazDeploymentOnpremBullet2: "Дані не залишають мережу оператора",
    alcatrazDeploymentOnpremBullet3: "Працює за NAT і в закритих мережах",
    alcatrazPillarsEyebrow: "Можливості платформи",
    alcatrazPillarsTitle: "Усе, що потрібно для керування парком приставок",
    alcatrazPillar1Title: "Здоров’я пристроїв",
    alcatrazPillar1Body:
      "Визначайте пріоритет проблем зі слабким Wi-Fi та високою температурою, переглядайте історію пристроїв і отримуйте щотижневі звіти.",
    alcatrazPillar2Title: "Поетапні OTA-оновлення прошивки",
    alcatrazPillar2Body:
      "Розгортайте прошивки поетапно, відстежуйте результати, виключайте окремі пристрої та зберігайте коментарі до кожної збірки чи релізу.",
    alcatrazPillar3Title: "Віддалена підтримка й діагностика",
    alcatrazPillar3Body:
      "Перезавантажуйте пристрої, керуйте ними дистанційно, запускайте діагностику MTR чи iPerf3 та усувайте проблеми без виїзду фахівця.",
    alcatrazPillar4Title: "Історія активності й аудит",
    alcatrazPillar4Body:
      "Переглядайте команди, зміни, приватні нотатки й OTA-події; для аудиту журнал також зберігає користувача або API-ключ.",
    alcatrazPillar5Title: "Захист пристроїв",
    alcatrazPillar5Body:
      "Застосовуйте профілі блокування, App Lock і net-lock для захисту орендованих, втрачених або списаних пристроїв.",
    alcatrazPillar6Title: "Зв’язок з абонентами",
    alcatrazPillar6Body:
      "Надсилайте адресні банери в лаунчері, сповіщення та кампанії із закликами до дії на екрані телевізора.",
    alcatrazPillar7Title: "API та галузеві стандарти",
    alcatrazPillar7Body:
      "Керуйте API-ключами з обмеженнями доступу та підключайтеся через REST, MQTT або наявну інфраструктуру TR-069/CWMP.",
    alcatrazPillar8Title: "Організація парку",
    alcatrazPillar8Body:
      "Використовуйте зовнішні ідентифікатори та групи, щоб шукати, фільтрувати, експортувати пристрої й виконувати масові дії.",
    alcatrazFleetHealthEyebrow: "Здоров’я пристроїв",
    alcatrazFleetHealthTitle: "Визначайте пріоритетні пристрої, що потребують уваги",
    alcatrazFleetHealthBody:
      "Розділ «Здоров’я пристроїв» аналізує телеметрію та дає операційним командам і службі підтримки зрозумілий огляд виявлених проблем. Панель показує загальний стан парку, а черга з фільтрами дає змогу відкрити кожен проблемний пристрій та переглянути історію його несправностей.",
    alcatrazFleetHealthBullet1: "Виявлення слабкого Wi-Fi та високої температури",
    alcatrazFleetHealthBullet2: "Фільтрація черги та визначення пріоритетних проблем",
    alcatrazFleetHealthBullet3: "Перегляд відомостей та історії проблем кожної приставки",
    alcatrazFleetHealthBullet4: "Щотижневі звіти про стан парку",
    alcatrazFleetHealthPlaceholder: "Панель «Здоров’я пристроїв» і пріоритетна черга проблем",
    alcatrazFleetPreviewUpdated: "Оновлено щойно",
    alcatrazFleetPreviewLive: "Огляд у реальному часі",
    alcatrazFleetPreviewNeedsAttention: "Потребують уваги",
    alcatrazFleetPreviewCallFirst: "Зв’язатися насамперед",
    alcatrazFleetPreviewKeepWatch: "Під наглядом",
    alcatrazFleetPreviewHealthy: "Справні",
    alcatrazFleetPreviewMonitored: "Відстежуються",
    alcatrazFleetPreviewIssueTypes: "Типи проблем",
    alcatrazFleetPreviewWeakWifi: "Слабкий Wi-Fi",
    alcatrazFleetPreviewTemperature: "Температура",
    alcatrazFleetPreviewQueue: "Пріоритетна черга пристроїв",
    alcatrazFleetPreviewCriticalFirst: "Спочатку критичні",
    alcatrazFleetPreviewShown: "Показано {count}",
    alcatrazFleetPreviewHighTemperature: "Висока температура",
    alcatrazFleetPreviewWatch: "Контролювати",
    alcatrazFleetPreviewAwaiting: "{count} проблем потребують підтвердження",
    alcatrazPreviewMinutesAgo: "{minutes} хв тому",
    alcatrazPreviewIllustrativeData: "Умовні дані",
    alcatrazFirmwareEyebrow: "Керування прошивками",
    alcatrazFirmwareTitle: "Безпечне поетапне розгортання",
    alcatrazFirmwareBody:
      "Плануйте розгортання прошивки для окремої частини парку, вимагайте підтвердження від користувача на пристрої та відстежуйте статистику в реальному часі. За потреби одним перемикачем виключайте окремі пристрої з автоматичних оновлень або запускайте оновлення вручну.",
    alcatrazFirmwareBullet1: "Поетапне розгортання прошивки",
    alcatrazFirmwareBullet2: "Виключення окремих пристроїв з автоматичних оновлень",
    alcatrazFirmwareBullet3: "Ручний запуск оновлення прошивки",
    alcatrazFirmwareBullet4: "Підтвердження на пристрої та статистика розгортання",
    alcatrazFirmwarePlaceholder: "Панель керування релізом прошивки",
    alcatrazFirmwareOtaLink: "Дізнатися про керування OTA-оновленнями",
    alcatrazInspectorEyebrow: "Дані про пристрій",
    alcatrazInspectorTitle: "Поточний стан і повна історія на одному екрані",
    alcatrazInspectorBody:
      "Відкрийте будь-яку приставку, щоб побачити її поточний стан, а потім простежте події, що до нього призвели. Хронологія активності охоплює команди, активацію, зміни пристрою, приватні нотатки, кампанії, сповіщення й OTA-події.",
    alcatrazActivityBullet1: "Готові режими перегляду, фільтри та окремий режим аудиту",
    alcatrazActivityBullet2: "Відомості про користувача або API-ключ для кожної дії",
    alcatrazActivityBullet3: "Детальні OTA-метрики та історія команд",
    alcatrazInspectorPreviewOnline: "Онлайн",
    alcatrazInspectorPreviewCurrentState: "Поточний стан",
    alcatrazInspectorPreviewActivity: "Активність",
    alcatrazInspectorPreviewCondition: "Стан пристрою",
    alcatrazInspectorPreviewLastChecked: "Перевірено {minutes} хв тому",
    alcatrazInspectorPreviewAllEvents: "Усі події",
    alcatrazInspectorPreviewCommands: "Команди",
    alcatrazInspectorPreviewNewest: "Спочатку нові",
    alcatrazInspectorPreviewToday: "Сьогодні",
    alcatrazInspectorPreviewYesterday: "Учора",
    alcatrazInspectorPreviewThisWeek: "Цього тижня",
    alcatrazInspectorPreviewLastWeek: "Минулого тижня",
    alcatrazInspectorPreviewEarlier: "Раніше",
    alcatrazInspectorPreviewSupportNote: "Нотатка підтримки: періодичні паузи відтворення",
    alcatrazInspectorPreviewFirmwareChange: "Прошивка 1.8.51 → 1.9.1",
    alcatrazInspectorPreviewOtaCompleted: "Завантаження OTA завершено",
    alcatrazInspectorPreviewCommandBy: "Команда · Іван Петренко",
    alcatrazInspectorPreviewPrivateNoteBy: "Приватна нотатка · Іван Петренко",
    alcatrazInspectorPreviewDeviceChangeApi: "Зміна пристрою · API-ключ · rollout-bot",
    alcatrazInspectorPreviewOtaMetrics: "Версія 1.9.0 · 45,78 МБ/с · 1 хв 18 с",
    alcatrazInspectorPreviewWaiting: "Очікує відповіді",
    alcatrazInspectorPreviewCompleted: "Завершено",
    alcatrazInspectorPreviewFooter: "Команди, зміни, нотатки та OTA-події",
    alcatrazInspectorPreviewIllustrative: "Приклад історії",
    alcatrazInspectorPreviewAlt:
      "Демонстраційний інспектор пристрою Alcatraz із поточним станом та історією активності.",
    alcatrazInspectorCardTitle: "Картка пристрою",
    alcatrazInspectorLabelState: "Стан",
    alcatrazInspectorValueState: "Онлайн · 4 д 1 год 19 хв",
    alcatrazInspectorLabelLastSeen: "Остання активність",
    alcatrazInspectorValueLastSeen: "12 хв тому",
    alcatrazInspectorLabelFirmware: "Прошивка",
    alcatrazInspectorValueFirmware: "v1.8.14",
    alcatrazInspectorLabelTemps: "Температури",
    alcatrazInspectorValueTemps: "CPU 51,2° · GPU 52,5° · RAM 50,8° · VEE 53,4°",
    alcatrazInspectorLabelRam: "RAM",
    alcatrazInspectorValueRam: "Вільно 383 МБ із 4 ГБ",
    alcatrazInspectorLabelFlash: "Накопичувач",
    alcatrazInspectorValueFlash: "Вільно 18,8 ГБ із 32 ГБ",
    alcatrazInspectorLabelTv: "Підключення до ТВ",
    alcatrazInspectorValueTv: "HDMI · 1920×1080 · 60 кадр/с",
    alcatrazInspectorLabelNetwork: "Мережа",
    alcatrazInspectorValueNetwork: "Wi-Fi 5 ГГц · RSSI −29 дБм (відмінно)",
    alcatrazInspectorLabelAndroid: "Android",
    alcatrazInspectorValueAndroid: "12",
    alcatrazInspectorLabelLocale: "Мова й часовий пояс",
    alcatrazInspectorValueLocale: "Англійська · Europe/Kyiv",
    alcatrazInspectorLabelApps: "Встановлені застосунки",
    alcatrazInspectorValueApps: "Список застосунків і версій",
    alcatrazRemoteEyebrow: "Дистанційне керування",
    alcatrazRemoteTitle: "Консоль команд для оператора",
    alcatrazRemoteBody:
      "Віддалено виконуйте дії, для яких зазвичай потрібен виїзд інженера, — від перезавантаження до відновлення заводських налаштувань — без фізичного доступу до приставки.",
    alcatrazRemoteGroupControl: "Керування",
    alcatrazRemoteGroupDiagnostics: "Діагностика",
    alcatrazRemoteGroupComms: "Сповіщення",
    alcatrazRemoteGroupLifecycle: "Оновлення",
    alcatrazRemoteGroupLockdown: "Обмеження доступу",
    alcatrazRemoteCmdReboot: "Перезавантаження",
    alcatrazRemoteCmdRemote: "Віртуальний пульт",
    alcatrazRemoteCmdScreenshot: "Зробити знімок екрана",
    alcatrazRemoteCmdSpeed: "Перевірити швидкість (iPerf3)",
    mtrAlcatrazRemoteCmd: "MTR-трасування маршруту",
    alcatrazRemoteCmdPush: "Надіслати push-сповіщення",
    alcatrazRemoteCmdFirmware: "Розгорнути прошивку",
    alcatrazRemoteCmdExclude: "Виключити з автоматичних оновлень",
    alcatrazRemoteCmdBlock: "Заблокувати пристрій",
    alcatrazRemoteCmdFactory: "Відновити заводські налаштування",
    alcatrazRemoteWarning: "Небезпечна дія",
    alcatrazRemoteHighlight1:
      "Усувайте типові несправності безпосередньо з NOC — без виїзду інженера.",
    alcatrazRemoteHighlight2:
      "Запускайте команди на одному пристрої або для цілої групи одночасно.",
    alcatrazRemoteHighlight3:
      "Для кожної дії журнал фіксує пристрій, час і користувача або API-ключ, що її ініціював.",
    mtrAlcatrazEyebrow: "MTR-діагностика",
    mtrAlcatrazTitle: "Перевіряйте маршрут від приставки абонента",
    mtrAlcatrazBody:
      "Оператор може запустити MTR (My Traceroute) з онлайн-приставки до будь-якої адреси. Завершені результати MTR та iPerf3 зберігаються в історії активності пристрою, а перевірку можна повторити з тими самими параметрами.",
    alcatrazAccessEyebrow: "Захист пристроїв",
    alcatrazAccessTitle: "Захищайте приставки за допомогою блокування та net-lock",
    alcatrazAccessBody:
      "Alcatraz DMS допомагає операторам захищати орендовані приставки, втрачене обладнання, неоплачені акаунти та пристрої, виведені з експлуатації. Блокуйте окрему приставку чи групу вручну або використовуйте net-lock, щоб обмежувати орендовані пристрої за межами дозволених мереж провайдера.",
    alcatrazAccessFlowTitle: "Як запускається блокування",
    alcatrazAccessManualTitle: "Ручне блокування",
    alcatrazAccessManualBody:
      "Блокуйте одну приставку або цілу групу за потреби. Це захищає втрачене, викрадене чи списане обладнання та обмежує доступ у разі заборгованості.",
    alcatrazAccessNetLockTitle: "Автоматичний net-lock",
    alcatrazAccessNetLockBody:
      "Автоматично блокуйте орендовані приставки за межами дозволених мереж провайдера. Це запобігає їх використанню через сторонні підключення.",
    alcatrazAccessFlowOutcome: "Виберіть профіль блокування",
    alcatrazAccessMockFooter: "Керується Alcatraz DMS",
    alcatrazAccessMockNotice: "Період попередження",
    alcatrazAccessProfileHardTitle: "Жорстке",
    alcatrazAccessProfileHardBody: "Вимикає приставку й повторює блокування після перезапуску.",
    alcatrazAccessModeHardBadge: "Жорстке блокування",
    alcatrazAccessModeHardTitle: "Пристрій заблоковано",
    alcatrazAccessModeHardBody:
      "Приставка показує повідомлення оператора, після чого вимикається. Блокування повторюється після перезапуску.",
    alcatrazAccessModeHardStatus: "Вимикається після попередження",
    alcatrazAccessProfileSoftTitle: "М’яке",
    alcatrazAccessProfileSoftBody:
      "Залишає приставку робочою й показує нагадування кожні 30 хвилин.",
    alcatrazAccessModeSoftBadge: "М’яке блокування",
    alcatrazAccessModeSoftTitle: "Сервісне повідомлення активне",
    alcatrazAccessModeSoftBody:
      "Приставка залишається доступною, а нагадування оператора з’являється за розкладом.",
    alcatrazAccessModeSoftStatus: "Нагадування кожні 30 хвилин",
    alcatrazAccessProfileAppLockTitle: "Блокування застосунку",
    alcatrazAccessProfileAppLockBody: "Обмежує приставку одним вибраним застосунком.",
    alcatrazAccessModeAppLockBadge: "App Lock",
    alcatrazAccessModeAppLockTitle: "Лише дозволений застосунок",
    alcatrazAccessModeAppLockBody:
      "Приставка відкриває тільки вибраний застосунок, доки оператор не змінить профіль.",
    alcatrazAccessModeAppLockStatus: "Один застосунок",
    alcatrazAccessModeAppAllowedApp: "IPTV",
    alcatrazAccessModeAppLockedLabel: "Заблоковано",
    alcatrazPushEyebrow: "Push-сповіщення",
    alcatrazPushTitle: "Спілкуйтеся з абонентами через екран телевізора",
    alcatrazPushBody:
      "Надсилайте банери в лаунчері та спливні повідомлення будь-якому сегменту парку — для сервісних сповіщень, рекомендацій контенту або кампаній з оновлення послуг. До кожного повідомлення можна додати кнопку, яка відкриває застосунок чи сторінку.",
    alcatrazPushBullet1: "Банери в лаунчері та спливні повідомлення",
    alcatrazPushBullet2: "Вибір аудиторії за групою пристроїв, моделлю або регіоном",
    alcatrazPushBullet3: "Кнопки з прямим переходом у застосунок",
    alcatrazPushBullet4: "Перегляди, натискання та CTR для кожного повідомлення",
    alcatrazPushPlaceholder: "Конструктор push-сповіщень",
    alcatrazApiEyebrow: "Безпечні інтеграції · REST API",
    alcatrazApiTitle: "Підключайте Alcatraz до наявних систем",
    alcatrazApiBody:
      "Створюйте й відкликайте API-ключі в консолі, за потреби обмежуйте права доступу й дозволені IP-адреси, установлюйте строк дії та безпечно копіюйте секрет лише під час створення ключа. Зовнішні ідентифікатори пов’язують записи пристроїв Alcatraz з абонентом, CRM, білінговою системою або домогосподарством без зміни наявних процесів.",
    alcatrazApiBullet1: "Самостійне керування API-ключами з обмеженнями доступу",
    alcatrazApiBullet2: "Зовнішні ID пристроїв для пошуку, фільтрів та експорту",
    alcatrazApiBullet3: "TR-069 / CWMP і MQTT разом із REST API",
    alcatrazApiPlaceholder: "Документація API",
    alcatrazPricingEyebrow: "Вартість",
    alcatrazPricingTitle: "Без додаткової плати для парків із менш ніж 500 активними пристроями",
    alcatrazPricingBody:
      "Партнери отримують доступ до повної консолі Alcatraz Pro без додаткової плати, доки парк налічує менш ніж 500 активних пристроїв inext. Для парків із 500 активними пристроями або більше доступ і комерційні умови узгоджуються безпосередньо з inext.",
    alcatrazPricingIncludedTitle: "Без додаткової плати · Менш ніж 500 активних пристроїв",
    alcatrazPricingIncludedBody:
      "Розділ «Здоров’я пристроїв», керування прошивками, діагностика, віддалена підтримка та безпечні інтеграції надаються без додаткової плати, якщо актуальний підрахунок за останні 30 днів показує менш ніж 500 активних пристроїв.",
    alcatrazPricingModelTitle: "500 активних пристроїв або більше",
    alcatrazPricingModelBody:
      "Зверніться до відділу продажу inext, щоб обговорити доступ і комерційні умови для вашого розгортання.",
    alcatrazPricingActiveTitle: "Що вважається активним пристроєм",
    alcatrazPricingActiveBody:
      "Доступ визначається за актуальним підрахунком активних пристроїв за останні 30 днів. Пристрої в таких станах не враховуються під час підрахунку:",
    alcatrazPricingStateProduction: "У виробництві",
    alcatrazPricingStateTransit: "У дорозі",
    alcatrazPricingStateWarehouse: "На складі",
    alcatrazPricingStateRetired: "Списані",
    alcatrazPricingCta: "Отримати розрахунок вартості",
    alcatrazFaqEyebrow: "FAQ",
    alcatrazFaqTitle: "Поширені запитання",
    alcatrazFaqQ1: "Чи можна розгорнути Alcatraz у власній мережі?",
    alcatrazFaqA1:
      "Так. Alcatraz DMS доступний як керована SaaS-платформа або як локальне рішення у внутрішній мережі оператора. Можливості й консоль однакові — оператор сам визначає, де зберігатимуться дані.",
    alcatrazFaqQ2: "Які пристрої підтримуються?",
    alcatrazFaqA2:
      "Усі актуальні моделі приставок inext підтримують Alcatraz DMS: TV5, TV5 Ultra, TV6 і TV6 Ultra. Підтримка нових моделей з’являється під час їх виходу на ринок.",
    alcatrazFaqQ3: "Як Alcatraz працює разом із TR-069?",
    alcatrazFaqA3:
      "Alcatraz підтримує TR-069 / CWMP, тому оператори з наявним ACS можуть і надалі ним користуватися. Водночас Alcatraz додає розширену телеметрію, push-сповіщення, дистанційне керування через застосунок і сучасне REST API.",
    alcatrazFaqQ4: "Чи можна інтегрувати Alcatraz із BSS / OSS?",
    alcatrazFaqA4:
      "Так. Alcatraz надає документований REST API та підтримує MQTT. Адміністратори можуть створювати й відкликати API-ключі, визначати права, обмежувати IP-адреси джерела та встановлювати строк дії. Зовнішні ID пов’язують пристрої з наявними записами CRM або білінгу.",
    alcatrazFaqQ5: "Скільки коштує Alcatraz DMS?",
    alcatrazFaqA5:
      "Alcatraz Pro надається без додаткової плати, доки парк налічує менш ніж 500 активних пристроїв inext. Для парків із 500 активними пристроями або більше доступ і комерційні умови узгоджуються безпосередньо з відділом продажу inext.",
    alcatrazFaqQ6: "Що вважається активним пристроєм?",
    alcatrazFaqA6:
      "У налаштуваннях компанії відображається актуальний підрахунок активних пристроїв за останні 30 днів, за яким визначається доступ. Пристрої, що ще перебувають на виробництві, у дорозі, на складі або вже списані, не враховуються під час підрахунку.",
    alcatrazFaqQ7: "Скільки часу займає впровадження?",
    alcatrazFaqA7:
      "Хмарне розгортання можна запустити за кілька днів. Розгортання у власній інфраструктурі потребує більше часу й залежить від технічної команди оператора — зазвичай від початку робіт до запуску минає кілька тижнів.",
    alcatrazFinalEyebrow: "Керуйте всім парком",
    alcatrazFinalTitle: "Готові об’єднати весь парк приставок на одній платформі?",
    alcatrazFinalBody:
      "Розкажіть нам про свою мережу, і ми підготуємо демонстрацію Alcatraz DMS за вашим сценарієм.",
    alcatrazFinalCtaSecondary: "Поговорити з відділом продажу",
    navSolutionsCustomization: "Кастомізація та брендинг",
    navSolutionsCustomizationDesc: "White-label обладнання, прошивки та застосунки",
    navSolutionsRemoteAppDesc: "Мобільний пульт для приставок inext",
    customPageSeoTitle: "Кастомізація, White-labeling та Co-branding — inext",
    customPageSeoDescription:
      "Зробіть приставки inext по-справжньому вашими — від простого передвстановлення застосунку до повністю кастомного дизайну обладнання та індивідуальної прошивки. White-labeling і co-branding для IPTV- та OTT-операторів.",
    customPageBreadcrumbHome: "Головна",
    customPageBreadcrumbSolutions: "Рішення",
    customPageBreadcrumbPage: "Кастомізація та брендинг",
    customPageHeroEyebrow: "Кастомізація · White-label · Co-brand",
    customPageHeroTitle: "Ваш бренд —",
    customPageHeroTitleAccent: "аж до кремнію",
    customPageHeroSub:
      "Від простого передвстановлення застосунку до повністю кастомної приставки з індивідуальною прошивкою — ми робимо white-label і co-branding кожного шару платформи inext, щоб ваші абоненти бачили лише вас.",
    customPageHeroCtaPrimary: "Зв’язатися з продажами",
    customPageHeroCtaSecondary: "Переглянути приклади",
    customPageHeroStat1: "Софт + обладнання",
    customPageHeroStat2: "Брендинг будь-якого рівня",
    customPageHeroStat3: "Ваш бренд, а не наш",
    customPageHeroImageAlt: "Інженери inext кастомізують ТВ-приставку, на екрані — дизайн плати",
    customPageSurfacesEyebrow: "Дві поверхні, одна айдентика",
    customPageSurfacesTitle: "Софт і обладнання — обидва ваші",
    customPageSurfacesDescription:
      "Брендуйте те, чого абоненти торкаються щодня, і коробку під їхнім телевізором. Оберіть одне або обидва.",
    customPageSoftwareTag: "Софт",
    customPageSoftwareTitle: "Кастомізація софту",
    customPageSoftwareBody:
      "Лаунчер, IPTV/OTT-застосунок, застосунок-пульт і системний UI — перетемовані, перебрендовані та з передвстановленими вашими сервісами.",
    customPageSoftwareBullet1: "Брендований лаунчер, анімація завантаження та шпалери",
    customPageSoftwareBullet2: "Кастомний IPTV/OTT-клієнт і EPG",
    customPageSoftwareBullet3: "Передвстановлені застосунки та контрольований каталог",
    customPageHardwareTag: "Обладнання",
    customPageHardwareTitle: "Кастомізація обладнання",
    customPageHardwareBody:
      "Від брендованої наклейки та роздрібної коробки до повністю кастомного корпусу, пульта та плати під вашу специфікацію.",
    customPageHardwareBullet1: "Брендоване пакування, інструкції та аксесуари",
    customPageHardwareBullet2: "Кастомний колір корпусу, логотип і розкладка пульта",
    customPageHardwareBullet3: "Індивідуальна плата, порти та чипсет для тиражних замовлень",
    customPageTiersEyebrow: "Брендинг будь-якого рівня",
    customPageTiersTitle: "Почніть з малого. Дійдіть до кінця.",
    customPageTiersDescription:
      "Оберіть глибину, що відповідає вашому бренду та бюджету — кожен крок спирається на попередній.",
    customPageTiersLevelLabel: "Рівень",
    customPageTier1Name: "Передвстановлення та анімація завантаження",
    customPageTier1Body:
      "Ваші застосунки, передвстановлені на стокових приставках inext, плюс брендована анімація завантаження. Найшвидший вихід на ринок — без окремого виробничого замовлення.",
    customPageTier1Tag: "Дні",
    customPageTier2Name: "Брендований досвід",
    customPageTier2Body:
      "Ваш лаунчер, анімація завантаження, шпалери, передвстановлені застосунки та попередньо налаштовані параметри. Абоненти бачать ваш бренд щойно вмикають пристрій.",
    customPageTier2Tag: "Тижні",
    customPageTier3Name: "Повний white-label",
    customPageTier3Body:
      "Ваша назва на обладнанні, прошивці та кожному застосунку. Жодного брендингу inext — платформа зникає за вашою.",
    customPageTier3Tag: "Місяці",
    customPageTier4Name: "Кастомне обладнання та прошивка",
    customPageTier4Body:
      "Приставка, спроєктована під вашу специфікацію — кастомний корпус, пульт, порти та збірка прошивки, яку ми підтримуємо для вашого парку.",
    customPageTier4Tag: "Проєкт",
    customPageTiersFootnote: "Не знаєте, з чого почати? Допоможемо визначити правильний рівень.",
    customPagePillarsEyebrow: "Що можна кастомізувати",
    customPagePillarsTitle: "Кожен шар — на вибір",
    customPagePillar1Title: "Пакування та коробка",
    customPagePillar1Body:
      "Роздрібні коробки, рукави, інструкції та комплекти аксесуарів з вашим брендингом.",
    customPagePillar2Title: "Завантаження та заставка",
    customPagePillar2Body:
      "Брендована анімація завантаження, екрани-заставки та послідовність вимкнення.",
    customPagePillar3Title: "Лаунчер і головний UI",
    customPagePillar3Body:
      "Кастомний головний екран, ряди контенту, шпалери та іконки застосунків.",
    customPagePillar4Title: "IPTV / OTT-застосунок",
    customPagePillar4Body: "Брендований плеєр з вашим EPG, catch-up, time-shift і VOD.",
    customPagePillar5Title: "Передвстановлені застосунки",
    customPagePillar5Body:
      "Ваші застосунки, передвстановлені на приставці, з контрольованим переліком доступних застосунків.",
    customPagePillar6Title: "Застосунок-пульт",
    customPagePillar6Body:
      "Брендований мобільний пульт з голосовим пошуком, клавіатурою та жестами.",
    customPagePillar7Title: "Прошивка та AOSP",
    customPagePillar7Body:
      "Кастомна збірка AOSP, системні налаштування, OTA-канал і політика безпеки.",
    customPagePillar8Title: "Дизайн обладнання",
    customPagePillar8Body: "Корпус, розкладка пульта, порти, чипсет і плата під ваш тираж.",
    customPageSoftwareDeepEyebrow: "Софт у ваших кольорах",
    customPageSoftwareDeepTitle: "Головний екран, який абоненти впізнають як ваш",
    customPageSoftwareDeepBody:
      "Ми змінюємо тему лаунчера, плеєра і системного UI навколо вашої палітри, логотипа й типографіки — а потім передвстановлюємо застосунки та сервіси, на які чекають ваші абоненти. Результат відчувається створеним спеціально, а не як типовий Android TV.",
    customPageSoftwareDeepBullet1: "Палітра, логотип, іконки та типографіка",
    customPageSoftwareDeepBullet2: "Кастомні ряди лаунчера та рекомендований контент",
    customPageSoftwareDeepBullet3: "Брендований IPTV/OTT-плеєр і EPG",
    customPageSoftwareDeepBullet4:
      "Передвстановлені застосунки та попередньо налаштовані параметри",
    customPageSoftwareDeepPlaceholder: "Макети брендованого лаунчера та застосунків",
    customPageHardwareDeepEyebrow: "Обладнання з вашою назвою",
    customPageHardwareDeepTitle: "Від брендованої наклейки до зовсім нової плати",
    customPageHardwareDeepBody:
      "Оберіть, наскільки далеко зайти. Додайте логотип і пакування до перевіреної приставки inext, перестилізуйте корпус і пульт або спроєктуйте абсолютно новий пристрій — разом із чипсетом, портами та платою — для тиражних розгортань.",
    customPageHardwareDeepBullet1: "Кастомний колір, оздоблення та логотип корпусу",
    customPageHardwareDeepBullet2: "Індивідуальна розкладка та брендинг пульта",
    customPageHardwareDeepBullet3: "Роздрібне пакування та комплекти аксесуарів",
    customPageHardwareDeepBullet4: "Кастомна плата, порти та чипсет (тираж)",
    customPageHardwareDeepPlaceholder: "Рендери кастомного обладнання та пакування",
    customPageExamplesEyebrow: "Приклади",
    customPageExamplesTitle: "Бренди, які зробили це своїм",
    customPageExamplesDescription:
      "Добірка операторів, що постачають обладнання inext під власним брендом — від глобальних OTT-платформ до регіональних ISP у Європі та Центральній Азії.",
    customPageExample1Name: "MEGOGO",
    customPageExample1Tag: "Україна",
    customPageExample1Meta: "З 2012",
    customPageExample1Body:
      "Міжнародний OTT-сервіс для ТБ, фільмів і спорту, понад 55 млн користувачів на місяць.",
    customPageExample2Name: "Kyivstar TV",
    customPageExample2Tag: "Україна",
    customPageExample2Meta: "З 2018",
    customPageExample2Body:
      "Один із найбільших телеком-операторів України, обслуговує близько 24 млн абонентів.",
    customPageExample3Name: "SWEET.TV",
    customPageExample3Tag: "Європа",
    customPageExample3Meta: "З 2012",
    customPageExample3Body:
      "Платформа стрімінгового ТБ та VOD, що працює в Центральній і Східній Європі.",
    customPageExample4Name: "ALMA TV",
    customPageExample4Tag: "Казахстан",
    customPageExample4Meta: "З 2019",
    customPageExample4Body:
      "Казахстанський провайдер платного ТБ та інтернету з повним спектром послуг.",
    customPageExample5Name: "Beeline",
    customPageExample5Tag: "Казахстан",
    customPageExample5Meta: "З 2022",
    customPageExample5Body:
      "Цифровий оператор: 11 млн мобільних і 2 млн домашніх інтернет-абонентів, входить до VEON.",
    customPageExample6Name: "K@TV1",
    customPageExample6Tag: "Азербайджан",
    customPageExample6Meta: "З 2023",
    customPageExample6Body: "Один із найбільших провайдерів цифрового телебачення в Азербайджані.",
    customPageExample7Name: "Sarkor",
    customPageExample7Tag: "Узбекистан",
    customPageExample7Meta: "З 2023",
    customPageExample7Body:
      "Флагманський IT- і телеком-провайдер Узбекистану з понад 25-річним досвідом.",
    customPageExample8Name: "Metroport",
    customPageExample8Tag: "Польща",
    customPageExample8Meta: "З 2024",
    customPageExample8Body:
      "Консорціум із 30+ польських інтернет-провайдерів, що обслуговує близько 150 000 абонентів.",
    customPageProcessEyebrow: "Як це працює",
    customPageProcessTitle: "Від брифу до коробок на полицях",
    customPageProcessStep1Title: "Дослідження",
    customPageProcessStep1Body:
      "Визначаємо ваш бренд, обсяги, цільові пристрої та рівень кастомізації, що підходить.",
    customPageProcessStep2Title: "Дизайн",
    customPageProcessStep2Body:
      "Брендові ассети, UI-дизайн і специфікація обладнання — змакетовані та погоджені.",
    customPageProcessStep3Title: "Розробка",
    customPageProcessStep3Body:
      "Реалізуємо прошивку, застосунки та обладнання, потім передаємо вам тестові пристрої.",
    customPageProcessStep4Title: "Сертифікація",
    customPageProcessStep4Body:
      "Сертифікації відповідності, магазинів і безпеки — як вимагає ваш ринок.",
    customPageProcessStep5Title: "Постачання",
    customPageProcessStep5Body:
      "Масове виробництво, провізіонінг і подальша OTA-підтримка через Alcatraz DMS.",
    customPageFaqEyebrow: "FAQ",
    customPageFaqTitle: "Поширені запитання",
    customPageFaqQ1: "Яка різниця між co-branding і white-labeling?",
    customPageFaqA1:
      "Co-branding поєднує ваш бренд з inext на спільному обладнанні та UI. White-labeling прибирає inext повністю — ваша назва на коробці, прошивці та кожному застосунку.",
    customPageFaqQ2: "Який мінімальний обсяг для кастомного обладнання?",
    customPageFaqA2:
      "Передвстановлення застосунку та co-branding мають низький мінімум або без нього. Кастомні корпуси, пульти та плати залежать від обсягу — MOQ підтвердимо на етапі дослідження.",
    customPageFaqQ3: "Чи можете ви створити повністю кастомну прошивку?",
    customPageFaqA3:
      "Так. Ми підтримуємо кастомні збірки AOSP з вашими системними налаштуваннями, політикою безпеки та окремим OTA-каналом — у довгостроковій підтримці.",
    customPageFaqQ4: "Чи проєктуєте ви нове обладнання з нуля?",
    customPageFaqA4:
      "За відповідних обсягів — так: кастомний корпус, пульт, порти, чипсет і плата, спроєктовані разом з нашою інженерною командою.",
    customPageFaqQ5: "Як обробляються оновлення після запуску?",
    customPageFaqA5:
      "Брендованими пристроями керують через Alcatraz DMS — телеметрія, поетапні OTA-прошивки, віддалене керування та push-повідомлення.",
    customPageFaqQ6: "Скільки це займає часу?",
    customPageFaqA6:
      "Передвстановлення та co-branding можуть вийти за дні; брендований UI — за тижні; кастомне обладнання — це проєктні терміни, які визначаємо разом.",
    customPageFinalEyebrow: "Зробіть це своїм",
    customPageFinalTitle: "Готові випускати під власним брендом?",
    customPageFinalBody:
      "Розкажіть про ваш бренд, обсяги та як далеко хочете зайти — ми складемо правильний шлях кастомізації.",
    customPageFinalCta: "Зв’язатися з продажами",
    customPageFinalCtaSecondary: "Замовити демо",
    navAccessories: "Аксесуари",
    accessoriesSeoTitle: "Аксесуари inext — пульти, кабелі та блоки живлення",
    accessoriesSeoDescription:
      "Дізнайтеся про додаткові аксесуари для Android-приставок inext. Офіційні програмовані пульти дистанційного керування, аналогові кабелі AV, блоки живлення та зовнішні ІЧ-приймачі.",
    accessoriesTitle: "Пульти, кабелі та живлення",
    accessoriesSubtitle: "Офіційні аксесуари та запасні частини для телевізійних приставок inext.",
    accessoriesHeroEyebrow: "Додаткові аксесуари",
    accessoriesFilterAll: "Усі аксесуари",
    accessoriesFilterRemotes: "Пульти",
    accessoriesFilterCables: "Кабелі та адаптери",
    accessoriesFilterPower: "Блоки живлення",
    accessoriesFilterSensors: "ІЧ-приймачі",
    accessoriesSpecsTab: "Характеристики",
    accessoriesFeaturesTab: "Особливості",
    accessoriesProgrammingTab: "Інструкція програмування",
    accessoriesBackToList: "Повернутися до аксесуарів",
    accessoriesVideoGuide: "Відеоінструкція",
    accessoriesAppBullet1: "Доступно для Android та iOS — безкоштовно",
    accessoriesAppBullet2: "Працює через Wi-Fi — без потреби прямої видимості",
    accessoriesAppBullet3: "Голосовий пошук та екранна клавіатура",
    accessoriesAppCta: "Дізнатися більше про застосунок",
    footerLinkAccessories: "Аксесуари",
    productMenuAccessoriesDesc: "Пульти, кабелі та блоки живлення",
    footerLinkArchive: "Попередні моделі",
    archiveSeoTitle: "Попередні приставки inext — архів знятих з виробництва моделей",
    archiveSeoDescription:
      "Архів знятих з виробництва приставок inext на Android та Linux — від HD1 2011 року до 4K-приставок на Allwinner та Amlogic. Фото та повні характеристики кожної моделі.",
    archiveTitle: "Попередні моделі",
    archiveHeroEyebrow: "Архів продукції",
    archiveSubtitle:
      "Усі приставки inext, які ми випустили з 2011 року. Ці моделі зняті з виробництва — ми зберігаємо їх тут із фото та повними характеристиками для довідки.",
    archiveViewSpecs: "Характеристики",
    archiveBadge: "Знято з виробництва",
    archiveSpecsHeading: "Характеристики",
    iptvAppSeoTitle: "IPTV-застосунок для операторів — брендований ТВ-клієнт для приставок inext",
    iptvAppSeoDescription:
      "Готовий IPTV-застосунок для приставок inext: M3U + XMLTV, Stalker / Ministra, TVIP та інші портали. Брендування у форматі white-label і попередньо задані налаштування допомагають швидше запустити сервіс.",
    iptvAppBreadcrumbHome: "Головна",
    iptvAppBreadcrumbSolutions: "Рішення",
    iptvAppBreadcrumbPage: "IPTV-застосунок",
    iptvAppHeroEyebrow: "Клієнтське ПЗ · приставки inext",
    iptvAppHeroTitle: "Не витрачайте час на розробку ТВ-застосунку —",
    iptvAppHeroTitleAccent: "використовуйте готовий під власним брендом",
    iptvAppHeroSub:
      "Готовий IPTV-клієнт для приставок inext. Ми адаптуємо оформлення до вашого бренду, заздалегідь налаштовуємо застосунок для вашої IPTV-платформи або плейлистів і постачаємо приставки з уже встановленим застосунком, щоб абоненти могли дивитися ТБ відразу після підключення.",
    iptvAppHeroStat1: "Понад 3 сімейства порталів",
    iptvAppHeroStat2: "Повністю white-label",
    iptvAppHeroStat3: "Без налаштування абонентом",
    iptvAppHeroCtaDemo: "Замовити демонстрацію",
    iptvAppHeroCtaSales: "Поговорити з відділом продажу",
    iptvAppModesEyebrow: "Варіанти підключення",
    iptvAppModesTitle: "Працює з наявною платформою оператора",
    iptvAppModesDescription:
      "Не потрібно мігрувати або впроваджувати нову middleware-платформу. Один застосунок адаптується до наявної головної станції — виберіть режим, який відповідає вашій інфраструктурі.",
    iptvAppMode1Title: "Плейлисти M3U + EPG у форматі XMLTV",
    iptvAppMode1Body:
      "Найпростіший спосіб вивести канали на екран. Підключіть плейлист і джерело EPG — абоненти отримають швидкий інтерфейс, оптимізований для телевізора, із повною програмою передач.",
    iptvAppMode1Bullet1: "Плейлисти M3U з категоріями та логотипами каналів",
    iptvAppMode1Bullet2:
      "Поденна EPG у форматі XMLTV із поточною й наступною передачею для кожного каналу",
    iptvAppMode1Bullet3: "Вибір аудіодоріжки під час відтворення",
    iptvAppMode1Bullet4: "Вбудований UDP–HTTP-проксі для multicast-мереж",
    iptvAppMode2Title: "Платформи Stalker / Ministra",
    iptvAppMode2Body:
      "Застосунок відтворює повний інтерфейс порталу Stalker або Ministra: ТБ, VideoClub, записи й обране. Тип приставки можна налаштувати, а вбудована панель плеєра надає додаткові засоби керування.",
    iptvAppMode2Bullet1:
      "Повне відтворення порталу з налаштовуваним типом приставки, наприклад MAG",
    iptvAppMode2Bullet2: "ТБ наживо, VideoClub / VOD, обране та записи",
    iptvAppMode2Bullet3:
      "Вбудована панель плеєра: аудіодоріжки, субтитри, масштаб і віртуальна клавіатура",
    iptvAppMode2Bullet4:
      "URL порталу й параметри відтворення заздалегідь налаштовані для вашого сервісу",
    iptvAppMode3Title: "TVIP, Hibox, Aura та інші вебпортали",
    iptvAppMode3Body:
      "Брендований портал оператора формує весь телевізійний інтерфейс: лаунчер, телегід, архів передач і записи. Інші вебплатформи можна додати на запит.",
    iptvAppMode3Bullet1: "Лаунчер у фірмовому стилі оператора точно відтворює затверджений дизайн",
    iptvAppMode3Bullet2: "Повна сітка телегіда з детальним EPG",
    iptvAppMode3Bullet3: "Архів передач (catch-up) і записи",
    iptvAppMode3Bullet4: "Симулятор дає змогу так само підключати інші вебпортали",
    iptvAppWhiteLabelEyebrow: "White-label і попереднє налаштування",
    iptvAppWhiteLabelTitle: "Ваш бренд на екрані, потрібні параметри — уже в застосунку",
    iptvAppWhiteLabelBody:
      "Ми оформлюємо застосунок у стилі вашого бренду, використовуючи логотип, кольори й назву, а також заздалегідь додаємо URL порталу, плейлист і джерело EPG. Приставки надходять повністю готовими: абоненту достатньо підключити пристрій і почати перегляд.",
    iptvAppWhiteLabelBullet1: "Ваш логотип, кольори та назва застосунку",
    iptvAppWhiteLabelBullet2: "Попередньо додані URL порталу, плейлист і джерело EPG",
    iptvAppWhiteLabelBullet3:
      "Обмежені або відкриті налаштування — оператор визначає, що можуть змінювати абоненти",
    iptvAppWhiteLabelBullet4: "Застосунок попередньо встановлено на приставках inext",
    iptvAppPillarsEyebrow: "Можливості",
    iptvAppPillarsTitle: "Усе, чого абоненти очікують з першого дня",
    iptvAppPillar1Title: "Повна телепрограма (EPG)",
    iptvAppPillar1Body:
      "Поденна програма передач із XMLTV або middleware-платформи з інформацією про поточну й наступну передачу на кожному каналі.",
    iptvAppPillar2Title: "Категорії та логотипи",
    iptvAppPillar2Body:
      "Зручні списки каналів із жанровими категоріями й логотипами для швидкого перемикання.",
    iptvAppPillar3Title: "Аудіодоріжки та субтитри",
    iptvAppPillar3Body: "Вибір аудіодоріжки й субтитрів безпосередньо в панелі плеєра.",
    iptvAppPillar4Title: "Підтримка multicast",
    iptvAppPillar4Body:
      "Вбудований UDP–HTTP-проксі відтворює multicast-потоки без додаткового обладнання.",
    iptvAppPillar5Title: "Інтерфейс для керування пультом",
    iptvAppPillar5Body:
      "Перемикання каналів цифровими кнопками, кольорові клавіші та віртуальна клавіатура — усе розраховано на керування пультом.",
    iptvAppPillar6Title: "Багатомовний інтерфейс",
    iptvAppPillar6Body:
      "Інтерфейс локалізований для потрібного ринку, а мову можна перемикати окремо на кожному пристрої.",
    iptvAppProcessEyebrow: "Як це працює",
    iptvAppProcessTitle: "Три кроки до приставок, готових для абонентів",
    iptvAppProcessStep1Title: "Надайте дані платформи та елементи бренду",
    iptvAppProcessStep1Body:
      "Параметри middleware-платформи або плейлиста, логотип і кольори — усе в одному короткому технічному завданні.",
    iptvAppProcessStep2Title: "Ми брендуємо, налаштовуємо й тестуємо",
    iptvAppProcessStep2Body:
      "Оформлюємо збірку у вашому стилі, додаємо потрібні налаштування й перевіряємо її на приставках inext.",
    iptvAppProcessStep3Title: "Приставки надходять готовими до роботи",
    iptvAppProcessStep3Body:
      "Абонент підключає приставку й одразу дивиться ТБ, а оновленнями оператор керує централізовано.",
    iptvAppEcosystemEyebrow: "Екосистема",
    iptvAppEcosystemTitle: "Частина екосистеми рішень inext для операторів",
    iptvAppEcosystemBody:
      "Поєднайте застосунок із приставками inext та Alcatraz DMS — обладнання, клієнтське ПЗ і керування парком від одного постачальника.",
    iptvAppEcosystemLinkStb: "Переглянути приставки inext",
    iptvAppEcosystemLinkAlcatraz: "Дізнатися про Alcatraz DMS",
    iptvAppFaqEyebrow: "FAQ",
    iptvAppFaqTitle: "Поширені запитання",
    iptvAppFaqQ1: "Які middleware-платформи підтримує застосунок?",
    iptvAppFaqA1:
      "Застосунок відразу підтримує Stalker / Ministra, TVIP, Hibox, Aura та звичайні плейлисти M3U з EPG у форматі XMLTV. Зазвичай можна додати й інші вебпортали — зверніться до нас щодо потрібної платформи.",
    iptvAppFaqQ2:
      "Чи можна адаптувати застосунок до нашого бренду й обмежити доступ до налаштувань?",
    iptvAppFaqA2:
      "Так. Ми постачаємо застосунок із вашим логотипом, кольорами й назвою та заздалегідь задаємо параметри порталу й відтворення. Налаштування можна обмежити, щоб абоненти не змінили конфігурацію випадково, або залишити відкритими.",
    iptvAppFaqQ3: "Чи працює застосунок без middleware-платформи — лише з M3U?",
    iptvAppFaqA3:
      "Так. У режимі M3U застосунку потрібні лише URL плейлиста та необов’язкове джерело XMLTV. Категорії, логотипи, повна EPG і вибір аудіодоріжок залишаються доступними.",
    iptvAppFaqQ4: "Скільки часу потрібно для запуску?",
    iptvAppFaqA4:
      "Кілька тижнів, а не місяців. Брендування й попереднє налаштування займають кілька днів; основний час потрібен для тестування у вашій мережі та доставки приставок.",
    iptvAppFinalEyebrow: "Запускайте сервіс швидше",
    iptvAppFinalTitle: "Готовий ТВ-застосунок уже є —",
    iptvAppFinalTitleAccent: "адаптуймо його до вашого бренду",
    iptvAppFinalBody:
      "Розкажіть про свою серверну платформу й бренд, і ми підготуємо попередньо налаштовану демонстраційну збірку для вашого сервісу.",
    iptvAppFinalCta: "Замовити демонстрацію",
    iptvAppFinalCtaSecondary: "Поговорити з відділом продажу",
    iptvAppAltNativePlayer:
      "IPTV-застосунок inext під час спортивної трансляції з панеллю плеєра та інформацією EPG про поточну й наступну передачу",
    iptvAppAltNativeEpg:
      "Список каналів зі шкалою програми передач на весь день в інтерфейсі IPTV-застосунку",
    iptvAppAltNativeCategories:
      "Бічна панель категорій з логотипами каналів та інформацією про поточну й наступну передачу",
    iptvAppAltNativeSetup: "Екран налаштування з вибором списку каналів M3U або порталу Stalker",
    iptvAppAltNativeAudio: "Меню вибору аудіодоріжки поверх прямої трансляції",
    iptvAppAltStalkerHome: "Головний екран порталу Stalker / Ministra з розділами TV і VideoClub",
    iptvAppAltStalkerChannels:
      "Список каналів порталу Stalker із попереднім переглядом прямого ефіру та EPG",
    iptvAppAltStalkerSettings: "Екран налаштувань з URL порталу та вибором профілю приставки MAG",
    iptvAppAltStalkerPlayerMenu:
      "Панель плеєра з елементами керування порталом, аудіодоріжками, субтитрами, масштабом і клавіатурою",
    iptvAppAltTvipHome: "Брендований операторський лаунчер у стилі TVIP",
    iptvAppAltTvipChannels:
      "Багатоколонковий список каналів з інформацією про передачі в порталі типу TVIP",
    iptvAppAltTvipEpg: "Повна сітка телегіда з інформацією про програми",
    navSolutionsIptvApp: "IPTV-застосунок",
    navSolutionsIptvAppDesc: "Брендований ТВ-клієнт для приставок inext",
    footerLinkIptvApp: "IPTV-застосунок",
    navSolutionsOta: "OTA-оновлення",
    navSolutionsOtaDesc: "Поетапна доставка прошивок і застосунків",
    footerLinkOta: "Керування OTA-оновленнями",
    otaBreadcrumbHome: "Головна",
    otaBreadcrumbSolutions: "Рішення",
    otaBreadcrumbPage: "Керування OTA-оновленнями",
    otaSeoTitle: "Керування OTA-оновленнями inext — поетапне оновлення парку приставок",
    otaSeoDescription:
      "Тестуйте, затверджуйте, поетапно розгортайте, доставляйте й контролюйте прошивки для парків приставок inext. Платформа також підтримує оновлення застосунків і вже доставила понад 1 мільйон OTA-оновлень.",
    otaHeroEyebrow: "Керування OTA-оновленнями",
    otaHeroTitle: "Потрібна прошивка — потрібному пристрою.",
    otaHeroTitleAccent: "Безпечно й у будь-якому масштабі.",
    otaHeroSub:
      "Тестуйте, затверджуйте, поетапно розгортайте, доставляйте й контролюйте прошивки для приставок inext на одній платформі — від першого тестового пристрою до загальнонаціонального парку.",
    otaHeroCtaDemo: "Замовити демо",
    otaHeroCtaSales: "Обговорити розгортання",
    otaHeroPlatformNote: "Керування OTA-оновленнями є частиною платформи inext",
    otaHeroStat1: "Поетапні розгортання від 1% до 100%",
    otaHeroStat2: "Доставка з урахуванням географії та оператора",
    otaHeroStat3: "У хмарі або локально",
    otaHeroDiagramTitle: "Запит на оновлення",
    otaHeroDiagramSubRunning: "Перевірка параметрів пристрою…",
    otaHeroDiagramSubDone: "Оновлення завершено",
    otaHeroDiagramStep1: "Модель · плата · поточна версія",
    otaHeroDiagramStep2: "Цільова група · розклад · відсоток розгортання",
    otaHeroDiagramStep3: "Найближчий доступний вузол зберігання",
    otaHeroDiagramOutcome: "Захищене й перевірене посилання для завантаження",
    otaHeroDiagramDownloading: "Завантаження прошивки на приставку…",
    otaHeroDiagramInstalling: "Установлення прошивки на приставку…",
    otaHeroDiagramInstalled: "Прошивку успішно встановлено",
    otaReleaseEyebrow: "Контрольований процес",
    otaReleaseTitle: "Від протестованої збірки до контрольованого розгортання",
    otaReleaseDescription:
      "Кожен реліз проходить чіткі етапи тестування, затвердження, розгортання та моніторингу. Коментарі з рольовим доступом зберігають обговорення в контексті відповідної збірки або релізу.",
    otaReleaseCard1Title: "Пропонуйте кожному пристрою лише сумісну прошивку",
    otaReleaseCard1Body:
      "Перш ніж запропонувати оновлення, платформа перевіряє модель, плату, поточну версію, оператора, правила релізу та наявність файлу прошивки.",
    otaReleaseCard2Title: "Установіть цільовий відсоток",
    otaReleaseCard2Body:
      "Почніть із невеликої пілотної групи, оцініть результати, а потім поступово розширюйте оновлення на весь парк. Розгортання можна призупинити або скоротити без втрати вже досягнутого прогресу.",
    otaReleaseCard4Title: "Тестуйте на вибраних пристроях",
    otaReleaseCard4Body:
      "Перевірте збірку на внутрішніх пристроях або пристроях у мережі, перш ніж дозволити її масове розповсюдження.",
    otaReleaseCard6Title: "Затвердьте публічний реліз",
    otaReleaseCard6Body:
      "Розмежуйте права на тестові та публічні релізи, щоб лише уповноважені користувачі могли розгортати прошивку на робочих пристроях.",
    otaRolloutEyebrow: "Керування розгортанням",
    otaRolloutTitle: "Точно визначайте цільові пристрої. Мінімізуйте масштаб ризику.",
    otaRolloutBody:
      "Перевірка сумісності та поетапне розгортання за заданим відсотком суттєво знижують ризики, а оператор зберігає контроль над кожним наступним етапом.",
    otaRolloutMeterLabel: "Цільовий відсоток",
    otaRolloutMeterStage1: "Внутрішній тест",
    otaRolloutMeterStage2: "Пілотна група",
    otaRolloutMeterStage3: "Розширення охоплення",
    otaRolloutMeterStage4: "Увесь парк",
    otaGovernEyebrow: "Розподіл повноважень",
    otaGovernTitle: "Чіткі правила затвердження",
    otaGovernBody:
      "Рольові права розмежовують тестування, затвердження, керування розгортанням і доступ до коментарів прошивки, щоб виробничі рішення залишалися чітко контрольованими.",
    otaGovernPerm3: "Створення тестових релізів",
    otaGovernPerm4: "Затвердження масового розповсюдження",
    otaGovernPerm5: "Створення й редагування правил розгортання",
    otaGovernPerm6: "Запуск, призупинення й відновлення розгортання",
    otaGovernPerm7: "Розширені параметри приватних релізів",
    otaDeliveryEyebrow: "Глобальна доставка",
    otaDeliveryTitle: "Відмовостійка доставка прошивок з урахуванням географії",
    otaDeliveryDescription:
      "Прошивки розповсюджуються через схвалені вузли зберігання за налаштованими правилами маршрутизації. Це дає змогу передавати дані ближче до пристроїв, зберігаючи контроль оператора над регіональною політикою доставки.",
    otaDeliveryCard1Title: "Маршрутизація за розташуванням, оператором і завантаженням вузла",
    otaDeliveryCard1Body:
      "Платформа вибирає найближчий схвалений вузол, на якому є потрібна прошивка й достатньо ресурсів для ще одного завантаження.",
    otaDeliveryCard2Title: "Перемикання на резервний вузол — лише за правилами",
    otaDeliveryCard2Body:
      "Якщо регіональний вузол недоступний або перевантажений, перевірений глобальний вузол може прийняти трафік, не порушуючи правил доставки.",
    otaDeliveryCard3Title: "Перевірка кожного завантаження",
    otaDeliveryCard3Body:
      "Посилання з обмеженим строком дії захищають дані маршрутизації та сховища, а файл перед установленням перевіряється за розміром і контрольною сумою.",
    otaDiagramEyebrow: "Як реліз потрапляє на пристрій",
    otaDiagramTitle: "Шлях доставки OTA",
    otaDiagramNode1: "Інтерфейс керування та API",
    otaDiagramNode2: "Контур керування з рольовим доступом",
    otaDiagramNode3: "Механізм вибору прошивки",
    otaDiagramNode4: "Служба керування OTA-доставкою",
    otaDiagramNode5: "Регіональні вузли або вузли у власній інфраструктурі",
    otaDiagramNode6: "Глобальне резервне сховище",
    otaDiagramNode7: "Парк приставок inext",
    otaDiagramNode8: "Телеметрія завантаження та встановлення",
    otaDiagramReturnLabel: "Телеметрія повертається на платформу",
    otaDeployEyebrow: "Інфраструктура оператора",
    otaDeployTitle: "Розгорніть у хмарі, у власній інфраструктурі або в гібридному режимі",
    otaDeployDescription:
      "Використовуйте хмарну доставку inext, розмістіть вузли зберігання у власній мережі або повністю розгорніть платформу у своїй інфраструктурі.",
    otaDeployCloudTag: "Рекомендовано",
    otaDeployCloudTitle: "Хмара (SaaS)",
    otaDeployCloudBody:
      "inext розміщує й обслуговує рішення. Швидкий запуск, автоматичні оновлення платформи та георозподілена доставка доступні з першого дня.",
    otaDeployCloudBullet1: "Не потрібно обслуговувати інфраструктуру",
    otaDeployCloudBullet2: "Доступ до глобальних вузлів зберігання",
    otaDeployCloudBullet3: "Автоматичні оновлення платформи",
    otaDeployOnpremTitle: "У власній інфраструктурі",
    otaDeployOnpremBody:
      "Серверна частина, вебінтерфейс і вузли зберігання працюють у мережі оператора — для організацій із жорсткими вимогами до зберігання даних або безпеки.",
    otaDeployOnpremBullet1: "Файли прошивок залишаються у мережі оператора",
    otaDeployOnpremBullet2: "Об’єктне сховище, сумісне із S3",
    otaDeployOnpremBullet3: "Контроль ресурсів і топології мережі",
    otaDeployNodeTitle: "Потрібні швидші оновлення? Додайте виділений вузол зберігання",
    otaDeployNodeBody:
      "Сервер зберігання можна розмістити у мережі оператора незалежно від того, де працює сама платформа. inext віддалено налаштує сервер, реплікує на нього прошивки та за лічені дні підключить його до мережі доставки.",
    otaDeployNodeChip1: "Для хмарного й локального розгортання",
    otaDeployNodeChip2: "Віддалене налаштування командою inext",
    otaDeployNodeChip3: "Запуск за дні, а не тижні",
    otaMonitorEyebrow: "Операційний контроль",
    otaMonitorTitle: "Контролюйте розгортання безпосередньо в консолі",
    otaMonitorDescription:
      "Відстежуйте охоплення розгортання та стан доставки, а за потреби аналізу відкривайте OTA-події конкретного пристрою з часової шкали активності.",
    otaMonitorCard1Title: "Контролюйте та розширюйте розгортання",
    otaMonitorCard1Body:
      "Перш ніж збільшувати цільовий відсоток, порівняйте поточне охоплення з кількістю активних пристроїв.",
    otaMonitorCard2Title: "Телеметрія завантаження",
    otaMonitorCard2Body:
      "Переглядайте детальні метрики завантаження та встановлення за збіркою, типом пристрою, вузлом, регіоном і окремою подією пристрою.",
    otaMonitorCard4Title: "Автоматичні сповіщення",
    otaMonitorCard4Body:
      "Сповіщайте відповідальних за реліз, коли розгортання досягає поточної цілі й можна переходити до перевірки результатів.",
    otaMonitorMetricsNote:
      "Метрики інфраструктури експортуються у форматі, сумісному зі стандартними платформами моніторингу, зокрема Prometheus і Grafana.",
    otaMigrateEyebrow: "Перехід на власну прошивку",
    otaMigrateTitle: "Переведіть парк зі стандартної прошивки на власну гілку",
    otaMigrateBody:
      "Оператори, які почали роботу зі стандартною прошивкою, можуть через OTA перевести вже розгорнуті пристрої на окрему брендовану гілку, включно із завантажувачем, — без виїзду фахівців і заміни обладнання.",
    otaMigrateBullet1: "Міграція розгорнутих пристроїв на власну гілку прошивки",
    otaMigrateBullet2: "Повна заміна образу, включно із завантажувачем",
    otaMigrateBullet3: "Без виїзду фахівців, повернення чи заміни обладнання",
    otaApiEyebrow: "Готово до інтеграції",
    otaApiTitle: "Інтегруйте OTA в операційну інфраструктуру",
    otaApiBody:
      "Використовуйте API-ключі із самостійним керуванням і налаштованими правами, щоб інтегрувати збірки прошивок, затвердження, стан пристроїв і перебіг розгортання з наявними системами підтримки та звітності.",
    otaApiPanelTitle: "API Alcatraz",
    otaApiPanelSub: "REST · документація · контроль доступу за токенами",
    otaAppsEyebrow: "Розгортання застосунків",
    otaAppsTitle: "Оновлюйте не лише прошивки, а й застосунки",
    otaAppsBody:
      "Крім прошивок, платформа може доставляти оновлення застосунків на підтримувані приставки, використовуючи спільну мережу доставки й ті самі механізми поетапного розгортання. Доступні можливості залежать від способу інтеграції застосунку.",
    otaAppsBullet1: "Спільна мережа доставки й поетапне розгортання",
    otaAppsBullet2: "Для підтримуваних приставок та інтегрованих застосунків",
    otaStatRolloutValue: "1 млн+",
    otaStatRolloutLabel: "OTA-оновлень доставила платформа inext",
    otaStatScaleValue: "1% → 100%",
    otaStatScaleLabel: "Керування поетапним розгортанням від пілотної групи до всього парку",
    otaStatDeliveryValue: "За географією",
    otaStatDeliveryLabel: "Маршрутизація за країною, оператором і поточним завантаженням вузлів",
    otaStatDeployValue: "Хмара · Власна інфраструктура",
    otaStatDeployLabel: "Розгортання в хмарі inext або повністю у власній мережі",
    otaTargetChipsLabel: "Критерії вибору пристроїв",
    otaTargetChip1: "Модель і плата STB",
    otaTargetChip2: "Поточна версія прошивки",
    otaTargetChip3: "ISP / оператор",
    otaTargetChip4: "Список дозволених MAC-адрес",
    otaTargetChip5: "Тестова група",
    otaTargetChip6: "Дозвіл на автоматичне оновлення",
    otaFaqEyebrow: "FAQ",
    otaFaqTitle: "Поширені запитання",
    otaFaqQ1: "Чи є OTA частиною Alcatraz DMS?",
    otaFaqA1:
      "OTA-оновлення прошивок доставляються через платформу inext Alcatraz зі спільною серверною частиною, консоллю та правами доступу. В Alcatraz DMS за доставку прошивок відповідає окремий модуль цієї самої системи.",
    otaFaqQ2: "Чи можна розгорнути OTA в мережі оператора?",
    otaFaqA2:
      "Так. Вузли зберігання можуть працювати в інфраструктурі оператора, а всю платформу — серверну частину та вебінтерфейс — можна розгорнути локально. Вузли підтримують об’єктні сховища, сумісні із S3.",
    otaFaqQ3: "Як поетапні розгортання знижують ризик?",
    otaFaqA3:
      "Оновлення спочатку отримує заданий відсоток парку. Система відстежує охоплення серед активних пристроїв, а розгортання розширюється лише після перевірки результатів. Його можна будь-коли призупинити, відновити або скоротити, а після завершення етапу відповідальні отримають сповіщення.",
    otaFaqQ4: "Що станеться, якщо регіональний вузол недоступний або заповнений?",
    otaFaqA4:
      "Маршрутизація враховує поточне завантаження вузлів. Якщо схвалений регіональний вузол недоступний або перевантажений, трафік може перейти на глобальний вузол, якщо це дозволяють правила. Оновлення пропонується пристрою лише за наявності перевіреного шляху доставки.",
    otaFaqQ5: "Чи можна примусово встановити критичне оновлення безпеки?",
    otaFaqA5:
      "Так. Реліз можна позначити обов’язковим, щоб користувачі не могли його пропустити. Правила послідовності оновлень також забезпечують установлення потрібної проміжної прошивки перед переходом на новішу збірку.",
    otaFaqQ6: "Як перевірити, що пристрій отримав потрібну прошивку?",
    otaFaqA6:
      "Метадані прошивки містять розмір файлу й контрольну суму, тому приставка перевіряє завантажений файл перед установленням. Пристрої також надсилають на платформу телеметрію завантаження.",
    otaFaqQ7: "Чи може система доставляти оновлення застосунків?",
    otaFaqA7:
      "Так. Система передусім призначена для керування життєвим циклом прошивок, але також може доставляти оновлення застосунків на підтримувані приставки. Доступні засоби керування залежать від способу інтеграції застосунку та вимог до розгортання.",
    otaFinalEyebrow: "Плануєте безпечніше розгортання?",
    otaFinalTitle: "Перегляньте керування OTA-оновленнями в дії",
    otaFinalBody:
      "Разом із командою inext пройдіть усі етапи — від тестування й затвердження до поетапного розгортання та моніторингу — на прикладі сценарію для вашого парку.",
    otaFinalCta: "Замовити демонстрацію OTA",
    otaFinalCtaSecondary: "Обговорити розгортання",
    otaLiveLabel: "Активний реліз",
    otaUiTestTitle: "Тестування",
    otaUiTestBody: "Надішліть цю прошивку на один або кілька пристроїв для тестування.",
    otaUiTestAction: "Створити тестовий реліз",
    otaUiConfirmTitle: "Затвердження",
    otaUiConfirmBody:
      "Позначте прошивку як готову до публічного релізу. Після затвердження збірку можна використовувати для масового розгортання.",
    otaUiConfirmAction: "Затвердити прошивку",
    otaUiReleaseTitle: "Реліз",
    otaUiReleaseBody: "Налаштуйте дату, час і відсоток розгортання затвердженої збірки.",
    otaUiReleaseAction: "Створити публічний реліз",
    otaUiLiveBody: "Активуйте або призупиніть реліз у будь-який момент.",
    otaUiMandatoryTitle: "Обов’язкове оновлення",
    otaUiMandatoryBody: "Користувачі не можуть відмовитися від цього оновлення.",
    otaUiResetTitle: "Скидання налаштувань після оновлення",
    otaUiResetBody: "Після встановлення поверніть пристрої до заводських налаштувань.",
    otaUiStagedTitle: "Поетапне розгортання",
    otaUiStagedBody:
      "Розгорніть прошивку на заданому відсотку пристроїв, що відповідають критеріям.",
    otaUiInteractiveLabel: "Інтерактивний приклад",
    otaUiCompletedAction: "Готово",
    otaUiWorkingAction: "Виконуємо…",
    otaUiWorkflowComplete: "Збірку затверджено й підготовлено до поетапного розгортання",
    otaUiReplayAction: "Повторити",
    otaUiApproximately: "приблизно",
    otaUiEligibleDevices: "STB у цільовій групі",
    otaAdvancedEyebrow: "Розширені можливості",
    otaAdvancedTitle: "Більше можливостей, ніж стандартне OTA-розгортання",
    otaAdvancedBody:
      "Переводьте наявні парки на брендовану гілку прошивки та інтегруйте керування релізами з іншими системами оператора.",
    worldwideEyebrow: "Доставка по всьому світу",
    worldwideHeadline: "Виробництво в Азії. Доставка по всьому світу.",
    worldwideSub:
      "Від виробничих партнерів у Шенчжені та на Тайвані — до операторів у Європі, Центральній Азії, Америці та за її межами. Пакування, митне оформлення та координація доставки — все включено.",
    worldwideOriginLabel: "Китай і Тайвань",
    worldwideStat1Value: "700K+",
    worldwideStat1Label: "пристроїв відправлено",
    worldwideStat3Label: "способи доставки",
    worldwideCta: "Як ми доставляємо",
    navSolutionsLogistics: "Глобальна логістика",
    navSolutionsLogisticsDesc: "B2B-доставка обладнання по всьому світу",
    footerLinkLogistics: "Глобальна логістика",
    logisticsSeoTitle: "Глобальна логістика — B2B-доставка обладнання по всьому світу",
    logisticsSeoDescription:
      "B2B-доставка обладнання inext від виробничих партнерів у Шеньчжені, Гуанчжоу й на Тайвані операторам і дистриб'юторам у всьому світі — повітрям, морем і суходолом, з експрес-кур'єром для зразків.",
    logisticsBreadcrumb: "Глобальна логістика",
    logisticsHeroEyebrow: "Глобальна B2B-логістика",
    logisticsHeroTitle: "Від виробництва — до",
    logisticsHeroTitleAccent: "вашого складу",
    logisticsHeroSub:
      "Ми виробляємо телеприставки з перевіреними партнерами в Китаї та на Тайвані, а потім координуємо доставку операторам, дистриб'юторам і на бізнес-склади по всьому світу. Єдина контактна особа супроводжує кожне бізнес-відвантаження.",
    logisticsHeroCtaPrimary: "Спланувати відвантаження",
    logisticsHeroCtaSecondary: "Знайти дистриб'ютора",
    logisticsHeroChip1: "B2B-доставка по всьому світу",
    logisticsHeroChip2: "Виробництво в Китаї та на Тайвані",
    logisticsHeroChip3: "Брендоване пакування, готове до продажу",
    logisticsHeroStage1: "Виробництво",
    logisticsHeroStage2: "Брендування й пакування",
    logisticsHeroStage3: "Перевезення",
    logisticsHeroStage4: "Митниця й доставка",
    logisticsGlobeHubLabel: "Виробничий хаб",
    logisticsGlobeRouteLabel: "Маршрут доставки",
    logisticsGlobeCaption:
      "B2B-маршрути з Китаю й Тайваню до Києва, Братислави, Сан-Паулу й Алмати з подальшою дистрибуцією з Братислави до Варшави та Угорщини.",
    logisticsHubShenzhen: "Шеньчжень",
    logisticsHubGuangzhou: "Гуанчжоу",
    logisticsHubTaiwan: "Тайвань",
    logisticsStat1Value: "700K+",
    logisticsStat1Label: "пристроїв доставлено по всьому світу",
    logisticsStat2Value: "15+",
    logisticsStat2Label: "країн обслуговування",
    logisticsStat3Value: "3",
    logisticsStat3Label: "виробничі хаби в Китаї та на Тайвані",
    logisticsStat4Value: "4",
    logisticsStat4Label: "варіанти перевезення — авіа, море, авто та кур'єр для зразків",
    logisticsMakeEyebrow: "Де це виробляється",
    logisticsMakeTitle: "Виробництво на перевірених майданчиках",
    logisticsMakeBody:
      "Наші телеприставки створюються у співпраці з виробничими партнерами та постачальниками у двох провідних регіонах електроніки світу. Розташування виробництва поряд із ланцюгом постачання компонентів забезпечує високу якість, короткі терміни виконання та передбачувані витрати.",
    logisticsMakeCard1Title: "Шеньчжень, Китай",
    logisticsMakeCard1Tag: "Збирання та пакування",
    logisticsMakeCard1Body:
      "Фінальне збирання, прошивання, контроль якості та пакування — зокрема брендовані під оператора коробки, готові до роздрібного продажу.",
    logisticsMakeCard2Title: "Гуанчжоу, Китай",
    logisticsMakeCard2Tag: "Плати та компоненти",
    logisticsMakeCard2Body:
      "Виробництво плат і закупівля компонентів. Розвинена місцева мережа постачальників забезпечує швидке виконання замовлень.",
    logisticsMakeCard3Title: "Тайвань",
    logisticsMakeCard3Tag: "Чипи та модулі",
    logisticsMakeCard3Body:
      "Ключові чипсети та модулі від відомих тайванських постачальників — кремнієва основа платформ, на яких працює наше обладнання.",
    logisticsFlowEyebrow: "Від виробництва до розгортання",
    logisticsFlowTitle: "Узгоджений шлях до вашої компанії",
    logisticsFlowBody:
      "Виробництво, пакування, перевезення й митне оформлення працюють як єдиний план із персональним координатором на кожному етапі.",
    logisticsFlowStep1Title: "Виробництво та контроль якості",
    logisticsFlowStep1Body:
      "Пристрої збирають і тестують поодинці, а потім прошивають вашою збіркою прошивки, перш ніж вони залишать лінію.",
    logisticsFlowStep2Title: "Брендування та пакування",
    logisticsFlowStep2Body:
      "Пристрої пакують у нейтральне або повністю брендоване пакування, готове до роздрібного продажу, відповідно до вашого ринку.",
    logisticsFlowStep3Title: "Відвантаження та митне оформлення",
    logisticsFlowStep3Body:
      "Ми обираємо потрібного перевізника під ваші терміни та бюджет і готуємо експортні й митні документи.",
    logisticsFlowStep4Title: "Доставка до вашої мережі",
    logisticsFlowStep4Body:
      "Серійні замовлення прибувають на ваш склад, до дистриб'ютора або визначеного логістичного партнера з відстеженням упродовж усього маршруту.",
    logisticsModesEyebrow: "Як ми доставляємо",
    logisticsModesTitle: "Правильний спосіб доставки для кожного відвантаження",
    logisticsModesBody:
      "Від однієї термінової палети до повного контейнера — ми підбираємо спосіб доставки під ваш обсяг, бюджет і термін.",
    logisticsModeAirTitle: "Авіаперевезення",
    logisticsModeAirBody:
      "Найшвидший вантажний маршрут для запусків і серійних замовлень із жорсткими термінами.",
    logisticsModeSeaTitle: "Морські перевезення",
    logisticsModeSeaBody:
      "Найвигідніший за вартістю варіант для великих планових замовлень із доставкою контейнерами.",
    logisticsModeRoadTitle: "Авто та залізниця",
    logisticsModeRoadBody:
      "Регіональна дистрибуція та подальша доставка після прибуття вантажу на ваш ринок.",
    logisticsModeCourierTitle: "Експрес-кур'єр",
    logisticsModeCourierBody:
      "Швидка доставка «від дверей до дверей» для оцінювальних зразків перед проєктом або серійним замовленням.",
    logisticsB2bNoteTitle: "Лише бізнес-відвантаження",
    logisticsB2bNoteBody:
      "Серійні замовлення доставляємо операторам, дистриб'юторам, на склади або логістичним партнерам. Ми не здійснюємо дропшипінг абонентам. Експрес-кур'єр використовуємо лише для доставки оцінювальних зразків.",
    logisticsHandleEyebrow: "Усе беремо на себе",
    logisticsHandleTitle: "Більше, ніж просто перевезення коробок",
    logisticsHandleBody:
      "Ми беремо на себе деталі, які гальмують операторів, щоб обладнання прибувало готовим до розгортання.",
    logisticsHandleItem1: "Брендоване під оператора пакування, готове до роздрібного продажу",
    logisticsHandleItem2: "Оптові, палетовані та контейнерні відвантаження",
    logisticsHandleItem3: "Експортна, митна документація та документи відповідності",
    logisticsHandleItem4: "Поетапне розгортання за регіонами",
    logisticsHandleItem5: "Координація з вашими дистриб'юторами та 3PL-провайдерами",
    logisticsHandleItem6: "Експрес-доставка зразків для технічного й комерційного оцінювання",
    logisticsHandleItem7:
      "Переліки серійних номерів і MAC-адрес кожного пристрою — готові до провізіонінгу",
    logisticsHandleItem8: "Попередньо встановлена прошивка та конфігурація під кожну партію",
    logisticsHandleItem9: "Гнучкі умови Incoterms — EXW, FOB або DAP під вашу команду",
    logisticsHandleFootnote:
      "Один координатор веде кожне відвантаження — від виробничої лінії до вашого складу.",
    logisticsLinksEyebrow: "Дізнавайтеся більше",
    logisticsLinksTitle: "Сплануйте решту свого розгортання",
    logisticsLinkCta: "Дізнатися більше",
    logisticsLinkDistributorsTitle: "Знайти дистриб'ютора",
    logisticsLinkDistributorsBody:
      "Працюйте з авторизованим партнером inext, який уже обслуговує ваш регіон.",
    logisticsLinkCustomizationTitle: "Брендування та пакування",
    logisticsLinkCustomizationBody:
      "Постачайте обладнання під власним брендом — від прошивки до роздрібної коробки.",
    logisticsLinkProductsTitle: "Переглянути обладнання",
    logisticsLinkProductsBody: "Порівняйте лінійку телеприставок inext і виберіть потрібну модель.",
    logisticsLinkAboutTitle: "Про inext",
    logisticsLinkAboutBody:
      "Команда, що стоїть за обладнанням і постачає його операторам із 2011 року.",
    logisticsFaqEyebrow: "FAQ",
    logisticsFaqTitle: "Доставка та логістика — відповіді на запитання",
    logisticsFaqQ1: "У які країни ви доставляєте?",
    logisticsFaqA1:
      "Ми доставляємо по всьому світу. Обладнання inext уже використовують оператори в понад 15 країнах, а наші логістичні партнери можуть охопити практично будь-який ринок — напряму або через місцевого дистриб'ютора.",
    logisticsFaqQ2: "Де виробляється продукція inext?",
    logisticsFaqA2:
      "Наші телеприставки створюються у співпраці з виробничими партнерами та постачальниками в Шеньчжені та Гуанчжоу (Китай) і на Тайвані — у відомих регіонах електроніки зі зрілими, надійними ланцюгами постачання.",
    logisticsFaqQ3: "Хто займається доставкою та митним оформленням?",
    logisticsFaqA3:
      "Ми координуємо весь шлях через нашу мережу логістичних партнерів і готуємо експортні та митні документи, тож ви отримуєте одну контактну особу замість того, щоб жонглювати кількома експедиторами.",
    logisticsFaqQ4: "Чи можете ви постачати під нашим власним брендом?",
    logisticsFaqA4:
      "Так. Пристрої можуть прибути на ваш склад або до дистрибуційного партнера в повністю брендованому пакуванні, готовому до роздрібного продажу. Варіанти прошивки, корпусу й пакування описано на сторінці кастомізації.",
    logisticsFaqQ5: "Які способи доставки та терміни постачання доступні?",
    logisticsFaqA5:
      "Серійні замовлення можна перевозити повітрям, морем, автотранспортом або залізницею. Експрес-кур'єр використовуємо для оцінювальних зразків, а не для дропшипінгу споживачам. Терміни залежать від обсягу, кастомізації та пункту призначення — реалістичний графік підтверджуємо з кожною пропозицією.",
    logisticsFaqQ6: "Чи є мінімальна кількість замовлення?",
    logisticsFaqA6:
      "Обсяги замовлень узгоджуються під кожен проєкт. Ми працюємо з операторами різного масштабу — від перших пілотних партій до повторних великих замовлень. Розкажіть нам, що вам потрібно.",
    logisticsFinalEyebrow: "Запустімо ваше обладнання в дорогу",
    logisticsFinalTitle: "Сплануйте свою доставку по всьому світу",
    logisticsFinalBody:
      "Розкажіть, куди потрібно доставити ваші пристрої та як швидко. Ми складемо план доставки — виробництво, пакування, фрахт і митне оформлення — і виділимо єдину команду, яка ним керуватиме.",
    logisticsFinalCta: "Зв'язатися з нашою командою",
    logisticsFinalCtaSecondary: "Знайти дистриб'ютора",
    productsIndexEyebrow: "Обладнання",
    productsIndexTitle: "Лінійка продуктів inext",
    productsIndexSubtitle:
      "Android TV-приставки 4K для операторів — а також офіційні аксесуари та інструменти, що доповнюють кожне впровадження.",
    productsIndexMoreHeading: "Дізнайтеся більше",
    productsIndexArchiveDesc: "Характеристики та фото знятих з виробництва моделей inext.",
    productsIndexCardCta: "Докладніше",
    productsIndexSeoTitle: "Продукти — Android TV-приставки та аксесуари | inext",
    productsIndexSeoDescription:
      "Огляд усієї лінійки inext: Android TV-приставки 4K, офіційні аксесуари, порівняння моделей і архів знятих з виробництва пристроїв.",
    solutionsIndexEyebrow: "Платформа та сервіси",
    solutionsIndexTitle: "Рішення для кожного етапу вашого ТБ-сервісу",
    solutionsIndexSubtitle:
      "Від керування пристроями та прошивок до застосунків, якими щодня користуються абоненти, — програмне забезпечення та сервіси, що керують парком inext.",
    solutionsIndexCardCta: "Докладніше",
    solutionsIndexFlagship: "Флагман",
    solutionsIndexSeoTitle: "Рішення — керування пристроями, OTA, IPTV-застосунок та інше | inext",
    solutionsIndexSeoDescription:
      "Огляд рішень inext: керування пристроями Alcatraz, керування OTA-оновленнями, IPTV-застосунок, застосунок inext Remote, кастомізація та глобальна логістика.",
    verimatrixNote:
      "Сертифікований партнер Verimatrix — наші телеприставки та IPTV-застосунок нативно інтегровані з умовним доступом Verimatrix VCAS і мульти-DRM.",
    solutionsRow1Title: "Керуйте всім парком пристроїв з одного місця",
    solutionsRow1Body:
      "Alcatraz аналізує телеметрію, упорядковує виявлені проблеми за пріоритетом у розділі «Здоров’я пристроїв», зберігає історію активності та підтримує контрольоване розгортання прошивок і віддалену діагностику.",
    solutionsRow2Title: "Екран, на якому живуть ваші абоненти",
    solutionsRow2Body:
      "Брендований IPTV-застосунок і безплатний мобільний пульт перетворюють приставку inext на телеперегляд, який справді подобається абонентам.",
    solutionsRow3Title: "Ваш бренд — створений і доставлений",
    solutionsRow3Body:
      "White-label обладнання та прошивки за вашими вимогами з доставкою по всьому світу — ви запускаєте, решту беремо на себе.",
    solutionsAllTitle: "Усі рішення — одна платформа",
    navGuides: "Гайди",
    footerGuides: "Гайди",
    footerLinkGuidesAndroidLinux: "Android чи Linux",
    guidesBreadcrumbHome: "Головна",
    guidesIndexEyebrow: "Гайди",
    guidesIndexTitle: "Гайди про рішення, що формують вашу ТВ-платформу",
    guidesIndexSubtitle:
      "Чесні, практичні гайди про вибір, з яким оператори стикаються насправді — обладнання, ОС, володіння пристроями, фінансування та спосіб доставки. Ми постачаємо весь стек, тож це не рекламні буклети.",
    guidesIndexAllTitle: "Усі гайди",
    guidesIndexCardCta: "Читати гайд",
    guidesIndexSeoTitle: "Гайди — як обрати та керувати вашою ТВ-платформою | inext",
    guidesIndexSeoDescription:
      "Практичні, незалежні від вендора гайди для IPTV- та OTT-операторів — вибір платформи, розгортання й рішення, що стоять за керуванням парком ТВ-приставок.",
    tcoCardTitle: "Калькулятор TCO для ТВ-приставок",
    tcoCardDesc:
      "Порівняйте сукупну вартість двох сценаріїв розгортання ТВ-приставок: закупівлю обладнання, заміни, підтримку, виїзне обслуговування та керування парком пристроїв.",
    tcoCardCta: "Відкрити калькулятор",
    tcoSeoTitle: "Калькулятор TCO для ТВ-приставок — порівняння витрат | inext",
    tcoSeoDescription:
      "Оцініть і порівняйте сукупну вартість володіння для двох сценаріїв розгортання IPTV- та OTT-приставок: закупівлю обладнання, заміни, підтримку, виїзне обслуговування та керування пристроями.",
    tcoBreadcrumbPage: "Калькулятор TCO",
    tcoHeroEyebrow: "Інтерактивний інструмент для планування",
    tcoHeroTitle: "Калькулятор сукупної вартості володіння ТВ-приставками",
    tcoHeroBody:
      "Порівняйте два сценарії розгортання ТВ-приставок за весь період експлуатації. Оцініть, як закупівельна ціна, відмови, підтримка абонентів, виїзне обслуговування та керування пристроями впливають на фактичну вартість одного пристрою.",
    tcoExampleNotice:
      "Попередньо заповнені значення — лише приклад, а не комерційна пропозиція чи гарантія економії. Замініть їх фактичними показниками вашої операційної моделі та даними з пропозицій постачальників.",
    tcoInputsEyebrow: "Вихідні дані",
    tcoInputsTitle: "Створіть два сценарії для порівняння",
    tcoInputsBody:
      "Вкажіть спільні для обох сценаріїв кількість пристроїв, строк експлуатації та валюту, а потім задайте витрати й операційні параметри для кожного сценарію.",
    tcoReset: "Відновити приклад",
    tcoFleetSize: "Кількість пристроїв у парку",
    tcoOwnershipPeriod: "Строк експлуатації, років",
    tcoCurrency: "Валюта розрахунку",
    tcoScenarioLabel: "Сценарій розгортання",
    tcoScenarioA: "Сценарій A",
    tcoScenarioB: "Сценарій B",
    tcoFieldUnitPrice: "Закупівельна ціна одного пристрою",
    tcoFieldLogistics: "Логістичні витрати на один пристрій",
    tcoFieldSetup: "Одноразові витрати на налаштування й адаптацію",
    tcoFieldFailureRate: "Річна частка відмов, %",
    tcoFieldReplacement: "Вартість однієї заміни",
    tcoFieldSupportContacts: "Звернення до підтримки на 1000 пристроїв за рік",
    tcoFieldSupportCost: "Вартість одного звернення до підтримки",
    tcoFieldTruckRolls: "Виїзди фахівця на 1000 пристроїв за рік",
    tcoFieldTruckRollCost: "Вартість одного виїзду фахівця",
    tcoFieldDmsCost: "Керування одним пристроєм за місяць",
    tcoDmsIncludedNote:
      "Керування пристроями: Alcatraz Pro надається без додаткової плати, доки парк налічує менш ніж 500 активних пристроїв inext. Для парків із 500 активними пристроями або більше зверніться до inext, щоб обговорити комерційні умови.",
    tcoResultsEyebrow: "Порівняння",
    tcoResultsTitle: "Орієнтовна сукупна вартість за весь період",
    tcoLowerResult: "{scenario}: на {amount} ({percent}%) менше",
    tcoEqualResult: "Обидва сценарії мають однакову орієнтовну TCO",
    tcoComparisonNote:
      "Розрахунок ґрунтується на вказаних вище даних. Для великого парку операційні витрати можуть мати більший вплив, ніж незначна різниця в закупівельній ціні.",
    tcoTotalLabel: "Сукупна вартість за вибраний період",
    tcoPerDevice: "Вартість у розрахунку на пристрій",
    tcoPerDeviceMonth: "Вартість одного пристрою за місяць",
    tcoCostProcurement: "Закупівля обладнання",
    tcoCostLogistics: "Логістика",
    tcoCostSetup: "Налаштування й адаптація",
    tcoCostReplacements: "Заміна обладнання",
    tcoCostSupport: "Підтримка абонентів",
    tcoCostFieldService: "Виїзне обслуговування",
    tcoCostManagement: "Керування пристроями",
    tcoMethodEyebrow: "Модель розрахунку",
    tcoMethodTitle: "Що враховує розрахунок TCO",
    tcoMethodBody:
      "Сукупна вартість володіння охоплює не лише початкову закупівлю, а й подальші операційні витрати. Модель навмисно зроблено прозорою, щоб кожне припущення можна було замінити фактичним показником.",
    tcoMethod1Title: "Початкове розгортання",
    tcoMethod1Body:
      "Вартість пристроїв і логістичні витрати розраховуються для всього парку. Витрати на налаштування й адаптацію враховуються один раз.",
    tcoMethod2Title: "Витрати протягом експлуатації",
    tcoMethod2Body:
      "Кількість відмов, звернень до підтримки та виїздів фахівців, а також щомісячні витрати на керування пристроями прогнозуються на весь вибраний строк експлуатації.",
    tcoMethod3Title: "Питомі витрати для порівняння",
    tcoMethod3Body:
      "Загальну суму подано як вартість на один пристрій та щомісячну вартість одного пристрою, щоб коректно порівнювати сценарії з різною закупівельною ціною.",
    tcoCtaTitle: "Перевірте розрахунок на реальному обладнанні",
    tcoCtaBody:
      "Калькулятор допомагає сформувати короткий список варіантів. Тестове розгортання дає змогу перевірити стабільність пристроїв, процеси підтримки, віддалену діагностику та фактичні операційні витрати.",
    tcoCtaButton: "Обговорити розгортання",
    footerLinkGuidesTco: "Калькулятор TCO для приставок",
    guidesCardAvlTitle: "Android чи Linux на ТВ-приставці",
    guidesCardAvlDesc:
      "Яка платформа підходить саме вашій мережі? Чесне порівняння — екосистема застосунків, вартість, контроль і коли яка з них виграє.",
    avlSeoTitle: "Android чи Linux на ТВ-приставці: як обрати | inext",
    avlSeoDescription:
      "Android TV чи Linux для парку ваших ТВ-приставок? Чесне, незалежне від вендора порівняння від inext — ми постачаємо обидві. Екосистема застосунків, вартість, контроль і коли яка з них виграє.",
    avlBreadcrumbPage: "Android чи Linux на ТВ-приставці",
    avlHeroEyebrow: "Гайд із вибору платформи",
    avlHeroTitle: "Android чи Linux на ТВ-приставці:",
    avlHeroTitleAccent: "яка платформа підходить вашій мережі?",
    avlHeroSub:
      "Більшість гайдів «Android чи Linux» пишуть вендори, які продають лише одну з платформ, — тож насправді це замаскована реклама. Ми не в такому становищі: будь-яка ТВ-приставка inext може постачатися як з Android, так і з полегшеним складанням Linux, тож ми щиро раді будь-якому вашому вибору. Це чесна версія.",
    avlHeroNote: "Ми постачаємо обидві — тож у цьому порівнянні немає прихованого упередження.",
    avlHeroCtaPrimary: "Зв’язатися з нашою командою",
    avlHeroCtaSecondary: "Переглянути порівняння",
    avlDefineEyebrow: "Почніть звідси",
    avlDefineTitle: "Спершу — про що насправді йдеться",
    avlDefineBody:
      "Обидві працюють на однаковому залізі, тож їх легко переплутати. Для цього порівняння розглядаймо їх окремо — як два різні продукти:",
    avlDefineAndroidLabel: "Android",
    avlDefineAndroidBody:
      "платформа Android TV — вона запускає екосистему застосунків Android під лаунчером, який ви можете брендувати, тож абоненти отримують знайомі застосунки та звичний інтерфейс.",
    avlDefineLinuxLabel: "Linux",
    avlDefineLinuxBody:
      "полегшене, спеціально зібране складання, у якому є лише ваш IPTV-застосунок, ваше проміжне ПЗ та інструменти, які ви туди додали, — без магазину застосунків і без шару Android.",
    avlDefineCandid:
      "Скажемо відверто одразу: близько 95% операторів, з якими ми працюємо, обирають Android — хоча в деяких регіонах Linux трапляється помітно частіше. Ми точно пояснимо, чому так, і коли Linux — розумніший вибір.",
    avlVerdictEyebrow: "Короткий висновок",
    avlVerdictTitle: "Дві колонки — знайдіть себе в одній",
    avlVerdictAndroidTitle: "Оберіть Android, якщо…",
    avlVerdictAndroid1:
      "Вам потрібна екосистема застосунків Android — популярні стримінгові та OTT-застосунки, які ваші абоненти вже знають",
    avlVerdictAndroid2:
      "Вам потрібен звичний, споживчий ТВ-досвід із мінімумом роботи над власним інтерфейсом",
    avlVerdictAndroid3: "Вам треба запуститися швидко й залишити простір для майбутніх застосунків",
    avlVerdictAndroid4:
      "Великий, знайомий каталог застосунків і споживчий рівень досвіду важливі для вашої пропозиції",
    avlVerdictLinuxTitle: "Оберіть Linux, якщо…",
    avlVerdictLinux1:
      "Ви надаєте суто керований IPTV-сервіс — власний застосунок, власна закрита екосистема й більше нічого",
    avlVerdictLinux2:
      "Вам потрібен найлегший слід і найнижчі експлуатаційні витрати на тому самому залізі",
    avlVerdictLinux3:
      "Вам потрібен максимальний контроль і жорстке блокування, без магазину застосунків на пристрої",
    avlVerdictLinux4: "Сторонні OTT-застосунки не входять до того, що ви продаєте",
    avlVerdictFootnote:
      "Чітко в колонці Android? Ви разом із тими 95% — це безпечний вибір за замовчуванням. Якщо ж вас описує колонка Linux, читайте далі.",
    avlCoreEyebrow: "Головна відмінність",
    avlCoreTitle: "Екосистема застосунків проти легкості та контролю",
    avlCoreBody1:
      "Якщо відкинути деталі, вибір зводиться до одного компромісу: екосистема застосунків і звичність проти легкості та контролю.",
    avlCoreBody2:
      "Android дає вам споживчий світ, який ваші абоненти вже знають: він запускає екосистему застосунків Android — ваш власний застосунок плюс популярні стримінгові та OTT-сервіси — під лаунчером, який ви можете брендувати, з доступом до всього каталогу застосунків Android. Саме через таке охоплення його обирає майже кожен оператор.",
    avlCoreBody3:
      "Linux дає протилежні переваги: гранично спрощений пристрій, який робить рівно те, що ви йому скажете, і нічого більше. Жодного магазину застосунків, жодного шару Google, жодної споживчої екосистеми — лише ваш IPTV-застосунок та інструменти, які ви схвалили. Завдяки цьому він легший, дешевший в експлуатації, простіший у блокуванні й повністю ваш.",
    avlCoreBody4:
      "Нюанс, що вирішує більшість випадків: великі OTT-сервіси зроблені саме як застосунки Android. Linux-приставка не здатна запустити їх узагалі — додати туди сторонній застосунок означає індивідуальну, окрему для кожного застосунку роботу, яка зазвичай непрактична. Тож якщо ваші абоненти очікують ці застосунки, Linux фактично відпадає сам собою. Якщо ж не очікують — його переваги цілком реальні.",
    avlTableEyebrow: "Пліч-о-пліч",
    avlTableTitle: "Android проти Linux, рядок за рядком",
    avlTableColDimension: "",
    avlTableColAndroid: "Android",
    avlTableColLinux: "Linux",
    avlRow1Dim: "Екосистема OTT-застосунків (Netflix, YouTube, Disney+)",
    avlRow1Android: "Запускає екосистему застосунків Android — ваш застосунок плюс OTT-сервіси",
    avlRow1Linux: "Жодних застосунків Android — лише клієнт, який ви створюєте",
    avlRow2Dim: "Звичність споживчого досвіду",
    avlRow2Android: "Знайомий досвід Android TV",
    avlRow2Linux: "Повністю власний — такий, який ви спроєктуєте",
    avlRow3Dim: "Брендування та кастомізація",
    avlRow3Android: "Брендований лаунчер, глибока кастомізація",
    avlRow3Linux: "Повний контроль над кожним пікселем і кожною поведінкою",
    avlRow4Dim: "Блокування в межах закритої екосистеми",
    avlRow4Android: "Можливе, потребує налаштування",
    avlRow4Linux: "Вбудоване — блокувати просто нічого, магазину застосунків немає",
    avlRow5Dim: "Слід на тій самій приставці",
    avlRow5Android: "Потребує більше запасу RAM і сховища",
    avlRow5Linux: "Працює легше; дає змогу взяти приставку нижчого класу",
    avlRow6Dim: "Час завантаження та споживання ресурсів",
    avlRow6Android: "Важчий",
    avlRow6Linux: "Легший, швидше завантаження",
    avlRow7Dim: "Оновлення платформи та безпеки",
    avlRow7Android: "База платформи Android плюс ваше OTA",
    avlRow7Linux: "Повністю керується оператором/inext через OTA",
    avlRow9Dim: "DRM / захист контенту",
    avlRow9Android: "Widevine та Verimatrix",
    avlRow9Linux: "Widevine та Verimatrix",
    avlRow10Dim: "Швидкість розробки та фахівці",
    avlRow10Android: "Велика екосистема, швидко",
    avlRow10Linux: "Робота для вузьких спеціалістів, більше індивідуального",
    avlRow12Dim: "Життєвий цикл і незалежність",
    avlRow12Android: "Рухається в ритмі платформи Google",
    avlRow12Linux: "Жодної зовнішньої залежності — довговічність контролюєте ви",
    avlRowAppDim: "Клієнтський застосунок inext",
    avlRowAppAndroid: "Готовий IPTV-застосунок і лаунчер — обидва під вашим брендом",
    avlRowAppLinux: "SDK та API, щоб швидко зібрати й інтегрувати",
    avlRowInextDim: "Керується стеком inext",
    avlStackLabel: "Однакове на обох:",
    avlStackAlcatraz: "Alcatraz DMS",
    avlStackOta: "OTA",
    avlStackTr069: "TR-069",
    avlStackCustomization: "кастомізація",
    avlTableNote:
      "DRM і точні особливості платформи залежать від приставки та складання — розкажіть, що потрібно вашому розгортанню, і ми все підтвердимо.",
    avlDecideEyebrow: "Що вирішує насправді",
    avlDecideTitle: "Питання, які закривають більшість рішень",
    avlDecide1Title: "Екосистема застосунків",
    avlDecide1Body:
      "Це найголовніша причина, чому виграє Android. Популярні OTT-сервіси — Netflix, YouTube, Disney+, Prime — зроблені як застосунки Android і працюють в екосистемі застосунків Android. Linux-приставка не здатна запустити їх узагалі; додати сторонній застосунок означає індивідуальну інтеграцію, яка для більшості операторів того не варта. Якщо перше питання абонента — «а Netflix тут є?», вашою відповіддю буде Android. Якщо ж ви постачаєте закритий IPTV-пакет і OTT-сервіси не входять до угоди, цей недолік вас просто не стосується.",
    avlDecide2Title: "Вартість і слід",
    avlDecide2Body:
      "Оскільки приставки однакові, сам по собі Linux не робить залізо дешевшим — він дає змогу зробити більше меншими засобами. Полегшене складання Linux менш вимогливе до RAM і сховища, тож для суто IPTV-розгортання ви можете взяти приставку нижчого класу, як-от inext TV5, і все одно отримати швидку, чуйну роботу — там, де та сама роль на Android потребує більшого запасу. У масштабах парку пристроїв цей запас — реальні гроші.",
    avlDecide3Title: "Контроль, безпека та блокування",
    avlDecide3Body:
      "Linux — природний вибір, коли «пристрій має робити рівно це й нічого більше» є жорсткою вимогою. Жодного магазину застосунків, жодної поверхні для встановлення стороннього ПЗ, менша поверхня для атак і складання, у якому є лише те, що ви схвалили. Android теж можна жорстко заблокувати, але це налаштування, яке вам доведеться підтримувати на тлі більшої платформи, що постійно змінюється. Для розгортань у форматі кіоску, регульованих чи під суворим контролем простота Linux і є тією самою перевагою.",
    avlDecide4Title: "Час виходу на ринок",
    avlDecide4Body:
      "Android швидше виводить на ринок продукт споживчого формату — лаунчер, застосунки та звична логіка взаємодії вже існують, їх лишається тільки забрендувати. Linux означає, що частину досвіду вам доведеться будувати або переносити самостійно — саме цього й хочеться, коли потрібен повний контроль, але це більше роботи наперед. Ми скорочуємо обидва шляхи: на Android — готовим IPTV-застосунком і послугою кастомізації, на Linux — SDK та API, що пришвидшують вашу збірку й інтеграцію.",
    avlDecide5Title: "Життєвий цикл і незалежність",
    avlDecide5Body:
      "Android рухається в ритмі платформи Google — нові версії та сумісність застосунків. Здебільшого це плюс, але це зовнішня залежність. У складання Linux такої сили тяжіння немає: воно ваше, заморожене чи розвинене за вашим графіком, у жодній чужій дорожній карті. Для розгортань із дуже довгим терміном служби або ринків, де ви хочете нульової зовнішньої залежності, це важливо.",
    avlProfilesEyebrow: "Що підходить саме вам?",
    avlProfilesTitle: "Підберіть платформу під свій сервіс",
    avlProfile1Title: "Оператор IPTV + OTT",
    avlProfile1Pick: "Android",
    avlProfile1Body:
      "Абоненти хочуть і ваші канали, і великі стримінгові застосунки. Це поширений випадок — ті самі ~95%.",
    avlProfile2Title: "Суто керований IPTV / закрита екосистема",
    avlProfile2Pick: "Linux",
    avlProfile2Body: "Тільки ваш застосунок, без сторонніх OTT. Варто серйозно розглянути.",
    avlProfile3Title: "Розгортання, орієнтоване на вартість і великі обсяги",
    avlProfile3Pick: "Linux",
    avlProfile3Body:
      "Коли пропозиція — це ваш власний пакет каналів, Linux на приставці нижчого класу розтягує бюджет.",
    avlProfile4Title: "Під суворим контролем / кіоск / регульований",
    avlProfile4Pick: "Linux",
    avlProfile4Body: "Коли блокування — жорстка вимога, легшу платформу простіше захистити.",
    avlProfile5Title: "Ще не визначилися / лишаєте варіанти відкритими",
    avlProfile5Pick: "Android",
    avlProfile5Body: "Безпечний вибір за замовчуванням, що тримає найбільше дверей відчиненими.",
    avlSameEyebrow: "Хоч би що ви обрали",
    avlSameTitle: "Решта стека — однакова",
    avlSameBody:
      "Кожна приставка inext — на Android чи на Linux — працює на одному операційному стеку: Alcatraz DMS для керування парком, поетапні OTA-оновлення, TR-069 і наша white-label кастомізація. Відрізняється лише одна частина — клієнтське ПЗ: на Android ви можете постачати наш готовий IPTV-застосунок і брендований лаунчер, обидва ваші; на Linux ми даємо вам SDK та API, щоб швидко зібрати й інтегрувати. У будь-якому разі інструменти, що керують парком, лишаються з вами.",
    avlLockTitle: "Те саме залізо — тож обирайте свідомо, а не нервово",
    avlLockBody:
      "Android чи Linux — це вибір прошивки на тій самій приставці, а не різні продукти. Ви можете оцінити обидві ще до того, як ухвалити рішення, або тримати змішаний парк. Переключити приставку між платформами згодом можливо, але це переошивка, а не звичайне OTA-оновлення, — тож найкраще обрати ту платформу, на якій ви плануєте лишитися, і твердо її дотримуватися. Рішення про залізо — низькоризикове; рішення про платформу варто ухвалювати виважено.",
    avlFaqEyebrow: "FAQ",
    avlFaqTitle: "Поширені запитання",
    avlFaqQ1: "Чи можна запускати Netflix на Linux-приставці?",
    avlFaqA1:
      "Зазвичай ні. Netflix, YouTube і Disney+ зроблені як застосунки Android; Linux-приставка не здатна їх запустити, а додавання стороннього застосунку — це індивідуальна, часто непрактична інтеграція. Якщо ці застосунки важливі для вашої пропозиції, обирайте Android.",
    avlFaqQ2: "Чи Android дорожчий за Linux?",
    avlFaqA2:
      "Залізо — це та сама приставка inext, тож платформа не є окремою статтею витрат. Android потребує трохи більше запасу RAM і сховища, тож для суто IPTV-ролі Linux може дати змогу взяти приставку нижчого класу.",
    avlFaqQ3: "Чи можна потім перейти з Linux на Android або назад?",
    avlFaqA3:
      "Це можливо, але це не звичайне OTA-оновлення — переключення приставки між Android і Linux означає переошивку прошивки, а це складніший процес. Залізо в обох випадках те саме, тож ви не купуєте різні пристрої, але ми б радили твердо обрати ту платформу, на якій плануєте лишитися.",
    avlFaqQ4: "Що обирає більшість операторів?",
    avlFaqA4:
      "Близько 95% обирають Android, бо їхні абоненти очікують популярні OTT-застосунки — хоча в деяких регіонах Linux трапляється помітно частіше. Linux виграє для розгортань суто керованого IPTV, жорсткого блокування й найлегшого сліду.",
    avlFaqQ5: "Чи працює керування пристроями inext на обох?",
    avlFaqA5:
      "Так — Alcatraz DMS, OTA-оновлення та TR-069 працюють однаково на складаннях Android і Linux.",
    avlCtaEyebrow: "Поговорімо",
    avlCtaTitle: "Не впевнені, що підходить вашому розгортанню?",
    avlCtaBody:
      "Розкажіть про свій сервіс, і ми чесно порекомендуємо платформу — зокрема й тоді, коли це Linux.",
    avlCtaPrimary: "Зв’язатися з нашою командою",
    avlCtaSecondary: "Замовити складання прошивки Linux",
    footerLinkGuidesAospCert: "AOSP чи сертифікація",
    guidesCardAcTitle: "AOSP проти Сертифікованого Android TV",
    guidesCardAcDesc:
      "Що насправді потрібно вашому запуску? Сертифікована екосистема застосунків проти швидкості, вартості й контролю — і як ми даємо і те, і інше.",
    acSeoTitle: "AOSP чи Сертифікований Android TV: що потрібно вашому запуску? | inext",
    acSeoDescription:
      "AOSP чи сертифікований Google Android TV для вашого розгортання? Чесне порівняння від inext — ми постачаємо обидва. Екосистема застосунків, вартість, час виходу на ринок і коли сертифікація справді того варта.",
    acBreadcrumbPage: "AOSP проти Сертифікованого Android TV",
    acHeroEyebrow: "Гайд із вибору платформи",
    acHeroTitle: "AOSP проти Сертифікованого Android TV:",
    acHeroTitleAccent: "що насправді потрібно вашому запуску?",
    acHeroSub:
      "Обидва — це Android, а різнить їх сертифікація Google і той час, гроші та контроль, які ви на неї міняєте. AOSP ми збираємо самі, тож не вдаватимемо нейтральність: для більшості операторів це швидший, дешевший і гнучкіший вибір — і саме його ми чесно радимо. А коли проєкту справді потрібна сертифікація, ми робимо і це, разом із нашими сертифікованими партнерами-3PL. Ця сторінка розкладає компроміс по поличках, щоб ви зрозуміли, що потрібно саме вашому запуску.",
    acHeroNote:
      "Більшість операторів виходять на AOSP. Коли проєкту справді потрібна сертифікація, ми робимо і це.",
    acHeroCtaPrimary: "Поговорити з нашою командою",
    acHeroCtaSecondary: "Подивитися порівняння",
    acDefineEyebrow: "Почніть звідси",
    acDefineTitle: "Спершу — що насправді змінює «сертифікація»",
    acDefineBody:
      "Обидва працюють на Android. Межа між ними — програма сертифікації Google і все, що від неї залежить:",
    acDefineAospLabel: "AOSP",
    acDefineAospBody:
      "Android з відкритим кодом, повністю ваш — ваш лаунчер, ваші застосунки, ваші правила. Без магазину Google Play і без бар'єра сертифікації, але з Widevine L1 та L3 на борту — тож із вашими угодами оператора він усе одно запускає преміумзастосунки на кшталт Netflix. Запуск значно швидший і дешевший.",
    acDefineCertLabel: "Сертифікований Android TV",
    acDefineCertBody:
      "Сертифікований Google, із вбудованими Google Play, Widevine L1, Google Assistant і Chromecast — основа сертифікованої екосистеми застосунків — ціною ліцензування, погодження та термінів Google.",
    acStat1: "1–2 тижні до робочого зразка",
    acStat2: "Без плати Google за кожен пристрій на AOSP",
    acStat3: "Обидві платформи — один партнер",
    acPivotEyebrow: "Почніть звідси",
    acPivotTitle: "Зазвичай усе зводиться до одного питання",
    acPivotQuestion:
      "Чи потрібен вашим абонентам відкритий магазин Google Play — тисячі застосунків, які вони встановлюють самі, — а також Google Assistant і Chromecast?",
    acPivotNoLabel: "Ні — підібраний досвід під контролем оператора",
    acPivotNoPick: "AOSP",
    acPivotNoText:
      "В основі — ваш власний сервіс і обраний набір застосунків: зокрема Netflix та інші преміумзастосунки там, де у вас є відповідна угода. Швидше, дешевше, повністю ваше.",
    acPivotYesLabel: "Так — відкритий споживчий магазин застосунків",
    acPivotYesPick: "Сертифікований",
    acPivotYesText:
      "Вам потрібен повноцінний Play Store, де абоненти самі встановлюють застосунки, і сервіси Google як частина продукту. Це варте ліцензування й довших термінів.",
    acPivotFootnote:
      "Більшість операторів відповідають «ні» й виходять на AOSP. Хоч куди б ви схилялися, ми це реалізуємо.",
    acTimelineEyebrow: "Час виходу на ринок",
    acTimelineTitle: "Два шляхи до запуску",
    acTimelineIntro:
      "Найбільша практична різниця — не в технології, а в тому, скільки часу займає вихід у роботу й у що це обходиться.",
    acTimelineAospLabel: "AOSP з inext",
    acTimelineAospResult: "~2 місяці до відвантаження",
    acTimelineAospStep1: "Налаштовуємо лаунчер, застосунок і сервіси під ваш бренд",
    acTimelineAospStep2: "Підтверджуємо робочий зразок — приблизно за 1–2 тижні",
    acTimelineAospStep3: "Розгортаємо",
    acTimelineCertLabel: "Сертифікований Android TV",
    acTimelineCertResult: "5–8 місяців до відвантаження",
    acTimelineCertStep1: "Ліцензуємо GMS, специфікуємо схвалене Google залізо",
    acTimelineCertStep2: "Збираємо й інтегруємо",
    acTimelineCertStep3: "Тестування для сертифікації",
    acTimelineCertStep4: "Погодження від Google",
    acTimelineCertStep5: "Розгортаємо",
    acTimelineNote:
      "Платформу AOSP ми вже зібрали, тож її звичний мінус «довго будувати» зник. Потрібна сертифікація? Цей напрям ми теж ведемо, разом із нашими сертифікованими партнерами-3PL.",
    acIncludesEyebrow: "Що ви отримуєте",
    acIncludesTitle: "Наш AOSP — не порожня коробка, а готова до запуску платформа",
    acIncludesBody:
      "Усе нижче вже зібране, перевірене й адаптоване під ваш бренд. Точний набір застосунків добирається під вашу країну та ліцензування, тож тут його не наведено.",
    acIncludes1:
      "Налаштовуваний лаунчер рівня оператора — ваш бренд і контент першими після ввімкнення",
    acIncludes2: "Наш IPTV-застосунок під вашим брендом",
    acIncludes3:
      "Локальні ТБ- і стримінгові сервіси вашого ринку попередньо встановлені — плюс преміумзастосунки на кшталт Netflix там, де у вас є угода",
    acIncludes4: "Керування через Alcatraz DMS, OTA і TR-069 з першого дня",
    acIncludes5: "Налаштовано й підтверджено робочим зразком за 1–2 тижні",
    acTableEyebrow: "Повне порівняння",
    acTableTitle: "У чому AOSP і Сертифікований насправді різняться",
    acTableColDimension: "",
    acTableColAosp: "AOSP",
    acTableColCert: "Сертифікований Android TV",
    acRow1Dim: "Магазин Google Play",
    acRow1Aosp: "Без Play Store — власна доставка застосунків",
    acRow1Cert: "Вбудований — тисячі застосунків",
    acRow2Dim: "Преміумзастосунки (Netflix, Disney+ у HD/4K)",
    acRow2Aosp: "Працюють там, де у вашої мережі є угода оператора — наш AOSP має Widevine L1",
    acRow2Cert: "Те саме, плюс розповсюдження через Google Play; угода оператора все одно потрібна",
    acRow3Dim: "Google Assistant і Chromecast",
    acRow3Aosp: "Не входять (або на замовлення)",
    acRow3Cert: "Вбудовані",
    acRow4Dim: "Widevine DRM",
    acRow4Aosp: "Widevine L1 і L3 на приставках inext",
    acRow4Cert: "Widevine L1 і L3",
    acRow5Dim: "Лаунчер / головний екран оператора",
    acRow5Aosp: "Повністю на замовлення, веде після ввімкнення — повний контроль",
    acRow5Cert: "Лаунчер рівня оператора, у межах правил Google",
    acRow6Dim: "Передвстановлені застосунки та локальні сервіси",
    acRow6Aosp: "Рівно те, що потрібно вашому ринку — на ваш розсуд",
    acRow6Cert: "Модель Google Play, плюс ваші доповнення",
    acRow7Dim: "Свобода кастомізації",
    acRow7Aosp: "Повна",
    acRow7Cert: "У межах програми Google",
    acRow8Dim: "Залізо",
    acRow8Aosp: "Працює на ощадливих, оптимізованих за ціною приставках",
    acRow8Cert: "Потужніше, схвалене Google",
    acRow9Dim: "Час виходу на ринок",
    acRow9Aosp: "~2 місяці до відвантаження (робочий зразок за 1–2 тижні)",
    acRow9Cert: "Зазвичай 5–8 місяців до відвантаження",
    acRow10Dim: "Вартість",
    acRow10Aosp: "Без ліцензії GMS і плати Google за кожен пристрій",
    acRow10Cert: "Ліцензія GMS, плата за кожен пристрій, витрати на тест-лабораторію",
    acRow11Dim: "Залежність від Google",
    acRow11Aosp: "Немає",
    acRow11Cert: "Постійна відповідність вимогам Google",
    acRow12Dim: "Білінг і платежі (продаж абонентам)",
    acRow12Aosp: "Будь-який платіжний шлюз чи партнер — власний білінг, без комісії платформи",
    acRow12Cert: "Цифрові продажі мають іти через білінг Google Play — Google бере комісію",
    acRow13Dim: "Викочування системного оновлення / прошивки",
    acRow13Aosp: "Зберіть сьогодні — завтра на всьому парку пристроїв, цілком на ваш розсуд",
    acRow13Cert:
      "Кожна зміна системи має пройти Google або лабораторію 3PL, перш ніж її можна випустити",
    acTableNote:
      "Преміумзастосунки на кшталт Netflix потребують власної сертифікації пристрою, а для ISP, що включає їх у пакет, — прямої угоди оператора, на будь-якій платформі. Перевага: наш AOSP має Widevine L1, тож за наявності такої угоди Netflix на ньому працює без сертифікації Google. Ми розпишемо, що саме потрібно кожному застосунку з вашого набору.",
    acSameEyebrow: "Хоч що вам потрібно",
    acSameTitle: "Обидві платформи, один партнер — і пряма відповідь, що саме вам потрібно",
    acSameBody:
      "Скажемо прямо: AOSP — наш власний продукт, тож саме його ми збираємо й зазвичай радимо — бо для більшості операторів це справді кращий варіант. Чого ми не робитимемо — то це нав'язувати його, коли вашому проєкту потрібна сертифікація, або продавати сертифікацію, якої не потрібно. А коли вона справді потрібна, ми постачаємо й повністю сертифікований Android TV — над самою сертифікацією працюємо з нашими сертифікованими партнерами-3PL. Одні стосунки, один операційний стек і пряма відповідь замість продажу того, на чому ми більше заробимо.",
    acInhouseTitle: "AOSP — власної розробки",
    acInhouseBody:
      "Перевірений, повністю налаштовуваний лаунчер рівня оператора й наш IPTV-застосунок із попередньо встановленими локальними ТБ- і стримінговими сервісами вашого ринку. Адаптовано під ваш бренд і підтверджено робочим зразком за 1–2 тижні.",
    acPartnerTitle: "Сертифікований Android TV — постачаємо його разом із партнерами-3PL",
    acPartnerBody:
      "Коли вашій пропозиції потрібні Google Play, сертифіковані преміумзастосунки й Widevine L1, ми постачаємо повністю сертифікований Android TV — над сертифікацією працюємо з нашими сертифікованими партнерами-3PL, а inext лишається вашою єдиною точкою контакту й командою, що відповідає за результат.",
    acSameNoteTitle: "Один стек обслуговує обидві",
    acSameNoteBody:
      "Хоч на якій платформі ви зупинитеся, парком пристроїв керує той самий операційний стек inext — Alcatraz DMS, поетапні OTA, TR-069 і white-label кастомізація. Вибір AOSP чи сертифікованого не змінює того, як ви працюєте щодня.",
    acFaqEyebrow: "FAQ",
    acFaqTitle: "Поширені запитання",
    acFaqQ1: "Чи можна запустити Netflix на AOSP від inext?",
    acFaqA1:
      "Так — там, де у вашої мережі є угода з Netflix. Наш AOSP підтримує Widevine L1, тож за наявності угоди оператора на ньому працює повноцінний застосунок Netflix без сертифікації Google. Те саме стосується інших преміумсервісів, на які у вас є угоди: ви приносите угоду, ми даємо готову до L1 платформу й інтеграцію.",
    acFaqQ2:
      "inext не є сертифікованим постачальником Android TV — ви все одно можете його надати?",
    acFaqA2:
      "Так. AOSP ми розробляємо власноруч, а також постачаємо повністю сертифікований Android TV — над самою сертифікацією працюємо із сертифікованими партнерами-3PL, де inext виступає головним підрядником. Ви отримуєте обидва варіанти й єдину точку контакту, а сертифікований напрям ведемо ми, тож вам не доведеться збирати його самотужки.",
    acFaqQ3: "Як швидко ви можете надати рішення на AOSP?",
    acFaqA3:
      "Наша платформа AOSP вже зібрана й перевірена, тож адаптувати її під ваш бренд і передати вам робочий зразок зазвичай займає 1–2 тижні. Від старту проєкту до відвантаження товару — приблизно 2 місяці, проти 5–8 місяців, які зазвичай потрібні сертифікованій приставці Android TV, хоча це залежить від ваших інтеграцій, ліцензування й замовлення.",
    acFaqQ4: "Що входить до AOSP від inext?",
    acFaqA4:
      "Налаштовуваний лаунчер рівня оператора, наш IPTV-застосунок і попередньо встановлені локальні ТБ- та стримінгові сервіси вашого ринку. Точний набір застосунків залежить від вашої країни й ліцензування у вашому регіоні, тож ми добираємо його під кожне розгортання.",
    acFaqQ5: "Що обирає більшість операторів?",
    acFaqA5:
      "Більшість обирає AOSP — він покриває те, що потрібно їхньому сервісу, запускається швидше й коштує менше, а ще запускає преміумзастосунки на кшталт Netflix там, де є відповідна угода. Сертифікація — правильний вибір, коли вам конкретно потрібен відкритий Google Play, з якого абоненти самі встановлюють застосунки, і сервіси Google, — і ми це теж постачаємо.",
    acFaqQ6: "Чи працює операційний стек inext на обох?",
    acFaqA6:
      "Так — Alcatraz DMS, OTA-оновлення й TR-069 керують вашим парком пристроїв однаково, чи то AOSP, чи сертифікований.",
    acFaqQ7: "Чи означає сертифікація Google, що мої абоненти отримають Netflix?",
    acFaqA7:
      "Сама по собі — ні, та для Netflix вона вам і не потрібна. Netflix сертифікує пристрої самостійно й хоче прямої угоди з операторами, які включають його в пакет; за наявності такої угоди наш AOSP запускає Netflix без сертифікації Google, бо він має Widevine L1. Справжня цінність сертифікації Google — це відкритий Play Store, з якого абоненти самі встановлюють застосунки, і власні сервіси Google (Assistant, Chromecast), а не флагманські застосунки.",
    acFaqQ8: "Якщо я продаю підписки чи контент, хто опікується білінгом?",
    acFaqA8:
      "На AOSP — ви самі, через будь-який платіжний шлюз чи партнера на ваш вибір, без комісії платформи й без участі Google. На сертифікованому Android TV цифрові товари, продані через застосунок із Play, мають проходити через білінг Google Play, і Google бере свою частку з кожної транзакції. Для операторів, що монетизують абонентів напряму, це швидко накопичується — і це одна з вагоміших причин лишатися на AOSP.",
    acFaqQ9: "Хто контролює оновлення прошивки (OTA) на кожній платформі?",
    acFaqA9:
      "На AOSP — ви самі: ми можемо зібрати нову прошивку й наступного дня викотити її на весь ваш парк пристроїв, без жодного зовнішнього погодження. На сертифікованому Android TV це під контролем: фреймворк сертифікації вимагає, щоб кожну зміну на рівні системи повторно перевірив Google або призначена тест-лабораторія 3PL, перш ніж її можна випустити — навіть на Operator Tier. Для операторів, які часто латають, тонко налаштовують чи ітерують, це суттєва практична різниця.",
    acCtaEyebrow: "Поговоріть із нами",
    acCtaTitle: "Не впевнені, чи потрібна вашому запуску сертифікація?",
    acCtaBody:
      "Розкажіть, чого очікують ваші абоненти і як швидко вам треба вийти в роботу. Ми порадимо платформу, що підходить, — AOSP чи сертифіковану — і реалізуємо її.",
    acCtaPrimary: "Поговорити з нашою командою",
    acCtaSecondary: "Замовити зразок на AOSP",
    footerLinkGuidesOwnStb: "Приставка чи Smart TV",
    footerLinkGuidesBoxModels: "Субсидія, оренда, продаж",
    footerLinkGuidesMulticastOtt: "Multicast чи OTT",
    footerLinkGuidesBuildBuy: "Розробляти чи купувати",
    guidesCardOsTitle: "Власні приставки чи Smart TV",
    guidesCardOsDesc:
      "Постачати власну брендовану приставку чи покладатися на Smart TV абонентів? Чесна відповідь — і те, і те, але приставка є тією частиною, якою ви володієте на 100%. Аргументи оператора на користь того, щоб її постачати.",
    guidesCardBmTitle: "Субсидувати, здавати в оренду чи продати приставку",
    guidesCardBmDesc:
      "Віддати приставку безкоштовно, здати в оренду чи продати одразу у власність? Це фінансове рішення, а не питання заліза — компроміси CapEx/OpEx і TCO, а також блокування DMS, що убезпечує субсидування й оренду.",
    guidesCardMoTitle: "Multicast IPTV проти OTT-стримінгу",
    guidesCardMoDesc:
      "Один економний потік для всіх у вашій керованій мережі чи окремий адаптивний потік для кожного глядача через інтернет? Чесні компроміси щодо пропускної здатності, якості, затримки та охоплення — і чому багато операторів використовують обидва підходи.",
    guidesCardBbTitle: "Приставка: розробляти чи купувати",
    guidesCardBbDesc:
      "Створити власну платформу приставки чи купити готовий стек? «Розробити» означає володіти вісьмома рівнями — від кремнію до підтримки. Чесний розбір «робити чи купувати» для операторів і коли виграє кожен бік.",
    footerLinkGuidesStbChecklist: "Чекліст вибору STB",
    guidesCardSbcTitle: "Чекліст вибору STB",
    guidesCardSbcDesc:
      "Перед закупівлею приставок перевірте весь комплекс: обладнання, кодеки, мережу, DRM, застосунки, керування парком, оформлення, гарантію та логістику.",
    sbcSeoTitle: "Чекліст вибору IPTV STB: як обрати ТВ-приставки | inext",
    sbcSeoDescription:
      "Практичний чекліст вибору STB для інтернет-провайдерів, IPTV- та OTT-операторів, телеком-компаній, готельних і MDU-проєктів та дистрибуторів.",
    sbcBreadcrumbPage: "Чекліст вибору STB",
    sbcHeroEyebrow: "Чекліст покупця",
    sbcHeroTitle: "Чекліст вибору STB:",
    sbcHeroTitleAccent: "що перевірити перед закупівлею приставок",
    sbcHeroSub:
      "Хороша приставка — це не лише чипсет і ціна. Обладнання, прошивка, застосунки, захист контенту, пульт, керування парком, підтримка й логістика мають працювати як єдине ціле після першої поставки.",
    sbcHeroNote:
      "Використовуйте цей чекліст перед випробуванням зразків, формуванням короткого списку постачальників або замовленням партії. Він призначений для інтернет-провайдерів, IPTV- та OTT-операторів, телеком-компаній, готельних і MDU-проєктів та дистрибуторів, які працюють з операторами.",
    sbcHeroCtaPrimary: "Поговорити з командою",
    sbcHeroCtaSecondary: "Відкрити чекліст",
    sbcStat1: "Обладнання та програмне забезпечення",
    sbcStat2: "Зразок перед замовленням партії",
    sbcStat3: "Керування парком має значення",
    sbcThesisEyebrow: "Почніть тут",
    sbcThesisTitle: "Купуйте сервісну платформу, а не просто приставку",
    sbcThesisBody1:
      "Недорога Android-приставка з роздрібного ринку може привабливо виглядати в кошторисі, але для керованого телебачення потрібен пристрій, який можна оформити під бренд, централізовано налаштовувати, блокувати, оновлювати й підтримувати в тисячах домівок, готельних номерів або партнерських об'єктів.",
    sbcThesisBody2:
      "Правильна STB залежить від моделі послуги: кероване IPTV у приватній мережі, телебачення з акцентом на OTT, гібрид IPTV та OTT, готельне або MDU-телебачення чи перепродаж через дистрибутора. Чекліст залишається тим самим, але важливість кожного пункту змінюється.",
    sbcThesisNoteTitle: "Практичне правило",
    sbcThesisNoteBody:
      "Якщо вимога впливає на досвід абонента, доступ до контенту, витрати на підтримку або контроль парку, перевірте її на реальному зразку до підтвердження замовлення.",
    sbcBuyerEyebrow: "Сценарії",
    sbcBuyerTitle: "Підбирайте приставку під сервіс, який запускаєте",
    sbcBuyerIntro:
      "Одна модель може підійти для кількох проєктів, але критерії закупівлі різняться. Почніть із послуги, а потім обирайте клас обладнання.",
    sbcBuyer1Title: "Керована IPTV-послуга",
    sbcBuyer1Body:
      "Пріоритети: Ethernet, підтримка багатоадресного мовлення, стабільна прошивка, простий головний екран, віддалена діагностика та надійне декодування прямих телеканалів.",
    sbcBuyer2Title: "Телебачення з акцентом на OTT",
    sbcBuyer2Body:
      "Пріоритети: швидкодія застосунків, готовність DRM, достатній обсяг сховища, стабільна робота Wi-Fi, адаптивне потокове передавання та зручний пульт.",
    sbcBuyer3Title: "Гібрид IPTV та OTT",
    sbcBuyer3Body:
      "Перевірте, що один пристрій без плутанини для глядача працює з прямими каналами через багатоадресне мовлення, VOD, телебаченням у записі, порталами й операторськими застосунками.",
    sbcBuyer4Title: "Готелі та MDU",
    sbcBuyer4Body:
      "Шукайте обмежений інтерфейс без залежності від особистих облікових записів, централізовані налаштування, масове налаштування пристроїв і просту заміну на об'єкті.",
    sbcBuyer5Title: "Оцінка для дистрибутора",
    sbcBuyer5Body:
      "Перевіряйте пакування, варіанти аксесуарів, гарантійний процес, локалізацію інтерфейсу, логістику й здатність постачальника підтримувати версії для операторів.",
    sbcTableEyebrow: "Чекліст",
    sbcTableTitle: "Що перевірити перед закупівлею STB",
    sbcTableIntro:
      "Сприймайте кожен рядок як пункт випробування зразка, а не як твердження з брошури. Надійний постачальник має підтвердити відповідь на реальному обладнанні.",
    sbcTableColCheck: "Перевірка",
    sbcTableColWhy: "Чому це важливо",
    sbcTableColNote: "Примітка покупця",
    sbcRow1Check: "Зрілість чипсета й платформи",
    sbcRow1Why:
      "SoC визначає декодування, рівень DRM, стабільність драйверів, тепловий режим і термін підтримки прошивки.",
    sbcRow1Note:
      "Запитайте, яку платформу постачальник уже постачає серійно, а не лише що може зібрати для одиничного проєкту.",
    sbcRow2Check: "Оперативна пам'ять і сховище",
    sbcRow2Why:
      "Нестача оперативної пам'яті сповільнює головний екран і OTT-застосунки; мале сховище обмежує кількість застосунків, журналів та оновлень.",
    sbcRow2Note:
      "Проста IPTV-послуга може працювати на доступнішій моделі. Android-рішення з багатьма застосунками потребують більшого запасу ресурсів.",
    sbcRow3Check: "Відео, аудіо та вимоги 4K",
    sbcRow3Why:
      "Кодеки, HDR, роздільна здатність і підтримка аудіо визначають, чи плавно працюватиме послуга на телевізорах абонентів.",
    sbcRow3Note: "Тестуйте реальні прямі канали й матеріали VOD, а не лише демонстраційні відео.",
    sbcRow4Check: "Ethernet і багатоадресне мовлення",
    sbcRow4Why:
      "Кероване IPTV та готельні мережі часто залежать від дротового Ethernet, IGMP і стабільного багатоадресного відтворення.",
    sbcRow4Note:
      "Якщо багатоадресне мовлення важливе, перевірте його на цільовому комутаторі та в реальній архітектурі мережі.",
    sbcRow5Check: "Wi-Fi та OTT поза мережею оператора",
    sbcRow5Why:
      "OTT у додаткових кімнатах і багатьох домашніх інсталяціях залежить від якості Wi-Fi, перемикання між точками доступу й адаптивного потокового передавання.",
    sbcRow5Note:
      "Тестуйте кімнати зі слабким сигналом і перевантажені квартири, а не лише чисту лабораторію.",
    sbcRow6Check: "Готовність DRM і CAS",
    sbcRow6Why:
      "Захищений контент потребує належного рівня DRM, завантаження ключів, інтеграції з партнерами та іноді підтримки CAS.",
    sbcRow6Note:
      "Підтвердьте повний шлях контенту: Widevine, Verimatrix, застосунок порталу, ліцензійну угоду оператора та налаштування на заводі.",
    sbcRow7Check: "Операційна система та стратегія застосунків",
    sbcRow7Why:
      "AOSP, сертифікована Android TV і Linux відрізняються доступністю застосунків, вартістю сертифікації, контролем оновлень і терміном запуску.",
    sbcRow7Note:
      "Обирайте операційну систему відповідно до потрібних застосунків і моделі керування, а не через загальну прихильність до платформи.",
    sbcRow8Check: "Керування пристроями та OTA",
    sbcRow8Why:
      "Без віддаленого налаштування, діагностики, поетапних оновлень і блокування кожна проблема на об'єкті стає дорогою.",
    sbcRow8Note: "Попросіть показати процес роботи в DMS до затвердження пристрою.",
    sbcRow9Check: "Пульт і щоденна зручність",
    sbcRow9Why:
      "Пульт, головний екран, послідовність запуску та екрани налаштувань формують щоденний досвід абонента сильніше, ніж перелік характеристик.",
    sbcRow9Note:
      "Тестуйте з користувачами без технічної підготовки та перевіряйте розташування кнопок, роботу через інфрачервоний канал або Bluetooth і якість перекладу.",
    sbcRow10Check: "Брендинг, пакування й аксесуари",
    sbcRow10Why:
      "Приставка, пульт, блок живлення, кабель HDMI, етикетки та короткий посібник впливають на підтримку й сприйняття якості.",
    sbcRow10Note:
      "Заздалегідь узгодьте типи вилок, мови, етикетки, компонування коробки та наявність запасних аксесуарів.",
    sbcRow11Check: "Гарантія, запасні пристрої й логістика",
    sbcRow11Why:
      "Замовлення великої партії обладнання — це тривалий операційний процес: терміни, гарантійні повернення, запасні пристрої та маршрути перевезення мають значення й після запуску.",
    sbcRow11Note: "Відокремлюйте доставку зразків для оцінювання від логістики серійних замовлень.",
    sbcRow12Check: "Підтримка постачальника та життєвий цикл",
    sbcRow12Why:
      "Приставка, яка працює сьогодні, надалі все одно потребуватиме оновлень прошивки й застосунків, виправлень безпеки та плану заміни.",
    sbcRow12Note:
      "Надавайте перевагу постачальникам, які можуть пояснити порядок підтримки протягом усього життєвого циклу пристрою.",
    sbcTableNote:
      "Найкращий вибір — зазвичай не пристрій із найдовшим переліком характеристик, а той, що усуває найбільше ризиків запуску й підтримки.",
    sbcModelEyebrow: "Підбір моделі",
    sbcModelTitle: "Практичний спосіб оцінити лінійку inext",
    sbcModelIntro:
      "Це не жорсткі правила, а відправна точка для зіставлення складності послуги із запасом ресурсів обладнання перед випробуванням зразка.",
    sbcModelTv5Body:
      "Доступний варіант для контрольованої IPTV-послуги, простих головних екранів і чутливих до ціни проєктів із невеликою кількістю застосунків.",
    sbcModelTv5Meta: "Проста IPTV-послуга",
    sbcModelTv5UltraBody:
      "Більше ресурсів для Android-рішень із фірмовим оформленням, додаткових застосунків і типових операторських розгортань зі збалансованою ціною.",
    sbcModelTv5UltraMeta: "Збалансований Android",
    sbcModelTv6Body:
      "Сильний вибір для сучасних гібридних послуг IPTV та OTT із більшим запасом для інтерфейсу, застосунків та оновлень.",
    sbcModelTv6Meta: "Універсальний гібрид",
    sbcModelTv6UltraBody:
      "Найпотужніший варіант для великої кількості застосунків, тривалого життєвого циклу та флагманських проєктів керованого телебачення.",
    sbcModelTv6UltraMeta: "Найпотужніша конфігурація",
    sbcModelCta: "Порівняти всі STB моделі",
    sbcRedFlagsEyebrow: "Ознаки ризику",
    sbcRedFlagsTitle: "Що має насторожити перед замовленням партії",
    sbcRedFlagsIntro:
      "Більшість проблем зі STB можна виявити під час оцінювання, якщо правильно випробувати зразок.",
    sbcRedFlag1:
      "Постачальник пропонує роздрібну Android-приставку без операторської прошивки, контролю головного екрана або керування парком.",
    sbcRedFlag2:
      "Підтримку DRM, CAS або захищених застосунків описано нечітко, без зрозумілого процесу налаштування та ліцензування.",
    sbcRedFlag3:
      "Оновлення OTA виконуються вручну, запускаються на весь парк одразу або залежать від дій абонента.",
    sbcRedFlag4:
      "Немає можливості віддалено блокувати, призупиняти, переналаштовувати або діагностувати пристрої.",
    sbcRedFlag5:
      "Роботу Ethernet, багатоадресного мовлення або Wi-Fi обіцяють, але не демонструють у цільовій мережі.",
    sbcRedFlag6: "Пакування, аксесуари, вилки, етикетки або посібники вважають другорядними.",
    sbcRedFlag7:
      "Постачальник не може пояснити гарантійний процес, наявність запасних пристроїв, життєвий цикл прошивки або логістику серійних замовлень.",
    sbcSampleEyebrow: "Перевірка зразка",
    sbcSampleTitle: "Що перевірити на зразку приставки",
    sbcSampleIntro:
      "Зразок — не сувенір, а доказ того, що пристрій може стати частиною керованого парку.",
    sbcSample1:
      "Виконайте холодний запуск у головний екран із вашим оформленням і перевірте перше враження користувача.",
    sbcSample2:
      "Відтворіть прямі IPTV-канали, потоки OTT, VOD і телебачення в записі з реальних джерел послуги.",
    sbcSample3:
      "Перевірте багатоадресне мовлення або портал у цільовій мережі, а не лише в лабораторії.",
    sbcSample4: "Перевірте захищений DRM-контент і всі необхідні захищені застосунки.",
    sbcSample5: "Надішліть оновлення застосунку або прошивки через систему керування.",
    sbcSample6:
      "Переконайтеся, що пристрій відображається в DMS, має діагностику, групи та віддалені дії.",
    sbcSample7:
      "Перевірте призупинення, мережеве блокування, режим кіоску або блокування застосунків, якщо цього потребує комерційна модель.",
    sbcSample8:
      "Оцініть пульт: зручність, призначення кнопок, сполучення та ймовірні звернення абонентів до підтримки.",
    sbcSample9:
      "Залиште приставку в роботі достатньо довго, щоб виявити перегрівання, перезапуски та проблеми з Wi-Fi або пам'яттю.",
    sbcSample10:
      "Перевірте пакування, вилки, етикетки, аксесуари та перекладені матеріали для швидкого початку роботи.",
    sbcFitEyebrow: "Де тут inext",
    sbcFitTitle: "Ми допомагаємо перевірити весь комплекс",
    sbcFitBody:
      "inext об'єднує обладнання, прошивку, головний екран, застосунок IPTV, Alcatraz DMS, OTA, оформлення під бренд і міжнародну B2B-логістику в єдине кероване рішення для STB. Один постачальник відповідає за обладнання, програмне забезпечення та розгортання ще до замовлення партії.",
    sbcFitCtaDms: "Дивитися Alcatraz DMS",
    sbcFitCtaLogistics: "Дивитися логістику",
    sbcFaqEyebrow: "FAQ",
    sbcFaqTitle: "Поширені запитання",
    sbcFaqQ1: "Це лише для IPTV-операторів?",
    sbcFaqA1:
      "Ні. Чекліст призначений для всіх, хто оцінює пристрої для керованого телебачення: інтернет-провайдерів, IPTV- та OTT-операторів, телеком-компаній, готельних і MDU-проєктів, а також дистрибуторів, що закуповують приставки для операторів.",
    sbcFaqQ2: "Обирати Android, AOSP, сертифіковану Android TV чи Linux?",
    sbcFaqA2:
      "Обирайте відповідно до послуги. Android або AOSP добре підходять для проєктів із багатьма застосунками та значною часткою OTT; сертифікована Android TV — для проєктів, яким потрібна екосистема Google; Linux — для контрольованих рішень лише з IPTV. Головне — узгодити операційну систему, застосунки, сертифікацію та контроль оновлень.",
    sbcFaqQ3: "Скільки потрібно оперативної пам'яті та сховища?",
    sbcFaqA3:
      "Проста IPTV-послуга може працювати на доступнішій приставці. Сучасний Android із кількома застосунками, складнішим інтерфейсом і довшим життєвим циклом потребує більшого запасу. Найнадійніший спосіб визначитися — протестувати реальний головний екран, застосунки й пакет оновлення на обраній моделі.",
    sbcFaqQ4: "Ethernet ще важливий, якщо OTT працює через Wi-Fi?",
    sbcFaqA4:
      "Так. OTT може працювати через Wi-Fi, але керована IPTV-послуга, багатоадресне мовлення та багато готельних або MDU-мереж досі залежать від дротового Ethernet для передбачуваної якості.",
    sbcFaqQ5: "Одна приставка може працювати і з IPTV, і з OTT?",
    sbcFaqA5:
      "Так, якщо обладнання, прошивка та застосунок підготовлені для обох сценаріїв. Перед замовленням слід перевірити пряме телебачення через багатоадресне мовлення або портал, потоки OTT, VOD і телебачення в записі на одному зразку.",
    sbcFaqQ6: "Коли варто замовляти зразок для оцінювання?",
    sbcFaqA6:
      "До комерційного погодження. Зразок треба випробувати з реальним порталом, контентом, мережею, шляхом DRM, головним екраном, пультом, процесом роботи в DMS і вимогами до пакування.",
    sbcFaqQ7: "Що дистрибуторам перевіряти інакше?",
    sbcFaqA7:
      "Дистрибутори мають перевірити не лише пристрій, а й сталість пакування, варіанти аксесуарів, регіональні типи вилок, гарантійний процес, локалізацію інтерфейсу, терміни та здатність постачальника підтримувати версії для операторів.",
    sbcCtaEyebrow: "Поговоріть із нами",
    sbcCtaTitle: "Перевірте приставку до розгортання",
    sbcCtaBody:
      "Розкажіть про модель послуги, мережу, вимоги до застосунків і цільову цінову категорію. Ми допоможемо обрати відповідну приставку inext, підготувати зразок із вашим оформленням і перевірити весь комплекс до серійного замовлення.",
    sbcCtaPrimary: "Поговорити з командою",
    sbcCtaSecondary: "Замовити зразок",
    osSeoTitle:
      "Власні приставки чи Smart TV абонентів: чому оператори постачають свою приставку | inext",
    osSeoDescription:
      "Постачати брендовані приставки чи покладатися на Smart TV абонентів? Чесна відповідь — і те, і те, але саме власна приставка є тією частиною, якою ви володієте й керуєте повністю. Аргументи оператора на користь приставки.",
    osBreadcrumbPage: "Власні приставки чи Smart TV",
    osHeroEyebrow: "Стратегічний гайд",
    osHeroTitle: "Власні приставки чи Smart TV абонентів:",
    osHeroTitleAccent: "чому варто мати і те, і те",
    osHeroSub:
      "Smart TV вже є майже в кожного абонента, тож виникає спокуса обійтися без заліза й просто випустити застосунок. Для серйозного оператора чесна відповідь — робити і те, і те: застосунки для Smart TV та мобільних — задля охоплення, а власну брендовану приставку — як керований центр усієї системи. Уся різниця у володінні: приставка — єдина платформа, якою ви керуєте повністю, у власному темпі, і ніхто сторонній не змінить вам правила гри.",
    osHeroNote:
      "Брендована приставка — і застосунок, що працює на ній, — це те, що створюємо ми, і та частина, яка належить тільки вам. Ця сторінка пояснює, чому вона вам потрібна.",
    osHeroCtaPrimary: "Поговорити з нашою командою",
    osHeroCtaSecondary: "Що ви контролюєте",
    osStat1: "Ваш бренд на приставці та пульті",
    osStat2: "100% контролю — у вашому темпі",
    osStat3: "Будь-який телевізор, будь-яка кімната",
    osThesisEyebrow: "Почніть звідси",
    osThesisTitle: "Тримайте центр у своїх руках, охоплюйте всі екрани",
    osThesisBody1:
      "Це не протистояння заліза й застосунків — це питання про те, чим ви володієте. Застосунки для Smart TV, мобільних і вебу виводять ваш сервіс на екрани, які в абонентів уже є. Вони важливі для охоплення, і їх варто випускати. Але на цих платформах ви — лише орендар: пристрій, головний екран, правила й дані належать Samsung, LG, Google чи Apple.",
    osThesisBody2:
      "Власна приставка — виняток. Це єдиний пристрій, який цілком ваш: ваш лаунчер після ввімкнення, ваш графік оновлень, ваш DRM, ваші дані, ваш білінг. Саме тут ви гарантуєте якість сервісу й закріплюєте зв'язок з абонентом. Виграшна схема поєднує керовану брендовану приставку в центрі — і застосунки всюди навколо задля охоплення.",
    osThesisCoreLabel: "Ваш центр",
    osThesisCoreValue: "Ваша брендована приставка",
    osThesisReachLabel: "Охоплення (тут ви — гість)",
    osThesisReachValue: "Smart TV · мобільні · вебзастосунки",
    osOwnRentEyebrow: "Власне чи орендоване",
    osOwnRentTitle: "На своїй приставці правила встановлюєте ви. На Smart TV — хтось інший.",
    osOwnColTitle: "На власній приставці ви контролюєте",
    osOwnItem1: "Головний екран — ваш лаунчер веде після ввімкнення",
    osOwnItem2: "Оновлення та нові функції — за вашим графіком",
    osOwnItem3: "DRM, безпеку та інтеграцію преміумзастосунків",
    osOwnItem4: "Простір для білінгу, реклами й допродажів — без комісії платформи",
    osOwnItem5: "Телеметрію пристроїв і дані про перегляди — вони ваші",
    osOwnItem6: "Як довго пристрій лишатиметься на підтримці",
    osRentColTitle: "На Smart TV абонента всім керує виробник",
    osRentItem1: "Головним екраном — ваш застосунок лише одна іконка серед багатьох",
    osRentItem2: "Перевіркою в магазині та оновленнями ОС — за своїм графіком",
    osRentItem3: "Тим, які рівні DRM і кодеки підтримує телевізор",
    osRentItem4: "Комісіями та умовами магазину — їх будь-коли можуть підняти",
    osRentItem5: "Даними платформи — вам дістаються лише крихти на рівні застосунку",
    osRentItem6: "Коли старі моделі втрачають підтримку, а ваш застосунок перестає працювати",
    osBenefitsEyebrow: "Аргументи на користь приставки",
    osBenefitsTitle: "Що дає вам власна приставка",
    osBenefit1Title: "Ваш бренд щодня",
    osBenefit1Body:
      "Ваш лаунчер — це перший екран на телевізорі, а ваш логотип — на приставці й на пульті, який абонент бере до рук щовечора. Така щоденна, відчутна на дотик присутність бренду формує прихильність, тримає вас на видноті й робить перехід до конкурента відчутно складнішим кроком.",
    osBenefit2Title: "Суверенітет над платформою",
    osBenefit2Body:
      "Ніхто сторонній не змінить вам правила гри. Samsung, LG чи Google можуть перемалювати свій головний екран, просунути конкурента, підняти комісії чи припинити підтримку старих телевізорів — і на їхніх платформах ви не зупините нічого з цього. На вашій приставці кожне таке рішення — за вами.",
    osBenefit3Title: "Дистанційне керування, менше звернень",
    osBenefit3Body:
      "З Alcatraz DMS і TR-069 ви дистанційно стежите за приставками, діагностуєте, налаштовуєте, оновлюєте й перезавантажуєте їх — менше виїздів майстра, швидші виправлення. Smart TV абонента — це «чорна скринька»: будь-яка проблема перетворюється на запитання «це ваш телевізор, ваша мережа чи наш застосунок?».",
    osBenefit4Title: "Якість сервісу, яку можна гарантувати",
    osBenefit4Body:
      "Ви фіксуєте чипсет, кодеки, 4K і Wi-Fi, тож сервіс працює однаково для всіх. На старому чи дешевому Smart TV ваш потік підвисає або взагалі не декодується — а винними роблять вас за залізо, яким ви не керуєте.",
    osBenefit5Title: "Випускайте новинки першими",
    osBenefit5Body:
      "Новий кодек, відкладений перегляд, хмарний відеозапис чи оновлений інтерфейс одразу доходить до всього вашого парку пристроїв. На Smart TV ви чекаєте на підтримку та повторну сертифікацію від кожної платформи, а старі телевізори не отримують цього взагалі.",
    osBenefit6Title: "Охопіть кожен телевізор і кожну кімнату",
    osBenefit6Body:
      "Приставка перетворює будь-який телевізор з HDMI — старі моделі, спальню, кухню, дачу — на вашу платформу. Підхід «лише Smart TV» тихцем відрізає ці екрани й тих абонентів, у кого Smart TV немає взагалі.",
    osBenefit7Title: "Зберігайте те, що продаєте",
    osBenefit7Body:
      "На власній приставці ви ведете свій білінг і маєте власний простір під рекламу й допродажі, без жодного магазину, що забирає свою частку, — і залишаєте собі дані про перегляди та пристрої, щоб ними діяти, а не віддаєте їх виробникові телевізорів.",
    osBenefit8Title: "Двері до B2B і гостинності",
    osBenefit8Body:
      "Готелям, багатоквартирним будинкам, лікарням і барам потрібні централізовано керовані, заблоковані пристрої без особистих акаунтів — те, чого підхід «лише застосунок» дати не може. Ваша приставка відчиняє ці ринки.",
    osBenefit9Title: "Цінність у вашій мережі",
    osBenefit9Body:
      "Керована приставка — це актив у вашій мережі, а не лише у вітальні: ефективна керована доставка з multicast тримає відео всередині мережі — це легше для смуги пропускання й транзиту, ніж OTT, який тягнуть через публічний інтернет, — а як керована кінцева точка вона дає вам видимість якості сервісу просто на краю мережі. Для ISP вона ще й прив'язує ТБ до інтернету й піднімає ARPU.",
    osScenarioTitle: "Звичайний вівторок на чужій платформі",
    osScenarioBody:
      "Уявіть собі: у вівторок виробник телевізорів перемальовує головний екран, ховає ваш застосунок за банером і починає по всьому вашому регіону просувати конкурентний сервіс. На Smart TV вдіяти із цим ви нічого не можете — це їхній головний екран, їхнє рішення, і жодне звернення в підтримку від оператора не змінить маркетинг виробника. На ваших власних приставках не міняється нічого: головний екран і далі ваш, бо й пристрій — ваш. Ось у чому різниця між орендованим місцем і власною платформою.",
    osHiddenEyebrow: "Чесний компроміс",
    osHiddenTitle: "«Лише Smart TV» обходиться дорожче, ніж здається",
    osHiddenBody:
      "Відмова від приставки заощаджує на залізі й логістиці одразу — і це справді так; для чистого OTT- чи D2C-проєкту це може бути правильним рішенням. Але «безкоштовні» Smart TV несуть витрати, які ви оплачуєте пізніше:",
    osHidden1:
      "Підтримка наосліп — ви не бачите пристрій і не можете його полагодити, тож будь-яка проблема перетворюється на здогадки",
    osHidden2:
      "Якість сервісу, за яку винними роблять вас, — старі, дешеві телевізори псують враження від вашого сервісу на залізі, яким ви не володієте",
    osHidden3:
      "Податок на фрагментацію — розробка й сертифікація застосунків під Tizen, webOS, Android TV, Fire TV, Apple TV та інші, у кожної з яких свої примхи й свій DRM",
    osHidden4:
      "Платформний ризик — комісії, політики, реклама й підтримка ОС змінюються на умовах виробника, а не ваших",
    osSameEyebrow: "Де наше місце",
    osSameTitle: "Ми створюємо приставку, якою володієте ви",
    osSameBody:
      "Ми не відмовлятимемо вас від застосунків для Smart TV й мобільних — випускайте їх, охоплення вам потрібне. А створюємо ми ту частину, яка належить тільки вам: вашу брендовану приставку. Ваш лаунчер рівня оператора після ввімкнення, ваш IPTV-застосунок, ваші сервіси з коробки, а весь парк пристроїв керується з кінця в кінець через Alcatraz DMS, OTA і TR-069. Застосунки розширюють вас на екрани, якими ви не керуєте; приставка ж — це база — цілком ваша, у вашому темпі.",
    osSameNoteTitle: "Це найдешевший контроль, який ви тільки купите",
    osSameNoteBody:
      "Приставка — це невелика стаття витрат поряд із відтоком, навантаженням на підтримку й платформним ризиком, які вона знімає. Ми допоможемо підібрати потрібну модель, забрендувати її аж до пульта й передати вам робочий зразок до рук за 1–2 тижні.",
    osFaqEyebrow: "FAQ",
    osFaqTitle: "Поширені запитання",
    osFaqQ1: "У більшості моїх абонентів уже є Smart TV — навіщо взагалі постачати приставку?",
    osFaqA1:
      "Тому що Smart TV — це їхнє й виробника, а не ваше. Приставка — це місце, де ви контролюєте сервіс, брендуєте його, керуєте ним і підтримуєте дистанційно, гарантуєте якість і залишаєте собі білінг та дані. Випускайте застосунки для Smart TV задля охоплення — але приставка є вашим якорем, і вона ж покриває другі телевізори та абонентів без Smart TV.",
    osFaqQ2: "Хіба постачати залізо не задорого?",
    osFaqA2:
      "Приставка коштує приблизно $30–50, і ця сума розкладається на весь час життя абонента — дрібниця поряд із тим, що вона заощаджує. Дистанційне керування зрізає витрати на підтримку й виїзди майстра, брендований пристрій зменшує відток, а ви зберігаєте дохід від білінгу, з якого жоден магазин не візьме комісії. Для більшості операторів вона себе окуповує; ми допоможемо це порахувати.",
    osFaqQ3: "Чи можна почати лише із застосунком, а приставки додати згодом?",
    osFaqA3:
      "Так — багато хто так і робить. Але оператори, які володіють зв'язком з абонентом, для своїх ключових абонентів починають із приставки, а застосунки використовують задля охоплення. Якщо ви стартуєте лише із застосунком, заплануйте приставку заздалегідь: саме вона перетворює застосунок із контентом на керований брендований сервіс.",
    osFaqQ4: "А як щодо готелів, багатоквартирних будинків та іншого B2B?",
    osFaqA4:
      "Це територія приставки. Розгортанням у готелях і MDU потрібні централізовано керовані, заблоковані пристрої без особистих акаунтів — рівно те, що дає керована приставка й чого не може застосунок на власному телевізорі гостя.",
    osFaqQ5: "Чи втрачаю я щось, постачаючи приставку?",
    osFaqA5:
      "Ви берете на себе вартість заліза й логістику — це реально, але виробництво, брендування й доставку по всьому світу беремо на себе ми, а робочий зразок під ваш бренд готуємо за 1–2 тижні. Натомість ви отримуєте контроль, присутність бренду, менше звернень у підтримку й більш лояльного абонента. Для оператора керованого сервісу цей обмін зазвичай вартий того.",
    osFaqQ6: "Чи прив'язує приставка мене до одного застосунку чи сервісу?",
    osFaqA6:
      "Ні — це ваша платформа. Ви обираєте лаунчер, застосунки, сервіси й ритм оновлень. У цьому й уся суть: на вашій приставці дорожня карта ваша, а не виробника телевізорів.",
    osCtaEyebrow: "Поговоріть із нами",
    osCtaTitle: "Володійте екраном, який ваші абоненти дивляться найчастіше",
    osCtaBody:
      "Розкажіть про свій сервіс і свій парк пристроїв. Ми специфікуємо брендовану приставку, налаштуємо її під ваш бренд і швидко передамо вам робочий зразок до рук.",
    osCtaPrimary: "Поговорити з нашою командою",
    osCtaSecondary: "Замовити зразок",
    bmSeoTitle:
      "Субсидувати, здавати в оренду чи продати приставку? CapEx чи OpEx для оператора | inext",
    bmSeoDescription:
      "Віддати приставку безкоштовно, здати в оренду чи продати одразу у власність? Це фінансове рішення, а не питання заліза. Розбираємо компроміси CapEx/OpEx і TCO між субсидуванням, орендою та продажем приставок — і блокування DMS, що робить субсидування й оренду безпечними.",
    bmBreadcrumbPage: "Субсидія, оренда чи продаж",
    bmHeroEyebrow: "Комерційний гайд",
    bmHeroTitle: "Субсидувати, здавати в оренду чи продати приставки —",
    bmHeroTitleAccent: "це фінансове рішення",
    bmHeroSub:
      "Одна й та сама керована приставка може дійти до абонента трьома шляхами: ви її даруєте, здаєте в оренду або продаєте. Змінюється не залізо, а те, хто за неї платить, кому вона належить і як ви повертаєте вкладене. Обрали не ту модель для сегмента — і ви або недозаробляєте, або берете на себе ризик, якого навіть не бачите. А більшість операторів узагалі не обирають щось одне: вони ведуть дві-три моделі водночас.",
    bmHeroNote:
      "Та сама приставка inext працює в усіх трьох сценаріях, а блокування Alcatraz DMS — саме те, що робить безпечним дарунок чи оренду приставки. Це покрокова стратегія оператора: як обирати ці моделі — і як їх поєднувати.",
    bmHeroCtaPrimary: "Поговорити з нашою командою",
    bmHeroCtaSecondary: "Чим допомагає блокування",
    bmStat1: "Одна приставка, три моделі",
    bmStat2: "CapEx чи OpEx — вирішуєте ви",
    bmStat3: "Блокування робить це безпечним",
    bmThesisEyebrow: "Почніть звідси",
    bmThesisTitle: "Це фінансове рішення, а не питання заліза",
    bmThesisBody1:
      "Приставка — часто найбільша стаття витрат на обладнання в бюджеті оператора, і вона зростає з кожним новим абонентом. Тож те, як приставка потрапляє в дім, — не дрібниця логістики: воно визначає ваш грошовий потік, те, що осідає у вас на балансі, і те, наскільки важко абоненту піти. Сама приставка в усіх трьох моделях однакова. Рішення тут суто фінансове.",
    bmThesisBody2:
      "І це рідко одне рішення. Той самий оператор може субсидувати приставки, щоб вигравати преміумабонентів і клієнтів triple-play, здавати їх в оренду основній базі, а для передплати, B2B чи других телевізорів — продавати одразу у власність, а згодом переводити абонентів між моделями. Справжнє питання не «яка модель», а «яка модель для якого абонента — і як убезпечити кожну з них».",
    bmThesisCoreLabel: "Один актив",
    bmThesisCoreValue: "Ваша керована приставка",
    bmThesisReachLabel: "Три комерційні моделі",
    bmThesisReachValue: "Субсидія · Оренда · Продаж",
    bmModelsEyebrow: "Три моделі",
    bmModelsTitle: "Три способи поставити приставку в дім",
    bmModelLabelUpfront: "Витрати наперед",
    bmModelLabelOwns: "Кому належить",
    bmModelLabelRevenue: "Як ви заробляєте",
    bmModelLabelBest: "Найкраще для",
    bmModel1Name: "Субсидувати",
    bmModel1Tagline: "Дайте приставку — здобудьте абонента.",
    bmModel1Upfront: "Ви платите наперед — CapEx у перший же день.",
    bmModel1Owns: "Зазвичай абоненту — після мінімального терміну.",
    bmModel1Revenue: "Повертається через підписку впродовж дії договору.",
    bmModel1Best: "Конкурентного залучення, преміуму та пакетів triple-play.",
    bmModel2Name: "Оренда",
    bmModel2Tagline: "Лишіть актив собі — беріть плату щомісяця.",
    bmModel2Upfront: "Ви платите за неї, але вона лишається вашим активом.",
    bmModel2Owns: "Вам — упродовж усього строку служби пристрою.",
    bmModel2Revenue: "Регулярна орендна плата; після повернення — забрати й перевидати.",
    bmModel2Best:
      "Регулярного доходу, низького бар'єру для абонента та обладнання для повторного використання.",
    bmModel3Name: "Продаж",
    bmModel3Tagline: "Гроші зараз — і нічого тримати на балансі.",
    bmModel3Upfront: "Платить абонент — одразу або в розстрочку.",
    bmModel3Owns: "Абоненту — від першого дня.",
    bmModel3Revenue: "Разовий дохід від заліза; жодного активу для амортизації.",
    bmModel3Best: "Передплати, других телевізорів, B2B та легшого балансу.",
    bmTableEyebrow: "Пліч-о-пліч",
    bmTableTitle: "Як порівнюються три моделі",
    bmTableColDimension: "",
    bmTableColSubsidize: "Субсидувати",
    bmTableColLease: "Оренда",
    bmTableColSell: "Продаж",
    bmRow1Label: "Витрати наперед",
    bmRow1Sub: "Оператор (CapEx)",
    bmRow1Lease: "Оператор (CapEx, лишається в нього)",
    bmRow1Sell: "Абонент",
    bmRow2Label: "На вашому балансі",
    bmRow2Sub: "Актив, далі списується",
    bmRow2Lease: "Актив, амортизується за строк служби",
    bmRow2Sell: "Нічого — вона продана",
    bmRow3Label: "Грошовий потік",
    bmRow3Sub: "Витрата зараз, повертається за термін",
    bmRow3Lease: "Витрата зараз, повертається регулярно",
    bmRow3Sell: "Надходження зараз",
    bmRow4Label: "Регулярний дохід",
    bmRow4Sub: "У складі підписки",
    bmRow4Lease: "Окрема орендна плата",
    bmRow4Sell: "На залізі — жодного",
    bmRow5Label: "Бар'єр для абонента",
    bmRow5Sub: "Найнижчий — це безкоштовно",
    bmRow5Lease: "Низький — невелика щомісячна сума",
    bmRow5Sell: "Найвищий — платить наперед",
    bmRow6Label: "Утримання абонента",
    bmRow6Sub: "Термін договору",
    bmRow6Lease: "Щоб піти — поверни приставку",
    bmRow6Sell: "Найслабше — вона його",
    bmRow7Label: "Якщо йде раніше",
    bmRow7Sub: "Неповернена субсидія",
    bmRow7Lease: "Забрати й перевидати",
    bmRow7Sell: "Уже сплачено — жодного ризику",
    bmTableSafeLabel: "Що це убезпечує",
    bmTableSafeValue:
      "Alcatraz DMS — net-lock · app-lock · дистанційне призупинення · повернення через OTA",
    bmTableNote: "Приставка в кожному стовпці однакова — рухаються лише гроші й право власності.",
    bmTcoEyebrow: "Цифри, приблизно",
    bmTcoTitle: "Та сама приставка — три форми грошового потоку",
    bmTcoBody:
      "Модель не змінює того, скільки коштує приставка, — вона змінює те, коли рухаються гроші. Візьмімо одну керовану приставку й простежмо за грошима:",
    bmTco1Title: "Субсидувати",
    bmTco1Body:
      "Ви витрачаєте вартість приставки в перший же день і повертаєте її через підписку. Окупність — це приблизно вартість приставки ÷ місячна маржа; утримайте абонента довше цієї точки — і решта стає прибутком. Втратите його раніше — і неповернена частина стане вашим збитком. Саме від цього й захищають мінімальний термін та дистанційне блокування.",
    bmTco2Title: "Оренда",
    bmTco2Body:
      "Ви так само платите за приставку, але щомісячна оренда перетворює її на ануїтет, який за строк служби пристрою може заробити більше, ніж сам коштував. Оскільки право власності лишається у вас, повернений пристрій очищають, переналаштовують і видають знову, — тож одна приставка встигає попрацювати в кількох абонентів, перш ніж піти на спокій.",
    bmTco3Title: "Продаж",
    bmTco3Body:
      "За залізо платить абонент, тож на вашому балансі нічого не осідає й оборотний капітал не заморожується. Ви віддаєте частину утримання абонента в обмін на гроші сьогодні та легшу операційну модель — нерідко це правильний вибір для передплати чи B2B.",
    bmTcoNote:
      "Це ілюстрація, а не комерційна пропозиція: ваша реальна відповідь залежить від вартості приставки, маржі, утримання й повторного використання. Ми допоможемо пропустити крізь цю логіку ваші власні цифри.",
    bmLockEyebrow: "Що робить це безпечним",
    bmLockTitle: "Контроль у програмі, а не на довірі",
    bmLockBody:
      "Ризик субсидування чи оренди простий: абонент перестає платити або приставка ніколи не повертається. Alcatraz DMS перетворює цей ризик на налаштування. Net-lock і app-lock прив'язують кожен пристрій до вашого сервісу — тож поза вашою мережею він не має жодної цінності для перепродажу й не перетворюється на звичайну Android-приставку. Саме це робить дарунок чи позичання заліза свідомим, безпечним рішенням, а не грою наосліп.",
    bmLock1Title: "Net-lock пристрою",
    bmLock1Body:
      "Субсидована чи орендована приставка прив'язана до вашого сервісу. Поза вашою мережею вона просто не активується — тож немає ні цінності для перепродажу, ні сенсу йти з нею.",
    bmLock2Title: "App-lock і режим кіоску",
    bmLock2Body:
      "Приставка працює з вашим лаунчером і вашими застосунками, а не з відкритим робочим столом Android. Субсидований пристрій не перепрофілювати, а ваш бренд лишається на екрані.",
    bmLock3Title: "Призупинення й відновлення дистанційно",
    bmLock3Body:
      "Пропустив платіж? Програмно заблокуйте приставку з панелі керування й поверніть її до життя тієї ж миті, коли абонент заплатить, — робота з неплатниками без жодного виїзду до абонента.",
    bmLock4Title: "Забрати й перевидати",
    bmLock4Body:
      "Повернений орендований пристрій очищають і переналаштовують «по повітрю», а тоді видають наступному абоненту, — це те саме повторне використання, на якому й тримається економіка оренди.",
    bmLockNote:
      "Ось чому модель — це програмний вибір. Один парк пристроїв можна водночас субсидувати, здавати в оренду й продавати, де кожен пристрій тримається своїх умов, а перевести його між моделями можна, навіть не торкаючись заліза.",
    bmMixEyebrow: "На практиці",
    bmMixTitle: "Більшість операторів ведуть не одну модель",
    bmMixBody:
      "Підбирайте модель під абонента, а не під компанію. Ось схема, яку ми знову і знову бачимо в наших клієнтів:",
    bmMix1:
      "Залучення та преміум → субсидувати. Заберіть бар'єр оплати наперед, щоб вигравати конкурентних абонентів і клієнтів triple-play; договір і блокування захищають цей дарунок.",
    bmMix2:
      "Основна база → оренда. Невелика щомісячна сума тримає бар'єр низьким, а актив — вашим, із поверненням і повторним використанням, коли абоненти йдуть.",
    bmMix3:
      "Передплата, другі телевізори та B2B → продаж. Беріть гроші наперед там, де утримання важить менше, а легкий баланс — більше.",
    bmMix4:
      "Згодом → конвертація. Та сама приставка дає змогу субсидувати заради залучення, а потім передати приставку абоненту у власність — без нового заліза, лише зі зміною умов.",
    bmFitEyebrow: "Де наше місце",
    bmFitTitle: "Один парк. Будь-яка модель. Зміна будь-коли.",
    bmFitBody:
      "Ми даємо керовану приставку й Alcatraz DMS і робимо безпечною будь-яку комерційну модель, яку ви оберете, — хоч кілька одразу. Net-lock, app-lock, дистанційне призупинення й повернення через OTA вбудовані з коробки, тож субсидування й оренда — не гра наосліп, а пропорції моделей ви можете міняти слідом за ринком, не перепрошиваючи й не докуповуючи приставки. Ми не нав'язуємо жодної моделі — просто робимо так, щоб усі три працювали на одній приставці.",
    bmFitNoteTitle: "Прорахуйте це разом із нами",
    bmFitNoteBody:
      "Розкажіть про свою маржу й утримання — вартість приставки за нами, а ми порівняємо субсидування, оренду та продаж на реальних цифрах і налаштуємо блокування, що захистить обрану вами модель.",
    bmFaqEyebrow: "FAQ",
    bmFaqTitle: "Поширені запитання",
    bmFaqQ1: "Яка модель найкраща?",
    bmFaqA1:
      "Універсального переможця немає — усе залежить від вашого ринку, грошової позиції й того, наскільки міцно вам потрібно утримувати абонента. Більшість операторів змішують моделі: субсидують заради залучення, здають базу в оренду й продають там, де утримання важить менше. Перевага керованої приставки якраз у тому, що обирати лише щось одне не доведеться.",
    bmFaqQ2: "Чи справді можна вести всі три моделі водночас?",
    bmFaqA2:
      "Так — багато наших клієнтів так і роблять. Оскільки модель закріплюється програмно через Alcatraz DMS, один парк пристроїв може тримати субсидовані, орендовані й продані пристрої пліч-о-пліч, кожен — на своїх умовах.",
    bmFaqQ3: "Що заважає перепродати чи перепрофілювати субсидовану або орендовану приставку?",
    bmFaqA3:
      "Net-lock і app-lock. Поза вашою мережею приставка не активується, тож не має жодної цінності для перепродажу; а працює вона тільки з вашим сервісом, тож не стане звичайною Android-приставкою. Саме це робить дарунок чи позичання заліза безпечним.",
    bmFaqQ4: "Що відбувається, коли абонент перестає платити?",
    bmFaqA4:
      "Ви програмно блокуєте пристрій дистанційно й відновлюєте його тієї ж миті, коли абонент платить, — без виїзду до абонента. В оренді приставка, яку так і не повернули, лишається заблокованою й нічого не вартою поза мережею; ту, що повернулася, очищають і видають знову.",
    bmFaqQ5: "Як оренда відображається на моєму балансі?",
    bmFaqA5:
      "За типового операційного лізингу ви тримаєте приставку як актив і амортизуєте її впродовж строку корисного використання, а орендну плату проводите як регулярний дохід — класичний перехід від CapEx до регулярної статті. Точний порядок обліку узгодьте зі своєю фінансовою командою; вхідні дані про строк служби й повторне використання надамо ми.",
    bmFaqQ6: "Чи можна згодом перевести абонента з однієї моделі на іншу?",
    bmFaqA6:
      "Так. Оскільки кожна модель працює на тій самій приставці, ви можете субсидувати заради залучення, а пізніше передати приставку абоненту у власність або перетворити оренду на продаж — усе програмно, без нового заліза.",
    bmCtaEyebrow: "Поговоріть із нами",
    bmCtaTitle: "Оберіть модель, яка вам пасує, — а ми зробимо її безпечною",
    bmCtaBody:
      "Розкажіть про свою маржу, відток і те, скільки братимете з абонента, — вартість приставки за нами, а ми допоможемо зважити субсидування, оренду та продаж на реальних цифрах і налаштуємо блокування Alcatraz DMS, що захистить обрану вами модель.",
    bmCtaPrimary: "Поговорити з нашою командою",
    bmCtaSecondary: "Замовити зразок",
    moSeoTitle: "Multicast IPTV проти OTT-стримінгу: архітектура доставки для операторів | inext",
    moSeoDescription:
      "Multicast IPTV чи OTT-юнікаст — як оператору доставляти лінійне ТБ? Один економний потік для всіх у керованій мережі чи окремий адаптивний потік для кожного глядача через інтернет. Чесні компроміси щодо пропускної здатності, якості, затримки та охоплення — і чому багато операторів використовують обидва підходи.",
    moBreadcrumbPage: "Multicast IPTV проти OTT",
    moHeroEyebrow: "Гайд з архітектури доставки",
    moHeroTitle: "Multicast IPTV проти OTT-стримінгу:",
    moHeroTitleAccent: "чому ви запустите обидва",
    moHeroSub:
      "Вивести лінійне ТБ на екран можна двома способами: надіслати один потік багатьом глядачам у власній керованій мережі (multicast IPTV) або надіслати окремий адаптивний потік кожному глядачеві через публічний інтернет (OTT-юнікаст). Нові впровадження дедалі частіше будують на OTT — він дістає будь-яку мережу й будь-який пристрій. Але численні керовані мережі, де мультикаст уже працює, тримають його не дарма: для прямого ефіру на масштабі ніщо не зрівняється з його ефективністю, майже нульовою затримкою та гарантованою якістю. Це не суперники — багато операторів поєднують обидва: мультикаст для прямого ефіру, юнікаст для решти.",
    moHeroNote:
      "Приставки inext і наш IPTV-застосунок працюють з обома: мультикаст у вашій керованій мережі, OTT — через інтернет, на одній і тій самій приставці. Ми підтримуємо обидва, бо обидва потрібні нашим клієнтам.",
    moHeroCtaPrimary: "Зв’язатися з нашою командою",
    moHeroCtaSecondary: "Подивитися, як приставка працює з обома",
    moStat1: "Один потік → багато глядачів (мультикаст)",
    moStat2: "Будь-яка мережа, будь-який пристрій (OTT)",
    moStat3: "Гібрид: одна приставка, обидва транспорти",
    moThesisEyebrow: "Почніть звідси",
    moThesisTitle: "Річ у мережі, а не лише в потоці",
    moThesisBody1:
      "Справжня різниця — не в абстрактній якості картинки, а в тому, де подорожує відео. Мультикаст пропускає вашою керованою мережею одну копію кожного лінійного каналу, і всі, хто його дивиться, ділять її між собою: 50 000 абонентів на одному каналі споживають стільки ж смуги, скільки й один. OTT натомість відкриває окремий юнікаст-потік для кожного глядача через публічний інтернет, підлаштовуючи бітрейт під кожне з’єднання. Перший підхід створений для ефективності й контролю у власній мережі; другий — для охоплення й гнучкості в мережах, які вам не належать.",
    moThesisBody2:
      "Будьмо чесними: для нових проєктів OTT сьогодні — вибір за замовчуванням: більшість нових впроваджень юнікастові, а чистий multicast IPTV здебільшого вважають спадщиною. Але «спадщина» не означає «погано»: там, де керована мережа вже несе мультикаст, він дає якість зображення, майже нульову затримку та мережеву ефективність, які юнікаст досі не здатен перевершити для прямого ефіру на масштабі, — тож зносити його рідко коли є сенс. Саме тому мультикаст лишається широко розгорнутим, зазвичай у гібриді: мультикаст для лінійних каналів, юнікаст для VOD, catch-up і зсуву в часі. Кожне завдання — на тому транспорті, який виконує його найкраще.",
    moThesisCoreLabel: "Керована мережа, один-до-багатьох",
    moThesisCoreValue: "Multicast IPTV",
    moThesisReachLabel: "Публічний інтернет, один-до-одного",
    moThesisReachValue: "OTT-юнікаст",
    moDefineEyebrow: "Як працює кожен",
    moDefineTitle: "Два транспорти для лінійного відео",
    moMcastColTitle: "Multicast IPTV",
    moMcastColSub: "Один потік, спільний для всіх глядачів, у вашій керованій мережі",
    moMcast1: "Мережею йде одна копія кожного каналу; глядачі приєднуються до неї через IGMP",
    moMcast2: "Смуга залишається сталою, скільки б людей не дивилося",
    moMcast3: "Сталий бітрейт і пріоритетний трафік — гарантована якість без буферизації",
    moMcast4:
      "Субсекундна затримка — ідеально для прямих спортивних трансляцій і національних подій",
    moMcast5:
      "Працює в керованій мережі з підтримкою мультикасту через дротовий Ethernet — Wi-Fi не передає його надійно",
    moMcast6: "Створений для лінійного ТБ; VOD і персоналізація все одно йдуть юнікастом",
    moOttColTitle: "OTT-юнікаст",
    moOttColSub: "Окремий адаптивний потік для кожного глядача, через публічний інтернет",
    moOtt1: "Кожен глядач отримує власний потік із CDN",
    moOtt2: "Адаптивний бітрейт (HLS/DASH) підлаштовується під швидкість кожного з’єднання",
    moOtt3:
      "Дістає будь-яку мережу й будь-який пристрій — смартфони, ноутбуки, Smart TV, поза мережею оператора",
    moOtt4: "Негарантована (best-effort) якість; затримка вища (low-latency HLS/DASH тепер ~2–5 с)",
    moOtt5: "Витрати на смугу й CDN зростають із кожним одночасним глядачем",
    moOtt6: "Несе VOD, catch-up, nPVR і персоналізацію за замовчуванням",
    moTableEyebrow: "Пліч-о-пліч",
    moTableTitle: "Як ці два підходи порівнюються",
    moTableColDimension: "",
    moTableColMcast: "Multicast IPTV",
    moTableColOtt: "OTT-юнікаст",
    moRow1Label: "Смуга на масштабі",
    moRow1Mcast: "Стала — один потік для всіх",
    moRow1Ott: "Лінійно зростає — один потік на глядача",
    moRow2Label: "Потрібна мережа",
    moRow2Mcast: "Лише ваша керована мережа",
    moRow2Ott: "Будь-яка мережа, публічний інтернет",
    moRow3Label: "Охоплення",
    moRow3Mcast: "Приставки в межах мережі оператора",
    moRow3Ott: "Будь-який пристрій, будь-де",
    moRow4Label: "Якість",
    moRow4Mcast: "Гарантована, сталий бітрейт",
    moRow4Ott: "Негарантована (best-effort), адаптивна",
    moRow5Label: "Затримка наживо",
    moRow5Mcast: "Менш ніж секунда",
    moRow5Ott: "~2–5 с у low-latency, до 10–30 с",
    moRow6Label: "Найкраще для",
    moRow6Mcast: "Лінійне ТБ, спорт, великі канали",
    moRow6Ott: "VOD, catch-up, мобільні, поза мережею оператора",
    moRow7Label: "VOD і персоналізація",
    moRow7Mcast: "Потребує юнікасту",
    moRow7Ott: "За замовчуванням",
    moRow8Label: "Структура витрат",
    moRow8Mcast: "Налаштування мережі; стала на масштабі",
    moRow8Ott: "CDN / вихідний трафік; зростає з глядачами",
    moRow9Label: "Контроль QoS",
    moRow9Mcast: "Повний — мережа ваша",
    moRow9Ott: "Обмежений — best-effort",
    moRow10Label: "З'єднання",
    moRow10Mcast: "Дротовий Ethernet — не Wi-Fi",
    moRow10Ott: "Будь-яке з'єднання, зокрема Wi-Fi",
    moTableInextLabel: "На приставках inext",
    moTableInextValue: "Один IPTV-застосунок відтворює обидва — мультикаст у мережі, OTT поза нею",
    moTableNote:
      "Більшість платформ ставлять лінійне ТБ на мультикаст там, де це дозволяє керована мережа, а все інше — на юнікаст.",
    moScaleEyebrow: "Розрив в ефективності",
    moScaleTitle: "Чому мультикаст досі виграє на великій прямій трансляції",
    moScaleBody:
      "Уявіть національний фінал на одному каналі: 50 000 абонентів дивляться одночасно. Через мультикаст це один потік у вашій мережі — навантаження таке саме, як від одного глядача. Через юнікаст це 50 000 окремих потоків, і ваш CDN та вихідний трафік зростають із кожним. Це і є головна причина, чому стільки мультикаст-мереж залишають у роботі: для масових одночасних переглядів наживо що більша аудиторія, то більша економія — і смуги, і витрат, і тієї майже нульової затримки, яку дає керована мережа.",
    moFitListEyebrow: "Коли що використовувати",
    moFitListTitle: "Постав кожне завдання на той транспорт, що робить його найкраще",
    moFit1:
      "Лінійне ТБ на масштабі у вашій керованій мережі → мультикаст. Спорт і великі канали отримують субсекундну затримку, гарантовану якість і сталу смугу.",
    moFit2:
      "VOD, catch-up, зсув у часі, nPVR і персоналізовані канали → юнікаст. Вони за природою індивідуальні для кожного глядача, тож OTT тут підходить найкраще.",
    moFit3:
      "Мобільні пристрої, поїздки, додаткові екрани й абоненти поза мережею оператора → OTT. Він дістає будь-яку мережу й будь-який пристрій без жодної мультикаст-інфраструктури.",
    moFit4:
      "Ринки, які вимагають гарантованої якості → мультикаст досі лідирує, і це обґрунтований, шанований вибір, а не пережиток минулого.",
    moBothEyebrow: "Де тут ми",
    moBothTitle: "Одна приставка, обидва транспорти",
    moBothBody:
      "Вам не доведеться обирати на рівні пристрою. Приставки inext і наш IPTV-застосунок працюють і з мультикастом (UDP/RTP з IGMP) у вашій керованій мережі, і з OTT (HLS/DASH, M3U та портали Stalker/Ministra/Xtream) через юнікаст — на одній приставці, в одній оселі. Абонент може дивитися прямий канал через мультикаст, а за мить відкрити VOD, що йде через юнікаст, — єдиний безперебійний сервіс, де кожен потік іде тим транспортом, що йому пасує. А оскільки мультикаст потребує дротового з'єднання, кожна приставка inext має порт Ethernet. Чистий юнікаст, класична мультикаст-мережа чи гібрид із двох — та сама приставка підходить для всіх трьох. Ми робимо для обох, бо обидва потрібні нашим клієнтам, — і не казатимемо вам, що обраний вами підхід хибний.",
    moBothNoteTitle: "Уже маєте один? Додайте другий.",
    moBothNoteBody:
      "Працюєте на чистому мультикасті й потрібне OTT-охоплення для мобільних і абонентів поза мережею? Чи на чистому OTT і хочете мультикаст-ефективності для великих прямих трансляцій? Приставка й застосунок підтримують обидва, тож розширюватися можна без зміни платформи. Допоможемо все спланувати.",
    moFaqEyebrow: "FAQ",
    moFaqTitle: "Поширені запитання",
    moFaqQ1: "Чи робить OTT мультикаст застарілим?",
    moFaqA1:
      "Для нових проєктів — здебільшого так: більшість нових впроваджень тепер ідуть у юнікаст/OTT, а чистий multicast IPTV широко вважають спадщиною. Але це не вся картина: там, де керована мережа вже несе мультикаст, від його ефективності, майже нульової затримки та гарантованої якості для прямого ефіру важко відмовитися, тож такі мережі лишаються в роботі й досі широко використовуються. Це радше не «заміна», а «вже не стандарт за замовчуванням для нових проєктів» — і зазвичай працює в гібриді, з юнікастом для VOD і catch-up.",
    moFaqQ2: "У якого з них краща якість картинки?",
    moFaqA2:
      "У керованій мережі мультикаст дає сталий бітрейт із пріоритетним трафіком, тож якість стабільна й без буферизації. Якість OTT адаптивна й негарантована (best-effort) — чудова на хорошому з’єднанні, мінлива на поганому. Якщо потрібна якість, яку ви контролюєте від початку до кінця, лідирує мультикаст; якщо потрібне охоплення непередбачуваних мереж — у тому й уся суть адаптивності OTT.",
    moFaqQ3: "Чи потрібна для мультикасту спеціальна мережа?",
    moFaqA3:
      "Так. Мультикаст потребує керованої мережі, де кожен комутатор на шляху підтримує мультикаст (IGMP), а також дротового Ethernet на приставці — Wi-Fi не передає мультикаст надійно. Тому це технологія для телекомів та інтернет-провайдерів у межах їхньої мережі, і саме тому кожна приставка inext має порт Ethernet. OTT нічого з цього не потребує — він працює через публічний інтернет і будь-яке з'єднання, зокрема Wi-Fi, і саме тому дістає будь-куди.",
    moFaqQ4: "Чи може одна приставка підтримувати обидва транспорти?",
    moFaqA4:
      "Так — у цьому й суть нашої. Приставки inext та IPTV-застосунок відтворюють прямий мультикаст у вашій мережі й OTT-потоки через інтернет, перемикаючись непомітно. Абонент бачить єдиний сервіс; ви вирішуєте, який транспорт що несе.",
    moFaqQ5: "А як щодо затримки для прямих спортивних трансляцій?",
    moFaqA5:
      "Мультикаст зазвичай дає субсекундну затримку — а це важливо, коли сусіди вже радіють голу, перш ніж його побачите ви. Стандартний OTT відстає на 10–30 секунд; low-latency HLS/DASH скоротив цей розрив приблизно до 2–5 секунд — нормально для більшості контенту, та все ще позаду мультикасту на великій прямій трансляції.",
    moFaqQ6: "Що таке multicast ABR?",
    moFaqA6:
      "Multicast ABR (mABR) несе потоки з адаптивним бітрейтом у форматі OTT поверх мультикасту, поєднуючи зручний для пристроїв формат OTT з ефективністю «один-до-багатьох» мультикасту. Він здатен зрізати пікові навантаження прямого трафіку до 90% і дає операторам масштабувати масові одночасні перегляди наживо без окремого юнікаст-потоку на кожного глядача. Наша платформа його підтримує.",
    moCtaEyebrow: "Поговорімо",
    moCtaTitle: "Доставляйте лінійне ТБ так, як побудована ваша мережа",
    moCtaBody:
      "Розкажіть нам про свою мережу, канали та аудиторію. Ми допоможемо розмістити мультикаст і OTT там, де кожен працює найкраще, — і постачимо приставки, що працюють з обома з коробки.",
    moCtaPrimary: "Зв’язатися з нашою командою",
    moCtaSecondary: "Замовити зразок",
    bbSeoTitle:
      "Розробляти самому чи купувати: чи варто провайдеру створювати власну приставку? | inext",
    bbSeoDescription:
      "Створити власну платформу приставки чи купити готовий стек? «Розробити» приставку означає зібрати вісім рівнів — кремній, обладнання, прошивку, застосунки, DRM, керування пристроями, виробництво й підтримку. Чесний розбір «робити чи купувати» для операторів.",
    bbBreadcrumbPage: "Розробляти чи купувати",
    bbHeroEyebrow: "Гід «робити чи купувати»",
    bbHeroTitle: "Створити власну приставку чи купити готовий стек?",
    bbHeroTitleAccent: "чесний розбір «робити чи купувати»",
    bbHeroSub:
      "«Зробити власну приставку» звучить як інженерна задача — але жоден оператор не виготовляє власні чипи, і майже ніхто не проєктує плату. На практиці «розробити» означає зібрати стек із восьми рівнів — від кремнію до служби підтримки — і володіти кожним із них. Декому це справді потрібно. Але більшість тих, хто каже, що створив приставку, насправді її зібрали. Цей гід показує, чого «розробка» вимагає насправді, щоб ви зрозуміли, на якому боці стоїте ви.",
    bbHeroNote:
      "Ми на боці «купити й партнеритися» — тож не вдаватимемо, ніби розробка не має сенсу ніколи. Для декого має. Це чесна версія цього вибору.",
    bbHeroCtaPrimary: "Поговорити з нашою командою",
    bbHeroCtaSecondary: "Переглянути 8 рівнів",
    bbStat1: "8 рівнів, якими треба володіти",
    bbStat2: "Розробка: програма на кілька років",
    bbStat3: "Купівля: брендований зразок за 1–2 тижні",
    bbThesisEyebrow: "Почніть звідси",
    bbThesisTitle: "«Розробити» рідко означає те, що здається",
    bbThesisBody1:
      "Ніхто не виготовляє власні чипи, і реалістично жоден оператор не проєктує власну плату — для цього є виробники кремнію та обладнання. Тож «створити власну приставку» — це не апаратний, а інтеграційний проєкт. Ви збираєте обладнання, яке замовляєте, ПЗ, яке пишете або ліцензуєте, і налагоджуєте процес, щоб усе це виробляти, оновлювати й підтримувати, — а тоді повністю відповідаєте за результат.",
    bbThesisBody2:
      "Це справжній і цілком робочий шлях — але масштабніший, ніж здається. За робочою приставкою, якою реально користуватиметься абонент, стоять вісім окремих компетенцій, і прогалина в будь-якій із них згодом виринає як застопорений запуск або збій в експлуатації. Перш ніж вирішувати розробляти, варто побачити весь стек, який ви берете на себе.",
    bbThesisCoreLabel: "Що таке «розробка» насправді",
    bbThesisCoreValue: "Зібрати стек і володіти ним",
    bbThesisReachLabel: "Що ви купуєте в будь-якому разі",
    bbThesisReachValue: "Кремній · обладнання ODM · ліцензії DRM",
    bbLayersEyebrow: "Стек",
    bbLayersTitle: "Вісім рівнів за робочою приставкою",
    bbLayersIntro:
      "Приставка виглядає як один продукт; насправді це вісім компетенцій, складених разом. Ось кожен рівень — і що означає ним володіти.",
    bbLayer1Name: "Кремній (SoC)",
    bbLayer1Body:
      "Чип — Amlogic, Allwinner, Realtek. Ви його обираєте, але ніколи не виготовляєте, і саме він задає стелю для 4K, кодеків, рівня DRM та secure boot.",
    bbLayer2Name: "Обладнання та промисловий дизайн",
    bbLayer2Body:
      "Плата, роз'єми, корпус, блок живлення, пульт. Проєктує й виробляє ODM — за референсним дизайном або вашою специфікацією — це не робиться власними силами.",
    bbLayer3Name: "Прошивка та BSP",
    bbLayer3Body:
      "Android AOSP або Linux, ядро, драйвери, secure boot. Вендор дає базу; довести її до продакшену під силу лише інженерам вбудованих систем.",
    bbLayer4Name: "Лаунчер і middleware",
    bbLayer4Body:
      "Брендований головний екран, EPG, налаштування та меню застосунків — та частина, яку абоненти сприймають як «вашу».",
    bbLayer5Name: "Застосунки",
    bbLayer5Body:
      "Ваш застосунок IPTV/VOD плюс OTT. Зауважте: Netflix, Disney+ та решту не «розробляють» — кожен потребує окремої сертифікації та прямої угоди з оператором.",
    bbLayer6Name: "DRM і захист контенту",
    bbLayer6Body:
      "Widevine і Verimatrix, ліцензовані та провізіоновані. Ключі Widevine L1 треба прошити на заводі, на чипі із secure enclave — додати L1 пізніше не вийде.",
    bbLayer7Name: "Керування пристроями та OTA",
    bbLayer7Body:
      "Провізіонування, поетапні оновлення прошивки з можливістю відкату, віддалена діагностика, TR-069. Повноцінний бекенд сам по собі.",
    bbLayer8Name: "Виробництво, логістика та підтримка",
    bbLayer8Body:
      "Виробництво, доставка по всьому світу, сертифікація, контроль якості, RMA та служба підтримки — непоказна, але більша частина всієї роботи.",
    bbSpectrumEyebrow: "Як оператори розробляють насправді",
    bbSpectrumTitle: "Чотири способи «розробити» — від найбільшого до найменшого",
    bbApproach1Name: "Повністю власними силами",
    bbApproach1Body:
      "Власні команди вбудованих систем, застосунків і бекенду; ODM, що будує за вашою специфікацією; власні угоди на DRM і власний бекенд керування пристроями; сертифікацію берете на себе теж. Реалістично на масштабі Tier-1 — багаторічна програма з кількома командами.",
    bbApproach2Name: "Референсний дизайн + ваше ПЗ",
    bbApproach2Body:
      "Старт із референсної плати SoC або приставки ODM; ваша команда збирає прошивку, лаунчер, застосунок та інтеграцію з DMS. Потрібна команда вбудованих систем, зате без розробки власного заліза.",
    bbApproach3Name: "Роздрібні пристрої + ваш застосунок",
    bbApproach3Body:
      "Обійтися взагалі без заліза — опублікувати застосунок на Chromecast/Google TV, Fire TV чи роздрібних приставках на Android. Ви «розробляєте» лише застосунок, але втрачаєте власну приставку: ні брендингу, ні керування парком, а головний екран і оновлення контролює вендор.",
    bbApproach4Name: "Обладнання ODM + стек від вендора",
    bbApproach4Body:
      "Замовляєте обладнання в ODM і ліцензуєте прошивку, лаунчер, застосунок та DMS у спеціаліста. Ви брендуєте й налаштовуєте; складні рівні вже готові. Це і є шлях «купити й партнеритися».",
    bbCostEyebrow: "Чесна ціна",
    bbCostTitle: "Розробка — це програма, а не покупка",
    bbCostBody:
      "Справжня розробка з нуля означає підняти кілька напрямів, яких у вас може й не бути, — вбудовану прошивку, розробку застосунків, провізіонування DRM, бекенд керування пристроями та OTA, виробництво й логістику, сертифікацію та підтримку — а тоді тримати їх укомплектованими весь час, поки живе продукт. Витрати на старті реальні, але поточні — більші: кожне оновлення ОС, патч безпеки й новий застосунок відтепер тягнете ви. Плануйте програму, що вимірюється кварталами, і команду, що вимірюється штатом, а не разову покупку.",
    bbWhenEyebrow: "Коли варто розробляти",
    bbWhenTitle: "Розробка справді виграє, коли…",
    bbWhen1:
      "У вас є масштаб. База абонентів, достатня, щоб розподілити на неї витрати на інженерну команду, повністю змінює розрахунок.",
    bbWhen2:
      "У вас є унікальна вимога. Функція чи інтеграція, якої не пропонує жоден вендор і яка лежить в основі того, чим ви вирізняєтеся.",
    bbWhen3:
      "У вас уже є команда. Власні інженери вбудованих систем і застосунків, яких ви готові фінансувати на довгу перспективу.",
    bbWhen4:
      "Контроль — це стратегія. Коли володіти кожним рівнем, а не просто брендувати його, — рішення рівня ради директорів, а не рядок у кошторисі.",
    bbWhenNote:
      "Якщо про вас — два або більше з цих пунктів, розробку варто розглянути серйозно. Якщо жоден, розрахунок зазвичай на боці того, щоб замовити складні рівні готовими.",
    bbTableEyebrow: "Пліч-о-пліч",
    bbTableTitle: "Розробляти чи купувати — вимір за виміром",
    bbTableColDimension: "",
    bbTableColBuild: "Розробити самому",
    bbTableColBuy: "Купити й партнеритися",
    bbRow1Label: "Час виходу на ринок",
    bbRow1Build: "Квартали й роки",
    bbRow1Buy: "Тижні до першого зразка",
    bbRow2Label: "Витрати на старті",
    bbRow2Build: "Високі — команди та інструментарій",
    bbRow2Buy: "За пристрій плюс налаштування",
    bbRow3Label: "Потрібна команда",
    bbRow3Build: "Вбудовані системи, застосунки, бекенд, QA",
    bbRow3Buy: "Продукт і операції",
    bbRow4Label: "Підтримка прошивки та ОС",
    bbRow4Build: "Ваша, назавжди",
    bbRow4Buy: "Обслуговують за вас",
    bbRow5Label: "DRM (Widevine L1)",
    bbRow5Build: "Домовляєтеся й провізіонуєте самі",
    bbRow5Buy: "Провізіоновано на заводі",
    bbRow6Label: "Керування пристроями та OTA",
    bbRow6Build: "Будуєте бекенд",
    bbRow6Buy: "Уже входить (DMS + OTA)",
    bbRow7Label: "Сертифікація",
    bbRow7Build: "GMS / Netflix на вас",
    bbRow7Buy: "Беруть на себе або з партнером",
    bbRow8Label: "Виробництво та логістика",
    bbRow8Build: "Ваш ODM і фрахт",
    bbRow8Buy: "Входить, по всьому світу",
    bbRow9Label: "Контроль",
    bbRow9Build: "Повний — кожен рівень",
    bbRow9Buy: "Ваш — щоб брендувати й налаштовувати",
    bbRow10Label: "Де лежить ризик",
    bbRow10Build: "На вас, від початку до кінця",
    bbRow10Buy: "Розділений із вендором",
    bbTableInextLabel: "Де тут inext",
    bbTableInextValue:
      "Колонка «купити й партнеритися» — брендуєте й налаштовуєте, робочий зразок за 1–2 тижні",
    bbTableNote:
      "Жодна колонка не є «правильною» — усе залежить від вашого масштабу, команди й того, якою часткою стека ви хочете володіти.",
    bbFitEyebrow: "Де тут ми",
    bbFitTitle: "Ми згортаємо розробку до «брендувати й налаштувати»",
    bbFitBody:
      "Ми в колонці «купити й партнеритися» й не приховуємо цього — але наше завдання зняти вісім рівнів із ваших плечей, а не відмовити вас від розробки, якщо вона вам справді потрібна. Ви отримуєте обладнання ODM, збірку на Android AOSP або Linux, ваш операторський лаунчер, застосунок IPTV, Widevine L1 і Verimatrix, провізіоновані на заводі, Alcatraz DMS із поетапними OTA та виробництво й доставку по всьому світу. Постачання white-label — ваш бренд на прошивці й, за бажанням, ваш логотип на обладнанні та пульті. Те, що було б програмою на кілька кварталів, зводиться до трьох кроків: обрати модель, забрендувати її й отримати робочий зразок за один-два тижні.",
    bbFitNoteTitle: "Не певні, на якому ви боці?",
    bbFitNoteBody:
      "Розкажіть про свій масштаб, чи маєте власну команду вбудованих систем і як швидко треба запуститися. Ми дамо прямий висновок «розробляти чи купувати» саме для вашої ситуації — без продажної риторики.",
    bbFaqEyebrow: "Поширені запитання",
    bbFaqTitle: "Часті запитання",
    bbFaqQ1: "Щоб «розробити», я мушу проєктувати власне обладнання?",
    bbFaqA1:
      "Ні — і не варто. Кремній постачають виробники чипів, а плати — ODM; навіть повна розробка власними силами стартує з референсного дизайну. «Розробка» — це про володіння ПЗ, інтеграцією й процесом, а не про травлення друкованої плати.",
    bbFaqQ2: "Хіба не можна просто поставити застосунок на роздрібні приставки Android?",
    bbFaqA2:
      "Можна, і для суто застосункового підходу це слушний початок. Але роздрібна приставка не ваша: навіть із Widevine L1 на борту ви не маєте ні брендингу, ні керування парком, ні net-lock, а головний екран і оновлення контролює вендор. Це застосунковий край спектра — добре для охоплення, слабко для керованого брендованого сервісу. (Це той самий компроміс «власна приставка проти Smart TV», тільки в іншій формі.)",
    bbFaqQ3: "Який рівень найважче розробити?",
    bbFaqA3:
      "Прошивка, без питань. Запустити плату — це проста частина; зробити її стабільною, швидкою та захищеною — складна, і вона фактично ніколи не закінчується. Кожен SoC і кожна плата потребують власної тонко налаштованої прошивки: драйвери, відеотракт, інтеграція DRM, керування живленням, secure boot. Це не разове портування — у нас пішли роки ітерацій, щоб довести кожну прошивку під свою плату. Саме цей рівень команди недооцінюють найчастіше — і саме на нього спеціаліст уже витратив ці роки.",
    bbFaqQ4: "Скільки триває справжня розробка?",
    bbFaqA4:
      "Для чесної розробки з нуля рахуйте у кварталах, а не тижнях: доведення прошивки, провізіонування DRM, керування пристроями, сертифікація й виробництво — кожне забирає час і частково йде одне за одним. Замовлення складних рівнів готовими стискає це до часу, потрібного, щоб забрендувати й налаштувати перевірену платформу.",
    bbFaqQ5: "Коли розробка справді має сенс?",
    bbFaqA5:
      "Коли у вас є масштаб, щоб амортизувати інженерну команду, унікальна вимога, яку не покриває жоден вендор, власна команда, у яку ви вкладаєтеся, або стратегічна причина володіти кожним рівнем. Якщо про вас — два або більше пунктів, розробку варто розглянути серйозно; якщо жоден, зазвичай виграє замовлення готового.",
    bbFaqQ6: "На якому боці inext — розробки чи купівлі?",
    bbFaqA6:
      "Ми на боці «купити й партнеритися», і кажемо це прямо. Ми постачаємо обладнання ODM, прошивку на AOSP або Linux, ваш брендований лаунчер і застосунок IPTV, DRM, провізіоноване на заводі, Alcatraz DMS та OTA, а також виробництво по всьому світу — white-label, тож усе виходить як ваш продукт. Ми ж чесно скажемо, якщо ваша ситуація насправді на боці розробки.",
    bbCtaEyebrow: "Поговоріть з нами",
    bbCtaTitle: "Отримайте прямий висновок «розробляти чи купувати»",
    bbCtaBody:
      "Розкажіть про свій масштаб, чи маєте власну команду вбудованих систем, і про свої терміни. Ми дамо чесний висновок для вашої ситуації — а якщо купівля пасує, то й брендований робочий зразок за тиждень-два.",
    bbCtaPrimary: "Поговорити з нашою командою",
    bbCtaSecondary: "Замовити зразок",
    guidesCardRsgTitle: "Скільки оперативної та вбудованої пам’яті потрібно приставці?",
    guidesCardRsgDesc:
      "Практичний порадник: як вибрати 1, 2 або 4 ГБ оперативної та 8, 16 або 32 ГБ вбудованої пам’яті для різних сценаріїв і чому прошивка та результати тестування важливіші за самі цифри.",
    footerLinkGuidesRamStorage: "Оперативна й вбудована пам’ять STB",
    rsgSeoTitle: "Скільки RAM і вбудованої пам’яті потрібно приставці? | inext",
    rsgSeoDescription:
      "Порівняйте 1, 2 і 4 ГБ RAM та 8, 16 і 32 ГБ вбудованої пам’яті для приставок. Дізнайтеся, як на вибір впливають сценарій використання, прошивка, застосунки та ігри.",
    rsgBreadcrumbPage: "Пам’ять приставки",
    rsgHeroEyebrow: "Порадник із вибору конфігурації приставки",
    rsgPublishedLabel: "Опубліковано",
    rsgUpdatedLabel: "Оновлено",
    rsgHeroTitle: "Скільки оперативної та вбудованої пам’яті",
    rsgHeroTitleAccent: "насправді потрібно приставці?",
    rsgHeroSub:
      "Єдиного мінімуму для сучасної приставки не існує. Для сервісу з чітко визначеним набором функцій може цілком вистачити ретельно оптимізованого пристрою з 1 ГБ. Ширший набір застосунків, ігри на самій приставці та довший строк служби потребують більшого запасу пам’яті.",
    rsgHeroNote:
      "Вибирайте конфігурацію з урахуванням усіх складників: прошивки, оболонки, застосунків, оновлень та ігор. Найбільші цифри в характеристиках не завжди означають найкращий результат.",
    rsgHeroCtaPrimary: "Порівняти конфігурації",
    rsgHeroCtaSecondary: "Порівняти моделі inext",
    rsgStat1: "Для базового сценарію",
    rsgStat2: "Універсальний варіант",
    rsgStat3: "Максимальний запас",
    rsgThesisEyebrow: "Коротка відповідь",
    rsgThesisTitle: "Обсяг пам’яті не дорівнює швидкодії",
    rsgThesisBody1:
      "RAM потрібна операційній системі та застосункам під час роботи. У вбудованій пам’яті зберігаються прошивка, застосунки, оновлення й локальні дані. Самі цифри не свідчать про якість ПЗ, швидкість накопичувача, можливості GPU, ефективність охолодження чи кількість зайвих фонових процесів.",
    rsgThesisBody2:
      "Саме тому добре спроєктована приставка з 1 ГБ швидко працює у чітко визначеному сценарії, тоді як погано налаштований пристрій із більшою RAM може повільно запускатися, вивантажувати застосунки з пам’яті або втрачати стабільність. Більше пам’яті дає гнучкість і запас, але не виправляє недоліків ПЗ.",
    rsgThesisNoteTitle: "Коли 1 ГБ справді достатньо",
    rsgThesisNoteBody:
      "Одного гігабайта достатньо лише тоді, коли сценарій використання відомий, прошивку створено саме для цього обладнання, а весь сервіс перевірено в умовах, наближених до реальних. Це не універсальна рекомендація для будь-якої приставки Android.",
    rsgGoogleNote:
      "Офіційні вимоги Android до сумісності не зводяться до універсального «мінімуму 2 ГБ»: вони залежать від версії Android, архітектури, конфігурації дисплея та обсягу пам’яті, який резервує обладнання.",
    rsgGoogleLink: "Переглянути вимоги Android до сумісності",
    rsgWorkloadsEyebrow: "Почніть зі сценарію",
    rsgWorkloadsTitle: "Обсяг пам’яті залежить від сценарію використання",
    rsgWorkloadsIntro:
      "Операторський сервіс із фіксованим набором функцій, готельна приставка, відкрита платформа з багатьма застосунками та пристрій для ігор потребують різного обсягу пам’яті. Спочатку визначте, що має працювати зараз і які функції можуть з’явитися згодом.",
    rsgWorkload1Title: "Операторський ТВ-сервіс",
    rsgWorkload1Body:
      "Одна керована оператором оболонка та один основний ТВ-застосунок, спеціально підготовлена прошивка й мінімум фонових служб.",
    rsgWorkload1Signal: "Вирішальне значення має оптимізація, а не кількість застосунків",
    rsgWorkload2Title: "Кілька IPTV- й OTT-застосунків",
    rsgWorkload2Body:
      "Кілька застосунків для телебачення, відеосервісів і допоміжних функцій, між якими глядачі перемикаються протягом одного сеансу.",
    rsgWorkload2Signal: "Потрібен запас для швидкого перемикання й кешу",
    rsgWorkload3Title: "Готелі та житлові комплекси",
    rsgWorkload3Body:
      "Брендований інтерфейс для гостей, відомості про об’єкт, трансляція контенту з телефона та інтеграція з іншими сервісами на великій кількості пристроїв.",
    rsgWorkload3Signal: "Головне — стабільність і віддалене відновлення",
    rsgWorkload4Title: "Прості ігри",
    rsgWorkload4Body:
      "Невимогливі ігри для Android і прості інтерактивні функції разом зі звичайними медіазастосунками.",
    rsgWorkload4Signal: "RAM допомагає, але не менш важливі GPU та контролер",
    rsgWorkload5Title: "Хмарні ігри",
    rsgWorkload5Body:
      "Гра запускається на віддаленому сервері, а приставка декодує відеопотік із малою затримкою та передає команди контролера.",
    rsgWorkload5Signal: "Затримка мережі може бути важливішою за додатковий обсяг RAM",
    rsgWorkload6Title: "Розвинені спеціалізовані рішення",
    rsgWorkload6Body:
      "Кілька брендованих застосунків, фонові служби, аналітика, інтеграції та набір функцій, який розширюватиметься з часом.",
    rsgWorkload6Signal: "Залиште запас на майбутні функції",
    rsgRamEyebrow: "Що займає RAM",
    rsgRamTitle: "RAM використовують чотири складники системи",
    rsgRamIntro:
      "Питання не лише в кількості гігабайтів, а в тому, скільки RAM залишається під час роботи готового сервісу. Перевіряйте фінальний системний образ, а не чисту версію для розробки.",
    rsgRamFactor1Title: "Операційна система та служби",
    rsgRamFactor1Body:
      "Android або Linux, оболонка, мережеві служби, DRM, засоби керування пристроями та служби виробника резервують пам’ять ще до запуску основного застосунку.",
    rsgRamFactor2Title: "Застосунки та фонова робота",
    rsgRamFactor2Body:
      "Дані EPG, мініатюри, аналітика, кеш і фонові процеси визначають, чи залишатимуться застосунки готовими до роботи, чи щоразу запускатимуться заново.",
    rsgRamFactor3Title: "Відтворення відео",
    rsgRamFactor3Body:
      "Сучасні приставки декодують відео апаратно. Плавне відтворення 4K значною мірою залежить від SoC, відеотракту й драйверів, а не лише від обсягу RAM.",
    rsgRamFactor4Title: "Ігри та багатозадачність",
    rsgRamFactor4Body:
      "Ігри, що запускаються на приставці, складніша графіка й часте перемикання між застосунками потребують більше робочої пам’яті. Саме тут додатковий запас дає найпомітніший результат.",
    rsgConfigEyebrow: "Практичне порівняння",
    rsgConfigTitle: "1/8, 2/16 чи 4/32 ГБ?",
    rsgConfigIntro:
      "Це орієнтири для різних сценаріїв, а не безумовний рейтинг швидкодії. Остаточне рішення ухвалюйте після тестування зразка з цільовою прошивкою, потрібними застосунками, відеопотоками та периферією.",
    rsgConfigCommon: "Найуніверсальніша",
    rsgConfigFitsLabel: "Добре підходить для",
    rsgConfigWatchLabel: "На що зважати",
    rsgConfigModelsLabel: "Відповідні моделі inext",
    rsgConfig1Label: "Для чітко визначеного сценарію",
    rsgConfig1Summary:
      "Економна конфігурація для випадків, коли inext або оператор контролює прошивку й свідомо обмежує набір функцій.",
    rsgConfig1Fit1: "Один основний телевізійний або медіазастосунок",
    rsgConfig1Fit2: "Легка оболонка й мінімум фонових служб",
    rsgConfig1Fit3: "Великі парки, де важлива ціна кожної приставки",
    rsgConfig1Watch:
      "Не варто автоматично обирати цю конфігурацію для каталогу застосунків, що зростає, вимогливих ігор на самій приставці або ПЗ, яке не тестували на цільовій прошивці.",
    rsgConfig2Label: "Універсальна конфігурація",
    rsgConfig2Summary:
      "Збалансований варіант для проєктів із кількома застосунками, розвиненішим інтерфейсом і запасом для майбутніх змін ПЗ.",
    rsgConfig2Fit1: "Сервіси IPTV та OTT з кількома застосунками",
    rsgConfig2Fit2: "Готелі, брендовані портали та прості ігри",
    rsgConfig2Fit3: "Проєкти, де майбутній набір функцій ще може змінюватися",
    rsgConfig2Watch:
      "У будь-якому разі перевіряйте, як зростає обсяг даних, наскільки швидко перемикаються застосунки та чи стабільно приставка працює тривалий час. Наявність 2 ГБ не скасовує потреби в якісній прошивці.",
    rsgConfig3Label: "Максимальний запас",
    rsgConfig3Summary:
      "Найгнучкіший варіант для великого набору застосунків, вимогливих завдань на самій приставці та проєктів, де можливість розвитку важливіша за найнижчу ціну обладнання.",
    rsgConfig3Fit1: "Великі каталоги застосунків і розвинені інтерфейси",
    rsgConfig3Fit2: "Вимогливіші ігри на приставці та інтерактивні застосунки",
    rsgConfig3Fit3: "Довгострокові проєкти з вимогами, які важко передбачити заздалегідь",
    rsgConfig3Watch:
      "Не переплачуйте за пам’ять, яка не використовуватиметься. Переконайтеся, що процесор, GPU, швидкість накопичувача та ПЗ дадуть змогу реально скористатися додатковим обсягом.",
    rsgConfigNote:
      "У назвах конфігурацій зазначено номінальний обсяг RAM і флешпам’яті. Після резервування пам’яті для обладнання, системних розділів і попередньо встановленого ПЗ користувачеві буде доступний менший обсяг.",
    rsgStorageEyebrow: "Сплануйте обсяг пам’яті",
    rsgStorageTitle: "Заявлений обсяг — не те саме, що вільне місце",
    rsgStorageIntro:
      "У пристрої з 8, 16 або 32 ГБ частину пам’яті одразу займають системні розділи та фінальна прошивка. Перевірте вільне місце на готовому зразку й оцініть, як воно зменшуватиметься протягом строку служби.",
    rsgStorage1Title: "Прошивка та системні розділи",
    rsgStorage1Body:
      "Операційна система, образ відновлення, службові дані виробника й зарезервовані розділи займають місце ще до встановлення застосунків.",
    rsgStorage2Title: "Стратегія оновлень",
    rsgStorage2Body:
      "Пакети відновлення, файли оновлень і схема A/B можуть потребувати додаткового місця — тимчасово або протягом усього строку служби пристрою.",
    rsgStorage3Title: "Застосунки, дані та кеш",
    rsgStorage3Body:
      "Файли застосунків — лише початок. Дані EPG, зображення, журнали, вебдані та кеш поступово накопичуються під час звичайного користування.",
    rsgStorage4Title: "Швидкість і ресурс накопичувача",
    rsgStorage4Body:
      "Швидка й надійна eMMC та належно налаштована файлова система можуть бути важливішими за великий обсяг вільного місця на повільнішому або погано оптимізованому пристрої.",
    rsgStorageNote:
      "Визначте мінімальний обсяг вільного місця після підготовки пристрою та типового циклу оновлення. Сам номінальний обсяг не гарантує, що наступну версію прошивки чи застосунку вдасться безпечно встановити.",
    rsgOptimizeEyebrow: "Чому відповідь залежить від прошивки",
    rsgOptimizeTitle: "Оптимізація вивільняє ресурси",
    rsgOptimizeIntro:
      "Прошивка приставки — це не типовий образ Android, просто скопійований на плату. BSP, драйвери, системні служби, оболонку та правила роботи застосунків потрібно узгоджено налаштувати для конкретного SoC і призначення пристрою.",
    rsgOptimize1Title: "Вимкніть усе зайве",
    rsgOptimize1Body:
      "Кожна непотрібна служба займає оперативну й вбудовану пам’ять, навантажує процесор і сповільнює запуск. Системний образ для чітко визначеного сценарію можна залишити компактним.",
    rsgOptimize2Title: "Налаштуйте BSP для конкретної плати",
    rsgOptimize2Body:
      "Параметри ядра, драйвери, розподіл пам’яті та апаратна обробка відео визначають ефективність використання ресурсів платформи.",
    rsgOptimize3Title: "Керуйте роботою застосунків",
    rsgOptimize3Body:
      "Налаштування оболонки, обмеження фонових процесів, правила кешування та сценарії відновлення допомагають зберігати швидку роботу інтерфейсу навіть під час тривалих сеансів.",
    rsgOptimize4Title: "Тестуйте кожну версію перед випуском",
    rsgOptimize4Body:
      "Оптимізацію потрібно постійно підтримувати: проводити регресійні тести, поетапно розгортати OTA-оновлення та контролювати стан пристроїв після оновлення.",
    rsgOptimizeProofTitle: "Конкретний приклад: inext TV5",
    rsgOptimizeProofBody:
      "TV5 поєднує 1 ГБ RAM і 8 ГБ eMMC з Android 10 AOSP, апаратно прискореним відтворенням 4K та Alcatraz DMS. Стабільна робота в цьому сценарії стала можливою завдяки рокам оптимізації прошивки для платформи H313, а не ігноруванню обмежень пам’яті.",
    rsgOptimizeProofCta: "Переглянути характеристики TV5",
    rsgGamingEyebrow: "Ігри змінюють вимоги до приставки",
    rsgGamingTitle: "Спочатку визначте тип ігор",
    rsgGamingIntro:
      "Фраза «підтримує ігри» може стосуватися зовсім різних сценаріїв. Проста головоломка, консольна гра з хмари та тривимірна гра, що запускається на самій приставці, мають різні вимоги до обладнання.",
    rsgGamingImageAlt:
      "Людина грає в перегони на телевізорі, використовуючи inext Remote як ігровий контролер",
    rsgGame1Title: "Прості й невимогливі ігри",
    rsgGame1Body:
      "Прості ігри для Android можуть працювати з помірним обсягом пам’яті, якщо прошивка не перевантажена зайвими службами, а кожну гру перевірено на обраній моделі.",
    rsgGame1Emphasis: "Для багатьох ігор достатньо 1–2 ГБ, але кожну потрібно перевіряти",
    rsgGame2Title: "Хмарні ігри",
    rsgGame2Body:
      "Обчислення відбуваються в хмарі. Якість гри залежить від мережі з малою затримкою, апаратного декодування відео, підключення контролера через Bluetooth або USB і стабільного відтворення кадрів.",
    rsgGame2Emphasis: "Найважливіші — затримки мережі, декодера й контролера",
    rsgGame3Title: "Вимогливі ігри на приставці",
    rsgGame3Body:
      "Ігрові рушії, великі текстури та ресурси, що завантажуються у фоні, потребують більше RAM і вбудованої пам’яті. Водночас вирішальними залишаються можливості GPU та здатність приставки довго працювати без перегрівання.",
    rsgGame3Emphasis: "Орієнтир — 4/32, але лише після перевірки GPU й охолодження",
    rsgGamingNote:
      "Чотири гігабайти RAM не перетворять малопотужний SoC на ігрову консоль. Для ігрового сценарію потрібно разом оцінювати RAM, GPU, процесор, швидкість вбудованої пам’яті, охолодження та підтримку контролерів.",
    rsgTestEyebrow: "Перевірка перед закупівлею",
    rsgTestTitle: "Тестуйте реальний сценарій, а не бали синтетичних тестів",
    rsgTestIntro:
      "Зразок постачальника має працювати з цільовою прошивкою, потрібними застосунками та типовим контентом. Повторюйте однакову процедуру приймання для кожної моделі, щоб порівнювати саме той сервіс, який отримають абоненти.",
    rsgTest1: "Виміряйте час холодного запуску та появи зображення після виходу зі сну",
    rsgTest2: "Запустіть основний застосунок і переходьте між ключовими екранами",
    rsgTest3: "Відтворіть типовий контент у 4K, HDR і з DRM-захистом",
    rsgTest4: "Багаторазово перемикайтеся між усіма потрібними застосунками",
    rsgTest5: "Безперервно відтворюйте прямий ефір, OTT або цільовий контент протягом 24–72 годин",
    rsgTest6: "Перевірте з потрібним контролером прості, хмарні й установлені на приставці ігри",
    rsgTest7:
      "Установіть OTA-оновлення за типового запасу вільного місця й перевірте сценарій відновлення",
    rsgTest8:
      "Зафіксуйте доступну RAM і вільне місце після первинного налаштування, тривалого використання та оновлень",
    rsgTestNoteTitle: "Забезпечте відтворюваність перевірки",
    rsgTestNoteBody:
      "Визначте критерії приймання ще до отримання зразків. Ретельно підготовлена демонстрація не замінює повноцінного плану випробувань.",
    rsgTestNoteCta: "Відкрити перелік перевірок для вибору приставки",
    rsgDecisionEyebrow: "Принцип вибору",
    rsgDecisionTitle:
      "Обирайте найменшу конфігурацію, що відповідає реальним вимогам із достатнім запасом",
    rsgDecision1Title: "Визначте склад фінального ПЗ",
    rsgDecision1Body:
      "Перелічіть ОС, оболонку, застосунки, системні служби, DRM, DMS і схему оновлень, які увійдуть до готового пристрою. Самої назви платформи для вибору недостатньо.",
    rsgDecision2Title: "Окремо оцініть відео та обчислювальну частину",
    rsgDecision2Body:
      "Перевірте, які кодеки й роздільності підтримує апаратний декодер, а потім оцініть CPU, GPU та RAM для оболонки, застосунків і багатозадачності.",
    rsgDecision3Title: "Сплануйте використання пам’яті на весь строк служби",
    rsgDecision3Body:
      "Урахуйте доступне місце, кеш, журнали, зростання застосунків, засоби відновлення та принаймні один реалістичний цикл оновлення.",
    rsgDecision4Title: "Зважте вартість запасу на майбутнє",
    rsgDecision4Body:
      "Порівняйте доплату за додаткову пам’ять з імовірністю появи нових застосунків, тривалішої підтримки або розширення функцій протягом експлуатації парку.",
    rsgDecisionConclusion:
      "Правильна приставка — не та, що має найбільше пам’яті. Вона має надійно працювати в передбаченому сценарії, вкладатися в бюджет парку та зберігати достатній запас на весь запланований строк служби.",
    rsgFaqEyebrow: "Поширені запитання",
    rsgFaqTitle: "Що варто знати про RAM і вбудовану пам’ять",
    rsgFaqQ1: "Чи достатньо 1 ГБ RAM сучасній приставці?",
    rsgFaqA1:
      "Може бути достатньо. Один гігабайт — обґрунтована конфігурація для сценарію з чітко визначеним набором функцій, оптимізованою прошивкою, легкою оболонкою та невеликою кількістю застосунків. Не варто автоматично обирати 1 ГБ для невідомого сценарію, широкого набору застосунків або вимогливих ігор на самій приставці. Перед рішенням протестуйте фінальну прошивку.",
    rsgFaqQ2: "Чи є 2 ГБ RAM мінімумом для Android TV?",
    rsgFaqA2:
      "Універсального правила про 2 ГБ для всіх приставок немає. Вимоги Android щодо сумісності залежать від версії системи, архітектури, конфігурації дисплея та обсягу пам’яті, який резервує обладнання. До того ж мінімальні вимоги сумісності самі по собі не показують, наскільки добре працюватиме конкретний набір застосунків. Це визначають випробування готового пристрою.",
    rsgFaqQ3: "Чи покращує збільшення RAM якість відео 4K?",
    rsgFaqA3:
      "Саме по собі — ні. Відео H.264, H.265 або VP9 зазвичай декодує спеціалізований апаратний блок. Плавне відтворення 4K залежить від SoC, декодера, драйверів, вихідного відеотракту та сумісності потоку. RAM більше впливає на роботу оболонки, застосунків, буферизацію та багатозадачність під час відтворення.",
    rsgFaqQ4: "Яка частина заявленої вбудованої пам’яті доступна?",
    rsgFaqA4:
      "Це залежить від прошивки та схеми розділів. Операційна система, засоби відновлення, зарезервовані дані й попередньо встановлені застосунки зменшують доступний обсяг. Попросіть показати вільне місце на зразку, що відповідає серійному пристрою після первинного налаштування, а не лише номінальний обсяг флешпам’яті.",
    rsgFaqQ5: "Скільки RAM потрібно приставці для ігор?",
    rsgFaqA5:
      "Невимогливі ігри можуть добре працювати з 1–2 ГБ, а складніші ігри на самій приставці виграють від 4 ГБ RAM і більшої вбудованої пам’яті. Для хмарних ігор важливіші затримка мережі, апаратне декодування та швидкість реакції контролера. У будь-якому сценарії разом із RAM потрібно оцінювати GPU й охолодження.",
    rsgFaqQ6: "Чи варто оператору доплачувати за пам’ять із розрахунком на майбутнє?",
    rsgFaqA6:
      "Лише якщо це відповідає реалістичному плану розвитку. Додатковий запас виправданий, коли ймовірні нові застосунки, складніший інтерфейс або довший строк служби. У великому парку переплата за невикористану пам’ять у кожному пристрої може перевищити вигоду від такого запасу.",
    rsgCtaEyebrow: "Вибирайте на основі перевірок",
    rsgCtaTitle: "Опишіть сценарій. Ми допоможемо вибрати приставку.",
    rsgCtaBody:
      "Розкажіть про застосунки, відеопотоки, інтеграції, вимоги до ігор і очікуваний строк служби. Команда inext порадить конфігурацію та підготує зразок із потрібним ПЗ для тестування.",
    rsgCtaPrimary: "Обговорити сценарій",
    rsgCtaSecondary: "Порівняти всі моделі",
    footerLinkBrand: "Брендові матеріали",
    brandSeoTitle: "Брендові матеріали та правила використання логотипа inext",
    brandSeoDescription:
      "Завантажте офіційні логотипи та іконки inext і ознайомтеся із затвердженими кольорами, шрифтами, правилами використання та умовами для преси й партнерського маркетингу.",
    brandEyebrow: "Бренд inext",
    brandHeading: "Брендові матеріали",
    brandIntro:
      "Завантажте затверджені файли логотипа inext і дотримуйтеся основних правил щодо кольорів, шрифтів, написання назви та використання матеріалів третіми сторонами.",
    brandDownloadPack: "Завантажити пакет матеріалів",
    brandDownloadGuide: "Завантажити PDF-посібник",
    brandDownloadNote:
      "Без попереднього запиту — для матеріалів преси й редакцій, а також партнерського маркетингу, що правдиво відображає співпрацю.",
    brandLogoAlt: "Логотип inext",
    brandLogoEyebrow: "Варіанти логотипа",
    brandLogoTitle: "Оберіть версію відповідно до фону",
    brandLogoDescription:
      "Використовуйте повний логотип усюди, де вистачає місця. Компактна іконка призначена для квадратних форматів або розміщення в обмеженому просторі. Файли доступні у масштабованому форматі SVG або як PNG із прозорим фоном.",
    brandPrimary: "Основний варіант · білий фон",
    brandOnDark: "Для чорного фону",
    brandOnBlue: "Для фірмового синього фону",
    brandFullLogo: "Повний логотип",
    brandIcon: "Іконка",
    brandColorsEyebrow: "Кольори",
    brandColorsTitle: "Лаконічна палітра з трьох кольорів",
    brandColorsDescription:
      "Це затверджені кольори логотипа inext. Використовуйте точні значення та готові файли, а не змінюйте кольори самостійно.",
    brandColorBlue: "Синій inext",
    brandColorWhite: "Білий",
    brandColorBlack: "Чорний",
    brandTypographyEyebrow: "Шрифт і назва",
    brandTypographyTitle: "Зберігайте чітке й послідовне оформлення тексту",
    brandTypographyDescription:
      "За можливості використовуйте Roboto в матеріалах бренду inext. Добирайте накреслення так, щоб зберігати чітку ієрархію та легкість читання.",
    brandTypographyLink: "Завантажити Roboto з Google Fonts",
    brandNameTitle: "Написання назви бренду",
    brandNameDescription:
      "У звичайному тексті пишіть назву бренду малими літерами: «inext». Якщо потрібен фірмовий шеврон, використовуйте затверджений файл логотипа й не замінюйте його текстовим символом «›».",
    brandUsageEyebrow: "Правильне використання",
    brandUsageTitle: "Зберігайте форму, контраст і зміст",
    brandUsageDescription:
      "Послідовне використання допомагає зберегти впізнаваність бренду в редакційних публікаціях, матеріалах про продукти та партнерських кампаніях.",
    brandDoTitle: "Варто",
    brandDoOfficialAssets: "Використовувати офіційні файли з цієї сторінки.",
    brandDoContrast: "Обирати затверджену версію з достатнім контрастом із фоном.",
    brandDoProportions:
      "Зберігати пропорції логотипа й залишати достатньо вільного простору навколо нього.",
    brandDoAccurateRelationship:
      "Точно описувати характер співпраці з inext у партнерських матеріалах.",
    brandDontTitle: "Не варто",
    brandDontRecolor: "Не вигадувати нові кольори й не поєднувати частини різних версій.",
    brandDontDistort:
      "Не розтягувати, не стискати, не повертати, не обрізати й не нахиляти логотип.",
    brandDontEffects: "Не додавати контури, тіні, градієнти чи інші ефекти.",
    brandDontRearrange:
      "Не змінювати розташування іконки й назви та не створювати текстову заміну логотипа.",
    brandPermissionsEyebrow: "Умови використання",
    brandPermissionsTitle: "Вільне завантаження, відповідальне використання",
    brandPermissionsDescription:
      "Файли логотипа можна вільно завантажувати й використовувати у правомірних публікаціях та партнерських матеріалах. Заповнювати форму чи надсилати електронний лист не потрібно.",
    brandPermissionPress:
      "Преса й редакції можуть використовувати матеріали в публікаціях про inext.",
    brandPermissionPartners:
      "Партнери можуть використовувати їх у маркетингових матеріалах, що правдиво відображають характер співпраці.",
    brandPermissionAccuracy:
      "Використання не повинно створювати хибного враження про схвалення, сертифікацію чи партнерство.",
    brandContactCta: "Запитати про нестандартне використання",
  },
  pl: {
    navAbout: "O nas",
    aboutTitle: "O inext",
    aboutDescription:
      "Poznaj inext — założony w Kijowie międzynarodowy zespół inżynierski, który tworzy dekodery dla operatorów, oprogramowanie TV i narzędzia do zarządzania urządzeniami.",
    aboutEyebrow: "Międzynarodowa firma technologiczna dla telewizji",
    aboutHeading: "Tworzymy rozwiązania TV, które sprawdzają się w rzeczywistych sieciach.",
    aboutIntro:
      "inext to międzynarodowy zespół projektujący dekodery, oprogramowanie TV i narzędzia do zarządzania flotą dla dostawców internetu oraz usług OTT. Wspieramy produkt od pierwszej specyfikacji i wdrożenia aż po jego wieloletnią eksploatację.",
    aboutStat1Value: "15",
    aboutStat1Label: "krajów z wdrożeniami operatorskimi",
    aboutStat3Value: "250+",
    aboutStat3Label: "klientów i partnerów B2B",
    aboutStat4Value: "17",
    aboutStat4Label: "modeli STB od 2011 roku",
    aboutStat5Value: "700K+",
    aboutStat5Label: "urządzeń dostarczonych na świecie",
    aboutWorldwideDeliveryTitle: "Międzynarodowe dostawy w praktyce",
    aboutWorldwideDeliveryBody:
      "inext ma doświadczenie w projektach międzynarodowych: od uruchomień na jednym rynku po wdrożenia operatorskie obejmujące kilka krajów. Dostarczamy dekodery, opakowania pod marką operatora, firmware i wsparcie wdrożeniowe — bezpośrednio lub we współpracy z dystrybutorami.",
    aboutBrandResourcesPrompt: "Szukasz logo lub zatwierdzonych materiałów marki?",
    aboutBrandResourcesCta: "Przejdź do materiałów marki",
    aboutCapabilitiesEyebrow: "Co tworzymy",
    aboutCapabilitiesTitle: "Jedna firma, kompletne rozwiązanie dla abonenta.",
    aboutCapabilitiesLede:
      "Sprzęt, oprogramowanie i narzędzia do obsługi floty powstają razem, dzięki czemu operator może sprawnie przejść od specyfikacji produktu do wdrożenia i późniejszego wsparcia.",
    aboutCapabilityHardwareTitle: "Sprzęt TV dla operatorów",
    aboutCapabilityHardwareBody:
      "Sprawdzone dekodery z Androidem AOSP do usług IPTV i OTT — od ekonomicznych modeli do masowych wdrożeń po urządzenie flagowe.",
    aboutCapabilityHardwareCta: "Zobacz ofertę",
    aboutCapabilitySoftwareTitle: "Firmware i oprogramowanie TV",
    aboutCapabilitySoftwareBody:
      "Firmware i launchery pod marką operatora, integracja aplikacji oraz dedykowane oprogramowanie TV dopasowane do usługi i identyfikacji marki.",
    aboutCapabilitySoftwareCta: "Poznaj personalizację",
    aboutCapabilityOperationsTitle: "Obsługa floty urządzeń",
    aboutCapabilityOperationsBody:
      "Provisioning, etapowe aktualizacje firmware, diagnostyka i zdalne zarządzanie przez Alcatraz DMS oraz standardowe protokoły operatorskie.",
    aboutCapabilityOperationsCta: "Poznaj Alcatraz DMS",
    aboutHeritageEyebrow: "Nasza historia",
    aboutHeritageTitle: "Kijowskie korzenie. Międzynarodowa perspektywa.",
    aboutStoryPara1:
      "Firma inext powstała w Kijowie w 2011 roku. Zaczynaliśmy od projektowania domowego sprzętu multimedialnego w okresie przechodzenia od fizycznych nośników do streamingu. Od samego początku liczyły się dla nas wydajność wideo, stabilność urządzeń i wieloletnia niezawodność.",
    aboutStoryPara2:
      "Dziś jesteśmy międzynarodowym zespołem pracującym z kilku krajów. Gdy IPTV i OTT stały się podstawą sieci operatorskich, nasze doświadczenie przekształciło się w szerszą platformę: dekodery, elastyczne oprogramowanie TV i zarządzanie flotą urządzeń. Rynek się zmienił, ale nasza rola pozostała taka sama — przekładać złożone wymagania techniczne na niezawodne produkty do codziennego użytkowania.",
    aboutPrinciplesEyebrow: "Jak pracujemy",
    aboutPrinciplesTitle: "Praktyczna inżynieria dla rzeczywistych wdrożeń.",
    aboutPrinciplesLede:
      "Podejmujemy decyzje z uwzględnieniem realiów sieci operatorskich, obsługi abonentów i produktów, które muszą pozostać użyteczne długo po uruchomieniu.",
    aboutPrinciple1Title: "Gotowe do wdrożenia",
    aboutPrinciple1Body:
      "Zacznij od sprawdzonych podstaw sprzętowych i programowych, zamiast budować je od nowa dla każdego wdrożenia.",
    aboutPrinciple2Title: "Elastyczność tam, gdzie ma znaczenie",
    aboutPrinciple2Body:
      "Dostosuj branding, firmware, integracje i sprzęt, gdy projekt ma wymagania, których nie spełnia standardowe urządzenie.",
    aboutPrinciple3Title: "Wsparcie przez cały cykl życia",
    aboutPrinciple3Body:
      "Zarządzaj firmware, diagnostyką i działaniem urządzeń po uruchomieniu, a nie tylko podczas dostawy produktu.",
    aboutCtaEyebrow: "Pracuj z inext",
    aboutCtaTitle: "Planujesz wdrożenie TV pod własną marką?",
    aboutCtaBody:
      "Opowiedz nam o swojej sieci, modelu treści i rynkach. Pomożemy dobrać właściwy pakiet urządzenia i oprogramowania.",
    aboutHeroEst: "Założono w Kijowie · 2011",
    aboutClientsEyebrow: "Zaufali nam operatorzy",
    aboutClientsLede:
      "Dostawcy internetu i platformy OTT w 15 krajach dostarczają abonentom dekodery inext.",
    aboutClientsCta: "Zobacz klientów i przykładowe wdrożenia",
    trustedBy: "Ponad 250 operatorów i dostawców telewizji w 15 krajach ufa inext",
    operationsStatPill: "Zasila ponad 120 sieci operatorskich na świecie",
    distributorListTitle: "Dystrybutorzy w Polsce",
    otherRegionsDistributorTitle: "Inne regiony",
    directSalesOperationsTitle: "Sprzedaż bezpośrednia i operacje UE",
    distributorContactCtaTitle: "Nie wiesz, z kim się skontaktować?",
    distributorContactCtaBody:
      "Opisz swój rynek i projekt. Skierujemy zapytanie do właściwego dystrybutora lub bezpośredniego kontaktu sprzedażowego inext.",
    distributorContactCtaButton: "Skontaktuj się z inext",
    contactRoutingLabel: "Globalna sprzedaż i kierowanie do dystrybutorów",
    contactAddressLabel: "Adres",
    contactPhoneLabel: "Telefon",
    contactEmailLabel: "E-mail",
    contactWebsiteLabel: "Strona internetowa",
    tv6UltraSeoTitle: "inext TV6 Ultra — dekoder 4K z Androidem 12 dla operatorów",
    tv6UltraSeoDescription:
      "inext TV6 Ultra: Allwinner H618, 4 GB RAM, 32 GB eMMC, 4K@60 HDR, dwuzakresowe Wi-Fi, BT 5.0, Android 12 AOSP i Alcatraz™ DMS. Dla operatorów, hoteli i platform OTT.",
    tv6UltraBreadcrumbHome: "Strona główna",
    tv6UltraBreadcrumbProducts: "Produkty",
    tv6UltraContactSales: "Skontaktuj się ze sprzedażą",
    tv6UltraFindDistributor: "Znajdź dystrybutora",
    tv6UltraAlcatrazTitle: "Zarządzanie przez Alcatraz™ DMS",
    tv6UltraAlcatrazBody:
      "Każdy TV6 Ultra jest gotowy do pracy z systemem zarządzania urządzeniami inext Alcatraz — z którego korzysta już 120+ sieci operatorskich na świecie.",
    tv6UltraAlcatrazCta: "Zobacz operacje",
    tv6UltraCtaTitle: "Zamów TV6 Ultra dla swojej sieci",
    tv6UltraCtaBody:
      "Ceny hurtowe, opakowania white-label i provisioning w Alcatraz™ — wszystko od jednego zespołu.",
    tv6UltraSpecChipset: "Chipset",
    tv6UltraSpecCpu: "CPU",
    tv6UltraSpecGpu: "GPU",
    tv6UltraSpecRam: "RAM",
    tv6UltraSpecStorage: "Pamięć",
    tv6UltraSpecDimensions: "Wymiary",
    tv6UltraSpecPower: "Zasilanie",
    tv6UltraSpecHdmi: "HDMI",
    tv6UltraSpecEthernet: "Ethernet",
    tv6UltraSpecWifi: "Wi-Fi",
    tv6UltraSpecBluetooth: "Bluetooth",
    tv6UltraSpecUsb: "USB",
    tv6UltraSpecCardReader: "Czytnik kart",
    tv6UltraSpecAudioOut: "Wyjście audio",
    tv6UltraSpecAudioFormats: "Formaty audio",
    tv6UltraSpecVideoFormats: "Formaty wideo",
    tv6UltraSpecVideoCodecs: "Kodeki wideo",
    tv6UltraSpecMaxRes: "Maks. rozdzielczość",
    tv6UltraSpec3d: "Obsługa 3D",
    tv6UltraSpecImageFormats: "Formaty obrazów",
    tv6UltraSpecOs: "System operacyjny",
    tv6UltraSpecDms: "Zarządzanie urządzeniami",
    tv6UltraSpecTr069: "TR-069",
    tv6UltraSpecFilesystems: "Systemy plików",
    tv6UltraSpecLanguages: "Języki",
    tv6UltraSpecInternet: "Funkcje internetowe",
    tv6UltraSpecTr069Yes: "Obsługiwany",
    tv6UltraSpecLanguagesValue: "Wiele języków",
    productSpecCpuArmv8Quad: "Czterordzeniowy ARM v8 Cortex-A53",
    productSpecCpuQuadCoreArm: "Czterordzeniowy ARM Cortex-A53",
    productSpecHdmiCableIncluded: "HDMI 2.0a (kabel w zestawie)",
    productSpecEthernet100: "RJ45 Fast Ethernet (100 Mb/s)",
    productSpecWifiDualBandN: "Dwa pasma: 2,4 i 5 GHz · 802.11 b/g/n",
    productSpecWifiDualBandAc: "Dwa pasma: 2,4 i 5 GHz · 802.11 b/g/n/ac",
    productSpecUsbHost: "2 × USB 2.0 w trybie hosta",
    productSpecAudioSpdifRcaTrs: "S/PDIF (optyczne) · RCA przez złącze TRS 3,5 mm",
    productSpecAudioSpdif: "S/PDIF (optyczne)",
    productSpecAudioSpdifRca: "S/PDIF (optyczne) · RCA (TRS 3,5 mm)",
    productSpecInternetFeatures:
      "IPTV · OTT · VOD · HLS · radio internetowe · HTML5 · WebKit · aplikacje Android",
    tv6UltraPackageRemote: "Pilot Bluetooth",
    tv6UltraPackagePower: "Zasilacz (5 V / 2 A)",
    tv6UltraPackageHdmi: "Kabel HDMI",
    tv6UltraPackageGuide: "Skrócona instrukcja",
    tv6UltraPackageBatteries: "Baterie",
    tv6UltraV2HeroEyebrow: "Flagowy · dekoder 4K z Androidem 12",
    tv6UltraV2HeroHeadline: "Maksymalna moc dla najbardziej wymagających treści.",
    tv6UltraV2HeroSub:
      "Centrum multimedialne klasy operatorskiej — dla abonenta i zespołu zarządzającego usługą.",
    tv6UltraCompareLabel: "Porównaj wszystkie modele",
    tv6UltraV2IntroPara1:
      "TV6 Ultra to flagowy model rodziny inext: dwukrotnie więcej RAM i pamięci niż TV6, sprzętowe 4K@60 i ten sam Alcatraz™ DMS, który już zasila ponad 120 sieci operatorskich na świecie.",
    tv6UltraV2IntroPara2:
      "Zaprojektowany tak, by wtopić się w salon i pozostać niewidoczny dla zespołu wsparcia — szybka konfiguracja, łatwe aktualizacje, cicha praca.",
    tv6UltraV2PerformanceEyebrow: "Wydajność",
    tv6UltraV2PerformanceTitle: "Płynne 4K. Każdy kodek.",
    tv6UltraV2PerformanceBody:
      "Czterordzeniowy Allwinner H618 z Mali-G31 MP2 sprzętowo dekoduje H.265, VP9 Profile 2 i H.264, dzięki czemu materiały 4K, VOD i aplikacje działają płynnie nawet pod obciążeniem.",
    tv6UltraV2PerformanceAccent: "Allwinner H618 · 4 GB DDR3 · 32 GB eMMC · 4K@60 H.265",
    tv6UltraV2ConnectivityEyebrow: "Łączność",
    tv6UltraV2ConnectivityTitle: "Wszystkie porty, których potrzebują abonenci.",
    tv5ConnectivityTitle: "Wszystkie niezbędne porty na pokładzie.",
    tv5UltraConnectivityTitle: "Pełne wejścia i wyjścia dla każdej instalacji.",
    tv6ConnectivityTitle: "Kabel, Wi-Fi i Bluetooth w komplecie.",
    tv6UltraV2ConnectivityCaption:
      "HDMI 2.0a · Ethernet 100 Mb · 2× USB 2.0 · microSD · S/PDIF · AV · dwuzakresowe Wi-Fi 2,4/5 GHz · Bluetooth 5.0.",
    tv6UltraV2SoftwareEyebrow: "Oprogramowanie",
    tv6UltraV2SoftwareTitle: "Android 12, gotowy od razu.",
    tv6UltraV2SoftwareBody:
      "Otwarty Android 12 (AOSP) z launcherem operatora, elastycznym brandingiem oraz TR-069 + Alcatraz™ DMS dla zespołu zarządzającego każdym wdrożonym urządzeniem.",
    tv6UltraV2SoftwareCustomTitle1: "Launcher operatora",
    tv6UltraV2SoftwareCustomBody1:
      "Dostosuj ekran główny do struktury swojej usługi: Live TV, VOD, catch-up, radio, aplikacji, ustawień i typowych ścieżek oglądania.",
    tv6UltraV2SoftwareCustomTitle2: "Marka i rynek",
    tv6UltraV2SoftwareCustomBody2:
      "Dopasuj logo, kolory, język, domyślne sekcje i preinstalowane usługi dla każdego operatora lub regionu.",
    tv6UltraV2SoftwareCustomTitle3: "Zdalne zarządzanie flotą",
    tv6UltraV2SoftwareCustomBody3:
      "Alcatraz™ DMS i TR-069 umożliwiają provisioning urządzeń, wdrażanie aktualizacji i zarządzanie ustawieniami, odciążając przy tym zespół wsparcia.",
    tv6UltraV2SpecsTitle: "Pełna specyfikacja techniczna",
    tv6UltraV2SpecsGroupHardware: "Sprzęt",
    tv6UltraV2SpecsGroupConnectivity: "Łączność",
    tv6UltraV2SpecsGroupMedia: "Media",
    tv6UltraV2SpecsGroupSoftware: "Oprogramowanie",
    tv6UltraV2SpecsGroupPackage: "W zestawie",
    tv6UltraV2RemoteEyebrow: "Pilot",
    tv6UltraV2RemoteTitle: "Pilot Bluetooth z mikrofonem, stworzony do salonu.",
    tv6UltraV2RemoteBody:
      "Sparuj raz przez Bluetooth — bez celowania w dekoder. Wbudowany mikrofon obsługuje wyszukiwanie głosowe w launcherze i aplikacjach, a programowalny przycisk zasilania TV oraz konfigurowalny przycisk ulubionych pozwalają każdemu abonentowi dopasować pilota do siebie.",
    tv6UltraV2RemoteFeatureBt: "Bluetooth 5.0 — bez konieczności celowania",
    tv6UltraV2RemoteFeatureMic: "Wbudowany mikrofon do wyszukiwania głosowego",
    tv6UltraV2RemoteFeatureTvPower: "Programowalny przycisk zasilania TV",
    tv6UltraV2RemoteFeatureFav: "Konfigurowalny przycisk ulubionych (FAV)",
    tv6UltraV2RemoteNoteBody:
      "TV6 Ultra domyślnie jest dostarczany z głosowym pilotem Bluetooth, ale możesz zamówić go z dowolnym pilotem z naszej oferty — Bluetooth lub IR — dopasowanym do Twojego rynku.",
    tv6UltraV2GlanceValue1: "4K @ 60 Hz",
    tv6UltraV2GlanceLabel1: "HDR · H.265",
    tv6UltraV2GlanceValue2: "Android 12",
    tv6UltraV2GlanceLabel2: "AOSP, gotowy na aplikacje",
    tv6UltraV2GlanceValue3: "4 GB / 32 GB",
    tv6UltraV2GlanceLabel3: "DDR3 + eMMC",
    tv6UltraV2GlanceValue4: "Pilot BT 5.0",
    tv6UltraV2GlanceLabel4: "Głos + FAV",
    navProducts: "Produkty",
    navCustomization: "Personalizacja",
    navBlog: "Blog",
    navFaq: "FAQ",
    navContact: "Kontakt",
    navSearch: "Szukaj",
    announcementLabel: "Aktualności",
    contactSales: "Skontaktuj się ze sprzedażą",
    toggleMenu: "Przełącz menu",
    language: "Język",
    breadcrumbLabel: "Ścieżka nawigacji",
    heroEyebrow: "Sprzęt STB dla operatorów · Od 2011 roku",
    heroTitle: "Dekodery Android TV",
    heroTitleAccent: "dla operatorów IPTV i OTT",
    heroDescription:
      "Cztery gotowe do wdrożenia modele Android TV, dostosowane do marki i oprogramowania operatora, z Alcatraz DMS do zarządzania flotą urządzeń.",
    heroModelsCta: "Porównaj modele STB",
    heroQuoteCta: "Poproś o wycenę",
    exploreProducts: "Zobacz produkty",
    bookDemo: "Umów demo",
    stackEyebrow: "Ekosystem inext",
    stackTitle: "Sprzęt, personalizacja i",
    stackTitleAccent: "operacje",
    stackTitleEnd: "— w jednym miejscu",
    stackDescription:
      "Trzy filary obejmujące wszystko, czego operator potrzebuje do uruchomienia i prowadzenia nowoczesnej usługi IPTV / OTT.",
    hardwareEyebrow: "Sprzęt · Nasz flagowy STB",
    hardwareTitle: "Poznaj",
    hardwareDescription:
      "Kompaktowy i wydajny dekoder z systemem Android 12 (AOSP), przeznaczony dla dostawców internetu i operatorów telewizyjnych. Allwinner H618, 4 GB pamięci DDR3 i 32 GB eMMC zapewniają płynne odtwarzanie 4K UHD przy 60 kl./s. Urządzenie ma HDMI 2.0a, dwuzakresowe Wi-Fi AC, Bluetooth 5.0 i Ethernet 100 Mb, a w zestawie znajdują się pilot, kabel HDMI oraz zasilacz.",
    viewTechSpecs: "Zobacz specyfikację",
    clientsEyebrow: "White-label i co-branding",
    clientsTitle: "Operatorzy już dostarczają",
    clientsTitleAccent: "STB inext",
    clientsDescription:
      "Sprawdzony sprzęt, opakowania i interfejsy dostarczone czołowym dostawcom internetu oraz platformom OTT — w pełni dopasowane do ich marek.",
    clientsOutro:
      "Od pojedynczego urządzenia po ogólnokrajowe wdrożenie — Twoja marka, nasza inżynieria.",
    customizationEyebrow: "Personalizacja",
    customizationTitle: "Twoja marka od początku do końca",
    customizationDescription:
      "Od opakowania po launcher na ekranie telewizora — każdy element produktu można dopasować do marki operatora i oferowanych przez niego treści.",
    learnMore: "Dowiedz się więcej",
    lineupEyebrow: "Wybierz sprzęt",
    lineupTitle: "Cztery dekodery. Jedna platforma operatorska.",
    lineupDescription:
      "Zacznij od potrzeb wdrożenia: podstawowy sprzęt 4K, więcej pamięci i miejsca albo pełny flagowy model z 4 GB. Każdy model powstał z myślą o kontroli operatorskiej i Alcatraz DMS.",
    lineupCompareAll: "Porównaj wszystkie modele",
    lineupFlagshipBadge: "Flagowiec",
    lineupTv5Tagline: "Ekonomiczny dekoder 4K z Androidem.",
    lineupTv5UltraTagline: "Więcej pamięci i miejsca na dane na sprawdzonej platformie.",
    lineupTv6Tagline: "Dekoder 4K z Bluetooth i Wi-Fi ac.",
    lineupTv6UltraTagline: "Najwyższa wydajność i najwięcej pamięci — model flagowy.",
    homeCompanionEyebrow: "Aplikacja towarzysząca",
    homeCompanionCta: "Poznaj inext Remote",
    operationsEyebrow: "Operacje · Alcatraz DMS + protokoły",
    operationsTitle: "Jedna platforma do zarządzania",
    operationsTitleAccent: "każdym urządzeniem",
    operationsDescription:
      "Alcatraz DMS to system zarządzania urządzeniami wykorzystywany w każdym wdrożeniu inext. Z jednej konsoli zespoły mogą wykrywać problemy floty, przeglądać aktywność urządzeń, wdrażać firmware i uruchamiać zdalną diagnostykę.",
    ctaEyebrow: "Porozmawiajmy",
    ctaTitle: "Gotowi wybrać",
    ctaTitleAccent: "odpowiedni dekoder?",
    ctaDescription:
      "Opowiedz nam o usłudze, wielkości floty i wymaganiach technicznych. Zaproponujemy konfigurację sprzętu i plan wdrożenia.",
    footerDescription:
      "Dekodery i oprogramowanie do zarządzania urządzeniami dla dostawców internetu oraz telewizji od 2011 roku.",
    footerProducts: "Produkty",
    footerSolutions: "Rozwiązania",
    footerCompany: "Firma",
    footerRights: "Wszelkie prawa zastrzeżone.",
    homeTitle: "Dekodery Android TV dla operatorów IPTV i OTT | inext",
    homeDescription:
      "inext dostarcza dekodery Android TV dla ISP i operatorów telewizyjnych, wraz z personalizacją white-label, aplikacjami IPTV, Alcatraz DMS i globalną dostawą B2B.",
    portalEyebrow: "Więcej niż dekoder",
    portalTitle: "Wszystko, czego operator potrzebuje wokół STB.",
    portalDescription:
      "Zmień wybrany sprzęt w kompletny produkt dla abonenta dzięki brandingowi, aplikacjom, zarządzaniu flotą i skoordynowanej dostawie B2B.",
    portalResourcesEyebrow: "Centrum wiedzy",
    portalResourcesTitle: "Zaplanuj wdrożenie z praktycznymi poradnikami i narzędziami.",
    portalResourcesDescription:
      "Poznaj decyzje sprzętowe, porównaj koszty floty i znajdź praktyczne odpowiedzi w portalu inext.",
    heroQuickHardware: "Sprzęt",
    heroQuickCustomization: "Personalizacja",
    heroQuickOperations: "Operacje",
    heroQuickLogistics: "Dostawa na świat",
    heroDashboardTitle: "Alcatraz DMS · Przegląd floty",
    heroMetricActiveDevices: "Aktywne urządzenia",
    heroMetricOnline: "Online",
    heroMetricStreams: "Transmisje / min",
    heroFirmware: "Firmware",
    heroDeviceOnline: "Online",
    heroDeviceImageAlt: "Dekoder inext TV6 Ultra z pilotem",
    heroSpecChipset: "Chipset",
    heroSpecMemory: "Pamięć",
    heroSpecVideo: "Wideo",
    heroSpecOs: "System",
    heroStackBadge: "Sprzęt i oprogramowanie w jednym ekosystemie",
    productMenuFlagship: "Flagowy",
    productMenuTv6UltraDesc: "Flagowy · 4 GB / 32 GB · pilot głosowy",
    productMenuTv6Desc: "Wydajny · 2 GB / 16 GB · pilot IR",
    productMenuTv5UltraDesc: "Standard · 2 GB / 16 GB · pilot IR",
    productMenuTv5Desc: "Podstawowy · 1 GB / 8 GB · pilot IR",
    navMenuProductsEyebrow: "Dekodery",
    navMenuSolutionsEyebrow: "Rozwiązania i oprogramowanie",
    navMenuSolutionsGroupPlatform: "Platforma i operacje",
    navMenuSolutionsGroupApps: "Aplikacje",
    navMenuSolutionsGroupServices: "Usługi",
    productMenuFeaturedTitle: "Flagowy dekoder 4K",
    productMenuFeaturedDesc: "Android 12 · pilot głosowy BT · Alcatraz DMS",
    productMenuFeaturedCta: "Poznaj flagowy model",
    pillarHardwareEyebrow: "Sprzęt",
    pillarHardwareTitle: "Dekodery 4K z Androidem",
    pillarHardwareDescription:
      "Kompaktowe, wydajne dekodery 4K zaprojektowane dla dostawców internetu i operatorów telewizyjnych. inext TV6 Ultra to flagowy model w ofercie.",
    pillarHardwareCta: "Zobacz całą ofertę",
    pillarCustomizationEyebrow: "Personalizacja",
    pillarCustomizationTitle: "Twoja marka na każdym ekranie",
    pillarCustomizationDescription:
      "Sprzęt white-label, co-branding, dedykowane aplikacje IPTV, launcher operatora i mobilna aplikacja pilota — wszystko dopasowane do Twojej marki.",
    pillarCustomizationCta: "Zobacz personalizację",
    pillarOperationsEyebrow: "Operacje",
    pillarOperationsTitle: "Zarządzaj całą flotą",
    pillarOperationsDescription:
      "Fleet Health, historia aktywności urządzeń, etapowe aktualizacje OTA, zdalna diagnostyka i TR-069 w jednej konsoli Alcatraz DMS dla całej sieci.",
    pillarOperationsCta: "Wewnątrz Alcatraz DMS",
    hardwareSpecChipset: "Allwinner H618 · czterordzeniowy A53",
    hardwareSpecMemory: "4 GB DDR3 · 32 GB eMMC · Mali-G31 MP2",
    hardwareSpecVideo: "4K UHD H.265 60 kl./s · VP9 · H.264",
    hardwareSpecWireless: "Dwuzakresowe Wi-Fi AC · BT 5.0 · LAN 100 Mb",
    hardwareSpecPorts: "HDMI 2.0a · wyjście A/V · 2×USB 2.0 · microSD/TF",
    hardwareSpecSoftware: "Android 12 (AOSP) · Alcatraz™ DMS · TR-069",
    hardwareImageAlt: "Dekoder inext TV6 Ultra z pilotem i opakowaniem",
    hardwareStatUltraHd: "Ultra HD",
    hardwareStat60Fps: "60 kl./s",
    hardwareStatAndroid: "Android",
    clientTagFullPackage: "Pełny pakiet",
    clientTagCoBranding: "Co-branding",
    clientTagRetailKit: "Zestaw detaliczny",
    clientTagCustomApp: "Dedykowana aplikacja",
    clientTagWhiteLabel: "White-label",
    clientImageAltSuffix: "STB od inext",
    clientNoteBeeline: "Dekoder, pilot i pudełko detaliczne pod marką operatora",
    clientNoteOkTv: "Urządzenie i opakowanie z marką operatora",
    clientNoteKyivstar: "Urządzenie, pilot i pudełko pod marką operatora",
    clientNoteAlmaTv: "Dekoder IPTV — opakowanie i zestaw z pilotem",
    clientNoteSarkor: "Interfejs operatora, opakowanie i akcesoria",
    clientNoteSweetTv: "Box 2 UltraHD — pełny zestaw detaliczny",
    clientNoteMegogo: "Czarna edycja z pilotem pod marką operatora",
    clientNoteMetroTv: "STB z marką operatora i pudełkiem detalicznym",
    customServiceWhiteLabelingTitle: "White-labeling",
    customServiceWhiteLabelingDescription:
      "Dostarczaj sprzęt i aplikacje pod własną marką — z opakowaniem, firmware i interfejsem w pełni dopasowanymi do Twojej identyfikacji.",
    customServiceCoBrandingTitle: "Co-branding",
    customServiceCoBrandingDescription:
      "Połącz swoją markę z platformą inext dzięki elastycznemu co-brandingowi sprzętu, oprogramowania i zestawów detalicznych.",
    customServiceIptvAppTitle: "Dedykowana aplikacja IPTV",
    customServiceIptvAppDescription:
      "Dedykowany odtwarzacz IPTV/OTT z EPG, catch-up, time-shift i VOD — dopasowany do Twojej oferty programowej.",
    customServiceLauncherTitle: "Launcher klasy operatorskiej",
    customServiceLauncherDescription:
      "Launcher Android TV z własnym układem sekcji, ekranem głównym pod marką operatora i pełną kontrolą nad interfejsem abonenta.",
    customServiceRemoteAppTitle: "Mobilna aplikacja pilota",
    customServiceRemoteAppDescription:
      "Zamień smartfon w wygodny pilot z parowaniem Bluetooth, wyszukiwaniem głosowym, klawiaturą i obsługą gestów.",
    customServiceAppDesignTitle: "Projekt dedykowanej aplikacji",
    customServiceAppDesignDescription:
      "Kompleksowy projekt interfejsu launchera, EPG i odtwarzacza — dopasowany do potrzeb abonentów oraz oferowanych treści.",
    operationsImageAlt:
      "Dashboard Alcatraz DMS — przegląd floty w czasie rzeczywistym z urządzeniami online, modelami i dystrybucją firmware",
    operationsFeatureTelemetry: "Alerty Fleet Health i kolejka problemów",
    operationsFeatureOta: "Etapowe wdrożenia firmware OTA",
    operationsFeatureTr069: "Obsługa TR-069 / CWMP",
    operationsFeaturePush: "Powiadomienia push do wybranych urządzeń",
    operationsFeatureIperf: "Diagnostyka MTR i iPerf3",
    operationsFeatureAccess: "Klucze API z ograniczonym zakresem i dostęp oparty na rolach",
    operationsFeatureDiagnostics: "Aktywność urządzeń i historia problemów",
    operationsLiveBadge: "Na żywo",
    operationsCalloutOnline: "6236 urządzeń online",
    operationsCalloutActive: "62% aktywnych w tym miesiącu",
    operationsCalloutFirmware: "2 nowe wersje firmware do testów",
    operationsMetric1Value: "120+",
    operationsMetric1Label: "sieci operatorskich",
    operationsMetric3Value: "24/7",
    operationsMetric3Label: "monitoring floty",
    footerLinkTv6Ultra: "inext TV6 Ultra",
    footerLinkTv6: "inext TV6",
    footerLinkTv5Ultra: "inext TV5 Ultra",
    footerLinkTv5: "inext TV5",
    footerLinkAbout: "O nas",
    footerLinkBlog: "Blog",
    footerLinkNewsletter: "Newsletter",
    footerLinkFaq: "FAQ",
    footerLinkContact: "Kontakt",
    footerLinkDistributors: "Dystrybutorzy",
    footerLinkPrivacy: "Polityka prywatności",
    footerLinkRepublishing: "Republikacja",
    footerLinkServiceStatus: "Status usług",
    aboutHeroImageAlt: "Urządzenia inext 3D kid, HD1, TV, TV2e i 4K2",
    aboutClientImageAltSuffix: "wdrożenie STB inext",
    contactsTitle: "Kontakt z inext",
    contactsDescription:
      "Skontaktuj się z przedstawicielem handlowym inext odpowiedzialnym za Twój rynek.",
    contactsEyebrow: "Kontakt",
    contactsHeading: "Stwórzmy razem Twoją kolejną usługę TV",
    contactsIntro: "Opowiedz nam o swoim projekcie, a nasz zespół skontaktuje się z Tobą.",
    contactFormTitle: "Wyślij zapytanie",
    contactFormIntro: "Podaj kilka informacji, abyśmy mogli połączyć Cię z właściwą osobą.",
    contactNameLabel: "Imię i nazwisko",
    contactCompanyLabel: "Firma",
    contactCompanyOptionalLabel: "Firma (opcjonalnie)",
    contactCompanyRequired: "Podaj nazwę firmy dla tego typu zapytania.",
    contactCountryLabel: "Kraj",
    contactPhoneOptionalLabel: "Telefon (opcjonalnie)",
    contactInquiryTypeLabel: "Jak możemy pomóc?",
    contactInquiryTypePlaceholder: "Wybierz typ zapytania",
    contactInquiryType_sales: "Zapytanie sprzedażowe",
    contactInquiryType_demo: "Umów demo",
    contactInquiryType_integration: "Integracja",
    contactInquiryType_brand: "Materiały marki i media",
    contactInquiryType_partnership: "Partnerstwo",
    contactInquiryType_support: "Wsparcie urządzeń",
    contactInquiryType_other: "Inne",
    contactBrandResourcesNote:
      "Oficjalne pliki logo i zasady użycia są dostępne do natychmiastowego pobrania. Użyj tego formularza tylko w przypadku pytań dotyczących niestandardowego użycia.",
    contactBrandResourcesCta: "Przejdź do materiałów marki",
    contactMessageLabel: "Wiadomość",
    contactWebsiteHoneypotLabel: "Strona internetowa",
    contactConsentPrefix: "Wyrażam zgodę na przetwarzanie moich danych zgodnie z",
    contactPrivacyLink: "Polityką prywatności",
    contactConsentRequired: "Zaakceptuj politykę prywatności, aby kontynuować.",
    contactSubmit: "Wyślij zapytanie",
    contactSubmitting: "Wysyłanie...",
    contactSuccessTitle: "Dziękujemy za kontakt",
    contactSuccessBody:
      "Twoje zapytanie zostało wysłane. Nasz zespół skontaktuje się z Tobą wkrótce.",
    contactFailureTitle: "Nie udało się wysłać zapytania",
    contactFailureBody: "Spróbuj ponownie albo napisz bezpośrednio na",
    findDistributorTitle: "Szukasz lokalnego dystrybutora?",
    findDistributorBody: "Znajdź właściwego partnera inext dla swojego rynku.",
    viewDistributors: "Zobacz dystrybutorów",
    exclusiveDistributorTitle: "Wyłączny dystrybutor w Ukrainie",
    globalDistributorListTitle: "Dystrybutorzy",
    distributorsTitle: "Dystrybutorzy inext",
    distributorsDescription: "Znajdź oficjalnego dystrybutora inext dla swojego rynku.",
    distributorsEyebrow: "Partnerzy",
    distributorsHeading: "Znajdź lokalnego dystrybutora",
    distributorsIntro: "Skontaktuj się z oficjalnym dystrybutorem inext w swoim regionie.",
    distributorRegionUkraine: "Ukraina",
    distributorRegionPoland: "Polska",
    distributorRegionSlovakia: "Słowacja",
    distributorRegionMoldova: "Mołdawia",
    distributorRegionEuOperations: "Operacje UE",
    distributorRegionGlobal: "Globalnie",
    privacyTitle: "Polityka prywatności",
    privacyDescription: "Jak inext przetwarza informacje przekazywane przez tę stronę.",
    privacyEyebrow: "Informacje prawne",
    privacyHeading: "Polityka prywatności",
    republishingTitle: "Republikacja i licencjonowanie",
    republishingDescription:
      "Większość artykułów inext jest dostępna na licencji CC BY 4.0 — można je ponownie publikować, tłumaczyć i adaptować z podaniem źródła. Wyjaśniamy, jak to zrobić.",
    republishingEyebrow: "Licencjonowanie",
    republishingHeading: "Republikacja naszych treści",
    blogLicenseLabel: "Licencja",
    blogLicenseAllRightsReserved: "Wszelkie prawa zastrzeżone",
    blogLicenseReusableNote: "Możesz ponownie opublikować ten artykuł, podając inext jako źródło.",
    blogLicenseReservedNote: "Skontaktuj się z nami przed ponowną publikacją.",
    blogLicenseGuidelines: "Zasady ponownej publikacji",
    republishKitToggle: "Republikuj ten artykuł",
    republishKitIntro: "Licencja CC BY 4.0 — podaj inext i dodaj link.",
    republishCopyLink: "Kopiuj link",
    republishCopyMarkdown: "Kopiuj jako Markdown",
    republishCopyHtml: "Kopiuj jako HTML",
    republishDownloadMarkdown: "Pobierz .md",
    republishDownloadHtml: "Pobierz .html",
    republishDownloadImages: "Pobierz obrazy (.zip)",
    republishDownloadingImages: "Przygotowywanie obrazów…",
    republishDownloadAudio: "Pobierz audio",
    republishDownloadingAudio: "Przygotowywanie audio…",
    republishCopied: "Skopiowano",
    republishContact: "Masz pytania lub potrzebujesz pliku w wyższej rozdzielczości?",
    republishReservedNotice:
      "Ten artykuł został opublikowany za zgodą podmiotu trzeciego i nie jest dostępny na licencji CC BY 4.0.",
    republishCreditPrefix: "Artykuł opublikowany pierwotnie przez inext na stronie ",
    republishCreditSuffix: " — ponowna publikacja na licencji CC BY 4.0.",
    faqTitle: "FAQ inext",
    faqDescription:
      "Odpowiedzi o STB inext, rozwiązaniach IPTV, personalizacji, Alcatraz™ DMS, firmware i rozwiązywaniu problemów.",
    faqEyebrow: "Wsparcie",
    faqHeading: "Najczęściej zadawane pytania",
    faqIntro:
      "Krótkie odpowiedzi o sprzęcie inext, rozwiązaniach dla operatorów (aplikacja IPTV, branding, zarządzanie flotą), firmware i typowych problemach z urządzeniami.",
    faqCategoryAll: "Wszystkie",
    faqCategoryDevices: "Urządzenia i konfiguracja",
    faqCategoryFirmware: "Firmware",
    faqCategorySolutions: "Rozwiązania i aplikacje",
    faqCategoryManagement: "Alcatraz™ DMS",
    faqCategoryTroubleshooting: "Rozwiązywanie problemów",
    faqQuestionCompare: "Który dekoder inext wybrać?",
    faqAnswerCompare:
      "TV6 Ultra to model flagowy do najbardziej wymagających wdrożeń 4K. TV6 zapewnia dobry stosunek wydajności do ceny. TV5 Ultra sprawdza się w masowych wdrożeniach IPTV/OTT, a TV5 to model podstawowy. Skorzystaj z porównania, aby dobrać pamięć, pilot i łączność do swojej sieci.",
    faqQuestionIptvMiddleware: "Jakie middleware IPTV obsługuje aplikacja inext IPTV?",
    faqAnswerIptvMiddleware:
      "Gotowy klient IPTV inext współpracuje ze Stalker/Ministra, TVIP, Hibox, Aura oraz zwykłymi playlistami M3U z EPG XMLTV — w Twoim brandingu i z wstępną konfiguracją jeszcze przed wysyłką dekoderów.",
    faqQuestionWhiteLabel: "Jaka jest różnica między co-brandingiem a white-labelingiem?",
    faqAnswerWhiteLabel:
      "Co-branding łączy Twoją markę z inext na wspólnym sprzęcie i w UI. White-labeling całkowicie usuwa inext z pudełka, firmware i aplikacji — abonenci widzą wyłącznie Twoją tożsamość.",
    faqQuestionRemoteApp: "Czym jest aplikacja inext Remote?",
    faqAnswerRemoteApp:
      "inext Remote to darmowa aplikacja towarzysząca na Androida i iOS, która steruje STB inext z telefonu — klawiatura i wyszukiwanie głosowe, przełączanie pokoi, tryb gamepada oraz jasny/ciemny motyw.",
    faqQuestionBuy: "Jak kupić produkty inext lub zostać partnerem?",
    faqAnswerBuy:
      "inext sprzedaje operatorom i dystrybutorom na całym świecie. Znajdź autoryzowanego partnera w pobliżu lub skontaktuj się z działem sprzedaży w sprawie dostaw, personalizacji i wdrożenia Alcatraz™ DMS.",
    faqQuestionAlcatrazDeploy: "Czy Alcatraz™ DMS może działać w naszej własnej sieci?",
    faqAnswerAlcatrazDeploy:
      "Tak. Alcatraz działa jako zarządzany chmurowy SaaS lub instalacja on-premises w zamkniętej sieci ISP — ten sam interfejs i zestaw funkcji, model wdrożenia wybierasz według wymagań dotyczących danych.",
    faqQuestionAlcatrazIntegrate:
      "Czy możemy zintegrować Alcatraz z naszym BSS/OSS lub narzędziami wsparcia?",
    faqAnswerAlcatrazIntegrate:
      "Tak. Alcatraz udostępnia udokumentowane REST API i obsługuje MQTT. Administratorzy mogą tworzyć i unieważniać klucze API, ograniczać uprawnienia i źródłowe adresy IP, ustawiać daty ważności oraz łączyć urządzenia z rekordami CRM lub systemu rozliczeniowego za pomocą zewnętrznych ID.",
    faqQuestionHdmi: "Jaki standard HDMI obsługują urządzenia inext?",
    faqAnswerHdmi:
      "Wszystkie aktualne STB inext mają wyjście HDMI 2.0a z obsługą CEC. Kabel HDMI znajduje się w zestawie.",
    faqQuestionResolution: "Czy wszystkie urządzenia inext obsługują 4K?",
    faqAnswerResolution:
      "Tak — TV5, TV5 Ultra, TV6 i TV6 Ultra obsługują odtwarzanie 4K UHD do 60 kl./s dzięki sprzętowemu dekodowaniu H.265, VP9 i H.264.",
    faqQuestionAndroid: "Na jakiej wersji Androida działają urządzenia inext?",
    faqAnswerAndroid:
      "TV6 Ultra i TV6 działają na Androidzie 12 (AOSP). TV5 Ultra i TV5 działają na Androidzie 10 (AOSP). Wszystkie modele korzystają z otwartego AOSP bez preinstalowanych usług Google Play.",
    faqQuestionRemote: "Jaki typ pilota znajduje się w zestawie?",
    faqAnswerRemote:
      "TV6 Ultra jest dostarczany z głosowym pilotem Bluetooth 5.0. TV6 zwykle ma pilot IR z pełną klawiaturą numeryczną, choć na niektórych rynkach dostępny jest też z pilotem Bluetooth. TV5 Ultra i TV5 mają pilot IR z pełną klawiaturą numeryczną.",
    faqQuestionFirmwares: "Gdzie znajdę oficjalne firmware?",
    faqAnswerFirmwares:
      "Najnowsze firmware dla urządzeń inext są dostępne wyłącznie przez aktualizację online OTA. Aktualizacje możesz sprawdzić na urządzeniu w Ustawieniach -> Informacje -> Aktualizacja systemu. Jeśli masz problem z aktualizacją, skontaktuj się z naszym centrum serwisowym.",
    faqQuestionFirmwareCheck: "Jak sprawdzić aktualną wersję firmware?",
    faqAnswerFirmwareCheck:
      "Przejdź do Ustawienia → Informacje → Numer kompilacji na urządzeniu. Znajdziesz tam wersję firmware i datę kompilacji.",
    faqQuestionOtaFleet: "Jak działają aktualizacje firmware OTA dla operatorów?",
    faqAnswerOtaFleet:
      "Aktualizacje firmware OTA to rozwiązanie dla operatorów zintegrowane z platformą Alcatraz. Wgraj wersję, zdefiniuj grupy docelowych urządzeń i ustaw procentowy cel etapowego wdrożenia — platforma kieruje pobieranie przez najbliższy węzeł pamięci i śledzi status instalacji na każdym urządzeniu. W dowolnym momencie możesz wstrzymać, rozszerzyć lub wycofać wdrożenie, a krytyczne aktualizacje oznaczyć jako obowiązkowe, aby urządzenia nie mogły ich pominąć.",
    faqQuestionAlcatraz: "Czym jest Alcatraz™ DMS?",
    faqAnswerAlcatraz:
      "Alcatraz™ DMS to platforma inext do zdalnego zarządzania flotą. Operatorzy używają Fleet Health do ustalania priorytetów problemów, przeglądają aktywność urządzeń, wdrażają firmware OTA, uruchamiają diagnostykę i zarządzają ustawieniami z jednej konsoli. Alcatraz Pro jest dostępny bez dodatkowych opłat dla flot liczących mniej niż 500 aktywnych urządzeń. Dla flot liczących co najmniej 500 aktywnych urządzeń dostęp i warunki komercyjne są uzgadniane bezpośrednio z inext.",
    faqQuestionAlcatrazModels: "Które modele obsługują Alcatraz™ DMS?",
    faqAnswerAlcatrazModels:
      "Wszystkie cztery aktualne modele inext — TV5, TV5 Ultra, TV6 i TV6 Ultra — są dostarczane z obsługą Alcatraz™ DMS.",
    faqQuestionTr069: "Czy TR-069 jest obsługiwany?",
    faqAnswerTr069:
      "Tak. Wszystkie aktualne modele obsługują TR-069/CWMP obok Alcatraz, więc operatorzy z istniejącym ACS mogą go dalej używać. Alcatraz dodaje bogatszą telemetrię, powiadomienia push, zdalne sterowanie w aplikacji i nowoczesne REST API.",
    faqQuestionBlackScreen: "Moje urządzenie pokazuje czarny ekran. Co zrobić?",
    faqAnswerBlackScreen:
      "Najpierw wykonaj prosty restart: odłącz inext od zasilania, odczekaj 30 sekund i podłącz ponownie. Jeśli to nie pomoże, skontaktuj się z naszym centrum serwisowym.",
    faqQuestionWifi: "Urządzenie nie łączy się z Wi-Fi. Co zrobić?",
    faqAnswerWifi:
      "Upewnij się, że jesteś w zasięgu routera i wpisujesz poprawne hasło. Jeśli to nie pomoże: (1) zrestartuj urządzenie i router, (2) zapomnij sieć i połącz się ponownie, (3) sprawdź, czy router nadaje w paśmie obsługiwanym przez urządzenie (2,4 GHz lub 5 GHz). Jeśli problem pozostaje, skontaktuj się z centrum serwisowym.",
    faqQuestionBlocked: "Urządzenie informuje, że zostało zablokowane. Co zrobić?",
    faqAnswerBlocked:
      "Najpierw skontaktuj się ze swoim dostawcą internetu (ISP). Jeśli ISP nie może pomóc, wyślij do nas wiadomość przez formularz kontaktowy powyżej.",
    faqContactTitle: "Masz jeszcze pytanie?",
    faqContactBody:
      "Nasz zespół wsparcia i partnerzy serwisowi pomogą w sprawach urządzeń, firmware, aplikacji IPTV, personalizacji, provisioningu i integracji Alcatraz™ DMS.",
    faqContactCta: "Skontaktuj się ze wsparciem",
    faqSearchPlaceholder: "Szukaj pytań...",
    faqSearchClear: "Wyczyść wyszukiwanie",
    faqNoResultsTitle: "Brak wyników",
    faqNoResultsWithQuery:
      "Nic nie pasuje do „{query}”. Spróbuj innych słów kluczowych albo wyczyść wyszukiwanie.",
    faqNoResultsCategory: "W tej kategorii nie ma jeszcze pytań.",
    searchTitle: "Wyszukiwarka inext",
    searchDescription:
      "Przeszukuj witrynę inext, strony produktów, sekcję wsparcia i artykuły na blogu.",
    searchEyebrow: "Wyszukiwarka",
    searchHeading: "Szukaj na stronie inext",
    searchIntro:
      "Znajdź informacje o produktach, odpowiedzi na pytania techniczne, dane dystrybutorów, informacje prawne i artykuły na blogu.",
    searchPlaceholder: "Szukaj produktów, wsparcia, bloga...",
    searchClear: "Wyczyść wyszukiwanie",
    searchLoading: "Ładowanie indeksu wyszukiwania...",
    searchErrorTitle: "Wyszukiwarka jest chwilowo niedostępna",
    searchErrorBody:
      "Nie udało się załadować indeksu wyszukiwania. Odśwież stronę albo spróbuj później.",
    searchNoQueryTitle: "Zacznij od słowa kluczowego",
    searchNoQueryBody:
      "Szukaj według nazwy modelu, funkcji, dystrybutora, tematu wsparcia albo słowa z artykułu.",
    searchNoResultsTitle: "Brak wyników",
    searchNoResultsBody:
      "Nic nie pasuje do „{query}”. Spróbuj krótszej frazy albo innego słowa kluczowego.",
    searchResultsCount: "{count} wyników dla „{query}”",
    searchTypePage: "Strona",
    searchTypeProduct: "Produkt",
    searchTypeBlog: "Blog",
    searchTypeSupport: "Wsparcie",
    searchTypeLegal: "Prawne",
    searchTypeApp: "Aplikacja",
    blogTitle: "inext insights",
    blogDescription:
      "Wydarzenia, nowości produktowe i informacje techniczne dla operatorów IPTV i OTT.",
    blogReadMore: "Czytaj artykuł",
    blogEmpty: "Dla tego rynku nie opublikowano jeszcze artykułów.",
    blogFeatured: "Najnowsze",
    blogFilterAll: "Wszystkie",
    blogTagEvents: "Wydarzenia",
    blogTagPartnerships: "Partnerstwa",
    blogTagProducts: "Produkty",
    blogTagSoftware: "Oprogramowanie",
    blogTagCompany: "Firma",
    blogLoadMore: "Pokaż więcej",
    blogBackToTop: "Wróć na górę",
    blogNewerPost: "Nowszy artykuł",
    blogOlderPost: "Starszy artykuł",
    blogMediaAudio: "Zawiera audio",
    blogMediaVideo: "Zawiera wideo",
    newsletterEyebrow: "Aktualności inext",
    newsletterTitle:
      "Nowości produktowe, aktualizacje firmware i praktyczne materiały dla operatorów.",
    newsletterDescription:
      "Otrzymuj informacje o nowych produktach, wydaniach firmware i aktualizacjach Alcatraz DMS oraz praktyczne materiały dla operatorów telewizyjnych.",
    newsletterSeoTitle: "Newsletter inext — nowości produktowe i aktualizacje firmware",
    newsletterSeoDescription:
      "Zapisz się, aby otrzymywać informacje o nowych produktach inext, wydaniach firmware, aktualizacjach Alcatraz DMS i praktyczne materiały dla operatorów telewizyjnych.",
    newsletterPageBenefitProducts: "Nowe dekodery i akcesoria",
    newsletterPageBenefitFirmware: "Nowe wersje firmware i aktualizacje Alcatraz DMS",
    newsletterPageBenefitInsights: "Praktyczne materiały dla operatorów telewizyjnych",
    newsletterPageFormTitle: "Zapisz się do newslettera inext",
    newsletterPageReassurance: "Tylko istotne wiadomości. Możesz zrezygnować w każdej chwili.",
    newsletterEmailLabel: "Adres e-mail",
    newsletterEmailPlaceholder: "imie@firma.pl",
    newsletterSubmit: "Zapisz się",
    newsletterSubmitting: "Zapisujemy…",
    newsletterSuccessTitle: "Subskrypcja aktywna",
    newsletterSuccessBody:
      "Od teraz będziesz otrzymywać nowości produktowe i aktualizacje od inext.",
    newsletterError: "Nie udało się zapisać do newslettera. Spróbuj ponownie.",
    newsletterPrivacyPrefix:
      "Zapisując się, wyrażasz zgodę na otrzymywanie nowości produktowych i aktualizacji od inext. Przeczytaj naszą",
    newsletterPrivacyLink: "politykę prywatności",
    newsletterWebsiteLabel: "Pozostaw to pole puste",
    newsEyebrow: "Aktualności",
    newsTitle: "Co nowego w",
    newsTitleAccent: "inext",
    newsDescription: "Premiery produktów, partnerstwa i notatki z wdrożeń u operatorów.",
    newsViewAll: "Zobacz wszystkie artykuły",
    notFoundTitle: "Nie znaleziono strony",
    notFoundBody: "Strona, której szukasz, nie istnieje albo została przeniesiona.",
    goHome: "Przejdź na stronę główną",
    errorTitle: "Ta strona się nie załadowała",
    errorBody:
      "Po naszej stronie coś poszło nie tak. Możesz odświeżyć stronę albo wrócić na stronę główną.",
    tryAgain: "Spróbuj ponownie",
    compareAllModels: "Porównaj wszystkie 4 modele",
    compareTierFlagship: "Flagowy",
    compareTierPerformance: "Wydajny",
    compareTierStandard: "Standard",
    compareTierEssential: "Podstawowy",
    compareGroupPerformance: "Wydajność",
    compareGroupConnectivity: "Łączność",
    compareGroupManagement: "Zarządzanie",
    compareGroupPhysical: "Parametry fizyczne",
    compareGroupInBox: "W zestawie",
    compareRowOs: "System operacyjny",
    compareRowChipset: "Chipset",
    compareRowCpu: "CPU",
    compareRowGpu: "GPU",
    compareRowRam: "RAM",
    compareRowStorage: "Pamięć",
    compareRowMaxRes: "Maks. rozdzielczość",
    compareRowCodecs: "Kodeki wideo",
    compareRowHdmi: "HDMI",
    compareRowEthernet: "Ethernet",
    compareRowWifi: "Wi-Fi",
    compareRowBluetooth: "Bluetooth",
    compareRowUsb: "USB",
    compareRowCardReader: "Czytnik kart",
    compareRowAvOutput: "Wyjście AV / audio",
    compareRowRemote: "Pilot",
    compareRowAlcatraz: "Alcatraz DMS",
    compareRowTr069: "TR-069",
    compareRowDimensions: "Wymiary",
    compareRowPower: "Zasilanie",
    compareRowRemoteInBox: "Pilot",
    compareRowHdmiCable: "Kabel HDMI",
    compareRowPowerAdapter: "Zasilacz",
    compareRowBatteries: "Baterie",
    compareRowGuide: "Skrócona instrukcja",
    compareViewSpecs: "Zobacz specyfikację",
    compareCtaTitle: "Potrzebujesz pomocy w wyborze modelu?",
    compareCtaBody:
      "Opowiedz nam o swojej sieci, profilu abonentów i docelowej cenie. Dobierzemy urządzenie inext do Twojego wdrożenia.",
    compareIncluded: "W zestawie",
    compareNotIncluded: "Brak",
    compareModelTv6UltraTagline: "Flagowy dekoder z Androidem 12 do wymagających wdrożeń 4K.",
    compareModelTv6UltraSpecRemote: "Pilot głosowy BT",
    compareModelTv6UltraHighlight1: "Najwięcej RAM i pamięci w ofercie",
    compareModelTv6UltraHighlight2: "Głosowy pilot Bluetooth 5.0",
    compareModelTv6UltraHighlight3: "Alcatraz™ DMS + TR-069",
    compareModelTv6Tagline: "Uniwersalny model z Androidem 12 do usług IPTV i OTT.",
    compareModelTv6SpecRemote: "Pilot IR",
    compareModelTv6Highlight1: "Ta sama platforma H618 co w TV6 Ultra",
    compareModelTv6Highlight2: "Android 12 AOSP",
    compareModelTv6Highlight3: "Alcatraz™ DMS + TR-069",
    compareModelTv5UltraTagline: "Sprawdzony model z Androidem 10 i 2 GB RAM.",
    compareModelTv5UltraSpecRemote: "Pilot IR",
    compareModelTv5UltraHighlight1: "Sprawdzona platforma H313",
    compareModelTv5UltraHighlight2: "Alcatraz™ DMS + TR-069",
    compareModelTv5UltraHighlight3: "Wyjście RCA AV dla starszych telewizorów",
    compareModelTv5Tagline:
      "Podstawowy dekoder z Androidem 10 do projektów z ograniczonym budżetem.",
    compareModelTv5SpecRemote: "Pilot IR",
    compareModelTv5Highlight1: "Najbardziej ekonomiczny model w ofercie",
    compareModelTv5Highlight2: "Alcatraz™ DMS + TR-069",
    compareModelTv5Highlight3: "Sprzętowe dekodowanie 4K@60",
    compareRemoteBtVoice: "Głosowy BT",
    compareRemoteIr: "IR",
    productPhotoComingSoon: "Zdjęcie produktu w przygotowaniu",
    productHardwarePhotoComingSoon: "Zdjęcie sprzętu w przygotowaniu",
    productSoftwarePhotoComingSoon: "Zdjęcie środowiska programowego w przygotowaniu",
    productSoftwareLifestyleImageAlt:
      "Telewizor z neutralnym launcherem operatora: Live TV, VOD, catch-up, radio, aplikacje i ustawienia",
    tv6HeroImageAlt:
      "inext TV6 na stoliku w salonie; na ekranie TV inext TV, MEGOGO, sweet.tv, IPTV, Plex, VLC i Spotify",
    tv6PortsImageAlt:
      "Tylne porty inext TV6: microSD, 2× USB, zależnie od wariantu port przedłużacza IR lub AV, S/PDIF, Ethernet, HDMI, DC 5V",
    tv6RemoteImageAlt:
      "Pilot IR inext TV6 z pełną klawiaturą numeryczną, panelem nawigacji i przyciskami odtwarzania",
    tv6HardwareRevealLabel: "Pokaż wewnętrzny sprzęt TV6",
    tv6HardwareRevealImageAlt:
      "Widok inext TV6 z góry z interaktywnym odsłonięciem wewnętrznego sprzętu",
    tv6UltraHeroImageAlt:
      "inext TV6 Ultra na konsoli w salonie; na ekranie TV inext TV, MEGOGO, sweet.tv, IPTV, Plex, VLC i Spotify",
    tv6UltraPortsImageAlt:
      "Tylne porty inext TV6 Ultra: microSD, 2× USB, AV, S/PDIF, Ethernet, HDMI, DC 5V",
    tv5PortsImageAlt:
      "Tylne porty inext TV5: AV, optyczny S/PDIF, Ethernet, HDMI, zasilanie DC, 2× USB, microSD",
    tv5RemoteImageAlt: "Pilot inext TV5 z przyciskiem OK, klawiszami numerycznymi i skrótami",
    tv5HardwareRevealLabel: "Pokaż wewnętrzny sprzęt TV5",
    tv5HardwareRevealImageAlt:
      "Widok inext TV5 z góry z interaktywnym odsłonięciem wewnętrznego sprzętu",
    tv5SoftwareImageAlt: "Telewizor z konfigurowalnym launcherem IPTV nad dekoderem inext TV5",
    tv6UltraRemoteImageAlt:
      "Głosowy pilot Bluetooth inext z mikrofonem, programowalnym przyciskiem zasilania TV i przyciskami FAV",
    tv6UltraHardwareRevealLabel: "Pokaż wewnętrzny sprzęt TV6 Ultra",
    tv6UltraHardwareRevealImageAlt:
      "Widok inext TV6 Ultra z góry z interaktywnym odsłonięciem wewnętrznego sprzętu",
    tv5UltraSeoTitle: "inext TV5 Ultra — dekoder z Androidem 10 dla operatorów",
    tv5UltraSeoDescription:
      "inext TV5 Ultra: Allwinner H313, 2 GB RAM, 16 GB eMMC, odtwarzanie 4K@60, dwuzakresowe Wi-Fi, Android 10 AOSP i Alcatraz™ DMS dla wdrożeń operatorskich.",
    tv5SeoTitle: "inext TV5 — podstawowy dekoder z Androidem 10 dla operatorów",
    tv5SeoDescription:
      "inext TV5: Allwinner H313, 1 GB RAM, 8 GB eMMC, odtwarzanie 4K@60, dwuzakresowe Wi-Fi, Android 10 AOSP i Alcatraz™ DMS dla ekonomicznych wdrożeń IPTV oraz OTT.",
    tv5UltraHeroEyebrow: "Standard · dekoder z Androidem 10",
    tv5UltraHeroHeadline: "Sprawdzony dekoder z Androidem do stabilnych wdrożeń operatorskich.",
    tv5UltraHeroSub:
      "TV5 Ultra łączy niezawodną platformę Allwinner H313 z 2 GB RAM, 16 GB pamięci, praktyczną łącznością i wsparciem inext Alcatraz™ DMS.",
    tv5UltraHeroImageAlt:
      "inext TV5 Ultra na szafce RTV pod telewizorem z uruchomionym launcherem inext",
    tv5UltraHardwareRevealLabel: "Pokaż wewnętrzny sprzęt TV5 Ultra",
    tv5UltraHardwareRevealImageAlt:
      "Widok inext TV5 Ultra z góry z interaktywnym odsłonięciem wewnętrznego sprzętu",
    tv5UltraSoftwareImageAlt:
      "Telewizor z konfigurowalnym launcherem operatora nad dekoderem inext TV5 Ultra",
    tv5UltraCompareLabel: "Porównaj wszystkie modele",
    tv5UltraGlanceValue1: "4K @ 60 Hz",
    tv5UltraGlanceLabel1: "Odtwarzanie H.265",
    tv5UltraGlanceValue2: "Android 10",
    tv5UltraGlanceLabel2: "AOSP, gotowy na aplikacje",
    tv5UltraGlanceValue3: "2 GB / 16 GB",
    tv5UltraGlanceLabel3: "DDR3 + eMMC",
    tv5UltraGlanceValue4: "Pilot IR",
    tv5UltraGlanceLabel4: "Prosta obsługa",
    tv5UltraIntroPara1:
      "TV5 Ultra powstał dla operatorów, którzy potrzebują stabilnego dekodera z Androidem 10 i pamięcią wystarczającą do codziennego korzystania z IPTV, OTT oraz launchera.",
    tv5UltraIntroPara2:
      "To praktyczne rozwiązanie: sprawdzony sprzęt, znane sterowanie IR, szerokie wsparcie mediów i zdalne zarządzanie przez Alcatraz™ DMS.",
    tv5UltraPerformanceTitle: "Sprawdzone 4K z zapasem mocy.",
    tv5UltraPerformanceBody:
      "Allwinner H313 z Mali-G31 MP2 zapewnia płynne odtwarzanie 4K@60 H.265 w usługach IPTV i OTT oraz sprawną obsługę launchera. 2 GB RAM i 16 GB eMMC wystarczają do typowych wdrożeń operatorskich.",
    tv5UltraPerformanceAccent: "Allwinner H313 · 2 GB DDR3 · 16 GB eMMC · 4K@60 H.265",
    tv5UltraConnectivityCaption:
      "HDMI 2.0a · Ethernet 100 Mb · 2× USB 2.0 · microSD · optyczne S/PDIF · wyjście RCA AV · dwuzakresowe Wi-Fi 2,4/5 GHz.",
    tv5UltraPortsImageAlt:
      "Tylne porty inext TV5 Ultra — optyczne S/PDIF, LAN, HDMI, USB i microSD",
    tv5UltraSoftwareTitle: "Android 10 przystosowany do aplikacji operatorskich.",
    tv5UltraSoftwareBody:
      "Android 10 AOSP zapewnia operatorom sprawdzoną platformę dla aplikacji i własnego launchera, a także zdalne zarządzanie flotą przez Alcatraz™ DMS oraz TR-069.",
    tv5UltraRemoteFeature1: "Pełna klawiatura numeryczna do szybkiego wybierania kanałów IPTV",
    tv5UltraRemoteFeature2: "Dedykowane przyciski nawigacji i odtwarzania",
    tv5UltraRemoteFeature3: "Sterowanie IR dla prostej konfiguracji u abonenta",
    tv5UltraAlcatrazBody:
      "TV5 Ultra można provisionować, monitorować i aktualizować przez te same procesy zarządzania urządzeniami Alcatraz, które działają w całej linii inext.",
    tv5UltraCtaTitle: "Zamów TV5 Ultra dla swojej sieci",
    tv5UltraCtaBody:
      "Praktyczny dekoder z Androidem 10, 2 GB RAM i 16 GB pamięci, dostępny z opakowaniem pod marką operatora i provisioningiem w Alcatraz™.",
    tv5HeroEyebrow: "Podstawowy · dekoder z Androidem 10",
    tv5HeroHeadline: "Ekonomiczny dekoder z Androidem do podstawowych wdrożeń IPTV.",
    tv5HeroSub:
      "TV5 oferuje ekosystem inext w przystępnej cenie: Android 10, odtwarzanie 4K na platformie H313, 1 GB RAM, 8 GB pamięci i obsługę Alcatraz™ DMS.",
    tv5CompareLabel: "Porównaj wszystkie modele",
    tv5GlanceValue1: "4K @ 60 Hz",
    tv5GlanceLabel1: "Odtwarzanie H.265",
    tv5GlanceValue2: "Android 10",
    tv5GlanceLabel2: "AOSP, gotowy na aplikacje",
    tv5GlanceValue3: "1 GB / 8 GB",
    tv5GlanceLabel3: "DDR3 + eMMC",
    tv5GlanceValue4: "Pilot IR",
    tv5GlanceLabel4: "Prosta obsługa",
    tv5IntroPara1:
      "TV5 to podstawowy model w operatorskiej ofercie inext: kompaktowy dekoder z Androidem 10 AOSP i łącznością potrzebną do zarządzanych usług IPTV oraz OTT.",
    tv5IntroPara2:
      "Zaprojektowano go dla wdrożeń, w których najważniejsze są niski koszt urządzenia, przewidywalne odtwarzanie i kontrola floty.",
    tv5PerformanceTitle: "Niezawodne 4K w rozsądnym budżecie.",
    tv5PerformanceBody:
      "Allwinner H313 z Mali-G31 MP2 zapewnia płynne odtwarzanie 4K@60 H.265 w podstawowych usługach IPTV i OTT, a 1 GB RAM oraz 8 GB eMMC sprawdzają się w projektach z ograniczonym budżetem.",
    tv5PerformanceAccent: "Allwinner H313 · 1 GB DDR3 · 8 GB eMMC · 4K@60 H.265",
    tv5ConnectivityCaption:
      "HDMI 2.0a · Ethernet 100 Mb · 2× USB 2.0 · microSD · optyczne S/PDIF · wyjście RCA AV · dwuzakresowe Wi-Fi 2,4/5 GHz.",
    tv5SoftwareTitle: "Android 10 dla podstawowych usług.",
    tv5SoftwareBody:
      "TV5 obsługuje launchery operatora, aplikacje IPTV i OTT, lokalizację oraz zdalną kontrolę floty przez Alcatraz™ DMS i TR-069.",
    tv5RemoteFeature1: "Klawiatura numeryczna do nawigacji po kanałach",
    tv5RemoteFeature2: "Dedykowane przyciski odtwarzania i menu",
    tv5RemoteFeature3: "Prosta konfiguracja IR w domach abonentów",
    tv5AlcatrazBody:
      "TV5 można provisionować, monitorować i aktualizować przez Alcatraz™ DMS, dzięki czemu nawet duże, ekonomiczne wdrożenia pozostają łatwe w zarządzaniu.",
    tv5CtaTitle: "Zamów TV5 dla swojej sieci",
    tv5CtaBody:
      "Ekonomiczny dekoder z Androidem, opakowaniem pod marką operatora i provisioningiem w Alcatraz™ — do podstawowych wdrożeń IPTV oraz OTT.",
    tv6SeoTitle: "inext TV6 — dekoder 4K z Androidem 12 dla operatorów",
    tv6SeoDescription:
      "inext TV6: Allwinner H618, 2 GB RAM, 16 GB eMMC, 4K@60 HDR, dwuzakresowe Wi-Fi, Android 12 AOSP i Alcatraz™ DMS. Kompaktowy STB dla ISP, hoteli i operatorów OTT.",
    tv6UltraSpec3dValue: "Obraz obok obrazu · pakowanie ramek",
    tv6UltraSpecMaxResValue: "4K UHD (2160p) @ 60 kl./s",
    tv6PackageRemote: "Pilot IR",
    packageNote:
      "Zawartość zestawu może różnić się w zależności od rynku, dostawy i konfiguracji operatora.",
    tv6HeroEyebrow: "Wydajny · dekoder 4K z Androidem 12",
    tv6HeroHeadline: "Kompaktowy dekoder do usług IPTV i OTT.",
    tv6HeroSub:
      "Praktyczny dekoder z Androidem 12 do wdrożeń operatorskich wymagających płynnego odtwarzania 4K, sprawdzonej łączności i zarządzania przez Alcatraz™ DMS — bez dopłacania za pamięć modelu flagowego.",
    tv6CompareLabel: "Porównaj z TV6 Ultra",
    tv6GlanceValue1: "4K @ 60 Hz",
    tv6GlanceLabel1: "HDR · H.265",
    tv6GlanceValue2: "Android 12",
    tv6GlanceLabel2: "AOSP, gotowy na aplikacje",
    tv6GlanceValue3: "2 GB / 16 GB",
    tv6GlanceLabel3: "DDR3 + eMMC",
    tv6GlanceValue4: "Pilot IR",
    tv6GlanceLabel4: "Prosta obsługa",
    tv6IntroPara1:
      "TV6 łączy najważniejsze cechy operatorskiej platformy inext w kompaktowym i ekonomicznym urządzeniu: obsługę wideo 4K, Android 12 AOSP, praktyczną łączność oraz zdalne zarządzanie flotą.",
    tv6IntroPara2:
      "Zaprojektowano go do wdrożeń, w których liczą się przewidywalna obsługa po stronie abonenta, łatwy provisioning i długoterminowe wsparcie, a nie maksymalna ilość pamięci.",
    tv6PerformanceAccent: "Allwinner H618 · 2 GB DDR3 · 16 GB eMMC · 4K@60 H.265",
    tv6ConnectivityCaption:
      "HDMI 2.0a · Ethernet 100 Mb · 2× USB 2.0 · microSD · optyczne S/PDIF · dedykowany port przedłużacza IR lub port AV, zależnie od wariantu TV6 · dwuzakresowe Wi-Fi 2,4/5 GHz · Bluetooth 5.0.",
    tv6RemoteEyebrow: "Pilot",
    tv6RemoteTitle: "Proste sterowanie IR do codziennego oglądania.",
    tv6RemoteBody:
      "Dołączony pilot IR zapewnia intuicyjną obsługę telewizji: ma klawiaturę numeryczną, przyciski nawigacyjne, sterowanie odtwarzaniem i szybki dostęp do funkcji potrzebnych abonentom IPTV.",
    tv5RemoteTitle: "Klasyczny pilot w zestawie.",
    tv5RemoteBody:
      "TV5 jest dostarczany z klasycznym pilotem IR wyposażonym w klawiaturę numeryczną, blok nawigacyjny i przyciski odtwarzania, dzięki czemu obsługa jest intuicyjna od pierwszego uruchomienia.",
    tv5UltraRemoteTitle: "Klasyczny pilot IR w każdym pudełku.",
    tv5UltraRemoteBody:
      "TV5 Ultra zawiera ten sam niezawodny pilot IR: z pełną klawiaturą numeryczną, blokiem nawigacyjnym i przyciskami odtwarzania, gotowy do użycia od razu po wyjęciu z pudełka.",
    tv6PerformanceTitle: "Płynne 4K bez flagowej ceny.",
    tv6PerformanceBody:
      "Czterordzeniowy Allwinner H618 z Mali-G31 MP2 sprzętowo dekoduje H.265, VP9 Profile 2 i H.264, zapewniając płynne odtwarzanie 4K w popularnych usługach IPTV i OTT.",
    tv6SoftwareTitle: "Android 12 z przestrzenią na rozwój.",
    tv6SoftwareBody:
      "Otwarty Android 12 (AOSP) z Bluetooth, dwuzakresowym Wi-Fi i launcherem operatora — elastyczna baza dla aplikacji marki, usług OTT i prostych gier.",
    tv6RemoteFeature1: "Pełna klawiatura numeryczna dla usług opartych na kanałach",
    tv6RemoteFeature2: "Dedykowane przyciski nawigacji i odtwarzania",
    tv6RemoteFeature3:
      "Dedykowany port przedłużacza IR w obsługiwanych wariantach TV6; warianty z portem AV nie obsługują przedłużacza",
    tv6RemoteBtNoteTitle: "Pilot na zamówienie",
    tv6RemoteBtNoteBody:
      "Wbudowany moduł Bluetooth pozwala zamówić TV6 z dowolnym pilotem z naszej oferty — IR lub Bluetooth. W niektórych regionach standardowo trafia do niego pilot Bluetooth.",
    tv6RemoteBtNoteLink: "Zobacz dostępne piloty",
    tv5RemoteIrNoteTitle: "Pilot IR do wyboru",
    tv5RemoteIrNoteBody:
      "Dostarczany z klasycznym pilotem IR, ale możesz zamówić go z dowolnym pilotem IR z naszej oferty — w tym z modelami programowalnymi, które sterują dekoderem i telewizorem jednocześnie.",
    tv6IrAvPortLabel: "Port 3.5 mm",
    tv6IrAvPortSpec:
      "Zależnie od rynku: dedykowany port przedłużacza IR lub AV; warianty z portem AV nie są kompatybilne z przedłużaczem IR",
    tv6AlcatrazBody:
      "Każdy TV6 można provisionować, monitorować i aktualizować przez system zarządzania urządzeniami inext Alcatraz używany przez sieci operatorskie na całym świecie.",
    tv6CtaTitle: "Zamów TV6 dla swojej sieci",
    tv6CtaBody:
      "Ceny wolumenowe, opakowania pod marką operatora i provisioning w Alcatraz™ do praktycznych wdrożeń IPTV oraz OTT.",
    remoteAppMenuLabel: "Aplikacja inext Remote",
    remoteAppProductCallout: "Wolisz sterować z telefonu? Pobierz bezpłatną aplikację inext Remote",
    footerLinkRemoteApp: "Aplikacja pilota",
    remoteAppSeoTitle: "inext Remote — mobilna aplikacja pilota do inext STB",
    remoteAppSeoDescription:
      "Pobierz bezpłatną aplikację inext Remote na Androida i iOS. Steruj inext STB, przełączaj pokoje, wyszukuj głosem lub klawiaturą, wpisuj tekst, korzystaj z gamepada oraz jasnego lub ciemnego motywu.",
    remoteAppBreadcrumbApps: "Aplikacje",
    remoteAppHeroEyebrow: "Bezpłatna aplikacja do Twojego dekodera inext",
    remoteAppHeroTitle: "Twój pilot do telewizora — teraz w telefonie.",
    remoteAppHeroBody:
      "inext Remote zmienia Twój telefon w pełnoprawny pilot do dekodera inext: szybko wpisuj tekst, wyszukuj głosem, przełączaj się między pokojami, graj w gry, przesuwaj palcem, by nawigować, i wybierz jasny lub ciemny wygląd.",
    remoteAppAppleBadgeAlt: "Pobierz inext Remote z App Store",
    remoteAppGoogleBadgeAlt: "Pobierz inext Remote z Google Play",
    remoteAppHeroImageAlt: "Ekran sterowania aplikacji mobilnej inext Remote",
    remoteAppStatDownloadsValue: "500K+",
    remoteAppStatDownloadsLabel: "pobrań",
    remoteAppStatModesValue: "D-pad + gesty",
    remoteAppStatModesLabel: "tryby sterowania",
    remoteAppStatThemesValue: "Jasny + ciemny",
    remoteAppStatThemesLabel: "motywy",
    remoteAppFeaturesEyebrow: "Co oferuje aplikacja",
    remoteAppFeaturesTitle: "Wszystko, czego oczekujesz od nowoczesnego pilota.",
    remoteAppFeaturesBody:
      "Codzienne sterowanie TV masz zawsze pod ręką, a do tego to, czego nie potrafi zwykły pilot: wygodne pisanie, szybkie wyszukiwanie, wiele pokoi i proste gry.",
    remoteAppFeatureControlTitle: "Pilot, który po prostu działa",
    remoteAppFeatureControlBody:
      "Nawiguj, odtwarzaj, pauzuj i reguluj głośność — bezpośrednio z telefonu.",
    remoteAppFeatureRoomsTitle: "Przełączanie urządzeń i pokoi",
    remoteAppFeatureRoomsBody:
      "Przełączaj się między swoimi urządzeniami inext w kilka sekund, gdy w domu masz więcej niż jeden ekran.",
    remoteAppFeatureVoiceTitle: "Głos i szybkie wyszukiwanie",
    remoteAppFeatureVoiceBody:
      "Wyszukuj treści głosem albo klawiaturą telefonu szybciej niż zwykłym pilotem.",
    remoteAppFeatureKeyboardTitle: "Łatwe wpisywanie tekstu",
    remoteAppFeatureKeyboardBody:
      "Wpisuj loginy, zapytania i tekst w aplikacjach na klawiaturze telefonu zamiast klikać litera po literze.",
    remoteAppFeatureGamepadTitle: "Tryb gamepada",
    remoteAppFeatureGamepadBody:
      "Zmień telefon w prosty kontroler do gier i interaktywnych aplikacji na telewizorze.",
    remoteAppFeatureModesTitle: "D-pad albo gesty",
    remoteAppFeatureModesBody:
      "Używaj klasycznych przycisków kierunkowych albo przełącz się na gesty, gdy to szybsze.",
    remoteAppModesEyebrow: "Tryby sterowania",
    remoteAppModesTitle: "Pilot, klawiatura i gamepad w jednej aplikacji.",
    remoteAppModesBody:
      "Korzystaj z klasycznego układu D-pad, przełącz się na gesty, gdy chcesz szybciej przeglądać treści, otwórz klawiaturę do wyszukiwania albo obróć telefon i uruchom tryb gamepada.",
    remoteAppModeDpad: "Klasyczny D-pad",
    remoteAppModeSwipe: "Tryb gestów",
    remoteAppGamepadImageAlt: "Zrzut ekranu trybu gamepada w inext Remote",
    remoteAppVideoEyebrow: "Zobacz w akcji",
    remoteAppVideoTitle: "inext Remote w akcji.",
    remoteAppVideoBody:
      "Krótki przegląd wszystkiego, co potrafi aplikacja — pilot, klawiatura, głos, pokoje, gamepad i motywy.",
    remoteAppVideoIframeTitle: "Wideo demonstracyjne aplikacji inext Remote",
    remoteAppScreensEyebrow: "Zrzuty ekranu",
    remoteAppScreensTitle: "Wygodna obsługa każdego dnia.",
    remoteAppScreensBody:
      "Zobacz główny pilot, urządzenia, klawiaturę numeryczną, wpisywanie tekstu, gamepad i motywy aplikacji mobilnej.",
    remoteAppScreenshotAlt: "Zrzut ekranu aplikacji inext Remote",
    remoteAppThemesEyebrow: "Wygląd",
    remoteAppThemesTitle: "Wygodnie w jasnym i ciemnym pokoju.",
    remoteAppThemesBody:
      "Jasny motyw sprawdza się w ciągu dnia, a ciemny podczas wieczornego oglądania. Aplikacja może też dopasować się do ustawień telefonu.",
    remoteAppLightTheme: "Jasny motyw",
    remoteAppLightThemeBody: "Czytelne sterowanie do użycia w dzień i jasnych pomieszczeniach.",
    remoteAppDarkTheme: "Ciemny motyw",
    remoteAppDarkThemeBody: "Mniej blasku podczas wieczornego oglądania.",
    remoteAppCtaEyebrow: "Pobierz za darmo",
    remoteAppCtaTitle: "Zainstaluj inext Remote na telefonie.",
    remoteAppCtaBody:
      "Pobierz bezpłatną aplikację z Google Play lub App Store i w kilka sekund sparuj ją z dekoderem inext.",
    navSolutions: "Rozwiązania",
    navSolutionsAlcatraz: "Alcatraz DMS",
    navSolutionsAlcatrazDesc: "Proaktywne monitorowanie floty i zdalna obsługa",
    footerLinkAlcatrazDms: "Alcatraz DMS",
    operationsLearnMore: "Dowiedz się więcej o Alcatraz DMS",
    alcatrazBreadcrumbHome: "Strona główna",
    alcatrazBreadcrumbSolutions: "Rozwiązania",
    alcatrazBreadcrumbPage: "Alcatraz DMS",
    alcatrazSeoTitle: "inext Alcatraz DMS — zarządzanie urządzeniami dla operatorów IPTV",
    alcatrazSeoDescription:
      "Zarządzanie dekoderami inext w chmurze lub lokalnie, z Fleet Health, historią aktywności urządzeń, zdalną diagnostyką i kontrolowanymi aktualizacjami OTA.",
    alcatrazTrialSeoTitle: "Bezpłatny 3-miesięczny dostęp próbny do Alcatraz Pro | inext",
    alcatrazTrialSeoDescription:
      "Uzyskaj trzy miesiące bezpłatnego dostępu do Alcatraz Pro — z dekoderami inext w Twojej sieci lub z urządzeniem demo, które wyślemy.",
    alcatrazTrialBreadcrumb: "3 miesiące bezpłatnie",
    alcatrazTrialEyebrow: "Dla ISP i operatorów TV",
    alcatrazTrialTitle: "Wypróbuj Alcatraz Pro bezpłatnie przez 3 miesiące",
    alcatrazTrialIntro:
      "Sprawdź możliwości Alcatraz Pro na dekoderach inext już działających w Twojej sieci, albo na urządzeniu demo, które wyślemy. Nasz zespół pomoże rozpocząć pracę — bez karty płatniczej i długoterminowych zobowiązań.",
    alcatrazTrialBenefitFree: "Pełny dostęp do Alcatraz Pro przez trzy miesiące",
    alcatrazTrialBenefitExisting:
      "Wykorzystaj posiadane dekodery inext — albo otrzymaj od nas urządzenie demo",
    alcatrazTrialBenefitGuided: "Pomoc zespołu inext w konfiguracji",
    alcatrazTrialStepsTitle: "Jak to działa",
    alcatrazTrialStep1: "Wyślij zgłoszenie",
    alcatrazTrialStep2: "Zweryfikujemy dane firmy",
    alcatrazTrialStep3: "Skonfigurujemy dostęp i pomożemy zacząć",
    alcatrazTrialFeaturesLink: "Zobacz funkcje i opcje wdrożenia",
    alcatrazTrialDashboardAlt: "Panel zarządzania flotą Alcatraz Pro",
    alcatrazTrialFormTitle: "Zacznij 3 miesiące bezpłatnie",
    alcatrazTrialFormIntro:
      "Podaj, jak możemy się z Tobą skontaktować. Zweryfikujemy dane firmy i pomożemy rozpocząć.",
    alcatrazTrialDemoOption: "Chcę demo przed okresem próbnym",
    alcatrazTrialSampleOption: "Nie mam jeszcze dekoderów inext — chcę otrzymać urządzenie demo",
    alcatrazRequestNamePlaceholder: "Anna Kowalska",
    alcatrazRequestCompanyPlaceholder: "Acme Telecom",
    alcatrazRequestEmailPlaceholder: "anna@acme.com",
    alcatrazRequestPhonePlaceholder: "+48 22 123 45 67",
    alcatrazRequestNameError: "Wpisz imię i nazwisko.",
    alcatrazRequestCompanyError: "Wpisz nazwę firmy.",
    alcatrazRequestEmailError: "Wpisz prawidłowy służbowy adres e-mail.",
    alcatrazRequestPhoneError: "Wpisz numer telefonu.",
    alcatrazTrialEligibility:
      "Dla klientów biznesowych — ISP i operatorów TV. Nie masz jeszcze dekoderów inext? Przygotujemy dla Ciebie urządzenie demo. Dostęp próbny wymaga krótkiej weryfikacji danych firmy.",
    alcatrazTrialNoCardNote: "Bez karty płatniczej i długoterminowych zobowiązań.",
    alcatrazTrialSubmitting: "Wysyłanie...",
    alcatrazTrialSubmitTrial: "Poproś o 3 miesiące bezpłatnie",
    alcatrazTrialSubmitDemo: "Poproś o demo i 3 miesiące bezpłatnie",
    alcatrazTrialSuccessTitle: "Otrzymaliśmy Twoją prośbę",
    alcatrazTrialSuccessBody:
      "Dziękujemy. Zweryfikujemy dane firmy i skontaktujemy się, aby uruchomić bezpłatny trzymiesięczny dostęp do Alcatraz Pro.",
    alcatrazTrialDemoSuccessBody:
      "Dziękujemy. Zweryfikujemy dane firmy i skontaktujemy się, aby umówić demo przed uruchomieniem bezpłatnego trzymiesięcznego dostępu.",
    alcatrazTrialSampleSuccessNote: "Przygotujemy i wyślemy Ci również urządzenie demo.",
    alcatrazTrialSuccessTimeline: "Zazwyczaj odpowiadamy w ciągu jednego dnia roboczego.",
    alcatrazStartSeoTitle:
      "Alcatraz Pro dla flot liczących mniej niż 500 aktywnych urządzeń | inext",
    alcatrazStartSeoDescription:
      "Alcatraz Pro jest dostępny bez dodatkowych opłat dla flot inext liczących mniej niż 500 aktywnych urządzeń. Poproś o dostęp i urządzenie testowe, jeśli flota nie korzysta jeszcze z dekoderów inext.",
    alcatrazStartBreadcrumb: "Uzyskaj Alcatraz Pro",
    alcatrazStartEyebrow: "Dla ISP i operatorów TV",
    alcatrazStartTitle: "Alcatraz Pro jest w cenie Twoich dekoderów inext",
    alcatrazStartIntro:
      "Zarządzaj całą flotą z jednej konsoli: monitoring, firmware, diagnostyka i zdalne wsparcie. Alcatraz Pro jest dostępny bez dodatkowych opłat, dopóki flota liczy mniej niż 500 aktywnych urządzeń inext.",
    alcatrazStartBenefit1:
      "Bez dodatkowych opłat dla flot liczących mniej niż 500 aktywnych urządzeń",
    alcatrazStartBenefit2: "Pełna konsola Alcatraz Pro, a nie wersja okrojona",
    alcatrazStartBenefit3: "Pomoc zespołu inext w konfiguracji",
    alcatrazStartActiveTitle: "Co liczy się jako aktywne urządzenie",
    alcatrazStartActiveBody:
      "Dostęp jest określany na podstawie aktualnego zestawienia aktywnych urządzeń z ostatnich 30 dni. Urządzenia nadal w produkcji, w transporcie, w magazynie lub już wycofane nie wliczają się do progu 500 urządzeń.",
    alcatrazStartStepsTitle: "Jak to działa",
    alcatrazStartStep1: "Wyślij zgłoszenie",
    alcatrazStartStep2: "Zweryfikujemy dane firmy",
    alcatrazStartStep3: "Utworzymy konto i pomożemy zacząć",
    alcatrazStartFeaturesLink: "Poznaj funkcje i opcje wdrożenia",
    alcatrazStartDashboardAlt: "Konsola zarządzania flotą Alcatraz Pro",
    alcatrazStartFormTitle: "Zamów konto Alcatraz Pro",
    alcatrazStartFormIntro:
      "Podaj, jak możemy się z Tobą skontaktować. Zweryfikujemy dane firmy i pomożemy rozpocząć pracę.",
    alcatrazStartDemoOption: "Chcę demo przed rozpoczęciem",
    alcatrazStartSampleOption: "Nie mam jeszcze dekoderów inext — chcę otrzymać urządzenie demo",
    alcatrazStartEligibility:
      "Alcatraz Pro jest dostępny dla klientów biznesowych — ISP i operatorów TV — bez dodatkowych opłat dla flot liczących mniej niż 500 aktywnych urządzeń. W przypadku flot liczących co najmniej 500 aktywnych urządzeń skontaktuj się z działem sprzedaży, aby omówić dostęp i warunki komercyjne.",
    alcatrazStartSubmitting: "Wysyłanie...",
    alcatrazStartSubmit: "Uzyskaj Alcatraz Pro",
    alcatrazStartSubmitDemo: "Poproś o demo + Alcatraz Pro",
    alcatrazStartNoCardNote: "Bez karty płatniczej i długoterminowych zobowiązań.",
    alcatrazStartSuccessTitle: "Otrzymaliśmy Twoje zgłoszenie",
    alcatrazStartSuccessBody:
      "Dziękujemy. Zweryfikujemy dane firmy i skontaktujemy się, aby uruchomić Twoje konto Alcatraz Pro.",
    alcatrazStartDemoSuccessBody:
      "Dziękujemy. Zweryfikujemy dane firmy i skontaktujemy się, aby umówić demo przed uruchomieniem konta Alcatraz Pro.",
    alcatrazStartSampleSuccessNote: "Przygotujemy i wyślemy Ci również urządzenie demo.",
    alcatrazStartSuccessTimeline: "Zazwyczaj odpowiadamy w ciągu jednego dnia roboczego.",
    alcatrazHeroEyebrow: "System zarządzania urządzeniami",
    alcatrazHeroTitle: "inext Alcatraz DMS —",
    alcatrazHeroTitleAccent: "cała flota zawsze pod kontrolą",
    alcatrazHeroSub:
      "W chmurze jako SaaS lub w całości we własnej infrastrukturze. Monitoruj kondycję floty, przeglądaj historię urządzeń, wdrażaj aktualizacje i obsługuj każdy dekoder inext z jednej platformy.",
    alcatrazCtaStart: "Uzyskaj Alcatraz Pro",
    alcatrazHeroCtaDemo: "Umów prezentację",
    alcatrazHeroCtaSales: "Porozmawiaj z działem sprzedaży",
    alcatrazHeroImageCaption: "Alcatraz DMS — panel z przeglądem floty",
    alcatrazHeroStatNetworks: "Ponad 120 sieci operatorskich",
    alcatrazHeroStatDeploy: "Chmura lub własna infrastruktura",
    alcatrazHeroStatScale: "Skaluje się wraz z flotą",
    alcatrazDeploymentEyebrow: "Wdrożenie",
    alcatrazDeploymentTitle: "Dwa modele wdrożenia",
    alcatrazDeploymentDescription:
      "Wybierz model zgodny z polityką swojej sieci. W obu wariantach otrzymujesz te same funkcje, konsolę i warunki subskrypcji.",
    alcatrazDeploymentCloudTag: "Zalecane",
    alcatrazDeploymentCloudTitle: "Chmura (SaaS)",
    alcatrazDeploymentCloudBody:
      "Platformę hostuje i obsługuje inext. Szybkie uruchomienie, automatyczne aktualizacje oraz dostęp dla rozproszonych zespołów wsparcia niezależnie od regionu.",
    alcatrazDeploymentCloudBullet1: "Nie trzeba utrzymywać własnej infrastruktury",
    alcatrazDeploymentCloudBullet2: "Automatyczne aktualizacje platformy",
    alcatrazDeploymentCloudBullet3: "Dostępność z gwarancją SLA",
    alcatrazDeploymentOnpremTitle: "We własnej infrastrukturze",
    alcatrazDeploymentOnpremBody:
      "Platforma działa wewnątrz zamkniętej sieci operatora i zapewnia pełną kontrolę nad lokalizacją danych — to rozwiązanie dla organizacji o rygorystycznych wymaganiach regulacyjnych lub dotyczących bezpieczeństwa.",
    alcatrazDeploymentOnpremBullet1: "Wdrożenie we własnym centrum danych",
    alcatrazDeploymentOnpremBullet2: "Dane nie opuszczają sieci operatora",
    alcatrazDeploymentOnpremBullet3: "Działa za NAT i w sieciach zamkniętych",
    alcatrazPillarsEyebrow: "Możliwości platformy",
    alcatrazPillarsTitle: "Wszystko, czego potrzeba do zarządzania flotą dekoderów",
    alcatrazPillar1Title: "Fleet Health",
    alcatrazPillar1Body:
      "Ustalaj priorytety problemów ze słabym Wi-Fi i wysoką temperaturą, przeglądaj historię urządzeń oraz otrzymuj cotygodniowe raporty.",
    alcatrazPillar2Title: "Etapowe aktualizacje firmware OTA",
    alcatrazPillar2Body:
      "Wdrażaj firmware etapami, śledź wyniki, wykluczaj pojedyncze urządzenia i przechowuj komentarze przy każdej kompilacji lub wydaniu.",
    alcatrazPillar3Title: "Zdalne wsparcie i diagnostyka",
    alcatrazPillar3Body:
      "Zdalnie restartuj urządzenia i steruj nimi, uruchamiaj diagnostykę MTR lub iPerf3 oraz rozwiązuj problemy bez wizyty technika.",
    alcatrazPillar4Title: "Historia aktywności i audyt",
    alcatrazPillar4Body:
      "Przeglądaj polecenia, zmiany, prywatne notatki i zdarzenia OTA wraz z informacją o użytkowniku lub kluczu API na potrzeby audytu.",
    alcatrazPillar5Title: "Ochrona urządzeń",
    alcatrazPillar5Body:
      "Stosuj profile blokowania, App Lock i net-lock, aby chronić urządzenia wynajęte, zagubione lub wycofane z użytku.",
    alcatrazPillar6Title: "Komunikacja z abonentami",
    alcatrazPillar6Body:
      "Wysyłaj kierowane banery w launcherze, powiadomienia i kampanie z przyciskami CTA na ekranie telewizora.",
    alcatrazPillar7Title: "API i standardy branżowe",
    alcatrazPillar7Body:
      "Zarządzaj kluczami API z ograniczeniami dostępu i integruj systemy przez REST, MQTT lub istniejące procesy TR-069/CWMP.",
    alcatrazPillar8Title: "Organizacja floty",
    alcatrazPillar8Body:
      "Używaj zewnętrznych identyfikatorów i grup do wyszukiwania, filtrowania, eksportowania i zbiorczego zarządzania urządzeniami.",
    alcatrazFleetHealthEyebrow: "Fleet Health",
    alcatrazFleetHealthTitle: "Nadaj priorytet urządzeniom wymagającym uwagi",
    alcatrazFleetHealthBody:
      "Fleet Health analizuje telemetrię urządzeń i porządkuje wykryte problemy w przejrzystym widoku dla zespołów operacyjnych i wsparcia. Pulpit podsumowuje stan całej floty, a kolejka z filtrami zapewnia bezpośredni dostęp do każdego urządzenia z problemem i jego historii.",
    alcatrazFleetHealthBullet1: "Wykrywanie słabego Wi-Fi i wysokiej temperatury",
    alcatrazFleetHealthBullet2: "Filtrowanie i ustalanie priorytetów kolejki problemów",
    alcatrazFleetHealthBullet3: "Przeglądanie szczegółów i historii problemów każdego dekodera",
    alcatrazFleetHealthBullet4: "Cotygodniowe podsumowania stanu floty",
    alcatrazFleetHealthPlaceholder: "Pulpit Fleet Health i priorytetowa kolejka problemów",
    alcatrazFleetPreviewUpdated: "Zaktualizowano przed chwilą",
    alcatrazFleetPreviewLive: "Podgląd w czasie rzeczywistym",
    alcatrazFleetPreviewNeedsAttention: "Wymagają uwagi",
    alcatrazFleetPreviewCallFirst: "Kontakt w pierwszej kolejności",
    alcatrazFleetPreviewKeepWatch: "Do obserwacji",
    alcatrazFleetPreviewHealthy: "Sprawne",
    alcatrazFleetPreviewMonitored: "Monitorowane",
    alcatrazFleetPreviewIssueTypes: "Typy problemów",
    alcatrazFleetPreviewWeakWifi: "Słaby sygnał Wi-Fi",
    alcatrazFleetPreviewTemperature: "Temperatura",
    alcatrazFleetPreviewQueue: "Priorytetowa kolejka urządzeń",
    alcatrazFleetPreviewCriticalFirst: "Najpierw stany krytyczne",
    alcatrazFleetPreviewShown: "Wyświetlono {count}",
    alcatrazFleetPreviewHighTemperature: "Wysoka temperatura",
    alcatrazFleetPreviewWatch: "Obserwuj",
    alcatrazFleetPreviewAwaiting: "{count} problemów czeka na potwierdzenie",
    alcatrazPreviewMinutesAgo: "{minutes} min temu",
    alcatrazPreviewIllustrativeData: "Dane przykładowe",
    alcatrazFirmwareEyebrow: "Zarządzanie firmware",
    alcatrazFirmwareTitle: "Bezpieczne wdrożenia etapowe",
    alcatrazFirmwareBody:
      "Planuj wdrożenia firmware dla części floty, wymagaj potwierdzenia na urządzeniu i śledź statystyki w czasie rzeczywistym. Jednym przełącznikiem wyłączaj wybrane urządzenia z automatycznych aktualizacji albo uruchamiaj aktualizację ręcznie.",
    alcatrazFirmwareBullet1: "Etapowe wdrażanie firmware",
    alcatrazFirmwareBullet2: "Wyłączanie automatycznych aktualizacji dla wybranych urządzeń",
    alcatrazFirmwareBullet3: "Ręczne uruchamianie aktualizacji firmware",
    alcatrazFirmwareBullet4: "Potwierdzenie na urządzeniu i statystyki wdrożenia",
    alcatrazFirmwarePlaceholder: "Panel zarządzania wydaniem firmware",
    alcatrazFirmwareOtaLink: "Poznaj zarządzanie aktualizacjami OTA",
    alcatrazInspectorEyebrow: "Dane urządzenia",
    alcatrazInspectorTitle: "Bieżący stan i pełna historia w jednym widoku",
    alcatrazInspectorBody:
      "Otwórz dowolny dekoder, aby zobaczyć jego bieżący stan, a następnie prześledź zdarzenia, które do niego doprowadziły. Oś czasu aktywności obejmuje polecenia, zdarzenia aktywacji, zmiany urządzenia, prywatne notatki, kampanie, powiadomienia i zdarzenia OTA.",
    alcatrazActivityBullet1: "Gotowe widoki, filtry i osobny tryb audytu",
    alcatrazActivityBullet2:
      "Informacja o użytkowniku lub kluczu API przy każdej zapisanej czynności",
    alcatrazActivityBullet3: "Szczegółowe metryki OTA i historia poleceń",
    alcatrazInspectorPreviewOnline: "Online",
    alcatrazInspectorPreviewCurrentState: "Bieżący stan",
    alcatrazInspectorPreviewActivity: "Aktywność",
    alcatrazInspectorPreviewCondition: "Stan urządzenia",
    alcatrazInspectorPreviewLastChecked: "Sprawdzono {minutes} min temu",
    alcatrazInspectorPreviewAllEvents: "Wszystkie zdarzenia",
    alcatrazInspectorPreviewCommands: "Polecenia",
    alcatrazInspectorPreviewNewest: "Najnowsze najpierw",
    alcatrazInspectorPreviewToday: "Dzisiaj",
    alcatrazInspectorPreviewYesterday: "Wczoraj",
    alcatrazInspectorPreviewThisWeek: "W tym tygodniu",
    alcatrazInspectorPreviewLastWeek: "W zeszłym tygodniu",
    alcatrazInspectorPreviewEarlier: "Wcześniej",
    alcatrazInspectorPreviewSupportNote: "Notatka zespołu wsparcia: okresowe przerwy w odtwarzaniu",
    alcatrazInspectorPreviewFirmwareChange: "Firmware 1.8.51 → 1.9.1",
    alcatrazInspectorPreviewOtaCompleted: "Pobieranie OTA zakończone",
    alcatrazInspectorPreviewCommandBy: "Polecenie · Jan Kowalski",
    alcatrazInspectorPreviewPrivateNoteBy: "Prywatna notatka · Jan Kowalski",
    alcatrazInspectorPreviewDeviceChangeApi: "Zmiana urządzenia · klucz API · rollout-bot",
    alcatrazInspectorPreviewOtaMetrics: "Wersja 1.9.0 · 45,78 MB/s · 1 min 18 s",
    alcatrazInspectorPreviewWaiting: "Oczekuje na odpowiedź",
    alcatrazInspectorPreviewCompleted: "Zakończono",
    alcatrazInspectorPreviewFooter: "Polecenia, zmiany, notatki i zdarzenia OTA",
    alcatrazInspectorPreviewIllustrative: "Przykładowa historia",
    alcatrazInspectorPreviewAlt:
      "Poglądowy inspektor urządzenia Alcatraz pokazujący bieżący stan i historię aktywności.",
    alcatrazInspectorCardTitle: "Karta urządzenia",
    alcatrazInspectorLabelState: "Status",
    alcatrazInspectorValueState: "Online · 4 d 1 godz. 19 min",
    alcatrazInspectorLabelLastSeen: "Ostatnia aktywność",
    alcatrazInspectorValueLastSeen: "12 min temu",
    alcatrazInspectorLabelFirmware: "Firmware",
    alcatrazInspectorValueFirmware: "v1.8.14",
    alcatrazInspectorLabelTemps: "Temperatury",
    alcatrazInspectorValueTemps: "CPU 51,2° · GPU 52,5° · RAM 50,8° · VEE 53,4°",
    alcatrazInspectorLabelRam: "RAM",
    alcatrazInspectorValueRam: "Wolne: 383 MB z 4 GB",
    alcatrazInspectorLabelFlash: "Pamięć wewnętrzna",
    alcatrazInspectorValueFlash: "Wolne: 18,8 GB z 32 GB",
    alcatrazInspectorLabelTv: "Połączenie z telewizorem",
    alcatrazInspectorValueTv: "HDMI · 1920×1080 · 60 kl./s",
    alcatrazInspectorLabelNetwork: "Sieć",
    alcatrazInspectorValueNetwork: "Wi-Fi 5 GHz · RSSI −29 dBm (znakomity sygnał)",
    alcatrazInspectorLabelAndroid: "Android",
    alcatrazInspectorValueAndroid: "12",
    alcatrazInspectorLabelLocale: "Język i strefa czasowa",
    alcatrazInspectorValueLocale: "Angielski · Europe/Kyiv",
    alcatrazInspectorLabelApps: "Zainstalowane aplikacje",
    alcatrazInspectorValueApps: "Lista aplikacji i wersji",
    alcatrazRemoteEyebrow: "Zdalne sterowanie",
    alcatrazRemoteTitle: "Konsola poleceń dla operatora",
    alcatrazRemoteBody:
      "Zdalnie wykonuj działania, które zwykle wymagają wizyty technika — od ponownego uruchomienia po przywrócenie ustawień fabrycznych — bez fizycznego dostępu do dekodera.",
    alcatrazRemoteGroupControl: "Sterowanie",
    alcatrazRemoteGroupDiagnostics: "Diagnostyka",
    alcatrazRemoteGroupComms: "Powiadomienia",
    alcatrazRemoteGroupLifecycle: "Aktualizacje",
    alcatrazRemoteGroupLockdown: "Ograniczenia dostępu",
    alcatrazRemoteCmdReboot: "Uruchom ponownie",
    alcatrazRemoteCmdRemote: "Wirtualny pilot",
    alcatrazRemoteCmdScreenshot: "Wykonaj zrzut ekranu",
    alcatrazRemoteCmdSpeed: "Sprawdź prędkość (iPerf3)",
    mtrAlcatrazRemoteCmd: "Diagnostyka trasy MTR",
    alcatrazRemoteCmdPush: "Wyślij powiadomienie push",
    alcatrazRemoteCmdFirmware: "Wdróż firmware",
    alcatrazRemoteCmdExclude: "Wyłącz automatyczne aktualizacje",
    alcatrazRemoteCmdBlock: "Zablokuj urządzenie",
    alcatrazRemoteCmdFactory: "Przywróć ustawienia fabryczne",
    alcatrazRemoteWarning: "Działanie krytyczne",
    alcatrazRemoteHighlight1:
      "Rozwiązuj typowe problemy z poziomu NOC — bez wysyłania technika w teren.",
    alcatrazRemoteHighlight2:
      "Uruchamiaj polecenia na pojedynczym urządzeniu lub całej grupie jednym kliknięciem.",
    alcatrazRemoteHighlight3:
      "W dzienniku każdej czynności zapisane są urządzenie, czas oraz użytkownik lub klucz API, który ją zainicjował.",
    mtrAlcatrazEyebrow: "Diagnostyka MTR",
    mtrAlcatrazTitle: "Sprawdź trasę z dekodera abonenta",
    mtrAlcatrazBody:
      "Operator może uruchomić MTR (My Traceroute) z dekodera będącego online do dowolnego hosta docelowego. Zakończone wyniki MTR i iPerf3 pozostają w historii aktywności urządzenia, a test można powtórzyć z tymi samymi parametrami.",
    alcatrazAccessEyebrow: "Ochrona urządzeń",
    alcatrazAccessTitle: "Chroń dekodery za pomocą blokad i net-lock",
    alcatrazAccessBody:
      "Alcatraz DMS pomaga zabezpieczać wynajęte dekodery w razie zgubienia, kradzieży, zaległości w opłatach lub wycofania z użycia. Pojedynczy dekoder albo grupę można zablokować ręcznie, a funkcja net-lock automatycznie ogranicza działanie urządzeń poza zatwierdzonymi sieciami operatora.",
    alcatrazAccessFlowTitle: "Jak działa blokada",
    alcatrazAccessManualTitle: "Blokada ręczna",
    alcatrazAccessManualBody:
      "Blokuj jeden dekoder lub całą grupę w razie potrzeby. Stosuj tę funkcję przy zgubionym, skradzionym lub wycofanym sprzęcie oraz zaległościach w opłatach.",
    alcatrazAccessNetLockTitle: "Automatyczny net-lock",
    alcatrazAccessNetLockBody:
      "Automatycznie blokuj wynajęte dekodery poza zatwierdzonymi sieciami operatora. Zapobiega to używaniu urządzeń przez nieautoryzowane połączenia.",
    alcatrazAccessFlowOutcome: "Wybierz profil blokady",
    alcatrazAccessMockFooter: "Zarządzane przez Alcatraz DMS",
    alcatrazAccessMockNotice: "Czas powiadomienia",
    alcatrazAccessProfileHardTitle: "Twarda",
    alcatrazAccessProfileHardBody: "Wyłącza dekoder i powtarza blokadę po ponownym uruchomieniu.",
    alcatrazAccessModeHardBadge: "Twarda blokada",
    alcatrazAccessModeHardTitle: "Urządzenie jest zablokowane",
    alcatrazAccessModeHardBody:
      "Dekoder pokazuje komunikat operatora, a następnie wyłącza się. Blokada powtarza się po ponownym uruchomieniu.",
    alcatrazAccessModeHardStatus: "Wyłącza się po powiadomieniu",
    alcatrazAccessProfileSoftTitle: "Miękka",
    alcatrazAccessProfileSoftBody:
      "Pozostawia dekoder w użyciu i pokazuje przypomnienia co 30 minut.",
    alcatrazAccessModeSoftBadge: "Miękka blokada",
    alcatrazAccessModeSoftTitle: "Aktywne powiadomienie serwisowe",
    alcatrazAccessModeSoftBody:
      "Dekoder pozostaje dostępny, a przypomnienie operatora pojawia się zgodnie z harmonogramem.",
    alcatrazAccessModeSoftStatus: "Przypomnienie co 30 minut",
    alcatrazAccessProfileAppLockTitle: "Blokada aplikacji",
    alcatrazAccessProfileAppLockBody: "Ogranicza dekoder do jednej wybranej aplikacji.",
    alcatrazAccessModeAppLockBadge: "Blokada aplikacji",
    alcatrazAccessModeAppLockTitle: "Tylko zatwierdzona aplikacja",
    alcatrazAccessModeAppLockBody:
      "Dekoder otwiera tylko wybraną aplikację, dopóki operator nie zmieni profilu.",
    alcatrazAccessModeAppLockStatus: "Jedna aplikacja",
    alcatrazAccessModeAppAllowedApp: "IPTV",
    alcatrazAccessModeAppLockedLabel: "Zablokowane",
    alcatrazPushEyebrow: "Powiadomienia push",
    alcatrazPushTitle: "Komunikuj się z abonentami przez ekran telewizora",
    alcatrazPushBody:
      "Wysyłaj banery w launcherze i komunikaty ekranowe do dowolnego segmentu floty — z informacjami serwisowymi, rekomendacjami treści lub kampaniami promocyjnymi. Każda wiadomość może zawierać przycisk otwierający aplikację lub stronę.",
    alcatrazPushBullet1: "Banery w launcherze i komunikaty ekranowe",
    alcatrazPushBullet2: "Dobór odbiorców według grupy urządzeń, modelu lub regionu",
    alcatrazPushBullet3: "Przyciski z bezpośrednim przejściem do aplikacji",
    alcatrazPushBullet4: "Wyświetlenia, kliknięcia i CTR dla każdej wiadomości",
    alcatrazPushPlaceholder: "Kreator powiadomień push",
    alcatrazApiEyebrow: "Bezpieczne integracje · REST API",
    alcatrazApiTitle: "Połącz Alcatraz z używanymi systemami",
    alcatrazApiBody:
      "Twórz i unieważniaj klucze API w konsoli, w razie potrzeby ograniczaj uprawnienia i dozwolone adresy IP, ustawiaj okres ważności oraz bezpiecznie kopiuj sekret tylko podczas tworzenia klucza. Zewnętrzne identyfikatory łączą rekordy urządzeń Alcatraz z abonentem, CRM, systemem rozliczeniowym lub gospodarstwem domowym bez zmiany istniejących procesów.",
    alcatrazApiBullet1:
      "Samodzielnie zarządzane klucze API z konfigurowalnymi ograniczeniami dostępu",
    alcatrazApiBullet2: "Zewnętrzne ID urządzeń do wyszukiwania, filtrowania i eksportu",
    alcatrazApiBullet3: "TR-069 / CWMP i MQTT wraz z REST API",
    alcatrazApiPlaceholder: "Dokumentacja API",
    alcatrazPricingEyebrow: "Cennik",
    alcatrazPricingTitle:
      "Bez dodatkowych opłat dla flot liczących mniej niż 500 aktywnych urządzeń",
    alcatrazPricingBody:
      "Partnerzy otrzymują dostęp do pełnej konsoli Alcatraz Pro bez dodatkowych opłat, dopóki flota liczy mniej niż 500 aktywnych urządzeń inext. Dla flot liczących co najmniej 500 aktywnych urządzeń dostęp i warunki komercyjne są uzgadniane bezpośrednio z inext.",
    alcatrazPricingIncludedTitle: "Bez dodatkowych opłat · Mniej niż 500 aktywnych urządzeń",
    alcatrazPricingIncludedBody:
      "Fleet Health, zarządzanie firmware, diagnostyka, zdalne wsparcie i bezpieczne integracje są dostępne bez dodatkowych opłat, gdy aktualne zestawienie aktywnych urządzeń z ostatnich 30 dni wskazuje mniej niż 500 aktywnych urządzeń.",
    alcatrazPricingModelTitle: "Co najmniej 500 aktywnych urządzeń",
    alcatrazPricingModelBody:
      "Skontaktuj się z działem sprzedaży inext, aby omówić dostęp i warunki komercyjne dla danego wdrożenia.",
    alcatrazPricingActiveTitle: "Co liczy się jako aktywne urządzenie",
    alcatrazPricingActiveBody:
      "Dostęp jest określany na podstawie aktualnego zestawienia aktywnych urządzeń z ostatnich 30 dni. Urządzenia w tych stanach nie wliczają się do progu:",
    alcatrazPricingStateProduction: "W produkcji",
    alcatrazPricingStateTransit: "W transporcie",
    alcatrazPricingStateWarehouse: "W magazynie",
    alcatrazPricingStateRetired: "Wycofane",
    alcatrazPricingCta: "Poproś o wycenę",
    alcatrazFaqEyebrow: "FAQ",
    alcatrazFaqTitle: "Najczęściej zadawane pytania",
    alcatrazFaqQ1: "Czy Alcatraz można wdrożyć we własnej sieci?",
    alcatrazFaqA1:
      "Tak. Alcatraz DMS jest dostępny jako zarządzana platforma SaaS albo rozwiązanie wdrożone lokalnie w zamkniętej sieci operatora. Funkcje i konsola są takie same — operator sam wybiera, gdzie przechowywane są dane.",
    alcatrazFaqQ2: "Jakie urządzenia obsługuje Alcatraz?",
    alcatrazFaqA2:
      "Wszystkie aktualne modele dekoderów inext obsługują Alcatraz DMS: TV5, TV5 Ultra, TV6 i TV6 Ultra. Obsługa nowych modeli jest dostępna od ich premiery.",
    alcatrazFaqQ3: "Jak Alcatraz współpracuje z TR-069?",
    alcatrazFaqA3:
      "Alcatraz obsługuje TR-069 / CWMP, więc operatorzy korzystający już z ACS mogą nadal go używać. Jednocześnie Alcatraz zapewnia rozszerzoną telemetrię, powiadomienia push, zdalne sterowanie przez aplikację i nowoczesne REST API.",
    alcatrazFaqQ4: "Czy Alcatraz można zintegrować z BSS / OSS?",
    alcatrazFaqA4:
      "Tak. Alcatraz udostępnia udokumentowane REST API i obsługuje MQTT. Administratorzy mogą tworzyć i unieważniać klucze API, ustalać zakres uprawnień, ograniczać źródłowe adresy IP i ustawiać daty wygaśnięcia. Zewnętrzne ID łączą urządzenia z istniejącymi rekordami CRM lub systemu rozliczeniowego.",
    alcatrazFaqQ5: "Ile kosztuje Alcatraz DMS?",
    alcatrazFaqA5:
      "Alcatraz Pro jest dostępny bez dodatkowych opłat, dopóki flota liczy mniej niż 500 aktywnych urządzeń inext. Dla flot liczących co najmniej 500 aktywnych urządzeń dostęp i warunki komercyjne są uzgadniane bezpośrednio z działem sprzedaży inext.",
    alcatrazFaqQ6: "Co liczy się jako aktywne urządzenie?",
    alcatrazFaqA6:
      "Ustawienia firmy pokazują aktualne zestawienie aktywnych urządzeń z ostatnich 30 dni, na podstawie którego określany jest dostęp. Urządzenia nadal w produkcji, w transporcie, w magazynie lub już wycofane nie wliczają się do progu.",
    alcatrazFaqQ7: "Ile trwa wdrożenie?",
    alcatrazFaqA7:
      "Wdrożenie chmurowe można uruchomić w kilka dni. Instalacja we własnej infrastrukturze trwa dłużej i zależy od zespołu technicznego operatora — od rozpoczęcia prac do uruchomienia mija zwykle kilka tygodni.",
    alcatrazFinalEyebrow: "Zarządzaj całą flotą",
    alcatrazFinalTitle: "Chcesz przenieść całą flotę dekoderów na jedną platformę?",
    alcatrazFinalBody:
      "Opowiedz nam o swojej sieci, a przygotujemy prezentację Alcatraz DMS dopasowaną do Twojego scenariusza.",
    alcatrazFinalCtaSecondary: "Porozmawiaj z działem sprzedaży",
    navSolutionsCustomization: "Personalizacja i branding",
    navSolutionsCustomizationDesc: "Sprzęt i oprogramowanie white-label",
    navSolutionsRemoteAppDesc: "Mobilny pilot do dekoderów inext",
    customPageSeoTitle: "Personalizacja, white-labeling i co-branding — inext",
    customPageSeoDescription:
      "Dostosuj dekodery inext do swojej marki — od preinstalacji aplikacji po w pełni dedykowany projekt sprzętu i własny firmware. White-labeling i co-branding dla operatorów IPTV i OTT.",
    customPageBreadcrumbHome: "Strona główna",
    customPageBreadcrumbSolutions: "Rozwiązania",
    customPageBreadcrumbPage: "Personalizacja i branding",
    customPageHeroEyebrow: "Personalizacja · White-label · Co-brand",
    customPageHeroTitle: "Twoja marka —",
    customPageHeroTitleAccent: "od ekranu po elektronikę",
    customPageHeroSub:
      "Od preinstalacji aplikacji po w pełni dedykowane urządzenie z własnym firmware — dostosowujemy każdą warstwę platformy inext w modelu white-label lub co-branding, tak aby abonenci widzieli markę operatora.",
    customPageHeroCtaPrimary: "Skontaktuj się ze sprzedażą",
    customPageHeroCtaSecondary: "Zobacz przykłady",
    customPageHeroStat1: "Oprogramowanie + sprzęt",
    customPageHeroStat2: "Branding na każdym poziomie",
    customPageHeroStat3: "Twoja marka, nie nasza",
    customPageHeroImageAlt:
      "Inżynierowie inext personalizują dekoder; na ekranie widać projekt płytki PCB",
    customPageSurfacesEyebrow: "Dwie warstwy, jedna tożsamość",
    customPageSurfacesTitle: "Oprogramowanie i sprzęt pod Twoją marką",
    customPageSurfacesDescription:
      "Dostosuj do swojej marki zarówno interfejs używany codziennie przez abonentów, jak i urządzenie stojące pod telewizorem. Możesz wybrać jedną z tych warstw lub obie.",
    customPageSoftwareTag: "Oprogramowanie",
    customPageSoftwareTitle: "Personalizacja oprogramowania",
    customPageSoftwareBody:
      "Launcher, aplikacja IPTV/OTT, aplikacja pilota i interfejs systemu — z motywem zgodnym z Twoją marką oraz preinstalowanymi usługami.",
    customPageSoftwareBullet1: "Launcher, animacja startowa i tapety pod marką operatora",
    customPageSoftwareBullet2: "Dedykowany klient IPTV/OTT i EPG",
    customPageSoftwareBullet3: "Preinstalowane aplikacje i kontrolowany katalog",
    customPageHardwareTag: "Sprzęt",
    customPageHardwareTitle: "Personalizacja sprzętu",
    customPageHardwareBody:
      "Od naklejki i pudełka detalicznego z logo operatora po w pełni dedykowaną obudowę, pilot i płytkę PCB zaprojektowane według Twojej specyfikacji.",
    customPageHardwareBullet1: "Opakowanie, instrukcje i akcesoria pod marką operatora",
    customPageHardwareBullet2: "Własny kolor obudowy, logo i układ pilota",
    customPageHardwareBullet3: "Dedykowana płytka PCB, porty i chipset dla zamówień wolumenowych",
    customPageTiersEyebrow: "Branding na każdym poziomie",
    customPageTiersTitle: "Zacznij od podstaw. Idź na całość.",
    customPageTiersDescription:
      "Wybierz głębokość dopasowaną do marki i budżetu — każdy krok opiera się na poprzednim.",
    customPageTiersLevelLabel: "Poziom",
    customPageTier1Name: "Preinstalacja i animacja startowa",
    customPageTier1Body:
      "Twoje aplikacje preinstalowane na standardowych dekoderach inext oraz animacja startowa z logo operatora. Najszybsze wejście na rynek — bez osobnego zamówienia produkcyjnego.",
    customPageTier1Tag: "Dni",
    customPageTier2Name: "Pełna identyfikacja marki",
    customPageTier2Body:
      "Twój launcher, animacja startowa, tapety, preinstalowane aplikacje i predefiniowane ustawienia. Abonenci widzą Twoją markę od momentu włączenia.",
    customPageTier2Tag: "Tygodnie",
    customPageTier3Name: "Pełny white-label",
    customPageTier3Body:
      "Twoja nazwa na sprzęcie, w firmware i każdej aplikacji. Marka inext pozostaje niewidoczna, a cała platforma działa pod Twoją marką.",
    customPageTier3Tag: "Miesiące",
    customPageTier4Name: "Dedykowany sprzęt i firmware",
    customPageTier4Body:
      "Dekoder zaprojektowany według Twojej specyfikacji — własna obudowa, pilot, porty i osobna wersja firmware utrzymywana dla Twojej floty.",
    customPageTier4Tag: "Projekt",
    customPageTiersFootnote: "Nie wiesz, od czego zacząć? Pomożemy dobrać właściwy poziom.",
    customPagePillarsEyebrow: "Co możesz spersonalizować",
    customPagePillarsTitle: "Możesz zmienić każdą warstwę",
    customPagePillar1Title: "Opakowanie i pudełko",
    customPagePillar1Body:
      "Pudełka detaliczne, obwoluty, instrukcje i zestawy akcesoriów z identyfikacją Twojej marki.",
    customPagePillar2Title: "Start i ekran powitalny",
    customPagePillar2Body:
      "Animacja startowa, ekrany powitalne i sekwencja wyłączania pod marką operatora.",
    customPagePillar3Title: "Launcher i UI ekranu głównego",
    customPagePillar3Body: "Własny ekran główny, rzędy treści, tapety i ikony aplikacji.",
    customPagePillar4Title: "Aplikacja IPTV / OTT",
    customPagePillar4Body:
      "Odtwarzacz pod Twoją marką, z własnym EPG oraz funkcjami catch-up, time-shift i VOD.",
    customPagePillar5Title: "Preinstalowane aplikacje",
    customPagePillar5Body:
      "Twoje aplikacje preinstalowane na dekoderze oraz kontrolowany katalog dostępnych aplikacji.",
    customPagePillar6Title: "Aplikacja pilota",
    customPagePillar6Body:
      "Mobilny pilot pod Twoją marką, z wyszukiwaniem głosowym, klawiaturą i obsługą gestów.",
    customPagePillar7Title: "Firmware i AOSP",
    customPagePillar7Body:
      "Własna kompilacja AOSP, ustawienia systemu, kanał OTA i polityka bezpieczeństwa.",
    customPagePillar8Title: "Projekt sprzętu",
    customPagePillar8Body: "Obudowa, układ pilota, porty, chipset i PCB pod Twój wolumen.",
    customPageSoftwareDeepEyebrow: "Oprogramowanie w Twoich kolorach",
    customPageSoftwareDeepTitle: "Ekran główny, który abonenci rozpoznają jako Twój",
    customPageSoftwareDeepBody:
      "Dostosowujemy launcher, odtwarzacz i interfejs systemu do Twojej palety, logo oraz typografii, a następnie preinstalujemy aplikacje i usługi potrzebne abonentom. W efekcie powstaje spójny, indywidualnie zaprojektowany produkt, a nie standardowy interfejs Android TV.",
    customPageSoftwareDeepBullet1: "Paleta, logo, ikony i typografia",
    customPageSoftwareDeepBullet2: "Własne rzędy launchera i polecane treści",
    customPageSoftwareDeepBullet3: "Odtwarzacz IPTV/OTT i EPG pod marką operatora",
    customPageSoftwareDeepBullet4: "Preinstalowane aplikacje i predefiniowane ustawienia",
    customPageSoftwareDeepPlaceholder: "Makiety launchera i aplikacji pod marką operatora",
    customPageHardwareDeepEyebrow: "Sprzęt z Twoją nazwą",
    customPageHardwareDeepTitle: "Od naklejki z logo po zupełnie nową płytkę",
    customPageHardwareDeepBody:
      "Wybierz odpowiedni zakres personalizacji. Dodaj logo i własne opakowanie do sprawdzonego dekodera inext, przeprojektuj obudowę i pilot albo wspólnie z nami stwórz zupełnie nowe urządzenie — wraz z chipsetem, portami i PCB — do wdrożeń wolumenowych.",
    customPageHardwareDeepBullet1: "Własny kolor, wykończenie i logo obudowy",
    customPageHardwareDeepBullet2: "Dedykowany układ i branding pilota",
    customPageHardwareDeepBullet3: "Opakowanie detaliczne i zestawy akcesoriów",
    customPageHardwareDeepBullet4: "Dedykowana płytka PCB, porty i chipset (wolumen)",
    customPageHardwareDeepPlaceholder: "Rendery dedykowanego sprzętu i opakowania",
    customPageExamplesEyebrow: "Przykłady",
    customPageExamplesTitle: "Marki, które wybrały własną identyfikację",
    customPageExamplesDescription:
      "Wybór operatorów dostarczających sprzęt inext pod własną marką — od globalnych platform OTT po regionalnych ISP w Europie i Azji Środkowej.",
    customPageExample1Name: "MEGOGO",
    customPageExample1Tag: "Ukraina",
    customPageExample1Meta: "Od 2012",
    customPageExample1Body:
      "Międzynarodowy serwis OTT do TV, filmów i sportu, ponad 55 mln użytkowników miesięcznie.",
    customPageExample2Name: "Kyivstar TV",
    customPageExample2Tag: "Ukraina",
    customPageExample2Meta: "Od 2018",
    customPageExample2Body:
      "Jeden z największych operatorów telekomunikacyjnych Ukrainy, obsługuje około 24 mln klientów.",
    customPageExample3Name: "SWEET.TV",
    customPageExample3Tag: "Europa",
    customPageExample3Meta: "Od 2012",
    customPageExample3Body:
      "Platforma streamingowej TV i VOD działająca w Europie Środkowo-Wschodniej.",
    customPageExample4Name: "ALMA TV",
    customPageExample4Tag: "Kazachstan",
    customPageExample4Meta: "Od 2019",
    customPageExample4Body:
      "Kazachstański dostawca płatnej telewizji i internetu z pełnym zakresem usług.",
    customPageExample5Name: "Beeline",
    customPageExample5Tag: "Kazachstan",
    customPageExample5Meta: "Od 2022",
    customPageExample5Body:
      "Operator cyfrowy: 11 mln abonentów mobilnych i 2 mln internetu domowego, część VEON.",
    customPageExample6Name: "K@TV1",
    customPageExample6Tag: "Azerbejdżan",
    customPageExample6Meta: "Od 2023",
    customPageExample6Body: "Jeden z największych dostawców cyfrowej telewizji w Azerbejdżanie.",
    customPageExample7Name: "Sarkor",
    customPageExample7Tag: "Uzbekistan",
    customPageExample7Meta: "Od 2023",
    customPageExample7Body:
      "Jeden z czołowych uzbeckich dostawców usług IT i telekomunikacyjnych, działający od ponad 25 lat.",
    customPageExample8Name: "Metroport",
    customPageExample8Tag: "Polska",
    customPageExample8Meta: "Od 2024",
    customPageExample8Body:
      "Konsorcjum ponad 30 polskich dostawców internetu, obsługujących około 150 000 abonentów.",
    customPageProcessEyebrow: "Jak to działa",
    customPageProcessTitle: "Od briefu do pudełek na półkach",
    customPageProcessStep1Title: "Rozpoznanie",
    customPageProcessStep1Body:
      "Określamy Twoją markę, wolumeny, urządzenia docelowe i dopasowany poziom personalizacji.",
    customPageProcessStep2Title: "Projekt",
    customPageProcessStep2Body:
      "Przygotowujemy do akceptacji materiały marki, projekt interfejsu i specyfikację sprzętu.",
    customPageProcessStep3Title: "Realizacja",
    customPageProcessStep3Body:
      "Wdrażamy firmware, aplikacje i sprzęt, a następnie przekazujemy jednostki testowe.",
    customPageProcessStep4Title: "Certyfikacja",
    customPageProcessStep4Body:
      "Certyfikaty zgodności, sklepów i bezpieczeństwa — zależnie od wymagań Twojego rynku.",
    customPageProcessStep5Title: "Dostawa",
    customPageProcessStep5Body:
      "Produkcja masowa, provisioning i bieżące wsparcie OTA przez Alcatraz DMS.",
    customPageFaqEyebrow: "FAQ",
    customPageFaqTitle: "Częste pytania",
    customPageFaqQ1: "Jaka jest różnica między co-brandingiem a white-labelingiem?",
    customPageFaqA1:
      "Co-branding łączy Twoją markę z inext na wspólnym sprzęcie i UI. White-labeling usuwa inext całkowicie — Twoja nazwa na pudełku, firmware i każdej aplikacji.",
    customPageFaqQ2: "Jaki jest minimalny wolumen dla dedykowanego sprzętu?",
    customPageFaqA2:
      "Preinstalacja aplikacji i co-branding mają niski próg wejścia lub nie wymagają minimalnego zamówienia. W przypadku dedykowanych obudów, pilotów i PCB minimalna liczba sztuk zależy od projektu — potwierdzimy ją podczas analizy wymagań.",
    customPageFaqQ3: "Czy możecie zbudować w pełni dedykowany firmware?",
    customPageFaqA3:
      "Tak. Utrzymujemy dedykowane wersje AOSP z Twoimi ustawieniami systemu, polityką bezpieczeństwa i osobnym kanałem OTA oraz zapewniamy im długoterminowe wsparcie.",
    customPageFaqQ4: "Czy projektujecie nowy sprzęt od zera?",
    customPageFaqA4:
      "Przy odpowiednich wolumenach tak — własna obudowa, pilot, porty, chipset i PCB, zaprojektowane wspólnie z naszym zespołem sprzętowym.",
    customPageFaqQ5: "Jak obsługiwane są aktualizacje po uruchomieniu?",
    customPageFaqA5:
      "Urządzeniami pod marką operatora zarządza się przez Alcatraz DMS: dostępne są telemetria, etapowe aktualizacje firmware OTA, zdalne sterowanie i powiadomienia push.",
    customPageFaqQ6: "Ile to trwa?",
    customPageFaqA6:
      "Preinstalacja i co-branding mogą trafić na rynek w ciągu kilku dni, a interfejs pod marką operatora — w ciągu kilku tygodni. Harmonogram dedykowanego sprzętu ustalamy indywidualnie.",
    customPageFinalEyebrow: "Twoja marka na każdym poziomie",
    customPageFinalTitle: "Chcesz wprowadzić urządzenie pod własną marką?",
    customPageFinalBody:
      "Opowiedz nam o swojej marce, planowanej liczbie urządzeń i potrzebnym zakresie zmian, a pomożemy wybrać właściwy poziom personalizacji.",
    customPageFinalCta: "Skontaktuj się ze sprzedażą",
    customPageFinalCtaSecondary: "Zamów demo",
    navAccessories: "Akcesoria",
    accessoriesSeoTitle: "Akcesoria inext — piloty, kable i zasilacze",
    accessoriesSeoDescription:
      "Poznaj opcjonalne akcesoria do dekoderów Android TV inext. Oficjalne programowalne piloty zdalnego sterowania, analogowe kable AV, zasilacze i zewnętrzne odbiorniki IR.",
    accessoriesTitle: "Piloty, kable i zasilanie",
    accessoriesSubtitle: "Oficjalne akcesoria i części zamienne do dekoderów inext.",
    accessoriesHeroEyebrow: "Opcjonalne akcesoria",
    accessoriesFilterAll: "Wszystkie akcesoria",
    accessoriesFilterRemotes: "Piloty",
    accessoriesFilterCables: "Kable i adaptery",
    accessoriesFilterPower: "Zasilacze",
    accessoriesFilterSensors: "Czujniki IR",
    accessoriesSpecsTab: "Specyfikacja",
    accessoriesFeaturesTab: "Funkcje",
    accessoriesProgrammingTab: "Instrukcja programowania",
    accessoriesBackToList: "Powrót do akcesoriów",
    accessoriesVideoGuide: "Przewodnik wideo",
    accessoriesAppBullet1: "Dostępna bezpłatnie na Androida i iOS",
    accessoriesAppBullet2: "Działa przez Wi-Fi — bez konieczności skierowania pilota",
    accessoriesAppBullet3: "Wyszukiwanie głosowe i klawiatura ekranowa",
    accessoriesAppCta: "Dowiedz się więcej o aplikacji",
    footerLinkAccessories: "Akcesoria",
    productMenuAccessoriesDesc: "Piloty, kable i zasilacze",
    footerLinkArchive: "Starsze modele",
    archiveSeoTitle: "Starsze dekodery inext — archiwum wycofanych modeli",
    archiveSeoDescription:
      "Archiwum wycofanych dekoderów inext z systemem Android i Linux — od HD1 z 2011 roku po dekodery 4K na Allwinner i Amlogic. Zdjęcia i pełne specyfikacje każdego modelu.",
    archiveTitle: "Starsze modele",
    archiveHeroEyebrow: "Archiwum produktów",
    archiveSubtitle:
      "Wszystkie dekodery inext, które wyprodukowaliśmy od 2011 roku. Te modele zostały wycofane — przechowujemy je tutaj ze zdjęciami i pełnymi specyfikacjami.",
    archiveViewSpecs: "Specyfikacja",
    archiveBadge: "Wycofany",
    archiveSpecsHeading: "Specyfikacja",
    iptvAppSeoTitle:
      "Aplikacja IPTV dla operatorów — klient TV pod własną marką dla dekoderów inext",
    iptvAppSeoDescription:
      "Gotowa aplikacja IPTV dla dekoderów inext: M3U + XMLTV, Stalker / Ministra, TVIP i inne portale. Branding white-label i wstępna konfiguracja pozwalają szybciej uruchomić usługę.",
    iptvAppBreadcrumbHome: "Strona główna",
    iptvAppBreadcrumbSolutions: "Rozwiązania",
    iptvAppBreadcrumbPage: "Aplikacja IPTV",
    iptvAppHeroEyebrow: "Oprogramowanie klienckie · dekodery inext",
    iptvAppHeroTitle: "Nie trać czasu na budowę aplikacji TV —",
    iptvAppHeroTitleAccent: "uruchom gotową pod własną marką",
    iptvAppHeroSub:
      "Gotowy klient IPTV dla dekoderów inext. Dostosowujemy wygląd aplikacji do Twojej marki, konfigurujemy ją pod platformę middleware lub playlisty i dostarczamy zainstalowaną na dekoderach, aby abonenci mogli oglądać telewizję od razu po podłączeniu.",
    iptvAppHeroStat1: "Ponad 3 rodziny portali",
    iptvAppHeroStat2: "W pełni white-label",
    iptvAppHeroStat3: "Konfiguracja bez udziału abonenta",
    iptvAppHeroCtaDemo: "Umów prezentację",
    iptvAppHeroCtaSales: "Porozmawiaj z działem sprzedaży",
    iptvAppModesEyebrow: "Warianty integracji",
    iptvAppModesTitle: "Działa z platformą, którą już wykorzystujesz",
    iptvAppModesDescription:
      "Nie wymaga migracji ani nowej platformy middleware. Aplikację można dostosować do istniejącej stacji czołowej, wybierając tryb odpowiedni dla danej infrastruktury.",
    iptvAppMode1Title: "Playlisty M3U + EPG w formacie XMLTV",
    iptvAppMode1Body:
      "Najprostszy sposób na wyświetlenie kanałów. Podłącz playlistę i źródło EPG — abonenci otrzymają szybki interfejs telewizyjny z pełnymi danymi programu.",
    iptvAppMode1Bullet1: "Playlisty M3U z kategoriami i logotypami kanałów",
    iptvAppMode1Bullet2:
      "Program EPG na każdy dzień z informacją o bieżącej i następnej audycji na każdym kanale",
    iptvAppMode1Bullet3: "Wybór ścieżki audio podczas odtwarzania",
    iptvAppMode1Bullet4: "Wbudowany serwer proxy UDP–HTTP dla sieci multicast",
    iptvAppMode2Title: "Platformy Stalker / Ministra",
    iptvAppMode2Body:
      "Aplikacja odwzorowuje pełny portal Stalker lub Ministra: telewizję, VideoClub, nagrania i ulubione. Profil dekodera można skonfigurować, a dodatkowy panel odtwarzacza zapewnia wygodne sterowanie.",
    iptvAppMode2Bullet1:
      "Pełne odwzorowanie portalu z konfigurowalnym typem dekodera, na przykład MAG",
    iptvAppMode2Bullet2: "Telewizja na żywo, VideoClub / VOD, ulubione i nagrania",
    iptvAppMode2Bullet3:
      "Panel odtwarzacza: ścieżki audio, napisy, powiększenie i klawiatura ekranowa",
    iptvAppMode2Bullet4:
      "Adres portalu i ustawienia odtwarzania wstępnie skonfigurowane dla Twojej usługi",
    iptvAppMode3Title: "TVIP, Hibox, Aura i inne portale internetowe",
    iptvAppMode3Body:
      "Portal w identyfikacji operatora tworzy kompletny interfejs telewizyjny: launcher, przewodnik po programach, archiwum audycji i nagrania. Inne platformy internetowe można dodać na życzenie.",
    iptvAppMode3Bullet1: "Launcher pod marką operatora dokładnie odwzorowuje zatwierdzony projekt",
    iptvAppMode3Bullet2: "Pełna siatka programu telewizyjnego ze szczegółowym EPG",
    iptvAppMode3Bullet3: "Archiwum audycji (catch-up) i nagrania",
    iptvAppMode3Bullet4:
      "Możliwość integracji kolejnych portali internetowych na tej samej zasadzie",
    iptvAppWhiteLabelEyebrow: "White-label i wstępna konfiguracja",
    iptvAppWhiteLabelTitle: "Twoja marka na ekranie, ustawienia gotowe od początku",
    iptvAppWhiteLabelBody:
      "Dostosowujemy aplikację do Twojej marki, wykorzystując logo, kolory i nazwę, a następnie wgrywamy adres portalu, playlistę i źródło EPG. Dekodery docierają gotowe do użycia — abonent musi je tylko podłączyć i rozpocząć oglądanie.",
    iptvAppWhiteLabelBullet1: "Twoje logo, kolory i nazwa aplikacji",
    iptvAppWhiteLabelBullet2: "Wgrane fabrycznie: adres portalu, playlista i źródło EPG",
    iptvAppWhiteLabelBullet3:
      "Ograniczone lub otwarte ustawienia — operator decyduje, co mogą zmieniać abonenci",
    iptvAppWhiteLabelBullet4: "Aplikacja fabrycznie zainstalowana na dekoderach inext",
    iptvAppPillarsEyebrow: "Funkcje",
    iptvAppPillarsTitle: "Wszystko, czego abonenci oczekują od pierwszego dnia",
    iptvAppPillar1Title: "Pełny przewodnik EPG",
    iptvAppPillar1Body:
      "Program telewizyjny na kolejne dni na podstawie XMLTV lub danych z platformy middleware, z informacją o bieżącej i następnej audycji na każdym kanale.",
    iptvAppPillar2Title: "Kategorie i logotypy",
    iptvAppPillar2Body:
      "Przejrzyste listy kanałów z kategoriami tematycznymi i logotypami ułatwiają szybkie przełączanie.",
    iptvAppPillar3Title: "Wiele ścieżek audio i napisy",
    iptvAppPillar3Body: "Wybór ścieżki audio i napisów bezpośrednio w panelu odtwarzacza.",
    iptvAppPillar4Title: "Obsługa multicast",
    iptvAppPillar4Body:
      "Wbudowany serwer proxy UDP–HTTP odtwarza strumienie multicast bez dodatkowego sprzętu.",
    iptvAppPillar5Title: "Interfejs zaprojektowany pod pilota",
    iptvAppPillar5Body:
      "Przełączanie kanałów przyciskami numerycznymi, kolorowe klawisze i klawiatura ekranowa — wszystko zaprojektowane z myślą o pilocie.",
    iptvAppPillar6Title: "Wielojęzyczny interfejs",
    iptvAppPillar6Body:
      "Interfejs jest lokalizowany na potrzeby danego rynku, a język można zmieniać osobno na każdym urządzeniu.",
    iptvAppProcessEyebrow: "Jak to działa",
    iptvAppProcessTitle: "Trzy kroki do dekoderów gotowych dla abonentów",
    iptvAppProcessStep1Title: "Przekaż dane platformy i materiały marki",
    iptvAppProcessStep1Body:
      "Parametry platformy middleware lub playlisty, logo i kolory — wszystko w jednym krótkim opisie wymagań.",
    iptvAppProcessStep2Title: "Dostosowujemy wygląd, konfigurujemy i testujemy",
    iptvAppProcessStep2Body:
      "Nadajemy kompilacji wygląd zgodny z Twoją marką, dodajemy potrzebne ustawienia i sprawdzamy ją na dekoderach inext.",
    iptvAppProcessStep3Title: "Dekodery docierają gotowe do użycia",
    iptvAppProcessStep3Body:
      "Abonent podłącza dekoder i od razu ogląda telewizję, a operator centralnie zarządza aktualizacjami.",
    iptvAppEcosystemEyebrow: "Ekosystem",
    iptvAppEcosystemTitle: "Część ekosystemu inext dla operatorów",
    iptvAppEcosystemBody:
      "Połącz aplikację z dekoderami inext i Alcatraz DMS — sprzęt, oprogramowanie klienckie i zarządzanie flotą od jednego dostawcy.",
    iptvAppEcosystemLinkStb: "Poznaj dekodery inext",
    iptvAppEcosystemLinkAlcatraz: "Poznaj Alcatraz DMS",
    iptvAppFaqEyebrow: "FAQ",
    iptvAppFaqTitle: "Najczęstsze pytania",
    iptvAppFaqQ1: "Jakie platformy middleware obsługuje aplikacja?",
    iptvAppFaqA1:
      "Aplikacja od razu obsługuje Stalker / Ministra, TVIP, Hibox, Aura oraz zwykłe playlisty M3U z EPG w formacie XMLTV. Zazwyczaj można dodać także inne portale internetowe — zapytaj nas o potrzebną platformę.",
    iptvAppFaqQ2: "Czy można dostosować aplikację do naszej marki i ograniczyć dostęp do ustawień?",
    iptvAppFaqA2:
      "Tak. Dostarczamy aplikację z Twoim logo, kolorami i nazwą oraz wstępnie konfigurujemy ustawienia portalu i odtwarzania. Dostęp do ustawień możemy ograniczyć, aby abonenci nie zmienili konfiguracji przypadkowo, albo pozostawić otwarty.",
    iptvAppFaqQ3: "Czy aplikacja działa bez platformy middleware, tylko z M3U?",
    iptvAppFaqA3:
      "Tak. W trybie M3U aplikacja potrzebuje jedynie adresu playlisty i opcjonalnego źródła XMLTV. Kategorie, logotypy, pełny przewodnik EPG i wybór ścieżek audio pozostają dostępne.",
    iptvAppFaqQ4: "Ile czasu potrzeba na uruchomienie?",
    iptvAppFaqA4:
      "Kilka tygodni, nie miesięcy. Dostosowanie marki i wstępna konfiguracja zajmują kilka dni; większość czasu potrzeba na testy w sieci operatora i dostawę dekoderów.",
    iptvAppFinalEyebrow: "Uruchom usługę szybciej",
    iptvAppFinalTitle: "Aplikacja TV jest już gotowa —",
    iptvAppFinalTitleAccent: "dostosujmy ją do Twojej marki",
    iptvAppFinalBody:
      "Opowiedz nam o swojej platformie i wymaganiach dotyczących marki, a przygotujemy wstępnie skonfigurowaną wersję demonstracyjną dla Twojej usługi.",
    iptvAppFinalCta: "Umów prezentację",
    iptvAppFinalCtaSecondary: "Porozmawiaj z działem sprzedaży",
    iptvAppAltNativePlayer:
      "Aplikacja IPTV inext podczas transmisji sportowej z panelem odtwarzacza i informacją EPG o bieżącej oraz następnej audycji",
    iptvAppAltNativeEpg:
      "Lista kanałów z osią programu EPG na cały dzień w interfejsie aplikacji IPTV",
    iptvAppAltNativeCategories:
      "Pasek kategorii z logotypami kanałów i informacją o bieżącej oraz następnej audycji",
    iptvAppAltNativeSetup: "Ekran konfiguracji z wyborem listy kanałów M3U lub portalu Stalker",
    iptvAppAltNativeAudio: "Menu wyboru ścieżki audio na tle transmisji na żywo",
    iptvAppAltStalkerHome: "Ekran główny portalu Stalker / Ministra z sekcjami TV i VideoClub",
    iptvAppAltStalkerChannels: "Lista kanałów portalu Stalker z podglądem transmisji na żywo i EPG",
    iptvAppAltStalkerSettings: "Ekran ustawień z adresem portalu i wyborem profilu dekodera MAG",
    iptvAppAltStalkerPlayerMenu:
      "Pasek odtwarzacza z elementami sterowania portalem, ścieżkami audio, napisami, powiększeniem i klawiaturą",
    iptvAppAltTvipHome: "Launcher w stylu TVIP w barwach operatora",
    iptvAppAltTvipChannels:
      "Wielokolumnowa lista kanałów z informacjami o audycjach w portalu typu TVIP",
    iptvAppAltTvipEpg: "Pełna siatka przewodnika po programach ze szczegółami audycji",
    navSolutionsIptvApp: "Aplikacja IPTV",
    navSolutionsIptvAppDesc: "Klient TV pod marką operatora dla dekoderów inext",
    footerLinkIptvApp: "Aplikacja IPTV",
    navSolutionsOta: "Aktualizacje OTA",
    navSolutionsOtaDesc: "Etapowe wdrożenia firmware i aplikacji",
    footerLinkOta: "Zarządzanie aktualizacjami OTA",
    otaBreadcrumbHome: "Strona główna",
    otaBreadcrumbSolutions: "Rozwiązania",
    otaBreadcrumbPage: "Zarządzanie aktualizacjami OTA",
    otaSeoTitle: "Zarządzanie aktualizacjami OTA inext — etapowe wdrożenia dla flot STB",
    otaSeoDescription:
      "Testuj, zatwierdzaj, etapowo wdrażaj, dostarczaj i monitoruj firmware w całych flotach STB inext. Platforma obsługuje również aktualizacje aplikacji i dostarczyła już ponad milion aktualizacji OTA.",
    otaHeroEyebrow: "Zarządzanie aktualizacjami OTA",
    otaHeroTitle: "Właściwy firmware dla właściwego urządzenia —",
    otaHeroTitleAccent: "bezpiecznie i na dowolną skalę",
    otaHeroSub:
      "Z jednej platformy testuj, zatwierdzaj, etapowo wdrażaj, dostarczaj i monitoruj firmware dla urządzeń STB inext — od pierwszego urządzenia testowego po ogólnokrajową flotę.",
    otaHeroCtaDemo: "Umów prezentację",
    otaHeroCtaSales: "Omów wdrożenie",
    otaHeroPlatformNote: "Zarządzanie aktualizacjami OTA jest częścią platformy inext",
    otaHeroStat1: "Wdrożenia etapowe od 1% do 100%",
    otaHeroStat2: "Dostawa według regionu i operatora",
    otaHeroStat3: "Chmura lub lokalnie",
    otaHeroDiagramTitle: "Żądanie aktualizacji",
    otaHeroDiagramSubRunning: "Sprawdzanie parametrów urządzenia…",
    otaHeroDiagramSubDone: "Aktualizacja zakończona",
    otaHeroDiagramStep1: "Model · płyta · zainstalowana wersja",
    otaHeroDiagramStep2: "Grupa docelowa · harmonogram · zakres wdrożenia",
    otaHeroDiagramStep3: "Najbliższy dostępny węzeł magazynujący",
    otaHeroDiagramOutcome: "Bezpieczny i zweryfikowany link do pobrania",
    otaHeroDiagramDownloading: "Pobieranie firmware przez urządzenie STB…",
    otaHeroDiagramInstalling: "Instalowanie firmware na urządzeniu STB…",
    otaHeroDiagramInstalled: "Firmware zainstalowano pomyślnie",
    otaReleaseEyebrow: "Kontrolowany proces",
    otaReleaseTitle: "Od przetestowanej kompilacji do kontrolowanego wdrożenia",
    otaReleaseDescription:
      "Każde wydanie przechodzi jasno określone etapy testowania, zatwierdzania, wdrażania i monitorowania. Komentarze z dostępem opartym na rolach pozostają w kontekście odpowiedniej kompilacji lub wydania.",
    otaReleaseCard1Title: "Udostępniaj każdemu urządzeniu wyłącznie zgodny firmware",
    otaReleaseCard1Body:
      "Zanim aktualizacja zostanie zaoferowana, każde żądanie jest sprawdzane pod kątem modelu, płyty, zainstalowanej wersji, operatora, reguł wydania i dostępności pakietu.",
    otaReleaseCard2Title: "Ustaw docelowy zakres wdrożenia",
    otaReleaseCard2Body:
      "Zacznij od małej grupy pilotażowej, oceń wyniki, a następnie stopniowo rozszerzaj wydanie na całą flotę. W każdej chwili możesz wstrzymać wdrożenie lub zmniejszyć jego docelowy zakres bez utraty dotychczasowego postępu.",
    otaReleaseCard4Title: "Testuj na wybranych urządzeniach",
    otaReleaseCard4Body:
      "Sprawdź kompilację na urządzeniach wewnętrznych lub pracujących już w sieci, zanim zostanie dopuszczona do powszechnej dystrybucji.",
    otaReleaseCard6Title: "Zatwierdź do wdrożenia produkcyjnego",
    otaReleaseCard6Body:
      "Rozdziel uprawnienia do wydań testowych i publicznych, aby tylko upoważnieni użytkownicy mogli wdrażać firmware w środowisku produkcyjnym.",
    otaRolloutEyebrow: "Sterowanie wdrożeniem",
    otaRolloutTitle: "Precyzyjnie wybieraj urządzenia. Ograniczaj skalę ryzyka.",
    otaRolloutBody:
      "Kontrola zgodności i etapowe wdrażanie na określonym odsetku urządzeń znacząco zmniejszają ryzyko, a operator zachowuje kontrolę nad każdym kolejnym etapem.",
    otaRolloutMeterLabel: "Docelowy zakres wdrożenia",
    otaRolloutMeterStage1: "Test wewnętrzny",
    otaRolloutMeterStage2: "Grupa pilotażowa",
    otaRolloutMeterStage3: "Rozszerzanie zasięgu",
    otaRolloutMeterStage4: "Cała flota",
    otaGovernEyebrow: "Zasady i uprawnienia",
    otaGovernTitle: "Jasne reguły zatwierdzania",
    otaGovernBody:
      "Uprawnienia oparte na rolach rozdzielają testowanie, zatwierdzanie, kontrolę wdrożenia i dostęp do komentarzy firmware, dzięki czemu decyzje produkcyjne pozostają jasno kontrolowane.",
    otaGovernPerm3: "Tworzenie wydań testowych",
    otaGovernPerm4: "Zatwierdzanie do publicznej dystrybucji",
    otaGovernPerm5: "Tworzenie i zmiana reguł wdrożenia",
    otaGovernPerm6: "Uruchamianie, wstrzymywanie i wznawianie wdrożeń",
    otaGovernPerm7: "Zaawansowane opcje wydań prywatnych",
    otaDeliveryEyebrow: "Globalna dystrybucja",
    otaDeliveryTitle: "Niezawodne dostarczanie firmware z uwzględnieniem lokalizacji",
    otaDeliveryDescription:
      "Firmware jest dystrybuowany przez zatwierdzone węzły magazynujące wybierane na podstawie konfigurowalnych reguł trasowania. Dane są pobierane z węzła położonego blisko floty, a operator zachowuje kontrolę nad zasadami dystrybucji w poszczególnych regionach.",
    otaDeliveryCard1Title: "Trasowanie według lokalizacji, operatora i obciążenia węzła",
    otaDeliveryCard1Body:
      "Platforma wybiera najbliższy zatwierdzony węzeł, na którym znajduje się właściwy firmware i który ma zasoby potrzebne do obsługi kolejnego pobrania.",
    otaDeliveryCard2Title: "Przełączenie awaryjne tylko wtedy, gdy zezwalają na to reguły",
    otaDeliveryCard2Body:
      "Jeśli węzeł regionalny jest niedostępny lub przeciążony, zweryfikowany węzeł globalny może przejąć ruch bez naruszania reguł dostarczania.",
    otaDeliveryCard3Title: "Sprawdzaj każdy pobrany plik",
    otaDeliveryCard3Body:
      "Linki z ograniczonym czasem ważności chronią informacje o trasowaniu i węzłach. Przed instalacją plik jest weryfikowany na podstawie rozmiaru i sumy kontrolnej.",
    otaDiagramEyebrow: "Jak wydanie trafia do urządzenia",
    otaDiagramTitle: "Ścieżka dostawy OTA",
    otaDiagramNode1: "Interfejs zarządzania i API",
    otaDiagramNode2: "Warstwa sterowania z dostępem opartym na rolach",
    otaDiagramNode3: "Mechanizm wyboru firmware",
    otaDiagramNode4: "Usługa koordynująca dostawę OTA",
    otaDiagramNode5: "Regionalne lub lokalne węzły magazynujące",
    otaDiagramNode6: "Globalny zapasowy magazyn danych",
    otaDiagramNode7: "Flota STB inext",
    otaDiagramNode8: "Telemetria pobierania i wdrożenia",
    otaDiagramReturnLabel: "Telemetria wraca do platformy",
    otaDeployEyebrow: "Infrastruktura operatora",
    otaDeployTitle: "Wdróż w chmurze, lokalnie lub hybrydowo",
    otaDeployDescription:
      "Korzystaj z dystrybucji w chmurze inext, umieść węzły magazynujące we własnej sieci albo uruchom w niej całą platformę.",
    otaDeployCloudTag: "Zalecane",
    otaDeployCloudTitle: "Chmura (SaaS)",
    otaDeployCloudBody:
      "Platformę hostuje i obsługuje inext. Szybkie uruchomienie, automatyczne aktualizacje i geograficznie rozproszona dystrybucja są dostępne od pierwszego dnia.",
    otaDeployCloudBullet1: "Nie trzeba utrzymywać własnej infrastruktury",
    otaDeployCloudBullet2: "Dostęp do globalnych węzłów magazynujących",
    otaDeployCloudBullet3: "Automatyczne aktualizacje platformy",
    otaDeployOnpremTitle: "We własnej infrastrukturze",
    otaDeployOnpremBody:
      "Część serwerowa, interfejs WWW i węzły magazynujące działają we własnej sieci operatora — to rozwiązanie dla organizacji o rygorystycznych wymaganiach dotyczących miejsca przechowywania danych lub bezpieczeństwa.",
    otaDeployOnpremBullet1: "Pliki firmware pozostają w sieci operatora",
    otaDeployOnpremBullet2: "Magazyn obiektowy zgodny z S3",
    otaDeployOnpremBullet3: "Kontrola zasobów i topologii",
    otaDeployNodeTitle: "Potrzebujesz szybszych aktualizacji? Dodaj dedykowany węzeł magazynujący",
    otaDeployNodeBody:
      "Serwer magazynujący może działać w sieci operatora niezależnie od miejsca utrzymywania platformy. inext konfiguruje go zdalnie, replikuje na niego firmware i w ciągu kilku dni włącza go do sieci dystrybucyjnej.",
    otaDeployNodeChip1: "Współpracuje z wdrożeniem chmurowym i lokalnym",
    otaDeployNodeChip2: "Zdalnie konfigurowany przez inext",
    otaDeployNodeChip3: "Uruchomienie w kilka dni, nie tygodni",
    otaMonitorEyebrow: "Nadzór operacyjny",
    otaMonitorTitle: "Śledź wdrożenie bezpośrednio w konsoli",
    otaMonitorDescription:
      "Monitoruj poziom wdrożenia i stan dystrybucji, a gdy potrzebna jest analiza, otwieraj zdarzenia OTA konkretnego urządzenia z osi aktywności.",
    otaMonitorCard1Title: "Monitoruj i rozszerzaj wdrożenie",
    otaMonitorCard1Body:
      "Przed zwiększeniem docelowego zakresu porównaj bieżący zasięg wdrożenia z liczbą aktywnych urządzeń.",
    otaMonitorCard2Title: "Telemetria pobierania",
    otaMonitorCard2Body:
      "Analizuj szczegółowe metryki pobierania i instalacji według kompilacji, typu urządzenia, węzła, regionu i pojedynczego zdarzenia urządzenia.",
    otaMonitorCard4Title: "Automatyczne powiadomienia",
    otaMonitorCard4Body:
      "Powiadamiaj osoby odpowiedzialne za wydanie, gdy wdrożenie osiągnie bieżący cel i będzie gotowe do oceny.",
    otaMonitorMetricsNote:
      "Metryki infrastruktury są eksportowane w formacie zgodnym ze standardowymi platformami monitoringu, takimi jak Prometheus i Grafana.",
    otaMigrateEyebrow: "Migracja floty",
    otaMigrateTitle: "Przenieś flotę ze standardowego firmware na własną gałąź",
    otaMigrateBody:
      "Operatorzy, którzy rozpoczęli pracę ze standardowym firmware, mogą przez OTA przenieść już wdrożone urządzenia na dedykowaną gałąź pod własną marką — łącznie z bootloaderem — bez wizyt techników i wymiany sprzętu.",
    otaMigrateBullet1: "Migracja wdrożonych urządzeń na własną gałąź firmware",
    otaMigrateBullet2: "Pełna zmiana obrazu systemu wraz z bootloaderem",
    otaMigrateBullet3: "Bez wizyt terenowych, zwrotów i wymiany sprzętu",
    otaApiEyebrow: "Gotowe do integracji",
    otaApiTitle: "Zintegruj OTA z systemami operacyjnymi",
    otaApiBody:
      "Korzystaj z samodzielnie zarządzanych kluczy API o ograniczonych uprawnieniach, aby integrować kompilacje firmware, zatwierdzenia, stan urządzeń i postęp wdrożeń z istniejącymi systemami wsparcia i raportowania.",
    otaApiPanelTitle: "API Alcatraz",
    otaApiPanelSub: "REST · dokumentacja · uprawnienia tokenów",
    otaAppsEyebrow: "Dystrybucja aplikacji",
    otaAppsTitle: "Aktualizuj nie tylko firmware, lecz także aplikacje",
    otaAppsBody:
      "Oprócz firmware platforma może dostarczać aktualizacje aplikacji do obsługiwanych urządzeń STB, wykorzystując tę samą sieć dystrybucyjną i mechanizmy etapowego wdrażania. Dostępne opcje zależą od sposobu integracji aplikacji.",
    otaAppsBullet1: "Wspólna sieć dystrybucyjna i etapowe wdrażanie",
    otaAppsBullet2: "Dla obsługiwanych urządzeń STB i zintegrowanych aplikacji",
    otaStatRolloutValue: "1 mln+",
    otaStatRolloutLabel: "aktualizacji OTA dostarczonych przez platformę inext",
    otaStatScaleValue: "1% → 100%",
    otaStatScaleLabel: "Etapowa kontrola wdrożenia od grupy pilotażowej po całą flotę",
    otaStatDeliveryValue: "Według lokalizacji",
    otaStatDeliveryLabel: "Trasowanie według kraju, operatora i bieżącego obciążenia węzłów",
    otaStatDeployValue: "Chmura · Własna infrastruktura",
    otaStatDeployLabel: "Uruchomienie w chmurze inext lub w całości we własnej sieci",
    otaTargetChipsLabel: "Kryteria wyboru urządzeń",
    otaTargetChip1: "Model i płyta STB",
    otaTargetChip2: "Zainstalowana wersja firmware",
    otaTargetChip3: "ISP / operator",
    otaTargetChip4: "Lista dozwolonych adresów MAC",
    otaTargetChip5: "Grupa testowa",
    otaTargetChip6: "Uprawnienie do automatycznych aktualizacji",
    otaFaqEyebrow: "FAQ",
    otaFaqTitle: "Najczęstsze pytania",
    otaFaqQ1: "Czy OTA jest częścią Alcatraz DMS?",
    otaFaqA1:
      "Aktualizacje firmware OTA są dostarczane przez platformę inext Alcatraz, z wykorzystaniem tej samej części serwerowej, konsoli i uprawnień. W Alcatraz DMS odpowiada za to moduł dystrybucji firmware w ramach tego samego systemu.",
    otaFaqQ2: "Czy OTA można wdrożyć w sieci operatora?",
    otaFaqA2:
      "Tak. Węzły magazynujące mogą działać w infrastrukturze operatora, a całą platformę — część serwerową i interfejs WWW — można wdrożyć lokalnie. Węzły obsługują magazyny obiektowe zgodne z S3.",
    otaFaqQ3: "Jak etapowe wdrożenia zmniejszają ryzyko?",
    otaFaqA3:
      "Aktualizacja trafia najpierw do określonego odsetka floty. System monitoruje jej zasięg wśród aktywnych urządzeń, a wdrożenie jest rozszerzane dopiero po ocenie wyników. Można je w dowolnym momencie wstrzymać, wznowić lub ograniczyć, a zakończenie etapu uruchamia powiadomienie.",
    otaFaqQ4: "Co się stanie, gdy węzeł regionalny będzie niedostępny lub przeciążony?",
    otaFaqA4:
      "Trasowanie uwzględnia bieżące obciążenie węzłów. Jeśli zatwierdzony węzeł regionalny jest niedostępny lub przeciążony, ruch może zostać skierowany do węzła globalnego, o ile zezwalają na to reguły. Aktualizacja jest oferowana urządzeniu tylko wtedy, gdy istnieje zweryfikowana ścieżka dostarczania.",
    otaFaqQ5: "Czy można wymusić krytyczną aktualizację bezpieczeństwa?",
    otaFaqA5:
      "Tak. Wydanie można oznaczyć jako obowiązkowe, aby użytkownicy nie mogli go pominąć. Reguły ścieżki aktualizacji zapewniają również instalację wymaganej pośredniej wersji firmware przed przejściem do nowszej kompilacji.",
    otaFaqQ6: "Jak system sprawdza, czy urządzenie otrzymało właściwy firmware?",
    otaFaqA6:
      "Metadane firmware zawierają rozmiar pliku i sumę kontrolną, dzięki czemu urządzenie STB weryfikuje pobrany plik przed instalacją. Urządzenia przesyłają też do platformy telemetrię pobierania.",
    otaFaqQ7: "Czy system może dostarczać aktualizacje aplikacji?",
    otaFaqA7:
      "Tak. System służy przede wszystkim do zarządzania cyklem życia firmware, ale może również dostarczać aktualizacje aplikacji do obsługiwanych urządzeń STB. Dostępne mechanizmy zależą od sposobu integracji aplikacji i wymagań wdrożeniowych.",
    otaFinalEyebrow: "Planujesz bezpieczniejsze wdrożenie?",
    otaFinalTitle: "Zobacz zarządzanie aktualizacjami OTA w działaniu",
    otaFinalBody:
      "Razem z zespołem inext przejdź przez testowanie, zatwierdzanie, etapowe wdrażanie i monitorowanie na przykładzie scenariusza z własnej floty.",
    otaFinalCta: "Umów prezentację OTA",
    otaFinalCtaSecondary: "Omów wdrożenie",
    otaLiveLabel: "Aktywne wydanie",
    otaUiTestTitle: "Testowanie",
    otaUiTestBody: "Wyślij ten firmware do jednego lub kilku urządzeń, aby go przetestować.",
    otaUiTestAction: "Utwórz wydanie testowe",
    otaUiConfirmTitle: "Zatwierdzenie",
    otaUiConfirmBody:
      "Oznacz firmware jako gotowy do wydania produkcyjnego. Zatwierdzoną kompilację można następnie wykorzystać we wdrożeniu produkcyjnym.",
    otaUiConfirmAction: "Zatwierdź firmware",
    otaUiReleaseTitle: "Wydanie",
    otaUiReleaseBody: "Ustaw datę, godzinę i docelowy zakres wdrożenia zatwierdzonej kompilacji.",
    otaUiReleaseAction: "Utwórz wydanie produkcyjne",
    otaUiLiveBody: "Aktywuj lub wstrzymaj wydanie w dowolnym momencie.",
    otaUiMandatoryTitle: "Aktualizacja obowiązkowa",
    otaUiMandatoryBody: "Użytkownicy nie mogą odrzucić tej aktualizacji.",
    otaUiResetTitle: "Przywrócenie ustawień po aktualizacji",
    otaUiResetBody: "Przywróć urządzenia do ustawień fabrycznych po instalacji.",
    otaUiStagedTitle: "Wdrożenie etapowe",
    otaUiStagedBody: "Udostępnij firmware wybranemu odsetkowi kwalifikujących się urządzeń.",
    otaUiInteractiveLabel: "Interaktywny przykład",
    otaUiCompletedAction: "Gotowe",
    otaUiWorkingAction: "Przetwarzanie…",
    otaUiWorkflowComplete: "Kompilacja zatwierdzona i gotowa do etapowego wdrożenia",
    otaUiReplayAction: "Powtórz",
    otaUiApproximately: "około",
    otaUiEligibleDevices: "kwalifikujących się urządzeń",
    otaAdvancedEyebrow: "Zaawansowane możliwości",
    otaAdvancedTitle: "Więcej możliwości niż standardowe wdrożenie OTA",
    otaAdvancedBody:
      "Przenoś istniejące floty na gałąź firmware pod marką operatora i integruj zarządzanie wydaniami z pozostałymi systemami.",
    worldwideEyebrow: "Dostawa na cały świat",
    worldwideHeadline: "Produkujemy w Azji. Dostarczamy na cały świat.",
    worldwideSub:
      "Od partnerów produkcyjnych w Shenzhen i na Tajwanie — do operatorów w Europie, Azji Środkowej, Ameryce i dalej. Opakowanie, odprawa celna i koordynacja dostawy — wszystko po naszej stronie.",
    worldwideOriginLabel: "Chiny i Tajwan",
    worldwideStat1Value: "700K+",
    worldwideStat1Label: "dostarczonych urządzeń",
    worldwideStat3Label: "tryby wysyłki",
    worldwideCta: "Jak wysyłamy",
    navSolutionsLogistics: "Logistyka globalna",
    navSolutionsLogisticsDesc: "Dostawy sprzętu B2B na cały świat",
    footerLinkLogistics: "Logistyka globalna",
    logisticsSeoTitle: "Logistyka globalna — dostawy sprzętu B2B na cały świat",
    logisticsSeoDescription:
      "Dostawy B2B sprzętu inext od partnerów produkcyjnych w Shenzhen, Kantonie i na Tajwanie do operatorów i dystrybutorów na całym świecie — drogą lotniczą, morską i lądową, z kurierem ekspresowym dla próbek.",
    logisticsBreadcrumb: "Logistyka globalna",
    logisticsHeroEyebrow: "Globalna logistyka B2B",
    logisticsHeroTitle: "Od produkcji do",
    logisticsHeroTitleAccent: "Twojego magazynu",
    logisticsHeroSub:
      "Produkujemy dekodery z uznanymi partnerami w Chinach i na Tajwanie, a następnie koordynujemy dostawy do operatorów, dystrybutorów i centrów logistycznych na całym świecie. Jedna osoba kontaktowa odpowiada za każdą przesyłkę B2B.",
    logisticsHeroCtaPrimary: "Zaplanuj wysyłkę",
    logisticsHeroCtaSecondary: "Znajdź dystrybutora",
    logisticsHeroChip1: "Dostawy B2B na cały świat",
    logisticsHeroChip2: "Produkcja w Chinach i na Tajwanie",
    logisticsHeroChip3: "Opakowania pod marką klienta, gotowe do sprzedaży",
    logisticsHeroStage1: "Produkcja",
    logisticsHeroStage2: "Branding i pakowanie",
    logisticsHeroStage3: "Transport",
    logisticsHeroStage4: "Odprawa i dostawa",
    logisticsGlobeHubLabel: "Ośrodek produkcyjny",
    logisticsGlobeRouteLabel: "Trasa dostawy",
    logisticsGlobeCaption:
      "Trasy B2B z Chin i Tajwanu do Kijowa, Bratysławy, São Paulo i Ałmaty, z dalszą dystrybucją z Bratysławy do Warszawy i na Węgry.",
    logisticsHubShenzhen: "Shenzhen",
    logisticsHubGuangzhou: "Kanton (Guangzhou)",
    logisticsHubTaiwan: "Tajwan",
    logisticsStat1Value: "700K+",
    logisticsStat1Label: "dostarczonych urządzeń na całym świecie",
    logisticsStat2Value: "15+",
    logisticsStat2Label: "obsługiwanych krajów",
    logisticsStat3Value: "3",
    logisticsStat3Label: "ośrodki produkcyjne w Chinach i na Tajwanie",
    logisticsStat4Value: "4",
    logisticsStat4Label: "formy transportu — lotniczy, morski, lądowy oraz kurier dla próbek",
    logisticsMakeEyebrow: "Gdzie powstają urządzenia",
    logisticsMakeTitle: "Produkcja w sprawdzonych ośrodkach",
    logisticsMakeBody:
      "Nasze dekodery powstają we współpracy z partnerami produkcyjnymi i dostawcami w dwóch wiodących regionach elektroniki na świecie. Utrzymanie produkcji blisko łańcucha dostaw podzespołów pozwala zachować wysoką jakość, krótkie czasy realizacji i przewidywalne koszty.",
    logisticsMakeCard1Title: "Shenzhen, Chiny",
    logisticsMakeCard1Tag: "Montaż i pakowanie",
    logisticsMakeCard1Body:
      "Montaż końcowy, wgrywanie firmware'u, kontrola jakości i pakowanie — w tym pudełka pod marką operatora, gotowe na półkę sklepową.",
    logisticsMakeCard2Title: "Kanton (Guangzhou), Chiny",
    logisticsMakeCard2Tag: "Płytki i podzespoły",
    logisticsMakeCard2Body:
      "Produkcja płytek i pozyskiwanie podzespołów dzięki rozbudowanemu łańcuchowi dostaw w Delcie Rzeki Perłowej, który umożliwia szybką realizację zamówień.",
    logisticsMakeCard3Title: "Tajwan",
    logisticsMakeCard3Tag: "Układy i moduły",
    logisticsMakeCard3Body:
      "Kluczowe chipsety i moduły od uznanych tajwańskich dostawców — układy scalone stanowiące podstawę naszych platform sprzętowych.",
    logisticsFlowEyebrow: "Od produkcji do wdrożenia",
    logisticsFlowTitle: "Od linii produkcyjnej do Twojego magazynu",
    logisticsFlowBody:
      "Produkcję, pakowanie, transport i odprawę celną łączymy w jeden plan, za który na każdym etapie odpowiada wyznaczony koordynator.",
    logisticsFlowStep1Title: "Produkcja i kontrola jakości",
    logisticsFlowStep1Body:
      "Urządzenia są montowane i indywidualnie testowane, a następnie — jeszcze przed zejściem z linii — wgrywamy na nie Twoją wersję firmware'u.",
    logisticsFlowStep2Title: "Nanoszenie marki i pakowanie",
    logisticsFlowStep2Body:
      "Urządzenia pakujemy w neutralne opakowania lub pudełka w pełni dopasowane do marki i rynku operatora, gotowe do sprzedaży detalicznej.",
    logisticsFlowStep3Title: "Wysyłka i odprawa celna",
    logisticsFlowStep3Body:
      "Dobieramy właściwego przewoźnika do Twojego harmonogramu i budżetu oraz przygotowujemy dokumenty eksportowe i celne.",
    logisticsFlowStep4Title: "Dostawa do Twojej sieci",
    logisticsFlowStep4Body:
      "Zamówienia produkcyjne trafiają do Twojego magazynu, dystrybutora lub wybranego partnera logistycznego, ze śledzeniem na całej trasie.",
    logisticsModesEyebrow: "Jak wysyłamy",
    logisticsModesTitle: "Odpowiednia forma transportu dla każdej wysyłki",
    logisticsModesBody:
      "Od pojedynczej pilnej palety po pełny kontener — dobieramy metodę wysyłki do Twojego wolumenu, budżetu i terminu.",
    logisticsModeAirTitle: "Fracht lotniczy",
    logisticsModeAirBody:
      "Najszybsza opcja przy uruchamianiu nowych usług i zamówieniach produkcyjnych z krótkim terminem dostawy.",
    logisticsModeSeaTitle: "Fracht morski",
    logisticsModeSeaBody:
      "Najbardziej opłacalna opcja przy dużych, planowanych zamówieniach wysyłanych w kontenerach.",
    logisticsModeRoadTitle: "Transport drogowy i kolejowy",
    logisticsModeRoadBody:
      "Dystrybucja regionalna i dalsza dostawa po dotarciu towaru na Twój rynek.",
    logisticsModeCourierTitle: "Kurier ekspresowy",
    logisticsModeCourierBody:
      "Szybka dostawa od drzwi do drzwi dla próbek testowych przed rozpoczęciem projektu lub złożeniem zamówienia wolumenowego.",
    logisticsB2bNoteTitle: "Wyłącznie dostawy biznesowe",
    logisticsB2bNoteBody:
      "Zamówienia produkcyjne dostarczamy do operatorów, dystrybutorów, magazynów lub partnerów logistycznych. Nie realizujemy dropshippingu do abonentów. Kurier ekspresowy służy wyłącznie do wysyłki próbek ewaluacyjnych.",
    logisticsHandleEyebrow: "Zajmiemy się tym za Ciebie",
    logisticsHandleTitle: "To więcej niż przewożenie pudełek",
    logisticsHandleBody:
      "Bierzemy na siebie szczegóły, które spowalniają operatorów, aby sprzęt docierał gotowy do wdrożenia.",
    logisticsHandleItem1: "Opakowania pod marką operatora, gotowe na półkę sklepową",
    logisticsHandleItem2: "Wysyłki hurtowe, na paletach i w kontenerach",
    logisticsHandleItem3: "Dokumentacja eksportowa, celna i zgodności",
    logisticsHandleItem4: "Wdrożenia etapowe, region po regionie",
    logisticsHandleItem5: "Koordynacja z Twoimi dystrybutorami i partnerami 3PL",
    logisticsHandleItem6: "Ekspresowa dostawa próbek do oceny technicznej i handlowej",
    logisticsHandleItem7:
      "Wykazy numerów seryjnych i adresów MAC każdego urządzenia, gotowe do provisioningu",
    logisticsHandleItem8: "Firmware i konfiguracja fabrycznie wgrane dla każdej partii",
    logisticsHandleItem9:
      "Elastyczne warunki Incoterms — EXW, FOB lub DAP dopasowane do Twojej organizacji",
    logisticsHandleFootnote:
      "Jeden koordynator prowadzi każdą wysyłkę — od linii produkcyjnej po Twój magazyn.",
    logisticsLinksEyebrow: "Zobacz także",
    logisticsLinksTitle: "Zaplanuj resztę wdrożenia",
    logisticsLinkCta: "Dowiedz się więcej",
    logisticsLinkDistributorsTitle: "Znajdź dystrybutora",
    logisticsLinkDistributorsBody:
      "Współpracuj z autoryzowanym partnerem inext, który już obsługuje Twój region.",
    logisticsLinkCustomizationTitle: "Branding i opakowania",
    logisticsLinkCustomizationBody:
      "Wysyłaj sprzęt pod własną marką — od firmware'u po pudełko sklepowe.",
    logisticsLinkProductsTitle: "Przeglądaj sprzęt",
    logisticsLinkProductsBody: "Porównaj ofertę dekoderów inext i wybierz odpowiedni model.",
    logisticsLinkAboutTitle: "O inext",
    logisticsLinkAboutBody: "Zespół stojący za sprzętem, dostarczający operatorom od 2011 roku.",
    logisticsFaqEyebrow: "FAQ",
    logisticsFaqTitle: "Dostawy i logistyka — odpowiedzi",
    logisticsFaqQ1: "Do jakich krajów dostarczacie?",
    logisticsFaqA1:
      "Wysyłamy na cały świat. Sprzęt inext jest już wdrożony przez operatorów w ponad 15 krajach, a nasi partnerzy logistyczni docierają praktycznie na każdy rynek — bezpośrednio lub przez lokalnego dystrybutora.",
    logisticsFaqQ2: "Gdzie produkowane są produkty inext?",
    logisticsFaqA2:
      "Nasze dekodery powstają we współpracy z partnerami produkcyjnymi i dostawcami w Shenzhen i Kantonie (Guangzhou) w Chinach oraz na Tajwanie — to uznane regiony elektroniki z dojrzałymi, niezawodnymi łańcuchami dostaw.",
    logisticsFaqQ3: "Kto zajmuje się wysyłką i odprawą celną?",
    logisticsFaqA3:
      "Koordynujemy całą trasę dostawy z pomocą naszej sieci partnerów logistycznych i przygotowujemy dokumenty eksportowe oraz celne. Dzięki temu kontaktujesz się z jednym koordynatorem zamiast z kilkoma spedytorami.",
    logisticsFaqQ4: "Czy możecie wysyłać sprzęt pod naszą marką?",
    logisticsFaqA4:
      "Tak. Urządzenia mogą dotrzeć do Twojego magazynu lub partnera dystrybucyjnego w opakowaniach w pełni dopasowanych do marki i gotowych do sprzedaży detalicznej. Opcje personalizacji firmware'u, obudowy i opakowania opisujemy na osobnej stronie.",
    logisticsFaqQ5: "Jakie metody wysyłki i czasy realizacji są dostępne?",
    logisticsFaqA5:
      "Zamówienia produkcyjne mogą podróżować frachtem lotniczym, morskim, drogowym lub kolejowym. Kurier ekspresowy służy do próbek ewaluacyjnych, nie do dropshippingu konsumenckiego. Czas realizacji zależy od wolumenu, personalizacji i miejsca docelowego — realny harmonogram potwierdzamy przy każdej wycenie.",
    logisticsFaqQ6: "Czy obowiązuje minimalna wielkość zamówienia?",
    logisticsFaqA6:
      "Wielkość zamówień ustalamy indywidualnie dla każdego projektu. Współpracujemy z operatorami różnej skali — od pierwszych partii pilotażowych po powtarzalne zamówienia wolumenowe. Porozmawiaj z nami o swoich potrzebach.",
    logisticsFinalEyebrow: "Wprawmy Twój sprzęt w ruch",
    logisticsFinalTitle: "Zaplanuj dostawy na cały świat",
    logisticsFinalBody:
      "Powiedz nam, dokąd mają trafić Twoje urządzenia i jak szybko. Przygotujemy plan dostawy — produkcja, opakowania, fracht i odprawa celna — oraz jeden zespół, który go zrealizuje.",
    logisticsFinalCta: "Porozmawiaj z naszym zespołem",
    logisticsFinalCtaSecondary: "Znajdź dystrybutora",
    productsIndexEyebrow: "Sprzęt",
    productsIndexTitle: "Oferta produktów inext",
    productsIndexSubtitle:
      "Dekodery 4K z Androidem stworzone dla operatorów — wraz z oryginalnymi akcesoriami i narzędziami potrzebnymi w każdym wdrożeniu.",
    productsIndexMoreHeading: "Zobacz więcej",
    productsIndexArchiveDesc: "Specyfikacje i zdjęcia wycofanych modeli inext.",
    productsIndexCardCta: "Dowiedz się więcej",
    productsIndexSeoTitle: "Produkty — dekodery z Androidem i akcesoria | inext",
    productsIndexSeoDescription:
      "Poznaj pełną ofertę inext: dekodery 4K z Androidem, oryginalne akcesoria, porównanie modeli i archiwum wycofanych urządzeń.",
    solutionsIndexEyebrow: "Platforma i usługi",
    solutionsIndexTitle: "Rozwiązania na każdy etap Twojej usługi TV",
    solutionsIndexSubtitle:
      "Od zarządzania urządzeniami i firmware po aplikacje, z których codziennie korzystają abonenci — oprogramowanie i usługi obsługujące flotę inext.",
    solutionsIndexCardCta: "Dowiedz się więcej",
    solutionsIndexFlagship: "Flagowe",
    solutionsIndexSeoTitle:
      "Rozwiązania — zarządzanie urządzeniami, OTA, aplikacja IPTV i więcej | inext",
    solutionsIndexSeoDescription:
      "Poznaj rozwiązania inext: zarządzanie urządzeniami Alcatraz, zarządzanie aktualizacjami OTA, aplikację IPTV, aplikację inext Remote, personalizację i globalną logistykę.",
    verimatrixNote:
      "Certyfikowany partner Verimatrix — nasze dekodery i aplikacja IPTV są natywnie zintegrowane z dostępem warunkowym Verimatrix VCAS i multi-DRM.",
    solutionsRow1Title: "Zarządzaj całą flotą z jednego miejsca",
    solutionsRow1Body:
      "Alcatraz analizuje telemetrię, porządkuje wykryte problemy w priorytetowej kolejce Fleet Health, zapisuje historię aktywności urządzeń oraz obsługuje kontrolowane wdrażanie firmware i zdalną diagnostykę.",
    solutionsRow2Title: "Interfejs, z którego codziennie korzystają abonenci",
    solutionsRow2Body:
      "Aplikacja IPTV pod marką operatora i bezpłatny pilot mobilny zmieniają dekoder inext w wygodną, spójną usługę telewizyjną.",
    solutionsRow3Title: "Twoja marka — od projektu po dostawę",
    solutionsRow3Body:
      "Sprzęt i firmware white-label przygotowane według Twojej specyfikacji oraz dostawa na cały świat — wszystkie etapy koordynuje jeden zespół.",
    solutionsAllTitle: "Wszystkie rozwiązania, jedna platforma",
    navGuides: "Poradniki",
    footerGuides: "Poradniki",
    footerLinkGuidesAndroidLinux: "Android czy Linux",
    guidesBreadcrumbHome: "Strona główna",
    guidesIndexEyebrow: "Poradniki",
    guidesIndexTitle: "Poradniki ułatwiające wybór platformy TV",
    guidesIndexSubtitle:
      "Rzetelne, praktyczne materiały o decyzjach podejmowanych przez operatorów: sprzęcie, systemie, modelu własności urządzeń, finansowaniu i dystrybucji. Dostarczamy kompletny ekosystem, dlatego możemy uczciwie porównywać dostępne warianty.",
    guidesIndexAllTitle: "Wszystkie poradniki",
    guidesIndexCardCta: "Przeczytaj poradnik",
    guidesIndexSeoTitle: "Poradniki — jak wybrać i prowadzić platformę TV | inext",
    guidesIndexSeoDescription:
      "Praktyczne, neutralne poradniki dla operatorów IPTV i OTT — wybór platformy, wdrożenie i decyzje stojące za prowadzeniem floty dekoderów.",
    tcoCardTitle: "Kalkulator TCO dekoderów",
    tcoCardDesc:
      "Porównaj całkowity koszt dwóch scenariuszy wdrożenia dekoderów, uwzględniając zakup sprzętu, wymiany, wsparcie, wizyty serwisowe i zarządzanie flotą.",
    tcoCardCta: "Otwórz kalkulator",
    tcoSeoTitle: "Kalkulator TCO dekoderów — porównanie kosztów floty | inext",
    tcoSeoDescription:
      "Oszacuj i porównaj całkowity koszt posiadania dla dwóch scenariuszy wdrożenia dekoderów IPTV lub OTT, uwzględniając zakup sprzętu, wymiany, wsparcie, wizyty serwisowe i zarządzanie urządzeniami.",
    tcoBreadcrumbPage: "Kalkulator TCO dekoderów",
    tcoHeroEyebrow: "Interaktywne narzędzie do planowania",
    tcoHeroTitle: "Kalkulator całkowitego kosztu posiadania dekoderów",
    tcoHeroBody:
      "Porównaj dwa scenariusze wdrożenia dekoderów w całym okresie eksploatacji. Zobacz, jak cena zakupu, awaryjność, obsługa abonentów, wizyty serwisowe i zarządzanie urządzeniami wpływają na rzeczywisty koszt jednego urządzenia.",
    tcoExampleNotice:
      "Wstępnie wypełnione wartości są jedynie przykładem — nie stanowią oferty ani gwarancji oszczędności. Zastąp je rzeczywistymi danymi operacyjnymi i wartościami z ofert dostawców.",
    tcoInputsEyebrow: "Dane wejściowe",
    tcoInputsTitle: "Utwórz dwa scenariusze do porównania",
    tcoInputsBody:
      "Wprowadź wspólne dla obu scenariuszy liczbę urządzeń, okres eksploatacji i walutę, a następnie określ koszty oraz parametry operacyjne każdego scenariusza.",
    tcoReset: "Przywróć wartości przykładowe",
    tcoFleetSize: "Liczba urządzeń we flocie",
    tcoOwnershipPeriod: "Okres eksploatacji, lata",
    tcoCurrency: "Waluta obliczeń",
    tcoScenarioLabel: "Scenariusz wdrożenia",
    tcoScenarioA: "Scenariusz A",
    tcoScenarioB: "Scenariusz B",
    tcoFieldUnitPrice: "Cena zakupu jednego urządzenia",
    tcoFieldLogistics: "Koszt logistyki na urządzenie",
    tcoFieldSetup: "Jednorazowy koszt konfiguracji i personalizacji",
    tcoFieldFailureRate: "Roczny wskaźnik awarii, %",
    tcoFieldReplacement: "Koszt jednej wymiany",
    tcoFieldSupportContacts: "Zgłoszenia do wsparcia na 1000 urządzeń rocznie",
    tcoFieldSupportCost: "Koszt jednego zgłoszenia do wsparcia",
    tcoFieldTruckRolls: "Wizyty serwisowe na 1000 urządzeń rocznie",
    tcoFieldTruckRollCost: "Koszt jednej wizyty serwisowej",
    tcoFieldDmsCost: "Zarządzanie jednym urządzeniem miesięcznie",
    tcoDmsIncludedNote:
      "Zarządzanie urządzeniami: Alcatraz Pro jest dostępny bez dodatkowych opłat, dopóki flota liczy mniej niż 500 aktywnych urządzeń inext. Dla flot liczących co najmniej 500 aktywnych urządzeń skontaktuj się z inext, aby omówić warunki komercyjne.",
    tcoResultsEyebrow: "Porównanie",
    tcoResultsTitle: "Szacowany koszt w całym okresie eksploatacji",
    tcoLowerResult: "{scenario}: o {amount} ({percent}%) mniej",
    tcoEqualResult: "Oba scenariusze mają taki sam szacowany TCO",
    tcoComparisonNote:
      "Obliczenie opiera się na danych wprowadzonych powyżej. W przypadku dużej floty koszty operacyjne mogą mieć większy wpływ niż niewielka różnica w cenie zakupu.",
    tcoTotalLabel: "Całkowity koszt w wybranym okresie",
    tcoPerDevice: "Koszt w przeliczeniu na urządzenie",
    tcoPerDeviceMonth: "Miesięczny koszt jednego urządzenia",
    tcoCostProcurement: "Zakup sprzętu",
    tcoCostLogistics: "Logistyka",
    tcoCostSetup: "Wdrożenie i personalizacja",
    tcoCostReplacements: "Wymiana sprzętu",
    tcoCostSupport: "Obsługa abonentów",
    tcoCostFieldService: "Wizyty serwisowe",
    tcoCostManagement: "Zarządzanie urządzeniami",
    tcoMethodEyebrow: "Model obliczeń",
    tcoMethodTitle: "Co uwzględnia kalkulacja TCO",
    tcoMethodBody:
      "Całkowity koszt posiadania obejmuje nie tylko początkowy zakup, ale także późniejsze koszty operacyjne. Model jest celowo przejrzysty, aby każde założenie można było zastąpić rzeczywistymi danymi operacyjnymi.",
    tcoMethod1Title: "Początkowe wdrożenie",
    tcoMethod1Body:
      "Koszty urządzeń i logistyki są obliczane dla całej floty. Konfiguracja i personalizacja są uwzględniane jednorazowo.",
    tcoMethod2Title: "Koszty w okresie eksploatacji",
    tcoMethod2Body:
      "Liczba awarii, zgłoszeń do wsparcia i wizyt serwisowych oraz miesięczne koszty zarządzania urządzeniami są prognozowane dla całego wybranego okresu eksploatacji.",
    tcoMethod3Title: "Koszty jednostkowe do porównania",
    tcoMethod3Body:
      "Łączny koszt jest przedstawiany jako koszt jednego urządzenia i miesięczny koszt jednego urządzenia, co ułatwia porównanie scenariuszy o różnych cenach zakupu.",
    tcoCtaTitle: "Zweryfikuj kalkulację na rzeczywistym sprzęcie",
    tcoCtaBody:
      "Kalkulator pomaga zawęzić listę wariantów. Wdrożenie testowe pozwala zweryfikować stabilność urządzeń, procesy wsparcia, zdalną diagnostykę i rzeczywiste koszty operacyjne.",
    tcoCtaButton: "Omów wdrożenie",
    footerLinkGuidesTco: "Kalkulator TCO dekoderów",
    guidesCardAvlTitle: "Dekoder Android czy Linux",
    guidesCardAvlDesc:
      "Która platforma pasuje do Twojej sieci? Uczciwe porównanie — ekosystem aplikacji, koszty, kontrola i sytuacje, w których wygrywa każda z nich.",
    avlSeoTitle: "Dekoder Android czy Linux: jak wybrać | inext",
    avlSeoDescription:
      "Android TV czy Linux dla Twojej floty dekoderów? Uczciwe, neutralne porównanie od inext — dostarczamy obie platformy. Ekosystem aplikacji, koszty, kontrola i sytuacje, w których wygrywa każda z nich.",
    avlBreadcrumbPage: "Dekoder Android czy Linux",
    avlHeroEyebrow: "Poradnik platformowy",
    avlHeroTitle: "Dekoder Android czy Linux:",
    avlHeroTitleAccent: "która platforma pasuje do Twojej sieci?",
    avlHeroSub:
      "Wiele porównań Androida z Linuksem przygotowują dostawcy oferujący tylko jedną z tych platform, dlatego neutralny poradnik łatwo zmienia się w materiał sprzedażowy. Każdy dekoder inext może działać na Androidzie albo na lekkiej wersji Linuksa, więc nie mamy powodu faworyzować żadnej opcji. Poniżej przedstawiamy różnice bez marketingowych uproszczeń.",
    avlHeroNote:
      "Dostarczamy obie platformy — więc w tym porównaniu nikt nie przechyla szali na żadną stronę.",
    avlHeroCtaPrimary: "Porozmawiaj z naszym zespołem",
    avlHeroCtaSecondary: "Zobacz porównanie",
    avlDefineEyebrow: "Zacznij tutaj",
    avlDefineTitle: "Najpierw ustalmy, o czym właściwie mowa",
    avlDefineBody:
      "Obie platformy mogą działać na tym samym sprzęcie, ale zapewniają zupełnie inne możliwości. Na potrzeby tego porównania traktujemy je jako dwa odrębne warianty produktu:",
    avlDefineAndroidLabel: "Android",
    avlDefineAndroidBody:
      "platforma Android TV — uruchamia ekosystem aplikacji Android za launcherem, który możesz oznaczyć własną marką, dzięki czemu abonenci dostają znajome aplikacje i interfejs.",
    avlDefineLinuxLabel: "Linux",
    avlDefineLinuxBody:
      "lekka wersja zbudowana pod konkretny cel, zawierająca wyłącznie Twoją aplikację IPTV, Twoje oprogramowanie pośredniczące i narzędzia, które tam umieścisz — bez sklepu z aplikacjami, bez warstwy Androida.",
    avlDefineCandid:
      "Około 95% operatorów, z którymi pracujemy, wybiera Androida, choć w niektórych regionach Linux jest wyraźnie popularniejszy. Wyjaśniamy, skąd wynika ta różnica i kiedy Linux okazuje się lepszym wyborem.",
    avlVerdictEyebrow: "Szybki werdykt",
    avlVerdictTitle: "Sprawdź, który opis pasuje do Twojej usługi",
    avlVerdictAndroidTitle: "Wybierz Androida, jeśli…",
    avlVerdictAndroid1:
      "Zależy Ci na ekosystemie aplikacji Android — popularnych aplikacjach streamingowych i OTT, które Twoi abonenci już znają",
    avlVerdictAndroid2:
      "Chcesz zaoferować abonentom znajomy interfejs telewizyjny bez budowania go od podstaw",
    avlVerdictAndroid3:
      "Musisz wystartować szybko i zachować otwartą drogę do kolejnych aplikacji w przyszłości",
    avlVerdictAndroid4:
      "W Twojej ofercie liczy się duży, znany katalog aplikacji i interfejs znany z urządzeń konsumenckich",
    avlVerdictLinuxTitle: "Wybierz Linuksa, jeśli…",
    avlVerdictLinux1:
      "Prowadzisz czystą, zarządzaną usługę IPTV — własna aplikacja, własny zamknięty ekosystem i nic poza tym",
    avlVerdictLinux2:
      "Zależy Ci na najlżejszej platformie i najniższych kosztach utrzymania na tym samym sprzęcie",
    avlVerdictLinux3:
      "Potrzebujesz maksymalnej kontroli i pełnego zablokowania urządzenia, bez sklepu z aplikacjami",
    avlVerdictLinux4: "Aplikacje OTT innych firm nie są częścią Twojej oferty",
    avlVerdictFootnote:
      "Jeśli większość argumentów przemawia za Androidem, wybierasz tak jak około 95% naszych klientów. Jeśli lepiej pasuje opis Linuksa, warto dokładniej przeanalizować ten wariant.",
    avlCoreEyebrow: "Sedno różnicy",
    avlCoreTitle: "Ekosystem aplikacji kontra lekkość i kontrola",
    avlCoreBody1:
      "Po odrzuceniu szczegółów wybór sprowadza się do jednego kompromisu: bogaty ekosystem aplikacji i znajomy interfejs albo lekka platforma i pełna kontrola.",
    avlCoreBody2:
      "Android zapewnia abonentom środowisko, które już znają: własną aplikację operatora, popularne aplikacje streamingowe i OTT oraz launcher pod marką operatora. Dostęp do szerokiego katalogu aplikacji sprawia, że wybiera go zdecydowana większość operatorów.",
    avlCoreBody3:
      "Linux ma inne zalety: pozwala stworzyć maksymalnie odchudzone urządzenie, które wykonuje tylko ściśle określone zadania. Bez sklepu z aplikacjami i usług Google — wyłącznie z aplikacją IPTV operatora oraz zatwierdzonymi narzędziami. Dzięki temu platforma jest lżejsza, tańsza w utrzymaniu i łatwiejsza do zablokowania.",
    avlCoreBody4:
      "W większości przypadków decyduje dostęp do aplikacji OTT, które powstają przede wszystkim na Androida. Dekoder z Linuksem ich nie uruchomi bez osobnej integracji przygotowanej dla każdej aplikacji, co zwykle jest niepraktyczne. Jeśli abonenci oczekują takich aplikacji, naturalnym wyborem staje się Android. W zamkniętej usłudze IPTV zalety Linuksa pozostają jednak w pełni istotne.",
    avlTableEyebrow: "Obok siebie",
    avlTableTitle: "Android kontra Linux, wiersz po wierszu",
    avlTableColDimension: "",
    avlTableColAndroid: "Android",
    avlTableColLinux: "Linux",
    avlRow1Dim: "Ekosystem aplikacji OTT (Netflix, YouTube, Disney+)",
    avlRow1Android: "Uruchamia ekosystem aplikacji Android — Twoja aplikacja plus aplikacje OTT",
    avlRow1Linux: "Brak aplikacji Android — tylko klient, który zbudujesz",
    avlRow2Dim: "Interfejs znany abonentom",
    avlRow2Android: "Znany interfejs Android TV",
    avlRow2Linux: "W pełni własny interfejs operatora",
    avlRow3Dim: "Marka i personalizacja",
    avlRow3Android: "Launcher pod Twoją marką, szeroka personalizacja",
    avlRow3Linux: "Pełna kontrola nad każdym pikselem i zachowaniem",
    avlRow4Dim: "Zablokowanie w modelu zamkniętego ekosystemu",
    avlRow4Android: "Możliwe, wymaga konfiguracji",
    avlRow4Linux: "Naturalne — nie ma żadnego sklepu z aplikacjami do zablokowania",
    avlRow5Dim: "Obciążenie tego samego dekodera",
    avlRow5Android: "Potrzebuje większego zapasu RAM-u i pamięci",
    avlRow5Linux: "Działa lżej; pozwala dobrać dekoder z niższej półki",
    avlRow6Dim: "Czas uruchamiania i zużycie zasobów",
    avlRow6Android: "Cięższy",
    avlRow6Linux: "Lżejszy, szybszy start",
    avlRow7Dim: "Aktualizacje platformy i zabezpieczeń",
    avlRow7Android: "Baza platformy Android plus Twoje OTA",
    avlRow7Linux: "W pełni zarządzane przez operatora/inext za pośrednictwem OTA",
    avlRow9Dim: "DRM / ochrona treści",
    avlRow9Android: "Widevine i Verimatrix",
    avlRow9Linux: "Widevine i Verimatrix",
    avlRow10Dim: "Tempo prac i dostępność specjalistów",
    avlRow10Android: "Duży ekosystem, szybko",
    avlRow10Linux: "Więcej prac specjalistycznych i rozwiązań indywidualnych",
    avlRow12Dim: "Cykl życia i niezależność",
    avlRow12Android: "Podąża za rytmem platformy Google",
    avlRow12Linux: "Bez zewnętrznych zależności — operator decyduje o długości cyklu życia",
    avlRowAppDim: "Aplikacja kliencka inext",
    avlRowAppAndroid: "Gotowa aplikacja IPTV i launcher — oba pod Twoją marką",
    avlRowAppLinux: "SDK i API do szybkiego budowania i integracji",
    avlRowInextDim: "Zarządzanie w ekosystemie inext",
    avlStackLabel: "Tak samo na obu:",
    avlStackAlcatraz: "Alcatraz DMS",
    avlStackOta: "OTA",
    avlStackTr069: "TR-069",
    avlStackCustomization: "personalizacja",
    avlTableNote:
      "DRM i dokładna specyfika platformy zależą od dekodera i wersji oprogramowania — powiedz nam, czego wymaga Twoje wdrożenie, a my to potwierdzimy.",
    avlDecideEyebrow: "Co naprawdę przesądza wybór",
    avlDecideTitle: "Pytania, które rozstrzygają większość decyzji",
    avlDecide1Title: "Ekosystem aplikacji",
    avlDecide1Body:
      "To główny powód przewagi Androida. Popularne aplikacje OTT — Netflix, YouTube, Disney+ czy Prime Video — powstają na Androida i działają w jego ekosystemie. Dekoder z Linuksem ich nie uruchomi bez indywidualnej integracji, która dla większości operatorów jest nieopłacalna. Jeśli abonenci oczekują takich aplikacji, właściwym wyborem będzie Android. W zamkniętym pakiecie IPTV ta wada Linuksa nie ma znaczenia.",
    avlDecide2Title: "Koszt i obciążenie sprzętu",
    avlDecide2Body:
      "Ponieważ obie platformy mogą działać na tym samym dekoderze, sam Linux nie obniża ceny sprzętu. Ma jednak mniejsze wymagania dotyczące RAM-u i pamięci, dlatego we wdrożeniu ograniczonym do IPTV można wybrać tańszy model, taki jak inext TV5, i nadal uzyskać płynne działanie. Android potrzebuje w tej samej roli większego zapasu zasobów, co przy dużej flocie przekłada się na realne koszty.",
    avlDecide3Title: "Kontrola, bezpieczeństwo i zablokowanie urządzenia",
    avlDecide3Body:
      "Linux jest naturalnym wyborem, gdy urządzenie ma wykonywać wyłącznie ściśle określone zadania. Brak sklepu i możliwości instalowania aplikacji z innych źródeł zmniejsza powierzchnię ataku, a system zawiera tylko zatwierdzone elementy. Androida również można zablokować, ale wymaga to utrzymywania odpowiedniej konfiguracji na większej, stale rozwijanej platformie. We wdrożeniach kioskowych, regulowanych lub ściśle zarządzanych prostota Linuksa staje się istotną zaletą.",
    avlDecide4Title: "Czas wprowadzenia na rynek",
    avlDecide4Body:
      "Android pozwala szybciej uruchomić produkt przeznaczony dla szerokiego grona abonentów: launcher, aplikacje i znany interfejs już istnieją i wymagają głównie dostosowania do marki operatora. W przypadku Linuksa większą część interfejsu trzeba zbudować lub przenieść samodzielnie. Zapewnia to pełną kontrolę, ale zwiększa zakres prac początkowych. Obie ścieżki skracamy dzięki gotowej aplikacji IPTV i personalizacji na Androidzie oraz SDK i API na Linuksie.",
    avlDecide5Title: "Cykl życia i niezależność",
    avlDecide5Body:
      "Android rozwija się zgodnie z cyklem platformy Google, w tym jej nowymi wersjami i wymaganiami dotyczącymi zgodności aplikacji. Zwykle jest to zaleta, ale oznacza również zewnętrzną zależność. Wersję Linuksa można utrzymywać bez takiego ograniczenia: zamrozić ją lub rozwijać we własnym tempie. Ma to znaczenie we wdrożeniach o bardzo długim cyklu życia oraz tam, gdzie wymagana jest maksymalna niezależność od zewnętrznych platform.",
    avlProfilesEyebrow: "Która jest dla Ciebie?",
    avlProfilesTitle: "Dopasuj usługę do platformy",
    avlProfile1Title: "Operator IPTV + OTT",
    avlProfile1Pick: "Android",
    avlProfile1Body:
      "Abonenci oczekują zarówno kanałów operatora, jak i popularnych aplikacji streamingowych. Ten wariant wybiera około 95% naszych klientów.",
    avlProfile2Title: "Czyste zarządzane IPTV / zamknięty ekosystem",
    avlProfile2Pick: "Linux",
    avlProfile2Body: "Tylko Twoja aplikacja, bez OTT innych firm. Wart poważnego rozważenia.",
    avlProfile3Title: "Wdrożenie nastawione na koszt, o dużym wolumenie",
    avlProfile3Pick: "Linux",
    avlProfile3Body:
      "Gdy oferta obejmuje własny, zamknięty pakiet, Linux na tańszym dekoderze pozwala lepiej wykorzystać budżet.",
    avlProfile4Title: "Ściśle kontrolowane / kioskowe / regulowane",
    avlProfile4Pick: "Linux",
    avlProfile4Body:
      "Gdy pełne zablokowanie jest twardym wymogiem, lżejszą platformę łatwiej zabezpieczyć.",
    avlProfile5Title: "Niepewny / chcę zostawić sobie otwarte opcje",
    avlProfile5Pick: "Android",
    avlProfile5Body: "Bezpieczny wybór domyślny, który zostawia najwięcej otwartych drzwi.",
    avlSameEyebrow: "Cokolwiek wybierzesz",
    avlSameTitle: "Pozostałe elementy ekosystemu są takie same",
    avlSameBody:
      "Każdy dekoder inext — z Androidem lub Linuksem — korzysta z tego samego ekosystemu operacyjnego: Alcatraz DMS do zarządzania flotą, etapowych aktualizacji OTA, TR-069 i personalizacji white-label. Różni się jedynie oprogramowanie klienckie. Na Androidzie dostępne są gotowa aplikacja IPTV i launcher pod marką operatora, a na Linuksie — SDK i API przyspieszające budowę oraz integrację. W obu przypadkach zachowujesz te same narzędzia do zarządzania flotą.",
    avlLockTitle: "Ten sam sprzęt — wybierz platformę zgodnie z potrzebami",
    avlLockBody:
      "Android czy Linux to wybór firmware'u na dokładnie tym samym dekoderze, a nie inny produkt. Możesz przetestować obie platformy przed podjęciem decyzji albo prowadzić flotę mieszaną. Przełączenie dekodera między platformami później jest możliwe, ale to ponowne wgranie firmware'u, a nie rutynowa aktualizacja OTA — dlatego najlepiej wybrać platformę, przy której zamierzasz zostać, i się jej trzymać. Decyzja o sprzęcie jest mało ryzykowna; decyzję o platformie warto podjąć z rozwagą.",
    avlFaqEyebrow: "FAQ",
    avlFaqTitle: "Częste pytania",
    avlFaqQ1: "Czy mogę uruchomić Netflix na dekoderze z Linuksem?",
    avlFaqA1:
      "Zazwyczaj nie. Netflix, YouTube i Disney+ powstają jako aplikacje Android; dekoder z Linuksem ich nie uruchomi, a dodanie aplikacji innej firmy to indywidualna, często niepraktyczna integracja. Jeśli te aplikacje są ważne dla Twojej oferty, wybierz Androida.",
    avlFaqQ2: "Czy Android jest droższy niż Linux?",
    avlFaqA2:
      "Sprzęt to ten sam dekoder inext, więc platforma nie jest osobną pozycją w kosztach. Android potrzebuje nieco większego zapasu RAM-u i pamięci, więc do czysto iptv-owej roli Linux pozwala dobrać dekoder z niższej półki.",
    avlFaqQ3: "Czy mogę później przejść z Linuksa na Androida albo z powrotem?",
    avlFaqA3:
      "Jest to możliwe, ale nie jest to rutynowa aktualizacja OTA — przeniesienie dekodera między Androidem a Linuksem oznacza ponowne wgranie firmware'u, co jest bardziej złożone. To i tak ten sam sprzęt, więc nie kupujesz innych urządzeń, ale zalecamy trzymanie się platformy, przy której zamierzasz zostać.",
    avlFaqQ4: "Co wybiera większość operatorów?",
    avlFaqA4:
      "Około 95% wybiera Androida, bo ich abonenci oczekują popularnych aplikacji OTT — choć w niektórych regionach Linux jest zauważalnie częstszy. Linux wygrywa przy czystym zarządzanym IPTV, przy zablokowaniu urządzenia i przy wdrożeniach o najmniejszym obciążeniu sprzętu.",
    avlFaqQ5: "Czy zarządzanie urządzeniami inext działa na obu platformach?",
    avlFaqA5:
      "Tak — Alcatraz DMS, aktualizacje OTA i TR-069 działają tak samo w wersjach na Androida i na Linuksa.",
    avlCtaEyebrow: "Porozmawiaj z nami",
    avlCtaTitle: "Nie wiesz, co pasuje do Twojego wdrożenia?",
    avlCtaBody:
      "Opowiedz nam o swojej usłudze, a my uczciwie zarekomendujemy platformę — łącznie z sytuacją, gdy będzie to Linux.",
    avlCtaPrimary: "Porozmawiaj z naszym zespołem",
    avlCtaSecondary: "Poproś o wersję firmware'u na Linuksa",
    footerLinkGuidesAospCert: "AOSP czy certyfikacja",
    guidesCardAcTitle: "AOSP a Certyfikowany Android TV",
    guidesCardAcDesc:
      "Czego naprawdę potrzebuje Twoje wdrożenie? Certyfikowany ekosystem aplikacji kontra szybkość, koszt i kontrola — i jak dostarczamy jedno i drugie.",
    acSeoTitle: "AOSP a Certyfikowany Android TV: czego potrzebuje Twoje wdrożenie? | inext",
    acSeoDescription:
      "AOSP czy certyfikowany przez Google Android TV w Twoim wdrożeniu operatorskim? Szczere porównanie od inext — dostarczamy jedno i drugie. Ekosystem aplikacji, koszt, czas wejścia na rynek i kiedy certyfikacja naprawdę się opłaca.",
    acBreadcrumbPage: "AOSP a Certyfikowany Android TV",
    acHeroEyebrow: "Przewodnik po platformach",
    acHeroTitle: "AOSP a Certyfikowany Android TV:",
    acHeroTitleAccent: "czego naprawdę potrzebuje Twoje wdrożenie?",
    acHeroSub:
      "Obie platformy to Android — różni je certyfikacja Google oraz czas, koszt i kontrola, które za nią oddajesz. AOSP budujemy sami, więc nie będziemy udawać bezstronnych: dla większości operatorów to szybszy, tańszy i bardziej elastyczny wybór, i taka jest nasza szczera rekomendacja — a gdy projekt naprawdę wymaga certyfikacji, ją również dostarczamy, razem z naszymi certyfikowanymi partnerami 3PL. Na tej stronie rozkładamy ten kompromis na czynniki pierwsze, żebyś sam ocenił, czego potrzebuje Twoje wdrożenie.",
    acHeroNote:
      "Większość operatorów wdraża AOSP. Gdy projekt naprawdę wymaga certyfikacji, ją również dostarczamy.",
    acHeroCtaPrimary: "Porozmawiaj z naszym zespołem",
    acHeroCtaSecondary: "Zobacz porównanie",
    acDefineEyebrow: "Zacznij tutaj",
    acDefineTitle: "Najpierw: co tak naprawdę zmienia „certyfikacja”",
    acDefineBody:
      "Obie działają na Androidzie. Granicę między nimi wyznacza program certyfikacji Google — i wszystko, co się z nim wiąże:",
    acDefineAospLabel: "AOSP",
    acDefineAospBody:
      "Android w wersji open source, w pełni Twój — Twój launcher, Twoje aplikacje, Twoje zasady. Bez sklepu Google Play i bez procesu certyfikacji Google, ale z obsługą Widevine L1 i L3, dzięki czemu — przy odpowiednich umowach operatorskich — może uruchamiać aplikacje premium, takie jak Netflix. Pozwala wejść na rynek znacznie szybciej i taniej.",
    acDefineCertLabel: "Certyfikowany Android TV",
    acDefineCertBody:
      "Certyfikowany przez Google, z wbudowanym Google Play, Widevine L1, Google Assistant i Chromecast — fundament certyfikowanego ekosystemu aplikacji — kosztem licencji, akceptacji i harmonogramu Google.",
    acStat1: "1–2 tygodnie do działającej próbki",
    acStat2: "Zero opłat Google od urządzenia w AOSP",
    acStat3: "Obie platformy, jeden partner",
    acPivotEyebrow: "Zacznij tutaj",
    acPivotTitle: "Zwykle sprowadza się to do jednego pytania",
    acPivotQuestion:
      "Czy Twoi abonenci potrzebują otwartego sklepu Google Play — samoobsługowego katalogu tysięcy aplikacji — a do tego Google Assistant i Chromecast?",
    acPivotNoLabel: "Nie — kontrolowane przez operatora, dopracowane środowisko",
    acPivotNoPick: "AOSP",
    acPivotNoText:
      "Stawiasz na własną usługę i wybrany zestaw aplikacji — w tym Netflix i inne aplikacje premium tam, gdzie masz umowę operatorską. Szybciej, taniej, w pełni Twoje.",
    acPivotYesLabel: "Tak — otwarty, konsumencki sklep z aplikacjami",
    acPivotYesPick: "Certyfikacja",
    acPivotYesText:
      "Chcesz, by częścią produktu był pełny, samoobsługowy Play Store i usługi Google. Wart licencji i dłuższego harmonogramu.",
    acPivotFootnote:
      "Większość operatorów odpowiada „nie” i wdraża AOSP. W którąkolwiek stronę się skłaniasz, my to dostarczymy.",
    acTimelineEyebrow: "Czas wejścia na rynek",
    acTimelineTitle: "Dwie drogi do startu",
    acTimelineIntro:
      "Największa praktyczna różnica nie tkwi w technologii — chodzi o to, ile czasu zajmuje wejście na rynek i ile to kosztuje.",
    acTimelineAospLabel: "AOSP z inext",
    acTimelineAospResult: "~2 miesiące do wysyłki",
    acTimelineAospStep1: "Dostosuj launcher, aplikację i usługi do swojej marki",
    acTimelineAospStep2: "Potwierdź działającą próbkę — mniej więcej po 1–2 tygodniach",
    acTimelineAospStep3: "Wdrażaj",
    acTimelineCertLabel: "Certyfikowany Android TV",
    acTimelineCertResult: "5–8 miesięcy do wysyłki",
    acTimelineCertStep1: "Zalicencjonuj GMS, dobierz sprzęt zatwierdzony przez Google",
    acTimelineCertStep2: "Zbuduj i zintegruj",
    acTimelineCertStep3: "Testy certyfikacyjne",
    acTimelineCertStep4: "Akceptacja Google",
    acTimelineCertStep5: "Wdrażaj",
    acTimelineNote:
      "Nasza platforma AOSP jest już gotowa, dlatego czas potrzebny na jej opracowanie od podstaw nie opóźnia projektu. Jeśli wymagana jest certyfikacja, prowadzimy również ten proces razem z certyfikowanymi partnerami 3PL.",
    acIncludesEyebrow: "Co otrzymujesz",
    acIncludesTitle: "Nasz AOSP to kompletna platforma gotowa do wdrożenia",
    acIncludesBody:
      "Wszystko poniżej jest już zbudowane, sprawdzone i dostosowane do Twojej marki. Dokładny zestaw aplikacji dobieramy do Twojego kraju i licencji, dlatego nie wymieniamy go tutaj.",
    acIncludes1:
      "Konfigurowalny launcher w warstwie Operator Tier — Twoja marka i treści na pierwszym planie zaraz po uruchomieniu",
    acIncludes2: "Nasza aplikacja IPTV pod Twoją marką",
    acIncludes3:
      "Lokalne usługi telewizyjne i streamingowe preinstalowane dla danego rynku, a przy odpowiedniej umowie także aplikacje premium, takie jak Netflix",
    acIncludes4: "Zarządzane przez Alcatraz DMS, OTA i TR-069 od pierwszego dnia",
    acIncludes5: "Dostosowane i potwierdzone działającą próbką w 1–2 tygodnie",
    acTableEyebrow: "Pełne porównanie",
    acTableTitle: "Najważniejsze różnice między AOSP a certyfikacją",
    acTableColDimension: "",
    acTableColAosp: "AOSP",
    acTableColCert: "Certyfikowany Android TV",
    acRow1Dim: "Sklep Google Play",
    acRow1Aosp: "Bez Play Store — Twój własny sposób dostarczania aplikacji",
    acRow1Cert: "Wbudowany — tysiące aplikacji",
    acRow2Dim: "Aplikacje premium (Netflix, Disney+ w HD/4K)",
    acRow2Aosp: "Działają tam, gdzie Twoja sieć ma umowę operatorską — nasz AOSP to Widevine L1",
    acRow2Cert: "Tak samo, plus dystrybucja przez Google Play; umowa operatorska nadal obowiązuje",
    acRow3Dim: "Google Assistant i Chromecast",
    acRow3Aosp: "Niedołączone (lub na zamówienie)",
    acRow3Cert: "Wbudowane",
    acRow4Dim: "DRM Widevine",
    acRow4Aosp: "Widevine L1 i L3 w dekoderach inext",
    acRow4Cert: "Widevine L1 i L3",
    acRow5Dim: "Launcher / ekran główny operatora",
    acRow5Aosp: "W pełni własny, na pierwszym planie po uruchomieniu — pełna kontrola",
    acRow5Cert: "Launcher w warstwie Operator Tier, w ramach zasad Google",
    acRow6Dim: "Aplikacje fabryczne i usługi lokalne",
    acRow6Aosp: "Dokładnie to, czego potrzebuje Twój rynek — Twoja decyzja",
    acRow6Cert: "Model Google Play, plus Twoje uzupełnienia",
    acRow7Dim: "Swoboda personalizacji",
    acRow7Aosp: "Pełna",
    acRow7Cert: "W ramach programu Google",
    acRow8Dim: "Sprzęt",
    acRow8Aosp: "Działa na oszczędnych, zoptymalizowanych kosztowo dekoderach",
    acRow8Cert: "Sprzęt o wyższej specyfikacji, zatwierdzony przez Google",
    acRow9Dim: "Czas wejścia na rynek",
    acRow9Aosp: "~2 miesiące do wysyłki (działająca próbka w 1–2 tygodnie)",
    acRow9Cert: "Zazwyczaj 5–8 miesięcy do wysyłki",
    acRow10Dim: "Koszt",
    acRow10Aosp: "Bez licencji GMS i bez opłat Google od urządzenia",
    acRow10Cert: "Licencja GMS, opłaty od urządzenia, koszty laboratorium testowego",
    acRow11Dim: "Zależność od Google",
    acRow11Aosp: "Brak",
    acRow11Cert: "Stała zgodność z wymaganiami Google",
    acRow12Dim: "Rozliczenia i płatności (sprzedaż abonentom)",
    acRow12Aosp:
      "Dowolna bramka płatnicza lub partner — własne rozliczenia, bez prowizji platformy",
    acRow12Cert:
      "Sprzedaż cyfrowa musi przechodzić przez płatności Google Play — Google pobiera prowizję",
    acRow13Dim: "Wgrywanie aktualizacji systemu/firmware",
    acRow13Aosp: "Możliwość szybkiego wdrożenia na całej flocie, bez zewnętrznej akceptacji",
    acRow13Cert:
      "Każda zmiana w systemie musi przejść przez Google lub laboratorium 3PL, zanim ją wgrasz",
    acTableNote:
      "Aplikacje premium, takie jak Netflix, wymagają własnej certyfikacji urządzenia, a jeśli dostawca internetu oferuje je w pakiecie — także bezpośredniej umowy operatorskiej, niezależnie od platformy. Nasz AOSP obsługuje Widevine L1, dlatego przy odpowiedniej umowie Netflix może działać bez certyfikacji Google. Dla każdego projektu potwierdzamy wymagania poszczególnych aplikacji.",
    acSameEyebrow: "Cokolwiek wybierzesz",
    acSameTitle: "Obie platformy od jednego partnera — zgodnie z potrzebami projektu",
    acSameBody:
      "AOSP jest naszym własnym produktem i zazwyczaj go rekomendujemy, ponieważ dla większości operatorów jest rozwiązaniem szybszym, tańszym i bardziej elastycznym. Nie proponujemy go jednak wtedy, gdy projekt rzeczywiście wymaga certyfikacji, ani nie zalecamy certyfikacji bez uzasadnienia. W razie potrzeby dostarczamy w pełni certyfikowany Android TV, prowadząc proces razem z certyfikowanymi partnerami 3PL. W obu wariantach operator współpracuje z jednym zespołem i korzysta z tych samych narzędzi operacyjnych.",
    acInhouseTitle: "AOSP — rozwijany przez nasz zespół",
    acInhouseBody:
      "Sprawdzony, w pełni konfigurowalny launcher w warstwie Operator Tier oraz aplikacja IPTV z lokalnymi usługami telewizyjnymi i streamingowymi preinstalowanymi dla danego rynku. Całość dostosowujemy do marki operatora i potwierdzamy na działającej próbce w ciągu 1–2 tygodni.",
    acPartnerTitle: "Certyfikowany Android TV — dostarczamy go z partnerami 3PL",
    acPartnerBody:
      "Gdy oferta wymaga Google Play, certyfikowanych aplikacji premium i Widevine L1, dostarczamy w pełni certyfikowany Android TV. Proces certyfikacji prowadzimy razem z certyfikowanymi partnerami 3PL, natomiast inext pozostaje jedynym punktem kontaktu i odpowiada za całość projektu.",
    acSameNoteTitle: "Jeden zestaw narzędzi obsługuje obie platformy",
    acSameNoteBody:
      "Na którąkolwiek platformę się zdecydujesz, flotą urządzeń zarządzają te same narzędzia operacyjne inext — Alcatraz DMS, etapowe OTA, TR-069 i personalizacja white-label. Wybór AOSP albo certyfikacji nie zmienia tego, jak pracujesz na co dzień.",
    acFaqEyebrow: "FAQ",
    acFaqTitle: "Najczęstsze pytania",
    acFaqQ1: "Czy mogę uruchomić Netflix na AOSP od inext?",
    acFaqA1:
      "Tak — tam, gdzie Twoja sieć ma umowę z Netflix. Nasz AOSP obsługuje Widevine L1, więc przy takiej umowie operatorskiej działa na nim w pełni funkcjonalna aplikacja Netflix, bez certyfikacji Google. To samo dotyczy innych usług premium, na które masz umowy: Ty wnosisz umowę, my dostarczamy platformę gotową na L1 oraz integrację.",
    acFaqQ2:
      "inext nie jest certyfikowanym dostawcą Android TV — czy mimo to możecie go dostarczyć?",
    acFaqA2:
      "Tak. AOSP budujemy we własnym zakresie, a dostarczamy także w pełni certyfikowany Android TV — prowadząc samą certyfikację razem z certyfikowanymi partnerami 3PL, gdzie inext jest głównym wykonawcą. Otrzymujesz obie opcje i jeden punkt kontaktu, a ścieżkę certyfikacji prowadzimy my, więc nie musisz składać tego samodzielnie.",
    acFaqQ3: "Jak szybko możecie dostarczyć rozwiązanie AOSP?",
    acFaqA3:
      "Nasza platforma AOSP jest już zbudowana i sprawdzona, więc dostosowanie jej do Twojej marki i dostarczenie Ci działającej próbki zajmuje zwykle 1–2 tygodnie. Od startu projektu do wysyłki towaru mija przeważnie około 2 miesięcy — w porównaniu z 5–8 miesiącami, których normalnie wymaga certyfikowany dekoder Android TV — choć zależy to od Twoich integracji, licencji i zamówienia.",
    acFaqQ4: "Co obejmuje platforma AOSP od inext?",
    acFaqA4:
      "Z konfigurowalnym launcherem Operator Tier, naszą aplikacją IPTV oraz lokalnymi usługami telewizyjnymi i streamingowymi preinstalowanymi dla danego rynku. Dokładny zestaw aplikacji zależy od kraju i licencji obowiązujących w regionie, dlatego dobieramy go osobno do każdego wdrożenia.",
    acFaqQ5: "Co wybiera większość operatorów?",
    acFaqA5:
      "Większość wybiera AOSP, ponieważ spełnia wymagania ich usług, skraca czas wejścia na rynek i obniża koszty, a przy odpowiedniej umowie operatorskiej obsługuje aplikacje premium, takie jak Netflix. Certyfikacja jest właściwym wyborem, gdy projekt wymaga otwartego sklepu Google Play i usług Google — ten wariant również dostarczamy.",
    acFaqQ6: "Czy zestaw narzędzi operacyjnych inext działa na obu platformach?",
    acFaqA6:
      "Tak — Alcatraz DMS, aktualizacje OTA i TR-069 zarządzają Twoją flotą urządzeń tak samo, niezależnie od tego, czy to AOSP, czy certyfikacja.",
    acFaqQ7: "Czy certyfikacja Google oznacza, że moi abonenci dostaną Netflix?",
    acFaqA7:
      "Nie. Netflix prowadzi własną certyfikację urządzeń i wymaga bezpośredniej umowy od operatorów oferujących usługę w pakiecie. Przy takiej umowie nasz AOSP z Widevine L1 może uruchamiać Netflix bez certyfikacji Google. Główną wartością certyfikacji Google są otwarty sklep Play oraz usługi Google, takie jak Assistant i Chromecast, a nie sam dostęp do aplikacji premium.",
    acFaqQ8: "Jeśli sprzedaję abonamenty lub treści, kto obsługuje rozliczenia?",
    acFaqA8:
      "W AOSP operator może korzystać z dowolnej bramki płatniczej lub wybranego partnera, bez prowizji platformy Google. W certyfikowanym Android TV dobra cyfrowe sprzedawane przez aplikację dystrybuowaną w Google Play muszą korzystać z płatności Google Play, od których Google pobiera prowizję. Przy dużej liczbie transakcji koszty szybko rosną, dlatego wielu operatorów pozostaje przy AOSP.",
    acFaqQ9: "Kto kontroluje aktualizacje firmware (OTA) na każdej z platform?",
    acFaqA9:
      "W AOSP kontrolę zachowuje operator: nowy firmware można przygotować i wdrożyć na całej flocie bez zewnętrznej akceptacji. W certyfikowanym Android TV każda zmiana na poziomie systemu musi zostać ponownie zweryfikowana przez Google lub wyznaczone laboratorium testowe 3PL, zanim trafi na urządzenia — także w warstwie Operator Tier. To istotna różnica dla operatorów, którzy często wprowadzają poprawki lub zmieniają konfigurację.",
    acCtaEyebrow: "Porozmawiaj z nami",
    acCtaTitle: "Nie masz pewności, czy Twoje wdrożenie wymaga certyfikacji?",
    acCtaBody:
      "Powiedz nam, czego oczekują Twoi abonenci i jak szybko musisz wejść na rynek. Zarekomendujemy dopasowaną platformę — AOSP albo certyfikację — i ją dostarczymy.",
    acCtaPrimary: "Porozmawiaj z naszym zespołem",
    acCtaSecondary: "Poproś o próbkę AOSP",
    footerLinkGuidesOwnStb: "Dekoder czy Smart TV",
    footerLinkGuidesBoxModels: "Dopłata, dzierżawa, sprzedaż",
    footerLinkGuidesMulticastOtt: "Multicast czy OTT",
    footerLinkGuidesBuildBuy: "Budować czy kupić",
    guidesCardOsTitle: "Własne dekodery czy Smart TV",
    guidesCardOsDesc:
      "Dostarczać dekoder pod własną marką czy polegać na telewizorach Smart TV abonentów? Najczęściej warto wykorzystać oba kanały, ale tylko własny dekoder zapewnia operatorowi pełną kontrolę.",
    guidesCardBmTitle: "Dopłacać do dekodera, dzierżawić czy sprzedać",
    guidesCardBmDesc:
      "Oddać dekoder, wynająć go czy sprzedać na własność? To decyzja finansowa, nie sprzętowa — kompromisy CapEx/OpEx i TCO oraz blokady DMS, które sprawiają, że dopłata i dzierżawa są bezpieczne.",
    guidesCardMoTitle: "Multicast IPTV a streaming OTT",
    guidesCardMoDesc:
      "Jeden wydajny strumień dla wielu w Twojej sieci zarządzanej czy osobny strumień adaptacyjny dla każdego widza przez internet? Uczciwe kompromisy w kwestii przepustowości, jakości, opóźnień i zasięgu — i dlaczego wielu operatorów stawia na oba rozwiązania.",
    guidesCardBbTitle: "Budować czy kupić dekoder",
    guidesCardBbDesc:
      "Zbudować własną platformę dekodera czy kupić gotowy ekosystem pod klucz? Budowa oznacza odpowiedzialność za osiem warstw — od elektroniki po wsparcie. Porównujemy oba podejścia i wskazujemy, kiedy każde z nich ma sens.",
    footerLinkGuidesStbChecklist: "Lista kontrolna wyboru STB",
    guidesCardSbcTitle: "Lista kontrolna wyboru STB",
    guidesCardSbcDesc:
      "Przed zakupem dekoderów sprawdź cały zestaw: sprzęt, kodeki, sieć, DRM, aplikacje, zarządzanie flotą, personalizację marki, gwarancję i logistykę.",
    sbcSeoTitle: "Lista kontrolna wyboru IPTV STB: jak wybrać dekodery | inext",
    sbcSeoDescription:
      "Praktyczna lista kontrolna wyboru STB dla dostawców internetu, operatorów IPTV i OTT, telekomów, hoteli, projektów MDU oraz dystrybutorów.",
    sbcBreadcrumbPage: "Lista kontrolna wyboru STB",
    sbcHeroEyebrow: "Lista kontrolna kupującego",
    sbcHeroTitle: "Lista kontrolna wyboru STB:",
    sbcHeroTitleAccent: "co sprawdzić przed wyborem dekoderów",
    sbcHeroSub:
      "Dobry dekoder to nie tylko podzespoły i cena. Sprzęt, oprogramowanie układowe, aplikacje, ochrona treści, pilot, zarządzanie flotą, wsparcie i logistyka muszą działać jako jedna całość po pierwszej dostawie.",
    sbcHeroNote:
      "Użyj tej listy przed testami próbki, wyborem dostawców albo zamówieniem większej partii. Materiał jest przeznaczony dla dostawców internetu, operatorów IPTV i OTT, telekomów, hoteli, projektów MDU oraz dystrybutorów obsługujących operatorów.",
    sbcHeroCtaPrimary: "Porozmawiaj z zespołem",
    sbcHeroCtaSecondary: "Otwórz listę",
    sbcStat1: "Sprzęt i oprogramowanie",
    sbcStat2: "Próbka przed zamówieniem",
    sbcStat3: "Zarządzanie flotą ma znaczenie",
    sbcThesisEyebrow: "Zacznij tutaj",
    sbcThesisTitle: "Kupujesz platformę usługi, nie tylko dekoder",
    sbcThesisBody1:
      "Tani dekoder z Androidem z rynku detalicznego może dobrze wyglądać w arkuszu, ale zarządzana telewizja wymaga urządzenia, które można dostosować do marki, automatycznie konfigurować, blokować, aktualizować i obsługiwać w tysiącach domów, pokoi hotelowych lub obiektów partnerskich.",
    sbcThesisBody2:
      "Właściwy STB zależy od modelu usługi: zarządzane IPTV w prywatnej sieci, telewizja nastawiona na OTT, hybryda IPTV i OTT, telewizja hotelowa lub MDU albo odsprzedaż przez dystrybutora. Lista pozostaje ta sama, ale znaczenie każdego punktu się zmienia.",
    sbcThesisNoteTitle: "Praktyczna zasada",
    sbcThesisNoteBody:
      "Jeśli wymaganie wpływa na wygodę abonenta, dostęp do treści, koszt wsparcia albo kontrolę floty, zweryfikuj je na rzeczywistej próbce przed zatwierdzeniem zamówienia.",
    sbcBuyerEyebrow: "Scenariusze",
    sbcBuyerTitle: "Dopasuj dekoder do usługi, którą prowadzisz",
    sbcBuyerIntro:
      "Ten sam model może obsłużyć kilka projektów, ale kryteria zakupu są różne. Zacznij od usługi, a potem wybierz odpowiednią klasę sprzętu.",
    sbcBuyer1Title: "Zarządzane IPTV",
    sbcBuyer1Body:
      "Priorytetem są Ethernet, obsługa multicastu, stabilne oprogramowanie układowe, prosty ekran startowy, zdalna diagnostyka i niezawodne dekodowanie telewizji na żywo.",
    sbcBuyer2Title: "Telewizja nastawiona na OTT",
    sbcBuyer2Body:
      "Priorytetem są wydajność aplikacji, gotowość DRM, odpowiednia pamięć masowa, stabilne Wi-Fi, strumieniowanie adaptacyjne i wygodny pilot.",
    sbcBuyer3Title: "Hybryda IPTV i OTT",
    sbcBuyer3Body:
      "Sprawdź, czy jedno urządzenie płynnie obsługuje telewizję na żywo przez multicast, VOD, telewizję z odtworzenia, portale i aplikacje operatora.",
    sbcBuyer4Title: "Hotele i MDU",
    sbcBuyer4Body:
      "Szukaj ograniczonego interfejsu bez zależności od prywatnych kont, centralnych ustawień, masowej konfiguracji i łatwej wymiany na obiekcie.",
    sbcBuyer5Title: "Ocena dystrybutora",
    sbcBuyer5Body:
      "Weryfikuj opakowanie, opcje akcesoriów, proces gwarancyjny, tłumaczenia, logistykę i zdolność dostawcy do utrzymywania wersji dla operatorów.",
    sbcTableEyebrow: "Lista kontrolna",
    sbcTableTitle: "Co sprawdzić przed zakupem STB",
    sbcTableIntro:
      "Traktuj każdy wiersz jak punkt testu próbki, a nie deklarację z broszury. Dobry dostawca powinien potwierdzić odpowiedź na rzeczywistym sprzęcie.",
    sbcTableColCheck: "Sprawdź",
    sbcTableColWhy: "Dlaczego to ważne",
    sbcTableColNote: "Notatka kupującego",
    sbcRow1Check: "Dojrzałość układu SoC i platformy",
    sbcRow1Why:
      "SoC określa możliwości dekodowania, poziom DRM, stabilność sterowników, temperaturę pracy i okres utrzymania oprogramowania układowego.",
    sbcRow1Note:
      "Pytaj, którą platformę dostawca już wdraża seryjnie, a nie tylko co potrafi zbudować dla pojedynczego projektu.",
    sbcRow2Check: "Pamięć operacyjna i masowa",
    sbcRow2Why:
      "Zbyt mała pamięć operacyjna spowalnia ekran startowy i aplikacje OTT; mała pamięć masowa ogranicza aplikacje, dzienniki i aktualizacje.",
    sbcRow2Note:
      "Proste IPTV może działać na tańszym sprzęcie. Rozwiązania Android z wieloma aplikacjami potrzebują większego zapasu zasobów.",
    sbcRow3Check: "Wideo, audio i wymagania 4K",
    sbcRow3Why:
      "Kodeki, HDR, rozdzielczość i obsługa audio decydują, czy usługa działa płynnie na telewizorach, których abonenci naprawdę używają.",
    sbcRow3Note:
      "Testuj rzeczywiste kanały na żywo i materiały VOD, a nie tylko filmy demonstracyjne.",
    sbcRow4Check: "Ethernet i multicast",
    sbcRow4Why:
      "Zarządzane IPTV i sieci hotelowe często zależą od przewodowego Ethernetu, IGMP i stabilnego odtwarzania multicast.",
    sbcRow4Note:
      "Jeśli multicast ma znaczenie, przetestuj go na docelowym przełączniku i w rzeczywistej architekturze sieci.",
    sbcRow5Check: "Wi-Fi i OTT poza siecią operatora",
    sbcRow5Why:
      "OTT w dodatkowych pokojach i wielu instalacjach domowych zależy od jakości Wi-Fi, przełączania między punktami dostępowymi i strumieniowania adaptacyjnego.",
    sbcRow5Note:
      "Testuj pokoje ze słabym sygnałem i zatłoczone mieszkania, nie tylko czyste laboratorium.",
    sbcRow6Check: "Gotowość DRM i CAS",
    sbcRow6Why:
      "Chronione treści wymagają właściwego poziomu DRM, wgrania kluczy, integracji z partnerami i czasem obsługi CAS.",
    sbcRow6Note:
      "Potwierdź pełną ścieżkę treści: Widevine, Verimatrix, aplikację portalu, umowę licencyjną operatora i konfigurację fabryczną.",
    sbcRow7Check: "System operacyjny i strategia aplikacji",
    sbcRow7Why:
      "AOSP, certyfikowany Android TV i Linux różnią się dostępnością aplikacji, kosztem certyfikacji, kontrolą aktualizacji i czasem wdrożenia.",
    sbcRow7Note:
      "Wybieraj system operacyjny zgodnie z potrzebnymi aplikacjami i modelem kontroli, a nie według ogólnej preferencji platformy.",
    sbcRow8Check: "Zarządzanie urządzeniami i OTA",
    sbcRow8Why:
      "Bez zdalnej konfiguracji, diagnostyki, etapowych aktualizacji i blokowania każdy problem w terenie staje się kosztowny.",
    sbcRow8Note: "Poproś o pokazanie procesu pracy w DMS przed zatwierdzeniem urządzenia.",
    sbcRow9Check: "Pilot i codzienna wygoda",
    sbcRow9Why:
      "Pilot, ekran startowy, sposób uruchamiania i ustawienia wpływają na codzienną wygodę abonenta bardziej niż lista parametrów.",
    sbcRow9Note:
      "Testuj z użytkownikami bez wiedzy technicznej i sprawdzaj układ przycisków, działanie przez podczerwień lub Bluetooth oraz jakość tłumaczenia.",
    sbcRow10Check: "Marka, opakowanie i akcesoria",
    sbcRow10Why:
      "Dekoder, pilot, zasilacz, przewód HDMI, etykiety i skrócona instrukcja wpływają na wsparcie i postrzeganą jakość.",
    sbcRow10Note:
      "Wcześnie potwierdź typy wtyczek, języki, etykiety, układ zawartości pudełka i dostępność zapasowych akcesoriów.",
    sbcRow11Check: "Gwarancja, zapasy i logistyka",
    sbcRow11Why:
      "Zamówienie dużej partii sprzętu to długotrwały proces operacyjny: terminy, zwroty gwarancyjne, urządzenia zapasowe i trasy transportu mają znaczenie także po uruchomieniu usługi.",
    sbcRow11Note: "Oddziel wysyłkę próbek do oceny od logistyki zamówień seryjnych.",
    sbcRow12Check: "Wsparcie dostawcy i cykl życia",
    sbcRow12Why:
      "Dekoder, który działa dzisiaj, później nadal będzie wymagał aktualizacji oprogramowania układowego i aplikacji, poprawek zabezpieczeń oraz planu wymiany.",
    sbcRow12Note:
      "Wybieraj dostawców, którzy potrafią wyjaśnić zasady wsparcia przez cały cykl życia urządzenia.",
    sbcTableNote:
      "Najlepszy wybór to zwykle urządzenie, które ogranicza najwięcej ryzyk związanych z uruchomieniem i wsparciem, a nie to z najdłuższą listą parametrów.",
    sbcModelEyebrow: "Dopasowanie modelu",
    sbcModelTitle: "Praktyczny sposób doboru linii inext",
    sbcModelIntro:
      "To nie są sztywne reguły, lecz punkt wyjścia do dopasowania złożoności usługi do zapasu zasobów sprzętu przed testem próbki.",
    sbcModelTv5Body:
      "Ekonomiczny wybór dla kontrolowanego IPTV, prostych ekranów startowych i projektów wrażliwych na koszt, które używają niewielu aplikacji.",
    sbcModelTv5Meta: "Ekonomiczne IPTV",
    sbcModelTv5UltraBody:
      "Więcej zasobów dla systemu Android dostosowanego do marki, dodatkowych aplikacji i typowych wdrożeń operatorskich w zrównoważonej cenie.",
    sbcModelTv5UltraMeta: "Zrównoważony Android",
    sbcModelTv6Body:
      "Dobry wybór dla nowoczesnych usług hybrydowych IPTV i OTT, z większym zapasem zasobów dla interfejsu, aplikacji i aktualizacji.",
    sbcModelTv6Meta: "Uniwersalna hybryda",
    sbcModelTv6UltraBody:
      "Najwydajniejszy wariant dla dużej liczby aplikacji, dłuższego cyklu życia i flagowych wdrożeń zarządzanej telewizji.",
    sbcModelTv6UltraMeta: "Najwyższa wydajność",
    sbcModelCta: "Porównaj wszystkie modele STB",
    sbcRedFlagsEyebrow: "Sygnały ostrzegawcze",
    sbcRedFlagsTitle: "Co powinno niepokoić przed zamówieniem partii",
    sbcRedFlagsIntro:
      "Większość problemów z STB można wykryć podczas oceny, jeśli próbka zostanie właściwie przetestowana.",
    sbcRedFlag1:
      "Dostawca oferuje detaliczny dekoder z Androidem bez oprogramowania dla operatora, kontroli ekranu startowego lub zarządzania flotą.",
    sbcRedFlag2:
      "Obsługa DRM, CAS lub chronionych aplikacji jest opisana niejasno, bez zrozumiałego procesu konfiguracji i licencjonowania.",
    sbcRedFlag3:
      "Aktualizacje OTA są wykonywane ręcznie, trafiają od razu do całej floty lub zależą od działania abonenta.",
    sbcRedFlag4:
      "Nie można zdalnie blokować, zawieszać, ponownie konfigurować ani diagnozować urządzeń.",
    sbcRedFlag5:
      "Działanie Ethernetu, multicastu lub Wi-Fi jest obiecywane, ale nie zostało pokazane w docelowej sieci.",
    sbcRedFlag6:
      "Opakowanie, akcesoria, wtyczki, etykiety lub instrukcje są traktowane jako sprawy drugorzędne.",
    sbcRedFlag7:
      "Dostawca nie potrafi wyjaśnić procesu gwarancyjnego, dostępności urządzeń zapasowych, cyklu życia oprogramowania układowego ani logistyki zamówień seryjnych.",
    sbcSampleEyebrow: "Test próbki",
    sbcSampleTitle: "Co testować na próbce dekodera",
    sbcSampleIntro:
      "Próbka nie jest pamiątką. To dowód, że urządzenie może stać się częścią zarządzanej floty.",
    sbcSample1:
      "Uruchom urządzenie od zimnego startu do ekranu z własną marką i sprawdź pierwsze wrażenie użytkownika.",
    sbcSample2:
      "Odtwórz kanały IPTV na żywo, strumienie OTT, VOD i telewizję z odtworzenia z rzeczywistych źródeł usługi.",
    sbcSample3: "Przetestuj multicast lub portal w docelowej sieci, a nie tylko w laboratorium.",
    sbcSample4: "Zweryfikuj treści chronione DRM i wszystkie wymagane chronione aplikacje.",
    sbcSample5:
      "Wyślij aktualizację aplikacji lub oprogramowania układowego przez system zarządzania.",
    sbcSample6:
      "Potwierdź, że urządzenie jest widoczne w DMS, ma diagnostykę, grupy i działania zdalne.",
    sbcSample7:
      "Przetestuj zawieszanie, blokadę sieciową, tryb kiosku lub blokadę aplikacji, jeśli wymaga tego model handlowy.",
    sbcSample8:
      "Oceń pilot: wygodę, przypisanie przycisków, parowanie i prawdopodobne zgłoszenia abonentów do pomocy technicznej.",
    sbcSample9:
      "Pozostaw dekoder w pracy wystarczająco długo, aby wykryć przegrzewanie, ponowne uruchomienia i problemy z Wi-Fi lub pamięcią.",
    sbcSample10:
      "Sprawdź opakowanie, wtyczki, etykiety, akcesoria i przetłumaczone materiały szybkiego startu.",
    sbcFitEyebrow: "Gdzie pasuje inext",
    sbcFitTitle: "Pomagamy zweryfikować cały zestaw",
    sbcFitBody:
      "inext łączy sprzęt, oprogramowanie układowe, ekran startowy, aplikację IPTV, Alcatraz DMS, OTA, personalizację marki i międzynarodową logistykę B2B w jedno zarządzane rozwiązanie STB. Jeden dostawca odpowiada za sprzęt, oprogramowanie i wdrożenie jeszcze przed zamówieniem partii.",
    sbcFitCtaDms: "Zobacz Alcatraz DMS",
    sbcFitCtaLogistics: "Zobacz logistykę",
    sbcFaqEyebrow: "FAQ",
    sbcFaqTitle: "Częste pytania",
    sbcFaqQ1: "Czy ta lista jest tylko dla operatorów IPTV?",
    sbcFaqA1:
      "Nie. Lista jest przeznaczona dla każdej organizacji oceniającej urządzenia do zarządzanych usług telewizyjnych: dostawców internetu, operatorów IPTV i OTT, telekomów, hoteli, projektów MDU oraz dystrybutorów kupujących dla operatorów.",
    sbcFaqQ2: "Wybrać Android, AOSP, certyfikowany Android TV czy Linux?",
    sbcFaqA2:
      "Wybieraj zgodnie z usługą. Android lub AOSP dobrze pasują do projektów z wieloma aplikacjami i dużym udziałem OTT; certyfikowany Android TV — do projektów, które potrzebują ekosystemu Google; Linux — do kontrolowanych rozwiązań wyłącznie IPTV. Kluczowe jest dopasowanie systemu operacyjnego, aplikacji, certyfikacji i kontroli aktualizacji.",
    sbcFaqQ3: "Ile potrzeba pamięci operacyjnej i masowej?",
    sbcFaqA3:
      "Proste IPTV może działać na tańszym dekoderze. Nowoczesny Android z kilkoma aplikacjami, bogatszym interfejsem i dłuższym cyklem życia potrzebuje większego zapasu. Najpewniejsza odpowiedź wymaga testu rzeczywistego ekranu startowego, aplikacji i pakietu aktualizacji na wybranym modelu.",
    sbcFaqQ4: "Czy Ethernet nadal jest ważny, jeśli OTT działa po Wi-Fi?",
    sbcFaqA4:
      "Tak. OTT może działać po Wi-Fi, ale zarządzane IPTV, multicast i wiele sieci hotelowych lub MDU nadal zależą od przewodowego Ethernetu, aby zapewnić przewidywalną jakość.",
    sbcFaqQ5: "Czy jeden STB obsłuży IPTV i OTT?",
    sbcFaqA5:
      "Tak, jeśli sprzęt, oprogramowanie układowe i aplikacja są przygotowane do obu scenariuszy. Przed decyzją należy przetestować telewizję na żywo przez multicast lub portal, strumienie OTT, VOD i telewizję z odtworzenia na tej samej próbce.",
    sbcFaqQ6: "Kiedy poprosić o próbkę do oceny?",
    sbcFaqA6:
      "Przed zatwierdzeniem handlowym. Próbkę należy przetestować z rzeczywistym portalem, treściami, siecią, ścieżką DRM, ekranem startowym, pilotem, procesem DMS i wymaganiami dotyczącymi opakowania.",
    sbcFaqQ7: "Co dystrybutorzy powinni sprawdzać inaczej?",
    sbcFaqA7:
      "Dystrybutorzy powinni zweryfikować nie tylko urządzenie, lecz także powtarzalność opakowania, warianty akcesoriów, regionalne wtyczki, proces gwarancyjny, tłumaczenia, terminy i zdolność dostawcy do utrzymywania wersji dla operatorów.",
    sbcCtaEyebrow: "Porozmawiaj z nami",
    sbcCtaTitle: "Zweryfikuj dekoder przed wdrożeniem",
    sbcCtaBody:
      "Opowiedz nam o modelu usługi, sieci, wymaganiach aplikacji i docelowej półce cenowej. Pomożemy dobrać właściwy STB inext, przygotować próbkę z własną marką i zweryfikować cały zestaw przed zamówieniem seryjnym.",
    sbcCtaPrimary: "Porozmawiaj z zespołem",
    sbcCtaSecondary: "Poproś o próbkę",
    osSeoTitle:
      "Własne dekodery czy Smart TV: dlaczego operatorzy dostarczają własny sprzęt | inext",
    osSeoDescription:
      "Dostarczać dekodery pod własną marką czy polegać na telewizorach Smart TV abonentów? Najczęściej warto wykorzystywać oba kanały, ale tylko własny dekoder zapewnia operatorowi pełną kontrolę nad urządzeniem.",
    osBreadcrumbPage: "Własne dekodery czy Smart TV",
    osHeroEyebrow: "Poradnik strategiczny",
    osHeroTitle: "Twoje dekodery czy telewizory Smart TV abonentów:",
    osHeroTitleAccent: "dlaczego potrzebujesz obu",
    osHeroSub:
      "Większość abonentów ma już telewizor Smart TV, dlatego model oparty wyłącznie na aplikacji może wydawać się wystarczający. Najlepszy zasięg zapewnia jednak połączenie obu podejść: aplikacji na Smart TV i urządzenia mobilne oraz własnego dekodera pod marką operatora jako kontrolowanego rdzenia usługi. Dekoder jest jedyną platformą, której funkcje, aktualizacje i interfejs operator może w pełni kształtować.",
    osHeroNote:
      "inext dostarcza dekoder wraz z działającą na nim aplikacją i dostosowuje oba elementy do marki operatora. Poniżej wyjaśniamy, dlaczego warto zachować tę kontrolowaną część usługi.",
    osHeroCtaPrimary: "Porozmawiaj z naszym zespołem",
    osHeroCtaSecondary: "Zobacz, co kontrolujesz",
    osStat1: "Twoja marka na dekoderze i pilocie",
    osStat2: "100% kontroli — w Twoim tempie",
    osStat3: "Każdy telewizor, każdy pokój",
    osThesisEyebrow: "Zacznij tutaj",
    osThesisTitle: "Kontroluj rdzeń, sięgaj wszędzie",
    osThesisBody1:
      "Nie chodzi o wybór między sprzętem a aplikacjami, lecz o zakres kontroli. Aplikacje na Smart TV, urządzenia mobilne i przeglądarki udostępniają usługę na ekranach, które abonenci już mają, dlatego są ważnym kanałem zasięgu. O urządzeniu, ekranie głównym, zasadach platformy i części danych decydują jednak Samsung, LG, Google lub Apple.",
    osThesisBody2:
      "Własny dekoder daje operatorowi kontrolę nad launcherem, harmonogramem aktualizacji, DRM, danymi i rozliczeniami. Pozwala zapewnić spójną obsługę i utrzymywać bezpośrednią relację z abonentem. Najskuteczniejszy model łączy dekoder pod marką operatora jako rdzeń usługi z aplikacjami zapewniającymi zasięg na pozostałych ekranach.",
    osThesisCoreLabel: "Rdzeń na własność",
    osThesisCoreValue: "Dekoder pod Twoją marką",
    osThesisReachLabel: "Zasięg na platformach zewnętrznych",
    osThesisReachValue: "Smart TV · aplikacje mobilne · webowe",
    osOwnRentEyebrow: "Własność kontra najem",
    osOwnRentTitle: "Na własnym dekoderze reguły ustalasz Ty. Na Smart TV — ktoś inny.",
    osOwnColTitle: "Na własnym dekoderze kontrolujesz",
    osOwnItem1: "Ekran główny — Twój launcher wita po uruchomieniu",
    osOwnItem2: "Aktualizacje i nowe funkcje — w Twoim harmonogramie",
    osOwnItem3: "DRM, bezpieczeństwo i integrację z aplikacjami premium",
    osOwnItem4: "Rozliczenia, reklamy i miejsce na dosprzedaż — bez prowizji platformy",
    osOwnItem5: "Telemetrię urządzeń i dane o oglądalności — są Twoje",
    osOwnItem6: "Jak długo urządzenie pozostaje wspierane",
    osRentColTitle: "Na Smart TV abonenta kontroluje producent telewizora",
    osRentItem1: "Ekran główny — Twoja aplikacja to jedna z wielu ikon",
    osRentItem2: "Weryfikację w sklepie z aplikacjami i aktualizacje systemu — w ich terminach",
    osRentItem3: "Które poziomy DRM i kodeki obsługuje telewizor",
    osRentItem4: "Opłaty i warunki sklepu — mogą je podnieść w każdej chwili",
    osRentItem5:
      "Dane platformy — operator otrzymuje tylko informacje dostępne na poziomie aplikacji",
    osRentItem6: "Kiedy starsze modele tracą wsparcie i Twoja aplikacja przestaje działać",
    osBenefitsEyebrow: "Argumenty za dekoderem",
    osBenefitsTitle: "Co daje Ci dostarczanie własnego dekodera",
    osBenefit1Title: "Twoja marka, każdego dnia",
    osBenefit1Body:
      "Launcher operatora jest pierwszym ekranem po uruchomieniu, a jego logo może znajdować się także na dekoderze i pilocie. Codzienna obecność marki zwiększa jej rozpoznawalność i wzmacnia relację z abonentem.",
    osBenefit2Title: "Suwerenność platformy",
    osBenefit2Body:
      "Samsung, LG lub Google mogą zmienić ekran główny, promować konkurencyjną usługę, podnieść opłaty albo zakończyć wsparcie starszych telewizorów. Operator ma na te decyzje ograniczony wpływ. Na własnym dekoderze sam określa wygląd platformy, zasady dystrybucji i okres wsparcia.",
    osBenefit3Title: "Zdalne zarządzanie, mniejsze wsparcie",
    osBenefit3Body:
      "Alcatraz DMS i TR-069 umożliwiają zdalne monitorowanie, diagnozowanie, konfigurowanie, aktualizowanie i ponowne uruchamianie dekoderów. Ogranicza to liczbę wyjazdów serwisowych i skraca czas usuwania usterek. W przypadku telewizora Smart TV operator ma znacznie mniej danych pozwalających ustalić, czy problem dotyczy urządzenia, sieci czy aplikacji.",
    osBenefit4Title: "QoE, którą możesz zagwarantować",
    osBenefit4Body:
      "Operator wybiera chipset, kodeki, obsługę 4K i parametry Wi-Fi, dlatego może zapewnić spójne działanie usługi. Na starszym lub słabszym telewizorze Smart TV transmisja może działać niestabilnie albo nie zostać poprawnie zdekodowana, choć abonent nadal będzie kojarzyć problem z usługą operatora.",
    osBenefit5Title: "Wprowadzaj funkcje jako pierwszy",
    osBenefit5Body:
      "Nowy kodek, funkcję catch-up, cloud DVR lub odświeżony interfejs można wdrożyć w całej flocie według harmonogramu operatora. Na Smart TV trzeba czekać na obsługę i ponowną certyfikację na każdej platformie, a starsze modele mogą w ogóle nie otrzymać aktualizacji.",
    osBenefit6Title: "Każdy telewizor, każdy pokój",
    osBenefit6Body:
      "Dekoder udostępnia usługę na dowolnym telewizorze z HDMI, także na starszym odbiorniku lub drugim ekranie w domu. Model oparty wyłącznie na Smart TV pomija te urządzenia oraz abonentów, którzy nie mają telewizora z odpowiednią platformą aplikacji.",
    osBenefit7Title: "Zachowaj kontrolę nad przychodami i danymi",
    osBenefit7Body:
      "Na własnym dekoderze operator może prowadzić rozliczenia, wyświetlać reklamy i proponować dodatkowe usługi bez prowizji sklepu z aplikacjami. Dane o oglądalności i urządzeniach pozostają przy tym w jego środowisku, zamiast trafiać do producenta telewizora.",
    osBenefit8Title: "Otwarcie na B2B i hotelarstwo",
    osBenefit8Body:
      "Hotele, bloki mieszkalne, szpitale i bary potrzebują centralnie zarządzanych, zablokowanych urządzeń bez osobistych logowań — czego samo podejście aplikacyjne nie zapewni. Twój dekoder otwiera te rynki.",
    osBenefit9Title: "Wartość w Twojej sieci",
    osBenefit9Body:
      "Zarządzany dekoder jest aktywem sieciowym, a nie tylko sprzętem w salonie. Multicast i inne zarządzane sposoby dystrybucji utrzymują ruch wideo wewnątrz sieci, ograniczając wykorzystanie pasma zewnętrznego w porównaniu z OTT z publicznego internetu. Dekoder jako zarządzany punkt końcowy daje też wgląd w QoE na brzegu sieci. Dla dostawcy internetu pozwala połączyć telewizję z usługą dostępu i zwiększać ARPU.",
    osScenarioTitle: "Gdy zewnętrzna platforma zmienia zasady",
    osScenarioBody:
      "Producent telewizora może przeprojektować ekran główny, ograniczyć widoczność aplikacji operatora i zacząć promować konkurencyjną usługę w całym regionie. Operator nie kontroluje takich decyzji marketingowych. Na własnych dekoderach układ ekranu pozostaje bez zmian, ponieważ to operator zarządza urządzeniem i jego interfejsem. Na tym polega różnica między obecnością na zewnętrznej platformie a kontrolowaniem własnej.",
    osHiddenEyebrow: "Uczciwy bilans",
    osHiddenTitle: "Strategia „tylko Smart TV” jest droższa, niż się wydaje",
    osHiddenBody:
      "Rezygnacja z dekodera pozwala początkowo uniknąć kosztów sprzętu i logistyki, a w czystym OTT lub modelu D2C może być właściwym wyborem. Wykorzystanie telewizorów Smart TV abonentów wiąże się jednak z kosztami pojawiającymi się później:",
    osHidden1:
      "Ograniczona diagnostyka — operator nie widzi stanu urządzenia i nie może go zdalnie naprawić, dlatego ustalenie źródła problemu trwa dłużej",
    osHidden2:
      "Ryzyko dla QoE — starsze i słabsze telewizory pogarszają odbiór usługi na sprzęcie, którego operator nie kontroluje",
    osHidden3:
      "Koszt fragmentacji — rozwój i certyfikacja aplikacji na Tizen, webOS, Android TV, Fire TV, Apple TV i kolejne platformy, z różnymi wymaganiami oraz DRM",
    osHidden4:
      "Ryzyko platformy — opłaty, zasady, reklamy i wsparcie systemu zmieniają się na warunkach producenta, nie Twoich",
    osSameEyebrow: "Gdzie tu my",
    osSameTitle: "Budujemy dekoder, który jest Twój",
    osSameBody:
      "Aplikacje na Smart TV i urządzenia mobilne pozostają ważnym kanałem zasięgu. inext dostarcza kontrolowany rdzeń usługi: dekoder pod marką operatora z launcherem w warstwie Operator Tier, aplikacją IPTV, preinstalowanymi usługami oraz zarządzaniem przez Alcatraz DMS, OTA i TR-069. Aplikacje rozszerzają dostępność na zewnętrznych platformach, a dekoder zapewnia operatorowi własne, w pełni zarządzane środowisko.",
    osSameNoteTitle: "Pełna kontrola w przewidywalnym koszcie",
    osSameNoteBody:
      "Koszt dekodera warto porównać z kosztami rezygnacji abonentów, wsparcia i zależności od zewnętrznych platform. Pomagamy dobrać odpowiedni model, dostosować urządzenie i pilot do marki operatora oraz przygotować działającą próbkę w ciągu 1–2 tygodni.",
    osFaqEyebrow: "FAQ",
    osFaqTitle: "Częste pytania",
    osFaqQ1: "Większość moich abonentów ma już Smart TV — po co w ogóle dostarczać dekoder?",
    osFaqA1:
      "Telewizor Smart TV pozostaje pod kontrolą abonenta i producenta. Własny dekoder pozwala operatorowi zarządzać interfejsem, wydajnością, zdalnym wsparciem, rozliczeniami i danymi. Aplikacje na Smart TV zwiększają zasięg, natomiast dekoder zapewnia kontrolowany rdzeń usługi i obsługuje także drugie telewizory oraz odbiorniki bez odpowiedniej platformy aplikacji.",
    osFaqQ2: "Czy dostarczanie sprzętu nie jest zbyt drogie?",
    osFaqA2:
      "Dekoder kosztuje orientacyjnie 30–50 USD, a koszt ten można rozłożyć na cały okres umowy z abonentem. Zdalne zarządzanie ogranicza koszty wsparcia i wyjazdów serwisowych, urządzenie pod marką operatora może wspierać retencję, a własne rozliczenia nie podlegają prowizji sklepu z aplikacjami. Rzeczywistą opłacalność warto obliczyć na podstawie danych danego operatora.",
    osFaqQ3: "Czy mogę zacząć od samej aplikacji, a dekodery dodać później?",
    osFaqA3:
      "Tak, wielu operatorów rozpoczyna w ten sposób. Aplikacje zwiększają zasięg, a dekodery można później wprowadzić dla kluczowych segmentów abonentów wymagających kontrolowanej usługi pod marką operatora. Warto jednak uwzględnić przyszły dekoder już w architekturze aplikacji i platformy.",
    osFaqQ4: "A co z hotelami, blokami mieszkalnymi i innym B2B?",
    osFaqA4:
      "To naturalny teren dla dekodera. Wdrożenia hotelarskie i w budynkach wielorodzinnych (MDU) potrzebują centralnie zarządzanych, zablokowanych urządzeń bez osobistych logowań — dokładnie tego, co zapewnia zarządzany dekoder, a czego aplikacja na prywatnym telewizorze gościa dać nie może.",
    osFaqQ5: "Czy dostarczając dekoder, coś tracę?",
    osFaqA5:
      "Operator ponosi koszt sprzętu i logistyki, ale inext może przejąć produkcję, personalizację i dostawę oraz przygotować działającą próbkę w ciągu 1–2 tygodni. W zamian operator zyskuje większą kontrolę, stałą obecność marki i możliwość ograniczenia kosztów wsparcia. Opłacalność należy ocenić na podstawie parametrów konkretnej usługi.",
    osFaqQ6: "Czy dekoder przywiązuje mnie do jednej aplikacji albo usługi?",
    osFaqA6:
      "Nie — to Twoja platforma. To Ty wybierasz launcher, aplikacje, usługi i częstotliwość aktualizacji. O to właśnie chodzi: na Twoim dekoderze mapa rozwoju należy do Ciebie, nie do producenta telewizora.",
    osCtaEyebrow: "Porozmawiaj z nami",
    osCtaTitle: "Zapanuj nad ekranem, który Twoi abonenci oglądają najczęściej",
    osCtaBody:
      "Opowiedz nam o swojej usłudze i planowanej flocie. Dobierzemy specyfikację dekodera, dostosujemy go do Twojej marki i przygotujemy działającą próbkę.",
    osCtaPrimary: "Porozmawiaj z naszym zespołem",
    osCtaSecondary: "Poproś o próbkę",
    bmSeoTitle:
      "Dopłacać do dekodera, dzierżawić czy sprzedać? CapEx kontra OpEx dla operatorów | inext",
    bmSeoDescription:
      "Oddać dekoder, wynająć go czy sprzedać na własność? To decyzja finansowa, nie sprzętowa. Kompromisy CapEx/OpEx i TCO przy dopłacaniu, dzierżawie i sprzedaży dekoderów — oraz blokady DMS, które sprawiają, że dopłata i dzierżawa są bezpieczne.",
    bmBreadcrumbPage: "Dopłata, dzierżawa czy sprzedaż",
    bmHeroEyebrow: "Poradnik komercyjny",
    bmHeroTitle: "Dopłacić do dekodera, wydzierżawić go czy sprzedać:",
    bmHeroTitleAccent: "to decyzja finansowa",
    bmHeroSub:
      "Ten sam zarządzany dekoder może trafić do abonenta na trzy sposoby: bez opłaty początkowej, w dzierżawie albo w sprzedaży. Sprzęt się nie zmienia — zmieniają się źródło finansowania, właściciel i sposób odzyskania kosztu. Źle dobrany model oznacza utratę potencjalnego przychodu albo trudne do oszacowania ryzyko. Większość operatorów nie ogranicza się do jednego wariantu, lecz stosuje dwa lub trzy równocześnie.",
    bmHeroNote:
      "Ten sam dekoder inext obsługuje wszystkie trzy modele, a blokady Alcatraz DMS ograniczają ryzyko związane z udostępnieniem lub dzierżawą sprzętu. Ten poradnik pomaga wybrać i połączyć odpowiednie warianty.",
    bmHeroCtaPrimary: "Porozmawiaj z naszym zespołem",
    bmHeroCtaSecondary: "Zobacz, jak pomagają blokady",
    bmStat1: "Jeden dekoder, trzy modele",
    bmStat2: "CapEx albo OpEx — Twój wybór",
    bmStat3: "Blokady zapewniają bezpieczeństwo",
    bmThesisEyebrow: "Zacznij tutaj",
    bmThesisTitle: "To decyzja finansowa, nie sprzętowa",
    bmThesisBody1:
      "Dekodery są często największą pozycją sprzętową w budżecie operatora, a łączny koszt rośnie z każdym nowym abonentem. Sposób udostępnienia urządzenia wpływa więc nie tylko na logistykę, lecz także na przepływy pieniężne, bilans i retencję. Sam dekoder pozostaje identyczny we wszystkich trzech modelach — zmienia się sposób jego finansowania.",
    bmThesisBody2:
      "Rzadko trzeba ograniczać się do jednego wariantu. Operator może finansować dekodery dla nowych abonentów segmentu premium i triple-play, dzierżawić je głównej grupie klientów, a sprzedawać użytkownikom prepaid, klientom B2B lub jako urządzenia do drugiego telewizora. Z czasem można też przenosić abonentów między modelami. Właściwe pytanie brzmi: który wariant pasuje do danego segmentu i jak ograniczyć związane z nim ryzyko?",
    bmThesisCoreLabel: "Jedno aktywo",
    bmThesisCoreValue: "Twój zarządzany dekoder",
    bmThesisReachLabel: "Trzy modele komercyjne",
    bmThesisReachValue: "Dopłata · Dzierżawa · Sprzedaż",
    bmModelsEyebrow: "Trzy modele",
    bmModelsTitle: "Trzy sposoby, by dekoder trafił do domu",
    bmModelLabelUpfront: "Na starcie",
    bmModelLabelOwns: "Czyja własność",
    bmModelLabelRevenue: "Jak zarabiasz",
    bmModelLabelBest: "Najlepsze do",
    bmModel1Name: "Dopłata",
    bmModel1Tagline: "Usuń koszt początkowy i pozyskaj abonenta.",
    bmModel1Upfront: "Finansujesz go na starcie — CapEx już pierwszego dnia.",
    bmModel1Owns: "Zwykle abonent, po okresie minimalnym.",
    bmModel1Revenue: "Odzyskujesz koszt z abonamentu w trakcie umowy.",
    bmModel1Best: "Pozyskiwanie klientów na konkurencyjnym rynku, pakiety premium i triple-play.",
    bmModel2Name: "Dzierżawa / wynajem",
    bmModel2Tagline: "Zatrzymaj aktywo, rozliczaj co miesiąc.",
    bmModel2Upfront: "Finansujesz go, ale zostaje Twoim aktywem.",
    bmModel2Owns: "Ty — przez cały okres życia urządzenia.",
    bmModel2Revenue: "Cykliczna opłata za najem; po zwrocie urządzenie można wydać ponownie.",
    bmModel2Best: "Przychód cykliczny, niska bariera wejścia i wielokrotne wykorzystanie sprzętu.",
    bmModel3Name: "Sprzedaż",
    bmModel3Tagline: "Płatność od razu, bez aktywa do utrzymania.",
    bmModel3Upfront: "Płaci abonent — na własność lub w ratach.",
    bmModel3Owns: "Abonent, od pierwszego dnia.",
    bmModel3Revenue: "Jednorazowy przychód ze sprzętu; żadnego aktywa do amortyzacji.",
    bmModel3Best: "Prepaid, drugie telewizory, B2B, lżejszy bilans.",
    bmTableEyebrow: "Obok siebie",
    bmTableTitle: "Jak wypadają w porównaniu",
    bmTableColDimension: "",
    bmTableColSubsidize: "Dopłata",
    bmTableColLease: "Dzierżawa",
    bmTableColSell: "Sprzedaż",
    bmRow1Label: "Koszt na starcie",
    bmRow1Sub: "Operator (CapEx)",
    bmRow1Lease: "Operator (CapEx, zatrzymany)",
    bmRow1Sell: "Abonent",
    bmRow2Label: "W Twoich księgach",
    bmRow2Sub: "Aktywo, potem spisane",
    bmRow2Lease: "Aktywo, amortyzowane przez okres życia",
    bmRow2Sell: "Nic — jest sprzedany",
    bmRow3Label: "Przepływ gotówki",
    bmRow3Sub: "Wypływ teraz, powrót w trakcie umowy",
    bmRow3Lease: "Wypływ teraz, cykliczny powrót",
    bmRow3Sell: "Wpływ teraz",
    bmRow4Label: "Przychód cykliczny",
    bmRow4Sub: "W ramach abonamentu",
    bmRow4Lease: "Osobna pozycja najmu",
    bmRow4Sell: "Brak na sprzęcie",
    bmRow5Label: "Bariera wejścia dla abonenta",
    bmRow5Sub: "Najniższy — jest za darmo",
    bmRow5Lease: "Niski — drobna opłata miesięczna",
    bmRow5Sell: "Najwyższy — płaci z góry",
    bmRow6Label: "Wpływ na retencję",
    bmRow6Sub: "Okres umowy",
    bmRow6Lease: "Aby odejść, trzeba zwrócić",
    bmRow6Sell: "Najmniejszy — dekoder należy do abonenta",
    bmRow7Label: "Jeśli odejdzie przed czasem",
    bmRow7Sub: "Nieodzyskana dopłata",
    bmRow7Lease: "Odzyskaj i wydaj ponownie",
    bmRow7Sell: "Już zapłacone — brak ryzyka",
    bmTableSafeLabel: "Co zapewnia bezpieczeństwo",
    bmTableSafeValue: "Alcatraz DMS — net-lock · app-lock · zdalne zawieszenie · odzysk przez OTA",
    bmTableNote:
      "Dekoder jest taki sam w każdej kolumnie — zmieniają się tylko pieniądze i własność.",
    bmTcoEyebrow: "Przykładowe rozliczenie",
    bmTcoTitle: "Ten sam dekoder, trzy rozkłady przepływów pieniężnych",
    bmTcoBody:
      "Model nie zmienia ceny dekodera, lecz moment ponoszenia kosztów i uzyskiwania przychodów. Poniżej pokazujemy przepływy dla jednego zarządzanego urządzenia:",
    bmTco1Title: "Dopłata",
    bmTco1Body:
      "Ponosisz koszt dekodera na początku i odzyskujesz go w abonamencie. Orientacyjny okres zwrotu można obliczyć, dzieląc koszt urządzenia przez miesięczną marżę. Jeśli abonent pozostanie dłużej, kolejne wpływy zwiększają rentowność; wcześniejsza rezygnacja pozostawia część kosztu nieodzyskaną. Ryzyko ograniczają minimalny okres umowy oraz zdalne blokady.",
    bmTco2Title: "Dzierżawa",
    bmTco2Body:
      "Operator nadal finansuje dekoder, ale miesięczny najem tworzy stały przychód, który w całym okresie eksploatacji może przekroczyć koszt urządzenia. Ponieważ sprzęt pozostaje własnością operatora, zwrócony egzemplarz można wyczyścić, ponownie provisionować i przekazać kolejnemu abonentowi. Jeden dekoder może więc obsłużyć kilka umów przed wycofaniem z użycia.",
    bmTco3Title: "Sprzedaż",
    bmTco3Body:
      "Sprzęt finansuje abonent, dlatego operator nie zamraża kapitału obrotowego ani nie utrzymuje urządzenia jako własnego aktywa. Mniejszy wpływ na retencję jest równoważony płatnością otrzymaną od razu i prostszą obsługą operacyjną. Ten model często sprawdza się w usługach prepaid i B2B.",
    bmTcoNote:
      "To wartości poglądowe, a nie oferta. Rzeczywisty wynik zależy od ceny dekodera, marży, retencji i możliwości ponownego wykorzystania urządzenia. Pomożemy wykonać obliczenia na danych operatora.",
    bmLockEyebrow: "Co daje bezpieczeństwo",
    bmLockTitle: "Oprogramowanie, które ogranicza ryzyko",
    bmLockBody:
      "W modelu z dopłatą lub dzierżawą ryzyko pojawia się wtedy, gdy abonent przestaje płacić albo nie zwraca dekodera. Alcatraz DMS pozwala nim zarządzać. Funkcje net-lock i app-lock wiążą urządzenie z usługą operatora, dlatego poza zatwierdzoną siecią ma ono ograniczoną wartość i nie działa jak zwykły sprzęt z Androidem. Dzięki temu udostępnianie lub dzierżawa dekoderów stają się przewidywalnym modelem biznesowym.",
    bmLock1Title: "Net-lock urządzenia",
    bmLock1Body:
      "Dekoder z dopłatą lub dzierżawy jest powiązany z usługą operatora. Poza zatwierdzoną siecią nie aktywuje się, co znacząco ogranicza jego wartość przy odsprzedaży.",
    bmLock2Title: "App-lock i tryb kiosku",
    bmLock2Body:
      "Dekoder uruchamia Twój launcher i Twoje aplikacje — nie otwarty pulpit Androida. Urządzenia z dopłatą nie da się przerobić na inne zastosowanie, a na ekranie zostaje Twoja marka.",
    bmLock3Title: "Zawieszaj i przywracaj zdalnie",
    bmLock3Body:
      "W razie zaległej płatności dekoder można zablokować zdalnie z panelu i ponownie aktywować po uregulowaniu należności — bez wyjazdu serwisowego.",
    bmLock4Title: "Odzyskaj i wydaj ponownie",
    bmLock4Body:
      "Zwrócony dekoder z dzierżawy można wyczyścić, ponownie provisionować przez OTA i przekazać kolejnemu abonentowi. Możliwość wielokrotnego wykorzystania urządzenia ma kluczowe znaczenie dla opłacalności dzierżawy.",
    bmLockNote:
      "Model komercyjny można egzekwować za pomocą oprogramowania. Jedna flota może obejmować urządzenia dofinansowane, dzierżawione i sprzedane, a warunki poszczególnych dekoderów można zmieniać bez modyfikacji sprzętu.",
    bmMixEyebrow: "W praktyce",
    bmMixTitle: "Większość operatorów prowadzi więcej niż jeden model",
    bmMixBody:
      "Model warto dopasować do segmentu abonentów, a nie stosować jednolicie w całej firmie. U naszych klientów często spotykamy następujący układ:",
    bmMix1:
      "Pozyskiwanie klientów i segment premium → dopłata. Brak kosztu początkowego ułatwia pozyskanie abonentów na konkurencyjnym rynku i w pakietach triple-play, a umowa i blokady ograniczają ryzyko.",
    bmMix2:
      "Główna baza abonentów → dzierżawa. Niewielka miesięczna opłata utrzymuje niską barierę wejścia, a urządzenie pozostaje aktywem operatora i może zostać wykorzystane ponownie po rezygnacji abonenta.",
    bmMix3:
      "Prepaid, drugi telewizor i B2B → sprzedaż. Płatność z góry sprawdza się tam, gdzie retencja ma mniejsze znaczenie, a ważniejszy jest lżejszy bilans.",
    bmMix4:
      "Zmiana modelu w czasie. Ten sam dekoder można początkowo dofinansować, a później sprzedać abonentowi — bez wymiany sprzętu, jedynie przez zmianę warunków.",
    bmFitEyebrow: "Gdzie tu my",
    bmFitTitle: "Jedna flota, dowolny model i możliwość późniejszej zmiany",
    bmFitBody:
      "Dostarczamy zarządzany dekoder i Alcatraz DMS, a operator wybiera jeden lub kilka modeli komercyjnych. Wbudowane funkcje net-lock, app-lock, zdalne zawieszenie i ponowne przygotowanie urządzenia przez OTA ograniczają ryzyko dopłaty oraz dzierżawy. Model można zmieniać wraz z sytuacją rynkową bez ponownego wgrywania systemu ani zakupu nowego sprzętu. Wszystkie trzy warianty działają na tym samym dekoderze.",
    bmFitNoteTitle: "Policz to z nami",
    bmFitNoteBody:
      "Podaj marżę i wskaźnik retencji, a my dodamy aktualny koszt dekodera, porównamy dopłatę, dzierżawę i sprzedaż na rzeczywistych danych oraz skonfigurujemy blokady odpowiednie dla wybranego modelu.",
    bmFaqEyebrow: "FAQ",
    bmFaqTitle: "Częste pytania",
    bmFaqQ1: "Który model jest najlepszy?",
    bmFaqA1:
      "Nie ma jednego najlepszego wariantu. Wybór zależy od rynku, dostępnego kapitału i znaczenia retencji. Wielu operatorów łączy modele: stosuje dopłatę przy pozyskiwaniu klientów, dzierżawę w głównej bazie abonentów i sprzedaż tam, gdzie retencja ma mniejsze znaczenie. Zarządzany dekoder pozwala korzystać z kilku wariantów równocześnie.",
    bmFaqQ2: "Czy naprawdę mogę prowadzić wszystkie trzy naraz?",
    bmFaqA2:
      "Tak. Wielu naszych klientów tak działa. Alcatraz DMS egzekwuje reguły przypisane do urządzenia, dlatego jedna flota może obejmować dekodery dofinansowane, dzierżawione i sprzedane, każdy na innych warunkach.",
    bmFaqQ3: "Co powstrzymuje odsprzedaż lub przeróbkę dekodera z dopłaty lub z dzierżawy?",
    bmFaqA3:
      "Net-lock i app-lock. Poza Twoją siecią dekoder się nie aktywuje, więc nie ma wartości odsprzedaży; uruchamia wyłącznie Twoją usługę, więc nie zamieni się w zwykły sprzęt z Androidem. To właśnie sprawia, że oddawanie czy wypożyczanie sprzętu jest bezpieczne.",
    bmFaqQ4: "Co się dzieje, gdy abonent przestaje płacić?",
    bmFaqA4:
      "Blokujesz urządzenie programowo i zdalnie, a przywracasz je w chwili, gdy abonent zapłaci — bez wyjazdu serwisowego. Przy dzierżawie dekoder, który nigdy nie wrócił, zostaje zablokowany i poza siecią bezwartościowy; ten, który wraca, czyścisz i wydajesz ponownie.",
    bmFaqQ5: "Jak dzierżawa wygląda w moim bilansie?",
    bmFaqA5:
      "Sposób ujęcia zależy od umowy i przyjętych zasad rachunkowości. Operator może utrzymywać dekoder jako aktywo i amortyzować go przez okres użytkowania, a opłaty za najem ujmować jako przychód cykliczny. Dokładny model należy potwierdzić z działem finansowym; my dostarczymy dane dotyczące cyklu życia urządzenia i jego ponownego wykorzystania.",
    bmFaqQ6: "Czy mogę później przenieść abonenta z jednego modelu na inny?",
    bmFaqA6:
      "Tak. Skoro każdy model działa na tym samym dekoderze, możesz dopłacić, żeby pozyskać abonenta, a później przenieść go na własność, albo zamienić najem w sprzedaż — wszystko w oprogramowaniu, bez nowego sprzętu.",
    bmCtaEyebrow: "Porozmawiaj z nami",
    bmCtaTitle: "Wybierz pasujący model — my zadbamy o bezpieczeństwo",
    bmCtaBody:
      "Podaj marże, wskaźnik rezygnacji i planowaną opłatę dla abonenta. Dodamy aktualny koszt dekodera, porównamy dopłatę, dzierżawę i sprzedaż na rzeczywistych danych oraz skonfigurujemy w Alcatraz DMS blokady odpowiednie dla wybranego modelu.",
    bmCtaPrimary: "Porozmawiaj z naszym zespołem",
    bmCtaSecondary: "Poproś o próbkę",
    moSeoTitle:
      "Multicast IPTV a streaming OTT: architektura dostarczania sygnału dla operatorów | inext",
    moSeoDescription:
      "Multicast IPTV czy OTT unicast — jak operator powinien dostarczać telewizję na żywo? Jeden wydajny strumień dla wszystkich w sieci zarządzanej czy osobny strumień adaptacyjny dla każdego widza przez internet? Uczciwe kompromisy w kwestii przepustowości, jakości, opóźnień i zasięgu — i dlaczego wielu operatorów stawia na oba rozwiązania.",
    moBreadcrumbPage: "Multicast IPTV a OTT",
    moHeroEyebrow: "Przewodnik po architekturze dostarczania sygnału",
    moHeroTitle: "Multicast IPTV a streaming OTT:",
    moHeroTitleAccent: "dlaczego warto używać obu",
    moHeroSub:
      "Telewizję na żywo można dostarczać na dwa sposoby: jednym strumieniem do wielu widzów we własnej sieci zarządzanej (multicast IPTV) albo osobnym strumieniem adaptacyjnym do każdego widza przez publiczny internet (OTT unicast). Nowe wdrożenia coraz częściej wykorzystują OTT, ponieważ działa w dowolnej sieci i na wielu typach urządzeń. Operatorzy, którzy mają już infrastrukturę multicastową, zachowują ją ze względu na wysoką wydajność, małe opóźnienie i przewidywalną jakość transmisji na żywo. Oba rozwiązania mogą się uzupełniać: multicast obsługuje kanały linearne, a unicast pozostałe treści.",
    moHeroNote:
      "Dekodery inext i nasza aplikacja IPTV obsługują oba sposoby transmisji na tym samym urządzeniu: multicast w sieci zarządzanej operatora oraz OTT przez internet.",
    moHeroCtaPrimary: "Porozmawiaj z naszym zespołem",
    moHeroCtaSecondary: "Zobacz, jak dekoder łączy oba",
    moStat1: "Jeden strumień → wielu widzów (multicast)",
    moStat2: "Dowolna sieć, dowolne urządzenie (OTT)",
    moStat3: "Hybryda: jeden dekoder, oba rozwiązania",
    moThesisEyebrow: "Zacznij tutaj",
    moThesisTitle: "Liczy się sieć, nie tylko sam strumień",
    moThesisBody1:
      "Najważniejsza różnica dotyczy sposobu przesyłania wideo. Multicast rozprowadza w sieci zarządzanej pojedynczą kopię każdego kanału na żywo, z której korzystają wszyscy oglądający. OTT tworzy osobny strumień unicast dla każdego widza w publicznym internecie i dostosowuje przepływność do jakości jego łącza. Pierwsze rozwiązanie stawia na wydajność i kontrolę we własnej sieci, drugie — na zasięg oraz elastyczność poza nią.",
    moThesisBody2:
      "W przypadku sieci budowanych od podstaw OTT jest dziś najczęstszym wyborem. Czysty multicast IPTV bywa uznawany za technologię starszej generacji, ale w istniejącej sieci zarządzanej nadal zapewnia bardzo małe opóźnienie, przewidywalną jakość i wysoką efektywność transmisji na żywo. Dlatego wielu operatorów zachowuje multicast w modelu hybrydowym: kanały linearne przesyła przez multicast, a VOD, catch-up i time-shift przez unicast. Każde zadanie trafia do rozwiązania, które obsługuje je najlepiej.",
    moThesisCoreLabel: "Sieć zarządzana, jeden do wielu",
    moThesisCoreValue: "Multicast IPTV",
    moThesisReachLabel: "Publiczny internet, jeden do jednego",
    moThesisReachValue: "OTT unicast",
    moDefineEyebrow: "Jak działa każde z rozwiązań",
    moDefineTitle: "Dwa sposoby transmisji wideo na żywo",
    moMcastColTitle: "Multicast IPTV",
    moMcastColSub:
      "Jeden strumień współdzielony przez wszystkich widzów w Twojej sieci zarządzanej",
    moMcast1:
      "Przez sieć wędruje jedna kopia każdego kanału; widzowie dołączają do niej przez IGMP",
    moMcast2: "Przepustowość pozostaje stała niezależnie od liczby oglądających",
    moMcast3: "Stała przepływność i priorytetyzacja ruchu — przewidywalna jakość bez buforowania",
    moMcast4:
      "Opóźnienie poniżej sekundy — idealne dla transmisji sportowych i wydarzeń ogólnokrajowych",
    moMcast5:
      "Działa w sieci zarządzanej z obsługą multicastu, po przewodowym Ethernecie — Wi-Fi nie przenosi go niezawodnie",
    moMcast6: "Stworzony do telewizji linearnej; VOD i personalizacja nadal działają na unicaście",
    moOttColTitle: "OTT unicast",
    moOttColSub: "Osobny strumień adaptacyjny dla każdego widza przez publiczny internet",
    moOtt1: "Każdy widz otrzymuje własny strumień z sieci CDN",
    moOtt2: "Adaptacyjna przepływność (HLS/DASH) dostosowuje się do jakości każdego łącza",
    moOtt3:
      "Działa w dowolnej sieci i na różnych urządzeniach — telefonach, laptopach oraz telewizorach Smart TV — także poza siecią operatora",
    moOtt4:
      "Jakość w trybie best-effort; opóźnienie jest wyższe (HLS/DASH o niskim opóźnieniu dziś ~2–5 s)",
    moOtt5: "Przepustowość i koszt CDN rosną z każdym jednoczesnym widzem",
    moOtt6: "Natywnie obsługuje VOD, catch-up, nPVR i personalizację",
    moTableEyebrow: "Zestawienie",
    moTableTitle: "Porównanie obu rozwiązań",
    moTableColDimension: "",
    moTableColMcast: "Multicast IPTV",
    moTableColOtt: "OTT unicast",
    moRow1Label: "Przepustowość przy skali",
    moRow1Mcast: "Stała — jeden strumień dla wszystkich",
    moRow1Ott: "Liniowa — jeden strumień na widza",
    moRow2Label: "Wymagana sieć",
    moRow2Mcast: "Wyłącznie Twoja sieć zarządzana",
    moRow2Ott: "Dowolna sieć, publiczny internet",
    moRow3Label: "Zasięg",
    moRow3Mcast: "Dekodery w sieci operatora",
    moRow3Ott: "Dowolne urządzenie, wszędzie",
    moRow4Label: "Jakość",
    moRow4Mcast: "Gwarantowana, ustalony bitrate",
    moRow4Ott: "Best-effort, adaptacyjna",
    moRow5Label: "Opóźnienie na żywo",
    moRow5Mcast: "Poniżej sekundy",
    moRow5Ott: "~2–5 s przy niskim opóźnieniu, do 10–30 s",
    moRow6Label: "Najlepsze do",
    moRow6Mcast: "Telewizja linearna, sport, duże kanały",
    moRow6Ott: "VOD, catch-up, urządzenia mobilne, poza siecią operatora",
    moRow7Label: "VOD i personalizacja",
    moRow7Mcast: "Wymaga unicastu",
    moRow7Ott: "Natywnie",
    moRow8Label: "Charakter kosztów",
    moRow8Mcast: "Przygotowanie sieci; stały przy skali",
    moRow8Ott: "CDN / transfer wychodzący; rośnie z liczbą widzów",
    moRow9Label: "Kontrola QoS",
    moRow9Mcast: "Pełna — sieć należy do Ciebie",
    moRow9Ott: "Ograniczona — best-effort",
    moRow10Label: "Połączenie",
    moRow10Mcast: "Przewodowy Ethernet — nie Wi-Fi",
    moRow10Ott: "Dowolne łącze, także Wi-Fi",
    moTableInextLabel: "Na dekoderach inext",
    moTableInextValue:
      "Jedna aplikacja IPTV odtwarza oba — multicast w sieci operatora, OTT poza nią",
    moTableNote:
      "Większość platform przypisuje telewizję linearną do multicastu wszędzie tam, gdzie pozwala na to sieć zarządzana, a całą resztę do unicastu.",
    moScaleEyebrow: "Różnica w wydajności",
    moScaleTitle: "Dlaczego multicast wciąż wygrywa przy wielkich wydarzeniach na żywo",
    moScaleBody:
      "Wyobraźmy sobie ogólnokrajowy finał oglądany jednocześnie przez 50 000 abonentów. Multicast rozprowadza jeden wspólny strumień w sieci, natomiast unicast wymaga 50 000 osobnych sesji, przez co rosną koszty CDN i transferu wychodzącego. Właśnie dlatego sieci multicastowe nadal pozostają w użyciu: wraz ze wzrostem widowni rosną oszczędności pasma i kosztów, a transmisja w sieci zarządzanej zachowuje bardzo małe opóźnienie.",
    moFitListEyebrow: "Kiedy którego użyć",
    moFitListTitle: "Dobierz sposób transmisji do rodzaju treści",
    moFit1:
      "Telewizja linearna na żywo na dużą skalę w Twojej sieci zarządzanej → multicast. Sport i duże kanały zyskują opóźnienie poniżej sekundy, gwarantowaną jakość i stałą przepustowość.",
    moFit2:
      "VOD, catch-up, przesuwanie w czasie, nPVR i kanały personalizowane → unicast. Z natury działają indywidualnie dla widza, więc OTT pasuje tu naturalnie.",
    moFit3:
      "Urządzenia mobilne, podróże, drugie ekrany i abonenci poza siecią operatora → OTT. Dociera do dowolnej sieci i dowolnego urządzenia bez infrastruktury multicastowej.",
    moFit4:
      "Usługi wymagające przewidywalnej jakości → multicast nadal ma wyraźną przewagę i pozostaje uzasadnionym wyborem, a nie technologicznym przeżytkiem.",
    moBothEyebrow: "Tu wkraczamy my",
    moBothTitle: "Jeden dekoder, oba sposoby transmisji",
    moBothBody:
      "Wybór sposobu transmisji nie wymaga wyboru innego urządzenia. Dekodery inext i nasza aplikacja IPTV obsługują multicast (UDP/RTP z IGMP) w sieci zarządzanej oraz OTT przez unicast (HLS/DASH, M3U i portale Stalker/Ministra/Xtream). Abonent może oglądać kanał na żywo przez multicast, a następnie uruchomić materiał VOD przesyłany przez unicast — w ramach jednej spójnej usługi. Każdy dekoder inext ma port Ethernet potrzebny w klasycznych instalacjach multicastowych. To samo urządzenie sprawdzi się w usłudze unicastowej, multicastowej lub hybrydowej.",
    moBothNoteTitle: "Masz już jedno? Dodaj drugie.",
    moBothNoteBody:
      "Działasz wyłącznie na multicaście i potrzebujesz zasięgu OTT dla urządzeń mobilnych i abonentów poza siecią? A może masz czysty OTT i chcesz wydajności multicastu na duże wydarzenia na żywo? Dekoder i aplikacja obsługują oba rozwiązania, więc możesz rozszerzyć usługę bez zmiany platformy. Pomożemy Ci określić zakres prac.",
    moFaqEyebrow: "FAQ",
    moFaqTitle: "Najczęstsze pytania",
    moFaqQ1: "Czy OTT czyni multicast przestarzałym?",
    moFaqA1:
      "W nowych wdrożeniach dominują dziś unicast i OTT, a czysty multicast IPTV nie jest już domyślnym wyborem. Nie oznacza to jednak, że stał się bezużyteczny. W istniejącej sieci zarządzanej nadal zapewnia wysoką wydajność, bardzo małe opóźnienie i przewidywalną jakość transmisji na żywo. Dlatego wiele takich sieci działa w modelu hybrydowym, wykorzystując unicast do VOD i catch-up.",
    moFaqQ2: "Które rozwiązanie daje lepszą jakość obrazu?",
    moFaqA2:
      "W sieci zarządzanej multicast zapewnia stałą przepływność i priorytetyzację ruchu, dzięki czemu jakość jest przewidywalna. OTT korzysta z transmisji adaptacyjnej w trybie best-effort: na dobrym łączu jakość może być znakomita, a na słabym ulega zmianie. Multicast daje większą kontrolę od końca do końca, natomiast zaletą OTT jest skuteczne działanie w sieciach o zmiennych parametrach.",
    moFaqQ3: "Czy multicast wymaga specjalnej sieci?",
    moFaqA3:
      "Tak. Multicast wymaga sieci zarządzanej, w której każdy przełącznik na trasie obsługuje multicast (IGMP), oraz przewodowego łącza Ethernet przy dekoderze — Wi-Fi nie przenosi multicastu niezawodnie. Dlatego jest to technologia telekomów i dostawców internetu, dla abonentów w sieci operatora, i dlatego każdy dekoder inext ma port Ethernet. OTT nie wymaga niczego takiego — działa przez publiczny internet i dowolne łącze, w tym Wi-Fi, i właśnie dlatego dociera wszędzie.",
    moFaqQ4: "Czy jeden dekoder obsłuży oba rozwiązania?",
    moFaqA4:
      "Tak — i o to właśnie chodzi w naszych dekoderach. Dekodery inext i aplikacja IPTV odtwarzają multicast na żywo w Twojej sieci oraz strumienie OTT przez internet, przełączając się między nimi w sposób niezauważalny. Abonent widzi jedną usługę; to Ty decydujesz, które rozwiązanie obsługuje dane treści.",
    moFaqQ5: "A co z opóźnieniem przy transmisjach sportowych na żywo?",
    moFaqA5:
      "Multicast zwykle zapewnia opóźnienie poniżej sekundy, co ma szczególne znaczenie podczas transmisji sportowych. Standardowy OTT może pozostawać 10–30 sekund za sygnałem źródłowym, a rozwiązania HLS/DASH o małym opóźnieniu skracają tę różnicę do około 2–5 sekund. Dla większości treści jest to wystarczające, ale przy dużych wydarzeniach na żywo multicast nadal zachowuje przewagę.",
    moFaqQ6: "Czym jest multicast ABR?",
    moFaqA6:
      "Multicast ABR (mABR) przenosi strumienie o adaptacyjnym bitrate w formatach OTT przez multicast — łącząc przyjazny dla urządzeń format OTT z wydajnością multicastu w trybie jeden do wielu. Potrafi ściąć szczyty ruchu na żywo nawet o 90% i pozwala operatorom skalować masowe jednoczesne oglądanie na żywo bez osobnego strumienia unicast dla każdego widza. Nasza platforma to obsługuje.",
    moCtaEyebrow: "Porozmawiajmy",
    moCtaTitle: "Dostarczaj telewizję na żywo tak, jak zbudowana jest Twoja sieć",
    moCtaBody:
      "Opowiedz nam o swojej sieci, kanałach i widowni. Pomożemy Ci umieścić multicast i OTT tam, gdzie sprawdzają się najlepiej — i dostarczymy dekodery gotowe do obsługi obu rozwiązań od razu po wyjęciu z pudełka.",
    moCtaPrimary: "Porozmawiaj z naszym zespołem",
    moCtaSecondary: "Zamów próbkę",
    bbSeoTitle:
      "Budować czy kupić: czy dostawca internetu powinien tworzyć własny dekoder? | inext",
    bbSeoDescription:
      "Zbudować własną platformę dekodera czy kupić gotowe rozwiązanie pod klucz? Budowa oznacza połączenie ośmiu warstw: układu scalonego, sprzętu, firmware, aplikacji, DRM, zarządzania urządzeniami, produkcji i wsparcia. Praktyczny przewodnik dla operatorów.",
    bbBreadcrumbPage: "Budować czy kupić",
    bbHeroEyebrow: "Przewodnik „zrobić czy kupić”",
    bbHeroTitle: "Zbudować własny dekoder czy kupić gotowe rozwiązanie?",
    bbHeroTitleAccent: "praktyczne porównanie obu modeli",
    bbHeroSub:
      "Budowa własnego dekodera brzmi jak projekt sprzętowy, ale operatorzy nie produkują układów scalonych, a tylko nieliczni projektują własne płytki. W praktyce chodzi o połączenie ośmiu warstw — od SoC po wsparcie — i przejęcie odpowiedzialności za każdą z nich. Dla części operatorów jest to właściwa droga. Ten poradnik wyjaśnia rzeczywisty zakres takiego projektu i pomaga ocenić, kiedy warto budować, a kiedy współpracować z dostawcą.",
    bbHeroNote:
      "Oferujemy model zakupu i współpracy, ale budowa własnej platformy może mieć sens dla operatorów o odpowiedniej skali, wymaganiach i zapleczu technicznym. Poniżej uczciwie porównujemy oba podejścia.",
    bbHeroCtaPrimary: "Porozmawiaj z naszym zespołem",
    bbHeroCtaSecondary: "Zobacz 8 warstw",
    bbStat1: "Odpowiedzialność za 8 warstw",
    bbStat2: "Budowa: wieloletni program",
    bbStat3: "Zakup: próbka pod własną marką w 1–2 tygodnie",
    bbThesisEyebrow: "Zacznij tutaj",
    bbThesisTitle: "„Budowa” oznacza przede wszystkim integrację",
    bbThesisBody1:
      "Układy scalone pochodzą od ich dostawców, a płytki zazwyczaj projektują i produkują firmy ODM. Budowa własnego dekodera jest więc przede wszystkim projektem integracyjnym: łączy zamówiony sprzęt, napisane lub licencjonowane oprogramowanie oraz procesy produkcji, aktualizacji i wsparcia. Operator przejmuje odpowiedzialność za całość od początku do końca.",
    bbThesisBody2:
      "To uzasadniona droga, ale jej zakres jest większy, niż może się początkowo wydawać. Gotowy dekoder wymaga ośmiu odrębnych kompetencji, a braki w którejkolwiek z nich mogą później opóźnić uruchomienie lub powodować awarie w terenie. Przed podjęciem decyzji warto przeanalizować cały ekosystem, za który operator będzie odpowiadać.",
    bbThesisCoreLabel: "Czym „budowa” naprawdę jest",
    bbThesisCoreValue: "Integracja platformy i odpowiedzialność za jej utrzymanie",
    bbThesisReachLabel: "Co i tak kupujesz",
    bbThesisReachValue: "Krzem · sprzęt ODM · licencje DRM",
    bbLayersEyebrow: "Kompletny ekosystem",
    bbLayersTitle: "Osiem warstw potrzebnych do stworzenia dekodera",
    bbLayersIntro:
      "Dekoder wygląda jak jeden produkt, ale wymaga ośmiu powiązanych obszarów kompetencji. Poniżej wyjaśniamy każdą warstwę i zakres odpowiedzialności związany z jej samodzielnym utrzymaniem.",
    bbLayer1Name: "Krzem (SoC)",
    bbLayer1Body:
      "Układ scalony, na przykład Amlogic, Allwinner lub Realtek. Operator wybiera go, ale go nie produkuje. SoC określa możliwości 4K, obsługiwane kodeki, poziom DRM i funkcje bezpiecznego rozruchu.",
    bbLayer2Name: "Sprzęt i projekt przemysłowy",
    bbLayer2Body:
      "Płytka, porty, obudowa, zasilacz i pilot. Zazwyczaj projektuje i produkuje je firma ODM na podstawie projektu referencyjnego lub specyfikacji operatora.",
    bbLayer3Name: "Firmware i BSP",
    bbLayer3Body:
      "Android AOSP albo Linux, jądro, sterowniki i bezpieczny rozruch. Dostawca zapewnia podstawę, ale przygotowanie stabilnej wersji produkcyjnej wymaga zespołu systemów wbudowanych.",
    bbLayer4Name: "Launcher i middleware",
    bbLayer4Body:
      "Ekran główny pod marką operatora, EPG, ustawienia i sposób uruchamiania aplikacji — elementy, które abonenci bezpośrednio kojarzą z usługą.",
    bbLayer5Name: "Aplikacje",
    bbLayer5Body:
      "Aplikacje operatora do IPTV, VOD i OTT. Usług takich jak Netflix czy Disney+ nie tworzy się samodzielnie — każda ma własne wymagania certyfikacyjne i handlowe.",
    bbLayer6Name: "DRM i ochrona treści",
    bbLayer6Body:
      "Licencjonowane i fabrycznie wdrożone rozwiązania, takie jak Widevine i Verimatrix. Klucze Widevine L1 muszą zostać wgrane podczas produkcji na układzie z bezpieczną enklawą — nie można dodać ich później zwykłą aktualizacją.",
    bbLayer7Name: "Zarządzanie urządzeniami i OTA",
    bbLayer7Body:
      "Provisioning, etapowe aktualizacje firmware z możliwością wycofania, zdalna diagnostyka i TR-069 wymagają osobnego systemu zaplecza.",
    bbLayer8Name: "Produkcja, logistyka i wsparcie",
    bbLayer8Body:
      "Produkcja, dostawy międzynarodowe, certyfikacja, kontrola jakości, obsługa RMA i wsparcie techniczne stanowią znaczną część całego przedsięwzięcia.",
    bbSpectrumEyebrow: "Jak operatorzy naprawdę budują",
    bbSpectrumTitle: "Cztery sposoby, by „budować” — od największego do najmniejszego",
    bbApproach1Name: "W pełni własnymi siłami",
    bbApproach1Body:
      "Własne zespoły systemów wbudowanych, aplikacji i zaplecza serwerowego; ODM produkujący według specyfikacji operatora; własne umowy DRM oraz system zarządzania urządzeniami; samodzielnie prowadzona certyfikacja. To realny wariant dla operatorów Tier 1, wymagający kilkuletniego programu i pracy wielu zespołów.",
    bbApproach2Name: "Projekt referencyjny + Twoje oprogramowanie",
    bbApproach2Body:
      "Punktem wyjścia jest płytka referencyjna SoC albo dekoder ODM, a zespół operatora tworzy firmware, launcher, aplikację i integrację z DMS. Nadal wymaga to specjalistów od systemów wbudowanych, ale eliminuje samodzielne projektowanie sprzętu.",
    bbApproach3Name: "Urządzenia detaliczne + Twoja aplikacja",
    bbApproach3Body:
      "Operator nie dostarcza własnego sprzętu, lecz publikuje aplikację na Chromecast/Google TV, Fire TV albo detaliczne dekodery z Androidem. Tworzy wyłącznie aplikację i rezygnuje z pełnej personalizacji oraz zarządzania flotą, a ekran główny i aktualizacje pozostają pod kontrolą producenta urządzenia.",
    bbApproach4Name: "Sprzęt ODM + gotowa platforma dostawcy",
    bbApproach4Body:
      "Sprzęt pochodzi od ODM, a firmware, launcher, aplikacja i DMS są licencjonowane od wyspecjalizowanego dostawcy. Operator odpowiada za markę i konfigurację, natomiast najbardziej złożone warstwy są już gotowe. To model zakupu i współpracy.",
    bbCostEyebrow: "Uczciwy koszt",
    bbCostTitle: "Budowa to program, nie zakup",
    bbCostBody:
      "Budowa od podstaw wymaga kompetencji, których operator może jeszcze nie mieć: firmware systemów wbudowanych, tworzenia aplikacji, wgrywania kluczy DRM, zaplecza do zarządzania urządzeniami i OTA, produkcji, logistyki, certyfikacji oraz wsparcia. Zespoły te trzeba utrzymywać przez cały cykl życia produktu. Oprócz kosztu początkowego dochodzą stałe wydatki na nowe wersje systemu, poprawki bezpieczeństwa i kolejne aplikacje. To program liczony w kwartałach lub latach i wymagający stałych etatów, a nie jednorazowy zakup.",
    bbWhenEyebrow: "Kiedy budować",
    bbWhenTitle: "Budowa naprawdę wygrywa, gdy…",
    bbWhen1:
      "Masz skalę. Baza abonentów na tyle duża, by rozłożyć koszt zespołu inżynierskiego na wszystkie urządzenia, zmienia cały rachunek.",
    bbWhen2:
      "Masz unikalne wymaganie. Funkcję albo integrację, której nie oferuje żaden dostawca, a która jest sednem tego, co Cię wyróżnia.",
    bbWhen3:
      "Masz już zespół. Wewnętrzny zespół systemów wbudowanych i aplikacji, który zamierzasz finansować długofalowo.",
    bbWhen4:
      "Pełna kontrola ma znaczenie strategiczne. Odpowiedzialność za każdą warstwę, a nie tylko dostosowanie marki, jest świadomą decyzją zarządu.",
    bbWhenNote:
      "Jeśli pasują do Ciebie dwa z tych punktów lub więcej, budowa zasługuje na poważne rozważenie. Jeśli żaden, rachunek zwykle przemawia za zamówieniem trudnych warstw na zewnątrz.",
    bbTableEyebrow: "Obok siebie",
    bbTableTitle: "Budować czy kupić, wymiar po wymiarze",
    bbTableColDimension: "",
    bbTableColBuild: "Budowa własnymi siłami",
    bbTableColBuy: "Zakup i współpraca",
    bbRow1Label: "Czas wejścia na rynek",
    bbRow1Build: "Od kwartałów do lat",
    bbRow1Buy: "Tygodnie do pierwszej próbki",
    bbRow2Label: "Koszt na starcie",
    bbRow2Build: "Wysoki — zespoły i narzędzia",
    bbRow2Buy: "Za urządzenie plus wdrożenie",
    bbRow3Label: "Potrzebny zespół",
    bbRow3Build: "Systemy wbudowane, aplikacje, zaplecze serwerowe, QA",
    bbRow3Buy: "Produkt i operacje",
    bbRow4Label: "Utrzymanie firmware i systemu",
    bbRow4Build: "Stała odpowiedzialność operatora",
    bbRow4Buy: "Utrzymywane za Ciebie",
    bbRow5Label: "DRM (Widevine L1)",
    bbRow5Build: "Negocjujesz i wgrywasz sam",
    bbRow5Buy: "Wgrywane fabrycznie",
    bbRow6Label: "Zarządzanie urządzeniami i OTA",
    bbRow6Build: "Budujesz zaplecze serwerowe",
    bbRow6Buy: "W komplecie (DMS + OTA)",
    bbRow7Label: "Certyfikacja",
    bbRow7Build: "Certyfikacja GMS i aplikacji po stronie operatora",
    bbRow7Buy: "Prowadzona przez dostawcę lub jego partnera",
    bbRow8Label: "Produkcja i logistyka",
    bbRow8Build: "Twój ODM i transport",
    bbRow8Buy: "W komplecie, na cały świat",
    bbRow9Label: "Kontrola",
    bbRow9Build: "Pełna — każda warstwa",
    bbRow9Buy: "Kontrola nad marką i konfiguracją",
    bbRow10Label: "Gdzie leży ryzyko",
    bbRow10Build: "Na Tobie, od początku do końca",
    bbRow10Buy: "Dzielone z dostawcą",
    bbTableInextLabel: "Gdzie tu inext",
    bbTableInextValue:
      "Model zakupu i współpracy — własna marka i konfiguracja, działająca próbka w 1–2 tygodnie",
    bbTableNote:
      "Żaden wariant nie jest właściwy w każdej sytuacji. Wybór zależy od skali, kompetencji zespołu i zakresu odpowiedzialności, który operator chce przejąć.",
    bbFitEyebrow: "Gdzie tu my",
    bbFitTitle: "Gotowa platforma, którą dostosowujesz do swojej marki",
    bbFitBody:
      "inext działa w modelu zakupu i współpracy, przejmując odpowiedzialność za osiem warstw platformy. Dostarczamy sprzęt ODM, Android AOSP albo Linux, launcher w warstwie Operator Tier, aplikację IPTV, fabrycznie wdrożone Widevine L1 i Verimatrix, Alcatraz DMS z etapowymi aktualizacjami OTA oraz produkcję i dostawę na cały świat. Całość jest dostępna w modelu white-label: z marką operatora w firmware, a opcjonalnie także na urządzeniu i pilocie. Zamiast wielokwartalnego programu operator wybiera model, określa identyfikację i otrzymuje działającą próbkę w ciągu 1–2 tygodni.",
    bbFitNoteTitle: "Nie masz pewności, po której stronie jesteś?",
    bbFitNoteBody:
      "Powiedz nam, jaką masz skalę, czy dysponujesz własnym zespołem systemów wbudowanych i jak szybko musisz wystartować. Dostaniesz uczciwą ocenę „budować czy kupić” dla Twojej sytuacji — a nie ofertę sprzedażową.",
    bbFaqEyebrow: "FAQ",
    bbFaqTitle: "Częste pytania",
    bbFaqQ1: "Czy żeby „budować”, muszę zaprojektować własny sprzęt?",
    bbFaqA1:
      "Nie. Układy scalone pochodzą od ich dostawców, a płytki zazwyczaj od ODM; nawet projekt rozwijany własnymi siłami zaczyna się od konstrukcji referencyjnej. Budowa oznacza przejęcie odpowiedzialności za oprogramowanie, integrację i procesy operacyjne, a nie samodzielną produkcję PCB.",
    bbFaqQ2: "Czy nie mogę po prostu wrzucić aplikacji na detaliczne dekodery z Androidem?",
    bbFaqA2:
      "Tak, a w modelu opartym wyłącznie na aplikacji może to być dobry początek. Detaliczny dekoder nie daje jednak pełnej kontroli: nawet przy Widevine L1 operator nie ma własnej identyfikacji sprzętu, zarządzania flotą ani funkcji net-lock, a ekran główny i aktualizacje kontroluje producent. Takie podejście zwiększa zasięg, ale słabiej sprawdza się w zarządzanej usłudze pod marką operatora.",
    bbFaqQ3: "Która warstwa jest najtrudniejsza do zbudowania?",
    bbFaqA3:
      "Najczęściej firmware. Samo uruchomienie płyty jest dopiero początkiem; znacznie trudniejsze jest zapewnienie stabilności, wydajności i bezpieczeństwa przez cały cykl życia. Każdy SoC i każda płyta wymagają dostrojonych sterowników, toru wideo, integracji DRM, zarządzania zasilaniem i bezpiecznego rozruchu. Nie jest to jednorazowe przeniesienie oprogramowania, lecz wieloletni proces rozwoju i testowania, którego zespoły często nie doszacowują.",
    bbFaqQ4: "Ile trwa prawdziwa budowa?",
    bbFaqA4:
      "Program prowadzony od zera trwa kwartały, a nie tygodnie. Przygotowanie produkcyjnego firmware, wgranie kluczy DRM, system zarządzania urządzeniami, certyfikacja i produkcja wymagają czasu, a część etapów musi przebiegać kolejno. Zlecenie najbardziej złożonych warstw wyspecjalizowanemu partnerowi skraca projekt do czasu potrzebnego na dostosowanie marki i konfigurację sprawdzonej platformy.",
    bbFaqQ5: "Kiedy budowa naprawdę ma sens?",
    bbFaqA5:
      "Gdy masz skalę, na której rozłożysz koszt zespołu inżynierskiego, unikalne wymaganie, którego nie pokrywa żaden dostawca, wewnętrzny zespół, który zamierzasz utrzymać, albo strategiczny powód, by mieć na własność każdą warstwę. Jeśli pasują do Ciebie dwa punkty lub więcej, budowa zasługuje na poważne rozważenie; jeśli żaden, zwykle wygrywa zamówienie na zewnątrz.",
    bbFaqQ6: "Po której stronie jest inext — budować czy kupić?",
    bbFaqA6:
      "Oferujemy model zakupu i współpracy. Dostarczamy sprzęt ODM, firmware AOSP albo Linux, launcher i aplikację IPTV pod marką operatora, fabrycznie wdrożone DRM, Alcatraz DMS i OTA oraz globalną produkcję i logistykę. Wszystko działa w modelu white-label, dlatego do abonenta trafia jako produkt operatora. Jeśli skala, wymagania i zaplecze techniczne przemawiają za samodzielną budową, również wskażemy to w ocenie projektu.",
    bbCtaEyebrow: "Porozmawiaj z nami",
    bbCtaTitle: "Uzyskaj uczciwą ocenę „budować czy kupić”",
    bbCtaBody:
      "Opowiedz nam o skali projektu, własnym zespole systemów wbudowanych i planowanym harmonogramie. Przedstawimy ocenę dopasowaną do sytuacji, a jeśli właściwy będzie model zakupu, przygotujemy działającą próbkę pod Twoją marką w ciągu 1–2 tygodni.",
    bbCtaPrimary: "Porozmawiaj z naszym zespołem",
    bbCtaSecondary: "Poproś o próbkę",
    guidesCardRsgTitle: "Ile RAM i pamięci wewnętrznej potrzebuje dekoder?",
    guidesCardRsgDesc:
      "Przewodnik po doborze 1 GB, 2 GB lub 4 GB RAM do konkretnego zastosowania. Wyjaśnia też, jak ocenić pamięć wewnętrzną, oprogramowanie i wyniki testów, które mówią więcej niż same liczby w specyfikacji.",
    footerLinkGuidesRamStorage: "RAM i pamięć wewnętrzna dekodera",
    rsgSeoTitle: "Ile RAM i pamięci potrzebuje dekoder? | inext",
    rsgSeoDescription:
      "Porównaj 1 GB, 2 GB i 4 GB RAM oraz 8 GB, 16 GB i 32 GB pamięci w dekoderach. Dobierz konfigurację do oprogramowania, aplikacji, gier i sposobu użytkowania.",
    rsgBreadcrumbPage: "RAM i pamięć dekodera",
    rsgHeroEyebrow: "Przewodnik po konfiguracjach dekoderów",
    rsgPublishedLabel: "Opublikowano",
    rsgUpdatedLabel: "Zaktualizowano",
    rsgHeroTitle: "Ile RAM i pamięci wewnętrznej",
    rsgHeroTitleAccent: "naprawdę potrzebuje dekoder?",
    rsgHeroSub:
      "Nie ma jednego minimum dla każdego nowoczesnego dekodera. Dobrze zoptymalizowane urządzenie z 1 GB może sprawnie obsługiwać usługę o ściśle określonym zakresie. Więcej pamięci ma sens przy rozbudowanym zestawie aplikacji, grach uruchamianych na urządzeniu lub dłuższym planowanym okresie eksploatacji.",
    rsgHeroNote:
      "Dobierz konfigurację do całego rozwiązania — oprogramowania systemowego, ekranu głównego, aplikacji, aktualizacji i gier — a nie do największej liczby w tabeli danych technicznych.",
    rsgHeroCtaPrimary: "Porównaj konfiguracje",
    rsgHeroCtaSecondary: "Porównaj modele inext",
    rsgStat1: "Do konkretnego zadania",
    rsgStat2: "Uniwersalny wybór",
    rsgStat3: "Największy zapas",
    rsgThesisEyebrow: "Krótka odpowiedź",
    rsgThesisTitle: "Sama pojemność pamięci nie określa wydajności",
    rsgThesisBody1:
      "RAM służy systemowi operacyjnemu i aplikacjom podczas pracy. Pamięć wewnętrzna mieści oprogramowanie systemowe, aplikacje, aktualizacje i dane lokalne. Same wartości w gigabajtach nie mówią nic o jakości oprogramowania, szybkości nośnika, możliwościach GPU, odprowadzaniu ciepła ani liczbie zbędnych procesów działających w tle.",
    rsgThesisBody2:
      "Dlatego dobrze zaprojektowany dekoder z 1 GB może sprawnie działać w usłudze o jasno określonym zakresie, a źle dostrojone urządzenie z większą ilością RAM nadal może uruchamiać się wolno, zamykać aplikacje lub działać niestabilnie. Więcej pamięci daje elastyczność i zapas, ale nie naprawia słabego oprogramowania.",
    rsgThesisNoteTitle: "Kiedy 1 GB naprawdę wystarcza",
    rsgThesisNoteBody:
      "Jeden gigabajt wystarcza tylko wtedy, gdy scenariusz użycia jest znany, oprogramowanie systemowe zostało przygotowane dla danego sprzętu, a kompletne rozwiązanie przetestowano w realistycznych warunkach. Nie jest to ogólne zalecenie dla każdego urządzenia z Androidem.",
    rsgGoogleNote:
      "Publiczne wymagania zgodności z Androidem są bardziej złożone niż uniwersalna zasada „minimum 2 GB”: zależą od wersji Androida, architektury, konfiguracji wyświetlacza i pamięci zarezerwowanej przez sprzęt.",
    rsgGoogleLink: "Zobacz wymagania zgodności z Androidem",
    rsgWorkloadsEyebrow: "Zacznij od zastosowania",
    rsgWorkloadsTitle: "Wymagania zależą od zastosowania",
    rsgWorkloadsIntro:
      "Dekoder operatora, urządzenie w pokoju hotelowym, otwarta platforma z wieloma aplikacjami i sprzęt do gier mają różne potrzeby. Określ, co musi działać od początku i jakie funkcje mogą pojawić się później.",
    rsgWorkload1Title: "Dedykowana usługa telewizyjna",
    rsgWorkload1Body:
      "Zarządzany ekran główny i jedna podstawowa aplikacja telewizyjna, ze ściśle kontrolowanym oprogramowaniem systemowym i niewielką liczbą usług w tle.",
    rsgWorkload1Signal: "Optymalizacja jest ważniejsza niż liczba aplikacji",
    rsgWorkload2Title: "Wiele aplikacji multimedialnych",
    rsgWorkload2Body:
      "Kilka aplikacji IPTV, OTT, multimedialnych i użytkowych, między którymi użytkownicy przechodzą podczas jednej sesji.",
    rsgWorkload2Signal: "Zostaw miejsce na przełączanie aplikacji i pamięć podręczną",
    rsgWorkload3Title: "Hotele i budynki wielorodzinne",
    rsgWorkload3Body:
      "Interfejs zgodny z marką obiektu, informacje dla gości, przesyłanie obrazu z urządzeń mobilnych i integracje z usługami hotelowymi, wdrażane często w wielu pokojach.",
    rsgWorkload3Signal: "Najważniejsze są spójne działanie i zdalne przywracanie",
    rsgWorkload4Title: "Proste gry",
    rsgWorkload4Body:
      "Lekkie gry na Androida i proste interaktywne rozwiązania obok zwykłych aplikacji multimedialnych.",
    rsgWorkload4Signal: "RAM pomaga, ale nadal decydują GPU i sterowanie",
    rsgWorkload5Title: "Gry w chmurze",
    rsgWorkload5Body:
      "Gra jest renderowana zdalnie, a dekoder odtwarza strumień wideo z małym opóźnieniem i wysyła polecenia kontrolera.",
    rsgWorkload5Signal: "Opóźnienie sieci może znaczyć więcej niż dodatkowy RAM",
    rsgWorkload6Title: "Rozbudowane platformy własne",
    rsgWorkload6Body:
      "Wiele aplikacji pod własną marką, usługi w tle, analityka, integracje i funkcje, których zakres będzie z czasem rosnąć.",
    rsgWorkload6Signal: "Zaplanuj zapas na rozwój produktu",
    rsgRamEyebrow: "Co zużywa RAM",
    rsgRamTitle: "Cztery obszary zużywają dostępny RAM",
    rsgRamIntro:
      "Właściwe pytanie nie brzmi „Ile gigabajtów?”, lecz „Ile pamięci pozostaje podczas działania całej usługi?”. Pomiar trzeba wykonać na kompletnym oprogramowaniu docelowym, a nie na czystej wersji rozwojowej.",
    rsgRamFactor1Title: "System operacyjny i usługi",
    rsgRamFactor1Body:
      "Android lub Linux, ekran główny, obsługa sieci, DRM, system zarządzania urządzeniami i usługi producenta zajmują pamięć jeszcze przed uruchomieniem głównej aplikacji.",
    rsgRamFactor2Title: "Aplikacje i praca w tle",
    rsgRamFactor2Body:
      "Dane EPG, miniatury, analityka, pamięć podręczna i procesy w tle decydują, czy aplikacje pozostają gotowe, czy muszą uruchamiać się ponownie.",
    rsgRamFactor3Title: "Odtwarzanie wideo",
    rsgRamFactor3Body:
      "Nowoczesne dekodery odtwarzają wideo za pomocą wyspecjalizowanego sprzętu. Płynność 4K zależy głównie od SoC, toru kodeka i sterowników, a nie od samej pojemności RAM.",
    rsgRamFactor4Title: "Gry i wielozadaniowość",
    rsgRamFactor4Body:
      "Gry uruchamiane na dekoderze, bardziej złożona grafika i częste przełączanie aplikacji wymagają więcej pamięci i wyraźnie korzystają z dodatkowego zapasu.",
    rsgConfigEyebrow: "Praktyczne porównanie",
    rsgConfigTitle: "1/8, 2/16 czy 4/32 GB?",
    rsgConfigIntro:
      "To konfiguracje przeznaczone do różnych zastosowań, a nie uniwersalne poziomy wydajności. Ostateczną decyzję podejmij po przetestowaniu egzemplarza z docelowym oprogramowaniem, aplikacjami, materiałami wideo i urządzeniami peryferyjnymi.",
    rsgConfigCommon: "Najbardziej uniwersalna",
    rsgConfigFitsLabel: "Sprawdzi się w",
    rsgConfigWatchLabel: "Na co uważać",
    rsgConfigModelsLabel: "Pasujące modele inext",
    rsgConfig1Label: "Do konkretnego zadania",
    rsgConfig1Summary:
      "Ekonomiczna konfiguracja, gdy inext lub operator kontroluje całe oprogramowanie urządzenia i świadomie ogranicza zakres jego zadań.",
    rsgConfig1Fit1: "Jedna główna aplikacja telewizyjna lub multimedialna",
    rsgConfig1Fit2: "Lekki ekran główny z ograniczoną liczbą usług w tle",
    rsgConfig1Fit3: "Duże floty, w których liczy się koszt każdego urządzenia",
    rsgConfig1Watch:
      "Nie jest to bezpieczny wybór dla stale rosnącego katalogu aplikacji, wymagających gier uruchamianych na dekoderze ani oprogramowania, którego nie sprawdzono na docelowym urządzeniu.",
    rsgConfig2Label: "Uniwersalny wybór",
    rsgConfig2Summary:
      "Dobrze wyważony punkt wyjścia dla wdrożeń z kilkoma aplikacjami, bardziej rozbudowanym interfejsem i zapasem na przyszłe zmiany oprogramowania.",
    rsgConfig2Fit1: "Usługi IPTV i OTT z wieloma aplikacjami",
    rsgConfig2Fit2: "Hotele, portale pod własną marką i proste gry",
    rsgConfig2Fit3: "Projekty, których wymagania mogą umiarkowanie rosnąć",
    rsgConfig2Watch:
      "Nadal trzeba sprawdzić wzrost danych, przełączanie aplikacji i stabilność długotrwałej pracy. 2 GB nie zastępują dobrze utrzymanego oprogramowania systemowego.",
    rsgConfig3Label: "Największy zapas",
    rsgConfig3Summary:
      "Najmocniejsza opcja dla rozbudowanych zestawów aplikacji, wymagających zadań wykonywanych na urządzeniu i projektów, w których elastyczność jest ważniejsza niż najniższy koszt sprzętu.",
    rsgConfig3Fit1: "Większe biblioteki aplikacji i bogatsze interfejsy",
    rsgConfig3Fit2: "Bardziej wymagające gry uruchamiane na urządzeniu i aplikacje interaktywne",
    rsgConfig3Fit3: "Dłuższe plany rozwoju z mniej przewidywalnymi wymaganiami",
    rsgConfig3Watch:
      "Nie warto płacić za pamięć, której urządzenie nie wykorzysta. Sprawdź, czy procesor, GPU, szybkość pamięci wewnętrznej i oprogramowanie pozwolą rzeczywiście skorzystać z dodatkowej pojemności.",
    rsgConfigNote:
      "Nazwy konfiguracji opisują nominalną pojemność RAM i pamięci flash. Dostępny RAM i użyteczna pamięć wewnętrzna są mniejsze po uwzględnieniu rezerw sprzętowych, partycji systemowych i fabrycznie zainstalowanego oprogramowania.",
    rsgStorageEyebrow: "Pamięć wymaga planu",
    rsgStorageTitle: "Pojemność nominalna to nie to samo co wolne miejsce",
    rsgStorageIntro:
      "W urządzeniu z 8 GB, 16 GB lub 32 GB część pamięci zajmują partycje i docelowe oprogramowanie systemowe. Sprawdź ilość wolnego miejsca na egzemplarzu odpowiadającym wersji produkcyjnej, a następnie oszacuj jej zmianę w całym okresie eksploatacji.",
    rsgStorage1Title: "Oprogramowanie systemowe i partycje",
    rsgStorage1Body:
      "System operacyjny, środowisko odzyskiwania, dane producenta i partycje zarezerwowane zajmują część pamięci jeszcze przed instalacją aplikacji.",
    rsgStorage2Title: "Strategia aktualizacji",
    rsgStorage2Body:
      "Pakiety odzyskiwania, etapowe pobieranie i aktualizacje w układzie A/B mogą wymagać miejsca zarezerwowanego czasowo lub na stałe.",
    rsgStorage3Title: "Aplikacje, dane i pamięć podręczna",
    rsgStorage3Body:
      "Pliki aplikacji to dopiero początek. Dane EPG, grafiki, dzienniki, dane internetowe i pamięć podręczna rosną podczas zwykłego użytkowania.",
    rsgStorage4Title: "Szybkość i trwałość zapisu",
    rsgStorage4Body:
      "Szybka, niezawodna pamięć eMMC i prawidłowo utrzymany system plików mogą być ważniejsze niż duża ilość wolnego miejsca w wolniejszym lub źle zarządzanym urządzeniu.",
    rsgStorageNote:
      "Określ minimalny próg wolnego miejsca po przygotowaniu urządzenia i po reprezentatywnym cyklu aktualizacji. Sama nominalna pojemność nie potwierdza, że kolejne wydanie systemu lub aplikacji zainstaluje się bezpiecznie.",
    rsgOptimizeEyebrow: "Dlaczego oprogramowanie zmienia odpowiedź",
    rsgOptimizeTitle: "Optymalizacja uwalnia zasoby dla usługi",
    rsgOptimizeIntro:
      "Oprogramowanie dekodera nie powinno być ogólną wersją Androida przeniesioną bez zmian na wybraną płytę. Pakiet BSP, sterowniki, usługi, ekran główny i sposób działania aplikacji trzeba wspólnie dostroić do konkretnego SoC i przeznaczenia produktu.",
    rsgOptimize1Title: "Wyłącz zbędne procesy",
    rsgOptimize1Body:
      "Każda niepotrzebna usługa zużywa RAM, pamięć wewnętrzną, czas procesora i wydłuża uruchamianie. Ściśle kontrolowane oprogramowanie może pozostać celowo lekkie.",
    rsgOptimize2Title: "Dostrój oprogramowanie obsługujące sprzęt",
    rsgOptimize2Body:
      "Ustawienia jądra, sterowniki, przydział pamięci i sprzętowa obsługa wideo decydują o efektywności wykorzystania zasobów platformy.",
    rsgOptimize3Title: "Kontroluj działanie aplikacji",
    rsgOptimize3Body:
      "Sposób działania ekranu głównego, ograniczenia procesów w tle, zasady pamięci podręcznej i mechanizmy przywracania pomagają zachować płynność podczas długich sesji.",
    rsgOptimize4Title: "Sprawdzaj każde wydanie produkcyjne",
    rsgOptimize4Body:
      "Optymalizację utrzymuje się przez testy regresji, etapowe dostarczanie aktualizacji OTA i monitorowanie urządzeń. Nie kończy się ona w dniu premiery.",
    rsgOptimizeProofTitle: "Konkretny przykład: inext TV5",
    rsgOptimizeProofBody:
      "TV5 łączy 1 GB RAM i 8 GB eMMC z Androidem 10 AOSP, sprzętowo przyspieszanym odtwarzaniem 4K oraz Alcatraz DMS. Może sprawnie pełnić ściśle określoną funkcję dzięki wieloletniej optymalizacji oprogramowania platformy H313, a nie dzięki pomijaniu ograniczeń pamięci.",
    rsgOptimizeProofCta: "Zobacz dane techniczne TV5",
    rsgGamingEyebrow: "Gry zmieniają wymagania",
    rsgGamingTitle: "Najpierw ustal rodzaj uruchamianych gier",
    rsgGamingIntro:
      "Określenie „obsługuje gry” może oznaczać bardzo różne możliwości. Prosta łamigłówka, gra konsolowa przesyłana z chmury i gra 3D uruchamiana bezpośrednio na urządzeniu stawiają dekoderowi inne wymagania.",
    rsgGamingImageAlt:
      "Osoba używa aplikacji inext Remote w trybie kontrolera, podczas gdy na telewizorze działa gra wyścigowa",
    rsgGame1Title: "Proste i lekkie gry",
    rsgGame1Body:
      "Proste gry na Androida mogą działać przy umiarkowanej ilości pamięci, jeśli całe oprogramowanie systemowe jest kontrolowane, a każdy tytuł został sprawdzony na docelowym urządzeniu.",
    rsgGame1Emphasis: "Często wystarcza 1–2 GB; testuj każdy tytuł",
    rsgGame2Title: "Gry w chmurze",
    rsgGame2Body:
      "Gra jest renderowana w chmurze. Jakość po stronie użytkownika zależy od sieci o małym opóźnieniu, sprzętowego dekodowania wideo, obsługi kontrolera przez Bluetooth lub USB oraz płynnego wyświetlania klatek.",
    rsgGame2Emphasis: "Najważniejsze są opóźnienia sieci, dekodera i kontrolera",
    rsgGame3Title: "Wymagające gry uruchamiane na urządzeniu",
    rsgGame3Body:
      "Większe tekstury, silniki gier i zasoby działające w tle korzystają z 4 GB RAM i większej pamięci wewnętrznej. Nadal jednak decydują możliwości GPU i zdolność urządzenia do utrzymania wydajności bez przegrzewania.",
    rsgGame3Emphasis: "Wybierz 4/32 po sprawdzeniu GPU i temperatur",
    rsgGamingNote:
      "Cztery gigabajty RAM nie zmienią słabego SoC w konsolę do gier. RAM, GPU, procesor, szybkość pamięci wewnętrznej, chłodzenie i obsługę kontrolera trzeba określić jako jeden wymóg dotyczący gier.",
    rsgTestEyebrow: "Sprawdź przed zakupem",
    rsgTestTitle: "Testuj rzeczywisty sposób użycia, nie tylko wynik testu syntetycznego",
    rsgTestIntro:
      "Egzemplarz testowy dostawcy powinien mieć docelowe oprogramowanie i odtwarzać materiały przewidziane dla usługi. Na każdym porównywanym urządzeniu powtórz tę samą procedurę odbiorczą, aby wynik odzwierciedlał usługę, którą otrzymają abonenci.",
    rsgTest1: "Zmierz czas zimnego startu oraz czas od wybudzenia do wyświetlenia obrazu",
    rsgTest2: "Uruchom główną aplikację i przechodź między kluczowymi ekranami",
    rsgTest3: "Odtwórz reprezentatywne treści 4K, HDR i chronione",
    rsgTest4: "Wielokrotnie przełączaj się między wszystkimi wymaganymi aplikacjami",
    rsgTest5:
      "Odtwarzaj telewizję na żywo, usługę OTT lub inne docelowe materiały przez 24–72 godziny",
    rsgTest6:
      "Sprawdź proste gry, gry w chmurze lub gry uruchamiane na urządzeniu z docelowym kontrolerem",
    rsgTest7:
      "Zainstaluj aktualizację OTA przy realistycznej ilości wolnego miejsca i sprawdź możliwość przywrócenia systemu",
    rsgTest8:
      "Zapisz dostępny RAM i pamięć wewnętrzną po przygotowaniu, użytkowaniu i aktualizacjach",
    rsgTestNoteTitle: "Zadbaj o powtarzalność testu",
    rsgTestNoteBody:
      "Kryteria zaliczenia i odrzucenia spisz przed otrzymaniem urządzeń testowych. Starannie przygotowana prezentacja nie zastępuje uzgodnionej procedury odbiorczej.",
    rsgTestNoteCta: "Otwórz listę kontrolną wyboru dekodera",
    rsgDecisionEyebrow: "Jak podjąć decyzję",
    rsgDecisionTitle: "Kup najmniejszą konfigurację, która spełnia rzeczywiste wymagania z zapasem",
    rsgDecision1Title: "Określ docelowe oprogramowanie",
    rsgDecision1Body:
      "Wymień system operacyjny, ekran główny, aplikacje, usługi, DRM, DMS i sposób aktualizacji, które trafią do urządzenia, a nie tylko ogólną nazwę platformy.",
    rsgDecision2Title: "Oddziel odtwarzanie wideo od pracy aplikacji",
    rsgDecision2Body:
      "Potwierdź obsługę kodeków i rozdzielczości przez dekoder sprzętowy, a następnie oceń CPU, GPU i RAM pod kątem działania interfejsu i aplikacji.",
    rsgDecision3Title: "Zaplanuj wykorzystanie pamięci na lata",
    rsgDecision3Body:
      "Uwzględnij dostępne miejsce, pamięć podręczną, dzienniki, wzrost aplikacji, odzyskiwanie oraz co najmniej jeden realistyczny cykl aktualizacji.",
    rsgDecision4Title: "Dobierz zapas do okresu eksploatacji",
    rsgDecision4Body:
      "Porównaj koszt dodatkowej pamięci z prawdopodobieństwem pojawienia się nowych aplikacji, dłuższego wsparcia lub rozszerzenia funkcji w okresie eksploatacji floty.",
    rsgDecisionConclusion:
      "Właściwy dekoder nie jest tym z największą ilością pamięci. To urządzenie, które niezawodnie realizuje udokumentowane zadania, mieści się w budżecie całej floty i ma wystarczający zapas na planowany okres eksploatacji.",
    rsgFaqEyebrow: "Najczęstsze pytania",
    rsgFaqTitle: "Odpowiedzi na pytania o RAM i pamięć wewnętrzną",
    rsgFaqQ1: "Czy 1 GB RAM wystarcza w nowoczesnym dekoderze?",
    rsgFaqA1:
      "Może wystarczyć. Jeden gigabajt to odpowiednia konfiguracja dla ściśle określonego zastosowania, zoptymalizowanego oprogramowania systemowego, lekkiego ekranu głównego i ograniczonego zestawu aplikacji. Nie jest bezpiecznym wyborem dla nieznanego scenariusza użycia, rozbudowanego ekosystemu aplikacji ani wymagających gier uruchamianych na urządzeniu. Przed decyzją przetestuj docelowe oprogramowanie.",
    rsgFaqQ2: "Czy 2 GB RAM to minimum dla Android TV?",
    rsgFaqA2:
      "Nie istnieje uniwersalna zasada 2 GB pasująca do każdego urządzenia telewizyjnego. Publiczne wymagania zgodności z Androidem zależą od wersji systemu, architektury, konfiguracji wyświetlacza i pamięci zarezerwowanej przez sprzęt. Minimalne wymagania zgodności nie określają też, jak sprawnie będzie działać konkretny zestaw aplikacji. Nadal rozstrzygają testy produkcyjne.",
    rsgFaqQ3: "Czy więcej RAM poprawia jakość obrazu 4K?",
    rsgFaqA3:
      "Nie samo w sobie. Wideo H.264, H.265 lub VP9 jest zwykle dekodowane przez wyspecjalizowany sprzęt. Płynne odtwarzanie 4K zależy od SoC, dekodera, sterowników, toru wyjściowego i zgodności strumienia. RAM ma większe znaczenie dla ekranu startowego, aplikacji, strategii buforowania i wielozadaniowości wokół odtwarzania.",
    rsgFaqQ4: "Jaka część podanej pojemności pamięci wewnętrznej jest dostępna?",
    rsgFaqA4:
      "Zależy to od oprogramowania systemowego i układu partycji. System operacyjny, środowisko odzyskiwania, dane zarezerwowane i fabrycznie zainstalowane aplikacje zmniejszają dostępne miejsce. Poproś o informację o wolnym miejscu na egzemplarzu odpowiadającym wersji produkcyjnej po jego skonfigurowaniu, zamiast opierać się wyłącznie na nominalnej pojemności pamięci flash.",
    rsgFaqQ5: "Ile RAM potrzebuje dekoder do gier?",
    rsgFaqA5:
      "Lekkie gry mogą dobrze działać przy 1–2 GB, a wymagające tytuły uruchamiane na urządzeniu korzystają z 4 GB RAM i większej pamięci wewnętrznej. Gry w chmurze bardziej zależą od opóźnienia sieci, dekodowania sprzętowego i reakcji kontrolera. W każdym przypadku obok RAM liczą się możliwości GPU i odprowadzanie ciepła.",
    rsgFaqQ6: "Czy operator powinien kupić dodatkową pamięć na przyszłość?",
    rsgFaqA6:
      "Tylko wtedy, gdy wynika to z realnego planu rozwoju. Dodatkowy zapas ma sens, gdy spodziewane są kolejne aplikacje, bardziej rozbudowany interfejs lub dłuższy okres eksploatacji. Koszt niewykorzystanej pamięci w każdym urządzeniu dużej floty może przewyższyć oszczędności wynikające z wyboru sprawdzonej, niższej konfiguracji i świadomego ograniczenia zakresu produktu.",
    rsgCtaEyebrow: "Wybieraj na podstawie testów",
    rsgCtaTitle: "Opisz zastosowanie. Pomożemy dobrać dekoder.",
    rsgCtaBody:
      "Przekaż informacje o aplikacjach, materiałach wideo, integracjach, wymaganiach dotyczących gier i oczekiwanym okresie eksploatacji. Zespół inext może polecić konfigurację i przygotować egzemplarz testowy z docelowym oprogramowaniem.",
    rsgCtaPrimary: "Omów wymagania",
    rsgCtaSecondary: "Porównaj wszystkie modele",
    footerLinkBrand: "Materiały marki",
    brandSeoTitle: "Materiały marki i zasady użycia logo inext",
    brandSeoDescription:
      "Pobierz oficjalne logo i ikony inext oraz sprawdź zatwierdzone kolory, typografię, zasady i uprawnienia dla prasy i marketingu partnerskiego.",
    brandEyebrow: "Marka inext",
    brandHeading: "Materiały marki gotowe do użycia",
    brandIntro:
      "Pobierz zatwierdzone pliki logo inext i poznaj podstawowe zasady dotyczące kolorów, typografii, zapisu nazwy oraz prawidłowego użycia przez strony trzecie.",
    brandDownloadPack: "Pobierz pakiet materiałów",
    brandDownloadGuide: "Pobierz przewodnik PDF",
    brandDownloadNote:
      "Bezpłatnie dla prasy, publikacji redakcyjnych i rzetelnego marketingu partnerskiego.",
    brandLogoAlt: "Logo inext",
    brandLogoEyebrow: "System logo",
    brandLogoTitle: "Wybierz wersję odpowiednią do tła",
    brandLogoDescription:
      "Pełnego logo należy używać wszędzie tam, gdzie pozwala na to miejsce. Kompaktowa ikona jest przeznaczona do kwadratowych lub małych formatów. Pliki są dostępne jako skalowalny SVG i przezroczysty PNG.",
    brandPrimary: "Podstawowe · białe tło",
    brandOnDark: "Na czarne tło",
    brandOnBlue: "Na niebieskie tło inext",
    brandFullLogo: "Pełne logo",
    brandIcon: "Ikona",
    brandColorsEyebrow: "Kolory",
    brandColorsTitle: "Skupiona paleta trzech kolorów",
    brandColorsDescription:
      "To zatwierdzone kolory logo inext. Należy używać dokładnych wartości poniżej i gotowych plików zamiast samodzielnie zmieniać kolory.",
    brandColorBlue: "Niebieski inext",
    brandColorWhite: "Biały",
    brandColorBlack: "Czarny",
    brandTypographyEyebrow: "Typografia i nazwa",
    brandTypographyTitle: "Zachowaj czytelną i spójną typografię",
    brandTypographyDescription:
      "W komunikacji marki inext należy w miarę możliwości używać kroju Roboto. Wagi pisma powinny zapewniać wyraźną hierarchię i wygodną czytelność.",
    brandTypographyLink: "Pobierz Roboto z Google Fonts",
    brandNameTitle: "Zapis nazwy marki",
    brandNameDescription:
      "W tekście ciągłym nazwę marki należy zapisywać małymi literami: „inext”. Gdy potrzebny jest znak szewronu, użyj zatwierdzonego pliku logo; nie zastępuj znaku logo tekstowym znakiem „›”.",
    brandUsageEyebrow: "Prawidłowe użycie",
    brandUsageTitle: "Chroń kształt, kontrast i znaczenie",
    brandUsageDescription:
      "Spójne stosowanie wzmacnia rozpoznawalność marki w publikacjach, materiałach produktowych i kampaniach partnerskich.",
    brandDoTitle: "Tak",
    brandDoOfficialAssets: "Korzystaj z oficjalnych plików dostępnych na tej stronie.",
    brandDoContrast: "Wybieraj zatwierdzoną wersję z wyraźnym kontrastem względem tła.",
    brandDoProportions: "Zachowuj proporcje logo i odpowiednią wolną przestrzeń wokół niego.",
    brandDoAccurateRelationship: "Rzetelnie opisuj relację z inext w materiałach partnerskich.",
    brandDontTitle: "Nie",
    brandDontRecolor: "Nie twórz nowych kolorów ani nie łącz elementów z różnych wersji.",
    brandDontDistort:
      "Nie rozciągaj, nie ściskaj, nie obracaj, nie przycinaj ani nie pochylaj grafiki.",
    brandDontEffects: "Nie dodawaj obrysów, cieni, gradientów ani innych efektów.",
    brandDontRearrange: "Nie zmieniaj układu ikony i logotypu ani nie zastępuj go tekstem.",
    brandPermissionsEyebrow: "Uprawnienia",
    brandPermissionsTitle: "Otwarte materiały, rzetelna prezentacja",
    brandPermissionsDescription:
      "Pliki logo są bezpłatnie dostępne do zgodnych z prawem publikacji i współpracy. Formularz ani wiadomość e-mail nie są wymagane.",
    brandPermissionPress:
      "Prasa i redakcje mogą używać materiałów w publikacjach dotyczących inext.",
    brandPermissionPartners:
      "Partnerzy mogą używać ich w marketingu odzwierciedlającym rzeczywistą współpracę.",
    brandPermissionAccuracy:
      "Użycie nie może sugerować nieistniejącego poparcia, certyfikacji ani partnerstwa.",
    brandContactCta: "Zapytaj o szczególne użycie",
  },
  pt: {
    navProducts: "Produtos",
    navCustomization: "Personalização",
    navAbout: "Sobre",
    navBlog: "Blog",
    navFaq: "FAQ",
    navContact: "Contato",
    navSearch: "Buscar",
    announcementLabel: "Novidade",
    contactSales: "Falar com vendas",
    toggleMenu: "Abrir/fechar menu",
    language: "Idioma",
    breadcrumbLabel: "Trilha de navegação",
    heroEyebrow: "Hardware de STB para operadoras · Desde 2011",
    heroTitle: "Set-top boxes Android TV",
    heroTitleAccent: "para operadoras de IPTV e OTT",
    heroDescription:
      "Quatro modelos Android TV prontos para implantação, personalizados para a marca e o software da operadora, com o Alcatraz DMS para gerenciar a frota.",
    heroModelsCta: "Comparar modelos de STB",
    heroQuoteCta: "Solicitar cotação",
    exploreProducts: "Conheça os produtos",
    bookDemo: "Agendar demonstração",
    trustedBy: "Mais de 250 operadoras e provedores de TV em 15 países confiam na inext",
    operationsStatPill: "Impulsionando mais de 120 redes de operadoras pelo mundo",
    stackEyebrow: "A stack da inext",
    stackTitle: "Hardware, personalização e",
    stackTitleAccent: "operação",
    stackTitleEnd: "— em um só lugar",
    stackDescription:
      "Três pilares que cobrem tudo o que uma operadora precisa para lançar e operar um serviço moderno de IPTV / OTT.",
    hardwareEyebrow: "Hardware · Nossa STB topo de linha",
    hardwareTitle: "Conheça o",
    hardwareDescription:
      "Uma TV box Android 12 (AOSP) compacta e potente, feita para provedores de internet e TV. Equipada com o Allwinner H618, 4GB DDR3 e 32GB eMMC, entrega reprodução 4K UHD fluida a 60fps via HDMI 2.0a, conecta-se por Wi-Fi AC dual-band, Bluetooth 5.0 ou Ethernet 100Mb e já vem com controle remoto, cabo HDMI e fonte de alimentação inclusos.",
    viewTechSpecs: "Ver especificações técnicas",
    clientsEyebrow: "White-label e co-branding",
    clientsTitle: "Operadoras que já entregam",
    clientsTitleAccent: "STBs inext",
    clientsDescription:
      "Hardware, embalagem e UX reais entregues a provedores de internet e plataformas OTT de destaque — totalmente personalizados, de ponta a ponta.",
    clientsOutro: "De uma única unidade a uma implantação nacional — sua marca, nossa engenharia.",
    customizationEyebrow: "Personalização",
    customizationTitle: "Sua marca, de ponta a ponta",
    customizationDescription:
      "Da caixa na prateleira ao launcher na TV, cada camada da experiência inext pode ser adaptada à marca e ao conteúdo da sua operadora.",
    learnMore: "Saiba mais",
    lineupEyebrow: "Escolha o hardware",
    lineupTitle: "Quatro STBs. Uma plataforma para operadoras.",
    lineupDescription:
      "Comece pelas necessidades da implantação: hardware 4K essencial, mais memória e armazenamento ou o modelo topo de linha com 4 GB. Todos são feitos para controle da operadora e Alcatraz DMS.",
    lineupCompareAll: "Comparar todos os modelos",
    lineupFlagshipBadge: "Topo de linha",
    lineupTv5Tagline: "Android 4K essencial para implantações com orçamento enxuto.",
    lineupTv5UltraTagline: "Mais memória e armazenamento na plataforma já comprovada.",
    lineupTv6Tagline: "4K mais inteligente, com Bluetooth e Wi-Fi ac.",
    lineupTv6UltraTagline: "Potência e armazenamento máximos — o topo de linha.",
    homeCompanionEyebrow: "App complementar",
    homeCompanionCta: "Conheça o inext Remote",
    operationsEyebrow: "Operação · Alcatraz DMS + protocolos",
    operationsTitle: "Uma plataforma para gerenciar",
    operationsTitleAccent: "cada dispositivo",
    operationsDescription:
      "O Alcatraz DMS é o sistema de gerenciamento de dispositivos usado em cada implantação inext. Em um único console, as equipes podem detectar problemas na frota, consultar a atividade dos dispositivos, distribuir firmware e executar diagnósticos remotos.",
    ctaEyebrow: "Fale com a gente",
    ctaTitle: "Pronto para escolher o",
    ctaTitleAccent: "STB certo?",
    ctaDescription:
      "Conte sobre o serviço, o tamanho da frota e os requisitos técnicos. Recomendaremos a configuração de hardware e o caminho de implantação.",
    footerDescription:
      "Set-top boxes e software de gerenciamento de dispositivos para provedores de internet e TV desde 2011.",
    footerProducts: "Produtos",
    footerSolutions: "Soluções",
    footerCompany: "Empresa",
    footerRights: "Todos os direitos reservados.",
    homeTitle: "Set-top boxes Android TV para operadoras de IPTV e OTT | inext",
    homeDescription:
      "A inext fornece set-top boxes Android TV para provedores de internet e operadoras de TV, com personalização white-label, aplicativos IPTV, Alcatraz DMS e entrega B2B global.",
    portalEyebrow: "Além do aparelho",
    portalTitle: "Tudo de que uma operadora precisa em torno do STB.",
    portalDescription:
      "Transforme o hardware escolhido em um produto completo para o assinante com marca, aplicativos, operação da frota e entrega B2B coordenada.",
    portalResourcesEyebrow: "Central de conhecimento",
    portalResourcesTitle: "Planeje a implantação com guias práticos e ferramentas.",
    portalResourcesDescription:
      "Pesquise decisões de hardware, compare custos da frota e encontre respostas práticas em todo o portal inext.",
    heroQuickHardware: "Hardware",
    heroQuickCustomization: "Personalização",
    heroQuickOperations: "Operação",
    heroQuickLogistics: "Entrega mundial",
    heroDashboardTitle: "Alcatraz DMS · Visão geral da frota",
    heroMetricActiveDevices: "Dispositivos ativos",
    heroMetricOnline: "Online",
    heroMetricStreams: "Streams / min",
    heroFirmware: "Firmware",
    heroDeviceOnline: "Online",
    heroDeviceImageAlt: "Set-top box inext TV6 Ultra com controle remoto",
    heroSpecChipset: "Chipset",
    heroSpecMemory: "Memória",
    heroSpecVideo: "Vídeo",
    heroSpecOs: "Sistema",
    heroStackBadge: "Hardware + software, em uma só stack",
    productMenuFlagship: "Topo de linha",
    productMenuTv6UltraDesc: "Premium · 4 GB / 32 GB · controle remoto por voz",
    productMenuTv6Desc: "Desempenho · 2 GB / 16 GB · controle remoto IR",
    productMenuTv5UltraDesc: "Padrão · 2 GB / 16 GB · controle remoto IR",
    productMenuTv5Desc: "Essencial · 1 GB / 8 GB · controle remoto IR",
    navMenuProductsEyebrow: "Set-top boxes",
    navMenuSolutionsEyebrow: "Soluções e software",
    navMenuSolutionsGroupPlatform: "Plataforma e operações",
    navMenuSolutionsGroupApps: "Apps",
    navMenuSolutionsGroupServices: "Serviços",
    productMenuFeaturedTitle: "A STB 4K topo de linha",
    productMenuFeaturedDesc: "Android 12 · controle remoto por voz BT · Alcatraz DMS",
    productMenuFeaturedCta: "Conheça o topo de linha",
    pillarHardwareEyebrow: "Hardware",
    pillarHardwareTitle: "Set-top boxes Android TV",
    pillarHardwareDescription:
      "STBs 4K compactas e potentes, desenvolvidas para provedores de internet e TV. Nosso topo de linha — o inext TV6 Ultra — lidera a linha.",
    pillarHardwareCta: "Conheça a linha",
    pillarCustomizationEyebrow: "Personalização",
    pillarCustomizationTitle: "Sua marca, em cada tela",
    pillarCustomizationDescription:
      "Hardware white-label, co-branding, apps de IPTV personalizados, launcher da operadora e um app complementar de controle remoto — tudo construído em torno da sua identidade.",
    pillarCustomizationCta: "Conheça a personalização",
    pillarOperationsEyebrow: "Operação",
    pillarOperationsTitle: "Opere sua frota em escala",
    pillarOperationsDescription:
      "Fleet Health, histórico de atividade dos dispositivos, atualizações OTA em etapas, diagnósticos remotos e TR-069 em um único console Alcatraz DMS para toda a rede.",
    pillarOperationsCta: "Por dentro do Alcatraz DMS",
    hardwareSpecChipset: "Allwinner H618 · Quad-Core A53",
    hardwareSpecMemory: "4 GB DDR3 · 32 GB eMMC · Mali-G31 MP2",
    hardwareSpecVideo: "4K UHD H.265 60 fps · VP9 · H.264",
    hardwareSpecWireless: "Wi-Fi AC banda dupla · BT 5.0 · LAN 100 Mb",
    hardwareSpecPorts: "HDMI 2.0a · saída A/V · 2×USB 2.0 · microSD/TF",
    hardwareSpecSoftware: "Android 12 (AOSP) · Alcatraz™ DMS · TR-069",
    hardwareImageAlt: "Set-top box inext TV6 Ultra com controle remoto e embalagem",
    hardwareStatUltraHd: "Ultra HD",
    hardwareStat60Fps: "60 fps",
    hardwareStatAndroid: "Android",
    clientTagFullPackage: "Pacote completo",
    clientTagCoBranding: "Co-branding",
    clientTagRetailKit: "Kit de varejo",
    clientTagCustomApp: "App personalizado",
    clientTagWhiteLabel: "White-label",
    clientImageAltSuffix: "STB da inext",
    clientNoteBeeline: "STB, controle remoto e caixa de varejo personalizados",
    clientNoteOkTv: "Dispositivo e embalagem de varejo com a marca da operadora",
    clientNoteKyivstar: "Dispositivo, controle remoto e caixa de varejo personalizados",
    clientNoteAlmaTv: "Box de IPTV — conjunto de embalagem + controle remoto",
    clientNoteSarkor: "Interface da operadora, embalagem e acessórios",
    clientNoteSweetTv: "Box 2 UltraHD — pacote de varejo completo",
    clientNoteMegogo: "Edição preta com controle remoto personalizado",
    clientNoteMetroTv: "STB com a marca da operadora e caixa de varejo",
    customServiceWhiteLabelingTitle: "White-labeling",
    customServiceWhiteLabelingDescription:
      "Entregue hardware e apps com a sua própria marca — embalagem, firmware e interface totalmente personalizados de acordo com a sua identidade.",
    customServiceCoBrandingTitle: "Co-branding",
    customServiceCoBrandingDescription:
      "Una a sua marca à plataforma inext por meio de experiências co-branded flexíveis e kits de varejo.",
    customServiceIptvAppTitle: "App de IPTV personalizado",
    customServiceIptvAppDescription:
      "Player de IPTV/OTT sob medida, com EPG, catch-up, time-shift e VOD — adaptado ao seu catálogo de conteúdo.",
    customServiceLauncherTitle: "Launcher da operadora",
    customServiceLauncherDescription:
      "Um launcher Android TV personalizado, com seções configuradas, telas iniciais sob medida e experiências controladas.",
    customServiceRemoteAppTitle: "App de controle remoto para celular",
    customServiceRemoteAppDescription:
      "Transforme qualquer smartphone em um controle remoto poderoso — pareamento Bluetooth, busca por voz, entrada por teclado e gestos.",
    customServiceAppDesignTitle: "Design de app personalizado",
    customServiceAppDesignDescription:
      "Trabalho completo de UI/UX para launcher, EPG e player — projetado em torno dos seus assinantes e do seu conteúdo.",
    operationsImageAlt:
      "Painel do Alcatraz DMS — visão geral da frota em tempo real com dispositivos online, modelos e distribuição de firmware",
    operationsFeatureTelemetry: "Alertas Fleet Health e fila de problemas",
    operationsFeatureOta: "Atualizações OTA de firmware em etapas",
    operationsFeatureTr069: "Suporte a TR-069 / CWMP",
    operationsFeaturePush: "Notificações push segmentadas",
    operationsFeatureIperf: "Diagnósticos MTR e iPerf3",
    operationsFeatureAccess: "Chaves de API com permissões limitadas e acesso por perfil",
    operationsFeatureDiagnostics: "Atividade dos dispositivos e histórico de problemas",
    operationsLiveBadge: "Ao vivo",
    operationsCalloutOnline: "6.236 dispositivos online",
    operationsCalloutActive: "62% ativos este mês",
    operationsCalloutFirmware: "2 novos firmwares para testar",
    operationsMetric1Value: "120+",
    operationsMetric1Label: "redes de operadoras",
    operationsMetric3Value: "24/7",
    operationsMetric3Label: "monitoramento da frota",
    footerLinkTv6Ultra: "inext TV6 Ultra",
    footerLinkTv6: "inext TV6",
    footerLinkTv5Ultra: "inext TV5 Ultra",
    footerLinkTv5: "inext TV5",
    footerLinkAbout: "Sobre",
    footerLinkBlog: "Blog",
    footerLinkNewsletter: "Newsletter",
    footerLinkFaq: "FAQ",
    footerLinkContact: "Contato",
    footerLinkDistributors: "Distribuidores",
    footerLinkPrivacy: "Política de Privacidade",
    footerLinkRepublishing: "Republicação",
    footerLinkServiceStatus: "Status do serviço",
    aboutTitle: "Sobre a inext",
    aboutDescription:
      "Conheça a inext, um time internacional de engenharia fundado em Kyiv que desenvolve set-top boxes prontos para operadoras, software de TV e ferramentas de gerenciamento de dispositivos.",
    aboutEyebrow: "Empresa internacional de tecnologia para TV",
    aboutHeading: "Desenvolvemos soluções de TV que funcionam em redes reais.",
    aboutIntro:
      "A inext é um time internacional que projeta set-top boxes, software de TV e ferramentas de gerenciamento de frota para provedores de internet e plataformas OTT. Acompanhamos o produto desde a especificação inicial até a implantação e a operação de longo prazo.",
    aboutStat1Value: "15",
    aboutStat1Label: "países com implantações em operadoras",
    aboutStat3Value: "250+",
    aboutStat3Label: "clientes e parceiros B2B",
    aboutStat4Value: "17",
    aboutStat4Label: "modelos de STB desenvolvidos desde 2011",
    aboutStat5Value: "700K+",
    aboutStat5Label: "dispositivos entregues no mundo todo",
    aboutWorldwideDeliveryTitle: "Entrega mundial na prática",
    aboutWorldwideDeliveryBody:
      "A inext tem experiência prática em projetos internacionais, de lançamentos em um único mercado a implantações de operadoras em vários países. Podemos entregar set-top boxes, embalagem personalizada, firmware e suporte de implantação diretamente ou por meio de trabalho coordenado com distribuidores.",
    aboutBrandResourcesPrompt: "Procurando o logo ou os materiais oficiais da marca?",
    aboutBrandResourcesCta: "Acessar materiais da marca",
    aboutCapabilitiesEyebrow: "O que desenvolvemos",
    aboutCapabilitiesTitle: "Um único time para a experiência completa do assinante.",
    aboutCapabilitiesLede:
      "Hardware, software e operação de frota são desenvolvidos em conjunto, oferecendo às operadoras um caminho prático da especificação do produto até uma implantação com suporte.",
    aboutCapabilityHardwareTitle: "Hardware de TV pronto para operadoras",
    aboutCapabilityHardwareBody:
      "Set-top boxes Android AOSP comprovados e configurados para serviços de IPTV e OTT, de modelos de entrada acessíveis à nossa plataforma topo de linha.",
    aboutCapabilityHardwareCta: "Conheça a linha",
    aboutCapabilitySoftwareTitle: "Firmware e software de TV",
    aboutCapabilitySoftwareBody:
      "Firmware personalizado, launchers, integração de aplicativos e desenvolvimento de TV sob medida, moldados de acordo com o serviço e a identidade da operadora.",
    aboutCapabilitySoftwareCta: "Conheça a personalização",
    aboutCapabilityOperationsTitle: "Operação de frota",
    aboutCapabilityOperationsBody:
      "Provisionamento, atualizações de firmware em etapas, diagnóstico e controle remoto pelo Alcatraz DMS e por protocolos de operadora já consolidados.",
    aboutCapabilityOperationsCta: "Conheça o Alcatraz DMS",
    aboutHeritageEyebrow: "Nossa história",
    aboutHeritageTitle: "Raízes em Kyiv. Visão internacional.",
    aboutStoryPara1:
      "Fundada em Kyiv em 2011, a inext começou desenvolvendo hardware de mídia doméstica durante a transição dos formatos físicos para o streaming. Desempenho de vídeo, estabilidade do dispositivo e confiabilidade de longo prazo foram essenciais desde o início.",
    aboutStoryPara2:
      "Hoje, somos um time internacional que atua a partir de vários países. À medida que IPTV e OTT se tornaram centrais nas redes das operadoras, nossa experiência evoluiu para uma plataforma mais ampla: set-top boxes, software de TV adaptável e gerenciamento de frota. O mercado mudou, mas nosso papel continua o mesmo: transformar requisitos técnicos complexos em produtos confiáveis para o dia a dia.",
    aboutPrinciplesEyebrow: "Como trabalhamos",
    aboutPrinciplesTitle: "Engenharia prática para implantações reais.",
    aboutPrinciplesLede:
      "Tomamos decisões considerando a realidade das redes das operadoras, o suporte ao assinante e produtos que precisam continuar úteis muito depois do lançamento.",
    aboutPrinciple1Title: "Pronto para implantação",
    aboutPrinciple1Body:
      "Comece com bases de hardware e software já comprovadas, em vez de reconstruir o básico a cada implantação.",
    aboutPrinciple2Title: "Adaptável onde importa",
    aboutPrinciple2Body:
      "Personalize marca, firmware, integrações e hardware quando o projeto tiver requisitos que um dispositivo padrão não consegue atender.",
    aboutPrinciple3Title: "Suporte ao longo de todo o ciclo de vida",
    aboutPrinciple3Body:
      "Gerencie firmware, diagnóstico e a operação dos dispositivos depois do lançamento, e não apenas durante a entrega do produto.",
    aboutCtaEyebrow: "Trabalhe com a inext",
    aboutCtaTitle: "Planejando uma implantação de TV com a sua marca?",
    aboutCtaBody:
      "Conte para a gente sobre sua rede, modelo de conteúdo e mercados. Vamos ajudar a definir o pacote certo de dispositivo e software.",
    aboutHeroEst: "Fundada em Kyiv · 2011",
    aboutHeroImageAlt: "Dispositivos inext 3D kid, HD1, TV, TV2e e 4K2",
    aboutClientsEyebrow: "A escolha das operadoras",
    aboutClientsLede:
      "Provedores de internet e plataformas OTT em 15 países já entregam STBs inext aos seus assinantes.",
    aboutClientsCta: "Ver todos os clientes e casos de sucesso",
    aboutClientImageAltSuffix: "implantação de STB inext",
    contactsTitle: "Fale com a inext",
    contactsDescription: "Fale com o contato de vendas da inext ideal para o seu mercado.",
    contactsEyebrow: "Contato",
    contactsHeading: "Vamos construir sua próxima experiência de TV",
    contactsIntro: "Conte para a gente sobre o seu projeto e nosso time entrará em contato.",
    contactFormTitle: "Enviar uma solicitação",
    contactFormIntro: "Compartilhe alguns detalhes para que possamos conectar você à pessoa certa.",
    contactNameLabel: "Nome",
    contactCompanyLabel: "Empresa",
    contactCompanyOptionalLabel: "Empresa (opcional)",
    contactCompanyRequired: "Informe o nome da empresa para este tipo de solicitação.",
    contactCountryLabel: "País",
    contactPhoneOptionalLabel: "Telefone (opcional)",
    contactInquiryTypeLabel: "Como podemos ajudar?",
    contactInquiryTypePlaceholder: "Selecione o tipo de solicitação",
    contactInquiryType_sales: "Solicitação de vendas",
    contactInquiryType_demo: "Agendar demonstração",
    contactInquiryType_integration: "Integração",
    contactInquiryType_brand: "Marca e imprensa",
    contactInquiryType_partnership: "Parceria",
    contactInquiryType_support: "Suporte ao dispositivo",
    contactInquiryType_other: "Outro",
    contactBrandResourcesNote:
      "Os arquivos oficiais do logo e as diretrizes de uso estão disponíveis para download imediato. Use este formulário apenas para dúvidas sobre usos especiais.",
    contactBrandResourcesCta: "Acessar materiais da marca",
    contactMessageLabel: "Mensagem",
    contactWebsiteHoneypotLabel: "Site",
    contactConsentPrefix: "Concordo com o tratamento das minhas informações conforme descrito na",
    contactPrivacyLink: "Política de Privacidade",
    contactConsentRequired: "Aceite a política de privacidade para continuar.",
    contactSubmit: "Enviar solicitação",
    contactSubmitting: "Enviando...",
    contactSuccessTitle: "Obrigado por entrar em contato",
    contactSuccessBody: "Sua solicitação foi enviada. Nosso time entrará em contato em breve.",
    contactFailureTitle: "Não foi possível enviar sua solicitação",
    contactFailureBody: "Tente novamente ou envie um e-mail diretamente para",
    contactRoutingLabel: "Encaminhamento global de vendas e distribuidores",
    findDistributorTitle: "Procurando um distribuidor local?",
    findDistributorBody: "Encontre o parceiro inext certo para o seu mercado.",
    viewDistributors: "Ver distribuidores",
    exclusiveDistributorTitle: "Distribuidor exclusivo na Ucrânia",
    globalDistributorListTitle: "Distribuidores",
    distributorListTitle: "Distribuidores na Polônia",
    otherRegionsDistributorTitle: "Outras regiões",
    directSalesOperationsTitle: "Vendas diretas e operações na UE",
    contactAddressLabel: "Endereço",
    contactPhoneLabel: "Telefone",
    contactEmailLabel: "E-mail",
    contactWebsiteLabel: "Site",
    distributorsTitle: "Distribuidores inext",
    distributorsDescription: "Encontre um distribuidor oficial inext para o seu mercado.",
    distributorsEyebrow: "Parceiros",
    distributorsHeading: "Encontre seu distribuidor local",
    distributorsIntro: "Conecte-se a um distribuidor oficial inext na sua região.",
    distributorRegionUkraine: "Ucrânia",
    distributorRegionPoland: "Polônia",
    distributorRegionSlovakia: "Eslováquia",
    distributorRegionMoldova: "Moldávia",
    distributorRegionEuOperations: "Operações na UE",
    distributorRegionGlobal: "Global",
    distributorContactCtaTitle: "Não sabe com quem falar?",
    distributorContactCtaBody:
      "Conte para a gente sobre o seu mercado e projeto. Vamos encaminhar sua solicitação ao distribuidor certo ou ao contato de vendas direto da inext.",
    distributorContactCtaButton: "Fale com a inext",
    privacyTitle: "Política de Privacidade",
    privacyDescription: "Como a inext trata as informações enviadas por meio deste site.",
    privacyEyebrow: "Jurídico",
    privacyHeading: "Política de Privacidade",
    republishingTitle: "Republicação e Licenciamento",
    republishingDescription:
      "A maioria dos artigos da inext está sob CC BY 4.0 — livres para republicar, traduzir e adaptar com atribuição. Veja como.",
    republishingEyebrow: "Licenciamento",
    republishingHeading: "Republicação do nosso conteúdo",
    blogLicenseLabel: "Licença",
    blogLicenseAllRightsReserved: "Todos os direitos reservados",
    blogLicenseReusableNote: "Você pode republicar este artigo livremente, com atribuição à inext.",
    blogLicenseReservedNote: "Entre em contato conosco antes de republicar.",
    blogLicenseGuidelines: "Diretrizes de republicação",
    republishKitToggle: "Republicar este artigo",
    republishKitIntro: "Licença CC BY 4.0 — credite a inext e inclua um link.",
    republishCopyLink: "Copiar link",
    republishCopyMarkdown: "Copiar como Markdown",
    republishCopyHtml: "Copiar como HTML",
    republishDownloadMarkdown: "Baixar .md",
    republishDownloadHtml: "Baixar .html",
    republishDownloadImages: "Baixar imagens (.zip)",
    republishDownloadingImages: "Preparando imagens…",
    republishDownloadAudio: "Baixar áudio",
    republishDownloadingAudio: "Preparando áudio…",
    republishCopied: "Copiado",
    republishContact: "Dúvidas ou precisa de um arquivo em resolução maior?",
    republishReservedNotice:
      "Este artigo é republicado de terceiros e não está disponível sob a licença CC BY 4.0.",
    republishCreditPrefix: "Publicado originalmente pela inext em ",
    republishCreditSuffix: " — republicado sob CC BY 4.0.",
    faqTitle: "FAQ da inext",
    faqDescription:
      "Respostas sobre as STBs inext, soluções de IPTV, personalização, Alcatraz™ DMS, firmware e solução de problemas.",
    faqEyebrow: "Suporte",
    faqHeading: "Perguntas frequentes",
    faqIntro:
      "Respostas rápidas sobre o hardware inext, soluções para operadoras (app de IPTV, marca, gerenciamento de frota), firmware e problemas comuns dos dispositivos.",
    faqCategoryAll: "Todas",
    faqCategoryDevices: "Dispositivos e configuração",
    faqCategoryFirmware: "Firmware",
    faqCategorySolutions: "Soluções e apps",
    faqCategoryManagement: "Alcatraz™ DMS",
    faqCategoryTroubleshooting: "Solução de problemas",
    faqQuestionCompare: "Qual set-top box inext devo escolher?",
    faqAnswerCompare:
      "O TV6 Ultra é o topo de linha para implantações 4K premium. O TV6 equilibra desempenho e custo. O TV5 Ultra é ideal para implantações de IPTV/OTT de grande volume; o TV5 é o modelo de entrada. Use nossa ferramenta de comparação lado a lado para alinhar memória, controles remotos e conectividade à sua rede.",
    faqQuestionIptvMiddleware: "Qual middleware de IPTV o app de IPTV da inext suporta?",
    faqAnswerIptvMiddleware:
      "O cliente IPTV pré-instalado da inext funciona com Stalker/Ministra, TVIP, Hibox, Aura e playlists M3U simples com EPG via XMLTV — em white-label e pré-configurado para o seu serviço antes do envio dos aparelhos.",
    faqQuestionWhiteLabel: "Qual é a diferença entre co-branding e white-label?",
    faqAnswerWhiteLabel:
      "O co-branding combina a sua marca com a da inext em hardware e interface compartilhados. Já o white-label remove a inext completamente do set-top box, do firmware e dos apps — os assinantes veem apenas a sua identidade.",
    faqQuestionRemoteApp: "O que é o app inext Remote?",
    faqAnswerRemoteApp:
      "O inext Remote é um app complementar gratuito para Android e iOS que controla os STBs da inext pelo celular — busca por teclado e por voz, troca de cômodo, modo gamepad e temas claro e escuro.",
    faqQuestionBuy: "Como comprar os produtos inext ou me tornar parceiro?",
    faqAnswerBuy:
      "A inext vende para operadoras e distribuidores no mundo todo. Encontre um parceiro autorizado perto de você ou fale com nosso time comercial para cotações de frota, personalização e onboarding do Alcatraz™ DMS.",
    faqQuestionAlcatrazDeploy: "O Alcatraz™ DMS pode rodar na nossa própria rede?",
    faqAnswerAlcatrazDeploy:
      "Sim. O Alcatraz roda como SaaS gerenciado em nuvem ou em instalação on-premises dentro de uma rede fechada do provedor — o mesmo console e os mesmos recursos, com a implantação escolhida conforme os seus requisitos de residência de dados.",
    faqQuestionAlcatrazIntegrate:
      "Podemos integrar o Alcatraz ao nosso BSS/OSS ou às ferramentas de suporte?",
    faqAnswerAlcatrazIntegrate:
      "Sim. O Alcatraz oferece uma API REST documentada e mensageria MQTT. Administradores podem criar e revogar chaves de API, restringir permissões e endereços IP de origem, definir datas de expiração e conectar dispositivos a referências de CRM ou billing por meio de IDs externos.",
    faqQuestionHdmi: "Qual padrão HDMI os dispositivos inext suportam?",
    faqAnswerHdmi:
      "Todos os STBs inext atuais têm saída HDMI 2.0a com suporte a CEC. Um cabo HDMI já vem incluído na caixa.",
    faqQuestionResolution: "Todos os dispositivos inext suportam 4K?",
    faqAnswerResolution:
      "Sim — TV5, TV5 Ultra, TV6 e TV6 Ultra suportam reprodução 4K UHD em até 60 FPS, com decodificação por hardware de H.265, VP9 e H.264.",
    faqQuestionAndroid: "Qual versão do Android os dispositivos inext usam?",
    faqAnswerAndroid:
      "TV6 Ultra e TV6 rodam Android 12 (AOSP). TV5 Ultra e TV5 rodam Android 10 (AOSP). Todos os modelos usam o AOSP puro, sem os Google Play Services pré-instalados.",
    faqQuestionRemote: "Que tipo de controle remoto vem incluído?",
    faqAnswerRemote:
      "O TV6 Ultra vem com um controle remoto de voz Bluetooth 5.0. O TV6 normalmente inclui um controle remoto IR com teclado numérico completo, embora em algumas regiões ele seja enviado com um controle Bluetooth. TV5 Ultra e TV5 incluem um controle remoto IR com teclado numérico completo.",
    faqQuestionFirmwares: "Onde encontro os firmwares oficiais?",
    faqAnswerFirmwares:
      "Todos os firmwares mais recentes para dispositivos inext estão disponíveis apenas por atualização OTA online. Você pode verificar as atualizações online no seu dispositivo em Configurações → Sobre → Atualização do sistema. Se tiver algum problema ao atualizar o dispositivo, entre em contato com a nossa central de atendimento.",
    faqQuestionFirmwareCheck: "Como verifico a versão atual do meu firmware?",
    faqAnswerFirmwareCheck:
      "No seu dispositivo, acesse Configurações → Sobre → Número da versão. A versão do firmware e a data da build são exibidas ali.",
    faqQuestionOtaFleet: "Como funcionam as atualizações de firmware OTA para operadores?",
    faqAnswerOtaFleet:
      "As atualizações de firmware OTA são uma solução para operadores integrada na plataforma Alcatraz. Faça o upload de uma versão, defina os grupos de dispositivos alvo e configure a percentagem de lançamento faseado — a plataforma encaminha os downloads pelo nó de armazenamento mais próximo e acompanha o estado de instalação em cada dispositivo. Pode pausar, expandir ou reverter em qualquer fase, e marcar atualizações críticas como obrigatórias para que os dispositivos não as possam ignorar.",
    faqQuestionAlcatraz: "O que é o Alcatraz™ DMS?",
    faqAnswerAlcatraz:
      "O Alcatraz™ DMS é a plataforma da inext para gerenciamento remoto de frota. As operadoras usam o Fleet Health para priorizar problemas, consultam a atividade dos dispositivos, distribuem firmware OTA, executam diagnósticos e gerenciam configurações em um único console. O Alcatraz Pro está incluído sem custo adicional para frotas com menos de 500 dispositivos ativos. Para frotas com 500 dispositivos ativos ou mais, o acesso e as condições comerciais são definidos diretamente com a inext.",
    faqQuestionAlcatrazModels: "Quais modelos incluem suporte ao Alcatraz™ DMS?",
    faqAnswerAlcatrazModels:
      "Todos os quatro modelos inext atuais — TV5, TV5 Ultra, TV6 e TV6 Ultra — já vêm com suporte ao Alcatraz™ DMS incluído.",
    faqQuestionTr069: "O TR-069 é suportado?",
    faqAnswerTr069:
      "Sim. Todos os modelos atuais são compatíveis com TR-069/CWMP e com o Alcatraz, então as operadoras que já têm um ACS podem continuar usando-o. O Alcatraz complementa essa estrutura com telemetria mais detalhada, notificações push, controle remoto pelo app e uma API REST moderna.",
    faqQuestionBlackScreen: "Meu dispositivo está com a tela preta, o que devo fazer?",
    faqAnswerBlackScreen:
      "Antes de tudo, tente uma reinicialização simples: tire o inext da tomada, espere 30 segundos e ligue novamente. Se isso não resolver, entre em contato com a nossa central de atendimento.",
    faqQuestionWifi: "Meu dispositivo não conecta ao Wi-Fi. O que devo fazer?",
    faqAnswerWifi:
      "Confira se você está dentro do alcance do roteador e se está digitando a senha correta. Se isso não resolver: (1) reinicie o dispositivo e o roteador, (2) esqueça a rede e conecte novamente, (3) confirme se o roteador transmite em uma banda compatível com o dispositivo (2,4 GHz ou 5 GHz). Se nenhuma dessas opções funcionar, entre em contato com a nossa central de atendimento.",
    faqQuestionBlocked: "Meu dispositivo diz que foi bloqueado. O que devo fazer?",
    faqAnswerBlocked:
      "Antes de tudo, tente entrar em contato com o seu provedor de internet (ISP). Se o provedor não conseguir ajudar, mande uma mensagem para nós usando o formulário de contato acima.",
    faqContactTitle: "Ainda tem alguma dúvida?",
    faqContactBody:
      "Nosso time de suporte e nossos parceiros de serviço podem ajudar com problemas de dispositivos, firmware, configuração do app IPTV, personalização, provisionamento e integração com o Alcatraz™ DMS.",
    faqContactCta: "Falar com o suporte",
    faqSearchPlaceholder: "Buscar perguntas...",
    faqSearchClear: "Limpar busca",
    faqNoResultsTitle: "Nenhum resultado encontrado",
    faqNoResultsWithQuery:
      'Nada corresponde a "{query}". Tente outras palavras-chave ou limpe a busca.',
    faqNoResultsCategory: "Ainda não há perguntas nesta categoria.",
    searchTitle: "Buscar na inext",
    searchDescription:
      "Pesquise no site da inext, nas páginas de produtos, nas páginas de suporte e nos artigos do blog.",
    searchEyebrow: "Busca",
    searchHeading: "Pesquise no site da inext",
    searchIntro:
      "Encontre detalhes de produtos, respostas do suporte, contatos de distribuidores, informações legais e artigos do blog em todo o site.",
    searchPlaceholder: "Buscar produtos, suporte, blog...",
    searchClear: "Limpar busca",
    searchLoading: "Carregando o índice de busca...",
    searchErrorTitle: "A busca está temporariamente indisponível",
    searchErrorBody:
      "Não foi possível carregar o índice de busca. Atualize a página ou tente novamente mais tarde.",
    searchNoQueryTitle: "Comece com uma palavra-chave",
    searchNoQueryBody:
      "Busque por nome de modelo, recurso, distribuidor, tópico de suporte ou palavra-chave de artigo.",
    searchNoResultsTitle: "Nenhum resultado encontrado",
    searchNoResultsBody:
      'Nada corresponde a "{query}". Tente uma frase mais curta ou outra palavra-chave.',
    searchResultsCount: '{count} resultados para "{query}"',
    searchTypePage: "Página",
    searchTypeProduct: "Produto",
    searchTypeBlog: "Blog",
    searchTypeSupport: "Suporte",
    searchTypeLegal: "Jurídico",
    searchTypeApp: "App",
    blogTitle: "insights inext",
    blogDescription:
      "Destaques de eventos, novidades de produtos e insights técnicos para operadoras de IPTV e OTT.",
    blogReadMore: "Ler artigo",
    blogEmpty: "Ainda não há artigos publicados para este mercado.",
    blogFeatured: "Destaque",
    blogFilterAll: "Todos",
    blogTagEvents: "Eventos",
    blogTagPartnerships: "Parcerias",
    blogTagProducts: "Produtos",
    blogTagSoftware: "Software",
    blogTagCompany: "Empresa",
    blogLoadMore: "Carregar mais",
    blogBackToTop: "Voltar ao topo",
    blogNewerPost: "Artigo mais recente",
    blogOlderPost: "Artigo anterior",
    blogMediaAudio: "Inclui áudio",
    blogMediaVideo: "Inclui vídeo",
    newsletterEyebrow: "Novidades da inext",
    newsletterTitle:
      "Lançamentos de produtos, atualizações de firmware e conteúdo prático para operadoras.",
    newsletterDescription:
      "Receba anúncios de produtos, novas versões de firmware, atualizações do Alcatraz DMS e conteúdo prático para operadoras de TV.",
    newsletterSeoTitle: "Newsletter da inext — produtos e atualizações de firmware",
    newsletterSeoDescription:
      "Assine para receber lançamentos de produtos da inext, novas versões de firmware, atualizações do Alcatraz DMS e conteúdo prático para operadoras de TV.",
    newsletterPageBenefitProducts: "Novos set-top boxes e acessórios",
    newsletterPageBenefitFirmware: "Novas versões de firmware e atualizações do Alcatraz DMS",
    newsletterPageBenefitInsights: "Conteúdo prático para operadoras de TV",
    newsletterPageFormTitle: "Assine a newsletter da inext",
    newsletterPageReassurance:
      "Só enviamos novidades relevantes. Cancele a inscrição quando quiser.",
    newsletterEmailLabel: "E-mail",
    newsletterEmailPlaceholder: "nome@empresa.com",
    newsletterSubmit: "Assinar",
    newsletterSubmitting: "Processando…",
    newsletterSuccessTitle: "Inscrição concluída",
    newsletterSuccessBody: "Agora você receberá novidades sobre produtos e atualizações da inext.",
    newsletterError: "Não foi possível fazer sua inscrição agora. Tente novamente.",
    newsletterPrivacyPrefix:
      "Ao assinar, você concorda em receber novidades sobre produtos e atualizações da inext. Consulte nossa",
    newsletterPrivacyLink: "política de privacidade",
    newsletterWebsiteLabel: "Deixe este campo em branco",
    newsEyebrow: "Sala de imprensa",
    newsTitle: "O que há de novo na",
    newsTitleAccent: "inext",
    newsDescription:
      "Lançamentos de produtos, parcerias e relatos de campo das implantações em operadoras.",
    newsViewAll: "Ver todos os artigos",
    notFoundTitle: "Página não encontrada",
    notFoundBody: "A página que você procura não existe ou foi movida.",
    goHome: "Ir para o início",
    errorTitle: "Esta página não carregou",
    errorBody:
      "Algo deu errado do nosso lado. Você pode tentar atualizar a página ou voltar para o início.",
    tryAgain: "Tentar novamente",
    compareAllModels: "Comparar todos os 4 modelos",
    compareTierFlagship: "Topo de linha",
    compareTierPerformance: "Desempenho",
    compareTierStandard: "Padrão",
    compareTierEssential: "Essencial",
    compareGroupPerformance: "Desempenho",
    compareGroupConnectivity: "Conectividade",
    compareGroupManagement: "Gerenciamento",
    compareGroupPhysical: "Físico",
    compareGroupInBox: "Na caixa",
    compareRowOs: "Sistema operacional",
    compareRowChipset: "Chipset",
    compareRowCpu: "CPU",
    compareRowGpu: "GPU",
    compareRowRam: "RAM",
    compareRowStorage: "Armazenamento",
    compareRowMaxRes: "Resolução máxima",
    compareRowCodecs: "Codecs de vídeo",
    compareRowHdmi: "HDMI",
    compareRowEthernet: "Ethernet",
    compareRowWifi: "Wi-Fi",
    compareRowBluetooth: "Bluetooth",
    compareRowUsb: "USB",
    compareRowCardReader: "Leitor de cartão",
    compareRowAvOutput: "Saída AV / áudio",
    compareRowRemote: "Controle remoto",
    compareRowAlcatraz: "Alcatraz DMS",
    compareRowTr069: "TR-069",
    compareRowDimensions: "Dimensões",
    compareRowPower: "Fonte de alimentação",
    compareRowRemoteInBox: "Controle remoto",
    compareRowHdmiCable: "Cabo HDMI",
    compareRowPowerAdapter: "Adaptador de alimentação",
    compareRowBatteries: "Pilhas",
    compareRowGuide: "Guia de início rápido",
    compareViewSpecs: "Ver especificações",
    compareCtaTitle: "Precisa de ajuda para escolher o modelo certo?",
    compareCtaBody:
      "Conte para nós sobre a sua rede, o perfil dos assinantes e a faixa de preço desejada. Vamos indicar o dispositivo inext ideal para o seu rollout.",
    compareIncluded: "Incluído",
    compareNotIncluded: "Não incluído",
    compareModelTv6UltraTagline:
      "TV box topo de linha com Android 12 para implantações 4K avançadas.",
    compareModelTv6UltraSpecRemote: "Controle de voz BT",
    compareModelTv6UltraHighlight1: "Maior RAM e armazenamento da linha",
    compareModelTv6UltraHighlight2: "Controle remoto de voz Bluetooth 5.0",
    compareModelTv6UltraHighlight3: "Alcatraz™ DMS + TR-069",
    compareModelTv6Tagline: "Modelo Android 12 equilibrado para IPTV e OTT do dia a dia.",
    compareModelTv6SpecRemote: "Controle IR",
    compareModelTv6Highlight1: "Mesma plataforma H618 do TV6 Ultra",
    compareModelTv6Highlight2: "Android 12 AOSP",
    compareModelTv6Highlight3: "Alcatraz™ DMS + TR-069",
    compareModelTv5UltraTagline: "Opção estável com Android 10 e 2 GB de RAM.",
    compareModelTv5UltraSpecRemote: "Controle IR",
    compareModelTv5UltraHighlight1: "Plataforma H313 comprovada",
    compareModelTv5UltraHighlight2: "Alcatraz™ DMS + TR-069",
    compareModelTv5UltraHighlight3: "Saída AV RCA para TVs antigas",
    compareModelTv5Tagline: "Box essencial com Android 10 para implantações sensíveis a custo.",
    compareModelTv5SpecRemote: "Controle IR",
    compareModelTv5Highlight1: "Melhor custo-benefício da linha",
    compareModelTv5Highlight2: "Alcatraz™ DMS + TR-069",
    compareModelTv5Highlight3: "Decodificação por hardware 4K@60",
    compareRemoteBtVoice: "Voz BT",
    compareRemoteIr: "IR",
    productPhotoComingSoon: "Foto do produto em breve",
    productHardwarePhotoComingSoon: "Foto do hardware em breve",
    productSoftwarePhotoComingSoon: "Foto lifestyle do software em breve",
    productSoftwareLifestyleImageAlt:
      "TV exibindo um launcher de operadora neutro por região com TV ao vivo, VOD, catch-up, rádio, apps e configurações",
    tv6HeroImageAlt:
      "inext TV6 sobre uma mesa de sala com a TV exibindo inext TV, MEGOGO, sweet.tv, IPTV, Plex, VLC e Spotify",
    tv6PortsImageAlt:
      "Portas traseiras do inext TV6: microSD, 2× USB, extensor IR ou porta AV conforme o mercado, S/PDIF, Ethernet, HDMI, DC 5V",
    tv6RemoteImageAlt:
      "Controle remoto IR do inext TV6 com teclado numérico completo, direcional de navegação e botões diretos de reprodução",
    tv6HardwareRevealLabel: "Revelar o hardware interno do TV6",
    tv6HardwareRevealImageAlt:
      "Vista superior do inext TV6 com revelação arrastável do hardware interno",
    tv6UltraHeroImageAlt:
      "inext TV6 Ultra sobre um rack de sala com a TV exibindo inext TV, MEGOGO, sweet.tv, IPTV, Plex, VLC e Spotify",
    tv6UltraPortsImageAlt:
      "Portas traseiras do inext TV6 Ultra: microSD, 2× USB, AV, S/PDIF, Ethernet, HDMI, DC 5V",
    tv5PortsImageAlt:
      "Portas traseiras do inext TV5: AV, S/PDIF óptica, Ethernet, HDMI, alimentação DC, 2× USB, microSD",
    tv5RemoteImageAlt:
      "Controle remoto do inext TV5 com direcional OK, teclas numéricas e botões de atalho",
    tv5HardwareRevealLabel: "Revelar o hardware interno do TV5",
    tv5HardwareRevealImageAlt:
      "Vista superior do inext TV5 com revelação arrastável do hardware interno",
    tv5SoftwareImageAlt:
      "TV exibindo um launcher IPTV personalizável acima de um set-top box inext TV5",
    tv6UltraRemoteImageAlt:
      "Controle remoto de voz Bluetooth da inext com microfone, botões programáveis de TV power e FAV",
    tv6UltraHardwareRevealLabel: "Revelar o hardware interno do TV6 Ultra",
    tv6UltraHardwareRevealImageAlt:
      "Vista superior do inext TV6 Ultra com revelação arrastável do hardware interno",
    tv5UltraSeoTitle: "inext TV5 Ultra — Set-Top Box Android 10 para Operadoras",
    tv5UltraSeoDescription:
      "inext TV5 Ultra: Allwinner H313, 2GB de RAM, 16GB eMMC, reprodução 4K@60, Wi-Fi dual-band, Android 10 AOSP e Alcatraz™ DMS para implantações de operadoras.",
    tv5SeoTitle: "inext TV5 — Set-Top Box Android 10 Essencial para Operadoras",
    tv5SeoDescription:
      "inext TV5: Allwinner H313, 1GB de RAM, 8GB eMMC, reprodução 4K@60, Wi-Fi dual-band, Android 10 AOSP e Alcatraz™ DMS para implantações de IPTV e OTT com ótimo custo-benefício.",
    tv5UltraHeroEyebrow: "Padrão · STB Android 10",
    tv5UltraHeroHeadline: "Um box Android TV comprovado para implantações estáveis de operadoras.",
    tv5UltraHeroSub:
      "O TV5 Ultra combina a confiável plataforma Allwinner H313 com 2 GB de RAM, 16 GB de armazenamento, conectividade prática e suporte ao inext Alcatraz™ DMS.",
    tv5UltraHeroImageAlt:
      "inext TV5 Ultra em um rack de mídia abaixo de uma TV rodando o launcher inext",
    tv5UltraHardwareRevealLabel: "Revelar o hardware interno do TV5 Ultra",
    tv5UltraHardwareRevealImageAlt:
      "Vista superior do inext TV5 Ultra com revelação arrastável do hardware interno",
    tv5UltraSoftwareImageAlt:
      "TV exibindo um launcher de operadora personalizável acima de um set-top box inext TV5 Ultra",
    tv5UltraCompareLabel: "Comparar todos os modelos",
    tv5UltraGlanceValue1: "4K @ 60 Hz",
    tv5UltraGlanceLabel1: "Reprodução H.265",
    tv5UltraGlanceValue2: "Android 10",
    tv5UltraGlanceLabel2: "AOSP, pronto para apps",
    tv5UltraGlanceValue3: "2 GB / 16 GB",
    tv5UltraGlanceLabel3: "DDR3 + eMMC",
    tv5UltraGlanceValue4: "Controle IR",
    tv5UltraGlanceLabel4: "Controle simples",
    tv5UltraIntroPara1:
      "O TV5 Ultra foi feito para operadoras que precisam de um set-top box Android 10 estável, com memória suficiente para os fluxos diários de IPTV, OTT e launcher.",
    tv5UltraIntroPara2:
      "Ele mantém a implantação prática: hardware comprovado, controle IR familiar, amplo suporte a mídia e gerenciamento remoto pelo Alcatraz™ DMS.",
    tv5UltraPerformanceTitle: "4K comprovado, com folga de sobra.",
    tv5UltraPerformanceBody:
      "O Allwinner H313 com Mali-G31 MP2 dá ao TV5 Ultra reprodução 4K@60 H.265 confiável para fluxos de IPTV, OTT e launcher, com 2 GB de RAM e 16 GB eMMC para as implantações do dia a dia das operadoras.",
    tv5UltraPerformanceAccent: "Allwinner H313 · 2 GB DDR3 · 16 GB eMMC · 4K@60 H.265",
    tv5UltraConnectivityCaption:
      "HDMI 2.0a · Ethernet 100 Mb · 2× USB 2.0 · microSD · S/PDIF óptica · saída AV RCA · Wi-Fi dual-band 2,4/5 GHz.",
    tv5UltraPortsImageAlt:
      "Portas traseiras do inext TV5 Ultra — S/PDIF óptica, LAN, HDMI, USB e microSD",
    tv5UltraSoftwareTitle: "Android 10, ajustado para apps de operadora.",
    tv5UltraSoftwareBody:
      "O Android 10 AOSP oferece às operadoras uma plataforma de apps familiar, opções de launcher personalizado e fluxos de gerenciamento remoto de frota pelo Alcatraz™ DMS e TR-069.",
    tv5UltraRemoteFeature1: "Teclado numérico completo para serviços de IPTV baseados em canais",
    tv5UltraRemoteFeature2: "Controles dedicados de navegação e reprodução",
    tv5UltraRemoteFeature3: "Controle IR para uma configuração simples do assinante",
    tv5UltraAlcatrazBody:
      "O TV5 Ultra pode ser provisionado, monitorado e atualizado pelos mesmos fluxos de gerenciamento de dispositivos do Alcatraz usados em toda a linha inext.",
    tv5UltraCtaTitle: "Peça o TV5 Ultra para a sua rede",
    tv5UltraCtaBody:
      "Uma opção prática de STB Android 10 com 2 GB de RAM, 16 GB de armazenamento, embalagem com a sua marca e provisionamento Alcatraz™.",
    tv5HeroEyebrow: "Essencial · STB Android 10",
    tv5HeroHeadline: "Android TV com ótimo custo-benefício para implantações IPTV essenciais.",
    tv5HeroSub:
      "O TV5 mantém o stack de operadora da inext acessível com Android 10, reprodução 4K no H313, 1 GB de RAM, 8 GB de armazenamento e suporte ao Alcatraz™ DMS.",
    tv5CompareLabel: "Comparar todos os modelos",
    tv5GlanceValue1: "4K @ 60 Hz",
    tv5GlanceLabel1: "Reprodução H.265",
    tv5GlanceValue2: "Android 10",
    tv5GlanceLabel2: "AOSP, pronto para apps",
    tv5GlanceValue3: "1 GB / 8 GB",
    tv5GlanceLabel3: "DDR3 + eMMC",
    tv5GlanceValue4: "Controle IR",
    tv5GlanceLabel4: "Controle simples",
    tv5IntroPara1:
      "O TV5 é a porta de entrada da linha de operadora da inext: hardware compacto, Android 10 AOSP e a conectividade essencial para serviços gerenciados de IPTV e OTT.",
    tv5IntroPara2:
      "Ele foi projetado para implantações em que baixo custo do dispositivo, reprodução previsível e controle de frota são o que mais importa.",
    tv5PerformanceTitle: "4K confiável com orçamento enxuto.",
    tv5PerformanceBody:
      "O Allwinner H313 com Mali-G31 MP2 dá ao TV5 reprodução 4K@60 H.265 confiável para serviços essenciais de IPTV e OTT, com 1 GB de RAM e 8 GB eMMC para implantações de operadora sensíveis a custo.",
    tv5PerformanceAccent: "Allwinner H313 · 1 GB DDR3 · 8 GB eMMC · 4K@60 H.265",
    tv5ConnectivityCaption:
      "HDMI 2.0a · Ethernet 100 Mb · 2× USB 2.0 · microSD · S/PDIF óptica · saída AV RCA · Wi-Fi dual-band 2,4/5 GHz.",
    tv5SoftwareTitle: "Android 10 para a entrega de serviços essenciais.",
    tv5SoftwareBody:
      "O TV5 suporta launchers de operadora, apps de IPTV e OTT, localização e controle remoto de frota pelo Alcatraz™ DMS e TR-069.",
    tv5RemoteFeature1: "Teclado numérico para navegação baseada em canais",
    tv5RemoteFeature2: "Controles dedicados de reprodução e menu",
    tv5RemoteFeature3: "Configuração IR simples para a casa do assinante",
    tv5AlcatrazBody:
      "O TV5 pode ser provisionado, monitorado e atualizado pelo Alcatraz™ DMS, mantendo as implantações de baixo custo gerenciáveis em escala.",
    tv5CtaTitle: "Peça o TV5 para a sua rede",
    tv5CtaBody:
      "Um pacote de STB Android com ótimo custo-benefício, embalagem com a sua marca e provisionamento Alcatraz™ para implantações essenciais de IPTV e OTT.",
    tv6SeoTitle: "inext TV6 — Set-Top Box 4K Android 12 para Operadoras",
    tv6SeoDescription:
      "inext TV6: Allwinner H618, 2GB de RAM, 16GB eMMC, 4K@60 HDR, Wi-Fi dual-band, Android 12 AOSP e Alcatraz™ DMS. Um STB compacto para provedores, hotéis e operadoras de OTT.",
    tv6UltraSeoTitle: "inext TV6 Ultra — Set-Top Box 4K Android 12 para Operadoras",
    tv6UltraSeoDescription:
      "inext TV6 Ultra: Allwinner H618, 4GB de RAM, 32GB eMMC, 4K@60 HDR, Wi-Fi dual-band, BT 5.0, Android 12 AOSP e Alcatraz™ DMS. Feito para provedores, hotéis e operadoras de OTT.",
    tv6UltraBreadcrumbHome: "Início",
    tv6UltraBreadcrumbProducts: "Produtos",
    tv6UltraContactSales: "Falar com o comercial",
    tv6UltraFindDistributor: "Encontrar um distribuidor",
    tv6UltraAlcatrazTitle: "Gerenciado pelo Alcatraz™ DMS",
    tv6UltraAlcatrazBody:
      "Todo TV6 Ultra já sai de fábrica pronto para o Alcatraz, o sistema de gerenciamento de dispositivos da inext — usado hoje por mais de 120 redes de operadoras no mundo todo.",
    tv6UltraAlcatrazCta: "Ver operações",
    tv6UltraCtaTitle: "Peça o TV6 Ultra para a sua rede",
    tv6UltraCtaBody:
      "Preço por volume, embalagem white-label e provisionamento Alcatraz™ — tudo com um único time.",
    tv6UltraSpecChipset: "Chipset",
    tv6UltraSpecCpu: "CPU",
    tv6UltraSpecGpu: "GPU",
    tv6UltraSpecRam: "RAM",
    tv6UltraSpecStorage: "Armazenamento",
    tv6UltraSpecDimensions: "Dimensões",
    tv6UltraSpecPower: "Fonte de alimentação",
    tv6UltraSpecHdmi: "HDMI",
    tv6UltraSpecEthernet: "Ethernet",
    tv6UltraSpecWifi: "Wi-Fi",
    tv6UltraSpecBluetooth: "Bluetooth",
    tv6UltraSpecUsb: "USB",
    tv6UltraSpecCardReader: "Leitor de cartão",
    tv6UltraSpecAudioOut: "Saída de áudio",
    tv6UltraSpecAudioFormats: "Formatos de áudio",
    tv6UltraSpecVideoFormats: "Formatos de vídeo",
    tv6UltraSpecVideoCodecs: "Codecs de vídeo",
    tv6UltraSpecMaxRes: "Resolução máxima",
    tv6UltraSpec3d: "Suporte a 3D",
    tv6UltraSpecImageFormats: "Formatos de imagem",
    tv6UltraSpecOs: "Sistema operacional",
    tv6UltraSpecDms: "Gerenciamento de dispositivos",
    tv6UltraSpecTr069: "TR-069",
    tv6UltraSpecFilesystems: "Sistemas de arquivos",
    tv6UltraSpecLanguages: "Idiomas",
    tv6UltraSpecInternet: "Recursos de internet",
    tv6UltraSpecTr069Yes: "Suportado",
    tv6UltraSpecLanguagesValue: "Multi-idioma",
    productSpecCpuArmv8Quad: "ARM v8 Cortex-A53 quad-core",
    productSpecCpuQuadCoreArm: "ARM Cortex-A53 quad-core",
    productSpecHdmiCableIncluded: "HDMI 2.0a (cabo incluído)",
    productSpecEthernet100: "RJ45 Fast Ethernet (100 Mbps)",
    productSpecWifiDualBandN: "Dual band 2,4 / 5 GHz · 802.11 b/g/n",
    productSpecWifiDualBandAc: "Dual band 2,4 / 5 GHz · 802.11 b/g/n/ac",
    productSpecUsbHost: "2 × USB 2.0 Host",
    productSpecAudioSpdifRcaTrs: "S/PDIF óptico · RCA via TRS de 3,5 mm",
    productSpecAudioSpdif: "S/PDIF óptico",
    productSpecAudioSpdifRca: "S/PDIF óptico · RCA (TRS de 3,5 mm)",
    productSpecInternetFeatures:
      "IPTV · OTT · VOD · HLS · rádio via internet · HTML5 · WebKit · apps Android",
    tv6UltraSpec3dValue: "Side-by-side · Frame-packed",
    tv6UltraSpecMaxResValue: "4K UHD (2160p) @ 60 fps",
    tv6PackageRemote: "Controle remoto IR",
    tv6UltraPackageRemote: "Controle remoto Bluetooth",
    tv6UltraPackagePower: "Adaptador de alimentação (5V / 2A)",
    tv6UltraPackageHdmi: "Cabo HDMI",
    tv6UltraPackageGuide: "Guia de início rápido",
    tv6UltraPackageBatteries: "Pilhas",
    packageNote:
      "O conteúdo da embalagem pode variar conforme o mercado, o envio e a configuração da operadora.",
    tv6HeroEyebrow: "Essential · STB Android 12 4K",
    tv6HeroHeadline: "Potência compacta para o dia a dia de IPTV e OTT.",
    tv6HeroSub:
      "Um set-top box Android 12 prático para implantações de operadora que precisam de reprodução 4K confiável, conectividade comprovada e controle via Alcatraz™ DMS sem o excesso de memória dos modelos topo de linha.",
    tv6CompareLabel: "Compare com o TV6 Ultra",
    tv6GlanceValue1: "4K @ 60 Hz",
    tv6GlanceLabel1: "HDR · H.265",
    tv6GlanceValue2: "Android 12",
    tv6GlanceLabel2: "AOSP, pronto para apps",
    tv6GlanceValue3: "2 GB / 16 GB",
    tv6GlanceLabel3: "DDR3 + eMMC",
    tv6GlanceValue4: "Controle IR",
    tv6GlanceLabel4: "Controle simples",
    tv6IntroPara1:
      "O TV6 traz a mesma abordagem inext, pensada para operadoras, em um dispositivo compacto e econômico: suporte a vídeo 4K, Android 12 AOSP, conectividade prática para a casa e gerenciamento remoto da frota.",
    tv6IntroPara2:
      "Ele foi feito para implantações em que a experiência previsível do assinante, o provisionamento fácil e o suporte de longo prazo importam mais do que especificações superdimensionadas.",
    tv6PerformanceAccent: "Allwinner H618 · 2 GB DDR3 · 16 GB eMMC · 4K@60 H.265",
    tv6ConnectivityCaption:
      "HDMI 2.0a · Ethernet 100 Mb · 2× USB 2.0 · microSD · S/PDIF óptico · porta dedicada para extensor IR ou porta AV, conforme a variante do TV6 · Wi-Fi dual-band 2,4/5 GHz · Bluetooth 5.0.",
    tv6RemoteEyebrow: "Controle remoto",
    tv6RemoteTitle: "Controle IR simples para o dia a dia.",
    tv6RemoteBody:
      "O controle remoto IR incluído mantém a experiência da sala de estar familiar: teclado numérico, controles de navegação, botões de reprodução e atalhos diretos que combinam com os assinantes de IPTV.",
    tv5RemoteTitle: "Um controle remoto familiar, já incluído.",
    tv5RemoteBody:
      "O TV5 vem com um controle remoto IR clássico — teclado numérico, navegação por D-pad e teclas de reprodução — para que a primeira configuração seja imediatamente familiar.",
    tv5UltraRemoteTitle: "Controle remoto IR clássico em toda caixa.",
    tv5UltraRemoteBody:
      "O TV5 Ultra acompanha o mesmo controle remoto IR confiável: teclado numérico completo, teclas de navegação e botões diretos de reprodução, prontos para parear assim que você tira da caixa.",
    tv6PerformanceTitle: "4K fluido sem preço de topo de linha.",
    tv6PerformanceBody:
      "O Allwinner H618 quad-core com Mali-G31 MP2 decodifica H.265, VP9 Profile 2 e H.264 por hardware — reprodução 4K confiável para grades de IPTV e OTT de grande volume.",
    tv6SoftwareTitle: "Android 12 com espaço para crescer.",
    tv6SoftwareBody:
      "Android 12 aberto (AOSP) com Bluetooth, Wi-Fi dual-band e um launcher pronto para operadoras — uma base flexível para apps personalizados, serviços OTT e jogos casuais.",
    tv6RemoteFeature1: "Teclado numérico completo para serviços baseados em canais",
    tv6RemoteFeature2: "Controles dedicados de navegação e reprodução",
    tv6RemoteFeature3:
      "Porta dedicada para extensor IR nas variantes do TV6 que oferecem suporte; variantes com porta AV não são compatíveis com o extensor",
    tv6RemoteBtNoteTitle: "O controle que você pedir",
    tv6RemoteBtNoteBody:
      "Um módulo Bluetooth integrado permite pedir o TV6 com qualquer controle da nossa linha — IR ou Bluetooth. Em algumas regiões, ele já vem com um controle Bluetooth por padrão.",
    tv6RemoteBtNoteLink: "Ver opções de controle",
    tv5RemoteIrNoteTitle: "Controle IR à sua escolha",
    tv5RemoteIrNoteBody:
      "Já vem com um controle IR clássico, mas pode ser pedido com qualquer controle IR da nossa linha — incluindo modelos programáveis que controlam a set-top box e a TV ao mesmo tempo.",
    tv6IrAvPortLabel: "Porta de 3,5 mm",
    tv6IrAvPortSpec:
      "Varia conforme o mercado: extensor IR dedicado ou AV; as variantes AV não são compatíveis com o extensor IR",
    tv6AlcatrazBody:
      "Todo TV6 pode ser provisionado, monitorado e atualizado pelo sistema de gerenciamento de dispositivos inext Alcatraz, usado por redes de operadoras no mundo todo.",
    tv6CtaTitle: "Peça o TV6 para a sua rede",
    tv6CtaBody:
      "Preços por volume, embalagem personalizada e provisionamento Alcatraz™ para rollouts práticos de IPTV e OTT.",
    tv6UltraV2HeroEyebrow: "Flagship · STB Android 12 4K",
    tv6UltraV2HeroHeadline: "Potência máxima para conteúdo máximo.",
    tv6UltraV2HeroSub:
      "Uma central de mídia de nível operadora para a sala de estar — e para a equipe de operações por trás dela.",
    tv6UltraCompareLabel: "Compare todos os modelos",
    tv6UltraV2IntroPara1:
      "O TV6 Ultra é o flagship da família inext: o dobro de RAM e armazenamento do TV6, 4K acelerado por hardware a 60 FPS e o mesmo Alcatraz™ DMS que já equipa mais de 120 redes de operadoras no mundo todo.",
    tv6UltraV2IntroPara2:
      "Feito para desaparecer na sala de estar e ficar invisível para a sua equipe de suporte — rápido de provisionar, fácil de atualizar e silencioso na estante.",
    tv6UltraV2PerformanceEyebrow: "Desempenho",
    tv6UltraV2PerformanceTitle: "4K sem esforço. Todos os codecs.",
    tv6UltraV2PerformanceBody:
      "O Allwinner H618 quad-core com Mali-G31 MP2 decodifica H.265, VP9 Profile 2 e H.264 por hardware, então streams 4K, VOD e apps continuam fluidos mesmo sob carga.",
    tv6UltraV2PerformanceAccent: "Allwinner H618 · 4 GB DDR3 · 32 GB eMMC · 4K@60 H.265",
    tv6UltraV2ConnectivityEyebrow: "Conectividade",
    tv6UltraV2ConnectivityTitle: "Todas as portas de que seus assinantes precisam.",
    tv5ConnectivityTitle: "Todas as portas essenciais, integradas.",
    tv5UltraConnectivityTitle: "Todas as entradas e saídas de que a sua instalação precisa.",
    tv6ConnectivityTitle: "Pronto para cabo, Wi-Fi e Bluetooth.",
    tv6UltraV2ConnectivityCaption:
      "HDMI 2.0a · Ethernet 100 Mb · 2× USB 2.0 · microSD · S/PDIF óptico · AV · Wi-Fi dual-band 2,4/5 GHz · Bluetooth 5.0.",
    tv6UltraV2SoftwareEyebrow: "Software",
    tv6UltraV2SoftwareTitle: "Android 12, pronto para uso.",
    tv6UltraV2SoftwareBody:
      "Android 12 aberto (AOSP) com launcher pronto para operadoras, branding flexível e TR-069 + Alcatraz™ DMS para a equipe de operações por trás de cada dispositivo implantado.",
    tv6UltraV2SoftwareCustomTitle1: "Launcher da operadora",
    tv6UltraV2SoftwareCustomBody1:
      "Monte a tela inicial em torno de TV ao vivo, VOD, catch-up, rádio, apps, configurações e os fluxos de assinante que você preferir.",
    tv6UltraV2SoftwareCustomTitle2: "Identidade de marca e mercado",
    tv6UltraV2SoftwareCustomBody2:
      "Adapte logos, cores, idioma, seções padrão e serviços pré-instalados para cada operadora ou implantação regional.",
    tv6UltraV2SoftwareCustomTitle3: "Controle remoto da frota",
    tv6UltraV2SoftwareCustomBody3:
      "Use o Alcatraz™ DMS e o TR-069 para provisionar dispositivos, enviar atualizações, gerenciar configurações e manter o trabalho de suporte fora da tela do assinante.",
    tv6UltraV2SpecsTitle: "Especificações completas",
    tv6UltraV2SpecsGroupHardware: "Hardware",
    tv6UltraV2SpecsGroupConnectivity: "Conectividade",
    tv6UltraV2SpecsGroupMedia: "Mídia",
    tv6UltraV2SpecsGroupSoftware: "Software",
    tv6UltraV2SpecsGroupPackage: "Na caixa",
    tv6UltraV2RemoteEyebrow: "Controle remoto",
    tv6UltraV2RemoteTitle: "Controle remoto Bluetooth com voz, feito para a sala de estar.",
    tv6UltraV2RemoteBody:
      "Pareie uma vez por Bluetooth e esqueça a linha de visão. Um microfone integrado habilita a busca por voz no launcher e nos apps, enquanto o botão programável de liga/desliga da TV e a tecla de favoritos personalizável permitem que cada assinante configure o controle do seu jeito.",
    tv6UltraV2RemoteFeatureBt: "Bluetooth 5.0 — sem precisar mirar o IR",
    tv6UltraV2RemoteFeatureMic: "Microfone integrado para busca por voz",
    tv6UltraV2RemoteFeatureTvPower: "Botão programável de liga/desliga da TV",
    tv6UltraV2RemoteFeatureFav: "Botão de favoritos (FAV) personalizável",
    tv6UltraV2RemoteNoteBody:
      "O TV6 Ultra já vem com o controle por voz Bluetooth por padrão, mas você pode pedir qualquer controle da nossa linha — Bluetooth ou IR — conforme o seu mercado.",
    tv6UltraV2GlanceValue1: "4K @ 60 Hz",
    tv6UltraV2GlanceLabel1: "HDR · H.265",
    tv6UltraV2GlanceValue2: "Android 12",
    tv6UltraV2GlanceLabel2: "AOSP, pronto para apps",
    tv6UltraV2GlanceValue3: "4 GB / 32 GB",
    tv6UltraV2GlanceLabel3: "DDR3 + eMMC",
    tv6UltraV2GlanceValue4: "Controle BT 5.0",
    tv6UltraV2GlanceLabel4: "Voz + FAV",
    remoteAppMenuLabel: "App inext Remote",
    remoteAppProductCallout: "Prefere usar o celular? Baixe o app inext Remote gratuito",
    footerLinkRemoteApp: "App de controle remoto",
    remoteAppSeoTitle: "inext Remote — app de controle remoto para STBs inext",
    remoteAppSeoDescription:
      "Baixe o app inext Remote gratuito para Android e iOS. Controle STBs inext, troque de ambiente, busque por voz ou teclado, digite texto, use o modo gamepad e escolha tema claro ou escuro.",
    remoteAppBreadcrumbApps: "Apps",
    remoteAppHeroEyebrow: "App gratuito para a sua TV box inext",
    remoteAppHeroTitle: "O seu controle remoto, agora no celular.",
    remoteAppHeroBody:
      "O inext Remote transforma o seu celular em um controle remoto completo para a sua TV box inext — digite rápido, busque por voz, alterne entre ambientes, jogue, navegue por gestos e escolha o visual claro ou escuro.",
    remoteAppAppleBadgeAlt: "Baixe o inext Remote na App Store",
    remoteAppGoogleBadgeAlt: "Baixe o inext Remote no Google Play",
    remoteAppHeroImageAlt: "Tela de controle do app inext Remote",
    remoteAppStatDownloadsValue: "500K+",
    remoteAppStatDownloadsLabel: "downloads",
    remoteAppStatModesValue: "D-pad + gestos",
    remoteAppStatModesLabel: "modos de controle",
    remoteAppStatThemesValue: "Claro + escuro",
    remoteAppStatThemesLabel: "temas",
    remoteAppFeaturesEyebrow: "Por que você vai gostar",
    remoteAppFeaturesTitle: "Tudo o que você espera de um controle remoto moderno.",
    remoteAppFeaturesBody:
      "Os controles do dia a dia da sua TV ficam à mão, além daquilo que um controle de plástico não faz: digitação fácil, busca rápida, vários ambientes e jogos casuais.",
    remoteAppFeatureControlTitle: "Um controle remoto que simplesmente funciona",
    remoteAppFeatureControlBody:
      "Navegue, reproduza, pause e ajuste o volume com todos os controles de TV que você já conhece — direto do seu celular.",
    remoteAppFeatureRoomsTitle: "Troque de dispositivo e de ambiente",
    remoteAppFeatureRoomsBody:
      "Alterne entre os seus dispositivos inext em segundos quando você tem mais de uma tela em casa.",
    remoteAppFeatureVoiceTitle: "Voz e busca rápida",
    remoteAppFeatureVoiceBody:
      "Use a busca por voz ou o teclado do celular para encontrar conteúdo mais rápido do que com um controle físico.",
    remoteAppFeatureKeyboardTitle: "Digitação de texto fácil",
    remoteAppFeatureKeyboardBody:
      "Digite logins, buscas e texto de apps no teclado do celular, em vez de clicar letra por letra.",
    remoteAppFeatureGamepadTitle: "Modo gamepad",
    remoteAppFeatureGamepadBody:
      "Transforme o celular em um controle de jogos simples para games e experiências interativas na TV.",
    remoteAppFeatureModesTitle: "D-pad ou gestos",
    remoteAppFeatureModesBody:
      "Use os botões direcionais clássicos ou passe para o controle por gestos e toques quando isso for mais rápido.",
    remoteAppModesEyebrow: "Modos de controle",
    remoteAppModesTitle: "Controle remoto, teclado e gamepad em um só app.",
    remoteAppModesBody:
      "Fique no layout familiar do D-pad para a TV, mude para gestos para navegar mais rápido, abra o teclado para buscar ou gire o celular para o modo gamepad.",
    remoteAppModeDpad: "D-pad clássico",
    remoteAppModeSwipe: "Modo de toques e gestos",
    remoteAppGamepadImageAlt: "Captura de tela do modo gamepad do inext Remote",
    remoteAppVideoEyebrow: "Veja em ação",
    remoteAppVideoTitle: "Veja o inext Remote em ação.",
    remoteAppVideoBody:
      "Um tour rápido por tudo o que o app faz — controle remoto, teclado, voz, ambientes, gamepad e temas.",
    remoteAppVideoIframeTitle: "Vídeo de demonstração do app inext Remote",
    remoteAppScreensEyebrow: "Capturas de tela",
    remoteAppScreensTitle: "Feito para o jeito como você assiste.",
    remoteAppScreensBody:
      "Veja as telas de controle remoto, dispositivos, teclado numérico, teclado completo, gamepad e temas do app no celular.",
    remoteAppScreenshotAlt: "Captura de tela do app inext Remote",
    remoteAppThemesEyebrow: "Aparência",
    remoteAppThemesTitle: "Confortável em ambientes claros ou escuros.",
    remoteAppThemesBody:
      "Os temas claro e escuro ficam ótimos — perfeitos para o dia, para assistir tarde da noite ou para combinar com o seu celular.",
    remoteAppLightTheme: "Tema claro",
    remoteAppLightThemeBody: "Controles limpos para uso durante o dia e ambientes iluminados.",
    remoteAppDarkTheme: "Tema escuro",
    remoteAppDarkThemeBody: "Menos brilho para assistir tarde da noite.",
    remoteAppCtaEyebrow: "Baixe grátis",
    remoteAppCtaTitle: "Baixe o inext Remote para o seu celular.",
    remoteAppCtaBody:
      "Baixe o app gratuito no Google Play ou na App Store e pareie com a sua TV box inext em segundos.",
    navSolutions: "Soluções",
    navSolutionsAlcatraz: "Alcatraz DMS",
    navSolutionsAlcatrazDesc: "Monitoramento proativo da frota e operações remotas",
    footerLinkAlcatrazDms: "Alcatraz DMS",
    operationsLearnMore: "Saiba mais sobre o Alcatraz DMS",
    alcatrazBreadcrumbHome: "Início",
    alcatrazBreadcrumbSolutions: "Soluções",
    alcatrazBreadcrumbPage: "Alcatraz DMS",
    alcatrazSeoTitle: "inext Alcatraz DMS — gerenciamento de dispositivos para operadoras IPTV",
    alcatrazSeoDescription:
      "Gerenciamento de STBs inext em nuvem ou on-premise, com Fleet Health, histórico de atividade, diagnósticos remotos e atualizações OTA controladas.",
    alcatrazTrialSeoTitle: "Teste grátis do Alcatraz Pro por 3 meses | inext",
    alcatrazTrialSeoDescription:
      "Solicite três meses grátis do Alcatraz Pro — com os STBs inext da sua rede ou com uma unidade demo que enviamos para você.",
    alcatrazTrialBreadcrumb: "Teste grátis de 3 meses",
    alcatrazTrialEyebrow: "Para ISPs e operadoras de TV",
    alcatrazTrialTitle: "Experimente o Alcatraz Pro grátis por 3 meses",
    alcatrazTrialIntro:
      "Veja o que o Alcatraz Pro pode fazer com os set-top boxes da inext — os que já estão na sua rede ou uma unidade demo que enviamos para você. Nossa equipe ajuda a começar — sem cartão de pagamento ou compromisso de longo prazo.",
    alcatrazTrialBenefitFree: "Acesso completo ao Alcatraz Pro por três meses",
    alcatrazTrialBenefitExisting: "Use seus STBs inext atuais — ou receba de nós uma unidade demo",
    alcatrazTrialBenefitGuided: "Suporte da equipe da inext na configuração",
    alcatrazTrialStepsTitle: "Como funciona",
    alcatrazTrialStep1: "Envie a solicitação",
    alcatrazTrialStep2: "Confirmamos os dados da empresa",
    alcatrazTrialStep3: "Configuramos o acesso e ajudamos você a começar",
    alcatrazTrialFeaturesLink: "Conheça os recursos e as opções de implantação",
    alcatrazTrialDashboardAlt: "Painel de gerenciamento de frota do Alcatraz Pro",
    alcatrazTrialFormTitle: "Comece seu teste grátis de 3 meses",
    alcatrazTrialFormIntro:
      "Informe seus dados de contato. Confirmaremos a elegibilidade da empresa e ajudaremos você a começar.",
    alcatrazTrialDemoOption: "Quero uma demonstração antes do teste",
    alcatrazTrialSampleOption: "Ainda não tenho STBs inext — quero receber uma unidade demo",
    alcatrazRequestNamePlaceholder: "Ana Silva",
    alcatrazRequestCompanyPlaceholder: "Acme Telecom",
    alcatrazRequestEmailPlaceholder: "ana@acme.com",
    alcatrazRequestPhonePlaceholder: "+55 11 91234-5678",
    alcatrazRequestNameError: "Informe seu nome.",
    alcatrazRequestCompanyError: "Informe o nome da empresa.",
    alcatrazRequestEmailError: "Informe um e-mail corporativo válido.",
    alcatrazRequestPhoneError: "Informe um número de telefone.",
    alcatrazTrialEligibility:
      "Para clientes empresariais — ISPs e operadoras de TV. Ainda não tem STBs inext? Preparamos uma unidade demo para você. O acesso ao teste está sujeito a uma rápida verificação dos dados da empresa.",
    alcatrazTrialNoCardNote: "Sem cartão de pagamento e sem compromisso de longo prazo.",
    alcatrazTrialSubmitting: "Enviando...",
    alcatrazTrialSubmitTrial: "Solicitar 3 meses grátis",
    alcatrazTrialSubmitDemo: "Solicitar demonstração e 3 meses grátis",
    alcatrazTrialSuccessTitle: "Recebemos sua solicitação de teste",
    alcatrazTrialSuccessBody:
      "Obrigado. Confirmaremos os dados da empresa e entraremos em contato para configurar seu teste grátis de três meses do Alcatraz Pro.",
    alcatrazTrialDemoSuccessBody:
      "Obrigado. Confirmaremos os dados da empresa e entraremos em contato para agendar uma demonstração antes de configurar seu teste grátis de três meses.",
    alcatrazTrialSampleSuccessNote: "Também vamos preparar e enviar uma unidade demo para você.",
    alcatrazTrialSuccessTimeline: "Normalmente respondemos em até um dia útil.",
    alcatrazStartSeoTitle: "Alcatraz Pro para frotas com menos de 500 dispositivos ativos | inext",
    alcatrazStartSeoDescription:
      "O Alcatraz Pro está incluído sem custo adicional para frotas inext com menos de 500 dispositivos ativos. Solicite acesso e uma unidade de avaliação se a frota ainda não usar STBs inext.",
    alcatrazStartBreadcrumb: "Obter o Alcatraz Pro",
    alcatrazStartEyebrow: "Para ISPs e operadoras de TV",
    alcatrazStartTitle: "O Alcatraz Pro é incluído com os seus set-top boxes inext",
    alcatrazStartIntro:
      "Gerencie toda a frota em um único console: monitoramento, firmware, diagnósticos e suporte remoto. O Alcatraz Pro está incluído sem custo adicional enquanto a frota tiver menos de 500 dispositivos inext ativos.",
    alcatrazStartBenefit1:
      "Incluído sem custo adicional para frotas com menos de 500 dispositivos ativos",
    alcatrazStartBenefit2: "O console completo do Alcatraz Pro, não uma versão limitada",
    alcatrazStartBenefit3: "Suporte da equipe da inext na configuração",
    alcatrazStartActiveTitle: "O que conta como dispositivo ativo",
    alcatrazStartActiveBody:
      "O acesso é definido com base na contagem mais recente de dispositivos ativos nos últimos 30 dias. Aparelhos ainda em produção, em trânsito, no estoque ou já desativados não contam para o limite de 500 dispositivos.",
    alcatrazStartStepsTitle: "Como funciona",
    alcatrazStartStep1: "Envie a solicitação",
    alcatrazStartStep2: "Confirmamos os dados da empresa",
    alcatrazStartStep3: "Criamos a sua conta e ajudamos você a começar",
    alcatrazStartFeaturesLink: "Conheça os recursos e as opções de implantação",
    alcatrazStartDashboardAlt: "Console de gerenciamento de frota do Alcatraz Pro",
    alcatrazStartFormTitle: "Receba a sua conta do Alcatraz Pro",
    alcatrazStartFormIntro:
      "Diga como podemos entrar em contato. Confirmaremos os dados da empresa e ajudaremos você a começar.",
    alcatrazStartDemoOption: "Quero uma demonstração antes de começar",
    alcatrazStartSampleOption: "Ainda não tenho STBs inext — quero receber uma unidade demo",
    alcatrazStartEligibility:
      "O Alcatraz Pro está disponível para clientes empresariais — ISPs e operadoras de TV — sem custo adicional para frotas com menos de 500 dispositivos ativos. Para frotas com 500 dispositivos ativos ou mais, fale com a equipe de vendas para discutir acesso e condições comerciais.",
    alcatrazStartSubmitting: "Enviando...",
    alcatrazStartSubmit: "Obter o Alcatraz Pro",
    alcatrazStartSubmitDemo: "Solicitar demonstração + Alcatraz Pro",
    alcatrazStartNoCardNote: "Sem cartão de pagamento e sem compromisso de longo prazo.",
    alcatrazStartSuccessTitle: "Recebemos a sua solicitação",
    alcatrazStartSuccessBody:
      "Obrigado. Confirmaremos os dados da empresa e entraremos em contato para configurar a sua conta do Alcatraz Pro.",
    alcatrazStartDemoSuccessBody:
      "Obrigado. Confirmaremos os dados da empresa e entraremos em contato para agendar uma demonstração antes de configurar a sua conta do Alcatraz Pro.",
    alcatrazStartSampleSuccessNote: "Também vamos preparar e enviar uma unidade demo para você.",
    alcatrazStartSuccessTimeline: "Normalmente respondemos em até um dia útil.",
    alcatrazHeroEyebrow: "Sistema de gerenciamento de dispositivos",
    alcatrazHeroTitle: "inext Alcatraz DMS —",
    alcatrazHeroTitleAccent: "sua frota, sempre sob controle",
    alcatrazHeroSub:
      "Nuvem SaaS ou totalmente on-premise. Monitore a saúde da frota, consulte o histórico dos dispositivos, distribua atualizações e ofereça suporte a cada STB inext em uma única plataforma.",
    alcatrazCtaStart: "Obter o Alcatraz Pro",
    alcatrazHeroCtaDemo: "Solicitar uma demo",
    alcatrazHeroCtaSales: "Falar com vendas",
    alcatrazHeroImageCaption: "Alcatraz DMS — painel de visão geral da frota",
    alcatrazHeroStatNetworks: "Mais de 120 redes de operadoras",
    alcatrazHeroStatDeploy: "Nuvem ou on-premise",
    alcatrazHeroStatScale: "Escala junto com a sua frota",
    alcatrazDeploymentEyebrow: "Implantação",
    alcatrazDeploymentTitle: "Duas formas de implantar",
    alcatrazDeploymentDescription:
      "Escolha o modelo que combina com a política da sua rede. Mesmos recursos, mesmo console, mesma assinatura.",
    alcatrazDeploymentCloudTag: "Recomendado",
    alcatrazDeploymentCloudTitle: "Nuvem (SaaS)",
    alcatrazDeploymentCloudBody:
      "Hospedado e operado pela inext. Início mais rápido, atualizações automáticas e acesso geodistribuído para a sua equipe de suporte.",
    alcatrazDeploymentCloudBullet1: "Sem infraestrutura para manter",
    alcatrazDeploymentCloudBullet2: "Upgrades automáticos da plataforma",
    alcatrazDeploymentCloudBullet3: "Disponibilidade garantida por SLA",
    alcatrazDeploymentOnpremTitle: "On-premise",
    alcatrazDeploymentOnpremBody:
      "Roda dentro da sua rede fechada de provedor. Soberania total dos dados para operadoras com requisitos rígidos de regulamentação ou segurança.",
    alcatrazDeploymentOnpremBullet1: "Implantado no seu data center",
    alcatrazDeploymentOnpremBullet2: "Seus dados nunca saem da sua rede",
    alcatrazDeploymentOnpremBullet3: "Funciona atrás de NAT / redes fechadas",
    alcatrazPillarsEyebrow: "O que há por dentro",
    alcatrazPillarsTitle: "Tudo o que você precisa para operar uma frota de STBs",
    alcatrazPillar1Title: "Fleet Health",
    alcatrazPillar1Body:
      "Priorize problemas de sinal Wi-Fi fraco e temperatura alta, consulte o histórico dos dispositivos e receba resumos semanais.",
    alcatrazPillar2Title: "Firmware OTA por etapas",
    alcatrazPillar2Body:
      "Distribua firmware em etapas, acompanhe os resultados, exclua dispositivos específicos e mantenha os comentários associados a cada build ou release.",
    alcatrazPillar3Title: "Suporte remoto e diagnósticos",
    alcatrazPillar3Body:
      "Reinicie e controle dispositivos remotamente, execute diagnósticos MTR ou iPerf3 e resolva problemas sem enviar um técnico ao local.",
    alcatrazPillar4Title: "Histórico de atividades e auditoria",
    alcatrazPillar4Body:
      "Consulte comandos, alterações, notas privadas e eventos OTA, com identificação do usuário ou da chave de API para auditoria.",
    alcatrazPillar5Title: "Proteção dos dispositivos",
    alcatrazPillar5Body:
      "Aplique perfis de bloqueio, App Lock e net-lock para proteger dispositivos alugados, perdidos ou desativados.",
    alcatrazPillar6Title: "Comunicação com assinantes",
    alcatrazPillar6Body:
      "Envie banners segmentados no launcher, notificações e campanhas com CTAs na tela da TV.",
    alcatrazPillar7Title: "API e padrões do setor",
    alcatrazPillar7Body:
      "Gerencie chaves de API com restrições de acesso e integre via REST, MQTT ou fluxos existentes de TR-069/CWMP.",
    alcatrazPillar8Title: "Organização da frota",
    alcatrazPillar8Body:
      "Use IDs externos e grupos para pesquisar, filtrar, exportar e executar ações em lote nos dispositivos.",
    alcatrazFleetHealthEyebrow: "Fleet Health",
    alcatrazFleetHealthTitle: "Priorize os dispositivos que precisam de atenção",
    alcatrazFleetHealthBody:
      "O Fleet Health analisa a telemetria dos dispositivos e organiza os problemas detectados em uma visão clara para as equipes de operações e suporte. O painel resume o estado de toda a frota, enquanto uma fila com filtros dá acesso direto a cada dispositivo afetado e ao seu histórico de problemas.",
    alcatrazFleetHealthBullet1: "Detectar Wi-Fi fraco e condições de alta temperatura",
    alcatrazFleetHealthBullet2: "Filtrar e priorizar a fila de problemas dos dispositivos",
    alcatrazFleetHealthBullet3: "Revisar detalhes e histórico de problemas de cada STB",
    alcatrazFleetHealthBullet4: "Receber resumos semanais da frota",
    alcatrazFleetHealthPlaceholder: "Painel Fleet Health e fila priorizada de problemas",
    alcatrazFleetPreviewUpdated: "Atualizado agora",
    alcatrazFleetPreviewLive: "Visão em tempo real",
    alcatrazFleetPreviewNeedsAttention: "Requerem atenção",
    alcatrazFleetPreviewCallFirst: "Contatar primeiro",
    alcatrazFleetPreviewKeepWatch: "Acompanhar",
    alcatrazFleetPreviewHealthy: "Saudáveis",
    alcatrazFleetPreviewMonitored: "Monitorados",
    alcatrazFleetPreviewIssueTypes: "Tipos de problema",
    alcatrazFleetPreviewWeakWifi: "Wi-Fi fraco",
    alcatrazFleetPreviewTemperature: "Temperatura",
    alcatrazFleetPreviewQueue: "Fila prioritária de dispositivos",
    alcatrazFleetPreviewCriticalFirst: "Casos críticos primeiro",
    alcatrazFleetPreviewShown: "{count} exibidos",
    alcatrazFleetPreviewHighTemperature: "Alta temperatura",
    alcatrazFleetPreviewWatch: "Acompanhar",
    alcatrazFleetPreviewAwaiting: "{count} problemas aguardando confirmação",
    alcatrazPreviewMinutesAgo: "há {minutes} min",
    alcatrazPreviewIllustrativeData: "Dados ilustrativos",
    alcatrazFirmwareEyebrow: "Gerenciamento de firmware",
    alcatrazFirmwareTitle: "Implantações em etapas com controles de segurança",
    alcatrazFirmwareBody:
      "Agende lançamentos de firmware para uma parte da frota, exija a confirmação no dispositivo e acompanhe as estatísticas do release em tempo real. Exclua qualquer dispositivo das atualizações automáticas com um único botão ou envie uma atualização manual quando precisar.",
    alcatrazFirmwareBullet1: "Rollout em etapas",
    alcatrazFirmwareBullet2: "Excluir das atualizações automáticas por dispositivo",
    alcatrazFirmwareBullet3: "Lançamento manual de firmware",
    alcatrazFirmwareBullet4: "Confirmação do cliente + estatísticas de release",
    alcatrazFirmwarePlaceholder: "Painel de lançamento de firmware",
    alcatrazFirmwareOtaLink: "Conheça a gestão de atualizações OTA",
    alcatrazInspectorEyebrow: "Inspetor de dispositivos",
    alcatrazInspectorTitle: "Estado atual e histórico completo na mesma tela",
    alcatrazInspectorBody:
      "Abra qualquer STB para ver seu estado atual e depois acompanhe os eventos que levaram a esse estado. A linha do tempo de atividade reúne comandos, eventos de ativação, alterações do dispositivo, notas privadas, campanhas, notificações e eventos OTA.",
    alcatrazActivityBullet1:
      "Modos de visualização predefinidos, filtros e modo de auditoria específico",
    alcatrazActivityBullet2: "Identificação do usuário ou da chave de API em cada ação registrada",
    alcatrazActivityBullet3: "Métricas OTA detalhadas e histórico de comandos",
    alcatrazInspectorPreviewOnline: "Online",
    alcatrazInspectorPreviewCurrentState: "Estado atual",
    alcatrazInspectorPreviewActivity: "Atividade",
    alcatrazInspectorPreviewCondition: "Condição do dispositivo",
    alcatrazInspectorPreviewLastChecked: "Verificado há {minutes} min",
    alcatrazInspectorPreviewAllEvents: "Todos os eventos",
    alcatrazInspectorPreviewCommands: "Comandos",
    alcatrazInspectorPreviewNewest: "Mais recentes primeiro",
    alcatrazInspectorPreviewToday: "Hoje",
    alcatrazInspectorPreviewYesterday: "Ontem",
    alcatrazInspectorPreviewThisWeek: "Esta semana",
    alcatrazInspectorPreviewLastWeek: "Semana passada",
    alcatrazInspectorPreviewEarlier: "Eventos anteriores",
    alcatrazInspectorPreviewSupportNote: "Nota do suporte: pausas intermitentes na reprodução",
    alcatrazInspectorPreviewFirmwareChange: "Firmware 1.8.51 → 1.9.1",
    alcatrazInspectorPreviewOtaCompleted: "Download OTA concluído",
    alcatrazInspectorPreviewCommandBy: "Comando · João Silva",
    alcatrazInspectorPreviewPrivateNoteBy: "Nota privada · João Silva",
    alcatrazInspectorPreviewDeviceChangeApi:
      "Alteração do dispositivo · chave de API · rollout-bot",
    alcatrazInspectorPreviewOtaMetrics: "Versão 1.9.0 · 45,78 MB/s · 1 min 18 s",
    alcatrazInspectorPreviewWaiting: "Aguardando resposta",
    alcatrazInspectorPreviewCompleted: "Concluído",
    alcatrazInspectorPreviewFooter: "Comandos, alterações, notas e eventos OTA",
    alcatrazInspectorPreviewIllustrative: "Histórico de exemplo",
    alcatrazInspectorPreviewAlt:
      "Demonstração do inspetor de dispositivos Alcatraz com o estado atual e o histórico de atividade.",
    alcatrazInspectorCardTitle: "Visão do dispositivo",
    alcatrazInspectorLabelState: "Estado",
    alcatrazInspectorValueState: "Online · 4d 1h 19min",
    alcatrazInspectorLabelLastSeen: "Última conexão",
    alcatrazInspectorValueLastSeen: "há 12 min",
    alcatrazInspectorLabelFirmware: "Firmware",
    alcatrazInspectorValueFirmware: "v1.8.14",
    alcatrazInspectorLabelTemps: "Temperaturas",
    alcatrazInspectorValueTemps: "CPU 51,2° · GPU 52,5° · RAM 50,8° · VEE 53,4°",
    alcatrazInspectorLabelRam: "RAM",
    alcatrazInspectorValueRam: "383 MB livres de 4 GB",
    alcatrazInspectorLabelFlash: "Flash",
    alcatrazInspectorValueFlash: "18,8 GB livres de 32 GB",
    alcatrazInspectorLabelTv: "Conexão com a TV",
    alcatrazInspectorValueTv: "HDMI · 1920×1080 · 60 fps",
    alcatrazInspectorLabelNetwork: "Rede",
    alcatrazInspectorValueNetwork: "Wi-Fi 5 GHz · RSSI −29 dBm (Excelente)",
    alcatrazInspectorLabelAndroid: "Android",
    alcatrazInspectorValueAndroid: "12",
    alcatrazInspectorLabelLocale: "Localidade",
    alcatrazInspectorValueLocale: "Inglês · Europe/Kyiv",
    alcatrazInspectorLabelApps: "Apps instalados",
    alcatrazInspectorValueApps: "Lista de apps com versões",
    alcatrazRemoteEyebrow: "Controle remoto",
    alcatrazRemoteTitle: "Um console de comandos da operadora",
    alcatrazRemoteBody:
      "Execute qualquer ação que normalmente exigiria um técnico em campo — de um reinício a um reset de fábrica completo — sem nunca encostar no aparelho.",
    alcatrazRemoteGroupControl: "Controle",
    alcatrazRemoteGroupDiagnostics: "Diagnósticos",
    alcatrazRemoteGroupComms: "Comunicação",
    alcatrazRemoteGroupLifecycle: "Ciclo de vida",
    alcatrazRemoteGroupLockdown: "Bloqueio",
    alcatrazRemoteCmdReboot: "Reiniciar",
    alcatrazRemoteCmdRemote: "Controle remoto virtual",
    alcatrazRemoteCmdScreenshot: "Captura de tela",
    alcatrazRemoteCmdSpeed: "Teste de velocidade (iPerf3)",
    mtrAlcatrazRemoteCmd: "Rastreamento de rota MTR",
    alcatrazRemoteCmdPush: "Notificação push",
    alcatrazRemoteCmdFirmware: "Lançamento de firmware",
    alcatrazRemoteCmdExclude: "Excluir das atualizações automáticas",
    alcatrazRemoteCmdBlock: "Bloquear dispositivo",
    alcatrazRemoteCmdFactory: "Reset de fábrica",
    alcatrazRemoteWarning: "Ação destrutiva",
    alcatrazRemoteHighlight1:
      "Resolva problemas comuns a partir do NOC — sem precisar despachar técnico em campo.",
    alcatrazRemoteHighlight2:
      "Execute o comando em um único dispositivo ou em um grupo inteiro com um clique.",
    alcatrazRemoteHighlight3:
      "Cada ação registra o dispositivo, a data e a hora, além do usuário ou da chave de API responsável.",
    mtrAlcatrazEyebrow: "Diagnóstico MTR",
    mtrAlcatrazTitle: "Rastreie a rota a partir do STB do assinante",
    mtrAlcatrazBody:
      "A operadora pode executar MTR (My Traceroute) a partir de um set-top box online para qualquer destino. Os resultados de MTR e iPerf3 ficam disponíveis no histórico de atividade do dispositivo, e os testes podem ser executados novamente com os parâmetros originais.",
    alcatrazAccessEyebrow: "Proteção de dispositivos",
    alcatrazAccessTitle: "Proteja STBs com bloqueio e net-lock",
    alcatrazAccessBody:
      "O Alcatraz DMS ajuda operadoras a proteger STBs alugados, equipamentos perdidos, contas com pendência de pagamento e dispositivos desativados. Bloqueie um STB ou grupo manualmente, ou use o net-lock para restringir aparelhos alugados fora das redes aprovadas da operadora.",
    alcatrazAccessFlowTitle: "Como o bloqueio é acionado",
    alcatrazAccessManualTitle: "Bloqueio manual",
    alcatrazAccessManualBody:
      "Bloqueie um STB ou um grupo inteiro quando necessário. Use para equipamentos perdidos, roubados ou desativados e para contas com pagamentos em atraso.",
    alcatrazAccessNetLockTitle: "Net-lock automático",
    alcatrazAccessNetLockBody:
      "Bloqueie automaticamente STBs alugados fora das redes aprovadas da operadora. Isso impede que os dispositivos sejam usados em conexões não autorizadas.",
    alcatrazAccessFlowOutcome: "Escolha o perfil de bloqueio",
    alcatrazAccessMockFooter: "Gerenciado pelo Alcatraz DMS",
    alcatrazAccessMockNotice: "Período de aviso",
    alcatrazAccessProfileHardTitle: "Rígido",
    alcatrazAccessProfileHardBody: "Desliga o STB e repete o bloqueio após a reinicialização.",
    alcatrazAccessModeHardBadge: "Bloqueio rígido",
    alcatrazAccessModeHardTitle: "Este dispositivo está bloqueado",
    alcatrazAccessModeHardBody:
      "O STB mostra a mensagem da operadora e depois desliga. O bloqueio se repete após reiniciar.",
    alcatrazAccessModeHardStatus: "Desliga após o aviso",
    alcatrazAccessProfileSoftTitle: "Leve",
    alcatrazAccessProfileSoftBody: "Mantém o STB em uso e mostra lembretes a cada 30 minutos.",
    alcatrazAccessModeSoftBadge: "Bloqueio leve",
    alcatrazAccessModeSoftTitle: "Aviso de serviço ativo",
    alcatrazAccessModeSoftBody:
      "O STB continua disponível enquanto o lembrete da operadora aparece no horário definido.",
    alcatrazAccessModeSoftStatus: "Lembrete a cada 30 minutos",
    alcatrazAccessProfileAppLockTitle: "Bloqueio de app",
    alcatrazAccessProfileAppLockBody: "Limita o STB a um app selecionado.",
    alcatrazAccessModeAppLockBadge: "Bloqueio de app",
    alcatrazAccessModeAppLockTitle: "Só o app aprovado está disponível",
    alcatrazAccessModeAppLockBody:
      "O STB só pode abrir o app selecionado até a operadora alterar o perfil.",
    alcatrazAccessModeAppLockStatus: "Apenas um app",
    alcatrazAccessModeAppAllowedApp: "IPTV",
    alcatrazAccessModeAppLockedLabel: "Bloqueado",
    alcatrazPushEyebrow: "Notificações push",
    alcatrazPushTitle: "Fale com os assinantes pela TV",
    alcatrazPushBody:
      "Envie banners no launcher e mensagens em toast para qualquer segmento da sua frota — para avisos de serviço, destaques de conteúdo ou campanhas de upgrade. Cada mensagem pode levar um CTA que abre um app ou uma página.",
    alcatrazPushBullet1: "Formatos launcher e toast",
    alcatrazPushBullet2: "Segmente por grupo de dispositivos, modelo ou região",
    alcatrazPushBullet3: "CTAs com deep link para dentro de um app",
    alcatrazPushBullet4: "Visualizações, cliques e CTR de cada mensagem",
    alcatrazPushPlaceholder: "Editor de notificações push",
    alcatrazApiEyebrow: "Integrações seguras · API REST",
    alcatrazApiTitle: "Conecte o Alcatraz aos sistemas existentes",
    alcatrazApiBody:
      "Crie e revogue chaves de API no console, restrinja permissões e endereços IP permitidos quando necessário, defina datas de expiração e copie com segurança o segredo de cada chave no momento da criação. IDs externos conectam os registros de dispositivos do Alcatraz a referências de assinante, CRM, billing ou residência sem alterar os fluxos existentes.",
    alcatrazApiBullet1:
      "Chaves de API gerenciadas no console, com restrições de acesso configuráveis",
    alcatrazApiBullet2: "IDs externos de dispositivos para busca, filtros e exportação",
    alcatrazApiBullet3: "TR-069 / CWMP e MQTT junto com a API REST",
    alcatrazApiPlaceholder: "Documentação da API",
    alcatrazPricingEyebrow: "Preços",
    alcatrazPricingTitle:
      "Incluído sem custo adicional para frotas com menos de 500 dispositivos ativos",
    alcatrazPricingBody:
      "Os parceiros recebem acesso ao console completo do Alcatraz Pro sem custo adicional enquanto a frota tiver menos de 500 dispositivos inext ativos. Para frotas com 500 dispositivos ativos ou mais, o acesso e as condições comerciais são definidos diretamente com a inext.",
    alcatrazPricingIncludedTitle: "Sem custo adicional · Menos de 500 dispositivos ativos",
    alcatrazPricingIncludedBody:
      "Fleet Health, gerenciamento de firmware, diagnósticos, suporte remoto e integrações seguras estão incluídos sem custo adicional quando a contagem mais recente dos últimos 30 dias mostra menos de 500 dispositivos ativos.",
    alcatrazPricingModelTitle: "500 dispositivos ativos ou mais",
    alcatrazPricingModelBody:
      "Fale com a equipe de vendas da inext para discutir acesso e condições comerciais para a implantação.",
    alcatrazPricingActiveTitle: "O que conta como dispositivo ativo",
    alcatrazPricingActiveBody:
      "O acesso é definido com base na contagem mais recente de dispositivos ativos nos últimos 30 dias. Dispositivos nestes estados não contam para o limite:",
    alcatrazPricingStateProduction: "Em produção",
    alcatrazPricingStateTransit: "Em trânsito",
    alcatrazPricingStateWarehouse: "Em estoque",
    alcatrazPricingStateRetired: "Desativados",
    alcatrazPricingCta: "Solicitar orçamento",
    alcatrazFaqEyebrow: "FAQ",
    alcatrazFaqTitle: "Dúvidas comuns",
    alcatrazFaqQ1: "Posso implantar o Alcatraz dentro da minha própria rede?",
    alcatrazFaqA1:
      "Sim. O Alcatraz DMS pode operar como um SaaS gerenciado ou como uma instalação on-premise dentro da rede fechada da operadora. Os recursos e o console são os mesmos; a operadora decide onde os dados ficam.",
    alcatrazFaqQ2: "Quais dispositivos são compatíveis?",
    alcatrazFaqA2:
      "Todo STB inext atual já vem com suporte ao Alcatraz DMS — TV5, TV5 Ultra, TV6 e TV6 Ultra. Novos modelos são adicionados conforme são lançados.",
    alcatrazFaqQ3: "Como o Alcatraz se relaciona com o TR-069?",
    alcatrazFaqA3:
      "O Alcatraz é compatível com TR-069 / CWMP, então as operadoras que já utilizam um ACS podem continuar usando-o. Além disso, o Alcatraz oferece telemetria mais detalhada, notificações push, controle remoto pelo app e uma API REST moderna.",
    alcatrazFaqQ4: "Dá para integrar com o nosso BSS / OSS?",
    alcatrazFaqA4:
      "Sim. O Alcatraz disponibiliza uma API REST documentada e oferece suporte a MQTT. Administradores podem criar e revogar chaves de API, definir permissões, limitar endereços IP de origem e estabelecer datas de expiração. IDs externos conectam os dispositivos aos registros existentes de CRM ou billing.",
    alcatrazFaqQ5: "Como funciona a precificação?",
    alcatrazFaqA5:
      "O Alcatraz Pro está incluído sem custo adicional enquanto a frota tiver menos de 500 dispositivos inext ativos. Para frotas com 500 dispositivos ativos ou mais, o acesso e as condições comerciais são definidos diretamente com a equipe de vendas da inext.",
    alcatrazFaqQ6: "O que conta como dispositivo ativo?",
    alcatrazFaqA6:
      "As configurações da empresa mostram a contagem mais recente de dispositivos ativos nos últimos 30 dias usada para definir o acesso. Aparelhos ainda em produção, em trânsito, no estoque ou já desativados não contam para o limite.",
    alcatrazFaqQ7: "Quanto tempo leva o onboarding?",
    alcatrazFaqA7:
      "Implantações em nuvem podem entrar no ar em poucos dias. Instalações on-premise levam mais tempo e dependem da equipe de infraestrutura da operadora — normalmente algumas semanas entre o início do projeto e a entrada em operação.",
    alcatrazFinalEyebrow: "Assuma o controle",
    alcatrazFinalTitle:
      "Pronto para centralizar toda a sua frota de set-top boxes em uma única plataforma?",
    alcatrazFinalBody:
      "Conte para a gente como é a sua rede e preparamos uma demonstração do Alcatraz DMS sob medida.",
    alcatrazFinalCtaSecondary: "Falar com vendas",
    navSolutionsCustomization: "Personalização e Marca",
    navSolutionsCustomizationDesc: "Hardware e software 100% white-label",
    navSolutionsRemoteAppDesc: "Controle remoto no celular para STBs inext",
    customPageSeoTitle: "Personalização, White-Label e Co-Branding — inext",
    customPageSeoDescription:
      "Deixe os set-top boxes inext com a sua cara — da simples pré-instalação de um app ao design totalmente personalizado de hardware e firmware exclusivo. White-label e co-branding para operadoras de IPTV e OTT.",
    customPageBreadcrumbHome: "Início",
    customPageBreadcrumbSolutions: "Soluções",
    customPageBreadcrumbPage: "Personalização e Marca",
    customPageHeroEyebrow: "Personalização · White-label · Co-branding",
    customPageHeroTitle: "A sua marca,",
    customPageHeroTitleAccent: "até no silício",
    customPageHeroSub:
      "Da simples pré-instalação de um app a um box totalmente personalizado rodando firmware exclusivo — fazemos o white-label e o co-branding de cada camada da plataforma inext, para que seus assinantes vejam só você.",
    customPageHeroCtaPrimary: "Falar com vendas",
    customPageHeroCtaSecondary: "Ver exemplos",
    customPageHeroStat1: "Software + hardware",
    customPageHeroStat2: "Personalização em qualquer nível",
    customPageHeroStat3: "A sua marca, não a nossa",
    customPageHeroImageAlt:
      "Engenheiros da inext personalizando um set-top box, com o design da PCB na tela",
    customPageSurfacesEyebrow: "Duas frentes, uma só identidade",
    customPageSurfacesTitle: "Software e hardware, ambos com a sua marca",
    customPageSurfacesDescription:
      "Coloque a sua marca naquilo que os assinantes usam todos os dias e no box que fica embaixo da TV. Escolha um ou os dois.",
    customPageSoftwareTag: "Software",
    customPageSoftwareTitle: "Personalização de software",
    customPageSoftwareBody:
      "Launcher, app de IPTV/OTT, app de controle remoto e interface do sistema — com novo tema, nova identidade visual e já carregados com os seus serviços.",
    customPageSoftwareBullet1:
      "Launcher, animação de inicialização e papéis de parede com a sua marca",
    customPageSoftwareBullet2: "Cliente de IPTV/OTT e EPG personalizados",
    customPageSoftwareBullet3: "Apps pré-instalados e catálogo controlado",
    customPageHardwareTag: "Hardware",
    customPageHardwareTitle: "Personalização de hardware",
    customPageHardwareBody:
      "De um adesivo com a sua marca e uma embalagem de varejo até uma carcaça, controle remoto e PCB totalmente personalizados, feitos conforme a sua especificação.",
    customPageHardwareBullet1: "Embalagem, manuais e acessórios com a sua marca",
    customPageHardwareBullet2: "Cor da carcaça, logo e layout do controle remoto personalizados",
    customPageHardwareBullet3: "PCB, portas e chipset exclusivos para pedidos de grande volume",
    customPageTiersEyebrow: "Personalização de marca em qualquer nível",
    customPageTiersTitle: "Comece simples. Vá até o fim.",
    customPageTiersDescription:
      "Escolha o nível de profundidade que combina com a sua marca e o seu orçamento — cada etapa parte da anterior.",
    customPageTiersLevelLabel: "Nível",
    customPageTier1Name: "Pré-instalação e animação de inicialização",
    customPageTier1Body:
      "Os seus apps pré-instalados nos boxes inext de fábrica, além de uma animação de inicialização com a sua marca. O caminho mais rápido para o mercado — sem uma linha de produção separada.",
    customPageTier1Tag: "Dias",
    customPageTier2Name: "Experiência com a sua marca",
    customPageTier2Body:
      "O seu launcher, animação de inicialização, papéis de parede, apps pré-instalados e configurações predefinidas. Os assinantes veem a sua marca já ao ligar o aparelho.",
    customPageTier2Tag: "Semanas",
    customPageTier3Name: "White-label completo",
    customPageTier3Body:
      "O seu nome no hardware, no firmware e em todos os apps. Sem nenhuma marca inext em lugar algum — a plataforma desaparece por trás da sua.",
    customPageTier3Tag: "Meses",
    customPageTier4Name: "Hardware e firmware personalizados",
    customPageTier4Body:
      "Um box projetado conforme a sua especificação — carcaça, controle remoto e portas personalizados e uma build de firmware mantida para a sua frota.",
    customPageTier4Tag: "Projeto",
    customPageTiersFootnote:
      "Não sabe por onde começar? Ajudamos você a dimensionar o nível certo.",
    customPagePillarsEyebrow: "O que você pode personalizar",
    customPagePillarsTitle: "Todas as camadas estão à disposição",
    customPagePillar1Title: "Embalagem e box",
    customPagePillar1Body: "Caixas de varejo, luvas, manuais e kits de acessórios com a sua marca.",
    customPagePillar2Title: "Inicialização e splash",
    customPagePillar2Body:
      "Animação de inicialização, telas de splash e sequência de desligamento com a sua marca.",
    customPagePillar3Title: "Launcher e interface inicial",
    customPagePillar3Body:
      "Tela inicial, trilhas de conteúdo, papéis de parede e ícones de apps personalizados.",
    customPagePillar4Title: "App de IPTV / OTT",
    customPagePillar4Body: "Player com a sua marca, com o seu EPG, catch-up, time-shift e VOD.",
    customPagePillar5Title: "Apps pré-instalados",
    customPagePillar5Body:
      "Os seus apps pré-instalados no box, com uma seleção de apps controlada.",
    customPagePillar6Title: "App de controle remoto",
    customPagePillar6Body:
      "Um controle remoto no celular com a sua marca, com voz, teclado e gestos.",
    customPagePillar7Title: "Firmware e AOSP",
    customPagePillar7Body:
      "Build AOSP personalizada, configurações do sistema, canal de OTA e política de segurança.",
    customPagePillar8Title: "Design de hardware",
    customPagePillar8Body:
      "Carcaça, layout do controle remoto, portas, chipset e PCB para o seu volume.",
    customPageSoftwareDeepEyebrow: "Software nas suas cores",
    customPageSoftwareDeepTitle: "Uma tela inicial que os assinantes reconhecem como sua",
    customPageSoftwareDeepBody:
      "Aplicamos um novo tema ao launcher, ao player e à interface do sistema usando a sua paleta, o seu logo e a sua tipografia — e já carregamos os apps e serviços que seus assinantes esperam. O resultado parece feito sob medida, não um Android TV genérico.",
    customPageSoftwareDeepBullet1: "Paleta, logo, ícones e tipografia",
    customPageSoftwareDeepBullet2: "Trilhas personalizadas no launcher e conteúdo em destaque",
    customPageSoftwareDeepBullet3: "Player de IPTV/OTT e EPG com a sua marca",
    customPageSoftwareDeepBullet4: "Apps pré-carregados e configurações predefinidas",
    customPageSoftwareDeepPlaceholder: "Mockups do launcher e dos apps com a sua marca",
    customPageHardwareDeepEyebrow: "Hardware com o seu nome",
    customPageHardwareDeepTitle: "De um adesivo com a sua marca a uma placa novinha em folha",
    customPageHardwareDeepBody:
      "Escolha até onde quer ir. Coloque o seu logo e a sua embalagem em um box inext já consagrado, redesenhe a carcaça e o controle remoto ou co-projete um dispositivo totalmente novo — chipset, portas e PCB inclusos — para implantações de grande volume.",
    customPageHardwareDeepBullet1: "Cor, acabamento e logo da carcaça personalizados",
    customPageHardwareDeepBullet2: "Layout e marca do controle remoto exclusivos",
    customPageHardwareDeepBullet3: "Embalagem de varejo e kits de acessórios",
    customPageHardwareDeepBullet4: "PCB, portas e chipset personalizados (volume)",
    customPageHardwareDeepPlaceholder: "Renders de hardware e embalagem personalizados",
    customPageExamplesEyebrow: "Exemplos",
    customPageExamplesTitle: "Marcas que deixaram o produto com a própria cara",
    customPageExamplesDescription:
      "Uma seleção de operadoras que vendem hardware inext sob a própria marca — de plataformas OTT globais a provedores regionais na Europa e na Ásia Central.",
    customPageExample1Name: "MEGOGO",
    customPageExample1Tag: "Ucrânia",
    customPageExample1Meta: "Desde 2012",
    customPageExample1Body:
      "Serviço OTT internacional de TV, filmes e esportes, com mais de 55 milhões de usuários por mês.",
    customPageExample2Name: "Kyivstar TV",
    customPageExample2Tag: "Ucrânia",
    customPageExample2Meta: "Desde 2018",
    customPageExample2Body:
      "Uma das maiores operadoras de telecom da Ucrânia, atendendo cerca de 24 milhões de clientes.",
    customPageExample3Name: "SWEET.TV",
    customPageExample3Tag: "Europa",
    customPageExample3Meta: "Desde 2012",
    customPageExample3Body:
      "Plataforma de TV por streaming e VOD que opera no Centro e no Leste Europeu.",
    customPageExample4Name: "ALMA TV",
    customPageExample4Tag: "Cazaquistão",
    customPageExample4Meta: "Desde 2019",
    customPageExample4Body:
      "Provedor de TV por assinatura e internet com serviço completo no Cazaquistão.",
    customPageExample5Name: "Beeline",
    customPageExample5Tag: "Cazaquistão",
    customPageExample5Meta: "Desde 2022",
    customPageExample5Body:
      "Operadora digital com 11 milhões de assinantes móveis e 2 milhões de internet residencial, parte do grupo VEON.",
    customPageExample6Name: "K@TV1",
    customPageExample6Tag: "Azerbaijão",
    customPageExample6Meta: "Desde 2023",
    customPageExample6Body:
      "Um dos maiores provedores de serviços de televisão digital do Azerbaijão.",
    customPageExample7Name: "Sarkor",
    customPageExample7Tag: "Uzbequistão",
    customPageExample7Meta: "Desde 2023",
    customPageExample7Body:
      "Um provedor de TI e telecom de referência no Uzbequistão, com mais de 25 anos de atuação.",
    customPageExample8Name: "Metroport",
    customPageExample8Tag: "Polônia",
    customPageExample8Meta: "Desde 2024",
    customPageExample8Body:
      "Um consórcio de mais de 30 provedores poloneses que atende cerca de 150.000 assinantes.",
    customPageProcessEyebrow: "Como funciona",
    customPageProcessTitle: "Do briefing aos boxes nas prateleiras",
    customPageProcessStep1Title: "Descoberta",
    customPageProcessStep1Body:
      "Mapeamos a sua marca, os volumes, os dispositivos-alvo e o nível de personalização ideal.",
    customPageProcessStep2Title: "Design",
    customPageProcessStep2Body:
      "Materiais de marca, design da interface e especificação de hardware — prototipados e aprovados.",
    customPageProcessStep3Title: "Desenvolvimento",
    customPageProcessStep3Body:
      "Implementamos firmware, apps e hardware e entregamos as unidades de teste.",
    customPageProcessStep4Title: "Certificação",
    customPageProcessStep4Body:
      "Certificações de conformidade, de loja e de segurança conforme o seu mercado exigir.",
    customPageProcessStep5Title: "Entrega",
    customPageProcessStep5Body:
      "Produção em massa, provisionamento e suporte OTA contínuo via Alcatraz DMS.",
    customPageFaqEyebrow: "FAQ",
    customPageFaqTitle: "Perguntas frequentes",
    customPageFaqQ1: "Qual é a diferença entre co-branding e white-label?",
    customPageFaqA1:
      "O co-branding une a sua marca à inext no mesmo hardware e na mesma interface. O white-label remove a inext por completo — o seu nome no box, no firmware e em todos os apps.",
    customPageFaqQ2: "Qual é o pedido mínimo para hardware personalizado?",
    customPageFaqA2:
      "A pré-instalação de apps e o co-branding têm pedido mínimo baixo ou nenhum. Carcaças, controles remotos e PCBs personalizados dependem do volume — confirmamos os MOQs durante a fase de descoberta.",
    customPageFaqQ3: "Vocês conseguem desenvolver um firmware totalmente personalizado?",
    customPageFaqA3:
      "Sim. Mantemos builds AOSP personalizadas com as suas configurações de sistema, política de segurança e um canal de OTA dedicado, com suporte de longo prazo.",
    customPageFaqQ4: "Vocês projetam hardware novo do zero?",
    customPageFaqA4:
      "Para os volumes certos, sim — carcaça, controle remoto, portas, chipset e PCB personalizados, co-projetados com a nossa equipe de hardware.",
    customPageFaqQ5: "Como as atualizações são feitas depois do lançamento?",
    customPageFaqA5:
      "Os dispositivos com a sua marca são gerenciados pelo Alcatraz DMS — telemetria, firmware OTA em etapas, controle remoto e notificações push.",
    customPageFaqQ6: "Quanto tempo leva?",
    customPageFaqA6:
      "A pré-instalação e o co-branding podem ser entregues em dias; uma interface com a sua marca, em semanas; o hardware personalizado segue um cronograma de projeto que definimos juntos.",
    customPageFinalEyebrow: "Deixe com a sua cara",
    customPageFinalTitle: "Pronto para colocar a sua marca nele?",
    customPageFinalBody:
      "Conte para a gente qual é a sua marca, os seus volumes e até onde você quer ir — vamos traçar o caminho de personalização ideal.",
    customPageFinalCta: "Falar com vendas",
    customPageFinalCtaSecondary: "Solicitar demonstração",
    navAccessories: "Acessórios",
    accessoriesSeoTitle: "Acessórios inext — Controles Remotos, Cabos e Fontes",
    accessoriesSeoDescription:
      "Conheça os acessórios opcionais para os boxes Android TV da inext. Controles remotos programáveis oficiais, cabos AV analógicos, fontes de alimentação e receptores IR externos.",
    accessoriesTitle: "Controles remotos, cabos e energia",
    accessoriesSubtitle: "Acessórios oficiais e peças de reposição para set-top boxes inext.",
    accessoriesHeroEyebrow: "Acessórios opcionais",
    accessoriesFilterAll: "Todos os acessórios",
    accessoriesFilterRemotes: "Controles remotos",
    accessoriesFilterCables: "Cabos e adaptadores",
    accessoriesFilterPower: "Fontes de alimentação",
    accessoriesFilterSensors: "Sensores IR",
    accessoriesSpecsTab: "Especificações",
    accessoriesFeaturesTab: "Recursos",
    accessoriesProgrammingTab: "Instruções de programação",
    accessoriesBackToList: "Voltar para acessórios",
    accessoriesVideoGuide: "Guia em vídeo",
    accessoriesAppBullet1: "Disponível para Android e iOS — grátis",
    accessoriesAppBullet2: "Funciona por Wi-Fi — não precisa de linha de visão",
    accessoriesAppBullet3: "Busca por voz e teclado na tela",
    accessoriesAppCta: "Saiba mais sobre o app",
    footerLinkAccessories: "Acessórios",
    productMenuAccessoriesDesc: "Controles, cabos e fontes de alimentação",
    footerLinkArchive: "Modelos legados",
    archiveSeoTitle: "Set-Top Boxes Legados da inext — Modelos Descontinuados",
    archiveSeoDescription:
      "Um arquivo dos set-top boxes Android e Linux descontinuados da inext, do HD1 de 2011 aos boxes 4K com Allwinner e Amlogic. Fotos e especificações completas de cada modelo antigo.",
    archiveTitle: "Modelos legados",
    archiveHeroEyebrow: "Arquivo de produtos",
    archiveSubtitle:
      "Todos os set-top boxes inext que lançamos desde 2011. Esses modelos foram descontinuados — mantidos aqui com fotos e especificações completas para referência.",
    archiveViewSpecs: "Ver especificações",
    archiveBadge: "Descontinuado",
    archiveSpecsHeading: "Especificações",
    iptvAppSeoTitle: "App de IPTV para Operadoras — Cliente White-Label para STBs inext",
    iptvAppSeoDescription:
      "App de IPTV pronto para STBs inext: M3U + XMLTV, Stalker/Ministra, TVIP e outros portais. Personalização white-label e configurações pré-definidas — lance mais rápido.",
    iptvAppBreadcrumbHome: "Início",
    iptvAppBreadcrumbSolutions: "Soluções",
    iptvAppBreadcrumbPage: "Aplicativo de IPTV",
    iptvAppHeroEyebrow: "Software cliente · STBs inext",
    iptvAppHeroTitle: "Não precisa desenvolver um app de TV —",
    iptvAppHeroTitleAccent: "lance o nosso, com a sua marca",
    iptvAppHeroSub:
      "Um cliente de IPTV pronto para set-top boxes inext. Aplicamos a sua marca, configuramos para o seu middleware ou as suas playlists e entregamos pré-instalado — para que os assinantes assistam à TV assim que ligam o box.",
    iptvAppHeroStat1: "Mais de 3 famílias de portais",
    iptvAppHeroStat2: "100% white-label",
    iptvAppHeroStat3: "Ativação zero-touch para o assinante",
    iptvAppHeroCtaDemo: "Solicitar demonstração",
    iptvAppHeroCtaSales: "Falar com vendas",
    iptvAppModesEyebrow: "Modos de backend",
    iptvAppModesTitle: "Funciona com o backend que você já usa",
    iptvAppModesDescription:
      "Sem migração, sem novo middleware. Um app que se adapta ao seu headend atual — escolha o modo que combina com a sua infraestrutura.",
    iptvAppMode1Title: "Playlists M3U + EPG XMLTV",
    iptvAppMode1Body:
      "A maneira mais simples de colocar os seus canais na tela. Aponte o app para uma playlist e um feed de EPG — os assinantes ganham uma interface nativa e rápida, com dados completos da programação.",
    iptvAppMode1Bullet1: "Playlists M3U com categorias e logos de canais",
    iptvAppMode1Bullet2: "EPG XMLTV dia a dia, com agora/a seguir em cada canal",
    iptvAppMode1Bullet3: "Seleção de múltiplas faixas de áudio durante a reprodução",
    iptvAppMode1Bullet4: "Proxy UDP-para-HTTP integrado para redes multicast",
    iptvAppMode2Title: "Middleware Stalker / Ministra",
    iptvAppMode2Body:
      "O app exibe o seu portal Stalker ou Ministra real — TV, VideoClub, gravações e favoritos — com um perfil de STB configurável e um overlay de player nativo por cima.",
    iptvAppMode2Bullet1: "Renderização completa do portal com tipo de STB configurável (ex.: MAG)",
    iptvAppMode2Bullet2: "TV ao vivo, VideoClub / VOD, favoritos e gravações",
    iptvAppMode2Bullet3:
      "Overlay de player nativo: faixas de áudio, legendas, zoom, teclado virtual",
    iptvAppMode2Bullet4:
      "URL do portal e configurações de reprodução pré-definidas para o seu serviço",
    iptvAppMode3Title: "TVIP, Hibox, Aura e outros portais web",
    iptvAppMode3Body:
      "O seu portal com a marca da operadora vira toda a experiência de TV — launcher, guia de programação, catch-up e gravações inclusos. Outros middlewares web podem ser adicionados sob demanda.",
    iptvAppMode3Bullet1: "Launchers com a marca da operadora exibidos exatamente como projetados",
    iptvAppMode3Bullet2: "Grade completa do guia de programação com EPG detalhado",
    iptvAppMode3Bullet3: "Catch-up de TV e gravações",
    iptvAppMode3Bullet4: "A mesma abordagem de simulador se estende a outros portais web",
    iptvAppWhiteLabelEyebrow: "White-label e pré-configuração",
    iptvAppWhiteLabelTitle: "A sua marca na tela, as suas configurações já embutidas",
    iptvAppWhiteLabelBody:
      "Personalizamos o app com o seu logo, as suas cores e o nome do app, e pré-carregamos a URL do seu portal, a playlist e a fonte de EPG. Os boxes chegam prontos para o assinante — é só conectar e assistir.",
    iptvAppWhiteLabelBullet1: "O seu logo, as suas cores e o nome do app",
    iptvAppWhiteLabelBullet2: "URL do portal, playlist e fonte de EPG pré-carregadas",
    iptvAppWhiteLabelBullet3:
      "Configurações bloqueadas ou abertas — você decide o que o assinante pode mudar",
    iptvAppWhiteLabelBullet4: "Entregue pré-instalado em STBs inext",
    iptvAppPillarsEyebrow: "Recursos",
    iptvAppPillarsTitle: "Tudo o que os assinantes esperam desde o primeiro dia",
    iptvAppPillar1Title: "EPG completo",
    iptvAppPillar1Body:
      "Guia de programação dia a dia, vindo do XMLTV ou do seu middleware, com agora/a seguir em cada canal.",
    iptvAppPillar2Title: "Categorias e logos",
    iptvAppPillar2Body:
      "Listas de canais organizadas, com categorias por gênero e logos de canais para zapear rápido.",
    iptvAppPillar3Title: "Múltiplos áudios e legendas",
    iptvAppPillar3Body: "Seleção de faixa de áudio e legendas direto no overlay do player.",
    iptvAppPillar4Title: "Compatível com multicast",
    iptvAppPillar4Body:
      "Proxy UDP-para-HTTP integrado reproduz streams multicast sem hardware extra.",
    iptvAppPillar5Title: "UX pensada para o controle remoto",
    iptvAppPillar5Body:
      "Zapeamento numérico, teclas coloridas e teclado virtual — feito para o controle remoto na mão.",
    iptvAppPillar6Title: "Interface multilíngue",
    iptvAppPillar6Body:
      "Interface localizada para o seu mercado, que pode ser trocada em cada dispositivo.",
    iptvAppProcessEyebrow: "Como funciona",
    iptvAppProcessTitle: "Três passos até boxes prontos para o assinante",
    iptvAppProcessStep1Title: "Conte o seu backend e a sua marca",
    iptvAppProcessStep1Body:
      "Detalhes do middleware ou da playlist, logo, cores — um briefing curto.",
    iptvAppProcessStep2Title: "Aplicamos a marca, pré-configuramos e testamos",
    iptvAppProcessStep2Body:
      "A sua build é personalizada, carregada com as suas configurações e verificada em STBs inext.",
    iptvAppProcessStep3Title: "Os boxes chegam prontos para o assinante",
    iptvAppProcessStep3Body:
      "Os assinantes conectam e assistem — as atualizações são gerenciadas de forma centralizada.",
    iptvAppEcosystemEyebrow: "Ecossistema",
    iptvAppEcosystemTitle: "Parte do stack de operadora da inext",
    iptvAppEcosystemBody:
      "Combine o app com os set-top boxes inext e o Alcatraz DMS — hardware, software cliente e gerenciamento de frota de um só fornecedor.",
    iptvAppEcosystemLinkStb: "Conheça os STBs inext",
    iptvAppEcosystemLinkAlcatraz: "Descubra o Alcatraz DMS",
    iptvAppFaqEyebrow: "FAQ",
    iptvAppFaqTitle: "Perguntas frequentes",
    iptvAppFaqQ1: "Quais middlewares são compatíveis?",
    iptvAppFaqA1:
      "Stalker / Ministra, TVIP, Hibox e Aura de fábrica, além de playlists M3U simples com EPG XMLTV. Em geral, outros portais baseados na web podem ser adicionados — fale com a gente sobre o seu.",
    iptvAppFaqQ2: "Vocês conseguem aplicar a nossa marca e bloquear as configurações?",
    iptvAppFaqA2:
      "Sim. Entregamos o app com o seu logo, as suas cores e o seu nome, pré-configuramos as opções de portal e reprodução e podemos bloqueá-las para que o assinante não estrague a configuração — ou deixá-las abertas.",
    iptvAppFaqQ3: "Funciona sem middleware (M3U simples)?",
    iptvAppFaqA3:
      "Sim. No modo M3U o app só precisa de uma URL de playlist e, opcionalmente, de um feed XMLTV — você ainda tem categorias, logos, um EPG completo e múltiplos áudios.",
    iptvAppFaqQ4: "Com que rapidez conseguimos lançar?",
    iptvAppFaqA4:
      "Semanas, não meses. A aplicação da marca e a pré-configuração levam dias; a maior parte do cronograma é o teste na sua rede e o envio dos boxes.",
    iptvAppFinalEyebrow: "Lance mais rápido",
    iptvAppFinalTitle: "O seu app de TV já está pronto —",
    iptvAppFinalTitleAccent: "vamos deixá-lo com a sua cara",
    iptvAppFinalBody:
      "Conte para a gente sobre o seu backend e a sua marca e preparamos uma build de demonstração pré-configurada para o seu serviço.",
    iptvAppFinalCta: "Solicitar demonstração",
    iptvAppFinalCtaSecondary: "Falar com vendas",
    iptvAppAltNativePlayer:
      "App de IPTV da inext reproduzindo esportes ao vivo com overlay de player e EPG agora/a seguir",
    iptvAppAltNativeEpg:
      "Lista de canais com linha do tempo de EPG do dia inteiro na interface IPTV nativa",
    iptvAppAltNativeCategories:
      "Barra lateral de categorias com logos de canais e informações de programa agora/a seguir",
    iptvAppAltNativeSetup:
      "Tela de configuração oferecendo uma lista de canais M3U ou um portal Stalker",
    iptvAppAltNativeAudio: "Menu de seleção de faixa de áudio sobre o vídeo ao vivo",
    iptvAppAltStalkerHome: "Tela inicial do portal Stalker / Ministra com seções de TV e VideoClub",
    iptvAppAltStalkerChannels:
      "Lista de canais do portal Stalker com pré-visualização ao vivo e EPG",
    iptvAppAltStalkerSettings:
      "Tela de configurações com URL do portal e seleção de tipo de STB MAG",
    iptvAppAltStalkerPlayerMenu:
      "Barra de ferramentas do player com controles de portal, áudio, legendas, zoom e teclado",
    iptvAppAltTvipHome: "Tela inicial do launcher estilo TVIP com a marca da operadora",
    iptvAppAltTvipChannels:
      "Lista de canais em várias colunas com detalhes da programação em um portal estilo TVIP",
    iptvAppAltTvipEpg: "Grade completa do guia de programação com detalhes dos programas",
    navSolutionsIptvApp: "Aplicativo de IPTV",
    navSolutionsIptvAppDesc: "Cliente de TV white-label para STBs inext",
    footerLinkIptvApp: "Aplicativo de IPTV",
    navSolutionsOta: "Atualizações OTA",
    navSolutionsOtaDesc: "Entrega de firmware e apps em etapas",
    footerLinkOta: "Gestão de atualizações OTA",
    otaBreadcrumbHome: "Início",
    otaBreadcrumbSolutions: "Soluções",
    otaBreadcrumbPage: "Gestão de atualizações OTA",
    otaSeoTitle:
      "Gestão de atualizações OTA inext — atualizações em etapas para frotas de STBs inext",
    otaSeoDescription:
      "Teste, aprove, distribua em etapas, entregue e monitore firmware em frotas de STBs inext, com suporte a atualizações de aplicativos. Mais de 1 milhão de atualizações OTA entregues pela plataforma inext.",
    otaHeroEyebrow: "Gestão de atualizações OTA",
    otaHeroTitle: "O firmware certo — para o dispositivo certo.",
    otaHeroTitleAccent: "Com segurança. Em qualquer escala.",
    otaHeroSub:
      "Teste, aprove, distribua e monitore firmware dos STBs inext em uma única plataforma — do dispositivo de QA a uma frota nacional.",
    otaHeroCtaDemo: "Solicitar uma demo",
    otaHeroCtaSales: "Conversar sobre a implantação",
    otaHeroPlatformNote: "A gestão de atualizações OTA faz parte da plataforma inext",
    otaHeroStat1: "Implantações em etapas de 1% a 100%",
    otaHeroStat2: "Entrega orientada por região e operadora",
    otaHeroStat3: "Nuvem ou instalação local",
    otaHeroDiagramTitle: "Solicitação de atualização",
    otaHeroDiagramSubRunning: "Avaliando para o dispositivo…",
    otaHeroDiagramSubDone: "Atualização concluída",
    otaHeroDiagramStep1: "Modelo · placa · versão instalada",
    otaHeroDiagramStep2: "Segmentação · agenda · percentual da implantação",
    otaHeroDiagramStep3: "Nó de armazenamento disponível mais próximo",
    otaHeroDiagramOutcome: "Link de download seguro e verificado",
    otaHeroDiagramDownloading: "Baixando o firmware para o STB…",
    otaHeroDiagramInstalling: "Instalando o firmware no STB…",
    otaHeroDiagramInstalled: "Firmware instalado com sucesso",
    otaReleaseEyebrow: "Fluxo controlado",
    otaReleaseTitle: "Do build testado à implantação controlada",
    otaReleaseDescription:
      "Cada release passa por etapas claras de teste, aprovação, implantação e monitoramento. Comentários com acesso por perfil mantêm as discussões no contexto da build ou do release correspondente.",
    otaReleaseCard1Title: "Ofereça a cada dispositivo apenas firmware compatível",
    otaReleaseCard1Body:
      "Antes de oferecer uma atualização, cada solicitação é verificada por modelo, placa, versão instalada, operadora, política do release e disponibilidade do arquivo.",
    otaReleaseCard2Title: "Defina a meta da implantação",
    otaReleaseCard2Body:
      "Comece com um pequeno grupo piloto, analise a adoção e depois expanda para toda a frota. Pause ou reduza a meta sem perder o progresso.",
    otaReleaseCard4Title: "Teste em dispositivos selecionados",
    otaReleaseCard4Body:
      "Valide o build em dispositivos internos ou em campo antes que ele possa ser distribuído publicamente.",
    otaReleaseCard6Title: "Aprove o release público",
    otaReleaseCard6Body:
      "Separe permissões de teste e de release público para que somente usuários autorizados possam levar o firmware à produção.",
    otaRolloutEyebrow: "Controles do release",
    otaRolloutTitle: "Segmentação precisa. Risco contido.",
    otaRolloutBody:
      "Verificações de compatibilidade e controles percentuais de implantação reduzem significativamente o risco do release e mantêm cada expansão sob controle da operadora.",
    otaRolloutMeterLabel: "Meta da implantação",
    otaRolloutMeterStage1: "Teste interno",
    otaRolloutMeterStage2: "Grupo piloto",
    otaRolloutMeterStage3: "Expansão",
    otaRolloutMeterStage4: "Frota completa",
    otaGovernEyebrow: "Controle de acesso",
    otaGovernTitle: "As regras de aprovação permanecem explícitas",
    otaGovernBody:
      "Permissões baseadas em perfil separam teste, aprovação, controle da implantação e acesso aos comentários de firmware, mantendo as decisões de produção claramente controladas.",
    otaGovernPerm3: "Criar releases de teste",
    otaGovernPerm4: "Aprovar distribuição pública",
    otaGovernPerm5: "Criar e alterar políticas de implantação",
    otaGovernPerm6: "Iniciar, pausar ou retomar releases",
    otaGovernPerm7: "Opções avançadas de releases privados",
    otaDeliveryEyebrow: "Entrega global",
    otaDeliveryTitle: "Entrega resiliente de firmware orientada por região",
    otaDeliveryDescription:
      "O firmware é distribuído por nós de armazenamento aprovados e escolhidos por regras configuráveis de roteamento, mantendo o tráfego perto da frota e a política regional sob controle da operadora.",
    otaDeliveryCard1Title: "Roteie por localização, operadora e capacidade",
    otaDeliveryCard1Body:
      "Selecione o nó aprovado mais próximo que tenha o firmware e capacidade livre para outro download.",
    otaDeliveryCard2Title: "Use fallback somente quando a política permitir",
    otaDeliveryCard2Body:
      "Se um nó regional estiver indisponível ou cheio, um fallback global verificado poderá assumir o tráfego sem ignorar as regras de entrega.",
    otaDeliveryCard3Title: "Verifique cada download",
    otaDeliveryCard3Body:
      "Links temporários protegem os detalhes de roteamento e armazenamento, enquanto tamanho e checksum validam o arquivo antes da instalação.",
    otaDiagramEyebrow: "Como um release chega ao dispositivo",
    otaDiagramTitle: "O caminho da entrega OTA",
    otaDiagramNode1: "Interface de gerenciamento e APIs",
    otaDiagramNode2: "Camada de controle por funções",
    otaDiagramNode3: "Mecanismo de seleção de firmware",
    otaDiagramNode4: "Orquestrador de entrega OTA",
    otaDiagramNode5: "Nós de armazenamento regionais ou locais",
    otaDiagramNode6: "Armazenamento global de fallback",
    otaDiagramNode7: "Frota de STBs inext",
    otaDiagramNode8: "Telemetria de download e adoção",
    otaDiagramReturnLabel: "A telemetria retorna à plataforma",
    otaDeployEyebrow: "Sua infraestrutura",
    otaDeployTitle: "Implante na nuvem, localmente ou de forma híbrida",
    otaDeployDescription:
      "Use a entrega em nuvem da inext, instale nós de armazenamento na sua rede ou execute toda a plataforma localmente.",
    otaDeployCloudTag: "Recomendado",
    otaDeployCloudTitle: "Nuvem (SaaS)",
    otaDeployCloudBody:
      "Hospedado e operado pela inext. Inicialização mais rápida, atualizações automáticas da plataforma e entrega geodistribuída desde o primeiro dia.",
    otaDeployCloudBullet1: "Nenhuma infraestrutura para manter",
    otaDeployCloudBullet2: "Nós globais de armazenamento incluídos",
    otaDeployCloudBullet3: "Atualizações automáticas da plataforma",
    otaDeployOnpremTitle: "Instalação local",
    otaDeployOnpremBody:
      "Backend, interface web e nós de armazenamento dentro da sua rede, para operadoras com requisitos rigorosos de residência de dados ou segurança.",
    otaDeployOnpremBullet1: "Os arquivos de firmware permanecem na sua rede",
    otaDeployOnpremBullet2: "Armazenamento de objetos compatível com S3",
    otaDeployOnpremBullet3: "Controle da capacidade e da topologia",
    otaDeployNodeTitle:
      "Precisa de atualizações mais rápidas? Adicione um nó de armazenamento dedicado",
    otaDeployNodeBody:
      "Um servidor de armazenamento pode operar dentro da sua rede independentemente de onde a plataforma esteja hospedada. A inext o configura remotamente, replica o firmware e o conecta à rede de entrega em poucos dias.",
    otaDeployNodeChip1: "Funciona com nuvem ou instalação local",
    otaDeployNodeChip2: "Provisionado remotamente pela inext",
    otaDeployNodeChip3: "Ativo em dias, não semanas",
    otaMonitorEyebrow: "Visibilidade operacional",
    otaMonitorTitle: "Acompanhe o progresso no console real",
    otaMonitorDescription:
      "Monitore a adoção do rollout e o estado da distribuição, e abra eventos OTA por dispositivo na linha do tempo de atividade quando uma análise for necessária.",
    otaMonitorCard1Title: "Monitore e expanda",
    otaMonitorCard1Body:
      "Compare a adoção com os dispositivos ativos e com a meta atual antes de expandir.",
    otaMonitorCard2Title: "Telemetria de download",
    otaMonitorCard2Body:
      "Analise métricas detalhadas de download e instalação por build, tipo de dispositivo, nó, região e evento individual do dispositivo.",
    otaMonitorCard4Title: "Notificações automáticas",
    otaMonitorCard4Body:
      "Avise os responsáveis pelo release quando a implantação atingir a meta atual e estiver pronta para revisão.",
    otaMonitorMetricsNote:
      "As métricas de infraestrutura são exportadas em formato compatível com plataformas padrão de monitoramento, como Prometheus e Grafana.",
    otaMigrateEyebrow: "Migração de frota",
    otaMigrateTitle: "Migre uma frota genérica para o seu próprio branch de firmware",
    otaMigrateBody:
      "Operadoras que começaram com firmware genérico podem migrar dispositivos implantados para um branch dedicado com a própria marca via OTA, incluindo o bootloader, sem visitas técnicas nem troca de hardware.",
    otaMigrateBullet1: "Migração de dispositivos implantados para um branch próprio",
    otaMigrateBullet2: "Conversão completa da imagem, incluindo o bootloader",
    otaMigrateBullet3: "Sem visitas em campo, devoluções ou troca de hardware",
    otaApiEyebrow: "Pronto para integração",
    otaApiTitle: "Conecte o OTA à sua stack operacional",
    otaApiBody:
      "Use chaves de API de autoatendimento com permissões limitadas para integrar builds, aprovações, estado dos dispositivos e adoção da implantação às ferramentas atuais de suporte e relatórios.",
    otaApiPanelTitle: "API Alcatraz",
    otaApiPanelSub: "REST · documentada · tokens com escopo",
    otaAppsEyebrow: "Entrega de aplicativos",
    otaAppsTitle: "Entregue atualizações de aplicativos, não só firmware",
    otaAppsBody:
      "Além do firmware, a plataforma pode distribuir atualizações de aplicativos para STBs compatíveis — reutilizando a mesma rede de entrega e os controles de implantação em etapas. As opções disponíveis dependem de como o aplicativo está integrado.",
    otaAppsBullet1: "Mesma rede de entrega e implantação em etapas",
    otaAppsBullet2: "Para STBs compatíveis e aplicativos integrados",
    otaStatRolloutValue: "1M+",
    otaStatRolloutLabel: "de atualizações OTA entregues pela plataforma inext",
    otaStatScaleValue: "1% → 100%",
    otaStatScaleLabel: "Controle de implantação em etapas, do grupo piloto à frota completa",
    otaStatDeliveryValue: "Roteamento geográfico",
    otaStatDeliveryLabel: "Roteamento por país, operadora e capacidade atual do nó",
    otaStatDeployValue: "Nuvem · Local",
    otaStatDeployLabel: "Execute na nossa nuvem ou totalmente dentro da sua rede",
    otaTargetChipsLabel: "Segmentar por",
    otaTargetChip1: "Modelo e placa do STB",
    otaTargetChip2: "Versão de firmware instalada",
    otaTargetChip3: "ISP / operadora",
    otaTargetChip4: "Lista de MAC permitidos",
    otaTargetChip5: "Grupo de teste",
    otaTargetChip6: "Elegibilidade para atualização automática",
    otaFaqEyebrow: "FAQ",
    otaFaqTitle: "Perguntas frequentes",
    otaFaqQ1: "O OTA faz parte do Alcatraz DMS?",
    otaFaqA1:
      "As atualizações de firmware OTA são entregues pela plataforma inext Alcatraz, com o mesmo backend, console e permissões. Para quem já usa o Alcatraz DMS, é a parte do mesmo sistema responsável pela entrega de firmware.",
    otaFaqQ2: "O OTA pode operar dentro da rede da operadora?",
    otaFaqA2:
      "Sim. Os nós de armazenamento podem operar na sua infraestrutura e toda a plataforma, incluindo backend e interface web, pode ser instalada localmente. Os nós suportam armazenamento de objetos compatível com S3.",
    otaFaqQ3: "Como as implantações em etapas reduzem o risco?",
    otaFaqA3:
      "O release é entregue a um percentual definido da frota, a adoção é monitorada entre dispositivos ativos e a expansão só ocorre após a revisão. A meta pode ser pausada, retomada ou reduzida, e uma notificação é enviada quando cada etapa termina.",
    otaFaqQ4: "O que acontece se um nó regional estiver indisponível ou cheio?",
    otaFaqA4:
      "O roteamento considera a capacidade. Se um nó regional aprovado estiver indisponível ou cheio, o tráfego pode passar para um nó global quando a política permitir. A atualização só é oferecida quando existe um caminho de entrega verificado.",
    otaFaqQ5: "É possível forçar uma atualização crítica de segurança?",
    otaFaqA5:
      "Sim. O release pode ser marcado como obrigatório para que o usuário não possa ignorá-lo, e as regras do caminho de atualização garantem a instalação de qualquer firmware intermediário necessário antes de avançar para um build mais recente.",
    otaFaqQ6: "Como é verificado se o dispositivo recebeu o firmware correto?",
    otaFaqA6:
      "Os metadados do firmware incluem o tamanho do arquivo e o checksum, permitindo que o STB valide o arquivo baixado antes da instalação. Os dispositivos também enviam telemetria de download para a plataforma.",
    otaFaqQ7: "O sistema pode entregar atualizações de aplicativos?",
    otaFaqA7:
      "Sim. O sistema foi desenvolvido principalmente para gerenciar o ciclo de vida do firmware, mas também pode distribuir atualizações de aplicativos para STBs compatíveis. Os controles disponíveis dependem da integração do aplicativo e dos requisitos de implantação.",
    otaFinalEyebrow: "Pronto para planejar uma implantação mais segura?",
    otaFinalTitle: "Veja a gestão de atualizações OTA em ação",
    otaFinalBody:
      "Percorra com a equipe da inext as etapas de teste, aprovação, implantação e monitoramento usando um cenário real da sua frota.",
    otaFinalCta: "Agendar uma demo de OTA",
    otaFinalCtaSecondary: "Conversar sobre a implantação",
    otaLiveLabel: "Ao vivo",
    otaUiTestTitle: "Teste",
    otaUiTestBody: "Envie este firmware para um ou mais dispositivos para teste.",
    otaUiTestAction: "Criar release de teste",
    otaUiConfirmTitle: "Confirmação",
    otaUiConfirmBody:
      "Marque o firmware como pronto para release público. Um build confirmado poderá então ser usado em um release público.",
    otaUiConfirmAction: "Confirmar firmware",
    otaUiReleaseTitle: "Release",
    otaUiReleaseBody: "Configure a data, a hora e o percentual de implantação do build aprovado.",
    otaUiReleaseAction: "Criar release público",
    otaUiLiveBody: "Ative ou desative o release a qualquer momento.",
    otaUiMandatoryTitle: "Obrigatória",
    otaUiMandatoryBody: "Os usuários não podem recusar esta atualização.",
    otaUiResetTitle: "Redefinir após a atualização",
    otaUiResetBody: "Restaure os dispositivos para as configurações de fábrica após a instalação.",
    otaUiStagedTitle: "Implantação em etapas",
    otaUiStagedBody:
      "Entregue este firmware a um percentual controlado de dispositivos compatíveis.",
    otaUiInteractiveLabel: "Prévia interativa",
    otaUiCompletedAction: "Concluído",
    otaUiWorkingAction: "Processando…",
    otaUiWorkflowComplete: "Aprovado e pronto para implantação em etapas",
    otaUiReplayAction: "Executar novamente",
    otaUiApproximately: "aproximadamente",
    otaUiEligibleDevices: "dispositivos compatíveis",
    otaAdvancedEyebrow: "Recursos avançados",
    otaAdvancedTitle: "Amplie o OTA além da implantação padrão",
    otaAdvancedBody:
      "Migre frotas existentes para um branch de firmware com marca própria e conecte as operações de release às demais ferramentas da operadora.",
    worldwideEyebrow: "Entrega em todo o mundo",
    worldwideHeadline: "Fabricado na Ásia. Entregamos em qualquer lugar.",
    worldwideSub:
      "Dos parceiros de fabricação em Shenzhen e Taiwan — a operadoras na Europa, Ásia Central, Américas e além. Embalagem, desembaraço aduaneiro e coordenação de entrega — tudo incluído.",
    worldwideOriginLabel: "China e Taiwan",
    worldwideStat1Value: "700K+",
    worldwideStat1Label: "dispositivos enviados",
    worldwideStat3Label: "modos de envio",
    worldwideCta: "Como enviamos",
    navSolutionsLogistics: "Logística Global",
    navSolutionsLogisticsDesc: "Entrega B2B de hardware no mundo todo",
    footerLinkLogistics: "Logística Global",
    logisticsSeoTitle: "Logística Global — Entrega B2B de Hardware no Mundo Todo",
    logisticsSeoDescription:
      "Entrega B2B de hardware inext dos parceiros de fabricação em Shenzhen, Guangzhou e Taiwan para operadoras e distribuidoras no mundo todo — por via aérea, marítima e terrestre, com courier expresso para amostras.",
    logisticsBreadcrumb: "Logística Global",
    logisticsHeroEyebrow: "Logística B2B global",
    logisticsHeroTitle: "Da produção ao",
    logisticsHeroTitleAccent: "seu armazém",
    logisticsHeroSub:
      "Produzimos set-top boxes com parceiros consolidados na China e em Taiwan e coordenamos a entrega para operadoras, distribuidoras e armazéns empresariais no mundo todo. Um único ponto de contato acompanha cada envio B2B.",
    logisticsHeroCtaPrimary: "Planejar um envio",
    logisticsHeroCtaSecondary: "Encontrar um distribuidor",
    logisticsHeroChip1: "Entrega B2B no mundo todo",
    logisticsHeroChip2: "Produzido na China e em Taiwan",
    logisticsHeroChip3: "Embalagem personalizada e pronta para venda",
    logisticsHeroStage1: "Produção",
    logisticsHeroStage2: "Marca e embalagem",
    logisticsHeroStage3: "Frete",
    logisticsHeroStage4: "Alfândega e entrega",
    logisticsGlobeHubLabel: "Polo de fabricação",
    logisticsGlobeRouteLabel: "Rota de entrega",
    logisticsGlobeCaption:
      "Rotas B2B da China e de Taiwan para Kyiv, Bratislava, São Paulo e Almaty, com distribuição a partir de Bratislava para Varsóvia e Hungria.",
    logisticsHubShenzhen: "Shenzhen",
    logisticsHubGuangzhou: "Guangzhou",
    logisticsHubTaiwan: "Taiwan",
    logisticsStat1Value: "700K+",
    logisticsStat1Label: "dispositivos entregues no mundo todo",
    logisticsStat2Value: "15+",
    logisticsStat2Label: "países atendidos",
    logisticsStat3Value: "3",
    logisticsStat3Label: "polos de fabricação na China e em Taiwan",
    logisticsStat4Value: "4",
    logisticsStat4Label: "opções de frete — aéreo, marítimo, terrestre e courier para amostras",
    logisticsMakeEyebrow: "Onde é fabricado",
    logisticsMakeTitle: "Produzido em polos de fabricação comprovados",
    logisticsMakeBody:
      "Nossos set-top boxes são produzidos com parceiros de fabricação e fornecimento em duas das principais regiões de eletrônicos do mundo. Manter a produção perto da cadeia de fornecimento de componentes garante alta qualidade, prazos de entrega curtos e custos previsíveis.",
    logisticsMakeCard1Title: "Shenzhen, China",
    logisticsMakeCard1Tag: "Montagem e embalagem",
    logisticsMakeCard1Body:
      "Montagem final, gravação de firmware, controle de qualidade e embalagem — incluindo caixas com a marca da operadora e prontas para o varejo.",
    logisticsMakeCard2Title: "Guangzhou, China",
    logisticsMakeCard2Tag: "Placas e componentes",
    logisticsMakeCard2Body:
      "Produção de placas e fornecimento de componentes, com o respaldo da densa cadeia de fornecimento do Delta do Rio das Pérolas para entregas ágeis.",
    logisticsMakeCard3Title: "Taiwan",
    logisticsMakeCard3Tag: "Chips e módulos",
    logisticsMakeCard3Body:
      "Chipsets e módulos essenciais de fornecedores taiwaneses consolidados — o silício por trás das plataformas em que nosso hardware roda.",
    logisticsFlowEyebrow: "Da produção à implantação",
    logisticsFlowTitle: "Um caminho coordenado até a sua operação",
    logisticsFlowBody:
      "Produção, embalagem, frete e alfândega avançam em um único plano, com um contato dedicado coordenando cada etapa.",
    logisticsFlowStep1Title: "Produção e controle de qualidade",
    logisticsFlowStep1Body:
      "Os dispositivos são montados e testados individualmente e, em seguida, recebem a gravação do seu build de firmware antes de saírem da linha.",
    logisticsFlowStep2Title: "Personalizar e embalar",
    logisticsFlowStep2Body:
      "As caixas são embaladas em embalagem neutra ou totalmente personalizada, pronta para o varejo e adequada ao seu mercado.",
    logisticsFlowStep3Title: "Enviar e desembaraçar na alfândega",
    logisticsFlowStep3Body:
      "Contratamos a transportadora certa para o seu prazo e orçamento e preparamos a documentação de exportação e desembaraço aduaneiro.",
    logisticsFlowStep4Title: "Entrega à sua rede",
    logisticsFlowStep4Body:
      "Os pedidos de produção chegam ao seu armazém, distribuidora ou parceiro logístico indicado, com rastreamento durante todo o percurso.",
    logisticsModesEyebrow: "Como enviamos",
    logisticsModesTitle: "O modal certo para cada envio",
    logisticsModesBody:
      "De um único palete urgente a um contêiner completo, ajustamos o método de envio ao seu volume, orçamento e prazo.",
    logisticsModeAirTitle: "Frete aéreo",
    logisticsModeAirBody:
      "A rota de frete mais rápida para lançamentos e pedidos de produção com prazo crítico.",
    logisticsModeSeaTitle: "Frete marítimo",
    logisticsModeSeaBody:
      "A opção mais econômica para pedidos grandes e planejados enviados em contêiner.",
    logisticsModeRoadTitle: "Rodoviário e ferroviário",
    logisticsModeRoadBody:
      "Distribuição regional e entrega seguinte assim que a mercadoria chega ao seu mercado.",
    logisticsModeCourierTitle: "Courier expresso",
    logisticsModeCourierBody:
      "Entrega rápida porta a porta de amostras para avaliação antes de um projeto ou pedido em volume.",
    logisticsB2bNoteTitle: "Somente envios empresariais",
    logisticsB2bNoteBody:
      "Pedidos de produção seguem para operadoras, distribuidoras, armazéns ou parceiros logísticos. Não fazemos dropshipping para assinantes. O courier expresso é reservado para amostras de avaliação.",
    logisticsHandleEyebrow: "Cuidamos de tudo para você",
    logisticsHandleTitle: "Muito além de transportar caixas",
    logisticsHandleBody:
      "Cuidamos dos detalhes que atrasam as operadoras, para que o hardware chegue pronto para implantar.",
    logisticsHandleItem1: "Embalagem com a marca da operadora e pronta para o varejo",
    logisticsHandleItem2: "Envios a granel, paletizados e em contêiner",
    logisticsHandleItem3: "Documentação de exportação, desembaraço aduaneiro e conformidade",
    logisticsHandleItem4: "Implantações faseadas, região por região",
    logisticsHandleItem5: "Coordenação com seus distribuidores e operadores 3PL",
    logisticsHandleItem6: "Entrega expressa de amostras para avaliação técnica e comercial",
    logisticsHandleItem7:
      "Listas de números de série e MACs de cada dispositivo, prontas para provisionamento",
    logisticsHandleItem8: "Firmware pré-gravado e configuração por lote",
    logisticsHandleItem9: "Incoterms flexíveis — EXW, FOB ou DAP conforme sua equipe",
    logisticsHandleFootnote:
      "Um único coordenador conduz cada remessa — da linha de produção ao seu depósito.",
    logisticsLinksEyebrow: "Continue explorando",
    logisticsLinksTitle: "Planeje o restante da sua implantação",
    logisticsLinkCta: "Saiba mais",
    logisticsLinkDistributorsTitle: "Encontrar um distribuidor",
    logisticsLinkDistributorsBody:
      "Trabalhe com um parceiro inext autorizado que já atende a sua região.",
    logisticsLinkCustomizationTitle: "Marca e embalagem",
    logisticsLinkCustomizationBody:
      "Envie hardware com a sua própria marca, do firmware à caixa de varejo.",
    logisticsLinkProductsTitle: "Conheça o hardware",
    logisticsLinkProductsBody:
      "Compare a linha de set-top boxes da inext e escolha o modelo ideal.",
    logisticsLinkAboutTitle: "Sobre a inext",
    logisticsLinkAboutBody: "O time por trás do hardware, entregando a operadoras desde 2011.",
    logisticsFaqEyebrow: "FAQ",
    logisticsFaqTitle: "Entrega e logística, sem mistério",
    logisticsFaqQ1: "Para quais países vocês entregam?",
    logisticsFaqA1:
      "Enviamos para o mundo todo. O hardware inext já está em operação com operadoras em mais de 15 países, e nossos parceiros logísticos conseguem alcançar praticamente qualquer mercado — diretamente ou por meio de um distribuidor local.",
    logisticsFaqQ2: "Onde os produtos inext são fabricados?",
    logisticsFaqA2:
      "Nossos set-top boxes são produzidos com parceiros de fabricação e fornecimento em Shenzhen e Guangzhou (China) e em Taiwan — regiões de eletrônicos consolidadas, com cadeias de fornecimento maduras e confiáveis.",
    logisticsFaqQ3: "Quem cuida do envio e da alfândega?",
    logisticsFaqA3:
      "Coordenamos toda a jornada por meio da nossa rede de parceiros logísticos e preparamos a documentação de exportação e desembaraço aduaneiro, para que você tenha um único ponto de contato em vez de lidar com vários agentes de carga.",
    logisticsFaqQ4: "Vocês podem enviar com a nossa própria marca?",
    logisticsFaqA4:
      "Sim. Os dispositivos podem chegar ao seu armazém ou parceiro de distribuição em embalagem totalmente personalizada e pronta para o varejo. Consulte nossas opções de personalização de firmware, gabinete e embalagem.",
    logisticsFaqQ5: "Quais métodos de envio e prazos de entrega estão disponíveis?",
    logisticsFaqA5:
      "Pedidos de produção podem seguir por via aérea, marítima, rodoviária ou ferroviária. O courier expresso atende amostras de avaliação, não dropshipping ao consumidor. Os prazos dependem do volume, da personalização e do destino — confirmamos um cronograma realista em cada orçamento.",
    logisticsFaqQ6: "Existe uma quantidade mínima de pedido?",
    logisticsFaqA6:
      "O tamanho dos pedidos é acordado por projeto. Trabalhamos com operadoras de diferentes portes, desde os primeiros lotes-piloto até pedidos recorrentes de grande volume — fale com a gente sobre o que você precisa.",
    logisticsFinalEyebrow: "Vamos colocar seu hardware em movimento",
    logisticsFinalTitle: "Planeje a sua entrega mundial",
    logisticsFinalBody:
      "Conte-nos para onde seus dispositivos precisam ir e com que rapidez. Montamos um plano de entrega — fabricação, embalagem, frete e alfândega — e um único time para executá-lo.",
    logisticsFinalCta: "Fale com nosso time",
    logisticsFinalCtaSecondary: "Encontrar um distribuidor",
    productsIndexEyebrow: "Hardware",
    productsIndexTitle: "A linha de produtos inext",
    productsIndexSubtitle:
      "Set-top boxes Android TV 4K feitas para operadoras — além dos acessórios oficiais e das ferramentas que completam cada implantação.",
    productsIndexMoreHeading: "Explore mais",
    productsIndexArchiveDesc: "Especificações e fotos de modelos inext descontinuados.",
    productsIndexCardCta: "Saiba mais",
    productsIndexSeoTitle: "Produtos — set-top boxes Android TV e acessórios | inext",
    productsIndexSeoDescription:
      "Conheça toda a linha inext: set-top boxes Android TV 4K, acessórios oficiais, uma comparação lado a lado e o arquivo de modelos descontinuados.",
    solutionsIndexEyebrow: "Plataforma e serviços",
    solutionsIndexTitle: "Soluções para cada etapa do seu serviço de TV",
    solutionsIndexSubtitle:
      "Do gerenciamento de dispositivos e firmware aos apps que os assinantes usam todos os dias — o software e os serviços que mantêm uma frota inext em operação.",
    solutionsIndexCardCta: "Saiba mais",
    solutionsIndexFlagship: "Flagship",
    solutionsIndexSeoTitle:
      "Soluções — gerenciamento de dispositivos, OTA, app IPTV e mais | inext",
    solutionsIndexSeoDescription:
      "Conheça as soluções inext: gerenciamento de dispositivos Alcatraz, gerenciamento de atualizações OTA, o app IPTV, o app inext Remote, customização e logística global.",
    verimatrixNote:
      "Parceiro certificado Verimatrix — nossas set-top boxes e o app IPTV integram nativamente o acesso condicional Verimatrix VCAS e multi-DRM.",
    solutionsRow1Title: "Gerencie toda a sua frota em um só lugar",
    solutionsRow1Body:
      "O Alcatraz analisa a telemetria, organiza os problemas detectados em uma fila priorizada do Fleet Health, mantém o histórico de atividade dos dispositivos e oferece distribuição controlada de firmware e diagnósticos remotos.",
    solutionsRow2Title: "A tela onde seus assinantes vivem",
    solutionsRow2Body:
      "Um app IPTV com sua marca e um controle remoto móvel gratuito transformam a box inext em uma experiência de TV que os assinantes curtem.",
    solutionsRow3Title: "Sua marca, construída e entregue",
    solutionsRow3Body:
      "Hardware e firmware white-label feitos conforme sua especificação e enviados para o mundo todo — você lança, nós cuidamos do resto.",
    solutionsAllTitle: "Todas as soluções, uma plataforma",
    navGuides: "Guias",
    footerGuides: "Guias",
    footerLinkGuidesAndroidLinux: "Android vs Linux",
    guidesBreadcrumbHome: "Início",
    guidesIndexEyebrow: "Guias",
    guidesIndexTitle: "Guias para as decisões por trás da sua plataforma de TV",
    guidesIndexSubtitle:
      "Guias honestos e práticos sobre as escolhas que operadoras realmente enfrentam — hardware, sistema, propriedade dos aparelhos, financiamento e método de distribuição. Como entregamos a stack inteira, isso aqui não é argumento de venda.",
    guidesIndexAllTitle: "Todos os guias",
    guidesIndexCardCta: "Ler o guia",
    guidesIndexSeoTitle: "Guias — como escolher e operar sua plataforma de TV | inext",
    guidesIndexSeoDescription:
      "Guias práticos e independentes para operadoras de IPTV e OTT — escolhas de plataforma, implantação e as decisões por trás de operar uma frota de set-top boxes.",
    tcoCardTitle: "Calculadora de TCO para set-top boxes",
    tcoCardDesc:
      "Compare o custo total de dois cenários de implantação de set-top boxes, incluindo hardware, substituições, suporte, visitas técnicas e gerenciamento da frota.",
    tcoCardCta: "Abrir calculadora",
    tcoSeoTitle: "Calculadora de TCO para set-top boxes — compare custos | inext",
    tcoSeoDescription:
      "Estime e compare o custo total de propriedade de dois cenários de implantação de set-top boxes para IPTV ou OTT, incluindo hardware, substituições, suporte, atendimento em campo e gerenciamento de dispositivos.",
    tcoBreadcrumbPage: "Calculadora de TCO para set-top boxes",
    tcoHeroEyebrow: "Ferramenta interativa para planejamento",
    tcoHeroTitle: "Calculadora de custo total de propriedade para set-top boxes",
    tcoHeroBody:
      "Compare dois cenários de implantação de set-top boxes ao longo de toda a vida útil. Avalie como o preço de compra, as falhas de hardware, o suporte aos assinantes, as visitas técnicas e o gerenciamento de dispositivos afetam o custo real por aparelho.",
    tcoExampleNotice:
      "Os valores preenchidos são apenas exemplos — não representam uma cotação nem garantia de economia. Substitua-os por dados reais da operação e valores das propostas dos fornecedores.",
    tcoInputsEyebrow: "Dados de entrada",
    tcoInputsTitle: "Crie dois cenários para comparação",
    tcoInputsBody:
      "Informe o tamanho da frota, a vida útil e a moeda comuns aos dois cenários. Em seguida, defina os custos e as premissas operacionais de cada um.",
    tcoReset: "Restaurar exemplo",
    tcoFleetSize: "Dispositivos na frota",
    tcoOwnershipPeriod: "Vida útil, anos",
    tcoCurrency: "Moeda do cálculo",
    tcoScenarioLabel: "Cenário de implantação",
    tcoScenarioA: "Cenário A",
    tcoScenarioB: "Cenário B",
    tcoFieldUnitPrice: "Preço de compra por dispositivo",
    tcoFieldLogistics: "Custo de logística por dispositivo",
    tcoFieldSetup: "Custo único de configuração e personalização",
    tcoFieldFailureRate: "Taxa anual de falhas, %",
    tcoFieldReplacement: "Custo por substituição",
    tcoFieldSupportContacts: "Atendimentos de suporte por 1.000 dispositivos ao ano",
    tcoFieldSupportCost: "Custo por atendimento de suporte",
    tcoFieldTruckRolls: "Visitas técnicas por 1.000 dispositivos ao ano",
    tcoFieldTruckRollCost: "Custo por visita técnica",
    tcoFieldDmsCost: "Gerenciamento por dispositivo ao mês",
    tcoDmsIncludedNote:
      "Gerenciamento de dispositivos: o Alcatraz Pro está incluído sem custo adicional enquanto a frota tiver menos de 500 dispositivos inext ativos. Para frotas com 500 dispositivos ativos ou mais, fale com a inext para discutir as condições comerciais.",
    tcoResultsEyebrow: "Comparação",
    tcoResultsTitle: "Custo total estimado ao longo da vida útil",
    tcoLowerResult: "{scenario}: {amount} a menos ({percent}%)",
    tcoEqualResult: "Os dois cenários têm o mesmo TCO estimado",
    tcoComparisonNote:
      "A estimativa se baseia nos dados informados acima. Em frotas grandes, os custos operacionais podem ter mais impacto do que uma pequena diferença no preço de compra.",
    tcoTotalLabel: "Custo total no período selecionado",
    tcoPerDevice: "Custo por dispositivo",
    tcoPerDeviceMonth: "Custo mensal por dispositivo",
    tcoCostProcurement: "Aquisição de hardware",
    tcoCostLogistics: "Logística",
    tcoCostSetup: "Configuração e personalização",
    tcoCostReplacements: "Substituição de hardware",
    tcoCostSupport: "Suporte aos assinantes",
    tcoCostFieldService: "Atendimento em campo",
    tcoCostManagement: "Gerenciamento de dispositivos",
    tcoMethodEyebrow: "Modelo de cálculo",
    tcoMethodTitle: "O que o cálculo de TCO considera",
    tcoMethodBody:
      "O custo total de propriedade inclui não apenas a compra inicial, mas também os custos operacionais posteriores. O modelo é propositalmente transparente para que cada premissa possa ser substituída por dados reais da operação.",
    tcoMethod1Title: "Implantação inicial",
    tcoMethod1Body:
      "Os custos dos dispositivos e da logística são calculados para toda a frota. A configuração e a personalização são contabilizadas uma única vez.",
    tcoMethod2Title: "Custos ao longo da vida útil",
    tcoMethod2Body:
      "Falhas, atendimentos de suporte, visitas técnicas e custos mensais de gerenciamento são projetados para toda a vida útil selecionada.",
    tcoMethod3Title: "Custos comparáveis por dispositivo",
    tcoMethod3Body:
      "O total é apresentado como custo por dispositivo e custo mensal por dispositivo, facilitando a comparação de cenários com preços de compra diferentes.",
    tcoCtaTitle: "Valide o cálculo com hardware real",
    tcoCtaBody:
      "A calculadora ajuda a reduzir a lista de opções. Uma implantação piloto permite verificar a estabilidade dos dispositivos, os fluxos de suporte, o diagnóstico remoto e os custos operacionais reais.",
    tcoCtaButton: "Conversar sobre a implantação",
    footerLinkGuidesTco: "Calculadora de TCO para set-top boxes",
    guidesCardAvlTitle: "Android vs Linux no set-top box",
    guidesCardAvlDesc:
      "Qual plataforma combina com a sua rede? Uma comparação honesta — ecossistema de apps, custo, controle e quando cada uma vence.",
    avlSeoTitle: "Android vs Linux no set-top box: como escolher | inext",
    avlSeoDescription:
      "Android TV ou Linux para a sua frota de set-top boxes? Uma comparação honesta e independente da inext — nós entregamos os dois. Ecossistema de apps, custo, controle e quando cada um vence.",
    avlBreadcrumbPage: "Android vs Linux no set-top box",
    avlHeroEyebrow: "Guia de plataforma",
    avlHeroTitle: "Android vs Linux no set-top box:",
    avlHeroTitleAccent: "qual plataforma combina com a sua rede?",
    avlHeroSub:
      "A maioria dos guias de 'Android vs Linux' é escrita por um fornecedor que vende só uma das duas — então, no fundo, são argumento de venda disfarçado. Não é o nosso caso: todo set-top box da inext pode sair com Android ou com um build Linux enxuto, então ficamos felizes com qualquer escolha que você fizer. Esta é a versão honesta.",
    avlHeroNote: "Entregamos os dois — então esta comparação não tem dedo na balança.",
    avlHeroCtaPrimary: "Fale com nosso time",
    avlHeroCtaSecondary: "Ver a comparação",
    avlDefineEyebrow: "Comece por aqui",
    avlDefineTitle: "Primeiro, o que realmente estamos comparando",
    avlDefineBody:
      "Os dois rodam no mesmo silício, então é fácil confundir. Para esta comparação, trate cada um como um produto distinto:",
    avlDefineAndroidLabel: "Android",
    avlDefineAndroidBody:
      "a plataforma Android TV — ela roda o ecossistema de apps Android por trás de um launcher que você pode personalizar com sua marca, então o assinante encontra os apps e a navegação que já conhece.",
    avlDefineLinuxLabel: "Linux",
    avlDefineLinuxBody:
      "um build enxuto e sob medida que contém apenas o seu app de IPTV, o seu middleware e as ferramentas que você colocar ali — sem loja de apps, sem camada Android.",
    avlDefineCandid:
      "Sendo direto desde já: cerca de 95% das operadoras com quem trabalhamos escolhem Android — embora, em algumas regiões, o Linux seja bem mais comum. Vamos explicar exatamente por quê, e em que casos o Linux é a escolha mais inteligente.",
    avlVerdictEyebrow: "O veredito rápido",
    avlVerdictTitle: "Duas colunas — encontre-se em uma delas",
    avlVerdictAndroidTitle: "Escolha Android se…",
    avlVerdictAndroid1:
      "Você quer o ecossistema de apps Android — os apps de streaming e OTT consagrados que seus assinantes já conhecem",
    avlVerdictAndroid2:
      "Você quer uma experiência de TV familiar, no padrão do consumidor, com pouco trabalho de UI sob medida",
    avlVerdictAndroid3: "Você precisa lançar rápido e manter abertas as opções de apps no futuro",
    avlVerdictAndroid4:
      "Um catálogo de apps amplo e conhecido e uma experiência no padrão do consumidor são importantes para a sua oferta",
    avlVerdictLinuxTitle: "Escolha Linux se…",
    avlVerdictLinux1:
      "Você opera um serviço de IPTV puramente gerenciado — seu próprio app, seu ecossistema fechado, nada além disso",
    avlVerdictLinux2:
      "Você quer a menor pegada possível e o menor custo operacional no mesmo hardware",
    avlVerdictLinux3:
      "Você precisa de controle total e bloqueio máximo, sem loja de apps no dispositivo",
    avlVerdictLinux4: "Apps OTT de terceiros não fazem parte do que você vende",
    avlVerdictFootnote:
      "Se encaixou claramente na coluna do Android? Você está com os 95% — essa é a escolha segura por padrão. Se a coluna do Linux descreve você, continue lendo.",
    avlCoreEyebrow: "A diferença essencial",
    avlCoreTitle: "Ecossistema de apps vs. leveza e controle",
    avlCoreBody1:
      "Tirando os detalhes, a escolha se resume a um único trade-off: ecossistema de apps e familiaridade versus leveza e controle.",
    avlCoreBody2:
      "O Android entrega o mundo de consumo que seus assinantes já conhecem: ele roda o ecossistema de apps Android — o seu próprio app mais os apps de streaming e OTT consagrados — por trás de um launcher com a sua marca, com todo o catálogo de apps Android à sua disposição. É esse alcance que faz quase toda operadora optar por ele.",
    avlCoreBody3:
      "O Linux entrega as virtudes opostas: um dispositivo enxuto que faz exatamente o que você manda e nada mais. Sem loja de apps, sem camada do Google, sem ecossistema de consumo — só o seu app de IPTV e as ferramentas que você aprovou. Isso o torna mais leve, mais barato de operar, mais fácil de bloquear e totalmente seu.",
    avlCoreBody4:
      "O detalhe que decide a maioria dos casos: os grandes apps de OTT são feitos como apps Android. Um set-top box Linux simplesmente não consegue rodá-los — colocar um app de terceiros ali é um trabalho sob medida, app por app, que costuma ser inviável. Então, se seus assinantes esperam esses apps, o Linux praticamente se elimina sozinho. Se não esperam, as vantagens dele são reais.",
    avlTableEyebrow: "Lado a lado",
    avlTableTitle: "Android vs Linux, linha por linha",
    avlTableColDimension: "",
    avlTableColAndroid: "Android",
    avlTableColLinux: "Linux",
    avlRow1Dim: "Ecossistema de apps OTT (Netflix, YouTube, Disney+)",
    avlRow1Android: "Roda o ecossistema de apps Android — seu app mais os apps OTT",
    avlRow1Linux: "Sem apps Android — apenas o cliente que você desenvolve",
    avlRow2Dim: "Familiaridade da UX para o consumidor",
    avlRow2Android: "Experiência Android TV familiar",
    avlRow2Linux: "Totalmente sob medida — o que você projetar",
    avlRow3Dim: "Marca e personalização",
    avlRow3Android: "Launcher com sua marca, personalização profunda",
    avlRow3Linux: "Controle total sobre cada pixel e cada comportamento",
    avlRow4Dim: "Bloqueio em ecossistema fechado",
    avlRow4Android: "Possível, exige configuração",
    avlRow4Linux: "Nativo — não há loja de apps para bloquear",
    avlRow5Dim: "Pegada no mesmo aparelho",
    avlRow5Android: "Exige mais folga de RAM/armazenamento",
    avlRow5Linux: "Roda mais enxuto; permite especificar um aparelho de tier mais baixo",
    avlRow6Dim: "Tempo de boot e uso de recursos",
    avlRow6Android: "Mais pesado",
    avlRow6Linux: "Mais leve, boot mais rápido",
    avlRow7Dim: "Atualizações de plataforma e segurança",
    avlRow7Android: "Base da plataforma Android mais o seu OTA",
    avlRow7Linux: "Totalmente gerenciado pela operadora/inext via OTA",
    avlRow9Dim: "DRM / proteção de conteúdo",
    avlRow9Android: "Widevine e Verimatrix",
    avlRow9Linux: "Widevine e Verimatrix",
    avlRow10Dim: "Velocidade de desenvolvimento e mão de obra",
    avlRow10Android: "Ecossistema grande, rápido",
    avlRow10Linux: "Trabalho especializado, mais sob medida",
    avlRow12Dim: "Ciclo de vida e independência",
    avlRow12Android: "Acompanha o ritmo da plataforma do Google",
    avlRow12Linux: "Sem dependência externa — você controla a longevidade",
    avlRowAppDim: "App cliente da inext",
    avlRowAppAndroid: "App de IPTV pronto e launcher — ambos com a sua marca",
    avlRowAppLinux: "SDK e API para desenvolver e integrar rápido",
    avlRowInextDim: "Gerenciado pela stack da inext",
    avlStackLabel: "Igual nos dois:",
    avlStackAlcatraz: "Alcatraz DMS",
    avlStackOta: "OTA",
    avlStackTr069: "TR-069",
    avlStackCustomization: "personalização",
    avlTableNote:
      "DRM e as especificações exatas da plataforma dependem do aparelho e do build — conte pra gente o que sua implantação precisa e confirmamos.",
    avlDecideEyebrow: "O que realmente decide",
    avlDecideTitle: "As perguntas que resolvem a maioria das decisões",
    avlDecide1Title: "O ecossistema de apps",
    avlDecide1Body:
      "Esta é, sozinha, a maior razão pela qual o Android vence. Os apps OTT consagrados — Netflix, YouTube, Disney+, Prime — são feitos como apps Android e rodam no ecossistema de apps Android. Um set-top box Linux simplesmente não consegue rodá-los; adicionar um app de terceiros ali é uma integração sob medida que, para a maioria das operadoras, não compensa. Se a primeira pergunta do assinante é 'tem Netflix?', a resposta é Android. Se você entrega um pacote de IPTV fechado e apps OTT não fazem parte do combinado, essa desvantagem simplesmente não se aplica a você.",
    avlDecide2Title: "Custo e pegada",
    avlDecide2Body:
      "Como os aparelhos são idênticos, o Linux não barateia o hardware por si só — ele permite fazer mais com menos. Um build Linux enxuto exige menos RAM e armazenamento, então, numa implantação de IPTV puro, você pode especificar um aparelho de tier mais baixo, como o inext TV5, e ainda assim ter uma experiência ágil, enquanto a mesma função no Android pede mais folga. Em escala de frota, essa folga vira dinheiro de verdade.",
    avlDecide3Title: "Controle, segurança e bloqueio",
    avlDecide3Body:
      "O Linux é a escolha natural quando 'o dispositivo precisa fazer exatamente isso e nada mais' é um requisito inegociável. Sem loja de apps, sem espaço para sideload, com uma superfície de ataque menor e um build contendo apenas o que você aprovou. O Android também pode ser bloqueado, mas isso é uma configuração que você mantém contra uma plataforma maior e em constante evolução. Para implantações no estilo quiosque, reguladas ou rigidamente gerenciadas, a simplicidade do Linux é justamente o diferencial.",
    avlDecide4Title: "Tempo até o mercado",
    avlDecide4Body:
      "O Android coloca um produto no estilo de consumo no ar mais rápido — o launcher, os apps e os padrões de UX já existem e só precisam ganhar a sua marca. O Linux significa desenvolver ou portar boa parte da experiência por conta própria, o que é exatamente o ponto quando você quer controle total, mas dá mais trabalho no início. Encurtamos os dois caminhos: no Android, com nosso app de IPTV pronto e serviço de personalização; no Linux, com um SDK e uma API que aceleram seu desenvolvimento e integração.",
    avlDecide5Title: "Ciclo de vida e independência",
    avlDecide5Body:
      "O Android acompanha o ritmo da plataforma do Google — novas versões e compatibilidade de apps. Na maior parte das vezes isso é uma vantagem, mas é uma dependência externa. Um build Linux não tem esse peso: ele é seu, congelado ou evoluindo no seu cronograma, no roadmap de mais ninguém além do seu. Para implantações de vida muito longa, ou mercados onde você quer zero dependência externa, isso faz diferença.",
    avlProfilesEyebrow: "Qual é a certa pra você?",
    avlProfilesTitle: "Combine seu serviço a uma plataforma",
    avlProfile1Title: "Operadora de IPTV + OTT",
    avlProfile1Pick: "Android",
    avlProfile1Body:
      "Os assinantes querem seus canais e os grandes apps de streaming. Este é o caso mais comum — os ~95%.",
    avlProfile2Title: "IPTV puramente gerenciado / ecossistema fechado",
    avlProfile2Pick: "Linux",
    avlProfile2Body: "Apenas o seu app, sem OTT de terceiros. Vale uma análise séria.",
    avlProfile3Title: "Implantação em alto volume, focada em custo",
    avlProfile3Pick: "Linux",
    avlProfile3Body:
      "Quando a oferta é o seu próprio pacote, o Linux num aparelho de tier mais baixo estica o orçamento.",
    avlProfile4Title: "Rigidamente controlado / quiosque / regulado",
    avlProfile4Pick: "Linux",
    avlProfile4Body:
      "Quando o bloqueio é um requisito inegociável, a plataforma mais enxuta é mais fácil de proteger.",
    avlProfile5Title: "Em dúvida / mantendo as opções abertas",
    avlProfile5Pick: "Android",
    avlProfile5Body: "A escolha segura por padrão, que mantém o maior número de portas abertas.",
    avlSameEyebrow: "Seja qual for a escolha",
    avlSameTitle: "O resto da stack é o mesmo",
    avlSameBody:
      "Todo aparelho da inext — Android ou Linux — roda na mesma stack operacional: Alcatraz DMS para o controle da frota, atualizações OTA escalonadas, TR-069 e nossa personalização white-label. O software cliente é a única parte que muda — no Android, você pode entregar nosso app de IPTV pronto e launcher, ambos com a sua marca; no Linux, fornecemos um SDK e uma API para desenvolver e integrar rápido. De qualquer forma, você mantém as ferramentas que operam a frota.",
    avlLockTitle: "Mesmo hardware — então decida com critério, não com nervosismo",
    avlLockBody:
      "Android ou Linux é uma escolha de firmware no mesmíssimo aparelho, não um produto diferente. Você pode avaliar os dois antes de se comprometer, ou operar uma frota mista. Trocar a plataforma de um aparelho depois é possível, mas isso é um re-flash, não uma atualização OTA de rotina — então o melhor é escolher a plataforma na qual pretende ficar e se comprometer com ela. A decisão de hardware é de baixo risco; a decisão de plataforma merece ser tomada com cuidado.",
    avlFaqEyebrow: "FAQ",
    avlFaqTitle: "Perguntas frequentes",
    avlFaqQ1: "Dá pra rodar Netflix num set-top box Linux?",
    avlFaqA1:
      "Em geral, não. Netflix, YouTube e Disney+ são feitos como apps Android; um set-top box Linux não consegue rodá-los, e adicionar um app de terceiros é uma integração sob medida e, muitas vezes, inviável. Se esses apps são importantes para a sua oferta, escolha Android.",
    avlFaqQ2: "O Android é mais caro que o Linux?",
    avlFaqA2:
      "O hardware é o mesmo aparelho da inext, então a plataforma não é um item de custo à parte. O Android pede um pouco mais de folga de RAM e armazenamento, então, para uma função de IPTV puro, o Linux pode permitir especificar um aparelho de tier mais baixo.",
    avlFaqQ3: "Dá pra migrar de Linux para Android depois, ou voltar?",
    avlFaqA3:
      "Dá, mas não é uma atualização OTA de rotina — mover um aparelho entre Android e Linux significa regravar o firmware, o que é mais trabalhoso. É o mesmo hardware nos dois casos, então você não está comprando dispositivos diferentes, mas recomendamos se comprometer com a plataforma na qual pretende ficar.",
    avlFaqQ4: "Qual a maioria das operadoras escolhe?",
    avlFaqA4:
      "Cerca de 95% escolhem Android, porque seus assinantes esperam os apps OTT consagrados — embora, em algumas regiões, o Linux seja bem mais comum. O Linux vence para implantações de IPTV puramente gerenciado, de bloqueio máximo e de menor pegada.",
    avlFaqQ5: "O gerenciamento de dispositivos da inext funciona nos dois?",
    avlFaqA5:
      "Sim — Alcatraz DMS, atualizações OTA e TR-069 funcionam da mesma forma nos builds Android e Linux.",
    avlCtaEyebrow: "Fale com a gente",
    avlCtaTitle: "Em dúvida sobre qual combina com a sua implantação?",
    avlCtaBody:
      "Conte pra gente sobre o seu serviço e recomendamos uma plataforma com honestidade — inclusive quando a resposta for Linux.",
    avlCtaPrimary: "Fale com nosso time",
    avlCtaSecondary: "Solicitar um build de firmware Linux",
    footerLinkGuidesAospCert: "AOSP vs certificação",
    guidesCardAcTitle: "AOSP vs. Android TV certificado",
    guidesCardAcDesc:
      "Qual deles o seu lançamento realmente precisa? O ecossistema de apps certificado vs. velocidade, custo e controle — e como entregamos os dois.",
    acSeoTitle: "AOSP vs. Android TV certificado: qual o seu lançamento precisa? | inext",
    acSeoDescription:
      "AOSP ou Android TV certificado pelo Google para a sua implantação de operadora? Uma comparação honesta da inext — entregamos os dois. Ecossistema de apps, custo, time-to-market e quando a certificação vale a pena.",
    acBreadcrumbPage: "AOSP vs. Android TV certificado",
    acHeroEyebrow: "Guia de plataforma",
    acHeroTitle: "AOSP vs. Android TV certificado:",
    acHeroTitleAccent: "qual deles o seu lançamento realmente precisa?",
    acHeroSub:
      "Os dois são Android — o que os separa é a certificação do Google e o tempo, o custo e o controle que você troca por ela. Nós mesmos desenvolvemos o AOSP, então não vamos fingir neutralidade: para a maioria das operadoras é a escolha mais rápida, mais barata e mais flexível, e essa é a nossa recomendação honesta — e quando um projeto realmente precisa de certificação, entregamos isso também, com nossos parceiros 3PL certificados. Esta página expõe o trade-off para você identificar qual deles o seu lançamento precisa.",
    acHeroNote:
      "A maioria das operadoras lança com AOSP. Quando um projeto realmente precisa de certificação, entregamos isso também.",
    acHeroCtaPrimary: "Fale com nosso time",
    acHeroCtaSecondary: "Ver a comparação",
    acDefineEyebrow: "Comece por aqui",
    acDefineTitle: "Primeiro, o que ‘certificado’ realmente muda",
    acDefineBody:
      "Os dois rodam Android. O que os separa é o programa de certificação do Google — e tudo o que vem junto com ele:",
    acDefineAospLabel: "AOSP",
    acDefineAospBody:
      "Android open source, totalmente seu — seu launcher, seus apps, suas regras. Sem Google Play e sem a barreira da certificação, mas com Widevine L1 e L3 embarcados, então, com os seus acordos de operadora, ele ainda roda apps premium como Netflix. Muito mais rápido e barato de lançar.",
    acDefineCertLabel: "Android TV certificado",
    acDefineCertBody:
      "Certificado pelo Google, com Google Play, Widevine L1, Google Assistant e Chromecast embarcados — a base do ecossistema de apps certificado — ao custo do licenciamento, da aprovação e do cronograma do Google.",
    acStat1: "1–2 semanas até uma amostra funcional",
    acStat2: "Sem taxas do Google por dispositivo no AOSP",
    acStat3: "As duas plataformas, um único parceiro",
    acPivotEyebrow: "Comece por aqui",
    acPivotTitle: "Normalmente tudo se resume a uma pergunta",
    acPivotQuestion:
      "Os seus assinantes precisam da Google Play Store aberta — um catálogo de autoatendimento com milhares de apps — somada a Google Assistant e Chromecast?",
    acPivotNoLabel: "Não — uma experiência curada e controlada pela operadora",
    acPivotNoPick: "AOSP",
    acPivotNoText:
      "Você lidera com o seu próprio serviço e um line-up escolhido — incluindo Netflix e outros apps premium nos quais você detém o acordo com a operadora. Mais rápido, mais barato, totalmente seu.",
    acPivotYesLabel: "Sim — a loja de apps aberta para o consumidor",
    acPivotYesPick: "Certificado",
    acPivotYesText:
      "Você quer a Play Store completa, em autoatendimento, e os serviços do Google como parte do produto. Vale o licenciamento e o cronograma mais longo.",
    acPivotFootnote:
      "A maioria das operadoras responde ‘não’ e lança com AOSP. Para qualquer lado que você penda, entregamos.",
    acTimelineEyebrow: "Time-to-market",
    acTimelineTitle: "Dois caminhos até o lançamento",
    acTimelineIntro:
      "A maior diferença prática não é a tecnologia — é quanto tempo leva para entrar no ar e quanto custa chegar lá.",
    acTimelineAospLabel: "AOSP com a inext",
    acTimelineAospResult: "~2 meses até o envio",
    acTimelineAospStep1: "Personalize o launcher, o app e os serviços com a sua marca",
    acTimelineAospStep2: "Aprove uma amostra funcional — cerca de 1–2 semanas",
    acTimelineAospStep3: "Implante",
    acTimelineCertLabel: "Android TV certificado",
    acTimelineCertResult: "5–8 meses até o envio",
    acTimelineCertStep1: "Licencie o GMS e especifique hardware homologado pelo Google",
    acTimelineCertStep2: "Desenvolva e integre",
    acTimelineCertStep3: "Testes de certificação",
    acTimelineCertStep4: "Aprovação do Google",
    acTimelineCertStep5: "Implante",
    acTimelineNote:
      "Nós já desenvolvemos a plataforma AOSP, então a habitual desvantagem do ‘lento para construir’ não existe mais. Precisa de certificação? Conduzimos essa frente também, com nossos parceiros 3PL certificados.",
    acIncludesEyebrow: "O que você recebe",
    acIncludesTitle: "Nosso AOSP não é uma caixa vazia — é uma plataforma pronta para lançar",
    acIncludesBody:
      "Tudo abaixo já está desenvolvido, comprovado e personalizado com a sua marca. O line-up exato de apps é ajustado ao seu país e ao seu licenciamento, por isso não está listado aqui.",
    acIncludes1:
      "Um launcher Operator Tier personalizável — sua marca e seu conteúdo em primeiro plano já na inicialização",
    acIncludes2: "Nosso app de IPTV, com a sua marca",
    acIncludes3:
      "Os serviços locais de TV e streaming do seu mercado pré-instalados — mais apps premium como Netflix onde você detém o acordo",
    acIncludes4: "Gerenciado por Alcatraz DMS, OTA e TR-069 desde o primeiro dia",
    acIncludes5: "Personalizado e validado com uma amostra funcional em 1–2 semanas",
    acTableEyebrow: "A comparação completa",
    acTableTitle: "Onde AOSP e certificado realmente diferem",
    acTableColDimension: "",
    acTableColAosp: "AOSP",
    acTableColCert: "Android TV certificado",
    acRow1Dim: "Google Play Store",
    acRow1Aosp: "Sem Play Store — entrega de apps por conta própria",
    acRow1Cert: "Embarcada — milhares de apps",
    acRow2Dim: "Apps premium (Netflix, Disney+ em HD/4K)",
    acRow2Aosp:
      "Funciona onde a sua rede detém o acordo com a operadora — nosso AOSP é Widevine L1",
    acRow2Cert:
      "O mesmo, mais a distribuição via Google Play; o acordo com a operadora continua valendo",
    acRow3Dim: "Google Assistant e Chromecast",
    acRow3Aosp: "Não incluídos (ou sob medida)",
    acRow3Cert: "Embarcados",
    acRow4Dim: "Widevine DRM",
    acRow4Aosp: "Widevine L1 e L3 nos set-top boxes da inext",
    acRow4Cert: "Widevine L1 e L3",
    acRow5Dim: "Launcher da operadora / tela inicial",
    acRow5Aosp: "Totalmente sob medida, em primeiro plano na inicialização — controle total",
    acRow5Cert: "Launcher Operator Tier, dentro das regras do Google",
    acRow6Dim: "Apps pré-instalados e serviços locais",
    acRow6Aosp: "Exatamente o que o seu mercado precisa — você decide",
    acRow6Cert: "Modelo Google Play, mais as suas adições",
    acRow7Dim: "Liberdade de personalização",
    acRow7Aosp: "Total",
    acRow7Cert: "Dentro do programa do Google",
    acRow8Dim: "Hardware",
    acRow8Aosp: "Roda em set-top boxes enxutos e otimizados em custo",
    acRow8Cert: "Mais parrudo, homologado pelo Google",
    acRow9Dim: "Time-to-market",
    acRow9Aosp: "~2 meses até o envio (amostra funcional em 1–2 semanas)",
    acRow9Cert: "Normalmente 5–8 meses até o envio",
    acRow10Dim: "Custo",
    acRow10Aosp: "Sem licença GMS nem taxas do Google por dispositivo",
    acRow10Cert: "Licença GMS, taxas por dispositivo, custos de laboratório de testes",
    acRow11Dim: "Dependência do Google",
    acRow11Aosp: "Nenhuma",
    acRow11Cert: "Conformidade contínua com o Google",
    acRow12Dim: "Cobrança e pagamentos (vendendo para os assinantes)",
    acRow12Aosp:
      "Qualquer gateway de pagamento ou parceiro — sua própria cobrança, sem comissão da plataforma",
    acRow12Cert:
      "Vendas digitais têm de usar o billing do Google Play — o Google fica com uma taxa",
    acRow13Dim: "Enviar uma atualização de sistema/firmware",
    acRow13Aosp:
      "Desenvolva hoje, em toda a frota de dispositivos amanhã — totalmente a seu critério",
    acRow13Cert:
      "Toda mudança de sistema precisa passar pelo Google ou por um laboratório 3PL antes de você poder enviá-la",
    acTableNote:
      "Apps premium como Netflix exigem a própria certificação de dispositivo e, para um ISP que os agrega, um acordo direto com a operadora — em qualquer das plataformas. O ponto positivo: nosso AOSP é Widevine L1, então, com esse acordo, a Netflix roda nele, sem certificação do Google. Vamos mapear o que cada app do seu line-up exige.",
    acSameEyebrow: "Seja qual for a sua necessidade",
    acSameTitle:
      "As duas plataformas, um único parceiro — e uma resposta direta sobre qual você precisa",
    acSameBody:
      "Vamos ser diretos: o AOSP é o nosso próprio produto, então é o que desenvolvemos e o que normalmente vamos recomendar — porque, para a maioria das operadoras, ele realmente é a melhor escolha. O que não vamos fazer é empurrá-lo quando o seu projeto precisa de certificação, nem vender certificação que você não precisa. Quando você de fato precisa dela, entregamos Android TV totalmente certificado também, trabalhando com nossos parceiros 3PL certificados na certificação. Um único relacionamento, uma única stack de operações e uma resposta direta, em vez de um discurso de venda a favor do que nos rende mais.",
    acInhouseTitle: "AOSP — desenvolvido internamente",
    acInhouseBody:
      "Um launcher Operator Tier comprovado e totalmente personalizável, mais o nosso app de IPTV, pré-instalado com os serviços locais de TV e streaming do seu mercado. Personalizado com a sua marca e validado com uma amostra funcional em 1–2 semanas.",
    acPartnerTitle: "Android TV certificado — nós o entregamos, com parceiros 3PL",
    acPartnerBody:
      "Quando a sua oferta precisa de Google Play, apps premium certificados e Widevine L1, entregamos Android TV totalmente certificado — trabalhando com nossos parceiros 3PL certificados na certificação, com a inext como seu ponto único de contato e um único time responsável.",
    acSameNoteTitle: "Uma stack opera as duas",
    acSameNoteBody:
      "Em qualquer plataforma que você decida, as mesmas operações da inext gerenciam a frota — Alcatraz DMS, OTA escalonado, TR-069 e personalização white-label. Escolher AOSP ou certificado não muda o seu dia a dia de operação.",
    acFaqEyebrow: "FAQ",
    acFaqTitle: "Perguntas frequentes",
    acFaqQ1: "Dá para rodar Netflix no AOSP da inext?",
    acFaqA1:
      "Sim — onde a sua rede detém um acordo com a Netflix. Nosso AOSP suporta Widevine L1, então, dado esse acordo com a operadora, ele roda um app da Netflix funcional, sem certificação do Google. O mesmo vale para outros serviços premium para os quais você tem acordos: você traz o acordo, nós fornecemos a plataforma pronta para L1 e a integração.",
    acFaqQ2:
      "A inext não é um fornecedor certificado de Android TV — mesmo assim, vocês conseguem entregar isso?",
    acFaqA2:
      "Sim. Desenvolvemos AOSP internamente e também entregamos Android TV totalmente certificado — trabalhando com parceiros 3PL certificados na certificação em si, com a inext como responsável principal. Você tem as duas opções e um ponto único de contato, e nós conduzimos a frente certificada para você não ter de montá-la sozinho.",
    acFaqQ3: "Com que rapidez vocês conseguem entregar uma solução AOSP?",
    acFaqA3:
      "Nossa plataforma AOSP já está desenvolvida e comprovada, então personalizá-la com a sua marca e colocar uma amostra funcional nas suas mãos normalmente leva 1–2 semanas. Do início do projeto até o envio da mercadoria costuma ser cerca de 2 meses — contra os 5–8 meses que um set-top box Android TV certificado normalmente exige — embora dependa das suas integrações, do licenciamento e do pedido.",
    acFaqQ4: "O que vem com o AOSP da inext?",
    acFaqA4:
      "Um launcher Operator Tier personalizável, o nosso app de IPTV e os serviços locais de TV e streaming do seu mercado pré-instalados. O line-up exato de apps depende do seu país e do licenciamento na sua região, por isso ajustamos a cada implantação.",
    acFaqQ5: "O que a maioria das operadoras escolhe?",
    acFaqA5:
      "A maioria escolhe AOSP — ele cobre o que o serviço delas precisa, lança mais rápido e custa menos, e ainda roda apps premium como Netflix onde elas detêm o acordo com a operadora. A certificação é a escolha certa quando você quer especificamente a Google Play Store aberta, em autoatendimento, e os serviços do Google — e entregamos isso também.",
    acFaqQ6: "A stack de operações da inext funciona nas duas?",
    acFaqA6:
      "Sim — Alcatraz DMS, atualizações OTA e TR-069 gerenciam a sua frota da mesma forma, seja AOSP ou certificado.",
    acFaqQ7: "A certificação do Google garante que meus assinantes tenham Netflix?",
    acFaqA7:
      "Não por si só — e você nem precisa dela para a Netflix. A Netflix certifica os dispositivos por conta própria e quer um acordo direto com operadoras que a agregam; dado esse acordo, nosso AOSP roda Netflix sem certificação do Google, porque é Widevine L1. O real valor da certificação do Google é a Play Store aberta, em autoatendimento, e os serviços do próprio Google (Assistant, Chromecast) — não os apps de destaque.",
    acFaqQ8: "Se eu vender assinaturas ou conteúdo, quem cuida da cobrança?",
    acFaqA8:
      "No AOSP, você — por qualquer gateway de pagamento ou parceiro que escolher, sem comissão da plataforma e sem o Google no meio. No Android TV certificado, bens digitais vendidos por um app distribuído na Play têm de usar o billing do Google Play, e o Google fica com uma fatia de cada transação. Para operadoras que monetizam os assinantes diretamente, isso pesa rápido — é um dos maiores motivos para elas ficarem no AOSP.",
    acFaqQ9: "Quem controla as atualizações de firmware (OTA) em cada plataforma?",
    acFaqA9:
      "No AOSP, você — podemos desenvolver um novo firmware e enviá-lo para toda a sua frota já no dia seguinte, sem aprovação externa. No Android TV certificado há uma barreira: o framework de certificação exige que toda mudança em nível de sistema seja reverificada pelo Google ou por um laboratório de testes 3PL designado antes de poder ser enviada — mesmo sob Operator Tier. Para operadoras que aplicam patches, ajustam ou iteram com frequência, essa é uma diferença prática importante.",
    acCtaEyebrow: "Fale com a gente",
    acCtaTitle: "Não tem certeza se o seu lançamento precisa de certificação?",
    acCtaBody:
      "Conte para nós o que os seus assinantes esperam e com que rapidez você precisa entrar no ar. Vamos recomendar a plataforma que se encaixa — AOSP ou certificado — e entregá-la.",
    acCtaPrimary: "Fale com nosso time",
    acCtaSecondary: "Solicite uma amostra AOSP",
    footerLinkGuidesOwnStb: "STB vs Smart TV",
    footerLinkGuidesBoxModels: "Subsidiar, locar, vender",
    footerLinkGuidesMulticastOtt: "Multicast vs OTT",
    footerLinkGuidesBuildBuy: "Construir ou comprar",
    guidesCardOsTitle: "STB próprio vs Smart TV",
    guidesCardOsDesc:
      "Entregar o seu box com a sua marca ou contar com as Smart TVs dos assinantes? A resposta honesta é: os dois — mas o box é a parte que é 100% sua. O argumento da operadora a favor de entregá-lo.",
    guidesCardBmTitle: "Subsidiar, locar ou vender o aparelho",
    guidesCardBmDesc:
      "Dar o aparelho, alugar ou vender de vez? Uma decisão de financiamento, não de hardware — os trade-offs de CapEx/OpEx e TCO, mais o bloqueio do DMS que mantém subsídio e locação seguros.",
    guidesCardMoTitle: "Multicast IPTV vs. OTT streaming",
    guidesCardMoDesc:
      "Um stream eficiente compartilhado por todos na sua rede gerenciada, ou um stream adaptativo por assinante pela internet? Os trade-offs honestos de largura de banda, qualidade, latência e alcance — e por que muitas operadoras rodam os dois.",
    guidesCardBbTitle: "Construir ou comprar o seu STB",
    guidesCardBbDesc:
      "Desenvolver a sua própria plataforma de set-top box ou comprar um stack pronto? “Construir” significa ser dono de oito camadas — do silício ao suporte. Um guia honesto de fazer ou comprar para operadoras, e quando cada lado vence.",
    footerLinkGuidesStbChecklist: "Checklist para comprar STBs",
    guidesCardSbcTitle: "Checklist para comprar STBs",
    guidesCardSbcDesc:
      "Antes de comprar set-top boxes, avalie o conjunto completo: hardware, codecs, rede, DRM, apps, gerenciamento da frota, personalização, garantia e logística.",
    sbcSeoTitle: "Checklist para comprar STBs de IPTV: como escolher set-top boxes | inext",
    sbcSeoDescription:
      "Checklist prático para provedores, operadoras de IPTV e OTT, empresas de telecomunicações, hotelaria, projetos MDU e distribuidores que escolhem set-top boxes.",
    sbcBreadcrumbPage: "Checklist para comprar STBs",
    sbcHeroEyebrow: "Checklist do comprador",
    sbcHeroTitle: "Checklist para comprar STBs:",
    sbcHeroTitleAccent: "o que avaliar antes de escolher os aparelhos",
    sbcHeroSub:
      "Um bom set-top box não se resume a chipset e preço. Hardware, firmware, apps, proteção de conteúdo, controle remoto, gerenciamento da frota, suporte e logística precisam funcionar juntos depois da primeira entrega.",
    sbcHeroNote:
      "Use este checklist antes de validar amostras, selecionar fornecedores ou fechar um pedido em volume. Ele foi criado para provedores de internet, operadoras de IPTV e OTT, empresas de telecomunicações, projetos de hotelaria e MDU e distribuidores que atendem operadoras.",
    sbcHeroCtaPrimary: "Fale com nosso time",
    sbcHeroCtaSecondary: "Abrir o checklist",
    sbcStat1: "Hardware e software integrados",
    sbcStat2: "Amostra antes do pedido",
    sbcStat3: "Gestão de frota é essencial",
    sbcThesisEyebrow: "Comece por aqui",
    sbcThesisTitle: "Compre a plataforma de serviço, não apenas o aparelho",
    sbcThesisBody1:
      "Uma Android TV box de varejo e baixo custo pode parecer atraente na planilha, mas serviços de TV gerenciados precisam de um aparelho que possa ser personalizado, provisionado, bloqueado, atualizado e assistido em milhares de residências, quartos de hotel ou instalações de parceiros.",
    sbcThesisBody2:
      "O STB certo depende do modelo de serviço: IPTV gerenciada em rede privada, streaming centrado em OTT, serviço híbrido de IPTV e OTT, televisão para hotelaria ou MDU ou revenda por distribuidores. O checklist é o mesmo, mas a importância de cada item muda.",
    sbcThesisNoteTitle: "A regra prática",
    sbcThesisNoteBody:
      "Se um requisito afeta a experiência do assinante, o acesso ao conteúdo, o custo de suporte ou o controle da frota, valide-o em uma amostra real antes de aprovar o pedido.",
    sbcBuyerEyebrow: "Casos de uso",
    sbcBuyerTitle: "Combine o aparelho com o serviço oferecido",
    sbcBuyerIntro:
      "O mesmo modelo pode atender a vários projetos, mas os critérios de compra mudam. Comece pelo serviço e depois escolha a categoria de hardware.",
    sbcBuyer1Title: "IPTV gerenciada",
    sbcBuyer1Body:
      "Priorize Ethernet, suporte a multicast, firmware estável, tela inicial simples, diagnóstico remoto e decodificação previsível para TV ao vivo.",
    sbcBuyer2Title: "TV centrada em OTT",
    sbcBuyer2Body:
      "Priorize o desempenho dos apps, a compatibilidade com DRM, o espaço de armazenamento, o comportamento do Wi-Fi, o streaming adaptativo e um controle remoto fácil de usar.",
    sbcBuyer3Title: "Híbrido IPTV e OTT",
    sbcBuyer3Body:
      "Verifique se o aparelho alterna entre TV ao vivo por multicast, VOD unicast, catch-up, portais e apps da operadora sem confundir o usuário.",
    sbcBuyer4Title: "Hotelaria e MDU",
    sbcBuyer4Body:
      "Procure uma interface restrita, sem dependência de contas pessoais, configurações centralizadas, provisionamento em massa e substituição simples em campo.",
    sbcBuyer5Title: "Avaliação para distribuidores",
    sbcBuyer5Body:
      "Valide embalagem, opções de acessórios, processo de garantia, localização de conteúdo, logística e capacidade do fornecedor de manter versões específicas para operadoras.",
    sbcTableEyebrow: "O checklist",
    sbcTableTitle: "O que verificar antes de comprar STBs",
    sbcTableIntro:
      "Trate cada linha como um item a validar na amostra, não como uma afirmação de catálogo. Um bom fornecedor deve comprovar a resposta em hardware real.",
    sbcTableColCheck: "Verifique",
    sbcTableColWhy: "Por que importa",
    sbcTableColNote: "Nota do comprador",
    sbcRow1Check: "Maturidade do chipset e da plataforma",
    sbcRow1Why:
      "O SoC determina a decodificação, o nível de DRM, a estabilidade dos drivers, o comportamento térmico e por quanto tempo o firmware poderá ser mantido.",
    sbcRow1Note:
      "Pergunte qual plataforma o fornecedor já entrega em escala, não apenas o que consegue montar como projeto isolado.",
    sbcRow2Check: "RAM e armazenamento",
    sbcRow2Why:
      "Pouca memória deixa telas iniciais e apps OTT lentos; pouco armazenamento limita apps, registros e atualizações.",
    sbcRow2Note:
      "Uma solução de IPTV enxuta pode funcionar com menos recursos. Implantações Android com muitos apps precisam de mais margem.",
    sbcRow3Check: "Requisitos de vídeo, áudio e 4K",
    sbcRow3Why:
      "Codecs, HDR, resolução e suporte de áudio determinam se o serviço reproduz bem nas TVs que os assinantes realmente usam.",
    sbcRow3Note: "Teste canais ao vivo e conteúdos VOD reais, não apenas vídeos de demonstração.",
    sbcRow4Check: "Ethernet e comportamento multicast",
    sbcRow4Why:
      "Serviços de IPTV gerenciada e redes de hotelaria frequentemente dependem de Ethernet cabeada, IGMP e reprodução multicast estável.",
    sbcRow4Note:
      "Se multicast for importante, teste-o no switch e na arquitetura da rede de destino.",
    sbcRow5Check: "Wi-Fi e OTT fora da rede",
    sbcRow5Why:
      "Serviços OTT, cômodos secundários e muitas instalações residenciais dependem da qualidade do Wi-Fi, do comportamento em roaming e do streaming adaptativo.",
    sbcRow5Note:
      "Teste quartos com sinal fraco e apartamentos congestionados, não só um laboratório limpo.",
    sbcRow6Check: "Prontidão para DRM e CAS",
    sbcRow6Why:
      "Conteúdo premium exige o nível correto de DRM, provisionamento de chaves, integração com parceiros e, em alguns casos, suporte a CAS.",
    sbcRow6Note:
      "Confirme o fluxo real do conteúdo: Widevine, Verimatrix, app do portal, contrato da operadora e provisionamento em fábrica.",
    sbcRow7Check: "Sistema operacional e estratégia de apps",
    sbcRow7Why:
      "AOSP, Android TV certificado e Linux mudam a disponibilidade de apps, o custo de certificação, o controle das atualizações e o prazo de lançamento.",
    sbcRow7Note:
      "Escolha o sistema operacional com base nos apps e no modelo de controle, não em uma preferência genérica de plataforma.",
    sbcRow8Check: "Gerenciamento de dispositivos e OTA",
    sbcRow8Why:
      "Sem provisionamento remoto, diagnóstico, atualizações em etapas e bloqueio, cada problema em campo se torna caro.",
    sbcRow8Note: "Peça para ver o fluxo de DMS antes de aprovar o aparelho.",
    sbcRow9Check: "Controle remoto e UX diário",
    sbcRow9Why:
      "O controle remoto, a tela inicial, a sequência de inicialização e as telas de configuração moldam a experiência diária mais do que a ficha técnica.",
    sbcRow9Note:
      "Teste com usuários não técnicos e confira a disposição dos botões, o funcionamento por infravermelho ou Bluetooth e a tradução da interface.",
    sbcRow10Check: "Marca, embalagem e acessórios",
    sbcRow10Why:
      "O aparelho, o controle remoto, a fonte de alimentação, o cabo HDMI, as etiquetas e o guia rápido afetam o suporte e a percepção de qualidade.",
    sbcRow10Note:
      "Confirme com antecedência os plugues, idiomas, etiquetas, organização da caixa e disponibilidade de acessórios de reposição.",
    sbcRow11Check: "Garantia, peças e logística",
    sbcRow11Why:
      "Um pedido de hardware em volume é uma operação contínua: prazos, RMA, unidades de reposição e rotas de transporte importam depois do lançamento.",
    sbcRow11Note: "Separe o envio das amostras de avaliação da logística dos pedidos de produção.",
    sbcRow12Check: "Suporte do fornecedor e ciclo de vida",
    sbcRow12Why:
      "Um aparelho que funciona hoje ainda precisará de firmware, atualizações de apps, correções de segurança e planejamento de substituição.",
    sbcRow12Note:
      "Prefira fornecedores que expliquem o suporte durante todo o ciclo de vida do aparelho.",
    sbcTableNote:
      "A melhor escolha costuma ser o aparelho que reduz mais riscos de lançamento e suporte, não aquele com a lista de especificações mais longa.",
    sbcModelEyebrow: "Adequação dos modelos",
    sbcModelTitle: "Uma forma prática de dimensionar a linha inext",
    sbcModelIntro:
      "Estas não são regras rígidas. São um ponto de partida para relacionar a complexidade do serviço à capacidade do hardware antes de testar a amostra.",
    sbcModelTv5Body:
      "Uma opção enxuta para implantações IPTV controladas, telas iniciais simples e projetos sensíveis a custo com poucos apps.",
    sbcModelTv5Meta: "IPTV enxuta",
    sbcModelTv5UltraBody:
      "Mais capacidade para experiências Android personalizadas, apps adicionais e implantações convencionais que exigem equilíbrio de preço.",
    sbcModelTv5UltraMeta: "Android equilibrado",
    sbcModelTv6Body:
      "Uma boa opção para serviços híbridos modernos de IPTV e OTT, com mais capacidade para interface, apps e atualizações.",
    sbcModelTv6Meta: "Híbrido versátil",
    sbcModelTv6UltraBody:
      "A opção premium para conjuntos maiores de apps, mais margem para o ciclo de vida e implantações avançadas de TV gerenciada.",
    sbcModelTv6UltraMeta: "Configuração premium",
    sbcModelCta: "Comparar todos os modelos STB",
    sbcRedFlagsEyebrow: "Sinais de alerta",
    sbcRedFlagsTitle: "Sinais de alerta antes de um pedido em volume",
    sbcRedFlagsIntro:
      "A maioria dos problemas de STB aparece na avaliação quando o comprador testa as coisas certas.",
    sbcRedFlag1:
      "O fornecedor oferece uma Android TV box de varejo sem firmware para operadoras, controle da tela inicial ou gerenciamento de frota.",
    sbcRedFlag2:
      "O suporte a DRM, CAS ou apps premium é descrito de forma vaga, sem um processo claro de provisionamento e licenciamento.",
    sbcRedFlag3:
      "As atualizações OTA são manuais, atingem toda a frota de uma vez ou dependem da ação do assinante.",
    sbcRedFlag4:
      "Não há como bloquear, suspender, reconfigurar ou diagnosticar os aparelhos remotamente.",
    sbcRedFlag5:
      "O funcionamento de Ethernet, multicast ou Wi-Fi é prometido, mas não demonstrado na rede de destino.",
    sbcRedFlag6:
      "Embalagem, acessórios, plugues, etiquetas ou manuais são tratados como detalhes de última hora.",
    sbcRedFlag7:
      "O fornecedor não consegue explicar o processo de garantia, as unidades de reposição, o ciclo de vida do firmware ou a logística de produção.",
    sbcSampleEyebrow: "Validação da amostra",
    sbcSampleTitle: "O que testar no aparelho de amostra",
    sbcSampleIntro:
      "Uma amostra não é uma lembrança. É a prova de que o aparelho pode integrar uma frota gerenciada.",
    sbcSample1:
      "Inicie o aparelho a frio na tela inicial personalizada e confirme a experiência da primeira tela.",
    sbcSample2:
      "Reproduza IPTV ao vivo, streams OTT, VOD e catch-up usando as fontes reais do serviço.",
    sbcSample3: "Teste o multicast ou o portal na rede de destino, não apenas no laboratório.",
    sbcSample4: "Valide conteúdo protegido por DRM e todos os apps premium exigidos pelo serviço.",
    sbcSample5: "Envie uma atualização de app ou firmware pelo sistema de gerenciamento.",
    sbcSample6: "Confirme se o aparelho aparece no DMS com diagnóstico, grupos e ações remotas.",
    sbcSample7: "Teste suspensão, bloqueio de rede ou modo quiosque se o modelo comercial exigir.",
    sbcSample8:
      "Avalie o controle remoto: ergonomia, mapeamento de botões, pareamento e possíveis dúvidas de suporte.",
    sbcSample9:
      "Mantenha o aparelho em uso por tempo suficiente para detectar aquecimento, reinicializações e problemas de Wi-Fi ou memória.",
    sbcSample10:
      "Revise a embalagem, os plugues, as etiquetas, os acessórios e os materiais de início rápido traduzidos.",
    sbcFitEyebrow: "Onde a inext entra",
    sbcFitTitle: "Ajudamos a validar o conjunto completo",
    sbcFitBody:
      "A inext reúne hardware, firmware, tela inicial, app de IPTV, Alcatraz DMS, OTA, personalização de marca e logística B2B mundial em uma única solução gerenciada de STB. Assim, o mesmo fornecedor responde pelas questões de hardware, software e implantação antes do pedido em volume.",
    sbcFitCtaDms: "Ver Alcatraz DMS",
    sbcFitCtaLogistics: "Ver logística",
    sbcFaqEyebrow: "FAQ",
    sbcFaqTitle: "Perguntas comuns",
    sbcFaqQ1: "Isso é só para operadoras IPTV?",
    sbcFaqA1:
      "Não. O checklist serve a qualquer organização que avalie dispositivos para serviços de TV gerenciados: provedores de internet, operadoras de IPTV e OTT, empresas de telecomunicações, projetos de hotelaria e MDU e distribuidores que compram para clientes operadores.",
    sbcFaqQ2: "Devo escolher Android, AOSP, Android TV certificado ou Linux?",
    sbcFaqA2:
      "Escolha com base no serviço. Android ou AOSP atendem bem a implantações com muitos apps e forte presença de OTT; Android TV certificado serve a projetos que precisam especificamente do ecossistema certificado do Google; e Linux pode ser adequado a implantações controladas somente de IPTV. O importante é alinhar sistema operacional, apps, certificação e controle de atualizações.",
    sbcFaqQ3: "De quanta RAM e armazenamento eu preciso?",
    sbcFaqA3:
      "Uma solução de IPTV enxuta pode usar um aparelho mais simples. Uma experiência Android moderna, com vários apps, interface mais rica e ciclo de vida mais longo, precisa de mais margem. A resposta mais segura é testar a tela inicial, os apps e o pacote de atualização reais no modelo candidato.",
    sbcFaqQ4: "Ethernet ainda importa se OTT funciona por Wi-Fi?",
    sbcFaqA4:
      "Sim. OTT pode funcionar por Wi-Fi, mas IPTV gerenciada, multicast e muitas redes de hotelaria ou MDU ainda dependem de Ethernet cabeada para oferecer qualidade previsível.",
    sbcFaqQ5: "Um STB pode lidar com IPTV e OTT?",
    sbcFaqA5:
      "Sim, desde que o hardware, o firmware e o app sejam preparados para ambos. Antes de fechar o pedido, teste TV ao vivo por multicast ou portal, streams OTT, VOD e catch-up na mesma amostra.",
    sbcFaqQ6: "Quando devo solicitar uma amostra de avaliação?",
    sbcFaqA6:
      "Antes da aprovação comercial. A amostra deve ser testada com o portal, o conteúdo, a rede, o fluxo de DRM, a tela inicial, o controle remoto, o DMS e os requisitos reais de embalagem.",
    sbcFaqQ7: "O que distribuidores devem verificar de forma diferente?",
    sbcFaqA7:
      "Distribuidores devem validar não apenas o aparelho, mas também a padronização da embalagem, as opções de acessórios, os plugues regionais, o processo de garantia, a localização de conteúdo, os prazos e a capacidade do fornecedor de manter versões específicas para operadoras.",
    sbcCtaEyebrow: "Fale com a gente",
    sbcCtaTitle: "Valide o aparelho antes da implantação",
    sbcCtaBody:
      "Conte qual é o seu modelo de serviço, a rede, os requisitos de apps e a faixa de preço desejada. Ajudaremos a escolher o STB inext adequado, personalizar uma amostra e validar o conjunto antes do pedido de produção.",
    sbcCtaPrimary: "Fale com nosso time",
    sbcCtaSecondary: "Solicite uma amostra",
    osSeoTitle: "STB próprio vs Smart TV: por que operadoras entregam o seu box | inext",
    osSeoDescription:
      "Uma operadora deve entregar set-top boxes com a sua marca ou contar com as Smart TVs dos assinantes? A resposta honesta é: os dois — mas o seu set-top box é a parte que você controla por inteiro. O argumento da operadora a favor do box.",
    osBreadcrumbPage: "STB próprio vs Smart TV",
    osHeroEyebrow: "Guia de estratégia",
    osHeroTitle: "Seu set-top box vs. a Smart TV do assinante:",
    osHeroTitleAccent: "por que você quer os dois",
    osHeroSub:
      "A maioria dos assinantes já tem uma Smart TV, então é tentador pular o hardware e entregar só um app. Para uma operadora séria, a resposta honesta é fazer as duas coisas — apps de Smart TV e mobile para alcance, e o seu set-top box com a sua marca como o núcleo que você controla. A diferença é a propriedade: o set-top box é a única plataforma que você controla por inteiro, no seu ritmo, sem nenhum terceiro capaz de mudar as regras do jogo.",
    osHeroNote:
      "O box com a sua marca — e o app que roda nele — é o que desenvolvemos, e a parte que é totalmente sua. Esta página defende esse argumento.",
    osHeroCtaPrimary: "Fale com nosso time",
    osHeroCtaSecondary: "Veja o que você controla",
    osStat1: "Sua marca no box e no controle remoto",
    osStat2: "100% de controle — no seu ritmo",
    osStat3: "Qualquer TV, qualquer cômodo",
    osThesisEyebrow: "Comece por aqui",
    osThesisTitle: "Controle o núcleo, alcance todo lugar",
    osThesisBody1:
      "Não se trata de hardware contra apps — e sim do que é seu. Apps de Smart TV, mobile e web colocam o seu serviço em telas que os assinantes já têm. Eles importam para o alcance, e você deveria entregá-los. Mas nessas plataformas você é inquilino: o aparelho, a tela inicial, as regras e os dados pertencem a Samsung, LG, Google ou Apple.",
    osThesisBody2:
      "O seu set-top box é a exceção. É o único aparelho inteiramente seu — seu launcher na inicialização, seu cronograma de atualizações, seu DRM, seus dados, sua cobrança. É onde você garante a experiência e ancora a relação com o assinante. A configuração vencedora combina um box com a sua marca, controlado, no núcleo, com apps em todo o resto para o alcance.",
    osThesisCoreLabel: "Núcleo próprio",
    osThesisCoreValue: "Seu set-top box com a sua marca",
    osThesisReachLabel: "Alcance (você é convidado)",
    osThesisReachValue: "Smart TV · mobile · apps web",
    osOwnRentEyebrow: "Ser dono vs. alugar",
    osOwnRentTitle: "No seu box, quem dita as regras é você. Na Smart TV, é outra pessoa.",
    osOwnColTitle: "No seu set-top box, você controla",
    osOwnItem1: "A tela inicial — seu launcher abre na inicialização",
    osOwnItem2: "Atualizações e novos recursos — no seu cronograma",
    osOwnItem3: "DRM, segurança e integração com apps premium",
    osOwnItem4: "Cobrança, anúncios e espaço de upsell — sem fatia da plataforma",
    osOwnItem5: "Telemetria do aparelho e dados de audiência — são seus",
    osOwnItem6: "Por quanto tempo o aparelho segue com suporte",
    osRentColTitle: "Na Smart TV do assinante, quem controla é o fabricante",
    osRentItem1: "A tela inicial — seu app é um ícone entre muitos",
    osRentItem2: "A aprovação na loja de apps e as atualizações do SO — no cronograma deles",
    osRentItem3: "Quais níveis de DRM e codecs a TV suporta",
    osRentItem4: "Taxas e termos da loja — eles podem aumentar a qualquer momento",
    osRentItem5: "Os dados da plataforma — você fica com migalhas do nível do app",
    osRentItem6: "Quando os modelos antigos perdem suporte e o seu app para de funcionar",
    osBenefitsEyebrow: "O argumento a favor do box",
    osBenefitsTitle: "O que entregar o seu próprio set-top box traz para você",
    osBenefit1Title: "Sua marca, todo dia",
    osBenefit1Body:
      "Seu launcher é a primeira tela na TV, e seu logo está no box e no controle remoto que o assinante segura toda noite. Essa presença de marca diária e física cria vínculo, te mantém em primeiro lugar na cabeça dele e faz da troca uma decisão mais pesada.",
    osBenefit2Title: "Soberania de plataforma",
    osBenefit2Body:
      "Nenhum terceiro pode mudar as regras do jogo. Samsung, LG ou Google podem redesenhar a tela inicial, promover um rival, aumentar taxas ou cortar o suporte de TVs antigas — e nas plataformas deles você não pode impedir nada disso. No seu box, cada uma dessas decisões é sua.",
    osBenefit3Title: "Gerenciamento remoto, menos suporte",
    osBenefit3Body:
      "Com o Alcatraz DMS e o TR-069, você monitora, diagnostica, configura, atualiza e reinicia os boxes remotamente — menos visitas técnicas, correções mais rápidas. A Smart TV do assinante é uma caixa-preta: todo problema vira ‘é a sua TV, a sua rede ou o nosso app?’.",
    osBenefit4Title: "QoE que você garante",
    osBenefit4Body:
      "Você define o chipset, os codecs, o 4K e o Wi-Fi, então o serviço entrega o mesmo desempenho para todo mundo. Numa Smart TV antiga ou barata, seu stream trava ou nem decodifica — e a culpa cai em você, por um hardware que você não controla.",
    osBenefit5Title: "Lance recursos primeiro",
    osBenefit5Body:
      "Um codec novo, catch-up, cloud DVR ou uma repaginada na UI chega à sua frota inteira na hora. Nas Smart TVs, você espera o suporte e a recertificação de cada plataforma, e os modelos antigos nunca recebem.",
    osBenefit6Title: "Alcance toda TV e todo cômodo",
    osBenefit6Body:
      "Um box transforma qualquer TV com HDMI — modelos antigos, quartos, a cozinha, a casa de praia — na sua plataforma. O caminho só com Smart TV exclui, sem alarde, todas essas telas, e os assinantes que nem têm uma Smart TV.",
    osBenefit7Title: "Fique com o que você vende",
    osBenefit7Body:
      "No seu set-top box, você roda a sua própria cobrança e o seu próprio espaço de anúncios e upsell, sem nenhuma loja tirando uma fatia — e mantém os dados de audiência e do aparelho para agir sobre eles, em vez de entregá-los ao fabricante da TV.",
    osBenefit8Title: "Abra B2B e hospitalidade",
    osBenefit8Body:
      "Hotéis, prédios de apartamentos, hospitais e bares precisam de aparelhos gerenciados centralmente e bloqueados, sem logins pessoais — algo que o caminho só de app não entrega. O seu set-top box abre esses mercados.",
    osBenefit9Title: "Valor na sua rede",
    osBenefit9Body:
      "Um set-top box gerenciado é um ativo na sua rede, não só na sala de estar: a entrega eficiente em multicast/gerenciada mantém o vídeo on-net — mais leve em banda e trânsito do que o OTT puxado pela internet pública — e, como endpoint gerenciado, te dá visibilidade de QoE bem na borda. Para um ISP, ele ainda amarra a TV à banda larga e eleva o ARPU.",
    osScenarioTitle: "Uma terça-feira na plataforma dos outros",
    osScenarioBody:
      "Imagine a cena: numa terça-feira, um fabricante de TVs redesenha a tela inicial, enterra o seu app atrás de um banner e começa a promover um serviço concorrente em toda a sua região. Nas Smart TVs, não há nada que você possa fazer — a tela inicial é deles, a decisão é deles, e nenhum chamado de suporte de uma operadora muda o marketing de um fabricante. Nos seus set-top boxes, nada muda: a tela inicial continua sendo sua, porque o aparelho é. Essa é a diferença entre alugar um espaço e ser dono da plataforma.",
    osHiddenEyebrow: "O trade-off honesto",
    osHiddenTitle: "Só com Smart TV parece mais barato do que é",
    osHiddenBody:
      "Pular o box economiza hardware e logística lá no início — isso é real, e para uma jogada de OTT puro ou D2C pode ser a escolha certa. Mas Smart TVs ‘de graça’ trazem custos que você paga depois:",
    osHidden1:
      "Uma caixa-preta de suporte — você não enxerga nem conserta o aparelho, então todo problema é chute",
    osHidden2:
      "QoE pela qual você leva a culpa — TVs antigas e baratas fazem seu serviço parecer ruim num hardware que não é seu",
    osHidden3:
      "Um imposto de fragmentação — desenvolver e certificar apps para Tizen, webOS, Android TV, Fire TV, Apple TV e mais, cada um com suas manias e seu DRM",
    osHidden4:
      "Risco de plataforma — taxas, políticas, anúncios e suporte do SO mudam nos termos do fabricante, não nos seus",
    osSameEyebrow: "Onde a gente entra",
    osSameTitle: "Construímos o box que é seu",
    osSameBody:
      "Não vamos te convencer a abrir mão dos apps de Smart TV e mobile — entregue-os, você precisa do alcance. O que construímos é a parte que é totalmente sua: o seu set-top box com a sua marca. Seu launcher Operator Tier na inicialização, seu app de IPTV, seus serviços pré-instalados e a frota inteira gerenciada de ponta a ponta com Alcatraz DMS, OTA e TR-069. Os apps te estendem para telas que você não controla; o box é a base — totalmente sua, operada no seu ritmo.",
    osSameNoteTitle: "É o controle mais barato que você vai comprar",
    osSameNoteBody:
      "Um box é um item pequeno diante do churn, da carga de suporte e do risco de plataforma que ele elimina. Ajudamos você a especificar o certo, colocar a sua marca até no controle remoto e ter uma amostra funcional nas suas mãos em 1–2 semanas.",
    osFaqEyebrow: "FAQ",
    osFaqTitle: "Perguntas frequentes",
    osFaqQ1: "A maioria dos meus assinantes já tem uma Smart TV — por que entregar um box?",
    osFaqA1:
      "Porque a Smart TV é deles e do fabricante, não sua. O box é onde você controla a experiência, coloca a sua marca, gerencia e dá suporte remotamente, garante o desempenho e mantém a sua cobrança e os seus dados. Entregue apps para as Smart TVs pelo alcance — mas o box é a sua âncora, e ele ainda cobre as segundas TVs e os assinantes que não têm Smart TV.",
    osFaqQ2: "Entregar hardware não sai caro demais?",
    osFaqA2:
      "Um box custa por volta de US$ 30–50, diluído ao longo da vida do assinante — pouco diante do que ele economiza. O gerenciamento remoto corta custos de suporte e visitas técnicas, o aparelho com a sua marca reduz o churn, e você fica com a receita de cobrança da qual nenhuma loja tira uma fatia. Para a maioria das operadoras ele se paga; ajudamos você a montar essa conta.",
    osFaqQ3: "Posso começar só com app e adicionar set-top boxes depois?",
    osFaqA3:
      "Pode — muitas fazem assim. Mas as operadoras que são donas da relação lideram com o box para os seus assinantes principais e usam os apps para o alcance. Se você começar só com app, planeje o set-top box cedo: é ele que transforma um app de conteúdo num serviço controlado e com a sua marca.",
    osFaqQ4: "E quanto a hotéis, prédios de apartamentos e outros B2B?",
    osFaqA4:
      "Esse é território de set-top box. Implantações em hospitalidade e MDU precisam de aparelhos gerenciados centralmente e bloqueados, sem logins pessoais — exatamente o que um set-top box gerenciado entrega e um app na TV do próprio hóspede não consegue.",
    osFaqQ5: "Eu perco alguma coisa ao entregar um box?",
    osFaqA5:
      "Você assume o custo do hardware e a logística — real, mas nós cuidamos da fabricação, da marca e da entrega no mundo todo, e personalizamos uma amostra funcional em 1–2 semanas. Em troca, você ganha controle, presença de marca, menos suporte e um assinante mais fiel. Para uma operadora de serviço gerenciado, essa troca costuma valer a pena.",
    osFaqQ6: "O box me prende a um único app ou serviço?",
    osFaqA6:
      "Não — a plataforma é sua. Você escolhe o launcher, os apps, os serviços e a cadência de atualizações. É justamente esse o ponto: no seu set-top box, o roadmap é seu, não de um fabricante de TVs.",
    osCtaEyebrow: "Fale com a gente",
    osCtaTitle: "Seja dono da tela que seus assinantes mais assistem",
    osCtaBody:
      "Conte pra gente sobre o seu serviço e a sua frota. Vamos especificar um set-top box com a sua marca, personalizá-lo do seu jeito e colocar uma amostra funcional nas suas mãos — rápido.",
    osCtaPrimary: "Fale com nosso time",
    osCtaSecondary: "Solicitar uma amostra",
    bmSeoTitle: "Subsidiar, locar ou vender o STB? CapEx vs OpEx para operadoras | inext",
    bmSeoDescription:
      "Dar o aparelho, alugar ou vender de vez? É uma decisão de financiamento, não de hardware. Os trade-offs de CapEx/OpEx e TCO de subsidiar, locar e vender set-top boxes — e o bloqueio do DMS que mantém subsídio e locação seguros.",
    bmBreadcrumbPage: "Subsidiar, locar ou vender",
    bmHeroEyebrow: "Guia comercial",
    bmHeroTitle: "Subsidiar, locar ou vender seus STBs:",
    bmHeroTitleAccent: "é uma decisão de financiamento",
    bmHeroSub:
      "O mesmo aparelho gerenciado chega ao assinante de três jeitos — dado a ele, alugado ou vendido. O que muda não é o hardware; é quem banca, quem é dono e como você recupera o investimento. Escolha o modelo errado para um segmento e você ou deixa dinheiro na mesa, ou carrega um risco que não enxerga. A maioria das operadoras não escolhe um só — roda dois ou três ao mesmo tempo.",
    bmHeroNote:
      "O mesmo STB inext atende aos três, e o bloqueio do Alcatraz DMS é o que torna seguro dar ou alugar um aparelho. Este é o manual da operadora para escolher — e combinar — cada modelo.",
    bmHeroCtaPrimary: "Fale com nosso time",
    bmHeroCtaSecondary: "Veja como o bloqueio ajuda",
    bmStat1: "Um aparelho, três modelos",
    bmStat2: "CapEx ou OpEx — você decide",
    bmStat3: "O bloqueio mantém tudo seguro",
    bmThesisEyebrow: "Comece por aqui",
    bmThesisTitle: "É uma decisão de financiamento, não de hardware",
    bmThesisBody1:
      "O set-top box costuma ser a maior linha de hardware do orçamento de uma operadora, e cresce a cada novo assinante. Então como o aparelho chega à casa não é um detalhe de logística: define o seu fluxo de caixa, o que entra no seu balanço e o quanto é difícil para o assinante ir embora. O aparelho em si é idêntico nos três modelos. A decisão é puramente financeira.",
    bmThesisBody2:
      "E raramente é uma decisão só. A mesma operadora pode subsidiar aparelhos para conquistar assinantes premium e de triple-play, locar para a base mainstream e vender de vez para clientes pré-pago, B2B ou de segunda TV — e depois mover assinantes entre os modelos com o tempo. A pergunta de verdade não é “qual modelo”, e sim “qual modelo para qual assinante, e como mantenho isso seguro?”.",
    bmThesisCoreLabel: "Um ativo",
    bmThesisCoreValue: "Seu STB gerenciado",
    bmThesisReachLabel: "Três modelos comerciais",
    bmThesisReachValue: "Subsidiar · Locar · Vender",
    bmModelsEyebrow: "Os três modelos",
    bmModelsTitle: "Três jeitos de colocar um aparelho na casa",
    bmModelLabelUpfront: "Antecipado",
    bmModelLabelOwns: "Quem é dono",
    bmModelLabelRevenue: "Como você ganha",
    bmModelLabelBest: "Melhor para",
    bmModel1Name: "Subsidiar",
    bmModel1Tagline: "Dê o aparelho, conquiste o assinante.",
    bmModel1Upfront: "Você banca lá no início — CapEx no dia um.",
    bmModel1Owns: "Em geral, o assinante, após um período mínimo.",
    bmModel1Revenue: "Recuperado pela assinatura ao longo do contrato.",
    bmModel1Best: "Aquisição competitiva, pacotes premium e triple-play.",
    bmModel2Name: "Locar / alugar",
    bmModel2Tagline: "Fique com o ativo, cobre por mês.",
    bmModel2Upfront: "Você banca, mas ele continua sendo seu ativo.",
    bmModel2Owns: "Você — por toda a vida do aparelho.",
    bmModel2Revenue: "Uma linha de aluguel recorrente; recupere e reimplante na devolução.",
    bmModel2Best: "Receita recorrente, baixa barreira, hardware que você reaproveita.",
    bmModel3Name: "Vender",
    bmModel3Tagline: "Dinheiro agora, nada para carregar.",
    bmModel3Upfront: "O assinante paga — à vista ou parcelado.",
    bmModel3Owns: "O assinante, desde o dia um.",
    bmModel3Revenue: "Receita única de hardware; nenhum ativo a depreciar.",
    bmModel3Best: "Pré-pago, segundas TVs, B2B, um balanço mais leve.",
    bmTableEyebrow: "Lado a lado",
    bmTableTitle: "Como os três se comparam",
    bmTableColDimension: "",
    bmTableColSubsidize: "Subsidiar",
    bmTableColLease: "Locar",
    bmTableColSell: "Vender",
    bmRow1Label: "Custo antecipado",
    bmRow1Sub: "Operadora (CapEx)",
    bmRow1Lease: "Operadora (CapEx, retido)",
    bmRow1Sell: "Assinante",
    bmRow2Label: "No seu balanço",
    bmRow2Sub: "Ativo, depois baixado",
    bmRow2Lease: "Ativo, depreciado ao longo da vida útil",
    bmRow2Sell: "Nada — está vendido",
    bmRow3Label: "Fluxo de caixa",
    bmRow3Sub: "Sai agora, volta ao longo do contrato",
    bmRow3Lease: "Sai agora, volta de forma recorrente",
    bmRow3Sell: "Entra agora",
    bmRow4Label: "Receita recorrente",
    bmRow4Sub: "Dentro da assinatura",
    bmRow4Lease: "Uma linha de aluguel à parte",
    bmRow4Sell: "Nenhuma sobre o hardware",
    bmRow5Label: "Barreira para o assinante",
    bmRow5Sub: "Mínima — é de graça",
    bmRow5Lease: "Baixa — uma mensalidade pequena",
    bmRow5Sell: "Máxima — paga adiantado",
    bmRow6Label: "Fidelidade",
    bmRow6Sub: "O período do contrato",
    bmRow6Lease: "Devolva para sair",
    bmRow6Sell: "Mínima — o aparelho é dele",
    bmRow7Label: "Se sair antes do prazo",
    bmRow7Sub: "Subsídio não recuperado",
    bmRow7Lease: "Recupere e reimplante",
    bmRow7Sell: "Já foi pago — sem exposição",
    bmTableSafeLabel: "O que mantém seguro",
    bmTableSafeValue: "Alcatraz DMS — net-lock · app-lock · suspensão remota · recuperação OTA",
    bmTableNote:
      "O aparelho é o mesmo em todas as colunas — só o dinheiro e a propriedade mudam de lugar.",
    bmTcoEyebrow: "Os números, por alto",
    bmTcoTitle: "Mesmo aparelho, três formatos de fluxo de caixa",
    bmTcoBody:
      "O modelo não muda quanto um aparelho custa — muda quando o dinheiro se move. Pegue um aparelho gerenciado e siga o caixa:",
    bmTco1Title: "Subsidiar",
    bmTco1Body:
      "Você gasta o custo do aparelho no dia um e recupera pela assinatura. O payback é, grosso modo, custo do aparelho ÷ margem mensal; mantenha o assinante além desse ponto e o resto é lucro. Perca-o antes disso e a parte não recuperada é o seu prejuízo — que é exatamente o que o período mínimo e o bloqueio remoto estão ali para proteger.",
    bmTco2Title: "Locar",
    bmTco2Body:
      "Você ainda banca o aparelho, mas o aluguel mensal o transforma num fluxo recorrente que pode render mais do que custou ao longo da vida do aparelho. Como você mantém a propriedade, uma unidade devolvida é zerada, reprovisionada e reemitida — então um aparelho pode atender a vários assinantes antes de se aposentar.",
    bmTco3Title: "Vender",
    bmTco3Body:
      "O assinante banca o hardware, então nada fica no seu balanço e nenhum capital de giro fica preso. Você troca um pouco de fidelidade por dinheiro hoje e uma operação mais leve — em geral, a escolha certa para pré-pago ou B2B.",
    bmTcoNote:
      "Ilustrativo, não é uma cotação — a sua resposta de verdade depende do custo do aparelho, da margem, da retenção e do reaproveitamento. Ajudamos você a passar os seus próprios números por essa conta.",
    bmLockEyebrow: "O que torna seguro",
    bmLockTitle: "Controle no software, não na confiança",
    bmLockBody:
      "O risco de subsidiar ou locar é simples: o assinante para de pagar, ou o aparelho nunca volta. O Alcatraz DMS transforma esse risco numa configuração. O net-lock e o app-lock prendem cada aparelho ao seu serviço — então, fora da sua rede, ele não tem valor de revenda e não dá para virar um box Android genérico. É isso que faz de entregar ou emprestar hardware uma decisão deliberada e segura, em vez de uma aposta.",
    bmLock1Title: "Net-lock no aparelho",
    bmLock1Body:
      "Um aparelho subsidiado ou locado fica preso ao seu serviço. Fora da sua rede ele simplesmente não ativa — então não há valor de revenda nem motivo para sumir com ele.",
    bmLock2Title: "App-lock e modo quiosque",
    bmLock2Body:
      "O aparelho roda o seu launcher e os seus apps — não um desktop Android aberto. Um aparelho subsidiado não pode ser reaproveitado para outra coisa, e a sua marca continua na tela.",
    bmLock3Title: "Suspenda e restaure remotamente",
    bmLock3Body:
      "Pagamento em atraso? Bloqueie o aparelho remotamente pelo painel e libere no instante em que ele pagar — cobrança sem uma única visita técnica.",
    bmLock4Title: "Recupere e reimplante",
    bmLock4Body:
      "Uma unidade de locação devolvida é zerada e reprovisionada pela rede, depois reemitida para o próximo assinante — o reaproveitamento que faz a conta da locação realmente fechar.",
    bmLockNote:
      "É por isso que o modelo é uma escolha de software. Uma mesma frota pode estar subsidiada, locada e vendida ao mesmo tempo — cada aparelho preso às suas próprias condições e movido entre elas sem nunca tocar no hardware.",
    bmMixEyebrow: "Na prática",
    bmMixTitle: "A maioria das operadoras roda mais de um",
    bmMixBody:
      "Combine o modelo com o assinante, não com a empresa. Um padrão que vemos sempre entre os nossos clientes:",
    bmMix1:
      "Aquisição e premium → subsidiar. Derrube a barreira inicial para conquistar assinantes competitivos e de triple-play; o contrato e o bloqueio protegem o aparelho dado.",
    bmMix2:
      "Base mainstream → locar. Uma pequena mensalidade mantém a barreira baixa e o ativo seu, com recuperar-e-reaproveitar quando o assinante dá churn.",
    bmMix3:
      "Pré-pago, segundas TVs e B2B → vender. Pegue o dinheiro lá no início, onde a fidelidade importa menos e um balanço leve importa mais.",
    bmMix4:
      "Com o tempo → converter. O mesmo aparelho deixa você subsidiar para adquirir e depois mover o assinante para a propriedade — sem hardware novo, só uma mudança de condições.",
    bmFitEyebrow: "Onde a gente entra",
    bmFitTitle: "Uma frota. Qualquer modelo. Mude quando quiser.",
    bmFitBody:
      "Nós entregamos o STB gerenciado e o Alcatraz DMS; você escolhe o modelo comercial — ou vários — e a gente torna cada um seguro de operar. Net-lock, app-lock, suspensão remota e recuperação OTA já vêm embutidos, então subsidiar e locar não são um salto de fé, e você pode mudar a combinação conforme o seu mercado muda, sem re-flash nem recompra. Não vamos te empurrar um modelo — fazemos os três funcionarem no mesmo aparelho.",
    bmFitNoteTitle: "Faça a conta com a gente",
    bmFitNoteBody:
      "Conte pra gente sua margem e sua retenção — o custo do aparelho é com a gente, e comparamos subsidiar, locar e vender em números reais, depois configuramos o bloqueio que protege a opção que você escolher.",
    bmFaqEyebrow: "FAQ",
    bmFaqTitle: "Perguntas frequentes",
    bmFaqQ1: "Qual modelo é o melhor?",
    bmFaqA1:
      "Não existe vencedor universal — depende do seu mercado, da sua posição de caixa e de quanta fidelidade você precisa. A maioria das operadoras combina: subsidia para adquirir, loca a base e vende onde a fidelidade importa menos. A vantagem de um aparelho gerenciado é que você não precisa escolher um só.",
    bmFaqQ2: "Dá mesmo para rodar os três ao mesmo tempo?",
    bmFaqA2:
      "Dá — muitos dos nossos clientes fazem isso. Como o modelo é imposto por software pelo Alcatraz DMS, uma mesma frota pode ter aparelhos subsidiados, locados e vendidos lado a lado, cada um nas suas próprias condições.",
    bmFaqQ3: "O que impede um aparelho subsidiado ou locado de ser revendido ou reaproveitado?",
    bmFaqA3:
      "O net-lock e o app-lock. Fora da sua rede, o aparelho não ativa, então não tem valor de revenda; e ele só roda o seu serviço, então não vira um box Android genérico. É isso que torna seguro dar ou emprestar hardware.",
    bmFaqQ4: "O que acontece quando um assinante para de pagar?",
    bmFaqA4:
      "Você bloqueia o aparelho remotamente e restaura no instante em que ele paga — sem visita técnica. Numa locação, um aparelho que nunca volta fica bloqueado e sem valor fora da rede; o que volta é zerado e reemitido.",
    bmFaqQ5: "Como a locação fica no meu balanço?",
    bmFaqA5:
      "Num arrendamento operacional típico, você mantém o aparelho como ativo e o deprecia ao longo da vida útil, enquanto lança o aluguel como receita recorrente — a clássica migração de CapEx para uma linha recorrente. Confirme o tratamento exato com a sua equipe financeira; nós fornecemos os dados de vida útil e reaproveitamento do aparelho.",
    bmFaqQ6: "Posso mover um assinante de um modelo para outro depois?",
    bmFaqA6:
      "Pode. Como todos os modelos rodam no mesmo aparelho, você pode subsidiar para adquirir e depois converter o assinante para a propriedade, ou transformar uma locação em venda — tudo por software, sem hardware novo.",
    bmCtaEyebrow: "Fale com a gente",
    bmCtaTitle: "Escolha o modelo que serve — a gente deixa seguro",
    bmCtaBody:
      "Conte pra gente suas margens, seu churn e quanto pretende cobrar do assinante — o custo do aparelho é com a gente, e ajudamos você a pesar subsidiar, locar e vender em números reais, e configuramos o bloqueio do Alcatraz DMS que protege a opção que você escolher.",
    bmCtaPrimary: "Fale com nosso time",
    bmCtaSecondary: "Solicitar uma amostra",
    moSeoTitle: "Multicast IPTV vs. OTT streaming: arquitetura de entrega para operadoras | inext",
    moSeoDescription:
      "Multicast IPTV ou OTT unicast — como uma operadora deve entregar TV ao vivo? Um stream eficiente compartilhado por todos numa rede gerenciada, ou um stream adaptativo por assinante pela internet. Os trade-offs honestos de largura de banda, qualidade, latência e alcance — e por que muitas operadoras rodam os dois.",
    moBreadcrumbPage: "Multicast IPTV vs. OTT",
    moHeroEyebrow: "Guia de arquitetura de entrega",
    moHeroTitle: "Multicast IPTV vs. OTT streaming:",
    moHeroTitleAccent: "por que você vai rodar os dois",
    moHeroSub:
      "Há duas formas de colocar TV ao vivo numa tela: enviar um único stream para muitos assinantes pela sua própria rede gerenciada (multicast IPTV), ou enviar um stream adaptativo separado para cada assinante pela internet pública (OTT unicast). Os projetos novos são cada vez mais construídos em OTT — ele alcança qualquer rede e qualquer dispositivo. Mas as muitas redes gerenciadas que já rodam multicast o mantêm por um bom motivo: para o ao vivo em escala, nada supera sua eficiência, latência quase nula e qualidade garantida. Os dois não são rivais — muitas operadoras combinam os dois: multicast para o ao vivo, unicast para o resto.",
    moHeroNote:
      "Os STBs da inext e o nosso app de IPTV falam os dois — multicast na sua rede gerenciada, OTT pela internet, no mesmo aparelho. Suportamos os dois porque nossos clientes usam os dois.",
    moHeroCtaPrimary: "Fale com nosso time",
    moHeroCtaSecondary: "Veja como o aparelho faz os dois",
    moStat1: "Um stream → muitos (multicast)",
    moStat2: "Qualquer rede, qualquer dispositivo (OTT)",
    moStat3: "Híbrido: um aparelho, os dois",
    moThesisEyebrow: "Comece por aqui",
    moThesisTitle: "A questão é a rede, não só o stream",
    moThesisBody1:
      "A diferença real não é a qualidade da imagem no abstrato — é por onde o vídeo trafega. O multicast envia uma única cópia de cada canal ao vivo pela sua rede gerenciada, e todos que estão sintonizados a compartilham: 50.000 assinantes num mesmo canal consomem a mesma largura de banda que um só. O OTT, em vez disso, abre um stream unicast separado para cada assinante pela internet pública, adaptando o bitrate a cada conexão. Um foi feito para eficiência e controle numa rede que é sua; o outro, para alcance e flexibilidade em redes que não são.",
    moThesisBody2:
      "Sejamos honestos: num projeto do zero, o OTT é hoje o padrão — a maioria dos novos projetos é unicast, e o multicast IPTV puro é amplamente tratado como legado. Mas “legado” não quer dizer “ruim”: onde uma rede gerenciada já carrega multicast, ele entrega qualidade de imagem, latência quase nula e eficiência de rede que o unicast ainda não alcança no ao vivo em escala — então raramente há um bom motivo para desativá-lo. É por isso que o multicast segue amplamente implantado, em geral num modelo híbrido: multicast para os canais lineares, unicast para VOD, catch-up e time-shift. Cada tarefa no transporte que a executa melhor.",
    moThesisCoreLabel: "Rede gerenciada, um-para-muitos",
    moThesisCoreValue: "Multicast IPTV",
    moThesisReachLabel: "Internet pública, um-para-um",
    moThesisReachValue: "OTT unicast",
    moDefineEyebrow: "Como cada um funciona",
    moDefineTitle: "Dois transportes para vídeo ao vivo",
    moMcastColTitle: "Multicast IPTV",
    moMcastColSub: "Um stream, compartilhado por todos os assinantes, na sua rede gerenciada",
    moMcast1: "Uma cópia de cada canal trafega pela rede; os assinantes entram nela via IGMP",
    moMcast2: "A largura de banda fica estável, não importa quantos sintonizem",
    moMcast3: "Bitrate fixo e tráfego priorizado — qualidade garantida, sem buffering",
    moMcast4: "Latência abaixo de um segundo — ideal para esportes ao vivo e eventos nacionais",
    moMcast5:
      "Roda numa rede gerenciada com multicast habilitado, por Ethernet cabeado — o Wi-Fi não o transporta de forma confiável",
    moMcast6: "Feito para TV linear; VOD e personalização ainda trafegam por unicast",
    moOttColTitle: "OTT unicast",
    moOttColSub: "Um stream adaptativo separado por assinante, pela internet pública",
    moOtt1: "Cada assinante recebe o seu próprio stream a partir de uma CDN",
    moOtt2: "O bitrate adaptativo (HLS/DASH) se ajusta à velocidade de cada conexão",
    moOtt3:
      "Alcança qualquer rede e qualquer dispositivo — celulares, notebooks, Smart TVs, fora da rede",
    moOtt4: "Qualidade best-effort; a latência é maior (HLS/DASH de baixa latência hoje em ~2–5s)",
    moOtt5: "A largura de banda e o custo de CDN crescem com cada assinante simultâneo",
    moOtt6: "Carrega VOD, catch-up, nPVR e personalização de forma nativa",
    moTableEyebrow: "Lado a lado",
    moTableTitle: "Como os dois se comparam",
    moTableColDimension: "",
    moTableColMcast: "Multicast IPTV",
    moTableColOtt: "OTT unicast",
    moRow1Label: "Largura de banda em escala",
    moRow1Mcast: "Estável — um stream atende a todos",
    moRow1Ott: "Linear — um stream por assinante",
    moRow2Label: "Rede necessária",
    moRow2Mcast: "Apenas a sua rede gerenciada",
    moRow2Ott: "Qualquer rede, internet pública",
    moRow3Label: "Alcance",
    moRow3Mcast: "Set-top boxes on-net",
    moRow3Ott: "Qualquer dispositivo, em qualquer lugar",
    moRow4Label: "Qualidade",
    moRow4Mcast: "Garantida, bitrate fixo",
    moRow4Ott: "Best-effort, adaptativa",
    moRow5Label: "Latência ao vivo",
    moRow5Mcast: "Abaixo de um segundo",
    moRow5Ott: "~2–5s com baixa latência, até 10–30s",
    moRow6Label: "Melhor para",
    moRow6Mcast: "TV linear, esportes, grandes canais",
    moRow6Ott: "VOD, catch-up, mobile, fora da rede",
    moRow7Label: "VOD e personalização",
    moRow7Mcast: "Precisa de unicast",
    moRow7Ott: "Nativo",
    moRow8Label: "Perfil de custo",
    moRow8Mcast: "Setup de rede; estável em escala",
    moRow8Ott: "CDN / egress; cresce com os assinantes",
    moRow9Label: "Controle de QoS",
    moRow9Mcast: "Total — a rede é sua",
    moRow9Ott: "Limitado — best-effort",
    moRow10Label: "Conexão",
    moRow10Mcast: "Ethernet cabeado — não Wi-Fi",
    moRow10Ott: "Qualquer link, inclusive Wi-Fi",
    moTableInextLabel: "Nos aparelhos inext",
    moTableInextValue: "Um único app de IPTV reproduz os dois — multicast on-net, OTT off-net",
    moTableNote:
      "A maioria das plataformas coloca a TV linear em multicast onde a rede gerenciada permite, e todo o resto em unicast.",
    moScaleEyebrow: "A diferença de eficiência",
    moScaleTitle: "Por que o multicast ainda vence o grande momento ao vivo",
    moScaleBody:
      "Imagine uma final nacional num único canal, com 50.000 assinantes assistindo ao mesmo tempo. Em multicast, isso é um único stream na sua rede — a carga é a mesma de um assinante. Em unicast, são 50.000 streams separados, e a sua CDN e o egress crescem com cada um deles. Esse é o motivo central pelo qual tantas redes multicast seguem em operação: no ao vivo com alta concorrência, quanto maior a audiência, maior a economia — de banda, de custo e daquela latência quase nula que uma rede gerenciada entrega.",
    moFitListEyebrow: "Quando usar cada um",
    moFitListTitle: "Coloque cada tarefa no transporte que a executa melhor",
    moFit1:
      "TV linear em escala na sua rede gerenciada → multicast. Esportes e grandes canais ganham latência abaixo de um segundo, qualidade garantida e largura de banda estável.",
    moFit2:
      "VOD, catch-up, time-shift, nPVR e canais personalizados → unicast. São, por natureza, por assinante, então o OTT é o encaixe natural.",
    moFit3:
      "Mobile, viagem, telas secundárias e assinantes fora da rede → OTT. Ele alcança qualquer rede e qualquer dispositivo, sem infraestrutura de multicast.",
    moFit4:
      "Mercados que exigem qualidade garantida → o multicast ainda lidera, e essa é uma escolha válida e bem respeitada — não uma herança do passado.",
    moBothEyebrow: "Onde nos encaixamos",
    moBothTitle: "Um aparelho, os dois transportes",
    moBothBody:
      "Você não precisa escolher no dispositivo. Os set-top boxes da inext e o nosso app de IPTV lidam com multicast (UDP/RTP com IGMP) na sua rede gerenciada e com OTT (HLS/DASH, M3U e portais Stalker/Ministra/Xtream) por unicast — no mesmo aparelho, na mesma casa. O assinante pode assistir a um canal ao vivo por multicast e, um instante depois, abrir um título VOD que chega por unicast — um serviço único e contínuo, com cada stream no transporte que mais combina com ele. E como o multicast precisa de um link cabeado, todo aparelho da inext vem com porta Ethernet. Unicast puro, uma rede multicast clássica ou um híbrido dos dois — o mesmo aparelho serve aos três. Construímos para os dois porque nossos clientes usam os dois — e não vamos dizer que a opção que você escolheu está errada.",
    moBothNoteTitle: "Já tem um? Adicione o outro.",
    moBothNoteBody:
      "Roda multicast puro e precisa do alcance OTT para mobile e fora da rede? Ou OTT puro e quer a eficiência do multicast para grandes eventos ao vivo? O aparelho e o app suportam os dois, então você pode estender sem trocar de plataforma. A gente ajuda a dimensionar.",
    moFaqEyebrow: "FAQ",
    moFaqTitle: "Perguntas frequentes",
    moFaqQ1: "O OTT está tornando o multicast obsoleto?",
    moFaqA1:
      "Para projetos novos, em grande parte sim — a maioria dos projetos do zero hoje vai de unicast/OTT, e o multicast IPTV puro é amplamente considerado legado. Mas essa não é a história toda: onde uma rede gerenciada já carrega multicast, é difícil abrir mão da sua eficiência, latência quase nula e qualidade garantida no ao vivo, então essas redes seguem em operação e continuam amplamente usadas. É menos “substituição” e mais “já não é o padrão para projetos do zero” — e normalmente roda num híbrido, com unicast para VOD e catch-up.",
    moFaqQ2: "Qual deles tem melhor qualidade de imagem?",
    moFaqA2:
      "Numa rede gerenciada, o multicast entrega um bitrate fixo com tráfego priorizado, então a qualidade é consistente e sem buffering. A qualidade do OTT é adaptativa e best-effort — excelente numa boa conexão, variável numa ruim. Para uma qualidade que você controla de ponta a ponta, o multicast lidera; para alcançar redes imprevisíveis, a adaptatividade do OTT é justamente o ponto.",
    moFaqQ3: "Preciso de uma rede especial para multicast?",
    moFaqA3:
      "Sim. O multicast precisa de uma rede gerenciada em que cada switch do caminho tenha multicast habilitado (IGMP), além de um link Ethernet cabeado no aparelho — o Wi-Fi não transporta multicast de forma confiável. É por isso que se trata de uma tecnologia de telco/ISP para assinantes on-net, e por isso todo aparelho da inext tem porta Ethernet. O OTT não precisa de nada disso — ele roda pela internet pública e por qualquer conexão, inclusive Wi-Fi, que é exatamente o motivo de alcançar qualquer lugar.",
    moFaqQ4: "Um único set-top box consegue fazer os dois?",
    moFaqA4:
      "Sim — é justamente a proposta dos nossos. Os aparelhos da inext e o app de IPTV reproduzem multicast ao vivo na sua rede e streams OTT pela internet, alternando de forma transparente. O assinante vê um único serviço; você decide qual transporte carrega o quê.",
    moFaqQ5: "E quanto à latência para esportes ao vivo?",
    moFaqA5:
      "O multicast costuma entregar latência abaixo de um segundo — o que conta quando os vizinhos comemoram o gol antes de o seu stream chegar lá. O OTT padrão atrasa de 10 a 30 segundos; o HLS/DASH de baixa latência reduziu isso para cerca de 2–5 segundos, suficiente para a maioria dos conteúdos, mas ainda atrás do multicast no grande momento ao vivo.",
    moFaqQ6: "O que é multicast ABR?",
    moFaqA6:
      "O multicast ABR (mABR) carrega streams de bitrate adaptativo, em formato OTT, por multicast — combinando o formato amigável a dispositivos do OTT com a eficiência de um-para-muitos do multicast. Ele pode cortar os picos de tráfego ao vivo em até 90% e permite que as operadoras escalem o ao vivo com alta concorrência sem um stream unicast por assinante. Nossa plataforma oferece suporte a isso.",
    moCtaEyebrow: "Fale com a gente",
    moCtaTitle: "Entregue TV ao vivo do jeito para o qual a sua rede foi feita",
    moCtaBody:
      "Conte para a gente sobre a sua rede, os seus canais e a sua audiência. Vamos ajudar a posicionar multicast e OTT onde cada um rende melhor — e enviar aparelhos que rodam os dois já de fábrica.",
    moCtaPrimary: "Fale com nosso time",
    moCtaSecondary: "Solicite uma amostra",
    bbSeoTitle: "Construir ou comprar: um ISP deve desenvolver o seu próprio set-top box? | inext",
    bbSeoDescription:
      "Desenvolver a sua própria plataforma de STB ou comprar um stack pronto? “Construir” um set-top box significa montar oito camadas — silício, hardware, firmware, apps, DRM, gerenciamento de dispositivos, fabricação e suporte. Um guia honesto de fazer ou comprar para operadoras.",
    bbBreadcrumbPage: "Construir ou comprar",
    bbHeroEyebrow: "Guia de fazer ou comprar",
    bbHeroTitle: "Construir o seu próprio STB ou comprar o stack?",
    bbHeroTitleAccent: "a conta honesta de fazer ou comprar",
    bbHeroSub:
      "“Construir o seu próprio box” soa como engenharia — mas nenhuma operadora fabrica os próprios chips, e quase nenhuma projeta a placa. Na prática, construir é montar um stack de oito camadas, do silício ao suporte, e ser dono de cada uma delas. Algumas operadoras realmente deveriam. Mas a maioria que diz ter construído um box, na verdade, montou um. Este guia mostra o que “construir” exige de fato, para você saber de que lado está.",
    bbHeroNote:
      "Nós somos o lado do comprar-e-fazer-parceria — então não vamos fingir que construir nunca faz sentido. Faz, para algumas. Esta é a versão honesta do trade-off.",
    bbHeroCtaPrimary: "Fale com nosso time",
    bbHeroCtaSecondary: "Ver as 8 camadas",
    bbStat1: "8 camadas para ser dono",
    bbStat2: "Construir: um programa de vários anos",
    bbStat3: "Comprar: uma amostra com a sua marca em 1–2 semanas",
    bbThesisEyebrow: "Comece por aqui",
    bbThesisTitle: "“Construir” quase nunca é o que parece",
    bbThesisBody1:
      "Ninguém fabrica os próprios chips e, sendo realista, nenhuma operadora projeta a própria placa — é para isso que existem os fornecedores de silício e os fabricantes. Então “construir o seu próprio STB” não é um projeto de hardware; é um projeto de integração. Você monta o hardware que compra, o software que desenvolve ou licencia e uma operação para fabricar, atualizar e dar suporte a tudo isso — e depois passa a ser dono do resultado de ponta a ponta.",
    bbThesisBody2:
      "É um caminho real e legítimo — mas maior do que aparenta. Um box que funciona e que o assinante consegue de fato usar envolve oito competências distintas, e uma falha em qualquer uma delas aparece lá na frente como um lançamento travado ou uma falha em campo. Antes de decidir construir, vale enxergar o stack inteiro que você assumiria.",
    bbThesisCoreLabel: "O que “construir” realmente é",
    bbThesisCoreValue: "Montar e ser dono de um stack",
    bbThesisReachLabel: "O que você compra de qualquer jeito",
    bbThesisReachValue: "Silício · hardware ODM · licenças de DRM",
    bbLayersEyebrow: "O stack",
    bbLayersTitle: "Oito camadas por trás de um box que funciona",
    bbLayersIntro:
      "Um set-top box parece um único produto; na verdade, são oito competências empilhadas. Aqui está cada camada e o que significa ser dono dela.",
    bbLayer1Name: "Silício (SoC)",
    bbLayer1Body:
      "O chip — Amlogic, Allwinner, Realtek. Você escolhe, nunca fabrica, e é ele que define o teto de 4K, codecs, tier de DRM e secure boot.",
    bbLayer2Name: "Hardware e design industrial",
    bbLayer2Body:
      "Placa, portas, carcaça, fonte de alimentação, controle remoto. Projetados e produzidos por um ODM — a partir de um design de referência ou da sua especificação — não é algo feito internamente.",
    bbLayer3Name: "Firmware e BSP",
    bbLayer3Body:
      "Android AOSP ou Linux, kernel, drivers, secure boot. O fornecedor te entrega uma base; deixá-la pronta para produção exige engenheiros de sistemas embarcados.",
    bbLayer4Name: "Launcher e middleware",
    bbLayer4Body:
      "A tela inicial com a sua marca, EPG, configurações e o launcher de apps — a parte que o assinante enxerga como “sua”.",
    bbLayer5Name: "Apps",
    bbLayer5Body:
      "O seu app de IPTV/VOD, além do OTT. Atenção: Netflix, Disney+ e os demais não são “construídos” — cada um exige a própria certificação e um acordo direto com a operadora.",
    bbLayer6Name: "DRM e proteção de conteúdo",
    bbLayer6Body:
      "Widevine e Verimatrix, licenciados e provisionados. As chaves do Widevine L1 têm de ser gravadas de fábrica, num chip com secure enclave — você não consegue adicionar L1 depois.",
    bbLayer7Name: "Gerenciamento de dispositivos e OTA",
    bbLayer7Body:
      "Provisionamento, atualizações de firmware em etapas com rollback, diagnóstico remoto, TR-069. Um backend por si só.",
    bbLayer8Name: "Fabricação, logística e suporte",
    bbLayer8Body:
      "Produção, envio para o mundo todo, certificação, QA, RMA e uma central de suporte — a maior parte do trabalho, e a menos glamourosa.",
    bbSpectrumEyebrow: "Como as operadoras constroem de verdade",
    bbSpectrumTitle: "Quatro formas de “construir”, da maior para a menor",
    bbApproach1Name: "Tudo internamente",
    bbApproach1Body:
      "Equipes próprias de embarcados, de apps e de backend; um ODM produzindo conforme a sua especificação; os seus próprios acordos de DRM e o seu backend de gerenciamento de dispositivos; a certificação é com você. Realista em escala Tier-1 — um programa de vários anos e várias equipes.",
    bbApproach2Name: "Design de referência + o seu software",
    bbApproach2Body:
      "Parta de uma placa de referência do SoC ou de um box de ODM; a sua equipe desenvolve o firmware, o launcher, o app e a integração com o DMS. Exige uma equipe de embarcados, mas dispensa hardware personalizado.",
    bbApproach3Name: "Aparelhos de varejo + o seu app",
    bbApproach3Body:
      "Pule o hardware por completo — publique o seu app no Chromecast/Google TV, no Fire TV ou em boxes Android de varejo. Você “constrói” só o app, mas abre mão do box próprio: sem marca, sem gerenciamento da frota, e o fornecedor controla a tela inicial e as atualizações.",
    bbApproach4Name: "Hardware ODM + um stack de fornecedor",
    bbApproach4Body:
      "Compre o hardware de um ODM e licencie o firmware, o launcher, o app e o DMS de um especialista. Você coloca a sua marca e configura; as camadas difíceis já estão prontas. Este é o caminho do comprar-e-fazer-parceria.",
    bbCostEyebrow: "O custo honesto",
    bbCostTitle: "Construir é um programa, não uma compra",
    bbCostBody:
      "Uma construção do zero de verdade significa montar várias disciplinas que talvez você não tenha — firmware embarcado, desenvolvimento de apps, provisionamento de DRM, um backend de gerenciamento de dispositivos e OTA, fabricação e logística, além de certificação e suporte — e depois mantê-las com equipe própria por toda a vida do produto. O custo inicial é real, mas o contínuo é maior: cada nova versão do SO, cada patch de segurança e cada app novo passa a ser seu para carregar. Planeje um programa medido em trimestres e uma equipe medida em headcount, não uma compra única.",
    bbWhenEyebrow: "Quando construir",
    bbWhenTitle: "Construir realmente vence quando…",
    bbWhen1:
      "Você tem escala. Uma base de assinantes grande o bastante para diluir uma equipe de engenharia muda completamente a conta.",
    bbWhen2:
      "Você tem um requisito único. Um recurso ou uma integração que nenhum fornecedor oferece e que é central para o modo como você se diferencia.",
    bbWhen3:
      "Você já tem a estrutura. Uma equipe interna de embarcados e de apps que você está disposto a bancar no longo prazo.",
    bbWhen4:
      "O controle é estratégico. Quando ser dono de cada camada — e não apenas colocar a sua marca — é uma decisão de conselho, não uma linha de custo.",
    bbWhenNote:
      "Se dois ou mais desses pontos descrevem você, construir merece uma análise séria. Se nenhum descreve, a conta geralmente pende para comprar as camadas difíceis.",
    bbTableEyebrow: "Lado a lado",
    bbTableTitle: "Construir ou comprar, ponto a ponto",
    bbTableColDimension: "",
    bbTableColBuild: "Construir internamente",
    bbTableColBuy: "Comprar e fazer parceria",
    bbRow1Label: "Time-to-market",
    bbRow1Build: "Trimestres a anos",
    bbRow1Buy: "Semanas até uma primeira amostra",
    bbRow2Label: "Custo inicial",
    bbRow2Build: "Alto — equipes e ferramentas",
    bbRow2Buy: "Por dispositivo, mais o setup",
    bbRow3Label: "Equipe necessária",
    bbRow3Build: "Embarcados, apps, backend, QA",
    bbRow3Buy: "Produto e operações",
    bbRow4Label: "Manutenção de firmware e SO",
    bbRow4Build: "Sua, para sempre",
    bbRow4Buy: "Mantida para você",
    bbRow5Label: "DRM (Widevine L1)",
    bbRow5Build: "Você negocia e provisiona",
    bbRow5Buy: "Provisionado de fábrica",
    bbRow6Label: "Gerenciamento de dispositivos e OTA",
    bbRow6Build: "Você desenvolve o backend",
    bbRow6Buy: "Incluído (DMS + OTA)",
    bbRow7Label: "Certificação",
    bbRow7Build: "GMS / Netflix por sua conta",
    bbRow7Buy: "Resolvida ou em parceria",
    bbRow8Label: "Fabricação e logística",
    bbRow8Build: "O seu ODM e o seu frete",
    bbRow8Buy: "Incluídas, no mundo todo",
    bbRow9Label: "Controle",
    bbRow9Build: "Total — cada camada",
    bbRow9Buy: "Seu, para marcar e configurar",
    bbRow10Label: "Onde fica o risco",
    bbRow10Build: "Com você, de ponta a ponta",
    bbRow10Buy: "Compartilhado com o fornecedor",
    bbTableInextLabel: "Onde a inext se encaixa",
    bbTableInextValue:
      "Na coluna do comprar-e-fazer-parceria — você marca e configura, com uma amostra funcional em 1–2 semanas",
    bbTableNote:
      "Nenhuma das colunas é “a certa” — depende da sua escala, da sua equipe e de quanto do stack você quer ter como seu.",
    bbFitEyebrow: "Onde a gente entra",
    bbFitTitle: "A gente reduz a construção a “marcar e configurar”",
    bbFitBody:
      "Nós ficamos na coluna do comprar-e-fazer-parceria, e não escondemos isso — mas o nosso trabalho é tirar as oito camadas das suas costas, não te dissuadir de construir se você realmente deveria. Você recebe hardware ODM, um build Android AOSP ou Linux, o seu launcher Operator Tier, o app de IPTV, Widevine L1 e Verimatrix provisionados de fábrica, o Alcatraz DMS com OTA em etapas e fabricação e entrega no mundo todo. Sai white-label — a sua marca no firmware e, se você quiser, o seu logo no hardware e no controle remoto. O que seria um programa de vários trimestres vira: escolha o modelo, coloque a sua marca e receba uma amostra funcional em uma a duas semanas.",
    bbFitNoteTitle: "Não tem certeza de que lado você está?",
    bbFitNoteBody:
      "Conte pra gente a sua escala, se você tem uma equipe interna de embarcados e com que rapidez precisa lançar. Vamos te dar uma leitura direta sobre construir ou comprar na sua situação — sem discurso de venda.",
    bbFaqEyebrow: "FAQ",
    bbFaqTitle: "Perguntas frequentes",
    bbFaqQ1: "Preciso projetar o meu próprio hardware para “construir”?",
    bbFaqA1:
      "Não — e nem deveria. O silício vem dos fornecedores de chips e as placas, dos ODMs; até uma construção 100% interna parte de um design de referência. “Construir” é ser dono do software, da integração e da operação — não desenhar uma PCB.",
    bbFaqQ2: "Não dá só para colocar o meu app em boxes Android de varejo?",
    bbFaqA2:
      "Dá, e para uma jogada de app puro é um começo válido. Mas um box de varejo não é seu: mesmo com Widevine L1 a bordo, você não tem marca, nem gerenciamento da frota, nem net-lock, e o fornecedor controla a tela inicial e as atualizações. É a ponta só-app do espectro — bom para alcance, fraco para um serviço controlado e com a sua marca. (É o mesmo trade-off do STB próprio vs. Smart TV, em outra forma.)",
    bbFaqQ3: "Qual é a camada mais difícil de construir?",
    bbFaqA3:
      "Firmware, sem dúvida. Fazer uma placa funcionar é a parte fácil; deixá-la estável, rápida e segura é a difícil — e isso praticamente não acaba. Cada SoC e cada placa precisa do seu próprio firmware afinado: drivers, pipeline de vídeo, integração de DRM, gerenciamento de energia, secure boot. Não é um port único — pra gente, levou anos de iteração pra acertar o firmware de cada placa. É a camada que os times mais subestimam — e exatamente aquela em que um especialista já colocou esses anos.",
    bbFaqQ4: "Quanto tempo leva uma construção de verdade?",
    bbFaqA4:
      "Para um programa genuíno, do zero, planeje em trimestres, não em semanas: deixar o firmware pronto para produção, provisionar o DRM, gerenciamento de dispositivos, certificação e fabricação levam tempo, cada um, e em parte acontecem um depois do outro. Comprar as camadas difíceis comprime isso ao tempo de colocar a sua marca e configurar uma plataforma já comprovada.",
    bbFaqQ5: "Quando construir faz sentido de verdade?",
    bbFaqA5:
      "Quando você tem escala para diluir uma equipe de engenharia, um requisito único que nenhum fornecedor cobre, uma equipe interna que você está disposto a bancar ou uma razão estratégica para ser dono de cada camada. Se dois ou mais pontos se encaixam em você, construir merece uma análise séria; se nenhum, comprar geralmente vence.",
    bbFaqQ6: "De que lado a inext está — construir ou comprar?",
    bbFaqA6:
      "Nós somos o lado do comprar-e-fazer-parceria, e dizemos isso. Fornecemos hardware ODM, firmware AOSP ou Linux, o seu launcher e app de IPTV com a sua marca, DRM provisionado de fábrica, Alcatraz DMS e OTA, e fabricação no mundo todo — white-label, então sai como o seu produto. E também vamos te dizer com honestidade se a sua situação, na verdade, pede construir.",
    bbCtaEyebrow: "Fale com a gente",
    bbCtaTitle: "Receba uma leitura direta sobre construir ou comprar",
    bbCtaBody:
      "Conte pra gente a sua escala, se você tem uma equipe interna de embarcados e o seu prazo. Vamos te dar uma leitura honesta para a sua situação — e, se comprar se encaixar, uma amostra funcional com a sua marca em uma ou duas semanas.",
    bbCtaPrimary: "Fale com nosso time",
    bbCtaSecondary: "Solicitar uma amostra",
    guidesCardRsgTitle: "De quanta RAM e armazenamento um STB precisa?",
    guidesCardRsgDesc:
      "Um guia para escolher entre 1 GB, 2 GB e 4 GB de RAM de acordo com o uso do aparelho. Também explica como avaliar armazenamento, firmware e testes, que dizem mais do que os maiores números da ficha técnica.",
    footerLinkGuidesRamStorage: "RAM e armazenamento de STB",
    rsgSeoTitle: "De quanta RAM e armazenamento um STB precisa? | inext",
    rsgSeoDescription:
      "Compare 1 GB, 2 GB e 4 GB de RAM e 8 GB, 16 GB e 32 GB de armazenamento em STBs. Escolha conforme o firmware, os apps, os jogos e o cenário de uso.",
    rsgBreadcrumbPage: "RAM e armazenamento de STB",
    rsgHeroEyebrow: "Guia de configuração de set-top boxes",
    rsgPublishedLabel: "Publicado em",
    rsgUpdatedLabel: "Atualizado em",
    rsgHeroTitle: "De quanta RAM e armazenamento",
    rsgHeroTitleAccent: "um set-top box realmente precisa?",
    rsgHeroSub:
      "Não existe um mínimo universal para todo STB moderno. Um aparelho de 1 GB bem otimizado pode ser a escolha certa para um serviço com função definida. Mais memória faz sentido quando há muitos apps, jogos executados no próprio aparelho ou uma vida útil mais longa.",
    rsgHeroNote:
      "Considere o conjunto completo — firmware, tela inicial, apps, atualizações e jogos — em vez de escolher apenas o maior número da ficha técnica.",
    rsgHeroCtaPrimary: "Comparar configurações",
    rsgHeroCtaSecondary: "Comparar modelos inext",
    rsgStat1: "Enxuto e eficiente",
    rsgStat2: "Equilíbrio versátil",
    rsgStat3: "Maior margem",
    rsgThesisEyebrow: "A resposta curta",
    rsgThesisTitle: "A quantidade de memória não define o desempenho sozinha",
    rsgThesisBody1:
      "A RAM é usada pelo sistema operacional e pelos apps em execução. O armazenamento guarda o firmware, os apps, as atualizações e os dados locais. Esses números, isoladamente, não revelam a qualidade do software, a velocidade da memória, a capacidade da GPU, o controle de temperatura nem a quantidade de processos desnecessários em segundo plano.",
    rsgThesisBody2:
      "Por isso, um STB de 1 GB bem projetado pode responder com rapidez em um serviço com função bem definida. Já um aparelho mal ajustado, mesmo com mais RAM, pode demorar para iniciar, fechar apps ou ficar instável. Mais memória oferece flexibilidade e margem, mas não corrige software ruim.",
    rsgThesisNoteTitle: "Quando 1 GB realmente é suficiente",
    rsgThesisNoteBody:
      "Um gigabyte só é suficiente quando o cenário de uso é conhecido, o firmware foi desenvolvido para aquele hardware e a solução completa foi testada em condições realistas. Isso não é uma recomendação geral para qualquer aparelho Android.",
    rsgGoogleNote:
      "As regras públicas de compatibilidade do Android são mais detalhadas que um “mínimo de 2 GB” universal: os requisitos variam conforme a versão do Android, a arquitetura, a configuração da tela e a memória reservada para o hardware.",
    rsgGoogleLink: "Ver requisitos de compatibilidade do Android",
    rsgWorkloadsEyebrow: "Comece pela função",
    rsgWorkloadsTitle: "Cada aplicação exige uma configuração",
    rsgWorkloadsIntro:
      "Um serviço controlado pela operadora, um aparelho para quarto de hotel, uma plataforma com vários apps de streaming e um modelo voltado a jogos têm necessidades diferentes. Defina o que precisa funcionar desde o início e o que pode ser acrescentado depois.",
    rsgWorkload1Title: "Serviço de TV dedicado",
    rsgWorkload1Body:
      "Uma tela inicial gerenciada e um app principal de TV, com firmware controlado e poucos serviços em segundo plano.",
    rsgWorkload1Signal: "A otimização importa mais que a quantidade de apps",
    rsgWorkload2Title: "Streaming com vários apps",
    rsgWorkload2Body:
      "Vários apps de IPTV, OTT, mídia e utilitários, com usuários alternando entre eles durante uma sessão.",
    rsgWorkload2Signal: "Reserve espaço para alternar apps e manter caches",
    rsgWorkload3Title: "Hotelaria e condomínios",
    rsgWorkload3Body:
      "Uma experiência personalizada com a marca do hotel, informações para hóspedes, espelhamento de tela e integrações com outros serviços, geralmente instalados em muitos quartos.",
    rsgWorkload3Signal: "Consistência e restauração remota vêm primeiro",
    rsgWorkload4Title: "Jogos casuais",
    rsgWorkload4Body:
      "Jogos leves para Android e experiências interativas simples, além dos apps usuais de mídia.",
    rsgWorkload4Signal: "A RAM ajuda; GPU e controles ainda decidem",
    rsgWorkload5Title: "Jogos na nuvem",
    rsgWorkload5Body:
      "O jogo é processado remotamente, enquanto o STB decodifica um fluxo de vídeo de baixa latência e envia os comandos do controle.",
    rsgWorkload5Signal: "A latência da rede pode pesar mais que RAM adicional",
    rsgWorkload6Title: "Plataformas próprias mais completas",
    rsgWorkload6Body:
      "Vários apps personalizados, serviços em segundo plano, ferramentas de análise, integrações e recursos que devem crescer com o tempo.",
    rsgWorkload6Signal: "Planeje uma margem para a evolução do produto",
    rsgRamEyebrow: "O que usa RAM",
    rsgRamTitle: "Quatro áreas consomem a RAM disponível",
    rsgRamIntro:
      "A pergunta útil não é “Quantos gigabytes?”, mas “Quanto sobra quando o serviço completo está funcionando?”. Faça a medição com o firmware final, não com uma versão limpa de desenvolvimento.",
    rsgRamFactor1Title: "Sistema operacional e serviços",
    rsgRamFactor1Body:
      "Android ou Linux, tela inicial, rede, DRM, sistema de gerenciamento dos aparelhos e serviços do fornecedor ocupam memória antes mesmo de o app principal iniciar.",
    rsgRamFactor2Title: "Apps e trabalho em segundo plano",
    rsgRamFactor2Body:
      "Dados de EPG, miniaturas, análises, caches e processos em segundo plano determinam se os apps ficam prontos ou precisam reiniciar.",
    rsgRamFactor3Title: "Reprodução de vídeo",
    rsgRamFactor3Body:
      "STBs modernos decodificam vídeo em hardware dedicado. A fluidez em 4K depende muito do SoC, da cadeia de codecs e dos drivers, não apenas da capacidade de RAM.",
    rsgRamFactor4Title: "Jogos e multitarefa",
    rsgRamFactor4Body:
      "Jogos executados no próprio aparelho, gráficos mais complexos e trocas frequentes entre apps exigem mais memória e são os que mais se beneficiam de uma margem adicional.",
    rsgConfigEyebrow: "Comparação prática",
    rsgConfigTitle: "1/8, 2/16 ou 4/32 GB?",
    rsgConfigIntro:
      "Estas configurações atendem a cenários de uso diferentes; não são níveis universais de desempenho. Tome a decisão final depois de testar uma unidade de avaliação com o firmware, os apps, os conteúdos e os periféricos previstos.",
    rsgConfigCommon: "Mais versátil",
    rsgConfigFitsLabel: "Indicado para",
    rsgConfigWatchLabel: "Pontos de atenção",
    rsgConfigModelsLabel: "Modelos inext indicados",
    rsgConfig1Label: "Implantação focada",
    rsgConfig1Summary:
      "Uma configuração econômica quando a inext ou a operadora controla todo o firmware e mantém o aparelho dedicado a um conjunto limitado de funções.",
    rsgConfig1Fit1: "Um app principal de TV ou mídia",
    rsgConfig1Fit2: "Uma tela inicial leve com poucos serviços em segundo plano",
    rsgConfig1Fit3: "Frotas grandes, nas quais o custo por unidade importa",
    rsgConfig1Watch:
      "Não é uma escolha segura para um catálogo crescente de apps, jogos exigentes executados no aparelho ou software que ainda não foi medido no firmware final.",
    rsgConfig2Label: "Equilíbrio flexível",
    rsgConfig2Summary:
      "Um ponto de partida equilibrado para projetos que precisam de vários apps, uma interface mais completa e margem para futuras mudanças no software.",
    rsgConfig2Fit1: "Serviços de IPTV e OTT com vários apps",
    rsgConfig2Fit2: "Hotelaria, portais com marca própria e jogos casuais",
    rsgConfig2Fit3: "Projetos cujos requisitos podem crescer moderadamente",
    rsgConfig2Watch:
      "Ainda é preciso validar o crescimento dos dados, a troca de apps e a estabilidade em uso prolongado. Ter 2 GB não elimina a necessidade de um firmware bem otimizado e mantido.",
    rsgConfig3Label: "Maior margem",
    rsgConfig3Summary:
      "A opção mais robusta para conjuntos amplos de apps, tarefas mais exigentes executadas no aparelho e projetos que priorizam flexibilidade em vez do menor custo de hardware.",
    rsgConfig3Fit1: "Bibliotecas maiores de apps e interfaces mais ricas",
    rsgConfig3Fit2: "Jogos mais exigentes executados no aparelho e apps interativos",
    rsgConfig3Fit3: "Planos de evolução mais longos e menos previsíveis",
    rsgConfig3Watch:
      "Não pague por memória que o aparelho não usará. Confirme se o processador, a GPU, a velocidade do armazenamento e o software permitem aproveitar de fato a capacidade adicional.",
    rsgConfigNote:
      "Os nomes das configurações descrevem as capacidades nominais de RAM e memória flash. A RAM disponível e o armazenamento utilizável são menores depois das reservas de hardware, partições do sistema e software pré-instalado.",
    rsgStorageEyebrow: "O armazenamento precisa de planejamento",
    rsgStorageTitle: "A capacidade anunciada não é o espaço disponível",
    rsgStorageIntro:
      "Em um aparelho de 8 GB, 16 GB ou 32 GB, parte da memória é ocupada pelas partições e pelo firmware de produção. Consulte o espaço realmente disponível na unidade final e estime como ele mudará ao longo da vida útil do serviço.",
    rsgStorage1Title: "Firmware e partições",
    rsgStorage1Body:
      "O sistema operacional, o ambiente de recuperação, os dados do fornecedor e as partições reservadas ocupam parte da memória antes mesmo da instalação dos apps.",
    rsgStorage2Title: "Estratégia de atualização",
    rsgStorage2Body:
      "Pacotes de recuperação, downloads em etapas e atualizações com partições A/B podem exigir armazenamento temporário ou permanentemente reservado.",
    rsgStorage3Title: "Apps, dados e caches",
    rsgStorage3Body:
      "Os arquivos dos apps são só o começo. Dados de EPG, imagens, registros, dados da web e caches crescem durante o uso normal.",
    rsgStorage4Title: "Velocidade e durabilidade de gravação",
    rsgStorage4Body:
      "Uma eMMC rápida e confiável e um sistema de arquivos bem mantido podem importar mais do que uma grande área livre em um aparelho lento ou mal gerenciado.",
    rsgStorageNote:
      "Defina um limite mínimo de espaço livre após a preparação e depois de um ciclo representativo de atualização. A capacidade nominal, sozinha, não confirma que a próxima versão do sistema ou do app será instalada com segurança.",
    rsgOptimizeEyebrow: "Por que o software muda a resposta",
    rsgOptimizeTitle: "A otimização libera recursos para o serviço",
    rsgOptimizeIntro:
      "O firmware de um STB não deve ser uma versão genérica do Android copiada sem ajustes para uma placa. BSP, drivers, serviços, tela inicial e processos dos apps precisam ser otimizados em conjunto para o SoC e a função específica do produto.",
    rsgOptimize1Title: "Elimine processos desnecessários",
    rsgOptimize1Body:
      "Cada serviço desnecessário consome RAM, armazenamento, processamento e tempo de inicialização. Um firmware controlado pode permanecer propositalmente enxuto.",
    rsgOptimize2Title: "Otimize toda a base de hardware",
    rsgOptimize2Body:
      "A configuração do kernel, os drivers, a alocação de memória e a integração da decodificação de vídeo determinam a eficiência com que a plataforma usa seus recursos.",
    rsgOptimize3Title: "Controle o funcionamento dos apps",
    rsgOptimize3Body:
      "O comportamento da tela inicial, os limites para processos em segundo plano, a política de cache e os mecanismos de recuperação mantêm a interface ágil mesmo em sessões longas.",
    rsgOptimize4Title: "Valide cada versão de produção",
    rsgOptimize4Body:
      "A otimização é mantida com testes de regressão, distribuição gradual de atualizações OTA e monitoramento. Ela não termina no lançamento.",
    rsgOptimizeProofTitle: "Um exemplo concreto: inext TV5",
    rsgOptimizeProofBody:
      "O TV5 combina 1 GB de RAM e 8 GB de eMMC com Android 10 AOSP, reprodução 4K acelerada por hardware e Alcatraz DMS. Ele cumpre bem uma função específica graças a anos de otimização do software para a plataforma H313, e não por ignorar os limites de memória.",
    rsgOptimizeProofCta: "Ver especificações do TV5",
    rsgGamingEyebrow: "Os jogos mudam os requisitos",
    rsgGamingTitle: "Pergunte qual tipo de jogo vai rodar",
    rsgGamingIntro:
      "A expressão “suporta jogos” pode significar coisas muito diferentes. Um quebra-cabeça simples, um jogo de console transmitido pela nuvem e um jogo 3D executado no aparelho exigem recursos distintos do STB.",
    rsgGamingImageAlt:
      "Pessoa usando o app inext Remote no modo controle enquanto um jogo de corrida roda na televisão",
    rsgGame1Title: "Jogos casuais e leves",
    rsgGame1Body:
      "Jogos simples para Android podem funcionar com uma quantidade modesta de memória quando todo o firmware é controlado e cada jogo é testado no aparelho de destino.",
    rsgGame1Emphasis: "Muitas vezes viável com 1–2 GB; teste cada jogo",
    rsgGame2Title: "Jogos na nuvem",
    rsgGame2Body:
      "O processamento acontece na nuvem. A experiência no aparelho depende de uma rede com baixa latência, decodificação de vídeo por hardware, suporte a controles Bluetooth ou USB e exibição estável dos quadros.",
    rsgGame2Emphasis: "Rede, decodificador e latência do controle vêm primeiro",
    rsgGame3Title: "Jogos exigentes executados no aparelho",
    rsgGame3Body:
      "Texturas maiores, motores de jogos e recursos em segundo plano se beneficiam de 4 GB de RAM e mais armazenamento. Ainda assim, a capacidade da GPU e a manutenção do desempenho sem superaquecimento continuam decisivas.",
    rsgGame3Emphasis: "Prefira 4/32 após validar GPU e temperatura",
    rsgGamingNote:
      "Quatro gigabytes de RAM não transformam um SoC fraco em um console. RAM, GPU, processador, desempenho do armazenamento, refrigeração e suporte ao controle precisam formar um único requisito para jogos.",
    rsgTestEyebrow: "Verifique antes de comprar",
    rsgTestTitle: "Teste o uso real, não apenas o resultado de um teste sintético",
    rsgTestIntro:
      "A unidade de avaliação do fornecedor deve rodar o firmware final e os conteúdos previstos. Repita a mesma sequência de testes em cada modelo para que a comparação represente o serviço que os assinantes receberão.",
    rsgTest1: "Meça o tempo da inicialização completa e da retomada até a exibição da imagem",
    rsgTest2: "Abra o app principal e navegue entre as telas essenciais",
    rsgTest3: "Reproduza conteúdos representativos em 4K, HDR e protegidos",
    rsgTest4: "Alterne repetidamente entre todos os apps necessários",
    rsgTest5: "Reproduza TV ao vivo, OTT ou o conteúdo previsto por 24–72 horas",
    rsgTest6:
      "Teste jogos casuais, jogos na nuvem ou jogos executados no aparelho com o controle previsto",
    rsgTest7: "Instale uma atualização OTA com espaço livre realista e verifique a recuperação",
    rsgTest8:
      "Registre a RAM e o armazenamento disponíveis após a configuração inicial, o uso e as atualizações",
    rsgTestNoteTitle: "Mantenha o teste reproduzível",
    rsgTestNoteBody:
      "Documente os critérios de aprovação e reprovação antes de receber as unidades de teste. Uma demonstração bem ensaiada não substitui um procedimento de aceitação acordado.",
    rsgTestNoteCta: "Abrir a lista de verificação para escolher um STB",
    rsgDecisionEyebrow: "Como decidir",
    rsgDecisionTitle: "Compre a configuração mais enxuta que atenda ao requisito real com margem",
    rsgDecision1Title: "Defina o firmware de produção",
    rsgDecision1Body:
      "Liste o sistema operacional, a tela inicial, os apps, os serviços, o DRM, o DMS e o método de atualização que serão entregues, não apenas o nome genérico da plataforma.",
    rsgDecision2Title: "Separe a reprodução do processamento dos apps",
    rsgDecision2Body:
      "Confirme os codecs e as resoluções aceitos pelo decodificador de hardware. Depois, avalie CPU, GPU e RAM para a interface e os demais apps.",
    rsgDecision3Title: "Planeje o armazenamento ao longo do tempo",
    rsgDecision3Body:
      "Considere espaço utilizável, caches, registros, crescimento dos apps, recuperação e pelo menos um ciclo realista de atualização.",
    rsgDecision4Title: "Dimensione a margem para a vida útil",
    rsgDecision4Body:
      "Compare o custo da memória extra com a probabilidade de novos apps, suporte mais longo ou uma função mais ampla durante a vida da frota.",
    rsgDecisionConclusion:
      "O STB certo não é o que tem mais memória. É aquele que executa com confiabilidade as funções documentadas, cabe no orçamento da frota e mantém margem suficiente para a vida útil planejada.",
    rsgFaqEyebrow: "Perguntas frequentes",
    rsgFaqTitle: "Respostas sobre RAM e armazenamento",
    rsgFaqQ1: "1 GB de RAM é suficiente para um set-top box moderno?",
    rsgFaqA1:
      "Pode ser. Um gigabyte é uma configuração adequada para um cenário de uso bem definido, com firmware otimizado, tela inicial leve e um conjunto limitado de apps. Não é uma escolha segura para uma aplicação desconhecida, um ecossistema amplo de apps ou jogos exigentes executados no aparelho. Teste o firmware final antes de decidir.",
    rsgFaqQ2: "2 GB de RAM são o mínimo para Android TV?",
    rsgFaqA2:
      "Não existe uma regra universal de 2 GB que sirva para todo dispositivo de TV. Os requisitos públicos de compatibilidade do Android variam conforme a versão do Android, a arquitetura, a configuração da tela e a memória reservada pelo hardware. Os mínimos de compatibilidade também não indicam se um conjunto específico de apps terá bom desempenho; os testes de produção continuam decisivos.",
    rsgFaqQ3: "Mais RAM melhora a qualidade do vídeo 4K?",
    rsgFaqA3:
      "Sozinha, não. Hardware dedicado normalmente decodifica vídeo H.264, H.265 ou VP9. A reprodução 4K fluida depende do SoC, do decodificador, dos drivers, do caminho de saída e da compatibilidade do fluxo. A RAM é mais relevante para a tela inicial, os apps, a estratégia de armazenamento temporário e a multitarefa ao redor da reprodução.",
    rsgFaqQ4: "Quanto do armazenamento anunciado fica disponível?",
    rsgFaqA4:
      "Isso varia conforme o firmware e o esquema de partições. O sistema operacional, o ambiente de recuperação, os dados reservados e os apps pré-instalados reduzem o espaço disponível. Peça a quantidade de espaço livre em uma unidade equivalente à versão de produção já configurada, não apenas a capacidade nominal da memória flash.",
    rsgFaqQ5: "De quanta RAM um STB precisa para jogos?",
    rsgFaqA5:
      "Jogos leves podem funcionar bem com 1–2 GB, enquanto títulos exigentes executados no aparelho se beneficiam de 4 GB de RAM e mais armazenamento. Jogos na nuvem dependem mais da latência da rede, da decodificação por hardware e da resposta do controle. Em todos os casos, a capacidade da GPU e o controle de temperatura importam junto com a RAM.",
    rsgFaqQ6: "Uma operadora deve comprar memória extra pensando no futuro?",
    rsgFaqA6:
      "Apenas quando houver um plano de evolução realista. Uma margem adicional faz sentido quando são esperados mais apps, interfaces mais completas ou uma vida útil mais longa. Em uma frota grande, pagar por memória sem uso previsto em cada unidade pode custar mais do que escolher uma configuração menor, já comprovada, e controlar o escopo do produto.",
    rsgCtaEyebrow: "Decida com base em testes",
    rsgCtaTitle: "Descreva o uso. Ajudamos a dimensionar o aparelho.",
    rsgCtaBody:
      "Compartilhe os apps, os conteúdos, as integrações, os requisitos de jogos e a vida útil esperada. A equipe inext pode recomendar uma configuração e preparar uma unidade de avaliação com o firmware previsto.",
    rsgCtaPrimary: "Conversar sobre os requisitos",
    rsgCtaSecondary: "Comparar todos os modelos",
    footerLinkBrand: "Materiais da marca",
    brandSeoTitle: "Materiais da marca e diretrizes do logo inext",
    brandSeoDescription:
      "Baixe logos e ícones oficiais da inext e consulte cores, tipografia, regras de uso e permissões aprovadas para imprensa e marketing de parceiros.",
    brandEyebrow: "Marca inext",
    brandHeading: "Materiais da marca prontos para usar",
    brandIntro:
      "Baixe os arquivos aprovados do logo inext e siga as orientações essenciais de cor, tipografia, nome escrito e uso correto por terceiros.",
    brandDownloadPack: "Baixar pacote de materiais",
    brandDownloadGuide: "Baixar guia em PDF",
    brandDownloadNote:
      "Download gratuito para imprensa, uso editorial e marketing correto de parceiros.",
    brandLogoAlt: "Logo inext",
    brandLogoEyebrow: "Sistema de logo",
    brandLogoTitle: "Escolha a versão certa para o fundo",
    brandLogoDescription:
      "Use o logo completo sempre que houver espaço. O ícone compacto foi criado para formatos quadrados ou com pouco espaço. Baixe os arquivos em SVG escalável ou PNG transparente.",
    brandPrimary: "Principal · fundo branco",
    brandOnDark: "Para fundos pretos",
    brandOnBlue: "Para fundos no azul inext",
    brandFullLogo: "Logo completo",
    brandIcon: "Ícone",
    brandColorsEyebrow: "Cores",
    brandColorsTitle: "Uma paleta objetiva de três cores",
    brandColorsDescription:
      "Estas são as cores aprovadas do logo inext. Use os valores exatos abaixo e os arquivos fornecidos em vez de recolorir o logo manualmente.",
    brandColorBlue: "Azul inext",
    brandColorWhite: "Branco",
    brandColorBlack: "Preto",
    brandTypographyEyebrow: "Tipografia e nome",
    brandTypographyTitle: "Mantenha a tipografia clara e consistente",
    brandTypographyDescription:
      "Use Roboto nas comunicações da marca inext sempre que possível. Escolha pesos que mantenham uma hierarquia clara e uma leitura confortável.",
    brandTypographyLink: "Obter Roboto no Google Fonts",
    brandNameTitle: "Nome da marca por escrito",
    brandNameDescription:
      "Em textos corridos, escreva o nome da marca em letras minúsculas: “inext”. Quando o símbolo chevron for necessário, use o arquivo oficial do logo; não substitua o símbolo do logo pelo caractere de texto “›”.",
    brandUsageEyebrow: "Uso correto",
    brandUsageTitle: "Preserve a forma, o contraste e o significado",
    brandUsageDescription:
      "O uso consistente torna a marca reconhecível em conteúdo editorial, materiais de produto e campanhas de parceiros.",
    brandDoTitle: "Faça",
    brandDoOfficialAssets: "Use os arquivos oficiais fornecidos nesta página.",
    brandDoContrast: "Escolha a versão aprovada com bom contraste em relação ao fundo.",
    brandDoProportions:
      "Preserve as proporções do logo e mantenha um espaço confortável ao redor dele.",
    brandDoAccurateRelationship:
      "Descreva corretamente a relação com a inext nos materiais de parceiros.",
    brandDontTitle: "Não faça",
    brandDontRecolor: "Não invente cores nem combine partes de versões diferentes.",
    brandDontDistort: "Não estique, comprima, gire, corte ou incline o arquivo.",
    brandDontEffects: "Não adicione contornos, sombras, gradientes ou outros efeitos.",
    brandDontRearrange: "Não reorganize o ícone e o nome nem componha um logo substituto em texto.",
    brandPermissionsEyebrow: "Permissões",
    brandPermissionsTitle: "Materiais abertos, representação correta",
    brandPermissionsDescription:
      "Os arquivos do logo estão disponíveis gratuitamente para cobertura legítima e colaboração. Não é necessário preencher formulário nem enviar e-mail.",
    brandPermissionPress:
      "Imprensa e equipes editoriais podem usar os materiais ao mencionar a inext.",
    brandPermissionPartners:
      "Parceiros podem usá-los em marketing que represente uma relação verdadeira.",
    brandPermissionAccuracy:
      "O uso não pode sugerir apoio, certificação ou parceria que não exista.",
    brandContactCta: "Consultar um uso especial",
  },
  es: {
    navProducts: "Productos",
    navCustomization: "Personalización",
    navAbout: "Acerca de",
    navBlog: "Blog",
    navFaq: "FAQ",
    navContact: "Contacto",
    navSearch: "Buscar",
    announcementLabel: "Novedad",
    contactSales: "Contactar a ventas",
    toggleMenu: "Mostrar u ocultar menú",
    language: "Idioma",
    breadcrumbLabel: "Ruta de navegación",
    heroEyebrow: "Hardware STB para operadores · Desde 2011",
    heroTitle: "Set-Top Boxes con Android TV",
    heroTitleAccent: "para operadores de IPTV y OTT",
    heroDescription:
      "Cuatro modelos Android TV listos para desplegar, personalizados para la marca y el software del operador, con Alcatraz DMS para gestionar la flota.",
    heroModelsCta: "Comparar modelos STB",
    heroQuoteCta: "Solicitar cotización",
    exploreProducts: "Explorar productos",
    bookDemo: "Solicitar demo",
    trustedBy: "Más de 250 operadores y proveedores de TV en 15 países confían en inext",
    operationsStatPill: "Impulsando más de 120 redes de operadores en todo el mundo",
    stackEyebrow: "El stack de inext",
    stackTitle: "Hardware, personalización y",
    stackTitleAccent: "operaciones",
    stackTitleEnd: "— en un solo lugar",
    stackDescription:
      "Tres pilares que cubren todo lo que un operador necesita para lanzar y operar un servicio moderno de IPTV / OTT.",
    hardwareEyebrow: "Hardware · Nuestro STB insignia",
    hardwareTitle: "Conozca el",
    hardwareDescription:
      "Un Set-Top Box con Android 12 (AOSP) compacto pero potente, diseñado para ISPs y operadores de TV. Con el Allwinner H618, 4GB DDR3 y 32GB eMMC, ofrece reproducción fluida en 4K UHD a 60fps por HDMI 2.0a, se conecta mediante Wi-Fi AC de doble banda, Bluetooth 5.0 o Ethernet de 100Mb, e incluye control remoto, cable HDMI y adaptador de corriente.",
    viewTechSpecs: "Ver especificaciones técnicas",
    clientsEyebrow: "White-label y co-branding",
    clientsTitle: "Operadores que ya envían",
    clientsTitleAccent: "STBs de inext",
    clientsDescription:
      "Hardware, empaque y UX reales entregados a los principales ISPs y plataformas OTT: totalmente de marca, de extremo a extremo.",
    clientsOutro:
      "Desde un solo equipo hasta un despliegue a nivel nacional: su marca, nuestra ingeniería.",
    customizationEyebrow: "Personalización",
    customizationTitle: "Su marca, de extremo a extremo",
    customizationDescription:
      "Desde el equipo en el estante hasta el launcher en la TV, cada capa de la experiencia inext puede adaptarse a la marca y el contenido de su operador.",
    learnMore: "Más información",
    lineupEyebrow: "Elija el hardware",
    lineupTitle: "Cuatro STBs. Una plataforma para operadores.",
    lineupDescription:
      "Empiece por las necesidades del despliegue: hardware 4K esencial, más memoria y almacenamiento o el modelo insignia de 4 GB. Todos están diseñados para el control del operador y Alcatraz DMS.",
    lineupCompareAll: "Comparar todos los modelos",
    lineupFlagshipBadge: "Insignia",
    lineupTv5Tagline: "Android 4K esencial para despliegues sensibles al costo.",
    lineupTv5UltraTagline: "Más memoria y almacenamiento sobre la plataforma comprobada.",
    lineupTv6Tagline: "4K más inteligente con Bluetooth y Wi-Fi ac.",
    lineupTv6UltraTagline: "Máxima potencia y almacenamiento: el insignia.",
    homeCompanionEyebrow: "App complementaria",
    homeCompanionCta: "Explorar inext Remote",
    operationsEyebrow: "Operaciones · Alcatraz DMS + protocolos",
    operationsTitle: "Una plataforma para gestionar",
    operationsTitleAccent: "cada dispositivo",
    operationsDescription:
      "Alcatraz DMS es el sistema de gestión de dispositivos utilizado en cada despliegue de inext. Desde una sola consola, los equipos pueden detectar problemas de la flota, consultar la actividad de los dispositivos, distribuir firmware y ejecutar diagnósticos remotos.",
    ctaEyebrow: "Hable con nosotros",
    ctaTitle: "¿Listo para elegir el",
    ctaTitleAccent: "STB adecuado?",
    ctaDescription:
      "Cuéntenos sobre el servicio, el tamaño de la flota y los requisitos técnicos. Recomendaremos la configuración de hardware y el plan de despliegue.",
    footerDescription:
      "Set-Top Boxes y software de gestión de dispositivos para ISPs y proveedores de TV desde 2011.",
    footerProducts: "Productos",
    footerSolutions: "Soluciones",
    footerCompany: "Empresa",
    footerRights: "Todos los derechos reservados.",
    homeTitle: "Set-Top Boxes con Android TV para operadores de IPTV y OTT | inext",
    homeDescription:
      "inext suministra Set-Top Boxes con Android TV para ISPs y operadores de TV, con personalización white-label, aplicaciones IPTV, Alcatraz DMS y entrega B2B global.",
    portalEyebrow: "Más allá del equipo",
    portalTitle: "Todo lo que un operador necesita alrededor del STB.",
    portalDescription:
      "Convierta el hardware elegido en un producto completo para el suscriptor con marca, aplicaciones, operación de flota y entrega B2B coordinada.",
    portalResourcesEyebrow: "Centro de conocimiento",
    portalResourcesTitle: "Planifique el despliegue con guías prácticas y herramientas.",
    portalResourcesDescription:
      "Investigue decisiones de hardware, compare costos de flota y encuentre respuestas prácticas en todo el portal de inext.",
    heroQuickHardware: "Hardware",
    heroQuickCustomization: "Personalización",
    heroQuickOperations: "Operaciones",
    heroQuickLogistics: "Entrega mundial",
    heroDashboardTitle: "Alcatraz DMS · Vista general de la flota",
    heroMetricActiveDevices: "Dispositivos activos",
    heroMetricOnline: "En línea",
    heroMetricStreams: "Streams / min",
    heroFirmware: "Firmware",
    heroDeviceOnline: "En línea",
    heroDeviceImageAlt: "Set-Top Box inext TV6 Ultra con control remoto",
    heroSpecChipset: "Chipset",
    heroSpecMemory: "Memoria",
    heroSpecVideo: "Video",
    heroSpecOs: "SO",
    heroStackBadge: "Hardware + software, en un solo stack",
    productMenuFlagship: "Insignia",
    productMenuTv6UltraDesc: "Premium · 4 GB / 32 GB · control remoto por voz",
    productMenuTv6Desc: "Rendimiento · 2 GB / 16 GB · control remoto IR",
    productMenuTv5UltraDesc: "Estándar · 2 GB / 16 GB · control remoto IR",
    productMenuTv5Desc: "Esencial · 1 GB / 8 GB · control remoto IR",
    navMenuProductsEyebrow: "Set-Top Boxes",
    navMenuSolutionsEyebrow: "Soluciones y software",
    navMenuSolutionsGroupPlatform: "Plataforma y operaciones",
    navMenuSolutionsGroupApps: "Apps",
    navMenuSolutionsGroupServices: "Servicios",
    productMenuFeaturedTitle: "El box 4K insignia",
    productMenuFeaturedDesc: "Android 12 · control remoto por voz BT · Alcatraz DMS",
    productMenuFeaturedCta: "Explorar el insignia",
    pillarHardwareEyebrow: "Hardware",
    pillarHardwareTitle: "Set-Top Boxes con Android TV",
    pillarHardwareDescription:
      "STBs 4K compactos y potentes diseñados para ISPs y operadores de TV. Nuestro insignia, el inext TV6 Ultra, encabeza la línea.",
    pillarHardwareCta: "Explorar la línea",
    pillarCustomizationEyebrow: "Personalización",
    pillarCustomizationTitle: "Su marca, en cada pantalla",
    pillarCustomizationDescription:
      "Hardware white-label, co-branding, apps de IPTV personalizadas, launcher de operador y una app complementaria de control remoto: creados en torno a su identidad.",
    pillarCustomizationCta: "Explorar personalización",
    pillarOperationsEyebrow: "Operaciones",
    pillarOperationsTitle: "Opere su flota a gran escala",
    pillarOperationsDescription:
      "Fleet Health, historial de actividad de los dispositivos, actualizaciones OTA por etapas, diagnósticos remotos y TR-069 en una sola consola Alcatraz DMS para toda la red.",
    pillarOperationsCta: "Dentro de Alcatraz DMS",
    hardwareSpecChipset: "Allwinner H618 · Quad-Core A53",
    hardwareSpecMemory: "4 GB DDR3 · 32 GB eMMC · Mali-G31 MP2",
    hardwareSpecVideo: "4K UHD H.265 60 fps · VP9 · H.264",
    hardwareSpecWireless: "Wi-Fi AC de doble banda · BT 5.0 · LAN 100Mb",
    hardwareSpecPorts: "HDMI 2.0a · salida A/V · 2×USB 2.0 · microSD/TF",
    hardwareSpecSoftware: "Android 12 (AOSP) · Alcatraz™ DMS · TR-069",
    hardwareImageAlt: "Set-Top Box inext TV6 Ultra con control remoto y empaque",
    hardwareStatUltraHd: "Ultra HD",
    hardwareStat60Fps: "60 fps",
    hardwareStatAndroid: "Android",
    clientTagFullPackage: "Paquete completo",
    clientTagCoBranding: "Co-branding",
    clientTagRetailKit: "Kit retail",
    clientTagCustomApp: "App personalizada",
    clientTagWhiteLabel: "White-label",
    clientImageAltSuffix: "STB de inext",
    clientNoteBeeline: "STB, control remoto y caja retail de marca",
    clientNoteOkTv: "Dispositivo y empaque retail con marca del operador",
    clientNoteKyivstar: "Dispositivo, control remoto y caja retail de marca",
    clientNoteAlmaTv: "Box IPTV — empaque + set de control remoto",
    clientNoteSarkor: "UI del operador, empaque y accesorios",
    clientNoteSweetTv: "Box 2 UltraHD — paquete retail completo",
    clientNoteMegogo: "Edición negra con control remoto de marca",
    clientNoteMetroTv: "STB con marca del operador y caja retail",
    customServiceWhiteLabelingTitle: "White-labeling",
    customServiceWhiteLabelingDescription:
      "Envíe hardware y apps con su propia marca: empaque, firmware y UI totalmente personalizados a su identidad.",
    customServiceCoBrandingTitle: "Co-branding",
    customServiceCoBrandingDescription:
      "Combine su marca con la plataforma inext a través de experiencias co-branded flexibles y kits retail.",
    customServiceIptvAppTitle: "App cliente de IPTV personalizada",
    customServiceIptvAppDescription:
      "Reproductor IPTV/OTT a medida con EPG, catch-up, time-shift y VOD: adaptado a su catálogo de contenido.",
    customServiceLauncherTitle: "Launcher para el nivel del operador",
    customServiceLauncherDescription:
      "Un launcher de Android TV curado con filas de marca, pantallas de inicio personalizadas y experiencias restringidas.",
    customServiceRemoteAppTitle: "App móvil de control remoto",
    customServiceRemoteAppDescription:
      "Convierta cualquier smartphone en un control remoto potente: emparejamiento Bluetooth, búsqueda por voz, entrada de teclado y gestos.",
    customServiceAppDesignTitle: "Diseño de app personalizado",
    customServiceAppDesignDescription:
      "Trabajo de UI/UX de extremo a extremo para launcher, EPG y reproductor: diseñado en torno a sus suscriptores y su contenido.",
    operationsImageAlt:
      "Panel de Alcatraz DMS — vista general de la flota en tiempo real con dispositivos en línea, modelos y distribución de firmware",
    operationsFeatureTelemetry: "Alertas Fleet Health y cola de problemas",
    operationsFeatureOta: "Despliegues de firmware OTA por etapas",
    operationsFeatureTr069: "Compatibilidad con TR-069 / CWMP",
    operationsFeaturePush: "Notificaciones push segmentadas",
    operationsFeatureIperf: "Diagnósticos MTR e iPerf3",
    operationsFeatureAccess: "Claves de API con permisos limitados y acceso por rol",
    operationsFeatureDiagnostics: "Actividad de dispositivos e historial de problemas",
    operationsLiveBadge: "En vivo",
    operationsCalloutOnline: "6,236 dispositivos en línea",
    operationsCalloutActive: "62% activos este mes",
    operationsCalloutFirmware: "2 nuevos firmwares por probar",
    operationsMetric1Value: "120+",
    operationsMetric1Label: "redes de operadores",
    operationsMetric3Value: "24/7",
    operationsMetric3Label: "monitoreo de flota",
    footerLinkTv6Ultra: "inext TV6 Ultra",
    footerLinkTv6: "inext TV6",
    footerLinkTv5Ultra: "inext TV5 Ultra",
    footerLinkTv5: "inext TV5",
    footerLinkAbout: "Acerca de",
    footerLinkBlog: "Blog",
    footerLinkNewsletter: "Boletín",
    footerLinkFaq: "FAQ",
    footerLinkContact: "Contacto",
    footerLinkDistributors: "Distribuidores",
    footerLinkPrivacy: "Política de privacidad",
    footerLinkRepublishing: "Republicación",
    footerLinkServiceStatus: "Estado del servicio",
    aboutTitle: "Acerca de inext",
    aboutDescription:
      "Conozca inext, un equipo internacional de ingeniería fundado en Kyiv que fabrica Set-Top Boxes listos para operadores, software de TV y herramientas de gestión de dispositivos.",
    aboutEyebrow: "Empresa internacional de tecnología de TV",
    aboutHeading: "Creamos soluciones de TV que funcionan en redes reales.",
    aboutIntro:
      "inext es un equipo internacional que diseña Set-Top Boxes, software de TV y herramientas de gestión de flotas para ISPs y proveedores OTT. Acompañamos el producto desde la especificación inicial hasta el despliegue y la operación a largo plazo.",
    aboutStat1Value: "15",
    aboutStat1Label: "países con despliegues de operadores",
    aboutStat3Value: "250+",
    aboutStat3Label: "clientes y socios B2B",
    aboutStat4Value: "17",
    aboutStat4Label: "modelos de STB desarrollados desde 2011",
    aboutStat5Value: "700K+",
    aboutStat5Label: "dispositivos entregados en todo el mundo",
    aboutWorldwideDeliveryTitle: "Entrega mundial en la práctica",
    aboutWorldwideDeliveryBody:
      "inext cuenta con experiencia práctica en proyectos internacionales, desde lanzamientos en un solo mercado hasta despliegues de operadores en varios países. Podemos entregar Set-Top Boxes, empaque de marca, firmware y soporte de despliegue de forma directa o mediante un trabajo coordinado con distribuidores.",
    aboutBrandResourcesPrompt: "¿Buscas el logo o los recursos oficiales de la marca?",
    aboutBrandResourcesCta: "Ver recursos de marca",
    aboutCapabilitiesEyebrow: "Lo que creamos",
    aboutCapabilitiesTitle: "Un solo equipo para la experiencia completa del suscriptor.",
    aboutCapabilitiesLede:
      "El hardware, el software y las operaciones de flota se desarrollan en conjunto, lo que da a los operadores una ruta práctica desde la especificación del producto hasta un despliegue con soporte.",
    aboutCapabilityHardwareTitle: "Hardware de TV listo para operadores",
    aboutCapabilityHardwareBody:
      "Set-Top Boxes comprobados con Android AOSP configurados para servicios de IPTV y OTT, desde modelos accesibles para despliegues hasta nuestra plataforma insignia.",
    aboutCapabilityHardwareCta: "Explorar la línea",
    aboutCapabilitySoftwareTitle: "Firmware y software de TV",
    aboutCapabilitySoftwareBody:
      "Firmware de marca, launchers, integración de aplicaciones y desarrollo de TV personalizado adaptados al servicio y la identidad del operador.",
    aboutCapabilitySoftwareCta: "Explorar personalización",
    aboutCapabilityOperationsTitle: "Operaciones de flota",
    aboutCapabilityOperationsBody:
      "Aprovisionamiento, actualizaciones de firmware por etapas, diagnósticos y control remoto a través de Alcatraz DMS y protocolos de operador establecidos.",
    aboutCapabilityOperationsCta: "Explorar Alcatraz DMS",
    aboutHeritageEyebrow: "Nuestra historia",
    aboutHeritageTitle: "Raíces en Kyiv. Perspectiva internacional.",
    aboutStoryPara1:
      "Fundada en Kyiv en 2011, inext comenzó desarrollando hardware de medios para el hogar durante la transición de los formatos físicos al streaming. El rendimiento de video, la estabilidad de los dispositivos y la fiabilidad a largo plazo fueron esenciales desde el principio.",
    aboutStoryPara2:
      "Hoy somos un equipo internacional que trabaja desde varios países. A medida que IPTV y OTT se volvieron centrales en las redes de operadores, nuestra experiencia evolucionó hacia una plataforma más amplia: Set-Top Boxes, software de TV adaptable y gestión de flotas. El mercado ha cambiado, pero nuestro papel sigue siendo el mismo: convertir requisitos técnicos complejos en productos confiables para el uso diario.",
    aboutPrinciplesEyebrow: "Cómo trabajamos",
    aboutPrinciplesTitle: "Ingeniería práctica para despliegues reales.",
    aboutPrinciplesLede:
      "Tomamos decisiones en torno a las realidades de las redes de operadores, el soporte a suscriptores y productos que deben seguir siendo útiles mucho después del lanzamiento.",
    aboutPrinciple1Title: "Listo para desplegar",
    aboutPrinciple1Body:
      "Comience con bases de hardware y software comprobadas en lugar de reconstruir lo básico en cada despliegue.",
    aboutPrinciple2Title: "Adaptable donde importa",
    aboutPrinciple2Body:
      "Personalice la marca, el firmware, las integraciones y el hardware cuando el proyecto tenga requisitos que un dispositivo estándar no pueda cumplir.",
    aboutPrinciple3Title: "Con soporte durante todo el ciclo de vida",
    aboutPrinciple3Body:
      "Gestione firmware, diagnósticos y operaciones de dispositivos después del lanzamiento, no solo durante la entrega del producto.",
    aboutCtaEyebrow: "Trabaje con inext",
    aboutCtaTitle: "¿Planea un despliegue de TV de marca?",
    aboutCtaBody:
      "Cuéntenos sobre su red, su modelo de contenido y sus mercados. Le ayudaremos a definir el paquete de dispositivo y software adecuado.",
    aboutHeroEst: "Fundada en Kyiv · 2011",
    aboutHeroImageAlt: "Dispositivos inext 3D kid, HD1, TV, TV2e y 4K2",
    aboutClientsEyebrow: "Con la confianza de los operadores",
    aboutClientsLede:
      "ISPs y plataformas OTT en 15 países ya envían STBs de inext a sus suscriptores.",
    aboutClientsCta: "Ver todos los clientes y casos de estudio",
    aboutClientImageAltSuffix: "despliegue de STB inext",
    contactsTitle: "Contactar a inext",
    contactsDescription: "Hable con el contacto de ventas de inext adecuado para su mercado.",
    contactsEyebrow: "Contacto",
    contactsHeading: "Construyamos su próxima experiencia de TV",
    contactsIntro: "Cuéntenos sobre su proyecto y nuestro equipo se pondrá en contacto con usted.",
    contactFormTitle: "Enviar una consulta",
    contactFormIntro:
      "Comparta algunos detalles para que podamos conectarlo con la persona adecuada.",
    contactNameLabel: "Nombre",
    contactCompanyLabel: "Empresa",
    contactCompanyOptionalLabel: "Empresa (opcional)",
    contactCompanyRequired: "Indica el nombre de la empresa para este tipo de consulta.",
    contactCountryLabel: "País",
    contactPhoneOptionalLabel: "Teléfono (opcional)",
    contactInquiryTypeLabel: "¿Cómo podemos ayudar?",
    contactInquiryTypePlaceholder: "Seleccione un tipo de consulta",
    contactInquiryType_sales: "Consulta de ventas",
    contactInquiryType_demo: "Solicitar demo",
    contactInquiryType_integration: "Integración",
    contactInquiryType_brand: "Marca y prensa",
    contactInquiryType_partnership: "Alianza",
    contactInquiryType_support: "Soporte de dispositivos",
    contactInquiryType_other: "Otro",
    contactBrandResourcesNote:
      "Los archivos oficiales del logo y las pautas de uso están disponibles para descarga inmediata. Usa este formulario solo para consultas sobre usos especiales.",
    contactBrandResourcesCta: "Ver recursos de marca",
    contactMessageLabel: "Mensaje",
    contactWebsiteHoneypotLabel: "Sitio web",
    contactConsentPrefix: "Acepto el procesamiento de mi información según se describe en la",
    contactPrivacyLink: "Política de Privacidad",
    contactConsentRequired: "Acepte la política de privacidad para continuar.",
    contactSubmit: "Enviar consulta",
    contactSubmitting: "Enviando...",
    contactSuccessTitle: "Gracias por contactarnos",
    contactSuccessBody: "Su consulta ha sido enviada. Nuestro equipo le responderá pronto.",
    contactFailureTitle: "No pudimos enviar su consulta",
    contactFailureBody: "Inténtelo de nuevo o escríbanos directamente a",
    contactRoutingLabel: "Ventas globales y direccionamiento de distribuidores",
    findDistributorTitle: "¿Busca un distribuidor local?",
    findDistributorBody: "Encuentre el socio inext adecuado para su mercado.",
    viewDistributors: "Ver distribuidores",
    exclusiveDistributorTitle: "Distribuidor exclusivo en Ucrania",
    globalDistributorListTitle: "Distribuidores",
    distributorListTitle: "Distribuidores en Polonia",
    otherRegionsDistributorTitle: "Otras regiones",
    directSalesOperationsTitle: "Ventas directas y operaciones en la UE",
    contactAddressLabel: "Dirección",
    contactPhoneLabel: "Teléfono",
    contactEmailLabel: "Correo electrónico",
    contactWebsiteLabel: "Sitio web",
    distributorsTitle: "Distribuidores inext",
    distributorsDescription: "Encuentre un distribuidor oficial de inext para su mercado.",
    distributorsEyebrow: "Socios",
    distributorsHeading: "Encuentre su distribuidor local",
    distributorsIntro: "Comuníquese con un distribuidor oficial de inext en su región.",
    distributorRegionUkraine: "Ucrania",
    distributorRegionPoland: "Polonia",
    distributorRegionSlovakia: "Eslovaquia",
    distributorRegionMoldova: "Moldavia",
    distributorRegionEuOperations: "Operaciones en la UE",
    distributorRegionGlobal: "Global",
    distributorContactCtaTitle: "¿No sabe con quién contactar?",
    distributorContactCtaBody:
      "Cuéntenos sobre su mercado y proyecto. Dirigiremos su consulta al distribuidor adecuado o al contacto de ventas directo de inext.",
    distributorContactCtaButton: "Contactar a inext",
    privacyTitle: "Política de Privacidad",
    privacyDescription: "Cómo inext procesa la información enviada a través de este sitio web.",
    privacyEyebrow: "Legal",
    privacyHeading: "Política de Privacidad",
    republishingTitle: "Republicación y licencias",
    republishingDescription:
      "La mayoría de los artículos de inext están bajo CC BY 4.0: libres de republicar, traducir y adaptar con atribución. Así se hace.",
    republishingEyebrow: "Licencias",
    republishingHeading: "Republicar nuestro contenido",
    blogLicenseLabel: "Licencia",
    blogLicenseAllRightsReserved: "Todos los derechos reservados",
    blogLicenseReusableNote: "Puede republicar este artículo con atribución a inext.",
    blogLicenseReservedNote: "Contáctenos antes de republicar.",
    blogLicenseGuidelines: "Pautas de republicación",
    republishKitToggle: "Republicar este artículo",
    republishKitIntro:
      "Licenciado bajo CC BY 4.0: acredite a inext e incluya un enlace de retorno.",
    republishCopyLink: "Copiar enlace",
    republishCopyMarkdown: "Copiar como Markdown",
    republishCopyHtml: "Copiar como HTML",
    republishDownloadMarkdown: "Descargar .md",
    republishDownloadHtml: "Descargar .html",
    republishDownloadImages: "Descargar imágenes (.zip)",
    republishDownloadingImages: "Preparando imágenes…",
    republishDownloadAudio: "Descargar audio",
    republishDownloadingAudio: "Preparando audio…",
    republishCopied: "Copiado",
    republishContact: "¿Tiene preguntas o necesita un recurso de mayor resolución?",
    republishReservedNotice:
      "Este artículo se republica de un tercero y no está disponible bajo CC BY 4.0.",
    republishCreditPrefix: "Publicado originalmente por inext en ",
    republishCreditSuffix: " — republicado bajo CC BY 4.0.",
    faqTitle: "Preguntas frecuentes de inext",
    faqDescription:
      "Respuestas sobre STBs de inext, soluciones IPTV, personalización, Alcatraz™ DMS, firmware y resolución de problemas.",
    faqEyebrow: "Soporte",
    faqHeading: "Preguntas frecuentes",
    faqIntro:
      "Respuestas rápidas sobre el hardware de inext, soluciones para operadores (app IPTV, marca, gestión de flota), firmware y problemas comunes de dispositivos.",
    faqCategoryAll: "Todas",
    faqCategoryDevices: "Dispositivos y configuración",
    faqCategoryFirmware: "Firmware",
    faqCategorySolutions: "Soluciones y apps",
    faqCategoryManagement: "Alcatraz™ DMS",
    faqCategoryTroubleshooting: "Resolución de problemas",
    faqQuestionCompare: "¿Qué Set-Top Box de inext debería elegir?",
    faqAnswerCompare:
      "TV6 Ultra es el modelo insignia para despliegues 4K premium. TV6 equilibra rendimiento y costo. TV5 Ultra se adapta a los despliegues masivos de IPTV/OTT; TV5 es el nivel de entrada. Use nuestra herramienta de comparación lado a lado para ajustar memoria, controles remotos y conectividad a su red.",
    faqQuestionIptvMiddleware: "¿Qué middleware de IPTV es compatible con la app IPTV de inext?",
    faqAnswerIptvMiddleware:
      "El cliente IPTV preinstalado de inext funciona con Stalker/Ministra, TVIP, Hibox, Aura y listas de reproducción M3U simples con EPG XMLTV, con marca blanca y preconfigurado para su servicio antes de que se envíen los equipos.",
    faqQuestionWhiteLabel: "¿Cuál es la diferencia entre co-branding y marca blanca?",
    faqAnswerWhiteLabel:
      "El co-branding combina su marca con inext en hardware y UI compartidos. La marca blanca elimina inext del equipo, el firmware y las apps por completo: los suscriptores solo ven su identidad.",
    faqQuestionRemoteApp: "¿Qué es la app inext Remote?",
    faqAnswerRemoteApp:
      "inext Remote es una app complementaria gratuita para Android e iOS que controla los STBs de inext desde un teléfono: teclado y búsqueda por voz, cambio de habitación, modo gamepad y temas claro/oscuro.",
    faqQuestionBuy: "¿Cómo puedo comprar productos inext o convertirme en socio?",
    faqAnswerBuy:
      "inext vende a operadores y distribuidores en todo el mundo. Encuentre un socio autorizado cerca de usted, o contacte a nuestro equipo de ventas para cotizaciones de flota, personalización e incorporación a Alcatraz™ DMS.",
    faqQuestionAlcatrazDeploy: "¿Puede Alcatraz™ DMS ejecutarse en nuestra propia red?",
    faqAnswerAlcatrazDeploy:
      "Sí. Alcatraz funciona como SaaS gestionado en la nube o como una instalación on-premises dentro de una red ISP cerrada: la misma consola y el mismo conjunto de funciones, con un despliegue elegido para cumplir sus requisitos de residencia de datos.",
    faqQuestionAlcatrazIntegrate:
      "¿Podemos integrar Alcatraz con nuestro BSS/OSS o herramientas de soporte?",
    faqAnswerAlcatrazIntegrate:
      "Sí. Alcatraz ofrece una API REST documentada y mensajería MQTT. Los administradores pueden crear y revocar claves de API, restringir permisos y direcciones IP de origen, establecer fechas de vencimiento y conectar dispositivos con referencias de CRM o facturación mediante IDs externos.",
    faqQuestionHdmi: "¿Qué estándar HDMI admiten los dispositivos inext?",
    faqAnswerHdmi:
      "Todos los STBs actuales de inext incluyen salida HDMI 2.0a con soporte CEC. Se incluye un cable HDMI en la caja.",
    faqQuestionResolution: "¿Todos los dispositivos inext admiten 4K?",
    faqAnswerResolution:
      "Sí: TV5, TV5 Ultra, TV6 y TV6 Ultra admiten reproducción 4K UHD de hasta 60 FPS mediante decodificación por hardware H.265, VP9 y H.264.",
    faqQuestionAndroid: "¿Qué versión de Android ejecutan los dispositivos inext?",
    faqAnswerAndroid:
      "TV6 Ultra y TV6 ejecutan Android 12 (AOSP). TV5 Ultra y TV5 ejecutan Android 10 (AOSP). Todos los modelos usan AOSP abierto sin los Servicios de Google Play preinstalados.",
    faqQuestionRemote: "¿Qué tipo de control remoto se incluye?",
    faqAnswerRemote:
      "TV6 Ultra viene con un control remoto por voz Bluetooth 5.0. TV6 normalmente incluye un control remoto IR con teclado numérico completo, aunque en algunas regiones se envía con un control remoto Bluetooth. TV5 Ultra y TV5 incluyen un control remoto IR con teclado numérico completo.",
    faqQuestionFirmwares: "¿Dónde puedo encontrar los firmwares oficiales?",
    faqAnswerFirmwares:
      "Todo el firmware más reciente para los dispositivos inext está disponible únicamente mediante actualización OTA en línea. Puede buscar actualizaciones en línea en su dispositivo desde Configuración → Acerca de → Actualización del sistema. Si tiene algún problema al actualizar su dispositivo, contacte a nuestro centro de servicio.",
    faqQuestionFirmwareCheck: "¿Cómo verifico mi versión actual de firmware?",
    faqAnswerFirmwareCheck:
      "Vaya a Configuración → Acerca de → Número de compilación en su dispositivo. Allí se muestran la versión del firmware y la fecha de compilación.",
    faqQuestionOtaFleet: "¿Cómo funcionan las actualizaciones de firmware OTA para los operadores?",
    faqAnswerOtaFleet:
      "Las actualizaciones de firmware OTA son una solución para operadores integrada en la plataforma Alcatraz. Suba una versión, defina grupos de dispositivos objetivo y establezca un porcentaje de despliegue escalonado: la plataforma dirige las descargas a través del nodo de almacenamiento más cercano y rastrea el estado de instalación por dispositivo. Puede pausar, expandir o revertir en cualquier etapa, y marcar las actualizaciones críticas como obligatorias para que los dispositivos no puedan omitirlas.",
    faqQuestionAlcatraz: "¿Qué es Alcatraz™ DMS?",
    faqAnswerAlcatraz:
      "Alcatraz™ DMS es la plataforma de inext para la gestión remota de flotas. Los operadores usan Fleet Health para priorizar problemas, consultan la actividad de los dispositivos, distribuyen firmware OTA, ejecutan diagnósticos y gestionan configuraciones desde una sola consola. Alcatraz Pro está incluido sin costo adicional para flotas con menos de 500 dispositivos activos. Para flotas con 500 dispositivos activos o más, el acceso y las condiciones comerciales se acuerdan directamente con inext.",
    faqQuestionAlcatrazModels: "¿Qué modelos incluyen soporte para Alcatraz™ DMS?",
    faqAnswerAlcatrazModels:
      "Los cuatro modelos actuales de inext — TV5, TV5 Ultra, TV6 y TV6 Ultra — vienen con soporte para Alcatraz™ DMS incluido.",
    faqQuestionTr069: "¿Es compatible con TR-069?",
    faqAnswerTr069:
      "Sí. Todos los modelos actuales admiten TR-069/CWMP junto con Alcatraz, de modo que los operadores con un ACS existente pueden seguir usándolo. Alcatraz añade telemetría más completa, notificaciones push, control remoto en la app y una API REST moderna.",
    faqQuestionBlackScreen: "Mi dispositivo tiene la pantalla en negro, ¿qué debo hacer?",
    faqAnswerBlackScreen:
      "Antes que nada, intente un simple reinicio: desconecte su inext de la toma de corriente, espere 30 segundos y vuelva a conectarlo. Si esto no ayuda, contacte a nuestro centro de servicio.",
    faqQuestionWifi: "Mi dispositivo no se conecta al Wi-Fi. ¿Qué debo hacer?",
    faqAnswerWifi:
      "Asegúrese de estar dentro del alcance de su router y de ingresar la contraseña correcta. Si eso no ayuda: (1) reinicie el dispositivo y el router, (2) olvide la red y vuelva a conectarse, (3) verifique que su router transmita en una banda que el dispositivo admita (2.4 GHz o 5 GHz). Si nada de esto funciona, contacte a nuestro centro de servicio.",
    faqQuestionBlocked: "Mi dispositivo dice que ha sido bloqueado. ¿Qué debo hacer?",
    faqAnswerBlocked:
      "Antes que nada, intente contactar a su Proveedor de Servicios de Internet (ISP). Si su ISP no puede ayudarle, envíenos un mensaje usando el formulario de contacto anterior.",
    faqContactTitle: "¿Aún tiene una pregunta?",
    faqContactBody:
      "Nuestro equipo de soporte y socios de servicio pueden ayudar con problemas de dispositivos, firmware, configuración de la app IPTV, personalización, aprovisionamiento e integración con Alcatraz™ DMS.",
    faqContactCta: "Contactar a soporte",
    faqSearchPlaceholder: "Buscar preguntas...",
    faqSearchClear: "Limpiar búsqueda",
    faqNoResultsTitle: "No se encontraron resultados",
    faqNoResultsWithQuery:
      'Nada coincidió con "{query}". Pruebe con otras palabras clave o limpie la búsqueda.',
    faqNoResultsCategory: "Aún no hay preguntas en esta categoría.",
    searchTitle: "Buscar en inext",
    searchDescription:
      "Busque en el sitio web de inext, páginas de productos, páginas de soporte y artículos del blog.",
    searchEyebrow: "Buscar",
    searchHeading: "Buscar en el sitio web de inext",
    searchIntro:
      "Encuentre detalles de productos, respuestas de soporte, contactos de distribuidores, información legal y artículos del blog en todo el sitio.",
    searchPlaceholder: "Buscar productos, soporte, blog...",
    searchClear: "Limpiar búsqueda",
    searchLoading: "Cargando índice de búsqueda...",
    searchErrorTitle: "La búsqueda no está disponible temporalmente",
    searchErrorBody:
      "No se pudo cargar el índice de búsqueda. Actualice la página o inténtelo de nuevo más tarde.",
    searchNoQueryTitle: "Comience con una palabra clave",
    searchNoQueryBody:
      "Busque por nombre de modelo, característica, distribuidor, tema de soporte o palabra clave de artículo.",
    searchNoResultsTitle: "No se encontraron resultados",
    searchNoResultsBody:
      'Nada coincidió con "{query}". Pruebe con una frase más corta o una palabra clave diferente.',
    searchResultsCount: '{count} resultados para "{query}"',
    searchTypePage: "Página",
    searchTypeProduct: "Producto",
    searchTypeBlog: "Blog",
    searchTypeSupport: "Soporte",
    searchTypeLegal: "Legal",
    searchTypeApp: "App",
    blogTitle: "inext insights",
    blogDescription:
      "Aspectos destacados de eventos, noticias de productos e información técnica para operadores de IPTV y OTT.",
    blogReadMore: "Leer artículo",
    blogEmpty: "Aún no se han publicado artículos para este mercado.",
    blogFeatured: "Recientes",
    blogFilterAll: "Todos",
    blogTagEvents: "Eventos",
    blogTagPartnerships: "Alianzas",
    blogTagProducts: "Productos",
    blogTagSoftware: "Software",
    blogTagCompany: "Empresa",
    blogLoadMore: "Cargar más",
    blogBackToTop: "Volver arriba",
    blogNewerPost: "Artículo más reciente",
    blogOlderPost: "Artículo anterior",
    blogMediaAudio: "Incluye audio",
    blogMediaVideo: "Incluye video",
    newsletterEyebrow: "Novedades de inext",
    newsletterTitle:
      "Lanzamientos de productos, actualizaciones de firmware y contenido práctico para operadores.",
    newsletterDescription:
      "Reciba anuncios de productos, nuevas versiones de firmware, actualizaciones de Alcatraz DMS y contenido práctico para operadores de TV.",
    newsletterSeoTitle: "Boletín de inext — productos y actualizaciones de firmware",
    newsletterSeoDescription:
      "Suscríbase para recibir lanzamientos de productos de inext, nuevas versiones de firmware, actualizaciones de Alcatraz DMS y contenido práctico para operadores de TV.",
    newsletterPageBenefitProducts: "Nuevos set-top boxes y accesorios",
    newsletterPageBenefitFirmware: "Nuevas versiones de firmware y actualizaciones de Alcatraz DMS",
    newsletterPageBenefitInsights: "Contenido práctico para operadores de TV",
    newsletterPageFormTitle: "Suscríbase al boletín de inext",
    newsletterPageReassurance:
      "Solo enviamos novedades relevantes. Puede darse de baja en cualquier momento.",
    newsletterEmailLabel: "Correo electrónico",
    newsletterEmailPlaceholder: "nombre@empresa.com",
    newsletterSubmit: "Suscribirse",
    newsletterSubmitting: "Procesando…",
    newsletterSuccessTitle: "Suscripción activa",
    newsletterSuccessBody:
      "A partir de ahora recibirá novedades sobre productos y actualizaciones de inext.",
    newsletterError: "No se pudo completar la suscripción. Inténtelo de nuevo.",
    newsletterPrivacyPrefix:
      "Al suscribirse, acepta recibir novedades sobre productos y actualizaciones de inext. Consulte nuestra",
    newsletterPrivacyLink: "política de privacidad",
    newsletterWebsiteLabel: "Deje este campo en blanco",
    newsEyebrow: "Sala de prensa",
    newsTitle: "Novedades en",
    newsTitleAccent: "inext",
    newsDescription:
      "Lanzamientos de productos, alianzas y notas de campo de despliegues de operadores.",
    newsViewAll: "Ver todos los artículos",
    notFoundTitle: "Página no encontrada",
    notFoundBody: "La página que busca no existe o ha sido movida.",
    goHome: "Ir al inicio",
    errorTitle: "Esta página no se cargó",
    errorBody: "Algo salió mal de nuestro lado. Puede intentar actualizar o volver al inicio.",
    tryAgain: "Intentar de nuevo",
    compareAllModels: "Comparar los 4 modelos",
    compareTierFlagship: "Insignia",
    compareTierPerformance: "Rendimiento",
    compareTierStandard: "Estándar",
    compareTierEssential: "Esencial",
    compareGroupPerformance: "Rendimiento",
    compareGroupConnectivity: "Conectividad",
    compareGroupManagement: "Gestión",
    compareGroupPhysical: "Físico",
    compareGroupInBox: "En la caja",
    compareRowOs: "Sistema operativo",
    compareRowChipset: "Chipset",
    compareRowCpu: "CPU",
    compareRowGpu: "GPU",
    compareRowRam: "RAM",
    compareRowStorage: "Almacenamiento",
    compareRowMaxRes: "Resolución máxima",
    compareRowCodecs: "Códecs de video",
    compareRowHdmi: "HDMI",
    compareRowEthernet: "Ethernet",
    compareRowWifi: "Wi-Fi",
    compareRowBluetooth: "Bluetooth",
    compareRowUsb: "USB",
    compareRowCardReader: "Lector de tarjetas",
    compareRowAvOutput: "Salida AV / audio",
    compareRowRemote: "Control remoto",
    compareRowAlcatraz: "Alcatraz DMS",
    compareRowTr069: "TR-069",
    compareRowDimensions: "Dimensiones",
    compareRowPower: "Fuente de alimentación",
    compareRowRemoteInBox: "Control remoto",
    compareRowHdmiCable: "Cable HDMI",
    compareRowPowerAdapter: "Adaptador de corriente",
    compareRowBatteries: "Baterías",
    compareRowGuide: "Guía de inicio rápido",
    compareViewSpecs: "Ver especificaciones",
    compareCtaTitle: "¿Necesita ayuda para elegir el modelo adecuado?",
    compareCtaBody:
      "Cuéntenos sobre su red, el perfil de sus suscriptores y el precio objetivo. Asignaremos el dispositivo inext adecuado a su despliegue.",
    compareIncluded: "Incluido",
    compareNotIncluded: "No incluido",
    compareModelTv6UltraTagline:
      "Set-Top Box insignia con Android 12 para despliegues 4K avanzados.",
    compareModelTv6UltraSpecRemote: "Control remoto por voz BT",
    compareModelTv6UltraHighlight1: "La mayor RAM y almacenamiento de la línea",
    compareModelTv6UltraHighlight2: "Control remoto por voz Bluetooth 5.0",
    compareModelTv6UltraHighlight3: "Alcatraz™ DMS + TR-069",
    compareModelTv6Tagline: "Modelo Android 12 equilibrado para IPTV y OTT del día a día.",
    compareModelTv6SpecRemote: "Control remoto IR",
    compareModelTv6Highlight1: "La misma plataforma H618 que TV6 Ultra",
    compareModelTv6Highlight2: "Android 12 AOSP",
    compareModelTv6Highlight3: "Alcatraz™ DMS + TR-069",
    compareModelTv5UltraTagline: "Opción estable con Android 10 y 2 GB de RAM.",
    compareModelTv5UltraSpecRemote: "Control remoto IR",
    compareModelTv5UltraHighlight1: "Plataforma H313 probada",
    compareModelTv5UltraHighlight2: "Alcatraz™ DMS + TR-069",
    compareModelTv5UltraHighlight3: "Salida AV RCA para TVs antiguos",
    compareModelTv5Tagline:
      "Set-Top Box esencial con Android 10 para despliegues sensibles al costo.",
    compareModelTv5SpecRemote: "Control remoto IR",
    compareModelTv5Highlight1: "El más rentable de la línea",
    compareModelTv5Highlight2: "Alcatraz™ DMS + TR-069",
    compareModelTv5Highlight3: "Decodificación por hardware 4K@60",
    compareRemoteBtVoice: "Voz BT",
    compareRemoteIr: "IR",
    productPhotoComingSoon: "Foto del producto próximamente",
    productHardwarePhotoComingSoon: "Foto del hardware próximamente",
    productSoftwarePhotoComingSoon: "Foto lifestyle del software próximamente",
    productSoftwareLifestyleImageAlt:
      "TV mostrando un launcher de operador neutral por región con TV en vivo, VOD, catch-up, radio, apps y configuración",
    tv6HeroImageAlt:
      "inext TV6 sobre una mesa de sala con el TV mostrando inext TV, MEGOGO, sweet.tv, IPTV, Plex, VLC y Spotify",
    tv6PortsImageAlt:
      "Puertos traseros del inext TV6: microSD, 2× USB, extensor IR o puerto AV según el mercado, S/PDIF, Ethernet, HDMI, DC 5V",
    tv6RemoteImageAlt:
      "Control remoto IR del inext TV6 con teclado numérico completo, pad de navegación y botones directos de reproducción",
    tv6HardwareRevealLabel: "Mostrar el hardware interno del TV6",
    tv6HardwareRevealImageAlt:
      "Vista superior del inext TV6 con una revelación deslizable del hardware interno",
    tv6UltraHeroImageAlt:
      "inext TV6 Ultra en un mueble de sala con el TV mostrando inext TV, MEGOGO, sweet.tv, IPTV, Plex, VLC y Spotify",
    tv6UltraPortsImageAlt:
      "Puertos traseros del inext TV6 Ultra: microSD, 2× USB, AV, S/PDIF, Ethernet, HDMI, DC 5V",
    tv5PortsImageAlt:
      "Puertos traseros del inext TV5: AV, S/PDIF óptico, Ethernet, HDMI, alimentación DC, 2× USB, microSD",
    tv5RemoteImageAlt:
      "Control remoto del inext TV5 con pad OK, teclas numéricas y botones de acceso directo",
    tv5HardwareRevealLabel: "Mostrar el hardware interno del TV5",
    tv5HardwareRevealImageAlt:
      "Vista superior del inext TV5 con una revelación deslizable del hardware interno",
    tv5SoftwareImageAlt:
      "TV que muestra un launcher IPTV personalizable sobre un Set-Top Box inext TV5",
    tv6UltraRemoteImageAlt:
      "Control remoto por voz Bluetooth de inext con micrófono, botón de encendido de TV programable y botones FAV",
    tv6UltraHardwareRevealLabel: "Mostrar el hardware interno del TV6 Ultra",
    tv6UltraHardwareRevealImageAlt:
      "Vista superior del inext TV6 Ultra con una revelación deslizable del hardware interno",
    tv5UltraSeoTitle: "inext TV5 Ultra — Set-Top Box Android 10 para operadores",
    tv5UltraSeoDescription:
      "inext TV5 Ultra: Allwinner H313, 2GB RAM, 16GB eMMC, reproducción 4K@60, Wi-Fi de doble banda, Android 10 AOSP y Alcatraz™ DMS para despliegues de operadores.",
    tv5SeoTitle: "inext TV5 — Set-Top Box Android 10 esencial para operadores",
    tv5SeoDescription:
      "inext TV5: Allwinner H313, 1GB RAM, 8GB eMMC, reproducción 4K@60, Wi-Fi de doble banda, Android 10 AOSP y Alcatraz™ DMS para despliegues de IPTV y OTT rentables.",
    tv5UltraHeroEyebrow: "Estándar · STB Android 10",
    tv5UltraHeroHeadline:
      "Un Set-Top Box Android TV probado para despliegues estables de operadores.",
    tv5UltraHeroSub:
      "TV5 Ultra combina la confiable plataforma Allwinner H313 con 2 GB RAM, 16 GB de almacenamiento, conectividad práctica y compatibilidad con inext Alcatraz™ DMS.",
    tv5UltraHeroImageAlt:
      "inext TV5 Ultra en un mueble multimedia debajo de una TV que ejecuta el launcher de inext",
    tv5UltraHardwareRevealLabel: "Mostrar el hardware interno del TV5 Ultra",
    tv5UltraHardwareRevealImageAlt:
      "Vista superior del inext TV5 Ultra con una revelación deslizable del hardware interno",
    tv5UltraSoftwareImageAlt:
      "TV que muestra un launcher de operador personalizable sobre un Set-Top Box inext TV5 Ultra",
    tv5UltraCompareLabel: "Comparar todos los modelos",
    tv5UltraGlanceValue1: "4K @ 60 Hz",
    tv5UltraGlanceLabel1: "Reproducción H.265",
    tv5UltraGlanceValue2: "Android 10",
    tv5UltraGlanceLabel2: "AOSP, listo para apps",
    tv5UltraGlanceValue3: "2 GB / 16 GB",
    tv5UltraGlanceLabel3: "DDR3 + eMMC",
    tv5UltraGlanceValue4: "Control IR",
    tv5UltraGlanceLabel4: "Control simple",
    tv5UltraIntroPara1:
      "TV5 Ultra está diseñado para operadores que necesitan un Set-Top Box Android 10 estable con memoria suficiente para los flujos cotidianos de IPTV, OTT y launcher.",
    tv5UltraIntroPara2:
      "Mantiene el despliegue práctico: hardware probado, control IR familiar, amplia compatibilidad multimedia y gestión remota a través de Alcatraz™ DMS.",
    tv5UltraPerformanceTitle: "4K probado, con margen de sobra.",
    tv5UltraPerformanceBody:
      "El Allwinner H313 con Mali-G31 MP2 le da al TV5 Ultra una reproducción confiable 4K@60 H.265 para flujos de IPTV, OTT y launcher, con 2 GB RAM y 16 GB eMMC para despliegues cotidianos de operadores.",
    tv5UltraPerformanceAccent: "Allwinner H313 · 2 GB DDR3 · 16 GB eMMC · 4K@60 H.265",
    tv5UltraConnectivityCaption:
      "HDMI 2.0a · Ethernet 100 Mb · 2× USB 2.0 · microSD · S/PDIF óptico · salida RCA AV · Wi-Fi de doble banda 2.4/5 GHz.",
    tv5UltraPortsImageAlt:
      "Puertos traseros del inext TV5 Ultra — S/PDIF óptico, LAN, HDMI, USB y microSD",
    tv5UltraSoftwareTitle: "Android 10, ajustado para apps de operador.",
    tv5UltraSoftwareBody:
      "Android 10 AOSP les da a los operadores una plataforma de apps familiar, opciones de launcher personalizado y flujos de trabajo de flota remota a través de Alcatraz™ DMS y TR-069.",
    tv5UltraRemoteFeature1: "Teclado numérico completo para servicios IPTV basados en canales",
    tv5UltraRemoteFeature2: "Controles de navegación y reproducción dedicados",
    tv5UltraRemoteFeature3: "Control IR para una configuración simple del suscriptor",
    tv5UltraAlcatrazBody:
      "TV5 Ultra puede aprovisionarse, monitorearse y actualizarse mediante los mismos flujos de gestión de dispositivos Alcatraz usados en toda la línea de inext.",
    tv5UltraCtaTitle: "Ordene el TV5 Ultra para su red",
    tv5UltraCtaBody:
      "Una opción práctica de STB Android 10 con 2 GB RAM, 16 GB de almacenamiento, empaque de marca y aprovisionamiento Alcatraz™.",
    tv5HeroEyebrow: "Esencial · STB Android 10",
    tv5HeroHeadline: "Android TV rentable para despliegues IPTV esenciales.",
    tv5HeroSub:
      "TV5 mantiene accesible el stack de operador de inext con Android 10, reproducción 4K del H313, 1 GB RAM, 8 GB de almacenamiento y compatibilidad con Alcatraz™ DMS.",
    tv5CompareLabel: "Comparar todos los modelos",
    tv5GlanceValue1: "4K @ 60 Hz",
    tv5GlanceLabel1: "Reproducción H.265",
    tv5GlanceValue2: "Android 10",
    tv5GlanceLabel2: "AOSP, listo para apps",
    tv5GlanceValue3: "1 GB / 8 GB",
    tv5GlanceLabel3: "DDR3 + eMMC",
    tv5GlanceValue4: "Control IR",
    tv5GlanceLabel4: "Control simple",
    tv5IntroPara1:
      "TV5 es el punto de entrada a la línea de operador de inext: hardware compacto, Android 10 AOSP y la conectividad esencial que necesitan los servicios gestionados de IPTV y OTT.",
    tv5IntroPara2:
      "Está diseñado para despliegues donde el bajo costo del dispositivo, la reproducción predecible y el control de flota importan más que nada.",
    tv5PerformanceTitle: "4K confiable con un presupuesto ajustado.",
    tv5PerformanceBody:
      "El Allwinner H313 con Mali-G31 MP2 le da al TV5 una reproducción confiable 4K@60 H.265 para servicios esenciales de IPTV y OTT, con 1 GB RAM y 8 GB eMMC para despliegues de operadores sensibles al costo.",
    tv5PerformanceAccent: "Allwinner H313 · 1 GB DDR3 · 8 GB eMMC · 4K@60 H.265",
    tv5ConnectivityCaption:
      "HDMI 2.0a · Ethernet 100 Mb · 2× USB 2.0 · microSD · S/PDIF óptico · salida RCA AV · Wi-Fi de doble banda 2.4/5 GHz.",
    tv5SoftwareTitle: "Android 10 para la entrega de servicios esenciales.",
    tv5SoftwareBody:
      "TV5 admite launchers de operador, apps de IPTV y OTT, localización y control remoto de flota a través de Alcatraz™ DMS y TR-069.",
    tv5RemoteFeature1: "Teclado numérico para navegación basada en canales",
    tv5RemoteFeature2: "Controles de reproducción y menú dedicados",
    tv5RemoteFeature3: "Configuración IR simple para los hogares de los suscriptores",
    tv5AlcatrazBody:
      "TV5 puede aprovisionarse, monitorearse y actualizarse a través de Alcatraz™ DMS, manteniendo manejables a gran escala los despliegues de bajo costo.",
    tv5CtaTitle: "Ordene el TV5 para su red",
    tv5CtaBody:
      "Un paquete rentable de STB Android con empaque de marca y aprovisionamiento Alcatraz™ para despliegues esenciales de IPTV y OTT.",
    tv6SeoTitle: "inext TV6 — Set-Top Box 4K Android 12 para operadores",
    tv6SeoDescription:
      "inext TV6: Allwinner H618, 2GB RAM, 16GB eMMC, 4K@60 HDR, Wi-Fi de doble banda, Android 12 AOSP y Alcatraz™ DMS. Un STB compacto para ISP, hoteles y operadores OTT.",
    tv6UltraSeoTitle: "inext TV6 Ultra — Set-Top Box 4K Android 12 para operadores",
    tv6UltraSeoDescription:
      "inext TV6 Ultra: Allwinner H618, 4GB RAM, 32GB eMMC, 4K@60 HDR, Wi-Fi de doble banda, BT 5.0, Android 12 AOSP y Alcatraz™ DMS. Diseñado para ISP, hoteles y operadores OTT.",
    tv6UltraBreadcrumbHome: "Inicio",
    tv6UltraBreadcrumbProducts: "Productos",
    tv6UltraContactSales: "Contactar a ventas",
    tv6UltraFindDistributor: "Encontrar un distribuidor",
    tv6UltraAlcatrazTitle: "Gestionado por Alcatraz™ DMS",
    tv6UltraAlcatrazBody:
      "Cada TV6 Ultra sale listo para el sistema de gestión de dispositivos Alcatraz de inext, usado hoy por más de 120 redes de operadores en todo el mundo.",
    tv6UltraAlcatrazCta: "Ver operaciones",
    tv6UltraCtaTitle: "Ordene el TV6 Ultra para su red",
    tv6UltraCtaBody:
      "Precios por volumen, empaque de marca blanca y aprovisionamiento Alcatraz™, todo de un solo equipo.",
    tv6UltraSpecChipset: "Chipset",
    tv6UltraSpecCpu: "CPU",
    tv6UltraSpecGpu: "GPU",
    tv6UltraSpecRam: "RAM",
    tv6UltraSpecStorage: "Almacenamiento",
    tv6UltraSpecDimensions: "Dimensiones",
    tv6UltraSpecPower: "Fuente de alimentación",
    tv6UltraSpecHdmi: "HDMI",
    tv6UltraSpecEthernet: "Ethernet",
    tv6UltraSpecWifi: "Wi-Fi",
    tv6UltraSpecBluetooth: "Bluetooth",
    tv6UltraSpecUsb: "USB",
    tv6UltraSpecCardReader: "Lector de tarjetas",
    tv6UltraSpecAudioOut: "Salida de audio",
    tv6UltraSpecAudioFormats: "Formatos de audio",
    tv6UltraSpecVideoFormats: "Formatos de video",
    tv6UltraSpecVideoCodecs: "Códecs de video",
    tv6UltraSpecMaxRes: "Resolución máxima",
    tv6UltraSpec3d: "Compatibilidad 3D",
    tv6UltraSpecImageFormats: "Formatos de imagen",
    tv6UltraSpecOs: "Sistema operativo",
    tv6UltraSpecDms: "Gestión de dispositivos",
    tv6UltraSpecTr069: "TR-069",
    tv6UltraSpecFilesystems: "Sistemas de archivos",
    tv6UltraSpecLanguages: "Idiomas",
    tv6UltraSpecInternet: "Funciones de internet",
    tv6UltraSpecTr069Yes: "Compatible",
    tv6UltraSpecLanguagesValue: "Multiidioma",
    productSpecCpuArmv8Quad: "ARM v8 Cortex-A53 de cuatro núcleos",
    productSpecCpuQuadCoreArm: "ARM Cortex-A53 de cuatro núcleos",
    productSpecHdmiCableIncluded: "HDMI 2.0a (cable incluido)",
    productSpecEthernet100: "RJ45 Fast Ethernet (100 Mbps)",
    productSpecWifiDualBandN: "Doble banda 2,4 / 5 GHz · 802.11 b/g/n",
    productSpecWifiDualBandAc: "Doble banda 2,4 / 5 GHz · 802.11 b/g/n/ac",
    productSpecUsbHost: "2 × USB 2.0 Host",
    productSpecAudioSpdifRcaTrs: "S/PDIF óptico · RCA mediante TRS de 3,5 mm",
    productSpecAudioSpdif: "S/PDIF óptico",
    productSpecAudioSpdifRca: "S/PDIF óptico · RCA (TRS de 3,5 mm)",
    productSpecInternetFeatures:
      "IPTV · OTT · VOD · HLS · radio por internet · HTML5 · WebKit · apps de Android",
    tv6UltraSpec3dValue: "Side-by-side · Frame-packed",
    tv6UltraSpecMaxResValue: "4K UHD (2160p) @ 60 fps",
    tv6PackageRemote: "Control remoto IR",
    tv6UltraPackageRemote: "Control remoto Bluetooth",
    tv6UltraPackagePower: "Adaptador de corriente (5V / 2A)",
    tv6UltraPackageHdmi: "Cable HDMI",
    tv6UltraPackageGuide: "Guía de inicio rápido",
    tv6UltraPackageBatteries: "Pilas",
    packageNote:
      "El contenido del paquete puede variar según el mercado, el envío y la configuración del operador.",
    tv6HeroEyebrow: "Esencial · STB 4K Android 12",
    tv6HeroHeadline: "Potencia compacta para IPTV y OTT del día a día.",
    tv6HeroSub:
      "Un Set-Top Box Android 12 práctico para despliegues de operadores que necesitan reproducción 4K confiable, conectividad probada y control Alcatraz™ DMS sin la carga de memoria de un modelo insignia.",
    tv6CompareLabel: "Comparar con TV6 Ultra",
    tv6GlanceValue1: "4K @ 60 Hz",
    tv6GlanceLabel1: "HDR · H.265",
    tv6GlanceValue2: "Android 12",
    tv6GlanceLabel2: "AOSP, listo para apps",
    tv6GlanceValue3: "2 GB / 16 GB",
    tv6GlanceLabel3: "DDR3 + eMMC",
    tv6GlanceValue4: "Control IR",
    tv6GlanceLabel4: "Control simple",
    tv6IntroPara1:
      "TV6 lleva el mismo enfoque de inext centrado en el operador a un dispositivo compacto y rentable: compatibilidad con video 4K, Android 12 AOSP, conectividad práctica para el hogar y gestión remota de flota.",
    tv6IntroPara2:
      "Está diseñado para despliegues donde una experiencia predecible del suscriptor, un aprovisionamiento sencillo y el soporte a largo plazo importan más que unas especificaciones sobredimensionadas.",
    tv6PerformanceAccent: "Allwinner H618 · 2 GB DDR3 · 16 GB eMMC · 4K@60 H.265",
    tv6ConnectivityCaption:
      "HDMI 2.0a · Ethernet 100 Mb · 2× USB 2.0 · microSD · S/PDIF óptico · extensor IR dedicado o puerto AV, según la variante del TV6 · Wi-Fi de doble banda 2.4/5 GHz · Bluetooth 5.0.",
    tv6RemoteEyebrow: "Control remoto",
    tv6RemoteTitle: "Control IR simple para el uso diario.",
    tv6RemoteBody:
      "El control remoto IR incluido mantiene familiar la experiencia de la sala: teclado numérico, controles de navegación, botones de reproducción y patrones de acceso directo que se adaptan a los suscriptores de IPTV.",
    tv5RemoteTitle: "Un control remoto familiar, incluido.",
    tv5RemoteBody:
      "TV5 viene con un control remoto IR clásico — teclado numérico, navegación D-pad y teclas de reproducción — para que la primera configuración se sienta instantáneamente familiar.",
    tv5UltraRemoteTitle: "Control remoto IR clásico en cada caja.",
    tv5UltraRemoteBody:
      "TV5 Ultra se envía con el mismo control remoto IR confiable: teclado numérico completo, pad de navegación y botones de reproducción directos, listo para emparejar de fábrica.",
    tv6PerformanceTitle: "4K fluido sin el precio de un modelo insignia.",
    tv6PerformanceBody:
      "El Allwinner H618 quad-core con Mali-G31 MP2 decodifica H.265, VP9 Profile 2 y H.264 por hardware — reproducción 4K confiable para catálogos de IPTV y OTT convencionales.",
    tv6SoftwareTitle: "Android 12 con espacio para crecer.",
    tv6SoftwareBody:
      "Android 12 abierto (AOSP) con Bluetooth, Wi-Fi de doble banda y un launcher listo para operadores — una base flexible para apps de marca, servicios OTT y juegos casuales.",
    tv6RemoteFeature1: "Teclado numérico completo para servicios basados en canales",
    tv6RemoteFeature2: "Controles de navegación y reproducción dedicados",
    tv6RemoteFeature3:
      "Puerto de extensor IR dedicado en las variantes compatibles del TV6; las variantes con puerto AV no admiten el extensor",
    tv6RemoteBtNoteTitle: "Cualquier control que especifique",
    tv6RemoteBtNoteBody:
      "Un módulo Bluetooth integrado le permite ordenar el TV6 con cualquier control remoto de nuestra línea — IR o Bluetooth. En algunas regiones se envía con un control remoto Bluetooth por defecto.",
    tv6RemoteBtNoteLink: "Explorar opciones de control remoto",
    tv5RemoteIrNoteTitle: "Su elección de control remoto IR",
    tv5RemoteIrNoteBody:
      "Se envía con un control remoto IR clásico, pero puede especificarse con cualquier control remoto IR de nuestra línea — incluidos modelos programables que controlan el Set-Top Box y la TV a la vez.",
    tv6IrAvPortLabel: "Puerto de 3.5 mm",
    tv6IrAvPortSpec:
      "Varía según el mercado: extensor IR dedicado o AV; las variantes AV no son compatibles con el extensor IR",
    tv6AlcatrazBody:
      "Cada TV6 puede aprovisionarse, monitorearse y actualizarse a través del sistema de gestión de dispositivos Alcatraz de inext, usado por redes de operadores en todo el mundo.",
    tv6CtaTitle: "Ordene el TV6 para su red",
    tv6CtaBody:
      "Precios por volumen, empaque de marca y aprovisionamiento Alcatraz™ para despliegues prácticos de IPTV y OTT.",
    tv6UltraV2HeroEyebrow: "Insignia · STB 4K Android 12",
    tv6UltraV2HeroHeadline: "Máxima potencia para el máximo contenido.",
    tv6UltraV2HeroSub:
      "Un hub multimedia de nivel operador para la sala — y para el equipo de operaciones detrás de ella.",
    tv6UltraCompareLabel: "Comparar todos los modelos",
    tv6UltraV2IntroPara1:
      "TV6 Ultra es el modelo insignia de la familia inext: el doble de RAM y almacenamiento que el TV6, 4K a 60 FPS acelerado por hardware y el mismo Alcatraz™ DMS que ya impulsa más de 120 redes de operadores en todo el mundo.",
    tv6UltraV2IntroPara2:
      "Diseñado para desaparecer en la sala y permanecer invisible para su equipo de soporte — rápido de aprovisionar, fácil de actualizar, silencioso en el estante.",
    tv6UltraV2PerformanceEyebrow: "Rendimiento",
    tv6UltraV2PerformanceTitle: "4K sin esfuerzo. Todos los códecs.",
    tv6UltraV2PerformanceBody:
      "El Allwinner H618 quad-core con Mali-G31 MP2 decodifica H.265, VP9 Profile 2 y H.264 por hardware, así que los streams 4K, el VOD y las apps se mantienen fluidos incluso bajo carga.",
    tv6UltraV2PerformanceAccent: "Allwinner H618 · 4 GB DDR3 · 32 GB eMMC · 4K@60 H.265",
    tv6UltraV2ConnectivityEyebrow: "Conectividad",
    tv6UltraV2ConnectivityTitle: "Todos los puertos que sus suscriptores necesitan.",
    tv5ConnectivityTitle: "Todos los puertos esenciales, integrados.",
    tv5UltraConnectivityTitle: "Todo el I/O que su instalación necesita.",
    tv6ConnectivityTitle: "Listo para cableado, Wi-Fi y Bluetooth.",
    tv6UltraV2ConnectivityCaption:
      "HDMI 2.0a · Ethernet 100 Mb · 2× USB 2.0 · microSD · S/PDIF óptico · AV · Wi-Fi de doble banda 2.4/5 GHz · Bluetooth 5.0.",
    tv6UltraV2SoftwareEyebrow: "Software",
    tv6UltraV2SoftwareTitle: "Android 12, listo de fábrica.",
    tv6UltraV2SoftwareBody:
      "Android 12 abierto (AOSP) con un launcher listo para operadores, personalización de marca flexible y TR-069 + Alcatraz™ DMS para el equipo de operaciones detrás de cada dispositivo desplegado.",
    tv6UltraV2SoftwareCustomTitle1: "Launcher de operador",
    tv6UltraV2SoftwareCustomBody1:
      "Configure la pantalla de inicio en torno a TV en vivo, VOD, catch-up, radio, apps, ajustes y sus flujos preferidos de suscriptor.",
    tv6UltraV2SoftwareCustomTitle2: "Ajuste de marca y mercado",
    tv6UltraV2SoftwareCustomBody2:
      "Adapte logos, colores, idioma, secciones predeterminadas y servicios precargados para cada operador o despliegue regional.",
    tv6UltraV2SoftwareCustomTitle3: "Control remoto de flota",
    tv6UltraV2SoftwareCustomBody3:
      "Use Alcatraz™ DMS y TR-069 para aprovisionar dispositivos, enviar actualizaciones, gestionar ajustes y mantener el trabajo de soporte fuera de la pantalla del suscriptor.",
    tv6UltraV2SpecsTitle: "Especificaciones completas",
    tv6UltraV2SpecsGroupHardware: "Hardware",
    tv6UltraV2SpecsGroupConnectivity: "Conectividad",
    tv6UltraV2SpecsGroupMedia: "Multimedia",
    tv6UltraV2SpecsGroupSoftware: "Software",
    tv6UltraV2SpecsGroupPackage: "En la caja",
    tv6UltraV2RemoteEyebrow: "Control remoto",
    tv6UltraV2RemoteTitle: "Control remoto por voz Bluetooth, hecho para la sala.",
    tv6UltraV2RemoteBody:
      "Empareje una vez por Bluetooth y olvídese de la línea de visión. Un micrófono integrado habilita la búsqueda por voz en el launcher y las apps, mientras que el botón de encendido de TV programable y la tecla de favoritos personalizable permiten que cada suscriptor lo haga suyo.",
    tv6UltraV2RemoteFeatureBt: "Bluetooth 5.0 — sin necesidad de apuntar con IR",
    tv6UltraV2RemoteFeatureMic: "Micrófono integrado para búsqueda por voz",
    tv6UltraV2RemoteFeatureTvPower: "Botón de encendido de TV programable",
    tv6UltraV2RemoteFeatureFav: "Botón de favoritos (FAV) personalizable",
    tv6UltraV2RemoteNoteBody:
      "TV6 Ultra se envía con el control remoto por voz Bluetooth por defecto — pero puede especificarlo con cualquier control remoto de nuestra línea, Bluetooth o IR, según su mercado.",
    tv6UltraV2GlanceValue1: "4K @ 60 Hz",
    tv6UltraV2GlanceLabel1: "HDR · H.265",
    tv6UltraV2GlanceValue2: "Android 12",
    tv6UltraV2GlanceLabel2: "AOSP, listo para apps",
    tv6UltraV2GlanceValue3: "4 GB / 32 GB",
    tv6UltraV2GlanceLabel3: "DDR3 + eMMC",
    tv6UltraV2GlanceValue4: "Control BT 5.0",
    tv6UltraV2GlanceLabel4: "Voz + FAV",
    remoteAppMenuLabel: "App inext Remote",
    remoteAppProductCallout: "¿Prefiere su teléfono? Descargue la app gratuita inext Remote",
    footerLinkRemoteApp: "App de control remoto",
    remoteAppSeoTitle: "inext Remote — App móvil de control remoto para STB de inext",
    remoteAppSeoDescription:
      "Descargue la app gratuita inext Remote para Android e iOS. Controle los STB de inext, cambie de habitación, busque por voz o teclado, ingrese texto, use el modo gamepad y elija tema claro u oscuro.",
    remoteAppBreadcrumbApps: "Apps",
    remoteAppHeroEyebrow: "App gratuita para su box de TV inext",
    remoteAppHeroTitle: "Su control remoto de TV, ahora en su teléfono.",
    remoteAppHeroBody:
      "inext Remote convierte su teléfono en un control remoto completo para su box de TV inext — escriba rápido, busque por voz, salte entre habitaciones, juegue, deslice para navegar y elija un aspecto claro u oscuro.",
    remoteAppAppleBadgeAlt: "Descargar inext Remote en la App Store",
    remoteAppGoogleBadgeAlt: "Obtenga inext Remote en Google Play",
    remoteAppHeroImageAlt: "Pantalla de control de la app móvil inext Remote",
    remoteAppStatDownloadsValue: "500K+",
    remoteAppStatDownloadsLabel: "descargas",
    remoteAppStatModesValue: "D-pad + deslizar",
    remoteAppStatModesLabel: "modos de control",
    remoteAppStatThemesValue: "Claro + oscuro",
    remoteAppStatThemesLabel: "temas",
    remoteAppFeaturesEyebrow: "Por qué le encantará",
    remoteAppFeaturesTitle: "Todo lo que quiere de un control remoto moderno.",
    remoteAppFeaturesBody:
      "Sus controles de TV cotidianos se mantienen cerca, además de lo que un control remoto de plástico no puede hacer: escritura fácil, búsqueda rápida, múltiples habitaciones y juegos casuales.",
    remoteAppFeatureControlTitle: "Un control remoto que simplemente funciona",
    remoteAppFeatureControlBody:
      "Navegue, reproduzca, pause y ajuste el volumen con todos los controles de TV que ya conoce — directo desde su teléfono.",
    remoteAppFeatureRoomsTitle: "Cambie de dispositivos y habitaciones",
    remoteAppFeatureRoomsBody:
      "Salte entre sus dispositivos inext en segundos cuando tiene más de una pantalla en casa.",
    remoteAppFeatureVoiceTitle: "Voz y búsqueda rápida",
    remoteAppFeatureVoiceBody:
      "Use la búsqueda por voz o el teclado del teléfono para encontrar contenido más rápido que con un control remoto físico.",
    remoteAppFeatureKeyboardTitle: "Ingreso de texto fácil",
    remoteAppFeatureKeyboardBody:
      "Ingrese inicios de sesión, consultas de búsqueda y texto de apps en el teclado del teléfono en lugar de hacer clic letra por letra.",
    remoteAppFeatureGamepadTitle: "Modo gamepad",
    remoteAppFeatureGamepadBody:
      "Convierta el teléfono en un control de juego simple para juegos y experiencias interactivas de TV.",
    remoteAppFeatureModesTitle: "D-pad o gestos",
    remoteAppFeatureModesBody:
      "Use los botones direccionales clásicos o cambie al control por deslizamiento y gestos cuando eso se sienta más rápido.",
    remoteAppModesEyebrow: "Modos de control",
    remoteAppModesTitle: "Un control remoto, teclado y gamepad en una sola app.",
    remoteAppModesBody:
      "Mantenga el diseño D-pad familiar para la TV, cambie a gestos para una navegación más rápida, abra el teclado para buscar o gire su teléfono al modo gamepad.",
    remoteAppModeDpad: "D-pad clásico",
    remoteAppModeSwipe: "Modo de deslizamiento y gestos",
    remoteAppGamepadImageAlt: "Captura de pantalla del modo gamepad de inext Remote",
    remoteAppVideoEyebrow: "Mírelo en acción",
    remoteAppVideoTitle: "Mire inext Remote en acción.",
    remoteAppVideoBody:
      "Un recorrido rápido por todo lo que la app puede hacer: control remoto, teclado, voz, habitaciones, gamepad y temas.",
    remoteAppVideoIframeTitle: "Video demostrativo de la app inext Remote",
    remoteAppScreensEyebrow: "Capturas de pantalla",
    remoteAppScreensTitle: "Hecha para su forma de ver.",
    remoteAppScreensBody:
      "Explore las pantallas del control remoto principal, dispositivos, teclado numérico, teclado, gamepad y temas de la app móvil.",
    remoteAppScreenshotAlt: "Captura de pantalla de la app inext Remote",
    remoteAppThemesEyebrow: "Apariencia",
    remoteAppThemesTitle: "Cómoda en habitaciones claras u oscuras.",
    remoteAppThemesBody:
      "Los temas claro y oscuro se ven geniales: perfectos para el día, para ver de noche o para combinar con su teléfono.",
    remoteAppLightTheme: "Tema claro",
    remoteAppLightThemeBody: "Controles limpios para uso diurno y habitaciones bien iluminadas.",
    remoteAppDarkTheme: "Tema oscuro",
    remoteAppDarkThemeBody: "Menos reflejos para ver de noche.",
    remoteAppCtaEyebrow: "Descargue gratis",
    remoteAppCtaTitle: "Obtenga inext Remote para su teléfono.",
    remoteAppCtaBody:
      "Descargue la app gratuita desde Google Play o la App Store y emparéjela con su inext TV box en segundos.",
    navSolutions: "Soluciones",
    navSolutionsAlcatraz: "Alcatraz DMS",
    navSolutionsAlcatrazDesc: "Monitoreo proactivo de la flota y operaciones remotas",
    footerLinkAlcatrazDms: "Alcatraz DMS",
    operationsLearnMore: "Más información sobre Alcatraz DMS",
    alcatrazBreadcrumbHome: "Inicio",
    alcatrazBreadcrumbSolutions: "Soluciones",
    alcatrazBreadcrumbPage: "Alcatraz DMS",
    alcatrazSeoTitle: "inext Alcatraz DMS — Gestión de dispositivos para operadores de IPTV",
    alcatrazSeoDescription:
      "Gestión de STBs inext en la nube u on-premises, con Fleet Health, historial de actividad, diagnósticos remotos y actualizaciones OTA controladas.",
    alcatrazTrialSeoTitle: "Prueba gratuita de Alcatraz Pro durante 3 meses | inext",
    alcatrazTrialSeoDescription:
      "Solicite tres meses gratis de Alcatraz Pro, con los decodificadores inext de su red o con una unidad demo que le enviamos.",
    alcatrazTrialBreadcrumb: "Prueba gratuita de 3 meses",
    alcatrazTrialEyebrow: "Para ISPs y operadores de TV",
    alcatrazTrialTitle: "Pruebe Alcatraz Pro gratis durante 3 meses",
    alcatrazTrialIntro:
      "Descubra lo que Alcatraz Pro puede hacer con los decodificadores inext: los que ya están en su red o una unidad demo que le enviamos. Nuestro equipo le ayudará a empezar, sin tarjeta de pago ni compromiso a largo plazo.",
    alcatrazTrialBenefitFree: "Acceso completo a Alcatraz Pro durante tres meses",
    alcatrazTrialBenefitExisting:
      "Utilice sus STBs inext actuales o reciba de nosotros una unidad demo",
    alcatrazTrialBenefitGuided: "Soporte del equipo de inext durante la configuración",
    alcatrazTrialStepsTitle: "Cómo funciona",
    alcatrazTrialStep1: "Envíe la solicitud",
    alcatrazTrialStep2: "Confirmamos los datos de la empresa",
    alcatrazTrialStep3: "Configuramos el acceso y le ayudamos a comenzar",
    alcatrazTrialFeaturesLink: "Explore las funciones y opciones de implementación",
    alcatrazTrialDashboardAlt: "Panel de gestión de flota de Alcatraz Pro",
    alcatrazTrialFormTitle: "Comience su prueba gratuita de 3 meses",
    alcatrazTrialFormIntro:
      "Indique sus datos de contacto. Confirmaremos la elegibilidad de la empresa y le ayudaremos a comenzar.",
    alcatrazTrialDemoOption: "Quiero una demostración antes de la prueba",
    alcatrazTrialSampleOption: "Aún no tengo STBs inext; quiero recibir una unidad demo",
    alcatrazRequestNamePlaceholder: "Ana García",
    alcatrazRequestCompanyPlaceholder: "Acme Telecom",
    alcatrazRequestEmailPlaceholder: "ana@acme.com",
    alcatrazRequestPhonePlaceholder: "+52 55 1234 5678",
    alcatrazRequestNameError: "Indique su nombre.",
    alcatrazRequestCompanyError: "Indique el nombre de la empresa.",
    alcatrazRequestEmailError: "Indique un correo electrónico corporativo válido.",
    alcatrazRequestPhoneError: "Indique un número de teléfono.",
    alcatrazTrialEligibility:
      "Para clientes empresariales: ISPs y operadores de TV. ¿Aún no tiene STBs inext? Prepararemos una unidad demo para usted. El acceso de prueba está sujeto a una breve verificación de los datos de la empresa.",
    alcatrazTrialNoCardNote: "Sin tarjeta de pago ni compromiso a largo plazo.",
    alcatrazTrialSubmitting: "Enviando...",
    alcatrazTrialSubmitTrial: "Solicitar 3 meses gratis",
    alcatrazTrialSubmitDemo: "Solicitar demostración y 3 meses gratis",
    alcatrazTrialSuccessTitle: "Recibimos su solicitud de prueba",
    alcatrazTrialSuccessBody:
      "Gracias. Confirmaremos los datos de la empresa y nos comunicaremos para configurar su prueba gratuita de tres meses de Alcatraz Pro.",
    alcatrazTrialDemoSuccessBody:
      "Gracias. Confirmaremos los datos de la empresa y nos comunicaremos para programar una demostración antes de configurar su prueba gratuita de tres meses.",
    alcatrazTrialSampleSuccessNote: "También prepararemos y le enviaremos una unidad demo.",
    alcatrazTrialSuccessTimeline: "Normalmente respondemos en un día hábil.",
    alcatrazStartSeoTitle: "Alcatraz Pro para flotas con menos de 500 dispositivos activos | inext",
    alcatrazStartSeoDescription:
      "Alcatraz Pro está incluido sin costo adicional para flotas inext con menos de 500 dispositivos activos. Solicite acceso y una unidad de evaluación si la flota aún no usa STBs inext.",
    alcatrazStartBreadcrumb: "Obtener Alcatraz Pro",
    alcatrazStartEyebrow: "Para ISPs y operadores de TV",
    alcatrazStartTitle: "Alcatraz Pro se incluye con sus decodificadores inext",
    alcatrazStartIntro:
      "Gestione toda la flota desde una sola consola: monitoreo, firmware, diagnósticos y soporte remoto. Alcatraz Pro está incluido sin costo adicional mientras la flota tenga menos de 500 dispositivos inext activos.",
    alcatrazStartBenefit1:
      "Incluido sin costo adicional para flotas con menos de 500 dispositivos activos",
    alcatrazStartBenefit2: "La consola completa de Alcatraz Pro, no una versión limitada",
    alcatrazStartBenefit3: "Soporte del equipo de inext durante la configuración",
    alcatrazStartActiveTitle: "Qué cuenta como dispositivo activo",
    alcatrazStartActiveBody:
      "El acceso se define a partir del recuento más reciente de dispositivos activos de los últimos 30 días. Los equipos aún en producción, en tránsito, almacenados o ya dados de baja no cuentan para el umbral de 500 dispositivos.",
    alcatrazStartStepsTitle: "Cómo funciona",
    alcatrazStartStep1: "Envíe la solicitud",
    alcatrazStartStep2: "Confirmamos los datos de la empresa",
    alcatrazStartStep3: "Creamos su cuenta y le ayudamos a comenzar",
    alcatrazStartFeaturesLink: "Explore las funciones y opciones de implementación",
    alcatrazStartDashboardAlt: "Consola de gestión de flota de Alcatraz Pro",
    alcatrazStartFormTitle: "Obtenga su cuenta de Alcatraz Pro",
    alcatrazStartFormIntro:
      "Indíquenos cómo comunicarnos con usted. Confirmaremos los datos de la empresa y le ayudaremos a comenzar.",
    alcatrazStartDemoOption: "Quiero una demostración antes de comenzar",
    alcatrazStartSampleOption: "Aún no tengo STBs inext; quiero recibir una unidad demo",
    alcatrazStartEligibility:
      "Alcatraz Pro está disponible para clientes empresariales — ISPs y operadores de TV — sin costo adicional para flotas con menos de 500 dispositivos activos. Para flotas con 500 dispositivos activos o más, comuníquese con ventas para analizar el acceso y las condiciones comerciales.",
    alcatrazStartSubmitting: "Enviando...",
    alcatrazStartSubmit: "Obtener Alcatraz Pro",
    alcatrazStartSubmitDemo: "Solicitar demostración + Alcatraz Pro",
    alcatrazStartNoCardNote: "Sin tarjeta de pago ni compromiso a largo plazo.",
    alcatrazStartSuccessTitle: "Recibimos su solicitud",
    alcatrazStartSuccessBody:
      "Gracias. Confirmaremos los datos de la empresa y nos comunicaremos para configurar su cuenta de Alcatraz Pro.",
    alcatrazStartDemoSuccessBody:
      "Gracias. Confirmaremos los datos de la empresa y nos comunicaremos para programar una demostración antes de configurar su cuenta de Alcatraz Pro.",
    alcatrazStartSampleSuccessNote: "También prepararemos y le enviaremos una unidad demo.",
    alcatrazStartSuccessTimeline: "Normalmente respondemos en un día hábil.",
    alcatrazHeroEyebrow: "Sistema de gestión de dispositivos",
    alcatrazHeroTitle: "inext Alcatraz DMS —",
    alcatrazHeroTitleAccent: "su flota, siempre bajo control",
    alcatrazHeroSub:
      "Nube SaaS o totalmente on-premises. Monitoree la salud de la flota, consulte el historial de los dispositivos, distribuya actualizaciones y dé soporte a cada STB inext desde una sola plataforma.",
    alcatrazCtaStart: "Obtener Alcatraz Pro",
    alcatrazHeroCtaDemo: "Solicitar demo",
    alcatrazHeroCtaSales: "Contactar a ventas",
    alcatrazHeroImageCaption: "Alcatraz DMS — panel general de la flota",
    alcatrazHeroStatNetworks: "Más de 120 redes de operadores",
    alcatrazHeroStatDeploy: "Nube u on-premises",
    alcatrazHeroStatScale: "Escala con su flota",
    alcatrazDeploymentEyebrow: "Implementación",
    alcatrazDeploymentTitle: "Dos formas de implementar",
    alcatrazDeploymentDescription:
      "Elija el modelo que se ajuste a la política de su red. Las mismas funciones, la misma consola, la misma suscripción.",
    alcatrazDeploymentCloudTag: "Recomendado",
    alcatrazDeploymentCloudTitle: "Nube (SaaS)",
    alcatrazDeploymentCloudBody:
      "Alojado y operado por inext. El inicio más rápido, actualizaciones automáticas y acceso geodistribuido para su equipo de soporte.",
    alcatrazDeploymentCloudBullet1: "Sin infraestructura que mantener",
    alcatrazDeploymentCloudBullet2: "Actualizaciones automáticas de la plataforma",
    alcatrazDeploymentCloudBullet3: "Disponibilidad respaldada por SLA",
    alcatrazDeploymentOnpremTitle: "On-premises",
    alcatrazDeploymentOnpremBody:
      "Se ejecuta dentro de su red cerrada de ISP. Soberanía total de los datos para operadores con requisitos regulatorios o de seguridad estrictos.",
    alcatrazDeploymentOnpremBullet1: "Implementado en su centro de datos",
    alcatrazDeploymentOnpremBullet2: "Sus datos nunca salen de su red",
    alcatrazDeploymentOnpremBullet3: "Funciona detrás de NAT / redes cerradas",
    alcatrazPillarsEyebrow: "Qué incluye",
    alcatrazPillarsTitle: "Todo lo que necesita para gestionar una flota de STBs",
    alcatrazPillar1Title: "Fleet Health",
    alcatrazPillar1Body:
      "Priorice los problemas de señal Wi-Fi débil y temperatura alta, consulte el historial de los dispositivos y reciba resúmenes semanales.",
    alcatrazPillar2Title: "Firmware OTA por fases",
    alcatrazPillar2Body:
      "Distribuya firmware por fases, supervise los resultados, excluya dispositivos específicos y mantenga los comentarios asociados a cada compilación o versión.",
    alcatrazPillar3Title: "Soporte remoto y diagnóstico",
    alcatrazPillar3Body:
      "Reinicie y controle dispositivos a distancia, ejecute diagnósticos MTR o iPerf3 y resuelva incidencias sin enviar un técnico.",
    alcatrazPillar4Title: "Historial de actividad y auditoría",
    alcatrazPillar4Body:
      "Consulte comandos, cambios, notas privadas y eventos OTA, con identificación del usuario o de la clave de API para auditoría.",
    alcatrazPillar5Title: "Protección de dispositivos",
    alcatrazPillar5Body:
      "Aplique perfiles de bloqueo, App Lock y net-lock para proteger dispositivos alquilados, perdidos o retirados.",
    alcatrazPillar6Title: "Comunicación con suscriptores",
    alcatrazPillar6Body:
      "Envíe banners segmentados en el launcher, notificaciones y campañas con llamadas a la acción en el televisor.",
    alcatrazPillar7Title: "API y estándares del sector",
    alcatrazPillar7Body:
      "Gestione claves de API con restricciones de acceso e integre mediante REST, MQTT o flujos existentes de TR-069/CWMP.",
    alcatrazPillar8Title: "Organización de la flota",
    alcatrazPillar8Body:
      "Use IDs externos y grupos para buscar, filtrar, exportar y ejecutar acciones en lote sobre los dispositivos.",
    alcatrazFleetHealthEyebrow: "Fleet Health",
    alcatrazFleetHealthTitle: "Priorice los dispositivos que necesitan atención",
    alcatrazFleetHealthBody:
      "Fleet Health analiza la telemetría de los dispositivos y organiza los problemas detectados en una vista clara para los equipos de operaciones y soporte. El panel resume el estado de toda la flota, mientras una cola con filtros da acceso directo a cada dispositivo afectado y a su historial de problemas.",
    alcatrazFleetHealthBullet1: "Detectar Wi-Fi débil y condiciones de alta temperatura",
    alcatrazFleetHealthBullet2: "Filtrar y priorizar la cola de problemas de dispositivos",
    alcatrazFleetHealthBullet3: "Revisar detalles e historial de problemas de cada STB",
    alcatrazFleetHealthBullet4: "Recibir resúmenes semanales de la flota",
    alcatrazFleetHealthPlaceholder: "Panel Fleet Health y cola priorizada de problemas",
    alcatrazFleetPreviewUpdated: "Actualizado ahora",
    alcatrazFleetPreviewLive: "Vista en tiempo real",
    alcatrazFleetPreviewNeedsAttention: "Requieren atención",
    alcatrazFleetPreviewCallFirst: "Contactar primero",
    alcatrazFleetPreviewKeepWatch: "En observación",
    alcatrazFleetPreviewHealthy: "Saludables",
    alcatrazFleetPreviewMonitored: "Monitoreados",
    alcatrazFleetPreviewIssueTypes: "Tipos de problema",
    alcatrazFleetPreviewWeakWifi: "Wi-Fi débil",
    alcatrazFleetPreviewTemperature: "Temperatura",
    alcatrazFleetPreviewQueue: "Cola prioritaria de dispositivos",
    alcatrazFleetPreviewCriticalFirst: "Casos críticos primero",
    alcatrazFleetPreviewShown: "{count} mostrados",
    alcatrazFleetPreviewHighTemperature: "Alta temperatura",
    alcatrazFleetPreviewWatch: "Vigilar",
    alcatrazFleetPreviewAwaiting: "{count} problemas pendientes de confirmación",
    alcatrazPreviewMinutesAgo: "hace {minutes} min",
    alcatrazPreviewIllustrativeData: "Datos ilustrativos",
    alcatrazFirmwareEyebrow: "Gestión de firmware",
    alcatrazFirmwareTitle: "Despliegues por fases con controles de seguridad",
    alcatrazFirmwareBody:
      "Programe lanzamientos de firmware para una parte de la flota, exija la confirmación en el dispositivo y consulte las estadísticas del lanzamiento en tiempo real. Excluya cualquier dispositivo de las actualizaciones automáticas con un solo interruptor, o envíe una actualización manual cuando lo necesite.",
    alcatrazFirmwareBullet1: "Despliegue por fases",
    alcatrazFirmwareBullet2: "Excluir de las actualizaciones automáticas por dispositivo",
    alcatrazFirmwareBullet3: "Lanzamiento manual de firmware",
    alcatrazFirmwareBullet4: "Confirmación del cliente + estadísticas de lanzamiento",
    alcatrazFirmwarePlaceholder: "Panel de lanzamiento de firmware",
    alcatrazFirmwareOtaLink: "Explorar la gestión de actualizaciones OTA",
    alcatrazInspectorEyebrow: "Inspector de dispositivos",
    alcatrazInspectorTitle: "Estado actual e historial completo en una misma vista",
    alcatrazInspectorBody:
      "Abra cualquier STB para ver su estado actual y luego siga los eventos que llevaron hasta él. La línea de tiempo de actividad reúne comandos, eventos de activación, cambios del dispositivo, notas privadas, campañas, notificaciones y eventos OTA.",
    alcatrazActivityBullet1: "Vistas predefinidas, filtros y modo de auditoría específico",
    alcatrazActivityBullet2:
      "Identificación del usuario o la clave de API en cada acción registrada",
    alcatrazActivityBullet3: "Métricas OTA detalladas e historial de comandos",
    alcatrazInspectorPreviewOnline: "En línea",
    alcatrazInspectorPreviewCurrentState: "Estado actual",
    alcatrazInspectorPreviewActivity: "Actividad",
    alcatrazInspectorPreviewCondition: "Condición del dispositivo",
    alcatrazInspectorPreviewLastChecked: "Revisado hace {minutes} min",
    alcatrazInspectorPreviewAllEvents: "Todos los eventos",
    alcatrazInspectorPreviewCommands: "Comandos",
    alcatrazInspectorPreviewNewest: "Más recientes primero",
    alcatrazInspectorPreviewToday: "Hoy",
    alcatrazInspectorPreviewYesterday: "Ayer",
    alcatrazInspectorPreviewThisWeek: "Esta semana",
    alcatrazInspectorPreviewLastWeek: "La semana pasada",
    alcatrazInspectorPreviewEarlier: "Eventos anteriores",
    alcatrazInspectorPreviewSupportNote:
      "Nota de soporte: pausas intermitentes durante la reproducción",
    alcatrazInspectorPreviewFirmwareChange: "Firmware 1.8.51 → 1.9.1",
    alcatrazInspectorPreviewOtaCompleted: "Descarga OTA completada",
    alcatrazInspectorPreviewCommandBy: "Comando · Juan Pérez",
    alcatrazInspectorPreviewPrivateNoteBy: "Nota privada · Juan Pérez",
    alcatrazInspectorPreviewDeviceChangeApi: "Cambio del dispositivo · clave de API · rollout-bot",
    alcatrazInspectorPreviewOtaMetrics: "Versión 1.9.0 · 45.78 MB/s · 1 min 18 s",
    alcatrazInspectorPreviewWaiting: "Esperando respuesta",
    alcatrazInspectorPreviewCompleted: "Completado",
    alcatrazInspectorPreviewFooter: "Comandos, cambios, notas y eventos OTA",
    alcatrazInspectorPreviewIllustrative: "Historial de ejemplo",
    alcatrazInspectorPreviewAlt:
      "Demostración del inspector de dispositivos Alcatraz con el estado actual y el historial de actividad.",
    alcatrazInspectorCardTitle: "Vista del dispositivo",
    alcatrazInspectorLabelState: "Estado",
    alcatrazInspectorValueState: "En línea · 4d 1h 19m",
    alcatrazInspectorLabelLastSeen: "Última conexión",
    alcatrazInspectorValueLastSeen: "hace 12 min",
    alcatrazInspectorLabelFirmware: "Firmware",
    alcatrazInspectorValueFirmware: "v1.8.14",
    alcatrazInspectorLabelTemps: "Temperaturas",
    alcatrazInspectorValueTemps: "CPU 51.2° · GPU 52.5° · RAM 50.8° · VEE 53.4°",
    alcatrazInspectorLabelRam: "RAM",
    alcatrazInspectorValueRam: "383 MB libres de 4 GB",
    alcatrazInspectorLabelFlash: "Flash",
    alcatrazInspectorValueFlash: "18.8 GB libres de 32 GB",
    alcatrazInspectorLabelTv: "Conexión de TV",
    alcatrazInspectorValueTv: "HDMI · 1920×1080 · 60 fps",
    alcatrazInspectorLabelNetwork: "Red",
    alcatrazInspectorValueNetwork: "Wi-Fi 5 GHz · RSSI −29 dBm (Excelente)",
    alcatrazInspectorLabelAndroid: "Android",
    alcatrazInspectorValueAndroid: "12",
    alcatrazInspectorLabelLocale: "Configuración regional",
    alcatrazInspectorValueLocale: "Inglés · Europa/Kyiv",
    alcatrazInspectorLabelApps: "Apps instaladas",
    alcatrazInspectorValueApps: "Lista de apps con versiones",
    alcatrazRemoteEyebrow: "Control remoto",
    alcatrazRemoteTitle: "Una consola de comandos para el operador",
    alcatrazRemoteBody:
      "Ejecute cualquiera de las acciones para las que normalmente necesitaría un ingeniero de campo, desde un reinicio hasta un restablecimiento de fábrica completo, sin tocar nunca el dispositivo.",
    alcatrazRemoteGroupControl: "Control",
    alcatrazRemoteGroupDiagnostics: "Diagnóstico",
    alcatrazRemoteGroupComms: "Comunicación",
    alcatrazRemoteGroupLifecycle: "Ciclo de vida",
    alcatrazRemoteGroupLockdown: "Bloqueo",
    alcatrazRemoteCmdReboot: "Reiniciar",
    alcatrazRemoteCmdRemote: "Control remoto virtual",
    alcatrazRemoteCmdScreenshot: "Captura de pantalla",
    alcatrazRemoteCmdSpeed: "Prueba de velocidad (iPerf3)",
    mtrAlcatrazRemoteCmd: "Rastreo de ruta MTR",
    alcatrazRemoteCmdPush: "Notificación push",
    alcatrazRemoteCmdFirmware: "Lanzamiento de firmware",
    alcatrazRemoteCmdExclude: "Excluir de las actualizaciones automáticas",
    alcatrazRemoteCmdBlock: "Bloquear dispositivo",
    alcatrazRemoteCmdFactory: "Restablecimiento de fábrica",
    alcatrazRemoteWarning: "Acción destructiva",
    alcatrazRemoteHighlight1:
      "Resuelva problemas comunes desde el NOC, sin enviar un ingeniero de campo.",
    alcatrazRemoteHighlight2:
      "Ejecute el comando en un solo dispositivo o en todo un grupo con un clic.",
    alcatrazRemoteHighlight3:
      "Cada acción registra el dispositivo, la fecha y hora, y el usuario o la clave de API que la inició.",
    mtrAlcatrazEyebrow: "Diagnóstico MTR",
    mtrAlcatrazTitle: "Rastree la ruta desde el STB del suscriptor",
    mtrAlcatrazBody:
      "Los operadores pueden ejecutar MTR (My Traceroute) desde un STB en línea hacia cualquier destino. Los resultados de MTR e iPerf3 permanecen disponibles en el historial de actividad del dispositivo, y las pruebas pueden ejecutarse de nuevo con sus parámetros originales.",
    alcatrazAccessEyebrow: "Protección de dispositivos",
    alcatrazAccessTitle: "Proteja los STBs con políticas de bloqueo y net-lock",
    alcatrazAccessBody:
      "Alcatraz DMS ayuda a los operadores a proteger STBs en alquiler, hardware perdido, cuentas impagas y dispositivos retirados. Bloquee cualquier STB o grupo manualmente, o use net-lock para restringir los dispositivos alquilados fuera de las redes de ISP aprobadas.",
    alcatrazAccessFlowTitle: "Cómo comienza el bloqueo",
    alcatrazAccessManualTitle: "Bloqueo manual",
    alcatrazAccessManualBody:
      "Bloquee un STB o todo un grupo cuando sea necesario. Úselo para equipos perdidos, robados o retirados y para cuentas con pagos atrasados.",
    alcatrazAccessNetLockTitle: "Net-lock automático",
    alcatrazAccessNetLockBody:
      "Bloquee automáticamente los STBs alquilados fuera de las redes aprobadas del operador. Esto evita que se utilicen mediante conexiones no autorizadas.",
    alcatrazAccessFlowOutcome: "Elija un perfil de bloqueo",
    alcatrazAccessMockFooter: "Gestionado por Alcatraz DMS",
    alcatrazAccessMockNotice: "Período de aviso",
    alcatrazAccessProfileHardTitle: "Estricto",
    alcatrazAccessProfileHardBody: "Apaga el STB y repite el bloqueo tras el reinicio.",
    alcatrazAccessModeHardBadge: "Bloqueo estricto",
    alcatrazAccessModeHardTitle: "Este dispositivo está bloqueado",
    alcatrazAccessModeHardBody:
      "El STB muestra el mensaje del operador y luego se apaga. El bloqueo se repite tras el reinicio.",
    alcatrazAccessModeHardStatus: "Se apaga tras el aviso",
    alcatrazAccessProfileSoftTitle: "Suave",
    alcatrazAccessProfileSoftBody:
      "Mantiene el STB utilizable y muestra recordatorios cada 30 minutos.",
    alcatrazAccessModeSoftBadge: "Bloqueo suave",
    alcatrazAccessModeSoftTitle: "Aviso de servicio activo",
    alcatrazAccessModeSoftBody:
      "El STB sigue utilizable mientras el recordatorio del operador aparece según lo programado.",
    alcatrazAccessModeSoftStatus: "Recordatorio cada 30 minutos",
    alcatrazAccessProfileAppLockTitle: "Bloqueo de app",
    alcatrazAccessProfileAppLockBody: "Limita el STB a una sola aplicación seleccionada.",
    alcatrazAccessModeAppLockBadge: "Bloqueo de app",
    alcatrazAccessModeAppLockTitle: "Solo la app aprobada está disponible",
    alcatrazAccessModeAppLockBody:
      "El STB solo puede abrir la aplicación seleccionada hasta que el operador cambie el perfil.",
    alcatrazAccessModeAppLockStatus: "Solo una app",
    alcatrazAccessModeAppAllowedApp: "IPTV",
    alcatrazAccessModeAppLockedLabel: "Bloqueado",
    alcatrazPushEyebrow: "Notificaciones push",
    alcatrazPushTitle: "Comuníquese con los suscriptores a través del televisor",
    alcatrazPushBody:
      "Envíe banners de launcher y mensajes toast a cualquier segmento de su flota: para mensajes de servicio, destacados de contenido o campañas de actualización. Cada mensaje puede llevar un CTA que abre una app o página.",
    alcatrazPushBullet1: "Estilos launcher y toast",
    alcatrazPushBullet2: "Segmente por grupo de dispositivos, modelo o región",
    alcatrazPushBullet3: "CTAs con enlace directo a una app",
    alcatrazPushBullet4: "Vistas, clics y CTR de cada mensaje",
    alcatrazPushPlaceholder: "Editor de notificaciones push",
    alcatrazApiEyebrow: "Integraciones seguras · API REST",
    alcatrazApiTitle: "Conecte Alcatraz con sus sistemas existentes",
    alcatrazApiBody:
      "Cree y revoque claves de API desde la consola, restrinja los permisos y las direcciones IP permitidas cuando sea necesario, establezca fechas de vencimiento y copie de forma segura el secreto de cada clave en el momento de crearla. Los IDs externos conectan los registros de dispositivos de Alcatraz con referencias de suscriptor, CRM, facturación u hogar sin cambiar los flujos existentes.",
    alcatrazApiBullet1: "Claves de API de autoservicio con restricciones de acceso configurables",
    alcatrazApiBullet2: "IDs externos de dispositivos para búsqueda, filtros y exportación",
    alcatrazApiBullet3: "TR-069 / CWMP y MQTT junto con la API REST",
    alcatrazApiPlaceholder: "Documentación de la API",
    alcatrazPricingEyebrow: "Precios",
    alcatrazPricingTitle:
      "Incluido sin costo adicional para flotas con menos de 500 dispositivos activos",
    alcatrazPricingBody:
      "Los socios reciben acceso a la consola completa de Alcatraz Pro sin costo adicional mientras la flota tenga menos de 500 dispositivos inext activos. Para flotas con 500 dispositivos activos o más, el acceso y las condiciones comerciales se acuerdan directamente con inext.",
    alcatrazPricingIncludedTitle: "Sin costo adicional · Menos de 500 dispositivos activos",
    alcatrazPricingIncludedBody:
      "Fleet Health, gestión de firmware, diagnósticos, soporte remoto e integraciones seguras están incluidos sin costo adicional cuando el recuento más reciente de dispositivos activos de los últimos 30 días muestra menos de 500 dispositivos activos.",
    alcatrazPricingModelTitle: "500 dispositivos activos o más",
    alcatrazPricingModelBody:
      "Comuníquese con el equipo de ventas de inext para analizar el acceso y las condiciones comerciales de la implementación.",
    alcatrazPricingActiveTitle: "Qué cuenta como dispositivo activo",
    alcatrazPricingActiveBody:
      "El acceso se define a partir del recuento más reciente de dispositivos activos de los últimos 30 días. Los dispositivos en estos estados no cuentan para el umbral:",
    alcatrazPricingStateProduction: "En producción",
    alcatrazPricingStateTransit: "En tránsito",
    alcatrazPricingStateWarehouse: "En almacén",
    alcatrazPricingStateRetired: "Dados de baja",
    alcatrazPricingCta: "Solicitar cotización",
    alcatrazFaqEyebrow: "FAQ",
    alcatrazFaqTitle: "Preguntas frecuentes",
    alcatrazFaqQ1: "¿Puedo implementar Alcatraz dentro de mi propia red?",
    alcatrazFaqA1:
      "Sí. Alcatraz DMS funciona como un SaaS gestionado o como una instalación on-premises dentro de su red cerrada de ISP. Las mismas funciones, la misma consola: usted elige dónde residen los datos.",
    alcatrazFaqQ2: "¿Qué dispositivos admite?",
    alcatrazFaqA2:
      "Todos los STBs actuales de inext incluyen soporte para Alcatraz DMS: TV5, TV5 Ultra, TV6 y TV6 Ultra. Se agregan nuevos modelos a medida que se lanzan.",
    alcatrazFaqQ3: "¿Cómo se relaciona Alcatraz con TR-069?",
    alcatrazFaqA3:
      "Alcatraz es compatible con TR-069 / CWMP, por lo que los operadores que ya usan un ACS pueden seguir utilizándolo. Además, Alcatraz ofrece telemetría más detallada, notificaciones push, control remoto desde la app y una API REST moderna.",
    alcatrazFaqQ4: "¿Podemos integrarlo con nuestro BSS / OSS?",
    alcatrazFaqA4:
      "Sí. Alcatraz expone una API REST documentada y admite MQTT. Los administradores pueden crear y revocar claves de API, definir permisos, limitar direcciones IP de origen y establecer fechas de vencimiento. Los IDs externos conectan dispositivos con registros existentes de CRM o facturación.",
    alcatrazFaqQ5: "¿Cómo se cotiza?",
    alcatrazFaqA5:
      "Alcatraz Pro está incluido sin costo adicional mientras la flota tenga menos de 500 dispositivos inext activos. Para flotas con 500 dispositivos activos o más, el acceso y las condiciones comerciales se acuerdan directamente con el equipo de ventas de inext.",
    alcatrazFaqQ6: "¿Qué cuenta como dispositivo activo?",
    alcatrazFaqA6:
      "La sección Configuración de la empresa muestra el recuento más reciente de dispositivos activos de los últimos 30 días que se utiliza para definir el acceso. Los equipos aún en producción, en tránsito, almacenados o ya dados de baja no cuentan para el umbral.",
    alcatrazFaqQ7: "¿Cuánto tarda la incorporación?",
    alcatrazFaqA7:
      "Las implementaciones en la nube pueden estar activas en días. Las instalaciones on-premises toman más tiempo y dependen de su equipo de infraestructura: normalmente unas pocas semanas desde el inicio hasta la puesta en marcha.",
    alcatrazFinalEyebrow: "Tome el control",
    alcatrazFinalTitle: "¿Listo para poner su flota de STBs en una sola plataforma?",
    alcatrazFinalBody:
      "Cuéntenos sobre su red y prepararemos un recorrido personalizado de Alcatraz DMS.",
    alcatrazFinalCtaSecondary: "Contactar a ventas",
    navSolutionsCustomization: "Personalización y marca",
    navSolutionsCustomizationDesc: "Hardware y software de marca blanca",
    navSolutionsRemoteAppDesc: "Control remoto móvil para STBs de inext",
    customPageSeoTitle: "Personalización, marca blanca y co-branding — inext",
    customPageSeoDescription:
      "Haga que los set-top boxes de inext sean inconfundiblemente suyos: desde una simple preinstalación de app hasta un diseño de hardware totalmente personalizado y firmware a medida. Marca blanca y co-branding para operadores de IPTV y OTT.",
    customPageBreadcrumbHome: "Inicio",
    customPageBreadcrumbSolutions: "Soluciones",
    customPageBreadcrumbPage: "Personalización y marca",
    customPageHeroEyebrow: "Personalización · Marca blanca · Co-branding",
    customPageHeroTitle: "Su marca,",
    customPageHeroTitleAccent: "hasta el silicio",
    customPageHeroSub:
      "Desde una simple preinstalación de app hasta un dispositivo totalmente personalizado con firmware a medida: aplicamos marca blanca y co-branding a cada capa de la plataforma inext, para que sus suscriptores solo lo vean a usted.",
    customPageHeroCtaPrimary: "Contactar a ventas",
    customPageHeroCtaSecondary: "Ver ejemplos",
    customPageHeroStat1: "Software + hardware",
    customPageHeroStat2: "Marca de cualquier nivel",
    customPageHeroStat3: "Su marca, no la nuestra",
    customPageHeroImageAlt:
      "Ingenieros de inext personalizando un set-top box, con el diseño del PCB en pantalla",
    customPageSurfacesEyebrow: "Dos superficies, una identidad",
    customPageSurfacesTitle: "Software y hardware, ambos tuyos",
    customPageSurfacesDescription:
      "Aplique su marca a lo que los suscriptores tocan todos los días y al dispositivo que está debajo de su TV. Tome uno, tome ambos.",
    customPageSoftwareTag: "Software",
    customPageSoftwareTitle: "Personalización de software",
    customPageSoftwareBody:
      "Launcher, app de IPTV/OTT, app de control remoto e interfaz del sistema: con nuevo tema, nueva marca y precargados con sus servicios.",
    customPageSoftwareBullet1: "Launcher, animación de arranque y fondos de pantalla de marca",
    customPageSoftwareBullet2: "Cliente de IPTV/OTT y EPG personalizados",
    customPageSoftwareBullet3: "Apps preinstaladas y un catálogo restringido",
    customPageHardwareTag: "Hardware",
    customPageHardwareTitle: "Personalización de hardware",
    customPageHardwareBody:
      "Desde una calcomanía de marca y una caja de venta hasta una carcasa, control remoto y PCB totalmente personalizados según sus especificaciones.",
    customPageHardwareBullet1: "Empaque, manuales y accesorios de marca",
    customPageHardwareBullet2:
      "Color de carcasa, logo y disposición del control remoto personalizados",
    customPageHardwareBullet3: "PCB, puertos y chipset a medida para pedidos por volumen",
    customPageTiersEyebrow: "Marca de cualquier nivel",
    customPageTiersTitle: "Empiece sencillo. Llegue hasta el final.",
    customPageTiersDescription:
      "Elija la profundidad que se ajuste a su marca y presupuesto: cada paso se construye sobre el anterior.",
    customPageTiersLevelLabel: "Nivel",
    customPageTier1Name: "Preinstalación y animación de arranque",
    customPageTier1Body:
      "Sus apps preinstaladas en boxes inext de serie, más una animación de arranque de marca. La ruta más rápida al mercado, sin una tirada de fabricación aparte.",
    customPageTier1Tag: "Días",
    customPageTier2Name: "Experiencia de marca",
    customPageTier2Body:
      "Su launcher, animación de arranque, fondos de pantalla, apps preinstaladas y ajustes predefinidos. Los suscriptores ven su marca en el momento en que encienden el equipo.",
    customPageTier2Tag: "Semanas",
    customPageTier3Name: "White-label completo",
    customPageTier3Body:
      "Su nombre en el hardware, el firmware y cada app. Sin marca inext en ninguna parte: la plataforma desaparece detrás de la suya.",
    customPageTier3Tag: "Meses",
    customPageTier4Name: "Hardware y firmware a medida",
    customPageTier4Body:
      "Un box diseñado según sus especificaciones: carcasa, control remoto y puertos a medida, y una compilación de firmware mantenida para su flota.",
    customPageTier4Tag: "Proyecto",
    customPageTiersFootnote: "¿No sabe por dónde empezar? Le ayudamos a definir el nivel adecuado.",
    customPagePillarsEyebrow: "Qué puede personalizar",
    customPagePillarsTitle: "Cada capa está sobre la mesa",
    customPagePillar1Title: "Empaque y box",
    customPagePillar1Body: "Cajas de venta, estuches, manuales y kits de accesorios con su marca.",
    customPagePillar2Title: "Arranque y splash",
    customPagePillar2Body:
      "Animación de arranque de marca, pantallas de bienvenida y secuencia de apagado.",
    customPagePillar3Title: "Launcher e interfaz de inicio",
    customPagePillar3Body:
      "Pantalla de inicio personalizada, filas de contenido, fondos de pantalla e iconos de apps.",
    customPagePillar4Title: "App IPTV / OTT",
    customPagePillar4Body: "Reproductor de marca con su EPG, catch-up, time-shift y VOD.",
    customPagePillar5Title: "Apps preinstaladas",
    customPagePillar5Body: "Sus apps preinstaladas en el box, con una selección de apps bloqueada.",
    customPagePillar6Title: "App de control remoto",
    customPagePillar6Body: "Un control remoto móvil de marca con voz, teclado y gestos.",
    customPagePillar7Title: "Firmware y AOSP",
    customPagePillar7Body:
      "Compilación AOSP personalizada, ajustes del sistema, canal OTA y política de seguridad.",
    customPagePillar8Title: "Diseño de hardware",
    customPagePillar8Body:
      "Carcasa, disposición del control remoto, puertos, chipset y PCB para su volumen.",
    customPageSoftwareDeepEyebrow: "Software con sus colores",
    customPageSoftwareDeepTitle: "Una pantalla de inicio que los suscriptores reconocen como suya",
    customPageSoftwareDeepBody:
      "Reestilizamos el launcher, el reproductor y la interfaz del sistema en torno a su paleta, logotipo y tipografía; luego precargamos las apps y servicios que sus suscriptores esperan. El resultado se siente hecho a medida, no un Android TV genérico.",
    customPageSoftwareDeepBullet1: "Paleta, logotipo, iconos y tipografía",
    customPageSoftwareDeepBullet2: "Filas de launcher personalizadas y contenido destacado",
    customPageSoftwareDeepBullet3: "Reproductor IPTV/OTT y EPG de marca",
    customPageSoftwareDeepBullet4: "Apps precargadas y ajustes predefinidos",
    customPageSoftwareDeepPlaceholder: "Maquetas de launcher y apps de marca",
    customPageHardwareDeepEyebrow: "Hardware con su nombre",
    customPageHardwareDeepTitle: "De un adhesivo de marca a una placa completamente nueva",
    customPageHardwareDeepBody:
      "Elija hasta dónde llevarlo. Añada su logotipo y empaque a un box inext probado, reestilice la carcasa y el control remoto, o codiseñe un dispositivo completamente nuevo —chipset, puertos y PCB incluidos— para despliegues de alto volumen.",
    customPageHardwareDeepBullet1: "Color, acabado y logotipo de carcasa personalizados",
    customPageHardwareDeepBullet2: "Disposición y marca de control remoto a medida",
    customPageHardwareDeepBullet3: "Empaque de venta y kits de accesorios",
    customPageHardwareDeepBullet4: "PCB, puertos y chipset a medida (volumen)",
    customPageHardwareDeepPlaceholder: "Renders de hardware y empaque personalizados",
    customPageExamplesEyebrow: "Ejemplos",
    customPageExamplesTitle: "Marcas que lo hicieron suyo",
    customPageExamplesDescription:
      "Una selección de operadores que despliegan hardware inext bajo su propia marca, desde plataformas OTT globales hasta ISP regionales en Europa y Asia Central.",
    customPageExample1Name: "MEGOGO",
    customPageExample1Tag: "Ucrania",
    customPageExample1Meta: "Desde 2012",
    customPageExample1Body:
      "Servicio OTT internacional de TV, películas y deportes, con más de 55 M de usuarios mensuales.",
    customPageExample2Name: "Kyivstar TV",
    customPageExample2Tag: "Ucrania",
    customPageExample2Meta: "Desde 2018",
    customPageExample2Body:
      "Uno de los mayores operadores de telecomunicaciones de Ucrania, con alrededor de 24 millones de clientes.",
    customPageExample3Name: "SWEET.TV",
    customPageExample3Tag: "Europa",
    customPageExample3Meta: "Desde 2012",
    customPageExample3Body:
      "Plataforma de TV en streaming y VOD que opera en Europa Central y del Este.",
    customPageExample4Name: "ALMA TV",
    customPageExample4Tag: "Kazajistán",
    customPageExample4Meta: "Desde 2019",
    customPageExample4Body:
      "Proveedor kazajo de TV por suscripción e internet con servicio integral.",
    customPageExample5Name: "Beeline",
    customPageExample5Tag: "Kazajistán",
    customPageExample5Meta: "Desde 2022",
    customPageExample5Body:
      "Operador digital con 11 M de suscriptores móviles y 2 M de internet en el hogar, parte de VEON.",
    customPageExample6Name: "K@TV1",
    customPageExample6Tag: "Azerbaiyán",
    customPageExample6Meta: "Desde 2023",
    customPageExample6Body:
      "Uno de los mayores proveedores de servicios de televisión digital de Azerbaiyán.",
    customPageExample7Name: "Sarkor",
    customPageExample7Tag: "Uzbekistán",
    customPageExample7Meta: "Desde 2023",
    customPageExample7Body:
      "Un proveedor uzbeko líder de TI y telecomunicaciones con más de 25 años de servicio.",
    customPageExample8Name: "Metroport",
    customPageExample8Tag: "Polonia",
    customPageExample8Meta: "Desde 2024",
    customPageExample8Body:
      "Un consorcio de más de 30 ISP polacos que atiende a alrededor de 150.000 suscriptores.",
    customPageProcessEyebrow: "Cómo funciona",
    customPageProcessTitle: "Del brief a los boxes en los estantes",
    customPageProcessStep1Title: "Descubrimiento",
    customPageProcessStep1Body:
      "Definimos su marca, volúmenes, dispositivos objetivo y el nivel de personalización que encaja.",
    customPageProcessStep2Title: "Diseño",
    customPageProcessStep2Body:
      "Recursos de marca, diseño de interfaz y especificación de hardware, maquetados y aprobados.",
    customPageProcessStep3Title: "Construcción",
    customPageProcessStep3Body:
      "Implementamos firmware, apps y hardware, y luego le entregamos unidades de prueba.",
    customPageProcessStep4Title: "Certificación",
    customPageProcessStep4Body:
      "Certificaciones de cumplimiento, tienda y seguridad según lo requiera su mercado.",
    customPageProcessStep5Title: "Entrega",
    customPageProcessStep5Body:
      "Producción en masa, aprovisionamiento y soporte OTA continuo a través de Alcatraz DMS.",
    customPageFaqEyebrow: "FAQ",
    customPageFaqTitle: "Preguntas frecuentes",
    customPageFaqQ1: "¿Cuál es la diferencia entre co-branding y white-labeling?",
    customPageFaqA1:
      "El co-branding combina su marca con inext en hardware e interfaz compartidos. El white-labeling elimina inext por completo: su nombre en el box, el firmware y cada app.",
    customPageFaqQ2: "¿Cuál es el pedido mínimo para hardware a medida?",
    customPageFaqA2:
      "La preinstalación de apps y el co-branding tienen mínimos bajos o nulos. Las carcasas, controles remotos y PCB a medida dependen del volumen: confirmaremos los MOQ durante el descubrimiento.",
    customPageFaqQ3: "¿Pueden crear firmware totalmente a medida?",
    customPageFaqA3:
      "Sí. Mantenemos compilaciones AOSP personalizadas con sus ajustes del sistema, política de seguridad y un canal OTA dedicado, con soporte a largo plazo.",
    customPageFaqQ4: "¿Diseñan hardware nuevo desde cero?",
    customPageFaqA4:
      "Para los volúmenes adecuados, sí: carcasa, control remoto, puertos, chipset y PCB a medida, codiseñados con nuestro equipo de hardware.",
    customPageFaqQ5: "¿Cómo se gestionan las actualizaciones después del lanzamiento?",
    customPageFaqA5:
      "Los dispositivos de marca se gestionan a través de Alcatraz DMS: telemetría, firmware OTA por etapas, control remoto y notificaciones push.",
    customPageFaqQ6: "¿Cuánto tiempo lleva?",
    customPageFaqA6:
      "La preinstalación y el co-branding pueden entregarse en días; una interfaz de marca en semanas; el hardware a medida es un cronograma de proyecto que definimos juntos.",
    customPageFinalEyebrow: "Hazlo tuyo",
    customPageFinalTitle: "¿Listo para ponerle su marca?",
    customPageFinalBody:
      "Cuéntenos su marca, sus volúmenes y hasta dónde quiere llevarlo: trazaremos la ruta de personalización adecuada.",
    customPageFinalCta: "Contactar a ventas",
    customPageFinalCtaSecondary: "Solicitar demo",
    navAccessories: "Accesorios",
    accessoriesSeoTitle: "Accesorios inext — Controles remotos, cables y adaptadores de corriente",
    accessoriesSeoDescription:
      "Explore accesorios opcionales para los boxes Android TV de inext. Controles remotos programables oficiales, cables AV analógicos, fuentes de alimentación y receptores IR externos.",
    accessoriesTitle: "Controles remotos, cables y corriente",
    accessoriesSubtitle: "Accesorios oficiales y repuestos para los Set-Top Boxes de inext.",
    accessoriesHeroEyebrow: "Accesorios opcionales",
    accessoriesFilterAll: "Todos los accesorios",
    accessoriesFilterRemotes: "Controles remotos",
    accessoriesFilterCables: "Cables y adaptadores",
    accessoriesFilterPower: "Fuentes de alimentación",
    accessoriesFilterSensors: "Sensores IR",
    accessoriesSpecsTab: "Especificaciones",
    accessoriesFeaturesTab: "Características",
    accessoriesProgrammingTab: "Instrucciones de programación",
    accessoriesBackToList: "Volver a accesorios",
    accessoriesVideoGuide: "Guía en video",
    accessoriesAppBullet1: "Disponible para Android e iOS — gratis",
    accessoriesAppBullet2: "Funciona por Wi-Fi — sin necesidad de línea de visión",
    accessoriesAppBullet3: "Búsqueda por voz y teclado en pantalla",
    accessoriesAppCta: "Más información sobre la app",
    footerLinkAccessories: "Accesorios",
    productMenuAccessoriesDesc: "Controles remotos, cables y fuentes de alimentación",
    footerLinkArchive: "Modelos anteriores",
    archiveSeoTitle: "Set-Top Boxes anteriores de inext — Archivo de modelos descontinuados",
    archiveSeoDescription:
      "Un archivo de Set-Top Boxes Android y Linux descontinuados de inext, desde el HD1 de 2011 hasta los boxes 4K con Allwinner y Amlogic. Fotos y especificaciones completas de cada modelo anterior.",
    archiveTitle: "Modelos anteriores",
    archiveHeroEyebrow: "Archivo de productos",
    archiveSubtitle:
      "Cada Set-Top Box de inext que hemos entregado desde 2011. Estos modelos están descontinuados; se conservan aquí con fotos y especificaciones completas como referencia.",
    archiveViewSpecs: "Ver especificaciones",
    archiveBadge: "Descontinuado",
    archiveSpecsHeading: "Especificaciones",
    iptvAppSeoTitle: "App IPTV para operadores — Cliente de TV de marca para STBs inext",
    iptvAppSeoDescription:
      "App IPTV lista para STBs inext: M3U + XMLTV, Stalker/Ministra, TVIP y otros portales. Marca white-label y ajustes preconfigurados — lance más rápido.",
    iptvAppBreadcrumbHome: "Inicio",
    iptvAppBreadcrumbSolutions: "Soluciones",
    iptvAppBreadcrumbPage: "Aplicación IPTV",
    iptvAppHeroEyebrow: "Software cliente · STBs inext",
    iptvAppHeroTitle: "Ahórrese crear una app de TV —",
    iptvAppHeroTitleAccent: "entrega la nuestra, con su marca",
    iptvAppHeroSub:
      "Un cliente IPTV listo para los Set-Top Boxes de inext. Aplicamos su marca, lo preconfiguramos para su middleware o listas de reproducción y lo entregamos preinstalado, para que los suscriptores vean TV nada más sacarlo de la caja.",
    iptvAppHeroStat1: "Más de 3 familias de portales",
    iptvAppHeroStat2: "100 % white-label",
    iptvAppHeroStat3: "Configuración del suscriptor sin intervención",
    iptvAppHeroCtaDemo: "Solicitar demo",
    iptvAppHeroCtaSales: "Contactar a ventas",
    iptvAppModesEyebrow: "Modos de backend",
    iptvAppModesTitle: "Funciona con el backend que ya utiliza",
    iptvAppModesDescription:
      "Sin migración, sin nuevo middleware. Una sola app se adapta a su headend actual: elija el modo que coincida con su stack.",
    iptvAppMode1Title: "Listas M3U + EPG XMLTV",
    iptvAppMode1Body:
      "La forma más sencilla de poner sus canales en pantalla. Apunte la app a una lista de reproducción y a un feed de EPG: los suscriptores obtienen una interfaz nativa rápida con datos de programación completos.",
    iptvAppMode1Bullet1: "Listas M3U con categorías y logotipos de canales",
    iptvAppMode1Bullet2: "EPG XMLTV día a día con ahora/después en cada canal",
    iptvAppMode1Bullet3: "Selección de pista multi-audio durante la reproducción",
    iptvAppMode1Bullet4: "Proxy UDP-a-HTTP integrado para redes multicast",
    iptvAppMode2Title: "Middleware Stalker / Ministra",
    iptvAppMode2Body:
      "La app renderiza su portal real Stalker o Ministra —TV, VideoClub, grabaciones y favoritos— con un perfil de STB configurable y una capa de reproductor nativo por encima.",
    iptvAppMode2Bullet1:
      "Renderizado completo del portal con un tipo de STB configurable (p. ej. MAG)",
    iptvAppMode2Bullet2: "TV en vivo, VideoClub / VOD, favoritos y grabaciones",
    iptvAppMode2Bullet3:
      "Capa de reproductor nativo: pistas de audio, subtítulos, zoom, teclado virtual",
    iptvAppMode2Bullet4:
      "URL del portal y ajustes de reproducción preconfigurados para su servicio",
    iptvAppMode3Title: "TVIP, Hibox, Aura y otros portales web",
    iptvAppMode3Body:
      "Su portal con la marca del operador se convierte en toda la experiencia de TV: launcher, guía de programación, catch-up y grabaciones incluidos. Se pueden añadir otros middlewares web a pedido.",
    iptvAppMode3Bullet1: "Launchers con la marca del operador renderizados tal como se diseñaron",
    iptvAppMode3Bullet2: "Cuadrícula completa de guía de programación con EPG detallado",
    iptvAppMode3Bullet3: "Catch-up TV y grabaciones",
    iptvAppMode3Bullet4: "El mismo enfoque de simulador se extiende a otros portales web",
    iptvAppWhiteLabelEyebrow: "White-label y preempaquetado",
    iptvAppWhiteLabelTitle: "Su marca en pantalla, sus ajustes integrados",
    iptvAppWhiteLabelBody:
      "Reestilizamos la app con su logotipo, colores y nombre de app, y luego precargamos la URL de su portal, la lista de reproducción y la fuente de EPG. Los boxes llegan listos para el suscriptor: conecte y mire.",
    iptvAppWhiteLabelBullet1: "Su logotipo, colores y nombre de app",
    iptvAppWhiteLabelBullet2: "URL de portal, lista de reproducción y fuente de EPG precargadas",
    iptvAppWhiteLabelBullet3:
      "Ajustes bloqueados o abiertos: usted decide qué pueden cambiar los suscriptores",
    iptvAppWhiteLabelBullet4: "Se entrega preinstalado en los STBs inext",
    iptvAppPillarsEyebrow: "Características",
    iptvAppPillarsTitle: "Todo lo que los suscriptores esperan desde el primer día",
    iptvAppPillar1Title: "EPG completo",
    iptvAppPillar1Body:
      "Guía de programación día a día desde XMLTV o su middleware, con ahora/después en cada canal.",
    iptvAppPillar2Title: "Categorías y logotipos",
    iptvAppPillar2Body:
      "Listas de canales ordenadas con categorías de género y logotipos de canales para un zapping rápido.",
    iptvAppPillar3Title: "Multi-audio y subtítulos",
    iptvAppPillar3Body:
      "Selección de pista de audio y subtítulos directamente en la capa del reproductor.",
    iptvAppPillar4Title: "Compatible con multicast",
    iptvAppPillar4Body:
      "El proxy UDP-a-HTTP integrado reproduce streams multicast sin hardware adicional.",
    iptvAppPillar5Title: "UX pensada para el control remoto",
    iptvAppPillar5Body:
      "Zapping numérico, teclas de color y un teclado virtual: diseñado para el control remoto en la mano.",
    iptvAppPillar6Title: "Interfaz multilingüe",
    iptvAppPillar6Body: "Interfaz localizada para su mercado, conmutable por dispositivo.",
    iptvAppProcessEyebrow: "Cómo funciona",
    iptvAppProcessTitle: "Tres pasos hacia boxes listos para el suscriptor",
    iptvAppProcessStep1Title: "Cuéntenos su backend y su marca",
    iptvAppProcessStep1Body:
      "Detalles del middleware o la lista de reproducción, logotipo, colores: un brief breve.",
    iptvAppProcessStep2Title: "Aplicamos la marca, preconfiguramos y probamos",
    iptvAppProcessStep2Body:
      "Su compilación se estiliza, se carga con sus ajustes y se verifica en los STBs inext.",
    iptvAppProcessStep3Title: "Los boxes llegan listos para el suscriptor",
    iptvAppProcessStep3Body:
      "Los suscriptores conectan y miran; las actualizaciones se gestionan de forma centralizada.",
    iptvAppEcosystemEyebrow: "Ecosistema",
    iptvAppEcosystemTitle: "Parte del stack para operadores de inext",
    iptvAppEcosystemBody:
      "Combine la app con los Set-Top Boxes de inext y Alcatraz DMS: hardware, software cliente y gestión de flota de un solo proveedor.",
    iptvAppEcosystemLinkStb: "Explorar los STBs inext",
    iptvAppEcosystemLinkAlcatraz: "Descubrir Alcatraz DMS",
    iptvAppFaqEyebrow: "FAQ",
    iptvAppFaqTitle: "Preguntas frecuentes",
    iptvAppFaqQ1: "¿Qué middlewares son compatibles?",
    iptvAppFaqA1:
      "Stalker / Ministra, TVIP, Hibox y Aura de fábrica, además de listas M3U simples con EPG XMLTV. Por lo general se pueden añadir otros portales basados en web: consúltenos por el suyo.",
    iptvAppFaqQ2: "¿Pueden aplicar nuestra marca y bloquear los ajustes?",
    iptvAppFaqA2:
      "Sí. Entregamos la app con su logotipo, colores y nombre, preconfiguramos los ajustes del portal y de reproducción, y podemos bloquearlos para que los suscriptores no rompan la configuración, o dejarlos abiertos.",
    iptvAppFaqQ3: "¿Funciona sin middleware (M3U simple)?",
    iptvAppFaqA3:
      "Sí. En modo M3U la app solo necesita una URL de lista de reproducción y un feed XMLTV opcional: aun así obtienes categorías, logotipos, un EPG completo y multi-audio.",
    iptvAppFaqQ4: "¿Qué tan rápido podemos lanzar?",
    iptvAppFaqA4:
      "Semanas, no meses. La marca y la preconfiguración llevan días; la mayor parte del cronograma es probar en su red y enviar los boxes.",
    iptvAppFinalEyebrow: "Lanza más rápido",
    iptvAppFinalTitle: "Su app de TV ya está creada —",
    iptvAppFinalTitleAccent: "hagámosla tuya",
    iptvAppFinalBody:
      "Cuéntenos sobre su backend y su marca y prepararemos una compilación de demo preconfigurada para su servicio.",
    iptvAppFinalCta: "Solicitar demo",
    iptvAppFinalCtaSecondary: "Contactar a ventas",
    iptvAppAltNativePlayer:
      "App IPTV de inext reproduciendo deportes en vivo con capa de reproductor y EPG ahora/después",
    iptvAppAltNativeEpg:
      "Lista de canales con línea de tiempo de EPG de día completo en la interfaz IPTV nativa",
    iptvAppAltNativeCategories:
      "Barra lateral de categorías con logotipos de canales e información de programa ahora/después",
    iptvAppAltNativeSetup:
      "Pantalla de configuración que ofrece una lista de canales M3U o un portal Stalker",
    iptvAppAltNativeAudio: "Menú de selección de pista de audio sobre el video en vivo",
    iptvAppAltStalkerHome:
      "Pantalla de inicio del portal Stalker / Ministra con secciones de TV y VideoClub",
    iptvAppAltStalkerChannels: "Lista de canales del portal Stalker con vista previa en vivo y EPG",
    iptvAppAltStalkerSettings:
      "Pantalla de ajustes con URL del portal y selección de tipo de STB MAG",
    iptvAppAltStalkerPlayerMenu:
      "Barra de herramientas del reproductor con controles de portal, audio, subtítulos, zoom y teclado",
    iptvAppAltTvipHome: "Pantalla de inicio de launcher estilo TVIP con la marca del operador",
    iptvAppAltTvipChannels:
      "Lista de canales de varias columnas con detalles de programa en un portal estilo TVIP",
    iptvAppAltTvipEpg: "Cuadrícula completa de guía de programación con detalles de programa",
    navSolutionsIptvApp: "Aplicación IPTV",
    navSolutionsIptvAppDesc: "Cliente de TV de marca para STBs inext",
    footerLinkIptvApp: "Aplicación IPTV",
    navSolutionsOta: "Actualizaciones OTA",
    navSolutionsOtaDesc: "Despliegues escalonados de firmware y apps",
    footerLinkOta: "Gestión de actualizaciones OTA",
    otaBreadcrumbHome: "Inicio",
    otaBreadcrumbSolutions: "Soluciones",
    otaBreadcrumbPage: "Gestión de actualizaciones OTA",
    otaSeoTitle:
      "inext Gestión de actualizaciones OTA — actualizaciones escalonadas para flotas de STB inext",
    otaSeoDescription:
      "Pruebe, apruebe, escalone, entregue y monitoree firmware en flotas de STB inext, con soporte para actualizaciones de aplicaciones. Más de 1 millón de actualizaciones OTA entregadas a través de la plataforma inext.",
    otaHeroEyebrow: "Gestión de actualizaciones OTA",
    otaHeroTitle: "El firmware correcto para el dispositivo correcto —",
    otaHeroTitleAccent: "de forma segura y a escala",
    otaHeroSub:
      "Pruebe, apruebe, escalone, entregue y monitoree el firmware de STB inext desde una sola plataforma — desde el primer dispositivo de QA hasta una flota a escala nacional.",
    otaHeroCtaDemo: "Solicitar demo",
    otaHeroCtaSales: "Analice su despliegue",
    otaHeroPlatformNote: "La gestión de actualizaciones OTA forma parte de inext",
    otaHeroStat1: "Despliegues escalonados del 1 % al 100 %",
    otaHeroStat2: "Entrega según geografía y operador",
    otaHeroStat3: "Nube u on-premises",
    otaHeroDiagramTitle: "Solicitud de actualización",
    otaHeroDiagramSubRunning: "Evaluando por dispositivo…",
    otaHeroDiagramSubDone: "Actualización completa",
    otaHeroDiagramStep1: "Modelo · placa · versión instalada",
    otaHeroDiagramStep2: "Segmentación · programación · % de despliegue",
    otaHeroDiagramStep3: "Nodo de almacenamiento disponible más cercano",
    otaHeroDiagramOutcome: "Enlace de descarga seguro y verificado",
    otaHeroDiagramDownloading: "Descargando firmware al STB…",
    otaHeroDiagramInstalling: "Instalando firmware en el STB…",
    otaHeroDiagramInstalled: "Firmware instalado correctamente",
    otaReleaseEyebrow: "Flujo de trabajo controlado",
    otaReleaseTitle: "De la compilación probada al despliegue controlado",
    otaReleaseDescription:
      "Cada lanzamiento pasa por etapas claras de prueba, aprobación, despliegue y monitoreo. Los comentarios con acceso por rol mantienen las conversaciones en el contexto de la compilación o el lanzamiento correspondiente.",
    otaReleaseCard1Title: "Ofrezca a cada dispositivo solo firmware compatible",
    otaReleaseCard1Body:
      "Cada solicitud se verifica frente al modelo, la placa, la versión instalada, el operador, la política de release y la disponibilidad del artefacto antes de ofrecer una actualización.",
    otaReleaseCard2Title: "Defina el objetivo del despliegue",
    otaReleaseCard2Body:
      "Comience con un pequeño grupo piloto, revise la adopción y luego amplíe hacia toda la flota. Pause o reduzca el objetivo sin perder el avance.",
    otaReleaseCard4Title: "Pruebe en dispositivos seleccionados",
    otaReleaseCard4Body:
      "Valide la compilación en dispositivos internos o de campo antes de que sea elegible para distribución pública.",
    otaReleaseCard6Title: "Apruebe para release público",
    otaReleaseCard6Body:
      "Separe los permisos de prueba y de release público para que solo los usuarios autorizados puedan pasar firmware a producción.",
    otaRolloutEyebrow: "Controles de release",
    otaRolloutTitle: "Segmente con precisión. Limite el alcance del impacto.",
    otaRolloutBody:
      "Las verificaciones de compatibilidad y los controles de despliegue por porcentaje reducen sustancialmente el riesgo del release, manteniendo a los operadores en control de cada expansión.",
    otaRolloutMeterLabel: "Objetivo de despliegue",
    otaRolloutMeterStage1: "Prueba interna",
    otaRolloutMeterStage2: "Anillo piloto",
    otaRolloutMeterStage3: "En expansión",
    otaRolloutMeterStage4: "Flota completa",
    otaGovernEyebrow: "Gobernanza",
    otaGovernTitle: "Las reglas de aprobación se mantienen explícitas",
    otaGovernBody:
      "Los permisos basados en roles separan las pruebas, la aprobación, el control del despliegue y el acceso a los comentarios de firmware, manteniendo claramente controladas las decisiones de producción.",
    otaGovernPerm3: "Crear releases de prueba",
    otaGovernPerm4: "Aprobar para distribución pública",
    otaGovernPerm5: "Crear y modificar políticas de despliegue",
    otaGovernPerm6: "Iniciar, pausar o reanudar releases",
    otaGovernPerm7: "Opciones avanzadas de release privado",
    otaDeliveryEyebrow: "Entrega global",
    otaDeliveryTitle: "Entrega de firmware resiliente y con reconocimiento geográfico",
    otaDeliveryDescription:
      "El firmware se distribuye a través de nodos de almacenamiento aprobados, elegidos mediante reglas de enrutamiento configurables — manteniendo el tráfico cerca de su flota mientras conserva el control de la política de entrega regional.",
    otaDeliveryCard1Title: "Enrute por ubicación, operador y capacidad",
    otaDeliveryCard1Body:
      "Elija el nodo aprobado más cercano que tenga el firmware y capacidad suficiente para otra descarga.",
    otaDeliveryCard2Title: "Conmute por error solo cuando la política lo permite",
    otaDeliveryCard2Body:
      "Si un nodo regional no está disponible o está lleno, un respaldo global verificado puede tomar el relevo sin omitir las reglas de entrega.",
    otaDeliveryCard3Title: "Verifique cada descarga",
    otaDeliveryCard3Body:
      "Los enlaces con tiempo limitado protegen los detalles de enrutamiento y almacenamiento, mientras que los metadatos de tamaño de archivo y checksum validan el artefacto antes de la instalación.",
    otaDiagramEyebrow: "Cómo llega un release a un dispositivo",
    otaDiagramTitle: "La ruta de entrega OTA",
    otaDiagramNode1: "UI y APIs de gestión",
    otaDiagramNode2: "Plano de control basado en roles",
    otaDiagramNode3: "Motor de selección de firmware",
    otaDiagramNode4: "Orquestador de entrega OTA",
    otaDiagramNode5: "Nodos de almacenamiento regionales / on-premises",
    otaDiagramNode6: "Almacenamiento de respaldo global",
    otaDiagramNode7: "Flota de STB inext",
    otaDiagramNode8: "Telemetría de descarga y adopción",
    otaDiagramReturnLabel: "La telemetría regresa a la plataforma",
    otaDeployEyebrow: "Su infraestructura",
    otaDeployTitle: "Despliegue en la nube, on-premises o ambos",
    otaDeployDescription:
      "Use la entrega en la nube de inext, coloque nodos de almacenamiento dentro de su red o ejecute la plataforma completa on-premises.",
    otaDeployCloudTag: "Recomendado",
    otaDeployCloudTitle: "Nube (SaaS)",
    otaDeployCloudBody:
      "Alojada y operada por inext. El inicio más rápido, actualizaciones automáticas de la plataforma y entrega geodistribuida lista para usar.",
    otaDeployCloudBullet1: "Sin infraestructura que mantener",
    otaDeployCloudBullet2: "Nodos de almacenamiento globales incluidos",
    otaDeployCloudBullet3: "Actualizaciones automáticas de la plataforma",
    otaDeployOnpremTitle: "On-premises",
    otaDeployOnpremBody:
      "Backend, interfaz web y nodos de almacenamiento dentro de su propia red — para operadores con requisitos estrictos de residencia de datos o seguridad.",
    otaDeployOnpremBullet1: "Los artefactos de firmware permanecen en su red",
    otaDeployOnpremBullet2: "Almacenamiento de objetos compatible con S3",
    otaDeployOnpremBullet3: "Control de la capacidad y la topología",
    otaDeployNodeTitle:
      "¿Necesita actualizaciones más rápidas? Agregue un nodo de almacenamiento dedicado",
    otaDeployNodeBody:
      "Un servidor de almacenamiento puede ejecutarse dentro de su red sin importar dónde esté alojada la plataforma. inext lo configura de forma remota, replica el firmware y lo integra a la red de entrega en días.",
    otaDeployNodeChip1: "Funciona con nube u on-premises",
    otaDeployNodeChip2: "Aprovisionado remotamente por inext",
    otaDeployNodeChip3: "Operativo en días, no semanas",
    otaMonitorEyebrow: "Visibilidad operativa",
    otaMonitorTitle: "Observe el avance del despliegue en la consola real",
    otaMonitorDescription:
      "Dé seguimiento a la adopción del despliegue y al estado de la distribución, y abra eventos OTA por dispositivo desde la línea de tiempo de actividad cuando sea necesario investigar.",
    otaMonitorCard1Title: "Monitoree y amplíe",
    otaMonitorCard1Body:
      "Compare la adopción con los dispositivos activos y el objetivo de despliegue actual antes de ampliar.",
    otaMonitorCard2Title: "Telemetría de descarga",
    otaMonitorCard2Body:
      "Revise métricas detalladas de descarga e instalación por compilación, tipo de dispositivo, nodo, región y evento individual del dispositivo.",
    otaMonitorCard4Title: "Notificaciones automatizadas",
    otaMonitorCard4Body:
      "Notifique a los responsables del release cuando un despliegue alcanza su objetivo actual y está listo para revisión.",
    otaMonitorMetricsNote:
      "Las métricas de infraestructura se exportan en un formato compatible con plataformas de monitoreo estándar como Prometheus y Grafana.",
    otaMigrateEyebrow: "Migración de flota",
    otaMigrateTitle: "Migre una flota genérica a su propio branch de firmware",
    otaMigrateBody:
      "Los operadores que lanzaron con firmware genérico pueden migrar los dispositivos desplegados a un branch dedicado de marca por aire — incluido el bootloader — sin visitas de campo ni cambios de hardware.",
    otaMigrateBullet1:
      "Transicione los dispositivos desplegados a un branch de firmware personalizado",
    otaMigrateBullet2: "Conversión completa de la imagen, incluido el bootloader",
    otaMigrateBullet3: "Sin visitas de campo, devoluciones ni cambios de hardware",
    otaApiEyebrow: "Lista para integrar",
    otaApiTitle: "Conecte OTA a su stack operativo",
    otaApiBody:
      "Use claves de API de autoservicio con permisos limitados para integrar compilaciones de firmware, aprobaciones, estado de dispositivos y adopción del despliegue con las herramientas de soporte y reportes existentes.",
    otaApiPanelTitle: "Alcatraz API",
    otaApiPanelSub: "REST · documentada · con tokens de alcance limitado",
    otaAppsEyebrow: "Entrega de aplicaciones",
    otaAppsTitle: "Entregue actualizaciones de apps, no solo firmware",
    otaAppsBody:
      "Más allá del firmware, la plataforma puede distribuir actualizaciones de aplicaciones a STB compatibles — reutilizando la misma red de entrega y los controles de despliegue escalonado. Las opciones disponibles dependen de cómo esté integrada la app.",
    otaAppsBullet1: "Misma red de entrega y despliegue escalonado",
    otaAppsBullet2: "Para STB compatibles y apps integradas",
    otaStatRolloutValue: "1M+",
    otaStatRolloutLabel: "actualizaciones OTA entregadas a través de la plataforma inext",
    otaStatScaleValue: "1 % → 100 %",
    otaStatScaleLabel: "Control de despliegue escalonado, del grupo piloto a la flota completa",
    otaStatDeliveryValue: "Según geografía",
    otaStatDeliveryLabel: "Enrutamiento por país, operador y capacidad de nodo en vivo",
    otaStatDeployValue: "Nube · On-premises",
    otaStatDeployLabel: "Ejecute en nuestra nube o completamente dentro de su propia red",
    otaTargetChipsLabel: "Segmentar por",
    otaTargetChip1: "Modelo y placa del STB",
    otaTargetChip2: "Versión de firmware instalada",
    otaTargetChip3: "ISP / operador",
    otaTargetChip4: "Lista de MAC permitidas",
    otaTargetChip5: "Grupo de prueba",
    otaTargetChip6: "Elegibilidad para actualización automática",
    otaFaqEyebrow: "FAQ",
    otaFaqTitle: "Preguntas frecuentes",
    otaFaqQ1: "¿OTA es parte de Alcatraz DMS?",
    otaFaqA1:
      "Las actualizaciones de firmware OTA se entregan a través de la plataforma inext Alcatraz — el mismo backend, consola y permisos. Si ya usa Alcatraz DMS, OTA es el lado de entrega de firmware del mismo sistema.",
    otaFaqQ2: "¿Puede OTA ejecutarse dentro de la red de un operador?",
    otaFaqA2:
      "Sí. Los nodos de almacenamiento pueden ejecutarse dentro de su infraestructura, y la plataforma completa — backend e interfaz web — puede desplegarse on-premises. Los nodos admiten almacenamiento de objetos compatible con S3.",
    otaFaqQ3: "¿Cómo reducen el riesgo los despliegues escalonados?",
    otaFaqA3:
      "Lanza a un porcentaje definido de la flota, monitorea la adopción frente a los dispositivos activos y amplía solo cuando está conforme. Puede pausar, reanudar o revertir el objetivo en cualquier momento, y recibe una notificación cuando se completa una etapa.",
    otaFaqQ4: "¿Qué sucede si un nodo de almacenamiento regional está caído o lleno?",
    otaFaqA4:
      "El enrutamiento reconoce la capacidad. Si un nodo regional aprobado no está disponible o está al máximo de su capacidad, el tráfico puede recurrir a un nodo global cuando la política de enrutamiento lo permite — y una actualización solo se ofrece cuando existe una ruta de entrega verificada.",
    otaFaqQ5: "¿Podemos forzar una actualización de seguridad crítica?",
    otaFaqA5:
      "Sí. Los releases pueden marcarse como obligatorios para que los usuarios no puedan omitirlos, y las reglas de la ruta de actualización garantizan que un dispositivo instale cualquier firmware intermedio requerido antes de avanzar a una compilación más reciente.",
    otaFaqQ6: "¿Cómo verifican que un dispositivo recibió el firmware correcto?",
    otaFaqA6:
      "Los metadatos del firmware incluyen información de tamaño de archivo y checksum, de modo que el STB valida el artefacto descargado antes de la instalación. Los dispositivos también reportan telemetría de descarga de vuelta a la plataforma.",
    otaFaqQ7: "¿El sistema puede entregar actualizaciones de aplicaciones?",
    otaFaqA7:
      "Sí. El sistema está diseñado principalmente para la gestión del ciclo de vida del firmware, pero también puede distribuir actualizaciones de aplicaciones a STB compatibles. Los controles disponibles dependen de la integración de la aplicación y los requisitos de despliegue.",
    otaFinalEyebrow: "¿Listo para planear un despliegue más seguro?",
    otaFinalTitle: "Vea la gestión de actualizaciones OTA en acción",
    otaFinalBody:
      "Recorra las pruebas, la aprobación, el despliegue escalonado y el monitoreo con el equipo de inext usando un escenario de despliegue de su propia flota.",
    otaFinalCta: "Reservar una demo de OTA",
    otaFinalCtaSecondary: "Analice su despliegue",
    otaLiveLabel: "En vivo",
    otaUiTestTitle: "Probar",
    otaUiTestBody: "Envíe este firmware a uno o más dispositivos para pruebas.",
    otaUiTestAction: "Crear release de prueba",
    otaUiConfirmTitle: "Confirmar",
    otaUiConfirmBody:
      "Marque el firmware como listo para release público. Una compilación confirmada puede luego usarse en un release público.",
    otaUiConfirmAction: "Confirmar firmware",
    otaUiReleaseTitle: "Release",
    otaUiReleaseBody:
      "Configure la fecha, la hora y el porcentaje de despliegue del release para la compilación aprobada.",
    otaUiReleaseAction: "Crear release público",
    otaUiLiveBody: "Active o desactive el release en cualquier momento.",
    otaUiMandatoryTitle: "Obligatorio",
    otaUiMandatoryBody: "Los usuarios no pueden rechazar esta actualización.",
    otaUiResetTitle: "Restablecer tras la actualización",
    otaUiResetBody:
      "Devuelva los dispositivos a la configuración de fábrica después de la instalación.",
    otaUiStagedTitle: "Despliegue escalonado",
    otaUiStagedBody: "Lance este firmware a un porcentaje controlado de dispositivos elegibles.",
    otaUiInteractiveLabel: "Vista previa interactiva",
    otaUiCompletedAction: "Completado",
    otaUiWorkingAction: "Procesando…",
    otaUiWorkflowComplete: "Aprobado y listo para el despliegue escalonado",
    otaUiReplayAction: "Ejecutar de nuevo",
    otaUiApproximately: "aproximadamente",
    otaUiEligibleDevices: "dispositivos elegibles",
    otaAdvancedEyebrow: "Capacidades avanzadas",
    otaAdvancedTitle: "Extienda OTA más allá del despliegue estándar",
    otaAdvancedBody:
      "Migre flotas existentes a un branch de firmware de marca y conecte las operaciones de release con el resto de las herramientas del operador.",
    worldwideEyebrow: "Entrega mundial",
    worldwideHeadline: "Fabricado en Asia. Desplegado en todas partes.",
    worldwideSub:
      "Desde socios de fabricación en Shenzhen y Taiwán, hasta operadores en Europa, Asia Central, las Américas y más allá. Empaque, aduanas y coordinación de entrega — todo gestionado.",
    worldwideOriginLabel: "China y Taiwán",
    worldwideStat1Value: "700K+",
    worldwideStat1Label: "dispositivos enviados",
    worldwideStat3Label: "modos de envío",
    worldwideCta: "Cómo enviamos",
    navSolutionsLogistics: "Logística global",
    navSolutionsLogisticsDesc: "Entrega de hardware B2B a nivel mundial",
    footerLinkLogistics: "Logística global",
    logisticsSeoTitle: "Logística global — Entrega de hardware B2B a nivel mundial",
    logisticsSeoDescription:
      "Entrega B2B de hardware inext desde socios de fabricación en Shenzhen, Guangzhou y Taiwán a operadores y distribuidores de todo el mundo — por aire, mar y carretera, con mensajería exprés para muestras.",
    logisticsBreadcrumb: "Logística global",
    logisticsHeroEyebrow: "Logística B2B mundial",
    logisticsHeroTitle: "De la producción a",
    logisticsHeroTitleAccent: "su almacén",
    logisticsHeroSub:
      "Fabricamos Set-Top Boxes con socios de fabricación consolidados en China y Taiwán, y luego coordinamos la entrega a operadores, distribuidores y almacenes empresariales de todo el mundo. Un solo punto de contacto mantiene cada envío B2B en movimiento.",
    logisticsHeroCtaPrimary: "Planear un envío",
    logisticsHeroCtaSecondary: "Encontrar un distribuidor",
    logisticsHeroChip1: "Entrega B2B a nivel mundial",
    logisticsHeroChip2: "Fabricado en China y Taiwán",
    logisticsHeroChip3: "Empaque de marca, listo para vender",
    logisticsHeroStage1: "Producción",
    logisticsHeroStage2: "Marca y empaque",
    logisticsHeroStage3: "Flete",
    logisticsHeroStage4: "Aduanas y entrega",
    logisticsGlobeHubLabel: "Centro de fabricación",
    logisticsGlobeRouteLabel: "Ruta de entrega",
    logisticsGlobeCaption:
      "Rutas B2B desde China y Taiwán hacia Kyiv, Bratislava, São Paulo y Almaty, con distribución posterior desde Bratislava hacia Varsovia y Hungría.",
    logisticsHubShenzhen: "Shenzhen",
    logisticsHubGuangzhou: "Guangzhou",
    logisticsHubTaiwan: "Taiwán",
    logisticsStat1Value: "700K+",
    logisticsStat1Label: "dispositivos entregados a nivel mundial",
    logisticsStat2Value: "15+",
    logisticsStat2Label: "países atendidos",
    logisticsStat3Value: "3",
    logisticsStat3Label: "centros de fabricación en China y Taiwán",
    logisticsStat4Value: "4",
    logisticsStat4Label: "opciones de flete — aire, mar, carretera y mensajería para muestras",
    logisticsMakeEyebrow: "Dónde se fabrica",
    logisticsMakeTitle: "Fabricado en centros de manufactura probados",
    logisticsMakeBody:
      "Nuestros Set-Top Boxes se producen con socios de fabricación y suministro en dos de las principales regiones electrónicas del mundo. Mantener la producción cerca de la cadena de suministro de componentes mantiene la calidad alta, los plazos cortos y los costos predecibles.",
    logisticsMakeCard1Title: "Shenzhen, China",
    logisticsMakeCard1Tag: "Ensamblaje y empaque",
    logisticsMakeCard1Body:
      "Ensamblaje final, grabación de firmware, control de calidad y empaque — incluidas cajas de marca del operador, listas para venta minorista.",
    logisticsMakeCard2Title: "Guangzhou, China",
    logisticsMakeCard2Tag: "Placas y componentes",
    logisticsMakeCard2Body:
      "Producción de placas y abastecimiento de componentes, respaldados por la densa cadena de suministro del Delta del Río Perla para una entrega rápida.",
    logisticsMakeCard3Title: "Taiwán",
    logisticsMakeCard3Tag: "Silicio y módulos",
    logisticsMakeCard3Body:
      "Chipsets y módulos clave de proveedores taiwaneses consolidados — el silicio detrás de las plataformas sobre las que corre nuestro hardware.",
    logisticsFlowEyebrow: "De la producción al despliegue",
    logisticsFlowTitle: "Una ruta coordinada hacia su operación",
    logisticsFlowBody:
      "Fabricación, empaque, flete y aduanas avanzan como un solo plan, con un contacto designado que coordina cada etapa.",
    logisticsFlowStep1Title: "Fabricación y control de calidad",
    logisticsFlowStep1Body:
      "Los dispositivos se ensamblan y se prueban individualmente, luego se graban con su compilación de firmware antes de salir de la línea.",
    logisticsFlowStep2Title: "Marca y empaque",
    logisticsFlowStep2Body:
      "Los boxes se empacan en embalaje neutro o totalmente de marca, listo para el retail y adaptado a su mercado.",
    logisticsFlowStep3Title: "Enviar y despachar en aduana",
    logisticsFlowStep3Body:
      "Contratamos al transportista adecuado según su plazo y presupuesto, y preparamos la documentación de exportación y despacho aduanero.",
    logisticsFlowStep4Title: "Entregado a su red",
    logisticsFlowStep4Body:
      "Los pedidos de producción llegan a su almacén, distribuidor o socio logístico designado, con seguimiento durante todo el trayecto.",
    logisticsModesEyebrow: "Cómo enviamos",
    logisticsModesTitle: "El modo adecuado para cada envío",
    logisticsModesBody:
      "Desde un solo palet urgente hasta un contenedor completo, ajustamos el método de envío a su volumen, presupuesto y plazo.",
    logisticsModeAirTitle: "Flete aéreo",
    logisticsModeAirBody:
      "La ruta de flete más rápida para lanzamientos y pedidos de producción con plazos críticos.",
    logisticsModeSeaTitle: "Flete marítimo",
    logisticsModeSeaBody:
      "La opción más económica para pedidos grandes y planificados enviados en contenedor.",
    logisticsModeRoadTitle: "Carretera y ferrocarril",
    logisticsModeRoadBody:
      "Distribución regional y entrega posterior una vez que la mercancía llega a su mercado.",
    logisticsModeCourierTitle: "Courier exprés",
    logisticsModeCourierBody:
      "Entrega rápida puerta a puerta de muestras de evaluación antes de un proyecto o pedido en volumen.",
    logisticsB2bNoteTitle: "Solo envíos empresariales",
    logisticsB2bNoteBody:
      "Los pedidos de producción van a operadores, distribuidores, almacenes o socios logísticos. No hacemos dropshipping a suscriptores. El courier exprés se reserva para muestras de evaluación.",
    logisticsHandleEyebrow: "Nos encargamos por usted",
    logisticsHandleTitle: "Más que mover boxes",
    logisticsHandleBody:
      "Nos ocupamos de los detalles que frenan a los operadores, para que el hardware llegue listo para desplegar.",
    logisticsHandleItem1: "Embalaje con la marca del operador, listo para el retail",
    logisticsHandleItem2: "Envíos a granel, paletizados y en contenedor",
    logisticsHandleItem3: "Documentación de exportación, aduana y cumplimiento normativo",
    logisticsHandleItem4: "Despliegues escalonados, región por región",
    logisticsHandleItem5: "Coordinación con sus distribuidores y 3PL",
    logisticsHandleItem6: "Entrega exprés de muestras para evaluación técnica y comercial",
    logisticsHandleItem7:
      "Manifiestos de números de serie y MAC por dispositivo, listos para el aprovisionamiento",
    logisticsHandleItem8: "Firmware pregrabado y configuración por lote",
    logisticsHandleItem9: "Incoterms flexibles — EXW, FOB o DAP según su equipo",
    logisticsHandleFootnote:
      "Un solo coordinador se encarga de cada envío, desde la línea de producción hasta su muelle.",
    logisticsLinksEyebrow: "Siga explorando",
    logisticsLinksTitle: "Planifique el resto de su despliegue",
    logisticsLinkCta: "Más información",
    logisticsLinkDistributorsTitle: "Encontrar un distribuidor",
    logisticsLinkDistributorsBody:
      "Trabaje con un socio autorizado de inext que ya opera en su región.",
    logisticsLinkCustomizationTitle: "Marca y embalaje",
    logisticsLinkCustomizationBody:
      "Envíe hardware bajo su propia marca, desde el firmware hasta la caja de retail.",
    logisticsLinkProductsTitle: "Explorar el hardware",
    logisticsLinkProductsBody:
      "Compare la gama de Set-Top Boxes de inext y elija el modelo adecuado.",
    logisticsLinkAboutTitle: "Acerca de inext",
    logisticsLinkAboutBody: "El equipo detrás del hardware, enviando a operadores desde 2011.",
    logisticsFaqEyebrow: "FAQ",
    logisticsFaqTitle: "Entrega y logística, resueltas",
    logisticsFaqQ1: "¿A qué países realizan entregas?",
    logisticsFaqA1:
      "Enviamos a todo el mundo. El hardware de inext ya está desplegado por operadores en más de 15 países, y nuestros socios logísticos pueden llegar a prácticamente cualquier mercado, ya sea directamente o a través de un distribuidor local.",
    logisticsFaqQ2: "¿Dónde se fabrican los productos de inext?",
    logisticsFaqA2:
      "Nuestros Set-Top Boxes se fabrican con socios de manufactura y suministro en Shenzhen y Guangzhou (China) y Taiwán — regiones electrónicas consolidadas con cadenas de suministro maduras y confiables.",
    logisticsFaqQ3: "¿Quién se encarga del envío y la aduana?",
    logisticsFaqA3:
      "Coordinamos todo el trayecto a través de nuestra red de socios logísticos y preparamos la documentación de exportación y despacho aduanero, para que tenga un único punto de contacto en lugar de lidiar con varias agencias de carga.",
    logisticsFaqQ4: "¿Pueden enviar bajo nuestra propia marca?",
    logisticsFaqA4:
      "Sí. Los dispositivos pueden llegar a su almacén o socio de distribución en embalaje totalmente de marca y listo para el retail. Consulte nuestras opciones de personalización de firmware, carcasa y embalaje.",
    logisticsFaqQ5: "¿Qué métodos de envío y plazos de entrega hay disponibles?",
    logisticsFaqA5:
      "Los pedidos de producción pueden viajar por aire, mar, carretera o ferrocarril. El courier exprés se usa para muestras de evaluación, no para dropshipping al consumidor. Los plazos de entrega dependen del volumen, la personalización y el destino — confirmamos un cronograma realista con cada cotización.",
    logisticsFaqQ6: "¿Hay una cantidad mínima de pedido?",
    logisticsFaqA6:
      "Los tamaños de pedido se acuerdan por proyecto. Trabajamos con operadores de distintas escalas, desde los primeros lotes piloto hasta pedidos recurrentes en volumen — cuéntenos qué necesita.",
    logisticsFinalEyebrow: "Pongamos su hardware en movimiento",
    logisticsFinalTitle: "Planifique su entrega a todo el mundo",
    logisticsFinalBody:
      "Díganos a dónde deben llegar sus dispositivos y con qué rapidez. Armaremos un plan de entrega — manufactura, embalaje, flete y aduana — y un único equipo para ejecutarlo.",
    logisticsFinalCta: "Hable con nuestro equipo",
    logisticsFinalCtaSecondary: "Encontrar un distribuidor",
    productsIndexEyebrow: "Hardware",
    productsIndexTitle: "La gama de productos de inext",
    productsIndexSubtitle:
      "Set-Top Boxes 4K con Android TV creados para operadores — más los accesorios oficiales y las herramientas que completan cada despliegue.",
    productsIndexMoreHeading: "Explorar más",
    productsIndexArchiveDesc: "Especificaciones y fotos de modelos de inext descontinuados.",
    productsIndexCardCta: "Más información",
    productsIndexSeoTitle: "Productos — Set-Top Boxes con Android TV y accesorios | inext",
    productsIndexSeoDescription:
      "Explore la gama completa de productos de inext: Set-Top Boxes 4K con Android TV, accesorios oficiales, una comparación lado a lado y el archivo de modelos anteriores.",
    solutionsIndexEyebrow: "Plataforma y servicios",
    solutionsIndexTitle: "Soluciones para cada etapa de su servicio de TV",
    solutionsIndexSubtitle:
      "Desde la gestión de dispositivos y el firmware hasta las apps que los suscriptores usan a diario — el software y los servicios que hacen funcionar una flota de inext.",
    solutionsIndexCardCta: "Más información",
    solutionsIndexFlagship: "Producto insignia",
    solutionsIndexSeoTitle: "Soluciones — gestión de dispositivos, OTA, app IPTV y más | inext",
    solutionsIndexSeoDescription:
      "Explore las soluciones de inext: gestión de dispositivos Alcatraz, gestión de actualizaciones OTA, la aplicación IPTV, la app inext Remote, personalización y logística global.",
    verimatrixNote:
      "Socio certificado de Verimatrix — nuestros Set-Top Boxes y la app IPTV se integran de forma nativa con el acceso condicional Verimatrix VCAS y multi-DRM.",
    solutionsRow1Title: "Gestione toda su flota desde un solo lugar",
    solutionsRow1Body:
      "Alcatraz analiza la telemetría, organiza los problemas detectados en una cola priorizada de Fleet Health, registra el historial de actividad de los dispositivos y admite la distribución controlada de firmware y los diagnósticos remotos.",
    solutionsRow2Title: "La pantalla donde viven sus suscriptores",
    solutionsRow2Body:
      "Una app IPTV de marca y un control remoto móvil gratuito convierten un box de inext en una experiencia de TV que los suscriptores realmente disfrutan.",
    solutionsRow3Title: "Su marca, creada y entregada",
    solutionsRow3Body:
      "Hardware y firmware de marca blanca hechos a su especificación, y luego enviados a todo el mundo — usted lanza, nosotros nos encargamos del resto.",
    solutionsAllTitle: "Todas las soluciones, una sola plataforma",
    navGuides: "Guías",
    footerGuides: "Guías",
    footerLinkGuidesAndroidLinux: "Android vs Linux",
    guidesBreadcrumbHome: "Inicio",
    guidesIndexEyebrow: "Guías",
    guidesIndexTitle: "Guías para las decisiones detrás de su plataforma de TV",
    guidesIndexSubtitle:
      "Guías honestas y prácticas sobre las opciones que los operadores enfrentan de verdad — hardware, sistema operativo, propiedad de los equipos, financiamiento y método de distribución. Nosotros entregamos todo el stack, así que estas no son argumentos de venta.",
    guidesIndexAllTitle: "Todas las guías",
    guidesIndexCardCta: "Leer guía",
    guidesIndexSeoTitle: "Guías — elegir y operar su plataforma de TV | inext",
    guidesIndexSeoDescription:
      "Guías prácticas y neutrales para operadores de IPTV y OTT — opciones de plataforma, despliegue y las decisiones detrás de operar una flota de Set-Top Boxes.",
    tcoCardTitle: "Calculadora de TCO de Set-Top Boxes",
    tcoCardDesc:
      "Compare el costo total de dos escenarios de despliegue de Set-Top Boxes, con la compra de hardware, los reemplazos, el soporte, las visitas técnicas y la gestión de la flota.",
    tcoCardCta: "Abrir calculadora",
    tcoSeoTitle: "Calculadora de TCO de Set-Top Boxes — compare costos | inext",
    tcoSeoDescription:
      "Calcule y compare el costo total de propiedad de dos escenarios de despliegue de Set-Top Boxes para IPTV u OTT, incluyendo la compra de hardware, los reemplazos, el soporte, el servicio en campo y la gestión de dispositivos.",
    tcoBreadcrumbPage: "Calculadora de TCO de Set-Top Boxes",
    tcoHeroEyebrow: "Herramienta interactiva de planificación",
    tcoHeroTitle: "Calculadora de costo total de propiedad para Set-Top Boxes",
    tcoHeroBody:
      "Compare dos escenarios de despliegue de Set-Top Boxes durante toda su vida útil. Evalúe cómo el precio de compra, las fallas de hardware, el soporte a suscriptores, las visitas técnicas y la gestión de dispositivos afectan el costo real por equipo.",
    tcoExampleNotice:
      "Los valores precargados son solo ejemplos; no representan una cotización ni una garantía de ahorro. Sustitúyalos por datos reales de la operación y valores de las propuestas de proveedores.",
    tcoInputsEyebrow: "Datos de entrada",
    tcoInputsTitle: "Cree dos escenarios para comparar",
    tcoInputsBody:
      "Indique el tamaño de la flota, la vida útil y la moneda comunes a ambos escenarios. Luego defina los costos y supuestos operativos de cada uno.",
    tcoReset: "Restaurar ejemplo",
    tcoFleetSize: "Dispositivos en la flota",
    tcoOwnershipPeriod: "Vida útil, años",
    tcoCurrency: "Moneda del cálculo",
    tcoScenarioLabel: "Escenario de despliegue",
    tcoScenarioA: "Escenario A",
    tcoScenarioB: "Escenario B",
    tcoFieldUnitPrice: "Precio de compra por dispositivo",
    tcoFieldLogistics: "Costo de logística por dispositivo",
    tcoFieldSetup: "Costo único de configuración y personalización",
    tcoFieldFailureRate: "Tasa anual de fallas, %",
    tcoFieldReplacement: "Costo por reemplazo",
    tcoFieldSupportContacts: "Solicitudes de soporte por cada 1000 dispositivos al año",
    tcoFieldSupportCost: "Costo por solicitud de soporte",
    tcoFieldTruckRolls: "Visitas técnicas por cada 1000 dispositivos al año",
    tcoFieldTruckRollCost: "Costo por visita técnica",
    tcoFieldDmsCost: "Gestión por dispositivo al mes",
    tcoDmsIncludedNote:
      "Gestión de dispositivos: Alcatraz Pro está incluido sin costo adicional mientras la flota tenga menos de 500 dispositivos inext activos. Para flotas con 500 dispositivos activos o más, contacte a inext para analizar las condiciones comerciales.",
    tcoResultsEyebrow: "Comparación",
    tcoResultsTitle: "Costo total estimado durante la vida útil",
    tcoLowerResult: "{scenario}: {amount} menos ({percent}%)",
    tcoEqualResult: "Ambos escenarios tienen el mismo TCO estimado",
    tcoComparisonNote:
      "La estimación se basa en los datos anteriores. En flotas grandes, los costos operativos pueden tener mayor impacto que una pequeña diferencia en el precio de compra.",
    tcoTotalLabel: "Costo total en el período seleccionado",
    tcoPerDevice: "Costo por dispositivo",
    tcoPerDeviceMonth: "Costo mensual por dispositivo",
    tcoCostProcurement: "Compra de hardware",
    tcoCostLogistics: "Logística",
    tcoCostSetup: "Configuración y personalización",
    tcoCostReplacements: "Reemplazo de hardware",
    tcoCostSupport: "Soporte a suscriptores",
    tcoCostFieldService: "Servicio en campo",
    tcoCostManagement: "Gestión de dispositivos",
    tcoMethodEyebrow: "Modelo de cálculo",
    tcoMethodTitle: "Qué considera el cálculo de TCO",
    tcoMethodBody:
      "El costo total de propiedad incluye no solo la compra inicial, sino también los costos operativos posteriores. El modelo es deliberadamente transparente para que cada supuesto pueda sustituirse por datos reales de la operación.",
    tcoMethod1Title: "Despliegue inicial",
    tcoMethod1Body:
      "Los costos de los dispositivos y la logística se calculan para toda la flota. La configuración y la personalización se contabilizan una sola vez.",
    tcoMethod2Title: "Costos durante la vida útil",
    tcoMethod2Body:
      "Las fallas, las solicitudes de soporte, las visitas técnicas y los costos mensuales de gestión se proyectan durante toda la vida útil seleccionada.",
    tcoMethod3Title: "Costos comparables por dispositivo",
    tcoMethod3Body:
      "El total se presenta como costo por dispositivo y costo mensual por dispositivo, lo que facilita comparar escenarios con precios de compra diferentes.",
    tcoCtaTitle: "Valide el cálculo con hardware real",
    tcoCtaBody:
      "La calculadora ayuda a reducir la lista de opciones. Un despliegue piloto permite comprobar la estabilidad de los dispositivos, los flujos de soporte, el diagnóstico remoto y los costos operativos reales.",
    tcoCtaButton: "Hablar sobre el despliegue",
    footerLinkGuidesTco: "Calculadora de TCO de Set-Top Boxes",
    guidesCardAvlTitle: "Android vs Linux en STB",
    guidesCardAvlDesc:
      "¿Qué plataforma se adapta a su red? Una comparación honesta — ecosistema de apps, costo, control y cuándo gana cada una.",
    avlSeoTitle: "Android vs Linux en STB: cómo elegir | inext",
    avlSeoDescription:
      "¿Android TV o Linux para su flota de Set-Top Boxes? Una comparación honesta y neutral de inext — enviamos ambos. Ecosistema de apps, costo, control y cuándo gana cada uno.",
    avlBreadcrumbPage: "Android vs Linux en STB",
    avlHeroEyebrow: "Guía de plataforma",
    avlHeroTitle: "Android vs Linux en STB:",
    avlHeroTitleAccent: "¿qué plataforma se adapta a su red?",
    avlHeroSub:
      "La mayoría de las guías de ‘Android vs Linux' las escribe un proveedor que solo vende una de ellas — así que en realidad son un argumento de venta disfrazado. Nosotros no estamos en esa posición: cada Set-Top Box de inext puede enviarse con Android o con una compilación ligera de Linux, así que genuinamente no nos importa cuál elija. Esta es la versión honesta.",
    avlHeroNote: "Enviamos ambos — así que esta comparación no tiene la balanza inclinada.",
    avlHeroCtaPrimary: "Hable con nuestro equipo",
    avlHeroCtaSecondary: "Ver la comparación",
    avlDefineEyebrow: "Empiece aquí",
    avlDefineTitle: "Primero, qué queremos decir realmente",
    avlDefineBody:
      "Ambos corren sobre el mismo silicio, así que es fácil confundirlos. Para esta comparación, manténgalos separados como dos productos:",
    avlDefineAndroidLabel: "Android",
    avlDefineAndroidBody:
      "la plataforma Android TV — ejecuta el ecosistema de apps de Android detrás de un launcher que puede personalizar con su marca, así los suscriptores obtienen las apps y los patrones que ya conocen.",
    avlDefineLinuxLabel: "Linux",
    avlDefineLinuxBody:
      "una compilación ligera y hecha a medida que contiene solo su app IPTV, su middleware y las herramientas que ponga ahí — sin tienda de apps, sin capa de Android.",
    avlDefineCandid:
      "La parte franca de entrada: alrededor del 95 % de los operadores con los que trabajamos eligen Android — aunque en algunas regiones Linux es notablemente más común. Explicaremos exactamente por qué, y cuándo Linux es la decisión más inteligente.",
    avlVerdictEyebrow: "El veredicto rápido",
    avlVerdictTitle: "Dos columnas — encuéntrese en una",
    avlVerdictAndroidTitle: "Elija Android si…",
    avlVerdictAndroid1:
      "Quiere el ecosistema de apps de Android — las apps de streaming y OTT populares que sus suscriptores ya conocen",
    avlVerdictAndroid2:
      "Quiere una experiencia de TV familiar y de nivel consumidor con un mínimo de trabajo de interfaz personalizada",
    avlVerdictAndroid3: "Necesita lanzar rápido y mantener abiertas las opciones de apps a futuro",
    avlVerdictAndroid4:
      "Un catálogo de apps amplio y familiar y una experiencia de nivel consumidor son importantes para su oferta",
    avlVerdictLinuxTitle: "Elija Linux si…",
    avlVerdictLinux1:
      "Opera un servicio de IPTV puro y gestionado — su propia app, su jardín amurallado, nada más",
    avlVerdictLinux2: "Quiere la menor huella y el menor costo operativo sobre el mismo hardware",
    avlVerdictLinux3: "Necesita el máximo control y bloqueo, sin tienda de apps en el dispositivo",
    avlVerdictLinux4: "Las apps OTT de terceros no forman parte de lo que vende",
    avlVerdictFootnote:
      "¿Claramente en la columna de Android? Está con el 95 % — esa es la opción segura por defecto. Si la columna de Linux le describe, siga leyendo.",
    avlCoreEyebrow: "La diferencia central",
    avlCoreTitle: "Ecosistema de apps vs. ligereza y control",
    avlCoreBody1:
      "Quite el detalle y la elección es un solo trade-off: ecosistema de apps y familiaridad frente a ligereza y control.",
    avlCoreBody2:
      "Android le da el mundo de consumo que sus suscriptores ya conocen: ejecuta el ecosistema de apps de Android — su propia app más las apps de streaming y OTT populares — detrás de un launcher que puede personalizar con su marca, con todo el catálogo de apps de Android abierto para usted. Ese alcance es la razón por la que casi todos los operadores lo eligen.",
    avlCoreBody3:
      "Linux le da las virtudes opuestas: un dispositivo reducido que hace exactamente lo que le indica y nada más. Sin tienda de apps, sin capa de Google, sin ecosistema de consumo — solo su app IPTV y las herramientas que aprobó. Eso lo hace más ligero, más barato de operar, más fácil de bloquear y totalmente suyo.",
    avlCoreBody4:
      "El detalle que decide la mayoría de los casos: las grandes apps OTT están creadas como apps de Android. Un box Linux no puede ejecutarlas en absoluto — poner ahí una app de terceros es un esfuerzo a medida, app por app, que suele ser poco práctico. Así que si sus suscriptores esperan esas apps, Linux se descarta por sí solo. Si no las esperan, sus ventajas son reales.",
    avlTableEyebrow: "Lado a lado",
    avlTableTitle: "Android vs Linux, fila por fila",
    avlTableColDimension: "",
    avlTableColAndroid: "Android",
    avlTableColLinux: "Linux",
    avlRow1Dim: "Ecosistema de apps OTT (Netflix, YouTube, Disney+)",
    avlRow1Android: "Ejecuta el ecosistema de apps de Android — su app más las apps OTT",
    avlRow1Linux: "Sin apps de Android — solo el cliente que construya",
    avlRow2Dim: "Familiaridad de la UX de consumo",
    avlRow2Android: "Experiencia Android TV familiar",
    avlRow2Linux: "Totalmente personalizada — lo que usted diseñe",
    avlRow3Dim: "Marca y personalización",
    avlRow3Android: "Launcher de marca, personalización profunda",
    avlRow3Linux: "Control total sobre cada píxel y comportamiento",
    avlRow4Dim: "Bloqueo de jardín amurallado",
    avlRow4Android: "Posible, requiere configuración",
    avlRow4Linux: "Nativo — no hay tienda de apps que bloquear",
    avlRow5Dim: "Huella en el mismo box",
    avlRow5Android: "Requiere más margen de RAM/almacenamiento",
    avlRow5Linux: "Corre más ligero; le permite especificar un box de gama inferior",
    avlRow6Dim: "Tiempo de arranque y uso de recursos",
    avlRow6Android: "Más pesado",
    avlRow6Linux: "Más ligero, arranque más rápido",
    avlRow7Dim: "Actualizaciones de plataforma y seguridad",
    avlRow7Android: "Base de la plataforma Android más su OTA",
    avlRow7Linux: "Totalmente gestionado por el operador/inext vía OTA",
    avlRow9Dim: "DRM / protección de contenido",
    avlRow9Android: "Widevine y Verimatrix",
    avlRow9Linux: "Widevine y Verimatrix",
    avlRow10Dim: "Velocidad de desarrollo y talento",
    avlRow10Android: "Ecosistema amplio, rápido",
    avlRow10Linux: "Trabajo especializado, más a medida",
    avlRow12Dim: "Ciclo de vida e independencia",
    avlRow12Android: "Avanza al ritmo de la plataforma de Google",
    avlRow12Linux: "Sin dependencia externa — usted controla la longevidad",
    avlRowAppDim: "App cliente de inext",
    avlRowAppAndroid: "App IPTV y launcher listos para usar — ambos con su marca",
    avlRowAppLinux: "SDK y API para construir e integrar rápido",
    avlRowInextDim: "Gestionado por el stack de inext",
    avlStackLabel: "Igual en ambos:",
    avlStackAlcatraz: "Alcatraz DMS",
    avlStackOta: "OTA",
    avlStackTr069: "TR-069",
    avlStackCustomization: "personalización",
    avlTableNote:
      "El DRM y las especificaciones exactas de la plataforma dependen del box y la compilación — cuéntenos qué necesita su despliegue y lo confirmaremos.",
    avlDecideEyebrow: "Qué lo decide de verdad",
    avlDecideTitle: "Las preguntas que resuelven la mayoría de las decisiones",
    avlDecide1Title: "El ecosistema de apps",
    avlDecide1Body:
      "Esta es la mayor razón por la que Android gana. Las apps OTT populares — Netflix, YouTube, Disney+, Prime — están creadas como apps de Android y corren sobre el ecosistema de apps de Android. Un box Linux no puede ejecutarlas en absoluto; agregar una app de terceros ahí es una integración a medida que, para la mayoría de los operadores, no vale la pena. Si la primera pregunta de un suscriptor es ‘¿tiene Netflix?', Android es su respuesta. Si entrega un bouquet de IPTV cerrado y las apps OTT no forman parte del trato, esta desventaja simplemente no le aplica.",
    avlDecide2Title: "Costo y huella",
    avlDecide2Body:
      "Como los boxes son idénticos, Linux no abarata el hardware por sí solo — le permite hacer más con menos. Una compilación ligera de Linux tiene menores demandas de RAM y almacenamiento, así que para un despliegue de IPTV puro puede especificar un box de gama inferior como el inext TV5 y aun así tener una experiencia ágil, donde el mismo rol en Android requiere más margen. A escala de flota, ese margen es dinero real.",
    avlDecide3Title: "Control, seguridad y bloqueo",
    avlDecide3Body:
      "Linux es la elección natural cuando ‘el dispositivo debe hacer exactamente esto y nada más' es un requisito estricto. Sin tienda de apps, sin superficie para instalar apps por fuera, una menor superficie de ataque y una compilación que contiene solo lo que aprobó. Android también se puede bloquear, pero eso es configuración que mantiene contra una plataforma más grande y en constante evolución. Para despliegues tipo kiosco, regulados o estrictamente gestionados, la simplicidad de Linux es la característica.",
    avlDecide4Title: "Tiempo de salida al mercado",
    avlDecide4Body:
      "Android pone en marcha un producto de estilo consumidor más rápido — el launcher, las apps y los patrones de UX ya existen y solo necesitan su marca. Linux implica construir o portar más de la experiencia por su cuenta, que es justo el objetivo cuando quiere control total, pero es más trabajo inicial. Nosotros acortamos ambos caminos: en Android con nuestra app IPTV lista para usar y nuestro servicio de personalización, en Linux con un SDK y una API que aceleran su construcción e integración.",
    avlDecide5Title: "Ciclo de vida e independencia",
    avlDecide5Body:
      "Android avanza al ritmo de la plataforma de Google — nuevas versiones y compatibilidad de apps. Eso es en su mayoría un beneficio, pero es una dependencia externa. Una compilación de Linux no tiene esa atadura: es suya, congelada o evolucionada según su calendario, en el roadmap de nadie más que el suyo. Para despliegues de muy larga vida, o mercados donde quiere cero dependencia externa, eso importa.",
    avlProfilesEyebrow: "¿Cuál es la adecuada para usted?",
    avlProfilesTitle: "Haga coincidir su servicio con una plataforma",
    avlProfile1Title: "Operador de IPTV + OTT",
    avlProfile1Pick: "Android",
    avlProfile1Body:
      "Los suscriptores quieren sus canales y las grandes apps de streaming. Este es el caso común — el ~95 %.",
    avlProfile2Title: "IPTV puro y gestionado / jardín amurallado",
    avlProfile2Pick: "Linux",
    avlProfile2Body: "Solo su app, sin OTT de terceros. Vale la pena considerarlo seriamente.",
    avlProfile3Title: "Despliegue de alto volumen orientado al costo",
    avlProfile3Pick: "Linux",
    avlProfile3Body:
      "Cuando la oferta es su propio bouquet, Linux en un box de gama inferior estira el presupuesto.",
    avlProfile4Title: "Estrictamente controlado / kiosco / regulado",
    avlProfile4Pick: "Linux",
    avlProfile4Body:
      "Cuando el bloqueo es un requisito estricto, la plataforma más ligera es más fácil de asegurar.",
    avlProfile5Title: "No está seguro / mantener opciones abiertas",
    avlProfile5Pick: "Android",
    avlProfile5Body:
      "La opción segura por defecto que mantiene abiertas la mayor cantidad de puertas.",
    avlSameEyebrow: "Cualquiera que elija",
    avlSameTitle: "El resto del stack es el mismo",
    avlSameBody:
      "Cada box de inext — Android o Linux — corre sobre el mismo stack operativo: Alcatraz DMS para el control de la flota, actualizaciones OTA escalonadas, TR-069 y nuestra personalización de marca blanca. El software cliente es la única parte que difiere — en Android puede enviar nuestra app IPTV lista para usar y un launcher de marca, ambos suyos; en Linux le damos un SDK y una API para construir e integrar rápido. En cualquier caso, conserva las herramientas que hacen funcionar la flota.",
    avlLockTitle: "El mismo hardware — así que decida con intención, no con nerviosismo",
    avlLockBody:
      "Android o Linux es una elección de firmware sobre el mismísimo box, no un producto distinto. Puede evaluar ambos antes de comprometerse, o operar una flota mixta. Cambiar un box de plataforma más adelante es posible, pero es una regrabación en lugar de una actualización OTA de rutina — así que lo mejor es elegir la plataforma en la que piensa quedarse y comprometerse con ella. La decisión de hardware es de bajo riesgo; la decisión de plataforma vale la pena tomarla con cuidado.",
    avlFaqEyebrow: "FAQ",
    avlFaqTitle: "Preguntas comunes",
    avlFaqQ1: "¿Puedo ejecutar Netflix en un STB con Linux?",
    avlFaqA1:
      "Por lo general, no. Netflix, YouTube y Disney+ están creadas como apps de Android; un box Linux no puede ejecutarlas, y agregar una app de terceros es una integración a medida, a menudo poco práctica. Si esas apps son importantes para su oferta, elija Android.",
    avlFaqQ2: "¿Es Android más caro que Linux?",
    avlFaqA2:
      "El hardware es el mismo box de inext, así que la plataforma no es un costo por partida. Android requiere un poco más de margen de RAM y almacenamiento, así que para un rol de IPTV puro Linux puede permitirle especificar un box de gama inferior.",
    avlFaqQ3: "¿Puedo cambiar de Linux a Android más adelante, o al revés?",
    avlFaqA3:
      "Es posible, pero no es una actualización OTA de rutina — mover un box entre Android y Linux implica regrabar el firmware, lo cual es más complejo. Es el mismo hardware en cualquier caso, así que no compra dispositivos distintos, pero recomendamos comprometerse con la plataforma en la que piensa quedarse.",
    avlFaqQ4: "¿Cuál eligen la mayoría de los operadores?",
    avlFaqA4:
      "Alrededor del 95 % elige Android, porque sus suscriptores esperan las apps OTT populares — aunque en algunas regiones Linux es notablemente más común. Linux gana para despliegues de IPTV puro y gestionado, de bloqueo estricto y de menor huella.",
    avlFaqQ5: "¿La gestión de dispositivos de inext funciona en ambos?",
    avlFaqA5:
      "Sí — Alcatraz DMS, las actualizaciones OTA y TR-069 funcionan igual en las compilaciones de Android y de Linux.",
    avlCtaEyebrow: "Hable con nosotros",
    avlCtaTitle: "¿No está seguro de cuál se adapta a su despliegue?",
    avlCtaBody:
      "Cuéntenos sobre su servicio y le recomendaremos una plataforma con honestidad — incluso cuando esa sea Linux.",
    avlCtaPrimary: "Hable con nuestro equipo",
    avlCtaSecondary: "Solicitar una compilación de firmware Linux",
    footerLinkGuidesAospCert: "AOSP vs certificado",
    guidesCardAcTitle: "AOSP vs Android TV certificado",
    guidesCardAcDesc:
      "¿Cuál necesita realmente su lanzamiento? El ecosistema de apps certificado vs. velocidad, costo y control — y cómo entregamos ambos.",
    acSeoTitle: "AOSP vs Android TV certificado: ¿cuál necesita su lanzamiento? | inext",
    acSeoDescription:
      "¿AOSP o Android TV certificado por Google para su despliegue de operador? Una comparación honesta de inext — entregamos ambos. Ecosistema de apps, costo, tiempo de salida al mercado y cuándo vale la pena la certificación.",
    acBreadcrumbPage: "AOSP vs Android TV certificado",
    acHeroEyebrow: "Guía de plataforma",
    acHeroTitle: "AOSP vs Android TV certificado:",
    acHeroTitleAccent: "¿cuál necesita realmente su lanzamiento?",
    acHeroSub:
      "Ambos son Android — lo que los separa es la certificación de Google, y el tiempo, el costo y el control que intercambia por ella. Nosotros mismos construimos AOSP, así que no fingiremos ser neutrales: para la mayoría de los operadores es la opción más rápida, más barata y más flexible, y esa es nuestra recomendación honesta — y cuando un proyecto realmente necesita certificación, también la entregamos, con nuestros socios 3PL certificados. Esta página presenta el trade-off para que pueda identificar cuál necesita su lanzamiento.",
    acHeroNote:
      "La mayoría de los operadores envían AOSP. Cuando un proyecto realmente necesita certificación, también la entregamos.",
    acHeroCtaPrimary: "Hable con nuestro equipo",
    acHeroCtaSecondary: "Ver la comparación",
    acDefineEyebrow: "Empiece aquí",
    acDefineTitle: "Primero, qué cambia realmente ‘certificado’",
    acDefineBody:
      "Ambos usan Android. La diferencia entre ellos es el programa de certificación de Google — y todo lo que depende de él:",
    acDefineAospLabel: "AOSP",
    acDefineAospBody:
      "Android de código abierto, totalmente suyo — su launcher, sus apps, sus reglas. Sin la tienda Google Play ni barrera de certificación, pero con Widevine L1 y L3 a bordo, así que con sus acuerdos de operador igual ejecuta apps premium como Netflix. Mucho más rápido y económico de lanzar.",
    acDefineCertLabel: "Android TV certificado",
    acDefineCertBody:
      "Certificado por Google, con Google Play, Widevine L1, Google Assistant y Chromecast integrados — la base del ecosistema de apps certificado — a cambio de las licencias, la aprobación y los plazos de Google.",
    acStat1: "1–2 semanas para una muestra funcional",
    acStat2: "Sin tarifas de Google por dispositivo en AOSP",
    acStat3: "Ambas plataformas, un solo socio",
    acPivotEyebrow: "Empiece aquí",
    acPivotTitle: "Por lo general todo se reduce a una pregunta",
    acPivotQuestion:
      "¿Sus suscriptores necesitan la tienda abierta Google Play — un catálogo de autoservicio con miles de apps — más Google Assistant y Chromecast?",
    acPivotNoLabel: "No — una experiencia curada y controlada por el operador",
    acPivotNoPick: "AOSP",
    acPivotNoText:
      "Lidera con su propio servicio y una selección elegida — incluidos Netflix y otras apps premium donde tiene el acuerdo de operador. Más rápido, más económico, totalmente suyo.",
    acPivotYesLabel: "Sí — la tienda de apps abierta para el consumidor",
    acPivotYesPick: "Certificado",
    acPivotYesText:
      "Quiere la Play Store completa de autoservicio y los servicios de Google como parte del producto. Vale la pena la licencia y el plazo más largo.",
    acPivotFootnote:
      "La mayoría de los operadores responde ‘no' y lanza con AOSP. Como sea que se incline, nosotros lo entregamos.",
    acTimelineEyebrow: "Tiempo de salida al mercado",
    acTimelineTitle: "Dos caminos hacia el lanzamiento",
    acTimelineIntro:
      "La mayor diferencia práctica no es la tecnología — es cuánto tarda en salir en vivo y cuánto cuesta llegar ahí.",
    acTimelineAospLabel: "AOSP con inext",
    acTimelineAospResult: "~2 meses hasta el envío",
    acTimelineAospStep1: "Personalice el launcher, la app y los servicios con su marca",
    acTimelineAospStep2: "Confirme una muestra funcional — alrededor de 1–2 semanas después",
    acTimelineAospStep3: "Despliegue",
    acTimelineCertLabel: "Android TV certificado",
    acTimelineCertResult: "5–8 meses hasta el envío",
    acTimelineCertStep1: "Licencie GMS, especifique hardware aprobado por Google",
    acTimelineCertStep2: "Desarrolle e integre",
    acTimelineCertStep3: "Pruebas de certificación",
    acTimelineCertStep4: "Aprobación de Google",
    acTimelineCertStep5: "Despliegue",
    acTimelineNote:
      "Ya construimos la plataforma AOSP, así que su habitual desventaja de ‘lenta de construir' desapareció. ¿Necesita certificación? También manejamos esa vía, con nuestros socios 3PL certificados.",
    acIncludesEyebrow: "Lo que obtiene",
    acIncludesTitle: "Nuestro AOSP no es una caja en blanco — es una plataforma lista para lanzar",
    acIncludesBody:
      "Todo lo de abajo ya está construido, probado y personalizado con su marca. La selección exacta de apps se adapta a su país y licenciamiento, por eso no se detalla aquí.",
    acIncludes1:
      "Un launcher personalizable de nivel operador — su marca y su contenido primero al arrancar",
    acIncludes2: "Nuestra app de IPTV, con su marca",
    acIncludes3:
      "Los servicios locales de TV y streaming de su mercado precargados — más apps premium como Netflix donde tiene el acuerdo",
    acIncludes4: "Gestionado con Alcatraz DMS, OTA y TR-069 desde el primer día",
    acIncludes5: "Personalizado y confirmado con una muestra funcional en 1–2 semanas",
    acTableEyebrow: "La comparación completa",
    acTableTitle: "En qué se diferencian realmente AOSP y Certificado",
    acTableColDimension: "",
    acTableColAosp: "AOSP",
    acTableColCert: "Android TV certificado",
    acRow1Dim: "Tienda Google Play",
    acRow1Aosp: "Sin Play Store — su propia distribución de apps",
    acRow1Cert: "Integrada — miles de apps",
    acRow2Dim: "Apps premium (Netflix, Disney+ en HD/4K)",
    acRow2Aosp: "Funciona donde su red tiene el acuerdo de operador — nuestro AOSP es Widevine L1",
    acRow2Cert: "Igual, más distribución vía Google Play; el acuerdo de operador sigue aplicando",
    acRow3Dim: "Google Assistant y Chromecast",
    acRow3Aosp: "No incluido (o personalizado)",
    acRow3Cert: "Integrado",
    acRow4Dim: "Widevine DRM",
    acRow4Aosp: "Widevine L1 y L3 en los equipos inext",
    acRow4Cert: "Widevine L1 y L3",
    acRow5Dim: "Launcher / pantalla de inicio del operador",
    acRow5Aosp: "Totalmente personalizado, primero al arrancar — control total",
    acRow5Cert: "Launcher de nivel operador, dentro de las reglas de Google",
    acRow6Dim: "Apps preinstaladas y servicios locales",
    acRow6Aosp: "Exactamente lo que su mercado necesita — usted decide",
    acRow6Cert: "Modelo Google Play, más sus agregados",
    acRow7Dim: "Libertad de personalización",
    acRow7Aosp: "Total",
    acRow7Cert: "Dentro del programa de Google",
    acRow8Dim: "Hardware",
    acRow8Aosp: "Funciona en equipos livianos y optimizados en costo",
    acRow8Cert: "De mayor especificación, aprobado por Google",
    acRow9Dim: "Tiempo de salida al mercado",
    acRow9Aosp: "~2 meses hasta el envío (una muestra funcional en 1–2 semanas)",
    acRow9Cert: "Normalmente 5–8 meses hasta el envío",
    acRow10Dim: "Costo",
    acRow10Aosp: "Sin licencia GMS ni tarifas de Google por dispositivo",
    acRow10Cert: "Licencia GMS, tarifas por dispositivo, costos de laboratorio de pruebas",
    acRow11Dim: "Dependencia de Google",
    acRow11Aosp: "Ninguna",
    acRow11Cert: "Cumplimiento continuo con Google",
    acRow12Dim: "Facturación y pagos (vender a los suscriptores)",
    acRow12Aosp:
      "Cualquier pasarela de pago o socio — su propia facturación, sin comisión de plataforma",
    acRow12Cert:
      "Las ventas digitales deben usar la facturación de Google Play — Google cobra una tarifa",
    acRow13Dim: "Enviar una actualización de sistema/firmware",
    acRow13Aosp: "Constrúyala hoy, en toda la flota mañana — enteramente su decisión",
    acRow13Cert:
      "Cada cambio de sistema debe pasar por Google o un laboratorio 3PL antes de que pueda enviarlo",
    acTableNote:
      "Las apps premium como Netflix necesitan su propia certificación de dispositivo y, para un ISP que las agrupa, un acuerdo directo de operador — en cualquiera de las dos plataformas. La ventaja: nuestro AOSP es Widevine L1, así que con ese acuerdo Netflix funciona en él, sin necesidad de certificación de Google. Mapearemos lo que necesita cada app de su selección.",
    acSameEyebrow: "La que necesite",
    acSameTitle: "Ambas plataformas, un solo socio — y una respuesta directa sobre cuál necesita",
    acSameBody:
      "Seamos directos: AOSP es nuestro propio producto, así que es lo que construimos y lo que normalmente recomendaremos — porque para la mayoría de los operadores realmente es la mejor opción. Lo que no haremos es imponerlo cuando su proyecto necesita certificación, ni venderle una certificación que no necesita. Cuando sí la necesite, también entregamos Android TV totalmente certificado, trabajando con nuestros socios 3PL certificados en la certificación. Una sola relación, un solo stack de operaciones y una respuesta directa en lugar de un discurso de ventas por lo que más nos convenga.",
    acInhouseTitle: "AOSP — desarrollado internamente",
    acInhouseBody:
      "Un launcher de nivel operador probado y totalmente personalizable y nuestra app de IPTV, precargada con los servicios locales de TV y streaming de su mercado. Personalizado con su marca y confirmado con una muestra funcional en 1–2 semanas.",
    acPartnerTitle: "Android TV certificado — lo entregamos, con socios 3PL",
    acPartnerBody:
      "Cuando su oferta necesita Google Play, apps premium certificadas y Widevine L1, entregamos Android TV totalmente certificado — trabajando con nuestros socios 3PL certificados en la certificación, con inext como su único punto de contacto y un solo equipo responsable.",
    acSameNoteTitle: "Un solo stack maneja ambas",
    acSameNoteBody:
      "Sea cual sea la plataforma que elija, las mismas operaciones de inext manejan la flota — Alcatraz DMS, OTA por etapas, TR-069 y personalización de marca blanca. Elegir AOSP o certificado no cambia cómo opera en el día a día.",
    acFaqEyebrow: "FAQ",
    acFaqTitle: "Preguntas frecuentes",
    acFaqQ1: "¿Puedo ejecutar Netflix en el AOSP de inext?",
    acFaqA1:
      "Sí — donde su red tenga un acuerdo con Netflix. Nuestro AOSP admite Widevine L1, así que con ese acuerdo de operador ejecuta una app de Netflix funcional, sin necesidad de certificación de Google. Lo mismo aplica para otros servicios premium con los que tenga acuerdos: usted aporta el acuerdo, nosotros aportamos la plataforma lista para L1 y la integración.",
    acFaqQ2: "inext no es un proveedor de Android TV certificado — ¿aun así pueden entregarlo?",
    acFaqA2:
      "Sí. Construimos AOSP internamente, y también entregamos Android TV totalmente certificado — trabajando con socios 3PL certificados en la certificación en sí, con inext como contratista principal. Obtiene ambas opciones y un único punto de contacto, y nosotros manejamos la vía certificada para que no tenga que armarla por su cuenta.",
    acFaqQ3: "¿Qué tan rápido pueden entregar una solución AOSP?",
    acFaqA3:
      "Nuestra plataforma AOSP ya está construida y probada, así que personalizarla con su marca y hacerle llegar una muestra funcional normalmente toma 1–2 semanas. Desde el inicio del proyecto hasta el envío de la mercancía suele ser alrededor de 2 meses — frente a los 5–8 meses que normalmente necesita un STB Android TV certificado — aunque depende de sus integraciones, licenciamiento y pedido.",
    acFaqQ4: "¿Con qué viene el AOSP de inext?",
    acFaqA4:
      "Un launcher de nivel operador personalizable, nuestra app de IPTV y los servicios locales de TV y streaming de su mercado precargados. La selección exacta de apps depende de su país y del licenciamiento en su región, por eso la adaptamos por despliegue.",
    acFaqQ5: "¿Cuál eligen la mayoría de los operadores?",
    acFaqA5:
      "La mayoría elige AOSP — cubre lo que su servicio necesita, se lanza más rápido y cuesta menos, y aun así ejecuta apps premium como Netflix donde tienen el acuerdo de operador. La certificación es la opción correcta cuando quiere específicamente la tienda abierta de autoservicio Google Play y los servicios de Google — y también la entregamos.",
    acFaqQ6: "¿El stack de operaciones de inext funciona en ambas?",
    acFaqA6:
      "Sí — Alcatraz DMS, actualizaciones OTA y TR-069 gestionan su flota de la misma manera, ya sea AOSP o certificado.",
    acFaqQ7: "¿La certificación de Google significa que mis suscriptores tienen Netflix?",
    acFaqA7:
      "Por sí sola no — y de todos modos no la necesita para Netflix. Netflix certifica los dispositivos por sí mismo y quiere un acuerdo directo con los operadores que lo agrupan; con ese acuerdo, nuestro AOSP ejecuta Netflix sin certificación de Google, porque es Widevine L1. El verdadero valor de la certificación de Google es la tienda abierta de autoservicio Play Store y los propios servicios de Google (Assistant, Chromecast) — no las apps de renombre.",
    acFaqQ8: "Si vendo suscripciones o contenido, ¿quién maneja la facturación?",
    acFaqA8:
      "En AOSP, usted — a través de cualquier pasarela de pago o socio que elija, sin comisión de plataforma y sin Google de por medio. En Android TV certificado, los bienes digitales vendidos a través de una app distribuida por Play deben usar la facturación de Google Play, y Google se lleva una parte de cada transacción. Para los operadores que monetizan directamente a los suscriptores, eso se acumula rápido — es una de las razones más importantes por las que se quedan en AOSP.",
    acFaqQ9: "¿Quién controla las actualizaciones de firmware (OTA) en cada plataforma?",
    acFaqA9:
      "En AOSP, usted — podemos construir un nuevo firmware y enviarlo a toda su flota al día siguiente, sin aprobación externa. En Android TV certificado está restringido: el marco de certificación exige que cada cambio a nivel de sistema sea reverificado por Google o un laboratorio de pruebas 3PL designado antes de poder enviarlo — incluso bajo el nivel operador. Para los operadores que parchan, ajustan o iteran a menudo, esa es una diferencia práctica importante.",
    acCtaEyebrow: "Hable con nosotros",
    acCtaTitle: "¿No está seguro de si su lanzamiento necesita certificación?",
    acCtaBody:
      "Cuéntenos qué esperan sus suscriptores y qué tan rápido necesita salir en vivo. Recomendaremos la plataforma que encaja — AOSP o certificado — y la entregamos.",
    acCtaPrimary: "Hable con nuestro equipo",
    acCtaSecondary: "Solicitar una muestra AOSP",
    footerLinkGuidesOwnStb: "STB vs Smart TV",
    footerLinkGuidesBoxModels: "Subsidiar, arrendar o vender",
    footerLinkGuidesMulticastOtt: "Multicast vs OTT",
    footerLinkGuidesBuildBuy: "Construir vs comprar",
    footerLinkGuidesStbChecklist: "Checklist de compra de STB",
    guidesCardSbcTitle: "Checklist del comprador de STB",
    guidesCardSbcDesc:
      "Antes de comprar Set-Top Boxes, revise todo el stack: hardware, códecs, redes, DRM, apps, gestión de flota, marca, garantía y logística.",
    guidesCardOsTitle: "STBs propios vs Smart TVs",
    guidesCardOsDesc:
      "¿Enviar su propio equipo de marca o depender de las Smart TVs de los suscriptores? La respuesta honesta es ambos — pero el equipo es la parte que posee al 100%. El argumento del operador para enviarlo.",
    guidesCardBmTitle: "Subsidiar, arrendar o vender el equipo",
    guidesCardBmDesc:
      "¿Regalar el equipo, alquilarlo o venderlo directamente? Una decisión de financiamiento, no de hardware — los pros y contras de CapEx/OpEx y TCO, más el bloqueo por DMS que mantiene seguros el subsidio y el arrendamiento.",
    guidesCardMoTitle: "IPTV multicast vs streaming OTT",
    guidesCardMoDesc:
      "¿Un flujo eficiente hacia muchos en su red gestionada, o un flujo adaptativo por espectador a través de internet? Los pros y contras honestos en ancho de banda, calidad, latencia y alcance — y por qué muchos operadores usan ambos.",
    guidesCardBbTitle: "Construir vs comprar su STB",
    guidesCardBbDesc:
      "¿Construir su propia plataforma de Set-Top Box o comprar un stack llave en mano? “Construir” significa poseer ocho capas — del silicio al soporte. Un análisis honesto de hacer o comprar para operadores, y cuándo gana cada opción.",
    sbcSeoTitle: "Checklist del comprador de STB IPTV: cómo elegir Set-Top Boxes | inext",
    sbcSeoDescription:
      "Un checklist práctico del comprador de STB para ISPs, operadores de IPTV y OTT, telcos, proveedores de hospitalidad, MDUs y distribuidores que eligen Set-Top Boxes para servicios de TV gestionados.",
    sbcBreadcrumbPage: "Checklist del comprador de STB",
    sbcHeroEyebrow: "Checklist del comprador",
    sbcHeroTitle: "Checklist del comprador de STB:",
    sbcHeroTitleAccent: "qué verificar antes de elegir equipos",
    sbcHeroSub:
      "Un buen Set-Top Box no es solo un chipset y un precio. Es el hardware, el firmware, las apps, la protección de contenido, el control remoto, la gestión de flota, el soporte y la logística que mantienen funcionando un servicio de TV después de que llega el primer envío.",
    sbcHeroNote:
      "Use este checklist antes de la validación de muestra, la preselección de proveedores o un pedido a granel. Está escrito para ISPs, operadores de IPTV y OTT, telcos, proyectos de hospitalidad y MDU, y distribuidores que evalúan equipos para clientes operadores.",
    sbcHeroCtaPrimary: "Hable con nuestro equipo",
    sbcHeroCtaSecondary: "Abrir el checklist",
    sbcStat1: "Stack de hardware + software",
    sbcStat2: "Muestra antes del pedido a granel",
    sbcStat3: "La gestión de flota importa",
    sbcThesisEyebrow: "Empiece aquí",
    sbcThesisTitle: "Compre la plataforma de servicio, no solo el equipo",
    sbcThesisBody1:
      "Un equipo Android de retail de bajo costo puede lucir atractivo en una hoja de cálculo, pero los compradores de TV gestionada necesitan un dispositivo que se pueda personalizar con marca, aprovisionar, bloquear, actualizar y soportar en miles de hogares, habitaciones de hotel o despliegues de socios.",
    sbcThesisBody2:
      "El STB correcto depende del modelo de servicio: IPTV gestionado en una red privada, streaming OTT primero, híbrido de IPTV y OTT, televisión de hospitalidad o MDU, o reventa por distribuidor. El checklist es el mismo, pero el peso de cada ítem cambia.",
    sbcThesisNoteTitle: "La regla práctica",
    sbcThesisNoteBody:
      "Si un requisito afecta la experiencia del suscriptor, el acceso al contenido, el costo de soporte o el control de flota, verifíquelo en una muestra real antes de aprobar el pedido.",
    sbcBuyerEyebrow: "Casos de uso",
    sbcBuyerTitle: "Ajuste el equipo al servicio que opera",
    sbcBuyerIntro:
      "El mismo modelo puede servir a varios proyectos, pero los criterios de compra son distintos. Empiece por el servicio, luego elija el nivel de hardware.",
    sbcBuyer1Title: "IPTV gestionado",
    sbcBuyer1Body:
      "Priorice Ethernet, soporte multicast, firmware estable, un launcher simple, diagnóstico remoto y decodificación predecible para TV en vivo.",
    sbcBuyer2Title: "TV OTT primero",
    sbcBuyer2Body:
      "Priorice el rendimiento de apps, la preparación para DRM, el margen de almacenamiento, el comportamiento de Wi-Fi, el streaming adaptativo y un control remoto amigable para el suscriptor.",
    sbcBuyer3Title: "Híbrido de IPTV y OTT",
    sbcBuyer3Body:
      "Verifique que un solo dispositivo pueda moverse entre TV en vivo multicast, VOD unicast, catch-up, portales y apps del operador sin confundir al espectador.",
    sbcBuyer4Title: "Hospitalidad y MDU",
    sbcBuyer4Body:
      "Busque una UX bloqueada, sin dependencia de cuenta personal, configuración centralizada, aprovisionamiento a granel y reemplazo sencillo en campo.",
    sbcBuyer5Title: "Evaluación del distribuidor",
    sbcBuyer5Body:
      "Valide el empaque, las opciones de accesorios, el proceso de garantía, la localización, la logística y si el proveedor puede soportar builds específicos del operador.",
    sbcTableEyebrow: "El checklist",
    sbcTableTitle: "Qué verificar antes de comprar STBs",
    sbcTableIntro:
      "Trate cada fila como un ítem para probar en la muestra, no como una afirmación de folleto. Un buen proveedor debe poder demostrar la respuesta en hardware real.",
    sbcTableColCheck: "Verificación",
    sbcTableColWhy: "Por qué importa",
    sbcTableColNote: "Nota del comprador",
    sbcRow1Check: "Madurez del chipset y la plataforma",
    sbcRow1Why:
      "El SoC define la decodificación, el nivel de DRM, la estabilidad de los drivers, la disipación térmica y cuánto tiempo se puede mantener el firmware.",
    sbcRow1Note:
      "Pregunte qué plataforma ya envía el proveedor a escala, no solo lo que se puede construir como algo único.",
    sbcRow2Check: "RAM y almacenamiento",
    sbcRow2Why:
      "Muy poca memoria hace que los launchers y las apps OTT se sientan lentos; muy poco almacenamiento limita apps, registros y actualizaciones.",
    sbcRow2Note:
      "El IPTV liviano puede funcionar con menos. Los despliegues Android con muchas apps necesitan más margen.",
    sbcRow3Check: "Requisitos de video, audio y 4K",
    sbcRow3Why:
      "El soporte de códec, HDR, resolución y audio decide si el servicio se reproduce con fluidez en las TVs que los suscriptores realmente usan.",
    sbcRow3Note: "Pruebe canales en vivo y contenidos VOD reales, no solo clips de demo.",
    sbcRow4Check: "Comportamiento de Ethernet y multicast",
    sbcRow4Why:
      "Las redes de IPTV gestionado y hospitalidad a menudo dependen de Ethernet cableado, IGMP y una reproducción multicast estable.",
    sbcRow4Note: "Si el multicast importa, pruébelo en el switch y el diseño de red objetivo.",
    sbcRow5Check: "Wi-Fi y OTT fuera de red",
    sbcRow5Why:
      "El OTT, las habitaciones secundarias y muchas instalaciones residenciales dependen de la calidad del Wi-Fi, el comportamiento de roaming y el streaming adaptativo.",
    sbcRow5Note:
      "Pruebe habitaciones con señal débil y apartamentos congestionados, no solo un laboratorio limpio.",
    sbcRow6Check: "Preparación para DRM y CAS",
    sbcRow6Why:
      "El contenido premium necesita el nivel de DRM correcto, aprovisionamiento de claves, integración con socios y a veces soporte de CAS.",
    sbcRow6Note:
      "Confirme la ruta real del contenido: Widevine, Verimatrix, app de portal, acuerdo de operador y aprovisionamiento de fábrica.",
    sbcRow7Check: "Sistema operativo y estrategia de apps",
    sbcRow7Why:
      "AOSP, Android TV certificado y Linux cambian cada uno la disponibilidad de apps, el costo de certificación, el control de actualizaciones y la velocidad de lanzamiento.",
    sbcRow7Note:
      "Elija el SO en torno a las apps y el modelo de control, no en torno a una preferencia genérica de plataforma.",
    sbcRow8Check: "Gestión de dispositivos y OTA",
    sbcRow8Why:
      "Sin aprovisionamiento remoto, diagnóstico, actualizaciones por etapas y bloqueo, cada problema en campo se vuelve costoso.",
    sbcRow8Note: "Pida ver el flujo de trabajo del DMS antes de aprobar el dispositivo.",
    sbcRow9Check: "Control remoto y UX diaria",
    sbcRow9Why:
      "El control remoto, el launcher, el flujo de arranque y las pantallas de configuración moldean la experiencia diaria del suscriptor más que una hoja de especificaciones.",
    sbcRow9Note:
      "Pruebe con usuarios no técnicos y revise la disposición de los botones, el comportamiento de IR/Bluetooth y la localización.",
    sbcRow10Check: "Marca, empaque y accesorios",
    sbcRow10Why:
      "El equipo, el control remoto, la fuente de alimentación, el cable HDMI, las etiquetas y la guía de inicio rápido afectan el soporte y la calidad percibida.",
    sbcRow10Note:
      "Confirme con anticipación los enchufes, idiomas, etiquetas, disposición de la caja y disponibilidad de accesorios de repuesto.",
    sbcRow11Check: "Garantía, repuestos y logística",
    sbcRow11Why:
      "El hardware a granel es un programa de operaciones: los plazos de entrega, el RMA, las unidades de repuesto y el enrutamiento de envíos importan después del lanzamiento.",
    sbcRow11Note:
      "Separe el envío de muestras de evaluación de la logística del pedido de producción.",
    sbcRow12Check: "Soporte del proveedor y ciclo de vida",
    sbcRow12Why:
      "Un equipo que funciona hoy aún necesita firmware, actualizaciones de apps, correcciones de seguridad y planificación de reemplazo más adelante.",
    sbcRow12Note:
      "Prefiera proveedores que puedan explicar la ruta de soporte durante toda la vida del dispositivo.",
    sbcTableNote:
      "La mejor opción suele ser el dispositivo que elimina el mayor riesgo de lanzamiento y soporte, no el que tiene la lista de especificaciones más larga.",
    sbcModelEyebrow: "Ajuste de modelo",
    sbcModelTitle: "Una manera práctica de dimensionar la línea inext",
    sbcModelIntro:
      "Estas no son reglas rígidas. Son un punto de partida para ajustar la complejidad del servicio al margen de hardware antes de probar la muestra.",
    sbcModelTv5Body:
      "Una opción liviana para despliegues de IPTV controlados, launchers simples y lanzamientos sensibles al costo donde el stack de apps es ligero.",
    sbcModelTv5Meta: "IPTV liviano",
    sbcModelTv5UltraBody:
      "Más espacio para experiencias Android de marca, apps adicionales y despliegues de operador mainstream que necesitan un precio equilibrado.",
    sbcModelTv5UltraMeta: "Android equilibrado",
    sbcModelTv6Body:
      "Un buen ajuste para servicios híbridos modernos de IPTV y OTT con más margen de UI, apps y actualizaciones.",
    sbcModelTv6Meta: "Híbrido mainstream",
    sbcModelTv6UltraBody:
      "La opción premium para stacks de apps más pesados, mayor margen de ciclo de vida y despliegues insignia de TV gestionada.",
    sbcModelTv6UltraMeta: "Stack premium",
    sbcModelCta: "Comparar todos los modelos de STB",
    sbcRedFlagsEyebrow: "Señales de alerta",
    sbcRedFlagsTitle: "Señales de advertencia antes de un pedido a granel",
    sbcRedFlagsIntro:
      "La mayoría de los problemas de STB son visibles durante la evaluación si el comprador prueba las cosas correctas.",
    sbcRedFlag1:
      "El proveedor ofrece un equipo Android de retail sin firmware de operador, control del launcher ni gestión de flota.",
    sbcRedFlag2:
      "El soporte de DRM, CAS o apps premium se describe de forma vaga, sin una ruta clara de aprovisionamiento y acuerdo.",
    sbcRedFlag3:
      "Las actualizaciones OTA son manuales, todas a la vez o dependen de que los suscriptores hagan lo correcto.",
    sbcRedFlag4:
      "No hay forma de bloquear, suspender, reconfigurar ni diagnosticar dispositivos de forma remota.",
    sbcRedFlag5:
      "El comportamiento de Ethernet, multicast o Wi-Fi se promete pero no se demuestra en la red objetivo.",
    sbcRedFlag6:
      "El empaque, los accesorios, los enchufes, las etiquetas o los manuales se tratan como algo secundario.",
    sbcRedFlag7:
      "El proveedor no puede explicar el manejo de la garantía, las unidades de repuesto, el ciclo de vida del firmware ni la logística de producción.",
    sbcSampleEyebrow: "Validación de muestra",
    sbcSampleTitle: "Qué probar en el equipo de muestra",
    sbcSampleIntro:
      "Una muestra no es un souvenir. Es la prueba de que el dispositivo puede convertirse en una flota gestionada.",
    sbcSample1:
      "Arranque en frío hacia el launcher de marca y confirme la experiencia de la primera pantalla.",
    sbcSample2:
      "Reproduzca IPTV en vivo, flujos OTT, VOD y catch-up desde las fuentes reales del servicio.",
    sbcSample3:
      "Pruebe el comportamiento de multicast o portal en la red objetivo, no solo en un laboratorio.",
    sbcSample4:
      "Verifique el contenido protegido con DRM y cualquier app premium que el servicio requiera.",
    sbcSample5: "Envíe una actualización de app o firmware a través del sistema de gestión.",
    sbcSample6:
      "Confirme que el dispositivo aparece en el DMS con diagnóstico, grupos y acciones remotas.",
    sbcSample7:
      "Pruebe el comportamiento de suspensión, bloqueo de red o kiosco/bloqueo de app si el modelo comercial lo necesita.",
    sbcSample8:
      "Evalúe la sensación del control remoto, el mapeo de botones, el emparejamiento y las llamadas de soporte que podría hacer un suscriptor.",
    sbcSample9:
      "Deje el equipo funcionando el tiempo suficiente para detectar problemas de calor, reinicios, Wi-Fi o memoria.",
    sbcSample10:
      "Revise el empaque, los enchufes, las etiquetas, los accesorios y los materiales de inicio rápido localizados.",
    sbcFitEyebrow: "Dónde encaja inext",
    sbcFitTitle: "Ayudamos a validar todo el stack",
    sbcFitBody:
      "inext suministra el hardware, el firmware, el launcher, la app de IPTV, Alcatraz DMS, OTA, la marca y la logística B2B mundial como un único stack de STB gestionado. Eso significa que el mismo proveedor puede responder la pregunta sobre el hardware, la del software y la del despliegue antes de un pedido a gran escala.",
    sbcFitCtaDms: "Ver Alcatraz DMS",
    sbcFitCtaLogistics: "Ver logística",
    sbcFaqEyebrow: "FAQ",
    sbcFaqTitle: "Preguntas frecuentes",
    sbcFaqQ1: "¿Esto es solo para operadores de IPTV?",
    sbcFaqA1:
      "No. El checklist sirve para cualquier organización que evalúe dispositivos de TV gestionados: ISP, operadores de IPTV y OTT, telcos, proyectos de hospitality y MDU, y distribuidores que compran para clientes operadores.",
    sbcFaqQ2: "¿Debo elegir Android, AOSP, Android TV certificado o Linux?",
    sbcFaqA2:
      "Elija en función del servicio. Android o AOSP encaja en despliegues con muchas apps y fuerte enfoque OTT, Android TV certificado encaja en proyectos que específicamente necesitan el ecosistema certificado de Google, y Linux puede ser adecuado para despliegues controlados de solo IPTV. Lo importante es alinear el sistema operativo, las apps, la certificación y el control de actualizaciones.",
    sbcFaqQ3: "¿Cuánta RAM y almacenamiento necesito?",
    sbcFaqA3:
      "Un IPTV liviano puede usar un equipo más modesto. Una experiencia Android moderna con varias apps, una interfaz más rica y un ciclo de vida más largo necesita más margen. La respuesta más segura es probar el launcher, las apps y el paquete de actualización reales en el modelo candidato.",
    sbcFaqQ4: "¿Sigue siendo importante Ethernet si OTT funciona por Wi-Fi?",
    sbcFaqA4:
      "Sí. OTT puede funcionar por Wi-Fi, pero el IPTV gestionado, el multicast y muchas redes de hospitality o MDU aún dependen de Ethernet cableado para una calidad de servicio predecible.",
    sbcFaqQ5: "¿Un mismo STB puede manejar IPTV y OTT?",
    sbcFaqA5:
      "Sí, si el hardware, el firmware y la app están diseñados para ambos. El comprador debería probar TV multicast o por portal en vivo, streams OTT, VOD y catch-up en la misma muestra antes de comprometerse.",
    sbcFaqQ6: "¿Cuándo debo solicitar una muestra de evaluación?",
    sbcFaqA6:
      "Antes de la aprobación comercial. Una muestra debería probarse con el portal, el contenido, la red, la ruta de DRM, el launcher, el control remoto, el flujo de trabajo del DMS y las expectativas de empaque reales.",
    sbcFaqQ7: "¿Qué deberían revisar de forma distinta los distribuidores?",
    sbcFaqA7:
      "Los distribuidores deberían verificar no solo el dispositivo, sino también un empaque replicable, las opciones de accesorios, los enchufes regionales, la gestión de la garantía, la localización, los plazos de entrega y si el proveedor puede dar soporte a builds específicos para cada operador.",
    sbcCtaEyebrow: "Hable con nosotros",
    sbcCtaTitle: "Valide el equipo antes del despliegue",
    sbcCtaBody:
      "Cuéntenos su modelo de servicio, su red, sus requisitos de apps y su franja de precio objetivo. Le ayudaremos a elegir el STB de inext adecuado, personalizar una muestra y probar el stack antes de un pedido de producción.",
    sbcCtaPrimary: "Hable con nuestro equipo",
    sbcCtaSecondary: "Solicitar una muestra",
    osSeoTitle:
      "STBs propios vs. Smart TVs: por qué los operadores envían su propio equipo | inext",
    osSeoDescription:
      "¿Un operador debe enviar Set-Top Boxes de marca o depender de los Smart TVs de los suscriptores? La respuesta honesta es ambos, pero su propio STB es la parte que posee y controla por completo. El argumento del operador a favor del equipo.",
    osBreadcrumbPage: "STBs propios vs. Smart TVs",
    osHeroEyebrow: "Guía de estrategia",
    osHeroTitle: "Sus propios STBs vs. los Smart TVs de los suscriptores:",
    osHeroTitleAccent: "por qué quiere ambos",
    osHeroSub:
      "La mayoría de los suscriptores ya tiene un Smart TV, así que es tentador saltarse el hardware y solo enviar una app. Para un operador serio la respuesta honesta es hacer ambas cosas: apps de Smart TV y móviles para alcance, y su propio STB de marca como el núcleo controlado. La diferencia es la propiedad: el equipo es la única plataforma que controla por completo, a su ritmo, sin que ningún tercero pueda cambiarle las reglas.",
    osHeroNote:
      "El equipo de marca —y la app que corre en él— es lo que construimos, y la parte que posee de forma absoluta. Esta página expone el argumento a su favor.",
    osHeroCtaPrimary: "Hable con nuestro equipo",
    osHeroCtaSecondary: "Vea lo que controla",
    osStat1: "Su marca en el equipo y el control remoto",
    osStat2: "100 % de control, a su ritmo",
    osStat3: "Cualquier TV, cualquier habitación",
    osThesisEyebrow: "Empiece aquí",
    osThesisTitle: "Controle el núcleo, llegue a todas partes",
    osThesisBody1:
      "No se trata de hardware contra apps, sino de lo que posee. Las apps de Smart TV, móviles y web ponen su servicio en las pantallas que los suscriptores ya tienen. Importan para el alcance y debería enviarlas. Pero en esas plataformas es un inquilino: el dispositivo, la pantalla de inicio, las reglas y los datos pertenecen a Samsung, LG, Google o Apple.",
    osThesisBody2:
      "Su propio STB es la excepción. Es el único dispositivo que es enteramente suyo: su launcher al arrancar, su calendario de actualizaciones, su DRM, sus datos, su facturación. Es donde garantiza la experiencia y ancla la relación con el suscriptor. La configuración ganadora combina un equipo controlado y de marca en el núcleo con apps en todas partes para el alcance.",
    osThesisCoreLabel: "Núcleo propio",
    osThesisCoreValue: "Su STB de marca",
    osThesisReachLabel: "Alcance (es un invitado)",
    osThesisReachValue: "Apps de Smart TV · móviles · web",
    osOwnRentEyebrow: "Poseer vs. alquilar",
    osOwnRentTitle: "En su equipo usted pone las reglas. En un Smart TV, las pone otro.",
    osOwnColTitle: "En su propio STB, usted controla",
    osOwnItem1: "La pantalla de inicio: su launcher lidera al arrancar",
    osOwnItem2: "Las actualizaciones y las nuevas funciones, a su ritmo",
    osOwnItem3: "El DRM, la seguridad y la integración de apps premium",
    osOwnItem4:
      "El espacio de facturación, anuncios y ventas adicionales, sin comisión de plataforma",
    osOwnItem5: "La telemetría del dispositivo y los datos de visualización: son suyos",
    osOwnItem6: "Cuánto tiempo sigue teniendo soporte el dispositivo",
    osRentColTitle: "En el Smart TV de un suscriptor, el fabricante controla",
    osRentItem1: "La pantalla de inicio: su app es un ícono más entre muchos",
    osRentItem2:
      "La revisión de la tienda de apps y las actualizaciones del sistema operativo, en su calendario",
    osRentItem3: "Qué niveles de DRM y códecs admite el TV",
    osRentItem4: "Las tarifas y condiciones de la tienda: pueden subirlas cuando quieran",
    osRentItem5: "Los datos de la plataforma: usted recibe migajas a nivel de app",
    osRentItem6: "Cuándo los modelos antiguos pierden soporte y su app deja de funcionar",
    osBenefitsEyebrow: "El argumento a favor del equipo",
    osBenefitsTitle: "Lo que gana al enviar su propio STB",
    osBenefit1Title: "Su marca, todos los días",
    osBenefit1Body:
      "Su launcher es la primera pantalla del TV, y su logo está en el equipo y en el control remoto que su suscriptor sostiene cada noche. Esa presencia de marca física y diaria genera apego, lo mantiene presente y hace que cambiarse se sienta como algo más grande.",
    osBenefit2Title: "Soberanía de plataforma",
    osBenefit2Body:
      "Ningún tercero puede cambiarle las reglas. Samsung, LG o Google pueden rediseñar su pantalla de inicio, promocionar a un rival, subir tarifas o dejar de dar soporte a TVs antiguos, y en sus plataformas no puede impedir nada de eso. En su equipo, cada una de esas decisiones es suya.",
    osBenefit3Title: "Gestión remota, menos soporte",
    osBenefit3Body:
      "Con Alcatraz DMS y TR-069 monitoree, diagnostique, configure, actualice y reinicie equipos de forma remota: menos visitas técnicas, soluciones más rápidas. El Smart TV de un suscriptor es una caja negra: cada problema se convierte en “¿es tu TV, tu red o nuestra app?”.",
    osBenefit4Title: "QoE que puede garantizar",
    osBenefit4Body:
      "Usted fija el chipset, los códecs, el 4K y el Wi-Fi, así que el servicio rinde igual para todos. En un Smart TV antiguo o barato su stream se entrecorta o no decodifica, y le echan la culpa por un hardware que no controla.",
    osBenefit5Title: "Lance funciones primero",
    osBenefit5Body:
      "Un nuevo códec, catch-up, DVR en la nube o un rediseño de la interfaz llega a toda su flota de inmediato. En los Smart TVs espera al soporte y la recertificación de cada plataforma, y los equipos antiguos nunca lo reciben.",
    osBenefit6Title: "Llegue a cada TV y cada habitación",
    osBenefit6Body:
      "Un equipo convierte cualquier TV con HDMI —equipos antiguos, dormitorios, la cocina, una casa de vacaciones— en su plataforma. Ir solo con Smart TV excluye discretamente esas pantallas, y a los suscriptores que ni siquiera tienen un Smart TV.",
    osBenefit7Title: "Quédese con lo que vende",
    osBenefit7Body:
      "En su STB maneja su propia facturación y su propio espacio de anuncios y ventas adicionales, sin que ninguna tienda se lleve una comisión, y conserva los datos de visualización y del dispositivo para actuar sobre ellos, en lugar de entregárselos al fabricante del TV.",
    osBenefit8Title: "Abra el B2B y el hospitality",
    osBenefit8Body:
      "Hoteles, edificios de apartamentos, hospitales y bares necesitan dispositivos gestionados de forma centralizada y bloqueados, sin inicios de sesión personales, algo que solo con apps no se puede lograr. Su STB abre esos mercados.",
    osBenefit9Title: "Valor en su red",
    osBenefit9Body:
      "Un STB gestionado es un activo en su red, no solo en la sala: la entrega multicast/gestionada eficiente mantiene el video dentro de la red —más liviano en ancho de banda y tránsito que el OTT traído por internet pública— y, como endpoint gestionado, le da visibilidad de QoE justo en el borde. Para un ISP, además vincula la TV a la banda ancha y aumenta el ARPU.",
    osScenarioTitle: "Un martes en la plataforma de otro",
    osScenarioBody:
      "Imagínelo: un martes, un fabricante de TV rediseña su pantalla de inicio, entierra su app detrás de un banner y empieza a promocionar un servicio competidor por toda su región. En los Smart TVs no puede hacer nada al respecto: es su pantalla de inicio, su decisión, y ningún ticket de soporte de un operador cambia el marketing de un fabricante. En sus propios STBs no cambia nada: la pantalla de inicio sigue siendo suya, porque el dispositivo lo es. Esa es la diferencia entre alquilar un espacio y ser dueño de la plataforma.",
    osHiddenEyebrow: "El costo real",
    osHiddenTitle: "Ir solo con Smart TV parece más barato de lo que es",
    osHiddenBody:
      "Saltarse el equipo ahorra hardware y logística por adelantado —eso es real, y para una jugada puramente OTT o D2C puede ser lo correcto—. Pero los Smart TVs “gratis” traen costos que paga después:",
    osHidden1:
      "Una caja negra de soporte: no puede ver ni reparar el dispositivo, así que cada problema es adivinanza",
    osHidden2:
      "Una QoE por la que lo culpan: los TVs antiguos y baratos hacen que su servicio se vea mal en un hardware que no posee",
    osHidden3:
      "Un impuesto de fragmentación: crear y certificar apps para Tizen, webOS, Android TV, Fire TV, Apple TV y más, cada una con sus propias particularidades y DRM",
    osHidden4:
      "Riesgo de plataforma: las tarifas, las políticas, los anuncios y el soporte del sistema operativo cambian según las condiciones del fabricante, no las suyas",
    osSameEyebrow: "Dónde encajamos",
    osSameTitle: "Construimos el equipo que posee",
    osSameBody:
      "No lo convenceremos de renunciar a las apps de Smart TV y móviles: envíelas, necesita el alcance. Lo que construimos es la parte que posee de forma absoluta: su STB de marca. Su launcher de nivel operador al arrancar, su app de IPTV, sus servicios precargados y toda la flota gestionada de extremo a extremo con Alcatraz DMS, OTA y TR-069. Las apps lo extienden a pantallas que no controla; el equipo es la base de operaciones, totalmente suyo, gestionado a su ritmo.",
    osSameNoteTitle: "Es el control más barato que comprará",
    osSameNoteBody:
      "Un equipo es una partida pequeña frente a la fuga de clientes, la carga de soporte y el riesgo de plataforma que elimina. Le ayudamos a especificar el adecuado, ponerle su marca hasta en el control remoto, y poner una muestra funcional en sus manos en 1–2 semanas.",
    osFaqEyebrow: "FAQ",
    osFaqTitle: "Preguntas frecuentes",
    osFaqQ1: "La mayoría de mis suscriptores ya tiene un Smart TV, ¿por qué enviar un equipo?",
    osFaqA1:
      "Porque el Smart TV es de ellos y del fabricante, no suyo. El equipo es donde controla la experiencia, le pone su marca, lo gestiona y le da soporte de forma remota, garantiza el rendimiento y conserva su facturación y sus datos. Envíe apps a los Smart TVs para tener alcance, pero el equipo es su ancla, y además cubre los segundos TVs y a los suscriptores que no tienen un TV inteligente.",
    osFaqQ2: "¿No es demasiado caro enviar hardware?",
    osFaqA2:
      "Un equipo cuesta aproximadamente $30–50, repartido a lo largo de la vida del suscriptor: poco frente a lo que ahorra. La gestión remota reduce los costos de soporte y las visitas técnicas, el dispositivo de marca reduce la fuga de clientes, y conserva ingresos de facturación de los que ninguna tienda puede llevarse una comisión. Para la mayoría de los operadores se paga solo; le ayudamos a modelarlo.",
    osFaqQ3: "¿Puedo empezar solo con apps y agregar STBs después?",
    osFaqA3:
      "Sí, muchos lo hacen. Pero los operadores que son dueños de la relación priorizan el equipo para sus suscriptores centrales y usan apps para el alcance. Si empieza solo con apps, planifique el STB desde temprano: es lo que convierte una app de contenido en un servicio controlado y de marca.",
    osFaqQ4: "¿Y los hoteles, los edificios de apartamentos y otros B2B?",
    osFaqA4:
      "Ese es terreno de STB. Los despliegues de hospitality y MDU necesitan dispositivos gestionados de forma centralizada y bloqueados, sin inicios de sesión personales: exactamente lo que ofrece un STB gestionado y lo que una app en el TV propio de un huésped no puede.",
    osFaqQ5: "¿Pierdo algo al enviar un equipo?",
    osFaqA5:
      "Asume el costo de hardware y la logística —reales, pero nosotros nos encargamos de la fabricación, la marca y la entrega mundial, y personalizamos una muestra funcional en 1–2 semanas—. A cambio obtiene control, presencia de marca, menos soporte y un suscriptor más fiel. Para un operador de servicio gestionado, ese intercambio suele valer la pena.",
    osFaqQ6: "¿El equipo me ata a una sola app o servicio?",
    osFaqA6:
      "No, es su plataforma. Usted elige el launcher, las apps, los servicios y la cadencia de actualizaciones. Ese es el punto: en su STB, la hoja de ruta es suya, no la de un fabricante de TV.",
    osCtaEyebrow: "Hable con nosotros",
    osCtaTitle: "Sea dueño de la pantalla que sus suscriptores más ven",
    osCtaBody:
      "Cuéntenos sobre su servicio y su flota. Especificaremos un STB de marca, lo personalizaremos con su marca y pondremos una muestra funcional en sus manos, rápido.",
    osCtaPrimary: "Hable con nuestro equipo",
    osCtaSecondary: "Solicitar una muestra",
    bmSeoTitle: "¿Subsidiar, arrendar o vender el STB? CapEx vs. OpEx para operadores | inext",
    bmSeoDescription:
      "¿Regalar el equipo, alquilarlo o venderlo sin más? Es una decisión de financiamiento, no de hardware. Los pros y contras de CapEx/OpEx y TCO de subsidiar, arrendar y vender Set-Top Boxes, y el bloqueo por DMS que hace seguros el subsidio y el arrendamiento.",
    bmBreadcrumbPage: "Subsidiar, arrendar o vender",
    bmHeroEyebrow: "Guía comercial",
    bmHeroTitle: "Subsidiar, arrendar o vender sus STBs:",
    bmHeroTitleAccent: "es una decisión de financiamiento",
    bmHeroSub:
      "El mismo equipo gestionado puede llegar a un suscriptor de tres maneras: regalado, arrendado o vendido. Lo que cambia no es el hardware; es quién lo financia, quién lo posee y cómo lo recupera. Elija el modelo equivocado para un segmento y deja dinero sobre la mesa o carga un riesgo que no puede ver. La mayoría de los operadores no elige uno solo: usan dos o tres a la vez.",
    bmHeroNote:
      "El mismo STB de inext sirve para los tres, y el bloqueo de Alcatraz DMS es lo que hace seguro regalar o alquilar un equipo. Este es el manual del operador para elegirlos y combinarlos.",
    bmHeroCtaPrimary: "Hable con nuestro equipo",
    bmHeroCtaSecondary: "Vea cómo ayuda el bloqueo",
    bmStat1: "Un equipo, tres modelos",
    bmStat2: "CapEx u OpEx: usted decide",
    bmStat3: "El bloqueo lo mantiene seguro",
    bmThesisEyebrow: "Empiece aquí",
    bmThesisTitle: "Es una decisión de financiamiento, no de hardware",
    bmThesisBody1:
      "Un Set-Top Box suele ser la mayor partida de hardware en el presupuesto de un operador, y crece con cada suscriptor que agrega. Así que cómo llega el equipo al hogar no es un detalle de logística: define su flujo de caja, lo que figura en su balance y lo difícil que le resulta a un suscriptor irse. El equipo en sí es idéntico en los tres modelos. La decisión es puramente financiera.",
    bmThesisBody2:
      "Y rara vez es una sola decisión. El mismo operador puede subsidiar equipos para ganar suscriptores premium y triple-play, arrendar a la base masiva, y vender directamente a clientes prepago, B2B o de segundo TV, y luego mover a los suscriptores entre modelos con el tiempo. La verdadera pregunta no es “qué modelo”, sino “qué modelo para qué suscriptor, y cómo lo mantengo seguro”.",
    bmThesisCoreLabel: "Un activo",
    bmThesisCoreValue: "Su STB gestionado",
    bmThesisReachLabel: "Tres modelos comerciales",
    bmThesisReachValue: "Subsidiar · Arrendar · Vender",
    bmModelsEyebrow: "Los tres modelos",
    bmModelsTitle: "Tres maneras de poner un equipo en el hogar",
    bmModelLabelUpfront: "Por adelantado",
    bmModelLabelOwns: "Quién lo posee",
    bmModelLabelRevenue: "Cómo gana",
    bmModelLabelBest: "Ideal para",
    bmModel1Name: "Subsidiar",
    bmModel1Tagline: "Regale el equipo, gane al suscriptor.",
    bmModel1Upfront: "Usted lo financia por adelantado: CapEx desde el primer día.",
    bmModel1Owns: "Por lo general el suscriptor, tras un plazo mínimo.",
    bmModel1Revenue: "Se recupera a través de la suscripción durante el contrato.",
    bmModel1Best: "Captación competitiva, paquetes premium y triple-play.",
    bmModel2Name: "Arrendar / alquilar",
    bmModel2Tagline: "Conserve el activo, cóbrelo cada mes.",
    bmModel2Upfront: "Usted lo financia, pero sigue siendo su activo.",
    bmModel2Owns: "Usted, durante toda la vida del dispositivo.",
    bmModel2Revenue:
      "Una partida de alquiler recurrente; recupérelo y redistribúyalo al devolverse.",
    bmModel2Best: "Ingresos recurrentes, baja fricción, hardware que reutiliza.",
    bmModel3Name: "Vender",
    bmModel3Tagline: "Efectivo ahora, nada que cargar.",
    bmModel3Upfront: "El suscriptor paga: de una vez o en cuotas.",
    bmModel3Owns: "El suscriptor, desde el primer día.",
    bmModel3Revenue: "Ingreso único por hardware; sin activo que depreciar.",
    bmModel3Best: "Prepago, segundos TVs, B2B, un balance más liviano.",
    bmTableEyebrow: "Lado a lado",
    bmTableTitle: "Cómo se comparan los tres",
    bmTableColDimension: "",
    bmTableColSubsidize: "Subsidiar",
    bmTableColLease: "Arrendar",
    bmTableColSell: "Vender",
    bmRow1Label: "Costo por adelantado",
    bmRow1Sub: "Operador (CapEx)",
    bmRow1Lease: "Operador (CapEx, retenido)",
    bmRow1Sell: "Suscriptor",
    bmRow2Label: "En sus libros",
    bmRow2Sub: "Activo, luego amortizado",
    bmRow2Lease: "Activo, depreciado a lo largo de su vida",
    bmRow2Sell: "Nada: está vendido",
    bmRow3Label: "Flujo de caja",
    bmRow3Sub: "Sale ahora, vuelve durante el plazo",
    bmRow3Lease: "Sale ahora, vuelve de forma recurrente",
    bmRow3Sell: "Entra ahora",
    bmRow4Label: "Ingresos recurrentes",
    bmRow4Sub: "Dentro de la suscripción",
    bmRow4Lease: "Una partida de alquiler aparte",
    bmRow4Sell: "Ninguno sobre el hardware",
    bmRow5Label: "Fricción para el suscriptor",
    bmRow5Sub: "La menor: es gratis",
    bmRow5Lease: "Baja: una pequeña mensualidad",
    bmRow5Sell: "La mayor: paga por adelantado",
    bmRow6Label: "Fidelización",
    bmRow6Sub: "El plazo del contrato",
    bmRow6Lease: "Devolverlo para irse",
    bmRow6Sell: "La menor: es de su propiedad",
    bmRow7Label: "Si se van antes de tiempo",
    bmRow7Sub: "Subsidio no recuperado",
    bmRow7Lease: "Recuperar y redistribuir",
    bmRow7Sell: "Ya pagado: sin exposición",
    bmTableSafeLabel: "Qué lo mantiene seguro",
    bmTableSafeValue:
      "Alcatraz DMS: net-lock · app-lock · suspensión remota · recuperación por OTA",
    bmTableNote: "El equipo es el mismo en cada columna: solo se mueven el dinero y la propiedad.",
    bmTcoEyebrow: "Los números, a grandes rasgos",
    bmTcoTitle: "Mismo equipo, tres formas de flujo de caja",
    bmTcoBody:
      "El modelo no cambia cuánto cuesta un equipo: cambia cuándo se mueve el dinero. Tome un equipo gestionado y siga el efectivo:",
    bmTco1Title: "Subsidiar",
    bmTco1Body:
      "Gasta el costo del equipo el primer día y lo recupera a través de la suscripción. La recuperación es aproximadamente costo del equipo ÷ margen mensual; conserve al suscriptor más allá de ese punto y el resto es ganancia. Piérdalo antes y la parte no recuperada es su pérdida, que es exactamente lo que un plazo mínimo y el bloqueo remoto están ahí para proteger.",
    bmTco2Title: "Arrendar",
    bmTco2Body:
      "Igual financia el equipo, pero un alquiler mensual lo convierte en una anualidad que puede rendir más que su costo a lo largo de la vida del dispositivo. Como conserva la propiedad, una unidad devuelta se borra, se reaprovisiona y se reemite, así que un mismo equipo puede servir a varios suscriptores antes de retirarse.",
    bmTco3Title: "Vender",
    bmTco3Body:
      "El suscriptor financia el hardware, así que nada figura en su balance y no se inmoviliza capital de trabajo. Cede algo de fidelización a cambio de efectivo hoy y una operación más liviana, a menudo lo correcto para prepago o B2B.",
    bmTcoNote:
      "Ilustrativo, no una cotización: su respuesta real depende del costo del equipo, el margen, la retención y la reutilización. Le ayudamos a pasar sus propios números por este análisis.",
    bmLockEyebrow: "Qué lo hace seguro",
    bmLockTitle: "Control por software, no por confianza",
    bmLockBody:
      "El riesgo al subsidiar o arrendar es simple: un suscriptor deja de pagar, o el equipo nunca vuelve. Alcatraz DMS convierte ese riesgo en un ajuste. Net-lock y app-lock vinculan cada dispositivo a su servicio, así que fuera de su red no tiene valor de reventa y no puede convertirse en un equipo Android genérico. Eso es lo que hace que regalar o prestar hardware sea una decisión deliberada y segura en vez de una apuesta.",
    bmLock1Title: "Net-lock del dispositivo",
    bmLock1Body:
      "Un equipo subsidiado o arrendado queda vinculado a su servicio. Fuera de su red simplemente no se activa, así que no tiene valor de reventa ni motivo para llevárselo.",
    bmLock2Title: "App-lock y modo kiosco",
    bmLock2Body:
      "El equipo corre su launcher y sus apps, no un escritorio Android abierto. Un dispositivo subsidiado no puede reutilizarse, y su marca permanece en la pantalla.",
    bmLock3Title: "Suspender y restaurar de forma remota",
    bmLock3Body:
      "¿Pago vencido? Bloquee suavemente el equipo desde el panel y reactívelo en cuanto paguen: gestión de cobros sin una sola visita técnica.",
    bmLock4Title: "Recuperar y redistribuir",
    bmLock4Body:
      "Una unidad de arrendamiento devuelta se borra y se reaprovisiona por aire, y luego se reemite al siguiente suscriptor: la reutilización que hace que la economía del arrendamiento realmente funcione.",
    bmLockNote:
      "Por eso el modelo es una decisión de software. Una misma flota puede estar subsidiada, arrendada y vendida al mismo tiempo, con cada dispositivo sujeto a sus propias condiciones y movido entre ellas sin tocar jamás el hardware.",
    bmMixEyebrow: "En la práctica",
    bmMixTitle: "La mayoría de los operadores usa más de uno",
    bmMixBody:
      "Alinee el modelo con el suscriptor, no con la empresa. Un patrón que vemos una y otra vez entre nuestros clientes:",
    bmMix1:
      "Captación y premium → subsidiar. Elimine la barrera inicial para ganar suscriptores competitivos y triple-play; el contrato y el bloqueo protegen el regalo.",
    bmMix2:
      "Base masiva → arrendar. Una pequeña partida mensual mantiene baja la fricción y el activo suyo, con recuperación y reutilización cuando los suscriptores se van.",
    bmMix3:
      "Prepago, segundos TVs y B2B → vender. Tome el efectivo por adelantado donde la fidelización importa menos y un balance liviano importa más.",
    bmMix4:
      "Con el tiempo → convertir. El mismo equipo le permite subsidiar para captar y luego pasar a un suscriptor a la propiedad: sin hardware nuevo, solo un cambio de condiciones.",
    bmFitEyebrow: "Dónde encajamos",
    bmFitTitle: "Una flota. Cualquier modelo. Cámbielo cuando quiera.",
    bmFitBody:
      "Enviamos el STB gestionado y Alcatraz DMS; usted elige el modelo comercial —o varios— y nosotros hacemos que cada uno sea seguro de operar. Net-lock, app-lock, suspensión remota y recuperación por OTA vienen integrados, así que subsidiar y arrendar no son un salto al vacío, y puede cambiar la combinación a medida que su mercado se mueve sin reflashear ni volver a comprar. No le impondremos un modelo: hacemos que los tres funcionen en el mismo equipo.",
    bmFitNoteTitle: "Modélelo con nosotros",
    bmFitNoteBody:
      "Cuéntenos sus márgenes y su retención: aportamos el costo del equipo y comparamos subsidiar, arrendar y vender con números reales, y luego configuramos el bloqueo que protege el que elija.",
    bmFaqEyebrow: "FAQ",
    bmFaqTitle: "Preguntas frecuentes",
    bmFaqQ1: "¿Cuál modelo es el mejor?",
    bmFaqA1:
      "No hay un ganador universal: depende de su mercado, su posición de caja y cuánta fidelización necesita. La mayoría de los operadores combina: subsidiar para captar, arrendar a la base y vender donde la fidelización importa menos. La ventaja de un equipo gestionado es que no tiene que elegir uno solo.",
    bmFaqQ2: "¿De verdad puedo usar los tres a la vez?",
    bmFaqA2:
      "Sí, muchos de nuestros clientes lo hacen. Como el modelo se aplica por software a través de Alcatraz DMS, una misma flota puede tener dispositivos subsidiados, arrendados y vendidos uno al lado del otro, cada uno con sus propias condiciones.",
    bmFaqQ3: "¿Qué impide que un equipo subsidiado o arrendado se revenda o reutilice?",
    bmFaqA3:
      "Net-lock y app-lock. Fuera de su red el equipo no se activa, así que no tiene valor de reventa; y solo corre su servicio, así que no puede convertirse en un equipo Android genérico. Eso es lo que hace seguro regalar o prestar hardware.",
    bmFaqQ4: "¿Qué pasa cuando un suscriptor deja de pagar?",
    bmFaqA4:
      "Bloquea el dispositivo de forma remota y lo restablece en el instante en que pagan — sin visita técnica. En un arrendamiento, una caja que nunca se devuelve queda bloqueada y sin valor fuera de la red; una que regresa se borra y se reasigna.",
    bmFaqQ5: "¿Cómo se refleja el arrendamiento en mi balance?",
    bmFaqA5:
      "Con un arrendamiento operativo típico, mantiene la caja como un activo y la deprecia a lo largo de su vida útil, mientras registra la renta como ingreso recurrente — el clásico cambio de CapEx a una línea recurrente. Confirme el tratamiento exacto con su equipo de finanzas; nosotros aportaremos los datos de vida útil y reutilización del dispositivo.",
    bmFaqQ6: "¿Puedo cambiar a un suscriptor de un modelo a otro más adelante?",
    bmFaqA6:
      "Sí. Como cada modelo funciona en la misma caja, puede subsidiar para captar y luego convertir al suscriptor a propiedad, o transformar un alquiler en una venta — todo por software, sin hardware nuevo.",
    bmCtaEyebrow: "Hable con nosotros",
    bmCtaTitle: "Elija el modelo que encaja — nosotros lo hacemos seguro",
    bmCtaBody:
      "Cuéntenos sus márgenes, su rotación y lo que le cobraría a un suscriptor — nosotros aportamos el costo de la caja y le ayudamos a sopesar subsidiar, arrendar y vender con números reales, y luego configuramos el bloqueo de Alcatraz DMS que protege el modelo que elija.",
    bmCtaPrimary: "Hable con nuestro equipo",
    bmCtaSecondary: "Solicitar una muestra",
    moSeoTitle:
      "Multicast IPTV vs. streaming OTT: arquitectura de distribución para operadores | inext",
    moSeoDescription:
      "Multicast IPTV o unicast OTT — ¿cómo debería un operador distribuir TV en vivo? Un flujo eficiente para muchos en una red gestionada, o un flujo adaptativo por espectador a través de internet. Las ventajas y desventajas reales de ancho de banda, calidad, latencia y alcance — y por qué muchos operadores usan ambos.",
    moBreadcrumbPage: "Multicast IPTV vs. OTT",
    moHeroEyebrow: "Guía de arquitectura de distribución",
    moHeroTitle: "Multicast IPTV vs. streaming OTT:",
    moHeroTitleAccent: "por qué usará ambos",
    moHeroSub:
      "Hay dos maneras de poner TV en vivo en una pantalla: enviar un flujo a muchos espectadores a través de su propia red gestionada (multicast IPTV), o enviar un flujo adaptativo distinto a cada espectador a través de internet público (unicast OTT). Los nuevos despliegues se construyen cada vez más sobre OTT — llega a cualquier red y a cualquier dispositivo. Pero las muchas redes gestionadas que ya usan multicast lo conservan por una buena razón: para el vivo a gran escala, nada iguala su eficiencia, latencia casi nula y calidad garantizada. Los dos no son rivales — muchos operadores los combinan: multicast para el vivo, unicast para el resto.",
    moHeroNote:
      "Los STB de inext y nuestra app de IPTV hablan ambos — multicast en su red gestionada, OTT a través de internet, en la misma caja. Damos soporte a ambos porque nuestros clientes usan ambos.",
    moHeroCtaPrimary: "Hable con nuestro equipo",
    moHeroCtaSecondary: "Mire cómo la caja hace ambos",
    moStat1: "Un flujo → muchos (multicast)",
    moStat2: "Cualquier red, cualquier dispositivo (OTT)",
    moStat3: "Híbrido: una caja, ambos",
    moThesisEyebrow: "Empiece aquí",
    moThesisTitle: "Se trata de la red, no solo del flujo",
    moThesisBody1:
      "La verdadera diferencia no es la calidad de imagen en abstracto — es por dónde viaja el video. Multicast envía una sola copia de cada canal en vivo a través de su red gestionada, y todos los que están sintonizados la comparten: 50 000 suscriptores en un canal cuestan el mismo ancho de banda que uno. OTT, en cambio, abre un flujo unicast distinto para cada espectador a través de internet público, adaptando el bitrate a cada conexión. Uno está hecho para la eficiencia y el control en una red que posee; el otro para el alcance y la flexibilidad en redes que no posee.",
    moThesisBody2:
      "Con franqueza, para un proyecto desde cero OTT es ahora la opción por defecto — la mayoría de los despliegues nuevos son unicast, y el multicast IPTV puro se considera ampliamente heredado. Pero “heredado” no significa malo: donde una red gestionada ya transporta multicast, ofrece una calidad de imagen, una latencia casi nula y una eficiencia de red que el unicast aún no puede igualar para el vivo a gran escala — así que rara vez hay una buena razón para desmantelarlo. Por eso el multicast sigue ampliamente desplegado, normalmente en un esquema híbrido: multicast para el lineal en vivo, unicast para VOD, catch-up y time-shift. Cada tarea en el transporte que la ejecuta mejor.",
    moThesisCoreLabel: "Red gestionada, uno a muchos",
    moThesisCoreValue: "Multicast IPTV",
    moThesisReachLabel: "Internet público, uno a uno",
    moThesisReachValue: "Unicast OTT",
    moDefineEyebrow: "Cómo funciona cada uno",
    moDefineTitle: "Dos transportes para el video en vivo",
    moMcastColTitle: "Multicast IPTV",
    moMcastColSub: "Un flujo, compartido por cada espectador, en su red gestionada",
    moMcast1:
      "Una copia de cada canal viaja por la red; los espectadores se unen a ella mediante IGMP",
    moMcast2: "El ancho de banda se mantiene constante sin importar cuántos sintonicen",
    moMcast3: "Bitrate fijo y tráfico priorizado — calidad garantizada y sin buffering",
    moMcast4: "Latencia inferior a un segundo — ideal para deportes en vivo y eventos nacionales",
    moMcast5:
      "Funciona en una red gestionada con multicast habilitado sobre Ethernet cableado — el Wi-Fi no puede transportarlo de forma confiable",
    moMcast6:
      "Hecho para el lineal en vivo; el VOD y la personalización siguen viajando por unicast",
    moOttColTitle: "Unicast OTT",
    moOttColSub: "Un flujo adaptativo distinto por espectador, a través de internet público",
    moOtt1: "Cada espectador obtiene su propio flujo desde una CDN",
    moOtt2: "El bitrate adaptativo (HLS/DASH) se ajusta a la velocidad de cada conexión",
    moOtt3:
      "Llega a cualquier red y a cualquier dispositivo — teléfonos, laptops, Smart TVs, fuera de la red",
    moOtt4:
      "Calidad de mejor esfuerzo; la latencia es mayor (HLS/DASH de baja latencia ahora ~2–5 s)",
    moOtt5: "El ancho de banda y el costo de CDN escalan con cada espectador simultáneo",
    moOtt6: "Transporta VOD, catch-up, nPVR y personalización de forma nativa",
    moTableEyebrow: "Lado a lado",
    moTableTitle: "Cómo se comparan los dos",
    moTableColDimension: "",
    moTableColMcast: "Multicast IPTV",
    moTableColOtt: "Unicast OTT",
    moRow1Label: "Ancho de banda a escala",
    moRow1Mcast: "Constante — un flujo los sirve a todos",
    moRow1Ott: "Lineal — un flujo por espectador",
    moRow2Label: "Red necesaria",
    moRow2Mcast: "Solo su red gestionada",
    moRow2Ott: "Cualquier red, internet público",
    moRow3Label: "Alcance",
    moRow3Mcast: "Set-Top Boxes dentro de la red",
    moRow3Ott: "Cualquier dispositivo, en cualquier lugar",
    moRow4Label: "Calidad",
    moRow4Mcast: "Garantizada, bitrate fijo",
    moRow4Ott: "Mejor esfuerzo, adaptativa",
    moRow5Label: "Latencia en vivo",
    moRow5Mcast: "Inferior a un segundo",
    moRow5Ott: "~2–5 s de baja latencia, hasta 10–30 s",
    moRow6Label: "Mejor para",
    moRow6Mcast: "Lineal en vivo, deportes, grandes canales",
    moRow6Ott: "VOD, catch-up, móvil, fuera de la red",
    moRow7Label: "VOD y personalización",
    moRow7Mcast: "Necesita unicast",
    moRow7Ott: "Nativo",
    moRow8Label: "Perfil de costo",
    moRow8Mcast: "Configuración de red; constante a escala",
    moRow8Ott: "CDN / egreso; crece con los espectadores",
    moRow9Label: "Control de QoS",
    moRow9Mcast: "Total — usted posee la red",
    moRow9Ott: "Limitado — mejor esfuerzo",
    moRow10Label: "Conexión",
    moRow10Mcast: "Ethernet cableado — no Wi-Fi",
    moRow10Ott: "Cualquier enlace, Wi-Fi incluido",
    moTableInextLabel: "En cajas inext",
    moTableInextValue:
      "Una app de IPTV reproduce ambos — multicast dentro de la red, OTT fuera de la red",
    moTableNote:
      "La mayoría de las plataformas ponen el lineal en vivo en multicast donde la red gestionada lo permite, y todo lo demás en unicast.",
    moScaleEyebrow: "La brecha de eficiencia",
    moScaleTitle: "Por qué el multicast aún gana el gran momento en vivo",
    moScaleBody:
      "Imagine una final nacional en un canal, 50 000 suscriptores viéndola a la vez. Por multicast eso es un solo flujo en su red — la carga es la misma que la de un espectador. Por unicast son 50 000 flujos separados, y su CDN y egreso escalan con cada uno. Esta es la razón principal por la que tantas redes multicast se mantienen en servicio: para el vivo de alta concurrencia, cuanto mayor es la audiencia, mayor es el ahorro — en ancho de banda, en costo y en la latencia casi nula que ofrece una red gestionada.",
    moFitListEyebrow: "Cuándo usar cuál",
    moFitListTitle: "Ponga cada tarea en el transporte que la ejecuta mejor",
    moFit1:
      "Lineal en vivo a escala en su red gestionada → multicast. Los deportes y los grandes canales obtienen latencia inferior a un segundo, calidad garantizada y ancho de banda constante.",
    moFit2:
      "VOD, catch-up, time-shift, nPVR y canales personalizados → unicast. Son por naturaleza por espectador, así que OTT es el ajuste natural.",
    moFit3:
      "Móvil, viajes, pantallas secundarias y suscriptores fuera de la red → OTT. Llega a cualquier red y a cualquier dispositivo sin infraestructura de multicast.",
    moFit4:
      "Mercados que exigen calidad garantizada → el multicast sigue liderando, y esa es una opción válida y bien considerada — no una heredada.",
    moBothEyebrow: "Dónde encajamos",
    moBothTitle: "Una caja, ambos transportes",
    moBothBody:
      "No tiene que elegir en el dispositivo. Los Set-Top Boxes de inext y nuestra app de IPTV manejan multicast (UDP/RTP con IGMP) en su red gestionada y OTT (HLS/DASH, M3U y portales Stalker/Ministra/Xtream) por unicast — en la misma caja, en el mismo hogar. Un suscriptor puede ver un canal en vivo por multicast y, un momento después, abrir un título de VOD que se transmite por unicast — un servicio fluido, cada flujo en el transporte que le conviene. Y como el multicast necesita un enlace cableado, cada caja inext incluye un puerto Ethernet. Unicast puro, una red multicast clásica o un híbrido de los dos — la misma caja encaja en los tres. Construimos para ambos porque nuestros clientes usan ambos, y no le diremos que el que eligió está mal.",
    moBothNoteTitle: "¿Ya usa uno? Añada el otro.",
    moBothNoteBody:
      "¿Usa multicast puro y necesita alcance OTT para móvil y fuera de la red? ¿O OTT puro y quiere la eficiencia del multicast para grandes eventos en vivo? La caja y la app soportan ambos, así que puede ampliar sin cambiar de plataforma. Le ayudamos a dimensionarlo.",
    moFaqEyebrow: "FAQ",
    moFaqTitle: "Preguntas frecuentes",
    moFaqQ1: "¿El OTT está dejando obsoleto al multicast?",
    moFaqA1:
      "Para los proyectos nuevos, en gran medida — la mayoría de los despliegues desde cero ahora optan por unicast/OTT, y el multicast IPTV puro se considera ampliamente heredado. Pero esa no es toda la historia: donde una red gestionada ya transporta multicast, su eficiencia, latencia casi nula y calidad garantizada para el vivo son difíciles de abandonar, así que esas redes se mantienen en servicio y siguen siendo muy usadas. Es menos “reemplazado” que “ya no es la opción por defecto para proyectos desde cero” — y normalmente se usa en un híbrido, con unicast para VOD y catch-up.",
    moFaqQ2: "¿Cuál tiene mejor calidad de imagen?",
    moFaqA2:
      "En una red gestionada, el multicast entrega un bitrate fijo con tráfico priorizado, así que la calidad es consistente y sin buffering. La calidad del OTT es adaptativa y de mejor esfuerzo — excelente en una buena conexión, variable en una mala. Para una calidad que controla de extremo a extremo, el multicast lidera; para el alcance en redes impredecibles, la adaptabilidad del OTT es justamente el punto.",
    moFaqQ3: "¿Necesito una red especial para multicast?",
    moFaqA3:
      "Sí. El multicast necesita una red gestionada donde cada switch en la ruta tenga multicast habilitado (IGMP), además de un enlace Ethernet cableado en la caja — el Wi-Fi no puede transportar multicast de forma confiable. Por eso es una tecnología de telco/ISP dentro de la red, y por eso cada caja inext tiene un puerto Ethernet. El OTT no necesita nada de eso — funciona sobre internet público y cualquier conexión, Wi-Fi incluido, que es exactamente por lo que llega a cualquier parte.",
    moFaqQ4: "¿Puede un solo Set-Top Box hacer ambos?",
    moFaqA4:
      "Sí — ese es el punto de los nuestros. Las cajas inext y la app de IPTV reproducen multicast en vivo en su red y flujos OTT a través de internet, cambiando de forma transparente. El suscriptor ve un solo servicio; usted decide qué transporte lleva cada cosa.",
    moFaqQ5: "¿Y la latencia para los deportes en vivo?",
    moFaqA5:
      "El multicast normalmente entrega una latencia inferior a un segundo — algo que importa cuando los vecinos festejan antes de que su flujo alcance la jugada. El OTT estándar se retrasa de 10 a 30 segundos; el HLS/DASH de baja latencia ha reducido eso a aproximadamente 2–5 segundos, bien para la mayoría del contenido pero aún por detrás del multicast en el gran momento en vivo.",
    moFaqQ6: "¿Qué es el multicast ABR?",
    moFaqA6:
      "El multicast ABR (mABR) transporta flujos de bitrate adaptativo en formato OTT sobre multicast — combinando el formato compatible con dispositivos del OTT con la eficiencia de uno a muchos del multicast. Puede reducir los picos de tráfico en vivo hasta en un 90 % y permite a los operadores escalar el vivo de alta concurrencia sin un flujo unicast por espectador. Nuestra plataforma lo soporta.",
    moCtaEyebrow: "Hable con nosotros",
    moCtaTitle: "Distribuya la TV en vivo como su red está diseñada para hacerlo",
    moCtaBody:
      "Cuéntenos sobre su red, sus canales y su audiencia. Le ayudaremos a ubicar el multicast y el OTT donde cada uno rinde mejor — y a enviar cajas que ejecutan ambos desde el primer momento.",
    moCtaPrimary: "Hable con nuestro equipo",
    moCtaSecondary: "Solicitar una muestra",
    bbSeoTitle: "Construir vs. comprar: ¿debería un ISP construir su propio Set-Top Box? | inext",
    bbSeoDescription:
      "¿Construir su propia plataforma de STB o comprar un stack llave en mano? “Construir” un Set-Top Box significa ensamblar ocho capas — silicio, hardware, firmware, apps, DRM, gestión de dispositivos, fabricación y soporte. Una guía honesta de hacer o comprar para operadores.",
    bbBreadcrumbPage: "Construir vs. comprar",
    bbHeroEyebrow: "Guía de hacer o comprar",
    bbHeroTitle: "¿Construir su propio STB o comprar el stack?",
    bbHeroTitleAccent: "el hacer o comprar honesto",
    bbHeroSub:
      "“Construir su propia caja” suena a ingeniería — pero ningún operador fabrica sus propios chips, y casi ninguno diseña la placa. En la práctica, construir significa ensamblar un stack de ocho capas, desde el silicio hasta la mesa de soporte, y ser dueño de cada una. Algunos operadores realmente deberían hacerlo. La mayoría de los que dicen que construyeron una caja en realidad la ensamblaron. Esta guía expone lo que “construir” realmente implica, para que pueda saber en qué lado está.",
    bbHeroNote:
      "Somos el lado de comprar y asociarse — así que no fingiremos que construir nunca tiene sentido. Lo tiene, para algunos. Esta es la versión honesta del dilema.",
    bbHeroCtaPrimary: "Hable con nuestro equipo",
    bbHeroCtaSecondary: "Mire las 8 capas",
    bbStat1: "8 capas que poseer",
    bbStat2: "Construir: un programa de varios años",
    bbStat3: "Comprar: una muestra de marca en 1–2 semanas",
    bbThesisEyebrow: "Empiece aquí",
    bbThesisTitle: "“Construir” rara vez significa lo que parece",
    bbThesisBody1:
      "Nadie fabrica sus propios chips y, siendo realistas, ningún operador diseña su propia placa — para eso están los proveedores de silicio y los fabricantes. Así que “construir su propio STB” no es un proyecto de hardware; es un proyecto de integración. Está ensamblando hardware que abastece, software que escribe o licencia, y una operación para fabricarlo, actualizarlo y darle soporte — y luego es dueño del resultado de extremo a extremo.",
    bbThesisBody2:
      "Ese es un camino real y válido — pero más grande de lo que parece. Una caja funcional que un suscriptor pueda realmente usar toca ocho competencias distintas, y una brecha en cualquiera de ellas aparece más tarde como un lanzamiento estancado o una falla en campo. Antes de decidir construir, ayuda ver todo el stack que asumiría.",
    bbThesisCoreLabel: "Qué es “construir” en realidad",
    bbThesisCoreValue: "Ensamblar y poseer un stack",
    bbThesisReachLabel: "Lo que compra de todos modos",
    bbThesisReachValue: "Silicio · hardware ODM · licencias de DRM",
    bbLayersEyebrow: "El stack",
    bbLayersTitle: "Ocho capas detrás de una caja funcional",
    bbLayersIntro:
      "Un Set-Top Box parece un solo producto; en realidad son ocho competencias apiladas. Aquí está cada capa, y lo que implica poseerla.",
    bbLayer1Name: "Silicio (SoC)",
    bbLayer1Body:
      "El chip — Amlogic, Allwinner, Realtek. Lo elige, nunca lo fabrica, y limita su 4K, códecs, nivel de DRM y arranque seguro.",
    bbLayer2Name: "Hardware y diseño industrial",
    bbLayer2Body:
      "Placa, puertos, carcasa, fuente de alimentación, control remoto. Diseñado y fabricado por un ODM — a partir de un diseño de referencia o de su especificación — no algo que se hace internamente.",
    bbLayer3Name: "Firmware y BSP",
    bbLayer3Body:
      "Android AOSP o Linux, kernel, controladores, arranque seguro. El proveedor le da una base; endurecerla para producción requiere ingenieros de sistemas embebidos.",
    bbLayer4Name: "Launcher y middleware",
    bbLayer4Body:
      "La pantalla de inicio de marca, EPG, ajustes y lanzador de apps — la parte que los suscriptores ven como “suya”.",
    bbLayer5Name: "Apps",
    bbLayer5Body:
      "Su app de IPTV/VOD, más OTT. Nota: Netflix, Disney+ y las demás no se “construyen” — cada una necesita su propia certificación y un acuerdo directo con el operador.",
    bbLayer6Name: "DRM y protección de contenido",
    bbLayer6Body:
      "Widevine y Verimatrix, licenciados y aprovisionados. Las claves de Widevine L1 deben grabarse en fábrica, en un chip con un enclave seguro — no puede añadir L1 después.",
    bbLayer7Name: "Gestión de dispositivos y OTA",
    bbLayer7Body:
      "Aprovisionamiento, actualizaciones de firmware escalonadas con reversión, diagnóstico remoto, TR-069. Un backend en sí mismo.",
    bbLayer8Name: "Fabricación, logística y soporte",
    bbLayer8Body:
      "Producción, envío mundial, certificación, QA, RMA y una mesa de soporte — la mayoría poco glamorosa del trabajo.",
    bbSpectrumEyebrow: "Cómo construyen realmente los operadores",
    bbSpectrumTitle: "Cuatro maneras de “construir”, de mayor a menor",
    bbApproach1Name: "Todo interno",
    bbApproach1Body:
      "Equipos propios de embebidos, apps y backend; un ODM que fabrica según su especificación; sus propios acuerdos de DRM y backend de gestión de dispositivos; usted gestiona la certificación. Realista a escala Tier-1 — un programa de varios años y varios equipos.",
    bbApproach2Name: "Diseño de referencia + su software",
    bbApproach2Body:
      "Parta de una placa de referencia de SoC o de una caja ODM; su equipo construye el firmware, el launcher, la app y la integración con el DMS. Necesita un equipo de embebidos, pero se salta el hardware personalizado.",
    bbApproach3Name: "Dispositivos de retail + su app",
    bbApproach3Body:
      "Sáltese el hardware por completo — publique su app en Chromecast/Google TV, Fire TV o cajas Android de retail. Solo “construye” la app, pero renuncia a la caja propia: sin marca, sin gestión de flota, y el proveedor controla la pantalla de inicio y las actualizaciones.",
    bbApproach4Name: "Hardware ODM + un stack de proveedor",
    bbApproach4Body:
      "Abastezca el hardware de un ODM y licencie el firmware, el launcher, la app y el DMS de un especialista. Usted marca y configura; las capas difíciles ya están hechas. Este es el camino de comprar y asociarse.",
    bbCostEyebrow: "El costo honesto",
    bbCostTitle: "Una construcción es un programa, no una compra",
    bbCostBody:
      "Una verdadera construcción desde cero significa levantar varias disciplinas que quizá no tenga — firmware embebido, desarrollo de apps, aprovisionamiento de DRM, un backend de gestión de dispositivos y OTA, fabricación y logística, y certificación y soporte — y luego mantenerlas con personal durante toda la vida del producto. El costo inicial es real, pero el continuo es mayor: cada actualización de SO, parche de seguridad y nueva app ahora corre por su cuenta. Planifique para un programa medido en trimestres y un equipo medido en personal, no una compra puntual.",
    bbWhenEyebrow: "Cuándo construir",
    bbWhenTitle: "Construir gana de verdad cuando…",
    bbWhen1:
      "Tiene la escala. Una base de suscriptores lo bastante grande como para amortizar una organización de ingeniería altera por completo las cuentas.",
    bbWhen2:
      "Tiene un requisito único. Una función o integración que ningún proveedor ofrece, y que es central para cómo se diferencia.",
    bbWhen3:
      "Ya tiene la organización. Un equipo interno de embebidos y apps que se compromete a financiar a largo plazo.",
    bbWhen4:
      "El control es estratégico. Cuando poseer cada capa — no solo ponerle su marca — es una decisión a nivel de directorio, no una línea de costo.",
    bbWhenNote:
      "Si dos o más de estos lo describen, construir merece una mirada seria. Si ninguno lo hace, las cuentas suelen favorecer abastecer las capas difíciles.",
    bbTableEyebrow: "Lado a lado",
    bbTableTitle: "Construir vs. comprar, dimensión por dimensión",
    bbTableColDimension: "",
    bbTableColBuild: "Construir internamente",
    bbTableColBuy: "Comprar y asociarse",
    bbRow1Label: "Tiempo al mercado",
    bbRow1Build: "Trimestres a años",
    bbRow1Buy: "Semanas hasta una primera muestra",
    bbRow2Label: "Costo inicial",
    bbRow2Build: "Alto — equipos y herramientas",
    bbRow2Buy: "Por dispositivo más configuración",
    bbRow3Label: "Equipo que necesita",
    bbRow3Build: "Embebidos, apps, backend, QA",
    bbRow3Buy: "Producto y operaciones",
    bbRow4Label: "Mantenimiento de firmware y SO",
    bbRow4Build: "Suyo, para siempre",
    bbRow4Buy: "Mantenido por nosotros",
    bbRow5Label: "DRM (Widevine L1)",
    bbRow5Build: "Usted negocia y aprovisiona",
    bbRow5Buy: "Aprovisionado en fábrica",
    bbRow6Label: "Gestión de dispositivos y OTA",
    bbRow6Build: "Construya el backend",
    bbRow6Buy: "Incluido (DMS + OTA)",
    bbRow7Label: "Certificación",
    bbRow7Build: "Usted posee GMS / Netflix",
    bbRow7Buy: "Gestionada o en asociación",
    bbRow8Label: "Fabricación y logística",
    bbRow8Build: "Su ODM y flete",
    bbRow8Buy: "Incluidas, a nivel mundial",
    bbRow9Label: "Control",
    bbRow9Build: "Total — cada capa",
    bbRow9Buy: "Suyo para marcar y configurar",
    bbRow10Label: "Dónde recae el riesgo",
    bbRow10Build: "En usted, de extremo a extremo",
    bbRow10Buy: "Compartido con el proveedor",
    bbTableInextLabel: "Dónde encaja inext",
    bbTableInextValue:
      "La columna de comprar y asociarse — marque y configure, una muestra funcional en 1–2 semanas",
    bbTableNote:
      "Ninguna columna es la “correcta” — depende de su escala, su equipo y cuánto del stack quiera poseer.",
    bbFitEyebrow: "Dónde encajamos",
    bbFitTitle: "Reducimos la construcción a “marcar y configurar”",
    bbFitBody:
      "Nos ubicamos en la columna de comprar y asociarse, y no lo ocultamos — pero nuestro trabajo es quitarle de encima las ocho capas, no convencerlo de no construir si realmente debería. Obtiene hardware ODM, una compilación de Android AOSP o Linux, su launcher de nivel operador, la app de IPTV, Widevine L1 y Verimatrix aprovisionados en fábrica, Alcatraz DMS con OTA escalonado, y fabricación y entrega a nivel mundial. Se envía en formato white-label — su marca en el firmware y, si lo desea, su logo en el hardware y el control remoto. Lo que sería un programa de varios trimestres se convierte en: elija el modelo, póngale su marca y obtenga una muestra funcional en una o dos semanas.",
    bbFitNoteTitle: "¿No está seguro de en qué lado está?",
    bbFitNoteBody:
      "Cuéntenos su escala, si tiene un equipo interno de embebidos y qué tan rápido necesita lanzar. Le daremos una lectura clara de construir vs. comprar para su situación — no un discurso de ventas.",
    bbFaqEyebrow: "FAQ",
    bbFaqTitle: "Preguntas frecuentes",
    bbFaqQ1: "¿Tengo que diseñar mi propio hardware para “construir”?",
    bbFaqA1:
      "No — y no debería. El silicio viene de los proveedores de chips y las placas de los ODM; incluso una construcción totalmente interna parte de un diseño de referencia. “Construir” se trata de poseer el software, la integración y la operación — no de grabar una PCB.",
    bbFaqQ2: "¿No puedo simplemente poner mi app en cajas Android de retail?",
    bbFaqA2:
      "Puede, y para una apuesta puramente de app es un comienzo válido. Pero una caja de retail no es suya: incluso con Widevine L1 a bordo, no obtiene marca, ni gestión de flota, ni bloqueo de red, y el proveedor controla la pantalla de inicio y las actualizaciones. Es el extremo de solo app del espectro — bueno para el alcance, débil para un servicio controlado y de marca. (Es el dilema de STB propio vs. Smart TV en otra forma.)",
    bbFaqQ3: "¿Cuál es la capa más difícil de construir?",
    bbFaqA3:
      "El firmware, sin duda. Poner una placa en marcha es la parte fácil; hacerla estable, rápida y segura es la difícil — y nunca termina realmente. Cada SoC y cada placa necesita su propio firmware afinado: controladores, la cadena de video, integración de DRM, gestión de energía, arranque seguro. No es un port único — a nosotros nos tomó años de iteración lograr cada firmware correcto para su placa. Es la capa que los equipos más subestiman, y exactamente el trabajo en el que un especialista ya ha invertido esos años.",
    bbFaqQ4: "¿Cuánto tarda una construcción real?",
    bbFaqA4:
      "Para un verdadero programa desde cero, planifique en trimestres, no en semanas: el endurecimiento del firmware, el aprovisionamiento de DRM, la gestión de dispositivos, la certificación y la fabricación toman tiempo cada uno y en parte corren uno tras otro. Abastecer las capas difíciles comprime eso al tiempo que toma marcar y configurar una plataforma probada.",
    bbFaqQ5: "¿Cuándo tiene sentido realmente construir?",
    bbFaqA5:
      "Cuando tiene la escala para amortizar una organización de ingeniería, un requisito único que ningún proveedor cubre, un equipo interno con el que se compromete, o una razón estratégica para poseer cada capa. Si dos o más le encajan, construir merece una mirada seria; si ninguno lo hace, abastecer suele ganar.",
    bbFaqQ6: "¿Dónde se ubica inext — construir o comprar?",
    bbFaqA6:
      "Somos el lado de comprar y asociarse, y lo decimos. Suministramos hardware ODM, firmware AOSP o Linux, su launcher de marca y app de IPTV, DRM aprovisionado en fábrica, Alcatraz DMS y OTA, y fabricación a nivel mundial — white-label, para que se envíe como su producto. También le diremos con honestidad si su situación en realidad favorece construir.",
    bbCtaEyebrow: "Hable con nosotros",
    bbCtaTitle: "Obtenga una lectura clara de construir vs. comprar",
    bbCtaBody:
      "Cuéntenos su escala, si tiene un equipo interno de embebidos y su cronograma. Le daremos una lectura honesta para su situación — y si comprar encaja, una muestra funcional de marca en una o dos semanas.",
    bbCtaPrimary: "Hable con nuestro equipo",
    bbCtaSecondary: "Solicitar una muestra",
    guidesCardRsgTitle: "¿Cuánta RAM y almacenamiento necesita un STB?",
    guidesCardRsgDesc:
      "Una guía para elegir entre 1 GB, 2 GB y 4 GB de RAM según el uso del equipo. También explica cómo evaluar el almacenamiento, el firmware y las pruebas, que dicen más que las cifras más altas de la ficha técnica.",
    footerLinkGuidesRamStorage: "RAM y almacenamiento de STB",
    rsgSeoTitle: "¿Cuánta RAM y almacenamiento necesita un STB? | inext",
    rsgSeoDescription:
      "Compare 1 GB, 2 GB y 4 GB de RAM y 8 GB, 16 GB y 32 GB de almacenamiento en STB. Elija según el firmware, las aplicaciones, los juegos y el uso previsto.",
    rsgBreadcrumbPage: "RAM y almacenamiento de STB",
    rsgHeroEyebrow: "Guía de configuración de set-top boxes",
    rsgPublishedLabel: "Publicado el",
    rsgUpdatedLabel: "Actualizado el",
    rsgHeroTitle: "¿Cuánta RAM y almacenamiento",
    rsgHeroTitleAccent: "necesita realmente un set-top box?",
    rsgHeroSub:
      "No existe un mínimo universal para todos los STB modernos. Un equipo de 1 GB bien optimizado puede ser la opción adecuada para un servicio con funciones definidas. Más memoria tiene sentido cuando se necesitan muchas aplicaciones, juegos ejecutados en el propio equipo o una vida útil más larga.",
    rsgHeroNote:
      "Considere la solución completa —firmware, pantalla de inicio, aplicaciones, actualizaciones y juegos— en lugar de elegir solo la cifra más alta de la ficha técnica.",
    rsgHeroCtaPrimary: "Comparar configuraciones",
    rsgHeroCtaSecondary: "Comparar modelos inext",
    rsgStat1: "Específico y eficiente",
    rsgStat2: "Opción versátil",
    rsgStat3: "Máximo margen",
    rsgThesisEyebrow: "La respuesta breve",
    rsgThesisTitle: "La cantidad de memoria no determina por sí sola el rendimiento",
    rsgThesisBody1:
      "La RAM se utiliza mientras funcionan el sistema operativo y las aplicaciones. El almacenamiento contiene el firmware, las aplicaciones, las actualizaciones y los datos locales. Esas cifras, por sí solas, no revelan la calidad del software, la velocidad de la memoria, la capacidad de la GPU, el control de temperatura ni la cantidad de procesos innecesarios que se ejecutan en segundo plano.",
    rsgThesisBody2:
      "Por eso, un STB de 1 GB bien diseñado puede responder con rapidez cuando cumple una función claramente definida. En cambio, un equipo mal ajustado puede tardar en iniciar, cerrar aplicaciones o volverse inestable aunque tenga más RAM. Más memoria aporta flexibilidad y margen, pero no corrige un software deficiente.",
    rsgThesisNoteTitle: "Cuándo 1 GB es realmente suficiente",
    rsgThesisNoteBody:
      "Un gigabyte solo es suficiente cuando se conoce el escenario de uso, el firmware está diseñado para ese equipo y la solución completa se ha probado en condiciones realistas. No es una recomendación general para cualquier dispositivo Android.",
    rsgGoogleNote:
      "Las reglas públicas de compatibilidad de Android son más detalladas que un “mínimo de 2 GB” universal: los requisitos varían según la versión de Android, la arquitectura, la configuración de pantalla y la memoria reservada por el hardware.",
    rsgGoogleLink: "Ver los requisitos de compatibilidad de Android",
    rsgWorkloadsEyebrow: "Comience por la función",
    rsgWorkloadsTitle: "Cada uso exige una configuración distinta",
    rsgWorkloadsIntro:
      "Un servicio controlado por un operador, un equipo para una habitación de hotel, una plataforma con varias aplicaciones de streaming y un dispositivo para juegos tienen necesidades diferentes. Defina qué debe funcionar desde el primer día y qué podría añadirse después.",
    rsgWorkload1Title: "Servicio de TV dedicado",
    rsgWorkload1Body:
      "Una pantalla de inicio administrada y una aplicación principal de TV, con firmware controlado y pocos servicios en segundo plano.",
    rsgWorkload1Signal: "La optimización importa más que la cantidad de aplicaciones",
    rsgWorkload2Title: "Streaming con varias aplicaciones",
    rsgWorkload2Body:
      "Varias aplicaciones de IPTV, OTT, medios y utilidades, entre las que los usuarios cambian durante una sesión.",
    rsgWorkload2Signal: "Reserve espacio para cambiar de aplicación y mantener cachés",
    rsgWorkload3Title: "Hotelería y condominios",
    rsgWorkload3Body:
      "Una experiencia personalizada con la marca del hotel, información para huéspedes, envío de contenido desde dispositivos móviles e integraciones con otros servicios, generalmente instaladas en muchas habitaciones.",
    rsgWorkload3Signal: "La uniformidad y la restauración remota son prioritarias",
    rsgWorkload4Title: "Juegos casuales",
    rsgWorkload4Body:
      "Juegos ligeros para Android y experiencias interactivas sencillas, además de las aplicaciones habituales de video.",
    rsgWorkload4Signal: "La RAM ayuda, pero la GPU y los controles siguen decidiendo",
    rsgWorkload5Title: "Juegos en la nube",
    rsgWorkload5Body:
      "El juego se procesa de forma remota mientras el STB decodifica un flujo de video de baja latencia y envía los comandos del control.",
    rsgWorkload5Signal: "La latencia de red puede pesar más que la RAM adicional",
    rsgWorkload6Title: "Plataformas propias más completas",
    rsgWorkload6Body:
      "Varias aplicaciones personalizadas, servicios en segundo plano, herramientas de análisis, integraciones y funciones cuyo alcance crecerá con el tiempo.",
    rsgWorkload6Signal: "Planifique un margen para la evolución del producto",
    rsgRamEyebrow: "Qué utiliza la RAM",
    rsgRamTitle: "Cuatro áreas consumen la RAM disponible",
    rsgRamIntro:
      "La pregunta útil no es “¿Cuántos gigabytes?”, sino “¿Cuánto queda disponible cuando funciona el servicio completo?”. Haga la medición con el firmware final, no con una versión limpia de desarrollo.",
    rsgRamFactor1Title: "Sistema operativo y servicios",
    rsgRamFactor1Body:
      "Android o Linux, la pantalla de inicio, la red, DRM, el sistema de gestión de equipos y los servicios del proveedor ocupan memoria antes de que se inicie la aplicación principal.",
    rsgRamFactor2Title: "Aplicaciones y trabajo en segundo plano",
    rsgRamFactor2Body:
      "Los datos de EPG, las miniaturas, la analítica, las cachés y los procesos en segundo plano determinan si las aplicaciones permanecen listas o deben reiniciarse.",
    rsgRamFactor3Title: "Reproducción de video",
    rsgRamFactor3Body:
      "Los STB modernos decodifican video mediante hardware dedicado. La fluidez en 4K depende en gran medida del SoC, la cadena de códecs y los controladores, no solo de la cantidad de RAM.",
    rsgRamFactor4Title: "Juegos y multitarea",
    rsgRamFactor4Body:
      "Los juegos ejecutados en el propio equipo, los gráficos más complejos y los cambios frecuentes entre aplicaciones exigen más memoria y son los que más se benefician de un margen adicional.",
    rsgConfigEyebrow: "Comparación práctica",
    rsgConfigTitle: "¿1/8, 2/16 o 4/32 GB?",
    rsgConfigIntro:
      "Estas configuraciones corresponden a distintos casos de uso; no son niveles universales de rendimiento. Tome la decisión final después de probar una unidad de evaluación con el firmware, las aplicaciones, los contenidos y los periféricos previstos.",
    rsgConfigCommon: "Más versátil",
    rsgConfigFitsLabel: "Adecuado para",
    rsgConfigWatchLabel: "Aspectos a vigilar",
    rsgConfigModelsLabel: "Modelos inext indicados",
    rsgConfig1Label: "Implementación enfocada",
    rsgConfig1Summary:
      "Una configuración económica cuando inext o el operador controla todo el firmware y mantiene el equipo dedicado a un conjunto limitado de funciones.",
    rsgConfig1Fit1: "Una aplicación principal de TV o medios",
    rsgConfig1Fit2: "Una pantalla de inicio ligera con pocos servicios en segundo plano",
    rsgConfig1Fit3: "Flotas grandes en las que importa el costo por unidad",
    rsgConfig1Watch:
      "No es una opción segura para un catálogo creciente de aplicaciones, juegos exigentes ejecutados en el equipo ni software que aún no se haya medido con el firmware final.",
    rsgConfig2Label: "Equilibrio flexible",
    rsgConfig2Summary:
      "Un punto de partida equilibrado para proyectos que necesitan varias aplicaciones, una interfaz más completa y margen para futuros cambios de software.",
    rsgConfig2Fit1: "Servicios de IPTV y OTT con varias aplicaciones",
    rsgConfig2Fit2: "Hotelería, portales de marca y juegos casuales",
    rsgConfig2Fit3: "Proyectos cuyos requisitos pueden crecer moderadamente",
    rsgConfig2Watch:
      "Aun así, valide el crecimiento de los datos, el cambio entre aplicaciones y la estabilidad durante usos prolongados. Tener 2 GB no elimina la necesidad de un firmware bien optimizado y mantenido.",
    rsgConfig3Label: "Máximo margen",
    rsgConfig3Summary:
      "La opción más sólida para conjuntos amplios de aplicaciones, tareas exigentes ejecutadas en el equipo y proyectos que priorizan la flexibilidad sobre el menor costo de hardware.",
    rsgConfig3Fit1: "Bibliotecas más grandes de aplicaciones e interfaces más completas",
    rsgConfig3Fit2: "Juegos más exigentes ejecutados en el equipo y aplicaciones interactivas",
    rsgConfig3Fit3: "Planes de evolución más largos y menos previsibles",
    rsgConfig3Watch:
      "No pague por memoria que el equipo no utilizará. Confirme que el procesador, la GPU, la velocidad del almacenamiento y el software permitan aprovechar realmente la capacidad adicional.",
    rsgConfigNote:
      "Los nombres de las configuraciones describen las capacidades nominales de RAM y memoria flash. La RAM disponible y el almacenamiento utilizable son menores después de las reservas de hardware, las particiones del sistema y el software preinstalado.",
    rsgStorageEyebrow: "El almacenamiento requiere planificación",
    rsgStorageTitle: "La capacidad anunciada no es el espacio disponible",
    rsgStorageIntro:
      "En un equipo de 8 GB, 16 GB o 32 GB, parte de la memoria está ocupada por las particiones y el firmware de producción. Consulte el espacio realmente disponible en la unidad final y estime cómo cambiará durante la vida útil del servicio.",
    rsgStorage1Title: "Firmware y particiones",
    rsgStorage1Body:
      "El sistema operativo, el entorno de recuperación, los datos del proveedor y las particiones reservadas ocupan parte de la memoria antes de instalar las aplicaciones.",
    rsgStorage2Title: "Estrategia de actualización",
    rsgStorage2Body:
      "Los paquetes de recuperación, las descargas por etapas y los diseños de actualización A/B pueden requerir almacenamiento reservado de forma temporal o permanente.",
    rsgStorage3Title: "Aplicaciones, datos y cachés",
    rsgStorage3Body:
      "Los archivos de las aplicaciones son solo el comienzo. Los datos de EPG, las imágenes, los registros, los datos web y las cachés aumentan durante el uso normal.",
    rsgStorage4Title: "Velocidad y durabilidad de escritura",
    rsgStorage4Body:
      "Una eMMC rápida y confiable y un sistema de archivos bien mantenido pueden importar más que una gran cantidad de espacio libre en un equipo lento o mal administrado.",
    rsgStorageNote:
      "Defina un umbral mínimo de espacio libre después de preparar el equipo y tras un ciclo representativo de actualización. La capacidad nominal por sí sola no confirma que la siguiente versión del sistema o de una aplicación se instalará de forma segura.",
    rsgOptimizeEyebrow: "Por qué el software cambia la respuesta",
    rsgOptimizeTitle: "La optimización libera recursos para el servicio",
    rsgOptimizeIntro:
      "El firmware de un STB no debería ser una versión genérica de Android copiada sin ajustes en una placa. El BSP, los controladores, los servicios, la pantalla de inicio y los procesos de las aplicaciones deben optimizarse en conjunto para el SoC y la función específica del producto.",
    rsgOptimize1Title: "Elimine los procesos innecesarios",
    rsgOptimize1Body:
      "Cada servicio innecesario consume RAM, almacenamiento, capacidad de procesamiento y tiempo de arranque. Un firmware controlado puede mantenerse deliberadamente ligero.",
    rsgOptimize2Title: "Optimice toda la base de hardware",
    rsgOptimize2Body:
      "La configuración del kernel, los controladores, la asignación de memoria y la integración de la decodificación de video determinan la eficiencia con la que la plataforma utiliza sus recursos.",
    rsgOptimize3Title: "Controle el funcionamiento de las aplicaciones",
    rsgOptimize3Body:
      "El comportamiento de la pantalla de inicio, los límites para procesos en segundo plano, la política de caché y los mecanismos de recuperación mantienen ágil la interfaz incluso durante sesiones largas.",
    rsgOptimize4Title: "Valide cada versión de producción",
    rsgOptimize4Body:
      "La optimización se mantiene mediante pruebas de regresión, distribución gradual de actualizaciones OTA y monitoreo. No termina una vez que se lanza el producto.",
    rsgOptimizeProofTitle: "Un ejemplo concreto: inext TV5",
    rsgOptimizeProofBody:
      "El TV5 combina 1 GB de RAM y 8 GB de eMMC con Android 10 AOSP, reproducción 4K acelerada por hardware y Alcatraz DMS. Cumple bien una función específica gracias a años de optimización del software para la plataforma H313, no porque se ignoren los límites de memoria.",
    rsgOptimizeProofCta: "Ver especificaciones del TV5",
    rsgGamingEyebrow: "Los juegos cambian los requisitos",
    rsgGamingTitle: "Pregunte qué tipo de juego se ejecutará",
    rsgGamingIntro:
      "La expresión “admite juegos” puede significar cosas muy distintas. Un rompecabezas sencillo, un juego de consola transmitido desde la nube y un juego 3D ejecutado en el propio equipo exigen recursos diferentes del STB.",
    rsgGamingImageAlt:
      "Persona que usa la aplicación inext Remote en modo de control mientras se ejecuta un juego de carreras en el televisor",
    rsgGame1Title: "Juegos casuales y ligeros",
    rsgGame1Body:
      "Los juegos sencillos para Android pueden funcionar con una cantidad moderada de memoria cuando todo el firmware está controlado y cada juego se prueba en el equipo previsto.",
    rsgGame1Emphasis: "A menudo es viable con 1–2 GB; pruebe cada juego",
    rsgGame2Title: "Juegos en la nube",
    rsgGame2Body:
      "El procesamiento ocurre en la nube. La experiencia en el equipo depende de una red de baja latencia, decodificación de video por hardware, compatibilidad con controles Bluetooth o USB y una imagen fluida y estable.",
    rsgGame2Emphasis: "Importan primero la red, el decodificador y la latencia del control",
    rsgGame3Title: "Juegos exigentes ejecutados en el equipo",
    rsgGame3Body:
      "Las texturas grandes, los motores de juego y los recursos en segundo plano se benefician de 4 GB de RAM y más almacenamiento. Aun así, la capacidad de la GPU y la posibilidad de mantener el rendimiento sin sobrecalentamiento siguen siendo decisivas.",
    rsgGame3Emphasis: "Considere 4/32 después de validar GPU y temperatura",
    rsgGamingNote:
      "Cuatro gigabytes de RAM no convierten un SoC débil en una consola. La RAM, la GPU, el procesador, el rendimiento del almacenamiento, la refrigeración y la compatibilidad con controles deben evaluarse como un conjunto.",
    rsgTestEyebrow: "Verifique antes de comprar",
    rsgTestTitle: "Pruebe el uso real, no solo el resultado de una prueba sintética",
    rsgTestIntro:
      "La unidad de evaluación del proveedor debe ejecutar el firmware final y los contenidos previstos. Repita la misma secuencia de pruebas en cada modelo para que la comparación refleje el servicio que recibirán los suscriptores.",
    rsgTest1:
      "Mida el tiempo de arranque completo y desde la reanudación hasta que aparezca la imagen",
    rsgTest2: "Abra la aplicación principal y cambie entre las pantallas clave",
    rsgTest3:
      "Reproduzca contenido representativo en 4K y HDR, incluido contenido protegido por DRM",
    rsgTest4: "Cambie repetidamente entre todas las aplicaciones requeridas",
    rsgTest5: "Reproduzca TV en vivo, OTT o los contenidos previstos durante 24–72 horas",
    rsgTest6:
      "Pruebe juegos casuales, juegos en la nube o juegos ejecutados en el equipo con el control previsto",
    rsgTest7:
      "Instale una actualización OTA con un espacio libre realista y verifique la recuperación",
    rsgTest8:
      "Registre la RAM y el almacenamiento disponibles después de la configuración inicial, el uso y las actualizaciones",
    rsgTestNoteTitle: "Mantenga la prueba reproducible",
    rsgTestNoteBody:
      "Documente los criterios de aprobación y rechazo antes de recibir las unidades de prueba. Una demostración bien preparada no sustituye un procedimiento de aceptación acordado.",
    rsgTestNoteCta: "Abrir la lista de verificación para elegir un STB",
    rsgDecisionEyebrow: "Cómo decidir",
    rsgDecisionTitle:
      "Compre la configuración más ajustada que cumpla el requisito real con margen",
    rsgDecision1Title: "Defina el firmware de producción",
    rsgDecision1Body:
      "Enumere el sistema operativo, la pantalla de inicio, las aplicaciones, los servicios, DRM, DMS y el método de actualización que se entregarán, no solo el nombre genérico de una plataforma.",
    rsgDecision2Title: "Separe la reproducción del procesamiento de las aplicaciones",
    rsgDecision2Body:
      "Confirme los códecs y las resoluciones compatibles con el decodificador de hardware. Después, evalúe CPU, GPU y RAM para la interfaz y las demás aplicaciones.",
    rsgDecision3Title: "Planifique el almacenamiento a lo largo del tiempo",
    rsgDecision3Body:
      "Considere el espacio utilizable, las cachés, los registros, el crecimiento de aplicaciones, la recuperación y al menos un ciclo realista de actualización.",
    rsgDecision4Title: "Dimensione el margen para la vida útil",
    rsgDecision4Body:
      "Compare el costo de la memoria adicional con la probabilidad de nuevas aplicaciones, soporte más prolongado o una función más amplia durante la vida de la flota.",
    rsgDecisionConclusion:
      "El STB adecuado no es el que tiene más memoria. Es el que cumple de forma confiable las funciones documentadas, se ajusta al presupuesto de la flota y conserva margen suficiente para la vida útil prevista.",
    rsgFaqEyebrow: "Preguntas frecuentes",
    rsgFaqTitle: "Respuestas sobre RAM y almacenamiento",
    rsgFaqQ1: "¿Es suficiente 1 GB de RAM para un set-top box moderno?",
    rsgFaqA1:
      "Puede serlo. Un gigabyte es una configuración adecuada para un escenario de uso bien definido, con firmware optimizado, una pantalla de inicio ligera y un conjunto limitado de aplicaciones. No es una opción segura para un uso desconocido, un ecosistema amplio de aplicaciones o juegos exigentes ejecutados en el equipo. Pruebe el firmware final antes de decidir.",
    rsgFaqQ2: "¿Son 2 GB de RAM el mínimo para Android TV?",
    rsgFaqA2:
      "No existe una regla universal de 2 GB que se ajuste a todos los equipos para TV. Los requisitos públicos de compatibilidad de Android varían según la versión de Android, la arquitectura, la configuración de pantalla y la memoria reservada por el hardware. Los mínimos de compatibilidad tampoco indican cómo funcionará un conjunto específico de aplicaciones; las pruebas de producción siguen siendo decisivas.",
    rsgFaqQ3: "¿Más RAM mejora la calidad del video 4K?",
    rsgFaqA3:
      "Por sí sola, no. El hardware dedicado normalmente decodifica video H.264, H.265 o VP9. La reproducción fluida en 4K depende del SoC, el decodificador, los controladores, la ruta de salida y la compatibilidad del flujo. La RAM es más relevante para la pantalla de inicio, las aplicaciones, la estrategia de almacenamiento temporal y la multitarea alrededor de la reproducción.",
    rsgFaqQ4: "¿Cuánto del almacenamiento anunciado se puede usar?",
    rsgFaqA4:
      "Varía según el firmware y el esquema de particiones. El sistema operativo, el entorno de recuperación, los datos reservados y las aplicaciones preinstaladas reducen el espacio disponible. Solicite la cantidad de espacio libre en una unidad equivalente a la versión de producción ya configurada, no solo la capacidad nominal de la memoria flash.",
    rsgFaqQ5: "¿Cuánta RAM necesita un STB para juegos?",
    rsgFaqA5:
      "Los juegos ligeros pueden funcionar bien con 1–2 GB, mientras que los títulos exigentes ejecutados en el equipo se benefician de 4 GB de RAM y más almacenamiento. Los juegos en la nube dependen más de la latencia de red, la decodificación por hardware y la respuesta del control. En todos los casos, la capacidad de la GPU y el control de temperatura importan junto con la RAM.",
    rsgFaqQ6: "¿Debe un operador comprar memoria adicional pensando en el futuro?",
    rsgFaqA6:
      "Solo cuando exista un plan de evolución realista. Un margen adicional tiene sentido si se esperan más aplicaciones, interfaces más completas o una vida útil más larga. En una flota grande, pagar por memoria sin uso previsto en cada unidad puede costar más que elegir una configuración menor ya comprobada y controlar el alcance del producto.",
    rsgCtaEyebrow: "Decida con base en pruebas",
    rsgCtaTitle: "Describa el uso. Le ayudaremos a dimensionar el equipo.",
    rsgCtaBody:
      "Comparta las aplicaciones, los contenidos, las integraciones, los requisitos de juegos y la vida útil esperada. El equipo de inext puede recomendar una configuración y preparar una unidad de evaluación con el firmware previsto.",
    rsgCtaPrimary: "Conversar sobre los requisitos",
    rsgCtaSecondary: "Comparar todos los modelos",
    footerLinkBrand: "Recursos de marca",
    brandSeoTitle: "Recursos de marca y guía de uso del logo inext",
    brandSeoDescription:
      "Descarga logos e íconos oficiales de inext y consulta los colores, la tipografía, las reglas y los permisos aprobados para prensa y marketing de socios.",
    brandEyebrow: "Marca inext",
    brandHeading: "Recursos de marca listos para usar",
    brandIntro:
      "Descarga los archivos aprobados del logo inext y sigue las pautas esenciales de color, tipografía, escritura del nombre y uso correcto por terceros.",
    brandDownloadPack: "Descargar paquete de recursos",
    brandDownloadGuide: "Descargar guía en PDF",
    brandDownloadNote:
      "Descarga gratuita para prensa, uso editorial y marketing correcto de socios.",
    brandLogoAlt: "Logo inext",
    brandLogoEyebrow: "Sistema de logo",
    brandLogoTitle: "Elige la versión adecuada para el fondo",
    brandLogoDescription:
      "Usa el logo completo siempre que haya espacio. El ícono compacto está pensado para formatos cuadrados o espacios reducidos. Descarga el arte en SVG escalable o PNG transparente.",
    brandPrimary: "Principal · fondo blanco",
    brandOnDark: "Para fondos negros",
    brandOnBlue: "Para fondos azul inext",
    brandFullLogo: "Logo completo",
    brandIcon: "Ícono",
    brandColorsEyebrow: "Color",
    brandColorsTitle: "Una paleta precisa de tres colores",
    brandColorsDescription:
      "Estos son los colores aprobados del logo inext. Usa los valores exactos y los archivos suministrados en lugar de cambiar el color manualmente.",
    brandColorBlue: "Azul inext",
    brandColorWhite: "Blanco",
    brandColorBlack: "Negro",
    brandTypographyEyebrow: "Tipografía y nombre",
    brandTypographyTitle: "Mantén la tipografía clara y coherente",
    brandTypographyDescription:
      "Usa Roboto en las comunicaciones de la marca inext siempre que sea posible. Elige pesos que mantengan una jerarquía clara y una lectura cómoda.",
    brandTypographyLink: "Obtener Roboto en Google Fonts",
    brandNameTitle: "Nombre de la marca por escrito",
    brandNameDescription:
      "En texto corrido, escribe el nombre de la marca en minúsculas: «inext». Cuando deba aparecer el símbolo en forma de chevrón, usa el archivo oficial del logo; no sustituyas la marca gráfica por el carácter de texto «›».",
    brandUsageEyebrow: "Uso correcto",
    brandUsageTitle: "Protege la forma, el contraste y el significado",
    brandUsageDescription:
      "El tratamiento coherente hace que la marca sea reconocible en publicaciones editoriales, materiales de producto y campañas de socios.",
    brandDoTitle: "Sí",
    brandDoOfficialAssets: "Usa los archivos oficiales disponibles en esta página.",
    brandDoContrast: "Elige la versión aprobada con buen contraste respecto del fondo.",
    brandDoProportions:
      "Conserva las proporciones del logo y deja un espacio cómodo a su alrededor.",
    brandDoAccurateRelationship:
      "Describe con precisión la relación con inext en los materiales de socios.",
    brandDontTitle: "No",
    brandDontRecolor: "No inventes colores ni combines partes de versiones diferentes.",
    brandDontDistort: "No estires, comprimas, gires, recortes ni inclines el arte.",
    brandDontEffects: "No agregues contornos, sombras, degradados ni otros efectos.",
    brandDontRearrange: "No reordenes el ícono y el nombre ni compongas un reemplazo con texto.",
    brandPermissionsEyebrow: "Permisos",
    brandPermissionsTitle: "Recursos abiertos, representación precisa",
    brandPermissionsDescription:
      "Los archivos del logo están disponibles de forma gratuita para cobertura legítima y colaboración. No se requiere formulario ni correo electrónico.",
    brandPermissionPress:
      "La prensa y los equipos editoriales pueden usar los recursos al mencionar a inext.",
    brandPermissionPartners:
      "Los socios pueden usarlos en marketing que refleje una relación auténtica.",
    brandPermissionAccuracy:
      "El uso no debe sugerir un respaldo, certificación o asociación que no exista.",
    brandContactCta: "Consultar un uso especial",
  },
};
